import {
  Regex_init_$Create$2nx0fagcwc0mz as Regex_init_$Create$,
  toInt2q8uldh7sc951 as toInt,
  protoOf180f3jzyo7rfj as protoOf,
  _Char___init__impl__6a9atxrzocepzq3zgi as _Char___init__impl__6a9atx,
  padStart36w1507hs626a as padStart,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  toString1pkumu07cwy4m as toString,
  IllegalArgumentException_init_$Create$1gox8sdqs91jy as IllegalArgumentException_init_$Create$,
  Unit_instance3kz1zqli6gr1r as Unit_instance,
  Long2qws0ah9gnpki as Long,
  fromInt1lka3ktyu79a4 as fromInt,
  multiply18i3gv3wlmcjg as multiply,
  toNumberlmbpvqo27r53 as toNumber,
  round2mrvepag8eey0 as round,
  numberToLong345n6tb1n1i71 as numberToLong,
  equalsLong28bsrfhwvd686 as equalsLong,
  divide3tol6kxdi8xn6 as divide,
  modulo3mmbfwxzpcw3a as modulo,
  VOID3gxj6tk5isa35 as VOID,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  substringAfter1hku067gwr5ve as substringAfter,
  toDouble1kn912gjoizjp as toDouble,
  startsWith26w8qjqapeeq6 as startsWith,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  ArrayList_init_$Create$a978fvbbts3d as ArrayList_init_$Create$,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  isFinite2t9l5a275mxm6 as isFinite,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  numberToDouble210hrknaofnhf as numberToDouble,
  isNumberiramasdbon0i as isNumber,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  listOf1jh22dvmctj1r as listOf,
  copyToArray2j022khrow2yi as copyToArray,
  listOfvhqybd2zx248 as listOf_0,
  plus310ted5e4i90h as plus,
  emptyList1g2z5xcrvp2zy as emptyList,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  LinkedHashMap_init_$Create$21wpz6bm2n4yn as LinkedHashMap_init_$Create$,
  isBlank1dvkhjjvox3p0 as isBlank,
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  _Result___get_value__impl__bjfvqg9vwgdwmhxc4m as _Result___get_value__impl__bjfvqg,
  _Result___get_isFailure__impl__jpiriv2yxkms7bg2hpm as _Result___get_isFailure__impl__jpiriv,
  to2cs3ny02qtbcb as to,
  emptyMapr06gerzljqtm as emptyMap,
  LinkedHashMap_init_$Create$qwveozlot922 as LinkedHashMap_init_$Create$_0,
  enumEntries20mr21zbe3az4 as enumEntries,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  toString30pk9tzaqopn as toString_0,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  equals2au1ep9vhcato as equals,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  toList3jhuyej2anx2q as toList,
  minus1djrl64vbav3y as minus,
  coerceIn1xblvmyr0tby6 as coerceIn,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ArrayList_init_$Create$2xrifdqz5xirg as ArrayList_init_$Create$_0,
  average1u332mxgzjdwv as average,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
  joinToString1cxrrlmo0chqs as joinToString,
  Collection1k04j3hzsbod0 as Collection,
  isInterface3d6p8outrmvmk as isInterface,
  toSet2orjxp16sotqu as toSet,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  toMutableList20rdgwi7d3cwi as toMutableList,
  hashCodeq5arwsb9dgti as hashCode,
  FunctionAdapter3lcrrz3moet5b as FunctionAdapter,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortedWith2csnbbb21k0lg as sortedWith,
  firstOrNull1982767dljvdy as firstOrNull,
  coerceAtMost322komnqp70ag as coerceAtMost,
  NoSuchElementException_init_$Create$2uedmacu7g3r8 as NoSuchElementException_init_$Create$,
  LinkedHashMap_init_$Create$s27yccuovnls as LinkedHashMap_init_$Create$_1,
  compareTo3ankvs086tmwq as compareTo,
  last1vo29oleiqj36 as last,
  coerceAtLeastklytehohcpeq as coerceAtLeast_0,
  coerceAtMostfyc3emgaderp as coerceAtMost_0,
  NoSuchElementException_init_$Create$14710snnwdnfb as NoSuchElementException_init_$Create$_0,
  setOf45ia9pnfhe90 as setOf,
  HashSet_init_$Create$b2fvq2b4c4v2 as HashSet_init_$Create$,
  contains2gm06f5aa19ov as contains,
  first58ocm7j58k3q as first,
  get_lastIndex1yw0x4k50k51w as get_lastIndex,
  until1jbpn0z3f8lbg as until,
  plus20p0vtfmu0596 as plus_0,
  isNaNymqb93xtq8w8 as isNaN_0,
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  trimEndvvzjdhan75g as trimEnd,
  mapOf2zpbbmyqk8xpf as mapOf,
  emptySetcxexqki71qfa as emptySet,
  split2bvyvnrlcifjv as split,
  KtMap140uvy3s5zad8 as KtMap,
  coerceIn10f36k81le1mm as coerceIn_0,
  linkedMapOf1is69t4zkcfr3 as linkedMapOf,
  sorted354mfsiv4s7x5 as sorted,
  get_indices3txodfl5wuu5j as get_indices,
  mapOf1xd03cq9cnmy8 as mapOf_0,
  getValue48kllevslyh6 as getValue,
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  distinct10qe1scfdvu5k as distinct,
  sum2ku6kbgxq0lee as sum,
  zipWithNext2nnv9puh4xyfv as zipWithNext,
  eachCount1imd75z0wkpbt as eachCount,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  Char19o2r8palgjof as Char,
  StringBuilder_init_$Create$b2348mky3co as StringBuilder_init_$Create$,
  charCodeAt1yspne1d8erbm as charCodeAt,
  toString1n9qg6fb0b5i8 as toString_1,
  substringiqarkczpya5m as substring,
  toIntOrNull1j8dcc6to13o4 as toIntOrNull_0,
  numberToChar93r9buh19yek as numberToChar,
  isDigit3mimrri4wkzop as isDigit,
  contains2el4s70rdq4ld as contains_0,
  startsWith5hna0vjiqaqm as startsWith_0,
  getOrNull1cdnsfrisdp41 as getOrNull,
  getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression,
  Iterable1y3qizuf89iou as Iterable,
  isInfinite12nl8hpz1hbp2 as isInfinite,
  Char__toInt_impl_vasixd28v1p2u6jau5g as Char__toInt_impl_vasixd,
  toString1h6jjoch8cjt8 as toString_2,
  Char__compareTo_impl_ypi4mb3bl0kdwnivnp6 as Char__compareTo_impl_ypi4mb,
  KtList3hktaavzmj137 as KtList,
  take3onnpy6q7ctcz as take,
  Companion_instance13way2il9a8jt as Companion_instance_0,
  toMap1vec9topfei08 as toMap,
  contains3ue2qo8xhmpf1 as contains_1,
  setOf1u3mizs95ngxo as setOf_0,
  HashSet_init_$Create$1pjsbfu0jyfkj as HashSet_init_$Create$_0,
  addAll1k27qatfgp3k5 as addAll,
  maxOrNull5i0eu9xqz7pb as maxOrNull,
  minOrNull2eu8keq9f1w4i as minOrNull,
  min1hp1v7yf4yjv0 as min,
  max3idzx6y8yn3fk as max,
  toMutableMapr5f3w62lv8sk as toMutableMap,
  HashMap_init_$Create$g6b5bm370ovq as HashMap_init_$Create$,
  Char__plus_impl_qi7pgj12gj4qbkhmj1y as Char__plus_impl_qi7pgj,
  downTo39qhfeycepm1j as downTo,
  compareBy2697bq0ffft96 as compareBy,
  constructCallableReference23y65rf941mch as constructCallableReference,
  withIndex37cl61h9v5txo as withIndex,
  RegexOption_IGNORE_CASE_getInstance2fmuzo7a7o03f as RegexOption_IGNORE_CASE_getInstance,
  Regex_init_$Create$ieoy8mfgcgs6 as Regex_init_$Create$_0,
  equals2v6cggk171b6e as equals_0,
  drop3na99dw9feawf as drop,
  getOrNull1go7ef9ldk0df as getOrNull_0,
  minWithOrNull30i4uakvje35v as minWithOrNull,
  maxWithOrNullsohvqg0i6v8s as maxWithOrNull,
  intersect7qttw6wlmz1n as intersect,
  union28sojvmrkgw6y as union,
  asSequence2phdjljfh9jhx as asSequence,
  filter184huxd00uyfg as filter,
  mapsbvh18eqox7a as map,
  sortedWith249tsu0292gn1 as sortedWith_0,
  take2rh6pen3z50h7 as take_0,
  toListx6x8nvfmvvht as toList_0,
  replace3le3ie7l9k8aq as replace,
  toSet2morh2kqexfa2 as toSet_0,
  trimStart5ewg8zf6cs5u as trimStart,
  endsWith3cq61xxngobwh as endsWith,
  removePrefix279df90bhrqqg as removePrefix,
  contains1tccixv8iwdcq as contains_2,
  dropLastlqc2oyv04br0 as dropLast,
  lineSequencefj20mplblw0p as lineSequence,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  dropLast1vpiyky649o34 as dropLast_0,
  asReversed308kw52j6ls1u as asReversed,
  flatten2dh4kibw1u0qq as flatten,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  zipfdxxupzuj2p9 as zip,
  takeLasttm5u17ojwaaq as takeLast,
  LinkedHashSet_init_$Create$vv7nkva6wxy5 as LinkedHashSet_init_$Create$,
  ArrayList_init_$Create$2rx6gww4owbo3 as ArrayList_init_$Create$_1,
  ArrayDeque_init_$Create$6m79olxzrhzp as ArrayDeque_init_$Create$,
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  get_indices2kzl7ig72xk9x as get_indices_0,
  toIntArray2d4xwvtjb01mq as toIntArray,
  toDoubleArray1tu5g57mgriew as toDoubleArray,
  toSet30l41gpetsxbw as toSet_1,
  get_indices3jka924ymcx7p as get_indices_1,
  toList2z3tifmtru5ra as toList_1,
  toList2enan2cfix0ie as toList_2,
  get_indicesc04v40g017hw as get_indices_2,
  toSet1glep2u1u9tcb as toSet_2,
} from './kotlin-kotlin-stdlib.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
initMetadataForObject(EpochDays, 'EpochDays');
initMetadataForObject(Fmt, 'Fmt');
initMetadataForObject(UnitText, 'UnitText');
initMetadataForClass(AlgorithmOptionKind, 'AlgorithmOptionKind', VOID, Enum);
initMetadataForClass(AlgorithmChoice, 'AlgorithmChoice');
initMetadataForClass(AlgorithmOption, 'AlgorithmOption');
initMetadataForObject(AlgorithmJson, 'AlgorithmJson');
initMetadataForClass(ExpenditureEngine, 'ExpenditureEngine', VOID, Enum);
initMetadataForClass(ExpenditureMode, 'ExpenditureMode', VOID, Enum);
initMetadataForClass(EnergyDensityMode, 'EnergyDensityMode', VOID, Enum);
initMetadataForClass(PredictionStyle, 'PredictionStyle', VOID, Enum);
initMetadataForCompanion(Companion);
initMetadataForClass(AlgorithmSettings, 'AlgorithmSettings', AlgorithmSettings);
initMetadataForClass(FloorMode, 'FloorMode', VOID, Enum);
initMetadataForClass(MacroMinimums, 'MacroMinimums');
initMetadataForObject(CalorieFloors, 'CalorieFloors');
initMetadataForClass(GoalType, 'GoalType', VOID, Enum);
initMetadataForObject(GoalAvailability, 'GoalAvailability');
initMetadataForClass(Goal, 'Goal');
initMetadataForClass(CalorieFloor, 'CalorieFloor', VOID, Enum);
initMetadataForClass(CheckInSmoothing, 'CheckInSmoothing', VOID, Enum);
initMetadataForClass(CheckInInput, 'CheckInInput');
initMetadataForClass(CheckInResult, 'CheckInResult');
initMetadataForClass(Persistence, 'Persistence', Persistence);
initMetadataForObject(CheckIn, 'CheckIn');
initMetadataForClass(RecoveryTrend, 'RecoveryTrend');
initMetadataForClass(RecoverySignals, 'RecoverySignals');
initMetadataForObject(CheckInSignals, 'CheckInSignals');
initMetadataForClass(MacroField, 'MacroField', VOID, Enum);
initMetadataForObject(CollaborativeTargets, 'CollaborativeTargets');
initMetadataForObject(DailyTargets, 'DailyTargets');
initMetadataForCompanion(Companion_0);
initMetadataForClass(DietBreak, 'DietBreak');
initMetadataForClass(GoalPeriodStart, 'GoalPeriodStart');
initMetadataForClass(ExpenditureInput, 'ExpenditureInput');
initMetadataForCompanion(Companion_1);
initMetadataForClass(ExpenditureRun, 'ExpenditureRun');
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(ExpenditureRunner, 'ExpenditureRunner');
initMetadataForClass(PacePreset, 'PacePreset');
initMetadataForClass(PacePoint, 'PacePoint');
initMetadataForClass(PaceProjection, 'PaceProjection');
initMetadataForClass(CurvePoint, 'CurvePoint');
initMetadataForObject(GoalPace, 'GoalPace');
initMetadataForClass(Band, 'Band', VOID, Enum);
initMetadataForObject(WaistToHeight, 'WaistToHeight');
initMetadataForClass(GoalProgress, 'GoalProgress');
initMetadataForClass(MilestoneKind, 'MilestoneKind', VOID, Enum);
initMetadataForClass(WeightMilestone, 'WeightMilestone');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Goals, 'Goals');
initMetadataForClass(FastLossWarning, 'FastLossWarning');
initMetadataForObject(LossPace, 'LossPace');
initMetadataForClass(DietType, 'DietType', VOID, Enum);
initMetadataForClass(ProteinPreference, 'ProteinPreference', VOID, Enum);
initMetadataForClass(MacroTargets, 'MacroTargets');
initMetadataForClass(MacroSplit, 'MacroSplit', VOID, Enum);
initMetadataForObject(Macros, 'Macros');
initMetadataForObject(NewProgram, 'NewProgram');
initMetadataForObject(NutritionJson, 'NutritionJson');
initMetadataForClass(LoggingReview, 'LoggingReview');
initMetadataForObject(PartialDays, 'PartialDays');
initMetadataForClass(StrengthIndexPoint, 'StrengthIndexPoint');
initMetadataForClass(GuardrailResult, 'GuardrailResult');
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(PerformanceGuardrail, 'PerformanceGuardrail');
initMetadataForClass(TrainingType, 'TrainingType', VOID, Enum);
initMetadataForClass(ProteinMethod, 'ProteinMethod', VOID, Enum);
initMetadataForObject(ProteinTargets, 'ProteinTargets');
initMetadataForClass(ShiftResult, 'ShiftResult');
initMetadataForObject(TrainingShift, 'TrainingShift');
initMetadataForClass(BandPoint, 'BandPoint');
initMetadataForClass(TrendProjection, 'TrendProjection');
initMetadataForObject(TrendChart, 'TrendChart');
initMetadataForClass(ProgramKind, 'ProgramKind', VOID, Enum);
initMetadataForClass(DistributionKind, 'DistributionKind', VOID, Enum);
initMetadataForClass(TrainingShiftSetting, 'TrainingShiftSetting', TrainingShiftSetting);
initMetadataForClass(NutritionProgram, 'NutritionProgram', NutritionProgram);
initMetadataForClass(BodyProfile, 'BodyProfile');
initMetadataForClass(PreviousCheckIn, 'PreviousCheckIn');
initMetadataForClass(CheckInParams, 'CheckInParams', CheckInParams);
initMetadataForClass(WeeklyCheckInInput, 'WeeklyCheckInInput');
initMetadataForClass(WeekReview, 'WeekReview');
initMetadataForClass(CheckInModule, 'CheckInModule', VOID, Enum);
initMetadataForClass(CheckInFlagCode, 'CheckInFlagCode', VOID, Enum);
initMetadataForClass(CheckInFlag, 'CheckInFlag');
initMetadataForClass(WeeklyCheckInResult, 'WeeklyCheckInResult');
initMetadataForObject(WeeklyCheckIn, 'WeeklyCheckIn');
initMetadataForClass(HighDayMode, 'HighDayMode', VOID, Enum);
initMetadataForObject(WeeklyDistribution, 'WeeklyDistribution');
initMetadataForClass(DayStatus, 'DayStatus', VOID, Enum);
initMetadataForClass(IntakeDay, 'IntakeDay');
initMetadataForClass(ExpenditureStatus, 'ExpenditureStatus', VOID, Enum);
initMetadataForClass(ExpenditurePoint, 'ExpenditurePoint');
initMetadataForClass(GoalChange, 'GoalChange');
initMetadataForClass(ExpenditureParams, 'ExpenditureParams', ExpenditureParams);
initMetadataForObject(AdaptiveExpenditure, 'AdaptiveExpenditure');
initMetadataForObject(BodyComposition, 'BodyComposition');
initMetadataForClass(EnergyBalancePoint, 'EnergyBalancePoint');
initMetadataForClass(EnergyBalanceSummary, 'EnergyBalanceSummary');
initMetadataForObject(EnergyBalance, 'EnergyBalance');
initMetadataForObject(EnergyDensity, 'EnergyDensity');
initMetadataForClass(ExpenditureFloorKind, 'ExpenditureFloorKind', VOID, Enum);
initMetadataForObject(ExpenditureFloor, 'ExpenditureFloor');
initMetadataForClass(ExpenditureChange, 'ExpenditureChange');
initMetadataForClass(DisplayedExpenditure, 'DisplayedExpenditure');
initMetadataForObject(ExpenditureInsights, 'ExpenditureInsights');
initMetadataForClass(ExpenditureBand, 'ExpenditureBand');
initMetadataForObject(ExpenditureV2, 'ExpenditureV2');
initMetadataForClass(GoalAdjustmentParams, 'GoalAdjustmentParams', GoalAdjustmentParams);
initMetadataForClass(GoalStart, 'GoalStart');
initMetadataForClass(sam$kotlin_Comparator$0_2, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(Active, 'Active');
initMetadataForCompanion(Companion_2);
initMetadataForClass(GoalAdjuster, 'GoalAdjuster');
initMetadataForClass(Sex, 'Sex', VOID, Enum);
initMetadataForClass(Ethnicity, 'Ethnicity', VOID, Enum);
initMetadataForClass(ActivityLevel, 'ActivityLevel', VOID, Enum);
initMetadataForClass(BmrEquation, 'BmrEquation', VOID, Enum);
initMetadataForClass(DailyActivity, 'DailyActivity', VOID, Enum);
initMetadataForClass(ExerciseSessions, 'ExerciseSessions', VOID, Enum);
initMetadataForClass(InitialExpenditureOptions, 'InitialExpenditureOptions', InitialExpenditureOptions);
initMetadataForObject(InitialExpenditure, 'InitialExpenditure');
initMetadataForClass(IntakePrior, 'IntakePrior', VOID, Enum);
initMetadataForClass(StateSpaceParams, 'StateSpaceParams', StateSpaceParams);
initMetadataForCompanion(Companion_3);
initMetadataForClass(ExpenditureV2Terms, 'ExpenditureV2Terms', ExpenditureV2Terms);
initMetadataForClass(DailyInputs, 'DailyInputs', DailyInputs);
initMetadataForClass(StateSpaceExpenditure$filter$$inlined$groupingBy$1);
initMetadataForObject(StateSpaceExpenditure, 'StateSpaceExpenditure');
initMetadataForCompanion(Companion_4);
initMetadataForClass(Matrix3, 'Matrix3');
initMetadataForObject(OffProduct, 'OffProduct');
initMetadataForClass(Parser, 'Parser');
initMetadataForObject(Json, 'Json');
initMetadataForObject(JsonRead, 'JsonRead');
initMetadataForClass(DrinkType, 'DrinkType', VOID, Enum);
initMetadataForClass(AlcoholEstimate, 'AlcoholEstimate');
initMetadataForObject(Alcohol, 'Alcohol');
initMetadataForCompanion(Companion_5);
initMetadataForClass(NutrientEntry, 'NutrientEntry');
initMetadataForClass(Completeness, 'Completeness');
initMetadataForClass(Contributor, 'Contributor');
initMetadataForClass(DailyNutrient, 'DailyNutrient');
initMetadataForClass(NutrientDay, 'NutrientDay');
initMetadataForClass(WeeklyNutrient, 'WeeklyNutrient');
initMetadataForClass(NutrientAverages, 'NutrientAverages');
initMetadataForClass(sam$kotlin_Comparator$0_3, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_4, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_5, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(NutrientAnalysis, 'NutrientAnalysis');
initMetadataForClass(FocusDay, 'FocusDay');
initMetadataForCompanion(Companion_6);
initMetadataForClass(NutrientFocus, 'NutrientFocus');
initMetadataForCompanion(Companion_7);
initMetadataForClass(GoalMethod, 'GoalMethod', VOID, Enum);
initMetadataForClass(GoalStatus, 'GoalStatus', VOID, Enum);
initMetadataForClass(NutrientGoalSetting, 'NutrientGoalSetting');
initMetadataForObject(NutrientGoalMethods, 'NutrientGoalMethods');
initMetadataForClass(NutrientGoalPeriod, 'NutrientGoalPeriod');
initMetadataForClass(NutrientGoalChange, 'NutrientGoalChange');
initMetadataForClass(sam$kotlin_Comparator$0_6, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(NutrientGoalHistory, 'NutrientGoalHistory');
initMetadataForObject(NutrientGoalJson, 'NutrientGoalJson');
initMetadataForObject(NutrientJson, 'NutrientJson');
initMetadataForClass(NutrientInfo, 'NutrientInfo');
initMetadataForClass(Per100g, 'Per100g');
initMetadataForObject(Nutrients, 'Nutrients');
initMetadataForClass(NutrientGoal, 'NutrientGoal');
initMetadataForObject(NutrientGoals, 'NutrientGoals');
initMetadataForClass(RecoveryDay, 'RecoveryDay');
initMetadataForObject(BodyMapArt, 'BodyMapArt');
initMetadataForClass(Point, 'Point');
initMetadataForClass(Fit, 'Fit');
initMetadataForObject(CurveFit, 'CurveFit');
initMetadataForClass(FixedReps, 'FixedReps', FixedReps);
initMetadataForClass(PowerLaw, 'PowerLaw');
initMetadataForCompanion(Companion_8);
initMetadataForClass(FatigueChoice, 'FatigueChoice', VOID, Enum);
initMetadataForCompanion(Companion_9);
initMetadataForClass(SurpriseCarry, 'SurpriseCarry', VOID, Enum);
initMetadataForObject(GeneratorSettingsJson, 'GeneratorSettingsJson');
initMetadataForClass(Barbell, 'Barbell');
initMetadataForClass(PlatePair, 'PlatePair');
initMetadataForClass(DumbbellRange, 'DumbbellRange');
initMetadataForClass(MicroMode, 'MicroMode', VOID, Enum);
initMetadataForClass(WeightStack, 'WeightStack');
initMetadataForCompanion(Companion_10);
initMetadataForClass(Gym, 'Gym', Gym);
initMetadataForClass(GymTemplate, 'GymTemplate', VOID, Enum);
initMetadataForClass(LoadRounding, 'LoadRounding', VOID, Enum);
initMetadataForClass(PlateLoadout, 'PlateLoadout');
initMetadataForObject(Loads, 'Loads');
initMetadataForClass(Search, 'Search');
initMetadataForClass(sam$kotlin_Comparator$0_7, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(PlateCalculator, 'PlateCalculator');
initMetadataForClass(LevelStatus, 'LevelStatus', VOID, Enum);
initMetadataForClass(MuscleLevel, 'MuscleLevel');
initMetadataForObject(MuscleLevels, 'MuscleLevels');
initMetadataForClass(MuscleIntensity, 'MuscleIntensity', VOID, Enum);
initMetadataForObject(MuscleHighlights, 'MuscleHighlights');
initMetadataForObject(Periodisation, 'Periodisation');
initMetadataForClass(Experience, 'Experience', VOID, Enum);
initMetadataForClass(Split, 'Split', VOID, Enum);
initMetadataForClass(CompoundSetRule, 'CompoundSetRule', VOID, Enum);
initMetadataForClass(RestRule, 'RestRule', VOID, Enum);
initMetadataForClass(GeneratorSettings, 'GeneratorSettings', GeneratorSettings);
initMetadataForClass(GeneratedProgram, 'GeneratedProgram');
initMetadataForClass(Slot, 'Slot', VOID, Enum);
initMetadataForClass(Template, 'Template', VOID, Enum);
initMetadataForClass(Picked, 'Picked');
initMetadataForClass(sam$kotlin_Comparator$0_8, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(ProgramGenerator$weeklyTargets$$inlined$groupingBy$1);
initMetadataForClass(ProgramGenerator$nameDays$$inlined$groupingBy$1);
initMetadataForObject(ProgramGenerator, 'ProgramGenerator');
initMetadataForClass(Substitute, 'Substitute');
initMetadataForClass(sam$kotlin_Comparator$0_9, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Substitutions, 'Substitutions');
initMetadataForClass(ImportedProgram, 'ImportedProgram');
initMetadataForObject(ProgramImport, 'ProgramImport');
initMetadataForClass(CyclePrescription, 'CyclePrescription');
initMetadataForClass(SetRecord, 'SetRecord');
initMetadataForClass(AdjustmentPriority, 'AdjustmentPriority', VOID, Enum);
initMetadataForClass(ProgressionOptions, 'ProgressionOptions', ProgressionOptions);
initMetadataForClass(TargetIssue, 'TargetIssue', VOID, Enum);
initMetadataForClass(AlternativeKind, 'AlternativeKind', VOID, Enum);
initMetadataForClass(TargetAlternative, 'TargetAlternative');
initMetadataForClass(PlannedSet, 'PlannedSet');
initMetadataForClass(ExerciseTargets, 'ExerciseTargets');
initMetadataForClass(Context, 'Context');
initMetadataForClass(Choice, 'Choice');
initMetadataForClass(sam$kotlin_Comparator$0_10, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_11, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Progression, 'Progression');
initMetadataForClass(SeriesRange, 'SeriesRange', VOID, Enum);
initMetadataForClass(SeriesAggregation, 'SeriesAggregation', VOID, Enum);
initMetadataForClass(SeriesAverage, 'SeriesAverage', VOID, Enum);
initMetadataForClass(SeriesPoint, 'SeriesPoint');
initMetadataForClass(sam$kotlin_Comparator$0_12, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_13, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(SeriesRanges, 'SeriesRanges');
initMetadataForClass(LoggedSet, 'LoggedSet');
initMetadataForClass(SetTarget, 'SetTarget');
initMetadataForClass(Candidate, 'Candidate');
initMetadataForClass(sam$kotlin_Comparator$0_14, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Strength, 'Strength');
initMetadataForClass(StackRange, 'StackRange');
function oneRepMax(loadKg, rtf) {
  return rtf <= 1.0 ? loadKg : loadKg / this.p18(rtf);
}
function load(oneRepMaxKg, rtf) {
  return oneRepMaxKg * this.p18(rtf);
}
initMetadataForInterface(StrengthCurve, 'StrengthCurve');
initMetadataForClass(EpleyCurve, 'EpleyCurve', EpleyCurve, VOID, [StrengthCurve]);
initMetadataForCompanion(Companion_11);
initMetadataForClass(FlooredExpCurve, 'FlooredExpCurve', VOID, VOID, [StrengthCurve]);
initMetadataForObject(OneRepMaxClamp, 'OneRepMaxClamp');
initMetadataForClass(CurveModel, 'CurveModel', VOID, Enum);
initMetadataForCompanion(Companion_12);
initMetadataForClass(Region, 'Region', VOID, Enum);
initMetadataForCompanion(Companion_13);
initMetadataForClass(Muscle, 'Muscle', VOID, Enum);
initMetadataForCompanion(Companion_14);
initMetadataForClass(Equipment, 'Equipment', VOID, Enum);
initMetadataForCompanion(Companion_15);
initMetadataForClass(SetType, 'SetType', VOID, Enum);
initMetadataForCompanion(Companion_16);
initMetadataForClass(ProgressionScheme, 'ProgressionScheme', VOID, Enum);
initMetadataForCompanion(Companion_17);
initMetadataForClass(Mechanic, 'Mechanic', VOID, Enum);
initMetadataForCompanion(Companion_18);
initMetadataForClass(Force, 'Force', VOID, Enum);
initMetadataForCompanion(Companion_19);
initMetadataForClass(TrainingGoal, 'TrainingGoal', VOID, Enum);
initMetadataForCompanion(Companion_20);
initMetadataForClass(DeloadPosition, 'DeloadPosition', VOID, Enum);
initMetadataForCompanion(Companion_21);
initMetadataForClass(MovementPattern, 'MovementPattern', VOID, Enum);
initMetadataForCompanion(Companion_22);
initMetadataForClass(ExerciseSlot, 'ExerciseSlot', VOID, Enum);
initMetadataForClass(Exercise, 'Exercise');
initMetadataForObject(ExerciseCatalogue, 'ExerciseCatalogue');
initMetadataForClass(TrainingSet, 'TrainingSet');
initMetadataForClass(RepMaxPoint, 'RepMaxPoint');
initMetadataForClass(WorkoutVolume, 'WorkoutVolume');
initMetadataForClass(WeeklyVolume, 'WeeklyVolume');
initMetadataForClass(LevelsWindow, 'LevelsWindow', VOID, Enum);
initMetadataForClass(sam$kotlin_Comparator$0_15, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_16, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_17, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForClass(sam$kotlin_Comparator$0_18, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(TrainingAnalytics, 'TrainingAnalytics');
initMetadataForObject(TrainingBacktest, 'TrainingBacktest');
initMetadataForClass(Kind, 'Kind', VOID, Enum);
initMetadataForCompanion(Companion_23);
initMetadataForClass(WarmupSpec, 'WarmupSpec');
initMetadataForCompanion(Companion_24);
initMetadataForClass(GroupKind, 'GroupKind', VOID, Enum);
initMetadataForClass(ProgramExercise, 'ProgramExercise');
initMetadataForClass(ProgramDay, 'ProgramDay');
initMetadataForClass(TrainingProgram, 'TrainingProgram');
initMetadataForObject(TrainingProgramJson, 'TrainingProgramJson');
initMetadataForClass(Prefill, 'Prefill', VOID, Enum);
initMetadataForClass(PreviousScope, 'PreviousScope', VOID, Enum);
initMetadataForCompanion(Companion_25);
initMetadataForClass(WarmupCategory, 'WarmupCategory', VOID, Enum);
initMetadataForCompanion(Companion_26);
initMetadataForClass(TrainingSettings, 'TrainingSettings', TrainingSettings);
initMetadataForObject(TrainingSettingsJson, 'TrainingSettingsJson');
initMetadataForObject(TrainingWeekdays, 'TrainingWeekdays');
initMetadataForClass(WarmupStep, 'WarmupStep');
initMetadataForClass(WarmupSet, 'WarmupSet');
initMetadataForClass(SmartWarmupStyle, 'SmartWarmupStyle', VOID, Enum);
initMetadataForClass(sam$kotlin_Comparator$0_19, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(Warmups, 'Warmups');
initMetadataForClass(TrendMethod, 'TrendMethod', VOID, Enum);
initMetadataForObject(Trend, 'Trend');
initMetadataForClass(LessLagParams, 'LessLagParams', LessLagParams);
initMetadataForClass(State, 'State');
initMetadataForClass(LessLagTrend$compute$$inlined$groupingBy$1);
initMetadataForObject(LessLagTrend, 'LessLagTrend');
initMetadataForClass(TransientTrendParams, 'TransientTrendParams', TransientTrendParams);
initMetadataForClass(TransientTrendPoint, 'TransientTrendPoint');
initMetadataForClass(TransientTrend$compute$$inlined$groupingBy$1);
initMetadataForObject(TransientTrend, 'TransientTrend');
initMetadataForClass(Direction, 'Direction', VOID, Enum);
initMetadataForClass(WeightChange, 'WeightChange');
initMetadataForCompanion(Companion_27);
initMetadataForClass(WeightInsights, 'WeightInsights');
initMetadataForObject(WeighInHabit, 'WeighInHabit');
initMetadataForClass(WeighIn, 'WeighIn');
initMetadataForClass(TrendPoint, 'TrendPoint');
initMetadataForClass(sam$kotlin_Comparator$0_20, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator, FunctionAdapter]);
initMetadataForObject(WeightTrend, 'WeightTrend');
initMetadataForClass(JsExpenditureModel, 'JsExpenditureModel');
initMetadataForClass(JsAlgorithmOption, 'JsAlgorithmOption');
initMetadataForClass(JsDisplayedExpenditure, 'JsDisplayedExpenditure');
initMetadataForClass(JsExpenditureChanges, 'JsExpenditureChanges');
initMetadataForClass(JsEnergyBalancePoint, 'JsEnergyBalancePoint');
initMetadataForClass(JsEnergyBalance, 'JsEnergyBalance');
initMetadataForClass(JsWeeklyCheckIn, 'JsWeeklyCheckIn');
initMetadataForClass(JsFastLoss, 'JsFastLoss');
initMetadataForClass(JsDietBreak, 'JsDietBreak');
initMetadataForClass(JsGoalProgress, 'JsGoalProgress');
initMetadataForClass(JsWeightMilestone, 'JsWeightMilestone');
initMetadataForClass(JsNutrientGoal, 'JsNutrientGoal');
initMetadataForClass(JsCompleteness, 'JsCompleteness');
initMetadataForClass(JsContributor, 'JsContributor');
initMetadataForClass(JsNutrientAverages, 'JsNutrientAverages');
initMetadataForClass(JsAlcohol, 'JsAlcohol');
initMetadataForClass(JsDrinkType, 'JsDrinkType');
initMetadataForClass(JsTrendPoint, 'JsTrendPoint');
initMetadataForClass(JsExpenditurePoint, 'JsExpenditurePoint');
initMetadataForClass(JsCheckInResult, 'JsCheckInResult');
initMetadataForClass(JsMacros, 'JsMacros');
initMetadataForClass(JsWeightInsights, 'JsWeightInsights');
initMetadataForClass(JsNutrientInfo, 'JsNutrientInfo');
initMetadataForClass(JsNutrientGoalSetting, 'JsNutrientGoalSetting');
initMetadataForClass(JsGoalMethod, 'JsGoalMethod');
initMetadataForClass(JsNutrientDay, 'JsNutrientDay');
initMetadataForClass(JsNutrientFocus, 'JsNutrientFocus');
initMetadataForClass(JsPlateLoadout, 'JsPlateLoadout');
initMetadataForClass(JsWarmupSet, 'JsWarmupSet');
initMetadataForClass(JsExerciseTargets, 'JsExerciseTargets');
initMetadataForClass(JsGeneratedProgram, 'JsGeneratedProgram');
initMetadataForClass(JsSubstitute, 'JsSubstitute');
initMetadataForClass(JsRepMaxPoint, 'JsRepMaxPoint');
initMetadataForClass(JsMuscleSets, 'JsMuscleSets');
initMetadataForClass(JsMuscleLevels, 'JsMuscleLevels');
initMetadataForClass(JsMuscleHighlights, 'JsMuscleHighlights');
initMetadataForClass(JsImportedProgram, 'JsImportedProgram');
initMetadataForClass(JsSeries, 'JsSeries');
initMetadataForClass(JsWeeklyVolumes, 'JsWeeklyVolumes');
initMetadataForClass(JsTrendChart, 'JsTrendChart');
//endregion
function daysInMonth($this, year, month) {
  switch (month) {
    case 2:
      return (year % 4 | 0) === 0 && !((year % 100 | 0) === 0) || (year % 400 | 0) === 0 ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
    default:
      return 31;
  }
}
function EpochDays() {
  EpochDays_instance = this;
  this.qd_1 = Regex_init_$Create$('^(\\d{4})-(\\d{2})-(\\d{2})$');
}
protoOf(EpochDays).rd = function (iso) {
  var tmp0_elvis_lhs = this.qd_1.x8(iso);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var match = tmp;
  var _destruct__k2r9zo = match.w9();
  // Inline function 'kotlin.text.Destructured.component1' call
  var y = _destruct__k2r9zo.od_1.v9().n(1);
  // Inline function 'kotlin.text.Destructured.component2' call
  var m = _destruct__k2r9zo.od_1.v9().n(2);
  // Inline function 'kotlin.text.Destructured.component3' call
  var d = _destruct__k2r9zo.od_1.v9().n(3);
  var year = toInt(y);
  var month = toInt(m);
  var day = toInt(d);
  if (!(1 <= month ? month <= 12 : false) || day < 1 || day > daysInMonth(this, year, month))
    return null;
  var shifted = month <= 2 ? year - 1 | 0 : year;
  var era = (shifted >= 0 ? shifted : shifted - 399 | 0) / 400 | 0;
  var yearOfEra = shifted - imul(era, 400) | 0;
  var dayOfYear = (((imul(153, month + (month > 2 ? -3 : 9) | 0) + 2 | 0) / 5 | 0) + day | 0) - 1 | 0;
  var dayOfEra = ((imul(yearOfEra, 365) + (yearOfEra / 4 | 0) | 0) - (yearOfEra / 100 | 0) | 0) + dayOfYear | 0;
  return (imul(era, 146097) + dayOfEra | 0) - 719468 | 0;
};
protoOf(EpochDays).sd = function (epochDay) {
  var z = epochDay + 719468 | 0;
  var era = (z >= 0 ? z : z - 146096 | 0) / 146097 | 0;
  var dayOfEra = z - imul(era, 146097) | 0;
  var yearOfEra = (((dayOfEra - (dayOfEra / 1460 | 0) | 0) + (dayOfEra / 36524 | 0) | 0) - (dayOfEra / 146096 | 0) | 0) / 365 | 0;
  var dayOfYear = dayOfEra - ((imul(365, yearOfEra) + (yearOfEra / 4 | 0) | 0) - (yearOfEra / 100 | 0) | 0) | 0;
  var mp = (imul(5, dayOfYear) + 2 | 0) / 153 | 0;
  var day = (dayOfYear - ((imul(153, mp) + 2 | 0) / 5 | 0) | 0) + 1 | 0;
  var month = mp < 10 ? mp + 3 | 0 : mp - 9 | 0;
  var year = (yearOfEra + imul(era, 400) | 0) + (month <= 2 ? 1 : 0) | 0;
  return padStart(year.toString(), 4, _Char___init__impl__6a9atx(48)) + '-' + padStart(month.toString(), 2, _Char___init__impl__6a9atx(48)) + '-' + padStart(day.toString(), 2, _Char___init__impl__6a9atx(48));
};
protoOf(EpochDays).td = function (epochDay) {
  return ((((epochDay + 3 | 0) % 7 | 0) + 7 | 0) % 7 | 0) + 1 | 0;
};
protoOf(EpochDays).ud = function (epochDay) {
  return epochDay - (this.td(epochDay) - 1 | 0) | 0;
};
var EpochDays_instance;
function EpochDays_getInstance() {
  if (EpochDays_instance == null)
    new EpochDays();
  return EpochDays_instance;
}
function Fmt() {
}
protoOf(Fmt).vd = function (value, decimals) {
  // Inline function 'kotlin.require' call
  if (!(0 <= decimals ? decimals <= 6 : false)) {
    var message = 'decimals must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var factor = new Long(1, 0);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < decimals)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'kotlin.Long.times' call
      var this_0 = factor;
      factor = multiply(this_0, fromInt(10));
    }
     while (inductionVariable < decimals);
  // Inline function 'kotlin.math.abs' call
  var tmp$ret$5 = Math.abs(value);
  var scaled = numberToLong(round(tmp$ret$5 * toNumber(factor)));
  var sign = value < 0.0 && !equalsLong(scaled, new Long(0, 0)) ? '-' : '';
  var whole = divide(scaled, factor);
  if (decimals === 0)
    return sign + whole.toString();
  return sign + whole.toString() + '.' + padStart(modulo(scaled, factor).toString(), decimals, _Char___init__impl__6a9atx(48));
};
protoOf(Fmt).wd = function (value, decimals, $super) {
  decimals = decimals === VOID ? 0 : decimals;
  return $super === VOID ? this.vd(value, decimals) : $super.vd.call(this, value, decimals);
};
protoOf(Fmt).xd = function (value, decimals) {
  var text = this.vd(value, decimals);
  var tmp;
  var tmp_0;
  if (value > 0.0) {
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.text.any' call
      var inductionVariable = 0;
      while (inductionVariable < charSequenceLength(text)) {
        var element = charSequenceGet(text, inductionVariable);
        inductionVariable = inductionVariable + 1 | 0;
        if (_Char___init__impl__6a9atx(49) <= element ? element <= _Char___init__impl__6a9atx(57) : false) {
          tmp$ret$0 = true;
          break $l$block;
        }
      }
      tmp$ret$0 = false;
    }
    tmp_0 = tmp$ret$0;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = '+' + text;
  } else {
    tmp = text;
  }
  return tmp;
};
protoOf(Fmt).yd = function (value, decimals, $super) {
  decimals = decimals === VOID ? 0 : decimals;
  return $super === VOID ? this.xd(value, decimals) : $super.xd.call(this, value, decimals);
};
protoOf(Fmt).zd = function (count, singular, plural) {
  return '' + count + ' ' + (count === 1 ? singular : plural);
};
protoOf(Fmt).ae = function (count, singular, plural, $super) {
  plural = plural === VOID ? singular + 's' : plural;
  return $super === VOID ? this.zd(count, singular, plural) : $super.zd.call(this, count, singular, plural);
};
var Fmt_instance;
function Fmt_getInstance() {
  return Fmt_instance;
}
function decimals($this, number) {
  return substringAfter(number, _Char___init__impl__6a9atx(46), '').length;
}
function convert($this, number, factor, decimals) {
  var value = toDouble(number) * factor;
  return (startsWith(number, '+') && value > 0.0 ? '+' : '') + Fmt_instance.vd(value, decimals);
}
function UnitText$localize$lambda(it) {
  return convert(UnitText_getInstance(), it.v9().n(1), 4.184, 0) + ' kJ';
}
function UnitText$localize$lambda_0(match) {
  return convert(UnitText_getInstance(), match.v9().n(1), 1.0 / 0.45359237, decimals(UnitText_getInstance(), match.v9().n(1))) + ' lb';
}
function UnitText() {
  UnitText_instance = this;
  this.be_1 = 0.45359237;
  this.ce_1 = 4.184;
  this.de_1 = Regex_init_$Create$('([+-]?\\d+(?:\\.\\d+)?) kcal\\b');
  this.ee_1 = Regex_init_$Create$('([+-]?\\d+(?:\\.\\d+)?) kg\\b');
}
protoOf(UnitText).fe = function (message, pounds, kilojoules) {
  var text = message;
  if (kilojoules) {
    var tmp = text;
    text = this.de_1.a9(tmp, UnitText$localize$lambda);
  }
  if (pounds) {
    var tmp_0 = text;
    text = this.ee_1.a9(tmp_0, UnitText$localize$lambda_0);
  }
  return text;
};
var UnitText_instance;
function UnitText_getInstance() {
  if (UnitText_instance == null)
    new UnitText();
  return UnitText_instance;
}
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  AlgorithmOptionKind_CHOICE_instance = new AlgorithmOptionKind('CHOICE', 0);
  AlgorithmOptionKind_BOOLEAN_instance = new AlgorithmOptionKind('BOOLEAN', 1);
  AlgorithmOptionKind_INTEGER_instance = new AlgorithmOptionKind('INTEGER', 2);
  AlgorithmOptionKind_NUMBER_instance = new AlgorithmOptionKind('NUMBER', 3);
  AlgorithmOptionKind_DATE_instance = new AlgorithmOptionKind('DATE', 4);
}
var AlgorithmOptionKind_CHOICE_instance;
var AlgorithmOptionKind_BOOLEAN_instance;
var AlgorithmOptionKind_INTEGER_instance;
var AlgorithmOptionKind_NUMBER_instance;
var AlgorithmOptionKind_DATE_instance;
function AlgorithmOptionKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function AlgorithmChoice(value, label) {
  this.ge_1 = value;
  this.he_1 = label;
}
protoOf(AlgorithmChoice).toString = function () {
  return 'AlgorithmChoice(value=' + this.ge_1 + ', label=' + this.he_1 + ')';
};
protoOf(AlgorithmChoice).hashCode = function () {
  var result = getStringHashCode(this.ge_1);
  result = imul(result, 31) + getStringHashCode(this.he_1) | 0;
  return result;
};
protoOf(AlgorithmChoice).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AlgorithmChoice))
    return false;
  if (!(this.ge_1 === other.ge_1))
    return false;
  if (!(this.he_1 === other.he_1))
    return false;
  return true;
};
function AlgorithmOption(key, label, help, kind, choices, get, set) {
  this.ie_1 = key;
  this.je_1 = label;
  this.ke_1 = help;
  this.le_1 = kind;
  this.me_1 = choices;
  this.ne_1 = get;
  this.oe_1 = set;
}
function choices($this, values, labels) {
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$(values.length);
  var index = 0;
  var inductionVariable = 0;
  var last = values.length;
  while (inductionVariable < last) {
    var item = values[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp$ret$2 = new AlgorithmChoice(item.w1_1, labels.n(_unary__edvuaz));
    destination.f(tmp$ret$2);
  }
  return destination;
}
function bool($this, text) {
  var tmp;
  switch (text) {
    case 'true':
      tmp = true;
      break;
    case 'false':
      tmp = false;
      break;
    default:
      throw IllegalArgumentException_init_$Create$("not true or false: '" + text + "'");
  }
  return tmp;
}
function positive($this, text) {
  var tmp0_safe_receiver = toDoubleOrNull(text);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver > 0.0 && isFinite(tmp0_safe_receiver)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("not a positive number: '" + text + "'");
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  return tmp_1;
}
function typed($this, option, text) {
  var tmp;
  switch (option.le_1.x1_1) {
    case 0:
    case 4:
      // Inline function 'kotlin.text.ifEmpty' call

      var tmp_0;
      // Inline function 'kotlin.text.isEmpty' call

      if (charSequenceLength(text) === 0) {
        tmp_0 = null;
      } else {
        tmp_0 = text;
      }

      tmp = tmp_0;
      break;
    case 1:
      tmp = text === 'true';
      break;
    case 2:
      tmp = toInt(text);
      break;
    case 3:
      tmp = toDoubleOrNull(text);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function text($this, value) {
  var tmp;
  if (value == null) {
    tmp = '';
  } else {
    if (typeof value === 'string') {
      tmp = value;
    } else {
      if (typeof value === 'boolean') {
        tmp = value.toString();
      } else {
        if (isNumber(value)) {
          // Inline function 'kotlin.let' call
          var it = numberToDouble(value);
          var tmp_0;
          var tmp_1;
          // Inline function 'kotlin.math.floor' call
          if (it === Math.floor(it)) {
            // Inline function 'kotlin.math.abs' call
            tmp_1 = Math.abs(it) < 1.0E15;
          } else {
            tmp_1 = false;
          }
          if (tmp_1) {
            tmp_0 = numberToLong(it).toString();
          } else {
            tmp_0 = it.toString();
          }
          tmp = tmp_0;
        } else {
          tmp = null;
        }
      }
    }
  }
  return tmp;
}
function AlgorithmJson$OPTIONS$lambda(it) {
  return it.pe_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_0(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_1(it) {
  var tmp0_safe_receiver = it.te_1;
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1_1;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function AlgorithmJson$OPTIONS$lambda_2(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = null;
  } else {
    // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
    AlgorithmJson_getInstance();
    // Inline function 'kotlin.enumValues' call
    var tmp0 = values();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.w1_1 === v) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  }
  return s.jf(VOID, VOID, VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_3(it) {
  return it.qe_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_4(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_0();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_5(it) {
  var tmp0_safe_receiver = it.re_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Fmt_instance.wd(tmp0_safe_receiver);
  }
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function AlgorithmJson$OPTIONS$lambda_6(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = null;
  } else {
    tmp = positive(AlgorithmJson_getInstance(), v);
  }
  return s.jf(VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_7(it) {
  var tmp0_safe_receiver = it.se_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = EpochDays_getInstance().sd(tmp0_safe_receiver);
  }
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function AlgorithmJson$OPTIONS$lambda_8(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = null;
  } else {
    var tmp0_elvis_lhs = EpochDays_getInstance().rd(v);
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$("not an ISO date: '" + v + "'");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  }
  return s.jf(VOID, VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_9(it) {
  return it.ue_1.toString();
}
function AlgorithmJson$OPTIONS$lambda_10(s, v) {
  var tmp0_elvis_lhs = toIntOrNull(v);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("not a whole number: '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return s.jf(VOID, VOID, VOID, VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_11(it) {
  return it.ve_1.toString();
}
function AlgorithmJson$OPTIONS$lambda_12(s, v) {
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, bool(AlgorithmJson_getInstance(), v));
}
function AlgorithmJson$OPTIONS$lambda_13(it) {
  return it.we_1.toString();
}
function AlgorithmJson$OPTIONS$lambda_14(s, v) {
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, bool(AlgorithmJson_getInstance(), v));
}
function AlgorithmJson$OPTIONS$lambda_15(it) {
  return it.xe_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_16(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_15();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_17(it) {
  return it.ye_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_18(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_1();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_19(it) {
  return it.ze_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_20(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_22();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_21(it) {
  return it.af_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_22(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_6();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_23(it) {
  return it.bf_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_24(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_2();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_25(it) {
  return it.cf_1.kf_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_26(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_19();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, s.cf_1.of(tmp$ret$0));
}
function AlgorithmJson$OPTIONS$lambda_27(it) {
  var tmp0_safe_receiver = it.cf_1.lf_1;
  // Inline function 'kotlin.text.orEmpty' call
  var tmp0_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1_1;
  return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
}
function AlgorithmJson$OPTIONS$lambda_28(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = null;
  } else {
    // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
    AlgorithmJson_getInstance();
    // Inline function 'kotlin.enumValues' call
    var tmp0 = values_20();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var inductionVariable = 0;
      var last = tmp0.length;
      while (inductionVariable < last) {
        var element = tmp0[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        if (element.w1_1 === v) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$3;
    var tmp_0;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
    } else {
      tmp_0 = tmp0_elvis_lhs;
    }
    tmp = tmp_0;
  }
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, s.cf_1.of(VOID, tmp));
}
function AlgorithmJson$OPTIONS$lambda_29(it) {
  return it.cf_1.mf_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_30(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_21();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, s.cf_1.of(VOID, VOID, tmp$ret$0));
}
function AlgorithmJson$OPTIONS$lambda_31(it) {
  return it.cf_1.nf_1.toString();
}
function AlgorithmJson$OPTIONS$lambda_32(s, v) {
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, s.cf_1.of(VOID, VOID, VOID, bool(AlgorithmJson_getInstance(), v)));
}
function AlgorithmJson$OPTIONS$lambda_33(it) {
  return it.df_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_34(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_11();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_35(it) {
  return it.ef_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_36(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_10();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_37(it) {
  return Fmt_instance.vd(it.ff_1, 1);
}
function AlgorithmJson$OPTIONS$lambda_38(s, v) {
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(v) === 0) {
    tmp = 80.0;
  } else {
    tmp = positive(AlgorithmJson_getInstance(), v);
  }
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp);
}
function AlgorithmJson$OPTIONS$lambda_39(it) {
  return it.gf_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_40(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_3();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_41(it) {
  return it.hf_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_42(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_9();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson$OPTIONS$lambda_43(it) {
  return it.if_1.w1_1;
}
function AlgorithmJson$OPTIONS$lambda_44(s, v) {
  // Inline function 'app.macrotide.core.coaching.AlgorithmJson.enumOf' call
  AlgorithmJson_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_14();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === v) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$2;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown value '" + v + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var tmp$ret$0 = tmp;
  return s.jf(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp$ret$0);
}
function AlgorithmJson() {
  AlgorithmJson_instance = this;
  this.pf_1 = listOf([new AlgorithmChoice('false', 'Off'), new AlgorithmChoice('true', 'On')]);
  this.qf_1 = listOf(['v0 (adaptive, default)', 'v1 (state-space)', 'v2 (state-space with adaptation)']);
  var tmp = this;
  var tmp_0 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = get_entries();
  var tmp$ret$0 = copyToArray(this_0);
  var tmp_1 = choices(this, tmp$ret$0, this.qf_1);
  var tmp_2 = AlgorithmJson$OPTIONS$lambda;
  var tmp_3 = new AlgorithmOption('expenditureEngine', 'Expenditure engine', 'Which model estimates expenditure everywhere: the dashboard, the Expenditure screen and the check-in.', tmp_0, tmp_1, tmp_2, AlgorithmJson$OPTIONS$lambda_0);
  var tmp_4 = AlgorithmOptionKind_CHOICE_getInstance();
  var tmp_5 = listOf_0(new AlgorithmChoice('', 'None'));
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = get_entries();
  var tmp$ret$1 = copyToArray(this_1);
  var tmp_6 = plus(tmp_5, choices(this, tmp$ret$1, this.qf_1));
  var tmp_7 = AlgorithmJson$OPTIONS$lambda_1;
  var tmp_8 = new AlgorithmOption('compareEngine', 'Compare with', 'A second engine drawn on the Expenditure chart, the in-app version of the backtest.', tmp_4, tmp_6, tmp_7, AlgorithmJson$OPTIONS$lambda_2);
  var tmp_9 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_2 = get_entries_0();
  var tmp$ret$2 = copyToArray(this_2);
  var tmp_10 = choices(this, tmp$ret$2, listOf(['Dynamic', 'Static']));
  var tmp_11 = AlgorithmJson$OPTIONS$lambda_3;
  var tmp_12 = new AlgorithmOption('expenditureMode', 'Expenditure mode', 'Static uses the value below instead of the engine, bounded by the floor and 3 \xD7 BMR. The engine still runs for comparison.', tmp_9, tmp_10, tmp_11, AlgorithmJson$OPTIONS$lambda_4);
  var tmp_13 = AlgorithmOptionKind_NUMBER_getInstance();
  var tmp_14 = emptyList();
  var tmp_15 = AlgorithmJson$OPTIONS$lambda_5;
  var tmp_16 = new AlgorithmOption('staticKcal', 'Static expenditure (kcal)', 'Used when the mode is static.', tmp_13, tmp_14, tmp_15, AlgorithmJson$OPTIONS$lambda_6);
  var tmp_17 = AlgorithmOptionKind_DATE_getInstance();
  var tmp_18 = emptyList();
  var tmp_19 = AlgorithmJson$OPTIONS$lambda_7;
  var tmp_20 = new AlgorithmOption('expenditureStartDate', 'Expenditure start date', 'Start the estimate here instead of at the first weigh-in, after a long break or a reset. It seeds from the last check-in before it.', tmp_17, tmp_18, tmp_19, AlgorithmJson$OPTIONS$lambda_8);
  var tmp_21 = AlgorithmOptionKind_INTEGER_getInstance();
  var tmp_22 = listOf_0(new AlgorithmChoice('4', '4 of 7 days (default)'));
  var tmp_23 = AlgorithmJson$OPTIONS$lambda_9;
  var tmp_24 = new AlgorithmOption('holdMinUsableDays', 'Hold threshold', "Expenditure holds, and the check-in keeps last week's targets, when fewer of the last 7 days than this have usable intake.", tmp_21, tmp_22, tmp_23, AlgorithmJson$OPTIONS$lambda_10);
  var tmp_25 = AlgorithmOptionKind_BOOLEAN_getInstance();
  var tmp_26 = AlgorithmJson$OPTIONS$lambda_11;
  var tmp_27 = new AlgorithmOption('holdAfterLastWeighIn', 'Hold after the last weigh-in', 'Days after your last weigh-in hold the last value; the next weigh-in fills them in.', tmp_25, this.pf_1, tmp_26, AlgorithmJson$OPTIONS$lambda_12);
  var tmp_28 = AlgorithmOptionKind_BOOLEAN_getInstance();
  var tmp_29 = AlgorithmJson$OPTIONS$lambda_13;
  var tmp_30 = new AlgorithmOption('goalAdjustmentCaps', 'Cap the goal adjustment', 'Limits how fast expenditure moves after a goal change: 25 kcal a day and 300 kcal in each direction, refilled slowly.', tmp_28, this.pf_1, tmp_29, AlgorithmJson$OPTIONS$lambda_14);
  var tmp_31 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_3 = get_entries_10();
  var tmp$ret$3 = copyToArray(this_3);
  var tmp_32 = choices(this, tmp$ret$3, listOf(['None (default)', 'Resting burn (ours)']));
  var tmp_33 = AlgorithmJson$OPTIONS$lambda_15;
  var tmp_34 = new AlgorithmOption('expenditureFloor', 'Expenditure floor', 'A lower bound so a few wrongly logged days cannot drag expenditure to impossible values.', tmp_31, tmp_32, tmp_33, AlgorithmJson$OPTIONS$lambda_16);
  var tmp_35 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_4 = get_entries_1();
  var tmp$ret$4 = copyToArray(this_4);
  var tmp_36 = choices(this, tmp$ret$4, listOf(['By body fat (Forbes, default)', 'Flat 7,700 kcal (MacroFactor)']));
  var tmp_37 = AlgorithmJson$OPTIONS$lambda_17;
  var tmp_38 = new AlgorithmOption('energyDensity', 'Energy per kg', 'Energy in a kg of weight change, used by the engines and the check-in.', tmp_35, tmp_36, tmp_37, AlgorithmJson$OPTIONS$lambda_18);
  var tmp_39 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_5 = get_entries_17();
  var tmp$ret$5 = copyToArray(this_5);
  var tmp_40 = choices(this, tmp$ret$5, listOf(['Your recent average (default)', 'Your expenditure']));
  var tmp_41 = AlgorithmJson$OPTIONS$lambda_19;
  var tmp_42 = new AlgorithmOption('intakePrior', 'Unlogged days (v1, v2)', 'What the state-space engines assume you ate on a day with no usable log.', tmp_39, tmp_40, tmp_41, AlgorithmJson$OPTIONS$lambda_20);
  var tmp_43 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_6 = get_entries_5();
  var tmp$ret$6 = copyToArray(this_6);
  var tmp_44 = choices(this, tmp$ret$6, listOf(['35 %, 60 % after 3 weeks (default)', 'None: follow expenditure', "Adaptive: by the engine's certainty"]));
  var tmp_45 = AlgorithmJson$OPTIONS$lambda_21;
  var tmp_46 = new AlgorithmOption('checkInSmoothing', 'Check-in smoothing', "How far each check-in moves your target toward expenditure plus your goal's change.", tmp_43, tmp_44, tmp_45, AlgorithmJson$OPTIONS$lambda_22);
  var tmp_47 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_7 = get_entries_2();
  var tmp$ret$7 = copyToArray(this_7);
  var tmp_48 = choices(this, tmp$ret$7, listOf(['Weight data (default)', 'Goal rate', 'Blend']));
  var tmp_49 = AlgorithmJson$OPTIONS$lambda_23;
  var tmp_50 = new AlgorithmOption('predictionStyle', 'Weight prediction', 'Which rate projects your goal date: your trend, your goal rate, or half of each.', tmp_47, tmp_48, tmp_49, AlgorithmJson$OPTIONS$lambda_24);
  var tmp_51 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_8 = get_entries_14();
  var tmp$ret$8 = copyToArray(this_8);
  var tmp_52 = choices(this, tmp$ret$8, listOf(['Katch with body fat, else Mifflin (default)', 'Katch\u2013McArdle', 'Mifflin\u2013St Jeor', 'Cunningham', 'ten Haaf (athletes and lifters)']));
  var tmp_53 = AlgorithmJson$OPTIONS$lambda_25;
  var tmp_54 = new AlgorithmOption('bmrEquation', 'BMR equation', 'Seeds expenditure before there is data, after a reset or a long break.', tmp_51, tmp_52, tmp_53, AlgorithmJson$OPTIONS$lambda_26);
  var tmp_55 = AlgorithmOptionKind_CHOICE_getInstance();
  var tmp_56 = listOf_0(new AlgorithmChoice('', 'From the profile (default)'));
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_9 = get_entries_15();
  var tmp$ret$9 = copyToArray(this_9);
  var tmp_57 = plus(tmp_56, choices(this, tmp$ret$9, listOf(['Mostly sedentary', 'Moderately active', 'Very active'])));
  var tmp_58 = AlgorithmJson$OPTIONS$lambda_27;
  var tmp_59 = new AlgorithmOption('dailyActivity', 'Daily life', "Activity outside exercise; with a choice here, activity is daily life plus exercise sessions instead of the profile's level.", tmp_55, tmp_57, tmp_58, AlgorithmJson$OPTIONS$lambda_28);
  var tmp_60 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_10 = get_entries_16();
  var tmp$ret$10 = copyToArray(this_10);
  var tmp_61 = choices(this, tmp$ret$10, listOf(['None', '1\u20133', '4\u20136', '7 or more']));
  var tmp_62 = AlgorithmJson$OPTIONS$lambda_29;
  var tmp_63 = new AlgorithmOption('exerciseSessions', 'Exercise sessions a week', 'Added to daily life when that is set.', tmp_60, tmp_61, tmp_62, AlgorithmJson$OPTIONS$lambda_30);
  var tmp_64 = AlgorithmOptionKind_BOOLEAN_getInstance();
  var tmp_65 = AlgorithmJson$OPTIONS$lambda_31;
  var tmp_66 = new AlgorithmOption('recentlyLosing', 'Losing recently', 'Lowers the starting estimate by 5 %.', tmp_64, this.pf_1, tmp_65, AlgorithmJson$OPTIONS$lambda_32);
  var tmp_67 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_11 = get_entries_8();
  var tmp$ret$11 = copyToArray(this_11);
  var tmp_68 = choices(this, tmp$ret$11, listOf(['By lean mass (default)', 'By goal and training (ours)']));
  var tmp_69 = AlgorithmJson$OPTIONS$lambda_33;
  var tmp_70 = new AlgorithmOption('proteinMethod', 'Protein', 'How the check-in sets protein.', tmp_67, tmp_68, tmp_69, AlgorithmJson$OPTIONS$lambda_34);
  var tmp_71 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_12 = get_entries_7();
  var tmp$ret$12 = copyToArray(this_12);
  var tmp_72 = choices(this, tmp$ret$12, listOf(['Auto, from logged sets', 'None', 'Cardio', 'Strength', 'Both']));
  var tmp_73 = AlgorithmJson$OPTIONS$lambda_35;
  var tmp_74 = new AlgorithmOption('trainingType', 'Training type', 'For protein. Auto counts strength training from 6 hard sets a week in your logged workouts.', tmp_71, tmp_72, tmp_73, AlgorithmJson$OPTIONS$lambda_36);
  var tmp_75 = AlgorithmOptionKind_NUMBER_getInstance();
  var tmp_76 = emptyList();
  var tmp_77 = AlgorithmJson$OPTIONS$lambda_37;
  var tmp_78 = new AlgorithmOption('proteinLeanCapKg', 'Lean mass cap for protein (kg)', 'Lean mass above this does not raise protein.', tmp_75, tmp_76, tmp_77, AlgorithmJson$OPTIONS$lambda_38);
  var tmp_79 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_13 = get_entries_3();
  var tmp$ret$13 = copyToArray(this_13);
  var tmp_80 = choices(this, tmp$ret$13, listOf(['Fixed 1,200 / 800 (default)', 'By body size (ours)']));
  var tmp_81 = AlgorithmJson$OPTIONS$lambda_39;
  var tmp_82 = new AlgorithmOption('floorMode', 'Calorie floor', "How the program's standard or low floor is set.", tmp_79, tmp_80, tmp_81, AlgorithmJson$OPTIONS$lambda_40);
  var tmp_83 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_14 = get_entries_6();
  var tmp$ret$14 = copyToArray(this_14);
  var tmp_84 = choices(this, tmp$ret$14, listOf(['Current (default)', 'Revised (ours)']));
  var tmp_85 = AlgorithmJson$OPTIONS$lambda_41;
  var tmp_86 = new AlgorithmOption('macroSplit', 'Fat and carb split', 'How fat and carbs share the calories after protein, and what gives way first on a very low budget.', tmp_83, tmp_84, tmp_85, AlgorithmJson$OPTIONS$lambda_42);
  var tmp_87 = AlgorithmOptionKind_CHOICE_getInstance();
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_15 = get_entries_9();
  var tmp$ret$15 = copyToArray(this_15);
  var tmp_88 = choices(this, tmp$ret$15, listOf(['1.10\xD7 (default)', 'By number of high days (ours)']));
  var tmp_89 = AlgorithmJson$OPTIONS$lambda_43;
  tmp.rf_1 = listOf([tmp_3, tmp_8, tmp_12, tmp_16, tmp_20, tmp_24, tmp_27, tmp_30, tmp_34, tmp_38, tmp_42, tmp_46, tmp_50, tmp_54, tmp_59, tmp_63, tmp_66, tmp_70, tmp_74, tmp_78, tmp_82, tmp_86, new AlgorithmOption('highDayMode', 'High days', 'How much more a high day gets, and whether low days pin to the floor instead of splitting evenly.', tmp_87, tmp_88, tmp_89, AlgorithmJson$OPTIONS$lambda_44)]);
  var tmp_90 = this;
  // Inline function 'kotlin.collections.associateBy' call
  var this_16 = this.rf_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_16, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_16.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$18 = element.ie_1;
    destination.k2(tmp$ret$18, element);
  }
  tmp_90.sf_1 = destination;
}
protoOf(AlgorithmJson).tf = function (json) {
  // Inline function 'kotlin.text.isNullOrBlank' call
  if (json == null || isBlank(json))
    return new AlgorithmSettings();
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = JsonRead_instance.vf(Json_instance.uf(json), 'algorithms');
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp0_elvis_lhs = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return new AlgorithmSettings();
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var map = tmp_1;
  var tmp0 = this.rf_1;
  // Inline function 'kotlin.collections.fold' call
  var accumulator = new AlgorithmSettings();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_0 = accumulator;
    var tmp$ret$7;
    $l$block: {
      var tmp0_elvis_lhs_0 = text(AlgorithmJson_getInstance(), map.s1(element.ie_1));
      var tmp_2;
      if (tmp0_elvis_lhs_0 == null) {
        tmp$ret$7 = tmp0_0;
        break $l$block;
      } else {
        tmp_2 = tmp0_elvis_lhs_0;
      }
      var text_0 = tmp_2;
      // Inline function 'kotlin.runCatching' call
      AlgorithmJson_getInstance();
      var tmp_3;
      try {
        // Inline function 'kotlin.Companion.success' call
        var value_0 = element.oe_1(tmp0_0, text_0);
        tmp_3 = _Result___init__impl__xyqfz8(value_0);
      } catch ($p_0) {
        var tmp_4;
        if ($p_0 instanceof Error) {
          var e_0 = $p_0;
          // Inline function 'kotlin.Companion.failure' call
          tmp_4 = _Result___init__impl__xyqfz8(createFailure(e_0));
        } else {
          throw $p_0;
        }
        tmp_3 = tmp_4;
      }
      // Inline function 'kotlin.Result.getOrNull' call
      var this_1 = tmp_3;
      var tmp1_elvis_lhs = _Result___get_isFailure__impl__jpiriv(this_1) ? null : _Result___get_value__impl__bjfvqg(this_1);
      tmp$ret$7 = tmp1_elvis_lhs == null ? tmp0_0 : tmp1_elvis_lhs;
    }
    accumulator = tmp$ret$7;
  }
  return accumulator;
};
protoOf(AlgorithmJson).wf = function (settings) {
  // Inline function 'kotlin.collections.associate' call
  var this_0 = this.rf_1;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.ie_1, element.ne_1(settings));
    destination.k2(pair.hb_1, pair.ib_1);
  }
  return destination;
};
protoOf(AlgorithmJson).xf = function (json, key, value) {
  var tmp0_elvis_lhs = this.sf_1.s1(key);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("unknown setting '" + key + "'");
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var option = tmp;
  var tmp_0;
  if (json == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(json)) {
      tmp_1 = json;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  var tmp2_safe_receiver = tmp_0;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    AlgorithmJson_getInstance();
    var tmp_3;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value_0 = JsonRead_instance.vf(Json_instance.uf(tmp2_safe_receiver), 'algorithms');
      tmp_3 = _Result___init__impl__xyqfz8(value_0);
    } catch ($p) {
      var tmp_4;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_4 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_3 = tmp_4;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_3;
    tmp_2 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs_0 = tmp_2;
  var raw = tmp0_elvis_lhs_0 == null ? emptyMap() : tmp0_elvis_lhs_0;
  var updated = option.oe_1(this.tf(json), value);
  return this.yf(updated, raw);
};
protoOf(AlgorithmJson).yf = function (settings, raw) {
  var out = LinkedHashMap_init_$Create$_0(raw);
  var _iterator__ex2g4s = this.rf_1.j();
  while (_iterator__ex2g4s.k()) {
    var option = _iterator__ex2g4s.l();
    var tmp2 = option.ie_1;
    // Inline function 'kotlin.collections.set' call
    var value = typed(this, option, option.ne_1(settings));
    out.k2(tmp2, value);
  }
  return Json_instance.zf(out);
};
var AlgorithmJson_instance;
function AlgorithmJson_getInstance() {
  if (AlgorithmJson_instance == null)
    new AlgorithmJson();
  return AlgorithmJson_instance;
}
function AlgorithmOptionKind_CHOICE_getInstance() {
  static_init();
  return AlgorithmOptionKind_CHOICE_instance;
}
function AlgorithmOptionKind_BOOLEAN_getInstance() {
  static_init();
  return AlgorithmOptionKind_BOOLEAN_instance;
}
function AlgorithmOptionKind_INTEGER_getInstance() {
  static_init();
  return AlgorithmOptionKind_INTEGER_instance;
}
function AlgorithmOptionKind_NUMBER_getInstance() {
  static_init();
  return AlgorithmOptionKind_NUMBER_instance;
}
function AlgorithmOptionKind_DATE_getInstance() {
  static_init();
  return AlgorithmOptionKind_DATE_instance;
}
var static_init_called_0;
function static_init_0() {
  if (static_init_called_0)
    return Unit_instance;
  static_init_called_0 = true;
  ExpenditureEngine_V0_instance = new ExpenditureEngine('V0', 0);
  ExpenditureEngine_V1_instance = new ExpenditureEngine('V1', 1);
  ExpenditureEngine_V2_instance = new ExpenditureEngine('V2', 2);
}
var ExpenditureEngine_V0_instance;
var ExpenditureEngine_V1_instance;
var ExpenditureEngine_V2_instance;
function values() {
  static_init_0();
  return [ExpenditureEngine_V0_getInstance(), ExpenditureEngine_V1_getInstance(), ExpenditureEngine_V2_getInstance()];
}
function get_entries() {
  static_init_0();
  if ($ENTRIES == null)
    $ENTRIES = enumEntries(values());
  return $ENTRIES;
}
var $ENTRIES;
function ExpenditureEngine(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_1;
function static_init_1() {
  if (static_init_called_1)
    return Unit_instance;
  static_init_called_1 = true;
  ExpenditureMode_DYNAMIC_instance = new ExpenditureMode('DYNAMIC', 0);
  ExpenditureMode_STATIC_instance = new ExpenditureMode('STATIC', 1);
}
var ExpenditureMode_DYNAMIC_instance;
var ExpenditureMode_STATIC_instance;
function values_0() {
  static_init_1();
  return [ExpenditureMode_DYNAMIC_getInstance(), ExpenditureMode_STATIC_getInstance()];
}
function get_entries_0() {
  static_init_1();
  if ($ENTRIES_0 == null)
    $ENTRIES_0 = enumEntries(values_0());
  return $ENTRIES_0;
}
var $ENTRIES_0;
function ExpenditureMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_2;
function static_init_2() {
  if (static_init_called_2)
    return Unit_instance;
  static_init_called_2 = true;
  EnergyDensityMode_FORBES_instance = new EnergyDensityMode('FORBES', 0);
  EnergyDensityMode_FLAT_7700_instance = new EnergyDensityMode('FLAT_7700', 1);
}
var EnergyDensityMode_FORBES_instance;
var EnergyDensityMode_FLAT_7700_instance;
function values_1() {
  static_init_2();
  return [EnergyDensityMode_FORBES_getInstance(), EnergyDensityMode_FLAT_7700_getInstance()];
}
function get_entries_1() {
  static_init_2();
  if ($ENTRIES_1 == null)
    $ENTRIES_1 = enumEntries(values_1());
  return $ENTRIES_1;
}
var $ENTRIES_1;
function EnergyDensityMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_3;
function static_init_3() {
  if (static_init_called_3)
    return Unit_instance;
  static_init_called_3 = true;
  PredictionStyle_DATA_instance = new PredictionStyle('DATA', 0);
  PredictionStyle_GOAL_instance = new PredictionStyle('GOAL', 1);
  PredictionStyle_BLEND_instance = new PredictionStyle('BLEND', 2);
}
var PredictionStyle_DATA_instance;
var PredictionStyle_GOAL_instance;
var PredictionStyle_BLEND_instance;
function values_2() {
  static_init_3();
  return [PredictionStyle_DATA_getInstance(), PredictionStyle_GOAL_getInstance(), PredictionStyle_BLEND_getInstance()];
}
function get_entries_2() {
  static_init_3();
  if ($ENTRIES_2 == null)
    $ENTRIES_2 = enumEntries(values_2());
  return $ENTRIES_2;
}
var $ENTRIES_2;
function PredictionStyle(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Companion() {
  Companion_instance_1 = this;
  this.ag_1 = 4;
  this.bg_1 = numberRangeToNumber(1, 7);
  this.cg_1 = 7;
}
var Companion_instance_1;
function Companion_getInstance() {
  if (Companion_instance_1 == null)
    new Companion();
  return Companion_instance_1;
}
function AlgorithmSettings(expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode) {
  Companion_getInstance();
  expenditureEngine = expenditureEngine === VOID ? ExpenditureEngine_V0_getInstance() : expenditureEngine;
  expenditureMode = expenditureMode === VOID ? ExpenditureMode_DYNAMIC_getInstance() : expenditureMode;
  staticKcal = staticKcal === VOID ? null : staticKcal;
  expenditureStartDay = expenditureStartDay === VOID ? null : expenditureStartDay;
  compareEngine = compareEngine === VOID ? null : compareEngine;
  holdMinUsableDays = holdMinUsableDays === VOID ? 4 : holdMinUsableDays;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? false : holdAfterLastWeighIn;
  goalAdjustmentCaps = goalAdjustmentCaps === VOID ? false : goalAdjustmentCaps;
  expenditureFloor = expenditureFloor === VOID ? ExpenditureFloorKind_NONE_getInstance() : expenditureFloor;
  energyDensity = energyDensity === VOID ? EnergyDensityMode_FORBES_getInstance() : energyDensity;
  intakePrior = intakePrior === VOID ? IntakePrior_RECENT_MEAN_getInstance() : intakePrior;
  checkInSmoothing = checkInSmoothing === VOID ? CheckInSmoothing_FIXED_getInstance() : checkInSmoothing;
  predictionStyle = predictionStyle === VOID ? PredictionStyle_DATA_getInstance() : predictionStyle;
  initial = initial === VOID ? new InitialExpenditureOptions() : initial;
  proteinMethod = proteinMethod === VOID ? ProteinMethod_LEAN_TABLE_getInstance() : proteinMethod;
  trainingType = trainingType === VOID ? TrainingType_AUTO_getInstance() : trainingType;
  proteinLeanCapKg = proteinLeanCapKg === VOID ? 80.0 : proteinLeanCapKg;
  floorMode = floorMode === VOID ? FloorMode_FIXED_getInstance() : floorMode;
  macroSplit = macroSplit === VOID ? MacroSplit_CURRENT_getInstance() : macroSplit;
  highDayMode = highDayMode === VOID ? HighDayMode_FIXED_getInstance() : highDayMode;
  this.pe_1 = expenditureEngine;
  this.qe_1 = expenditureMode;
  this.re_1 = staticKcal;
  this.se_1 = expenditureStartDay;
  this.te_1 = compareEngine;
  this.ue_1 = holdMinUsableDays;
  this.ve_1 = holdAfterLastWeighIn;
  this.we_1 = goalAdjustmentCaps;
  this.xe_1 = expenditureFloor;
  this.ye_1 = energyDensity;
  this.ze_1 = intakePrior;
  this.af_1 = checkInSmoothing;
  this.bf_1 = predictionStyle;
  this.cf_1 = initial;
  this.df_1 = proteinMethod;
  this.ef_1 = trainingType;
  this.ff_1 = proteinLeanCapKg;
  this.gf_1 = floorMode;
  this.hf_1 = macroSplit;
  this.if_1 = highDayMode;
  var progression = Companion_getInstance().bg_1;
  var containsLower = progression.oc_1;
  var containsUpper = progression.pc_1;
  var containsArg = this.ue_1;
  // Inline function 'kotlin.require' call
  if (!(containsLower <= containsArg ? containsArg <= containsUpper : false)) {
    var message = 'holdMinUsableDays must be ' + Companion_getInstance().bg_1.toString();
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.ff_1 > 0.0)) {
    var message_0 = 'proteinLeanCapKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(AlgorithmSettings).dg = function () {
  return new CheckInParams(8 - this.ue_1 | 0);
};
protoOf(AlgorithmSettings).eg = function (weightKg, bodyFatFraction) {
  var tmp;
  switch (this.ye_1.x1_1) {
    case 0:
      tmp = EnergyDensity_instance.eg(weightKg, bodyFatFraction);
      break;
    case 1:
      tmp = 7700.0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(AlgorithmSettings).kg = function (expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode) {
  return new AlgorithmSettings(expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode);
};
protoOf(AlgorithmSettings).jf = function (expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode, $super) {
  expenditureEngine = expenditureEngine === VOID ? this.pe_1 : expenditureEngine;
  expenditureMode = expenditureMode === VOID ? this.qe_1 : expenditureMode;
  staticKcal = staticKcal === VOID ? this.re_1 : staticKcal;
  expenditureStartDay = expenditureStartDay === VOID ? this.se_1 : expenditureStartDay;
  compareEngine = compareEngine === VOID ? this.te_1 : compareEngine;
  holdMinUsableDays = holdMinUsableDays === VOID ? this.ue_1 : holdMinUsableDays;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? this.ve_1 : holdAfterLastWeighIn;
  goalAdjustmentCaps = goalAdjustmentCaps === VOID ? this.we_1 : goalAdjustmentCaps;
  expenditureFloor = expenditureFloor === VOID ? this.xe_1 : expenditureFloor;
  energyDensity = energyDensity === VOID ? this.ye_1 : energyDensity;
  intakePrior = intakePrior === VOID ? this.ze_1 : intakePrior;
  checkInSmoothing = checkInSmoothing === VOID ? this.af_1 : checkInSmoothing;
  predictionStyle = predictionStyle === VOID ? this.bf_1 : predictionStyle;
  initial = initial === VOID ? this.cf_1 : initial;
  proteinMethod = proteinMethod === VOID ? this.df_1 : proteinMethod;
  trainingType = trainingType === VOID ? this.ef_1 : trainingType;
  proteinLeanCapKg = proteinLeanCapKg === VOID ? this.ff_1 : proteinLeanCapKg;
  floorMode = floorMode === VOID ? this.gf_1 : floorMode;
  macroSplit = macroSplit === VOID ? this.hf_1 : macroSplit;
  highDayMode = highDayMode === VOID ? this.if_1 : highDayMode;
  return $super === VOID ? this.kg(expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode) : $super.kg.call(this, expenditureEngine, expenditureMode, staticKcal, expenditureStartDay, compareEngine, holdMinUsableDays, holdAfterLastWeighIn, goalAdjustmentCaps, expenditureFloor, energyDensity, intakePrior, checkInSmoothing, predictionStyle, initial, proteinMethod, trainingType, proteinLeanCapKg, floorMode, macroSplit, highDayMode);
};
protoOf(AlgorithmSettings).toString = function () {
  return 'AlgorithmSettings(expenditureEngine=' + this.pe_1.toString() + ', expenditureMode=' + this.qe_1.toString() + ', staticKcal=' + this.re_1 + ', expenditureStartDay=' + this.se_1 + ', compareEngine=' + toString_0(this.te_1) + ', holdMinUsableDays=' + this.ue_1 + ', holdAfterLastWeighIn=' + this.ve_1 + ', goalAdjustmentCaps=' + this.we_1 + ', expenditureFloor=' + this.xe_1.toString() + ', energyDensity=' + this.ye_1.toString() + ', intakePrior=' + this.ze_1.toString() + ', checkInSmoothing=' + this.af_1.toString() + ', predictionStyle=' + this.bf_1.toString() + ', initial=' + this.cf_1.toString() + ', proteinMethod=' + this.df_1.toString() + ', trainingType=' + this.ef_1.toString() + ', proteinLeanCapKg=' + this.ff_1 + ', floorMode=' + this.gf_1.toString() + ', macroSplit=' + this.hf_1.toString() + ', highDayMode=' + this.if_1.toString() + ')';
};
protoOf(AlgorithmSettings).hashCode = function () {
  var result = this.pe_1.hashCode();
  result = imul(result, 31) + this.qe_1.hashCode() | 0;
  result = imul(result, 31) + (this.re_1 == null ? 0 : getNumberHashCode(this.re_1)) | 0;
  result = imul(result, 31) + (this.se_1 == null ? 0 : this.se_1) | 0;
  result = imul(result, 31) + (this.te_1 == null ? 0 : this.te_1.hashCode()) | 0;
  result = imul(result, 31) + this.ue_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ve_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.we_1) | 0;
  result = imul(result, 31) + this.xe_1.hashCode() | 0;
  result = imul(result, 31) + this.ye_1.hashCode() | 0;
  result = imul(result, 31) + this.ze_1.hashCode() | 0;
  result = imul(result, 31) + this.af_1.hashCode() | 0;
  result = imul(result, 31) + this.bf_1.hashCode() | 0;
  result = imul(result, 31) + this.cf_1.hashCode() | 0;
  result = imul(result, 31) + this.df_1.hashCode() | 0;
  result = imul(result, 31) + this.ef_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.ff_1) | 0;
  result = imul(result, 31) + this.gf_1.hashCode() | 0;
  result = imul(result, 31) + this.hf_1.hashCode() | 0;
  result = imul(result, 31) + this.if_1.hashCode() | 0;
  return result;
};
protoOf(AlgorithmSettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AlgorithmSettings))
    return false;
  if (!this.pe_1.equals(other.pe_1))
    return false;
  if (!this.qe_1.equals(other.qe_1))
    return false;
  if (!equals(this.re_1, other.re_1))
    return false;
  if (!(this.se_1 == other.se_1))
    return false;
  if (!equals(this.te_1, other.te_1))
    return false;
  if (!(this.ue_1 === other.ue_1))
    return false;
  if (!(this.ve_1 === other.ve_1))
    return false;
  if (!(this.we_1 === other.we_1))
    return false;
  if (!this.xe_1.equals(other.xe_1))
    return false;
  if (!this.ye_1.equals(other.ye_1))
    return false;
  if (!this.ze_1.equals(other.ze_1))
    return false;
  if (!this.af_1.equals(other.af_1))
    return false;
  if (!this.bf_1.equals(other.bf_1))
    return false;
  if (!this.cf_1.equals(other.cf_1))
    return false;
  if (!this.df_1.equals(other.df_1))
    return false;
  if (!this.ef_1.equals(other.ef_1))
    return false;
  if (!equals(this.ff_1, other.ff_1))
    return false;
  if (!this.gf_1.equals(other.gf_1))
    return false;
  if (!this.hf_1.equals(other.hf_1))
    return false;
  if (!this.if_1.equals(other.if_1))
    return false;
  return true;
};
function ExpenditureEngine_V0_getInstance() {
  static_init_0();
  return ExpenditureEngine_V0_instance;
}
function ExpenditureEngine_V1_getInstance() {
  static_init_0();
  return ExpenditureEngine_V1_instance;
}
function ExpenditureEngine_V2_getInstance() {
  static_init_0();
  return ExpenditureEngine_V2_instance;
}
function ExpenditureMode_DYNAMIC_getInstance() {
  static_init_1();
  return ExpenditureMode_DYNAMIC_instance;
}
function ExpenditureMode_STATIC_getInstance() {
  static_init_1();
  return ExpenditureMode_STATIC_instance;
}
function EnergyDensityMode_FORBES_getInstance() {
  static_init_2();
  return EnergyDensityMode_FORBES_instance;
}
function EnergyDensityMode_FLAT_7700_getInstance() {
  static_init_2();
  return EnergyDensityMode_FLAT_7700_instance;
}
function PredictionStyle_DATA_getInstance() {
  static_init_3();
  return PredictionStyle_DATA_instance;
}
function PredictionStyle_GOAL_getInstance() {
  static_init_3();
  return PredictionStyle_GOAL_instance;
}
function PredictionStyle_BLEND_getInstance() {
  static_init_3();
  return PredictionStyle_BLEND_instance;
}
var static_init_called_4;
function static_init_4() {
  if (static_init_called_4)
    return Unit_instance;
  static_init_called_4 = true;
  FloorMode_FIXED_instance = new FloorMode('FIXED', 0);
  FloorMode_BODY_SIZE_instance = new FloorMode('BODY_SIZE', 1);
}
var FloorMode_FIXED_instance;
var FloorMode_BODY_SIZE_instance;
function values_3() {
  static_init_4();
  return [FloorMode_FIXED_getInstance(), FloorMode_BODY_SIZE_getInstance()];
}
function get_entries_3() {
  static_init_4();
  if ($ENTRIES_3 == null)
    $ENTRIES_3 = enumEntries(values_3());
  return $ENTRIES_3;
}
var $ENTRIES_3;
function FloorMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function MacroMinimums(fatG, carbsG, proteinG) {
  this.lg_1 = fatG;
  this.mg_1 = carbsG;
  this.ng_1 = proteinG;
}
protoOf(MacroMinimums).og = function () {
  return Macros_instance.ah(this.ng_1, this.lg_1, this.mg_1);
};
protoOf(MacroMinimums).toString = function () {
  return 'MacroMinimums(fatG=' + this.lg_1 + ', carbsG=' + this.mg_1 + ', proteinG=' + this.ng_1 + ')';
};
protoOf(MacroMinimums).hashCode = function () {
  var result = getNumberHashCode(this.lg_1);
  result = imul(result, 31) + getNumberHashCode(this.mg_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ng_1) | 0;
  return result;
};
protoOf(MacroMinimums).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MacroMinimums))
    return false;
  if (!equals(this.lg_1, other.lg_1))
    return false;
  if (!equals(this.mg_1, other.mg_1))
    return false;
  if (!equals(this.ng_1, other.ng_1))
    return false;
  return true;
};
function CalorieFloors() {
  this.bh_1 = 1.3;
  this.ch_1 = 50.0;
  this.dh_1 = 1.2;
}
protoOf(CalorieFloors).eh = function (mode, bodyWeightKg, leanMassKg, heightCm, leanCapKg) {
  var tmp;
  switch (mode.x1_1) {
    case 0:
    case 1:
      var tmp_0 = 0.6 * bodyWeightKg;
      // Inline function 'kotlin.math.min' call

      var tmp$ret$0 = Math.min(leanMassKg, leanCapKg);
      tmp = new MacroMinimums(tmp_0, 50.0, 1.2 * tmp$ret$0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CalorieFloors).fh = function (mode, floor, minimums) {
  var tmp0_elvis_lhs = floor.ih_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var fixed = tmp;
  var tmp_0;
  switch (mode.x1_1) {
    case 0:
      return fixed;
    case 1:
      tmp_0 = 1.3;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var margin = tmp_0;
  var tmp_1;
  switch (floor.x1_1) {
    case 0:
      // Inline function 'kotlin.math.max' call

      var b = margin * minimums.og();
      tmp_1 = Math.max(fixed, b);
      break;
    case 1:
      // Inline function 'kotlin.math.max' call

      var b_0 = minimums.og();
      tmp_1 = Math.max(fixed, b_0);
      break;
    case 2:
      tmp_1 = null;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_1;
};
var CalorieFloors_instance;
function CalorieFloors_getInstance() {
  return CalorieFloors_instance;
}
function FloorMode_FIXED_getInstance() {
  static_init_4();
  return FloorMode_FIXED_instance;
}
function FloorMode_BODY_SIZE_getInstance() {
  static_init_4();
  return FloorMode_BODY_SIZE_instance;
}
var static_init_called_5;
function static_init_5() {
  if (static_init_called_5)
    return Unit_instance;
  static_init_called_5 = true;
  GoalType_LOSE_instance = new GoalType('LOSE', 0);
  GoalType_MAINTAIN_instance = new GoalType('MAINTAIN', 1);
  GoalType_GAIN_instance = new GoalType('GAIN', 2);
}
var GoalType_LOSE_instance;
var GoalType_MAINTAIN_instance;
var GoalType_GAIN_instance;
function values_4() {
  static_init_5();
  return [GoalType_LOSE_getInstance(), GoalType_MAINTAIN_getInstance(), GoalType_GAIN_getInstance()];
}
function valueOf(value) {
  static_init_5();
  switch (value) {
    case 'LOSE':
      return GoalType_LOSE_getInstance();
    case 'MAINTAIN':
      return GoalType_MAINTAIN_getInstance();
    case 'GAIN':
      return GoalType_GAIN_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.GoalType.' + value);
      break;
  }
}
function get_entries_4() {
  static_init_5();
  if ($ENTRIES_4 == null)
    $ENTRIES_4 = enumEntries(values_4());
  return $ENTRIES_4;
}
var $ENTRIES_4;
function GoalType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function GoalAvailability() {
  this.jh_1 = 18;
  this.kh_1 = "Weight-loss goals aren't offered under 18. A doctor or dietitian can help.";
}
protoOf(GoalAvailability).lh = function (ageYears) {
  return !(ageYears == null) && ageYears < 18 ? minus(get_entries_4(), GoalType_LOSE_getInstance()) : toList(get_entries_4());
};
var GoalAvailability_instance;
function GoalAvailability_getInstance() {
  return GoalAvailability_instance;
}
function Goal(type, ratePctPerWeek, targetWeightKg) {
  this.mh_1 = type;
  this.nh_1 = ratePctPerWeek;
  this.oh_1 = targetWeightKg;
}
protoOf(Goal).ph = function (type, ratePctPerWeek, targetWeightKg) {
  return new Goal(type, ratePctPerWeek, targetWeightKg);
};
protoOf(Goal).qh = function (type, ratePctPerWeek, targetWeightKg, $super) {
  type = type === VOID ? this.mh_1 : type;
  ratePctPerWeek = ratePctPerWeek === VOID ? this.nh_1 : ratePctPerWeek;
  targetWeightKg = targetWeightKg === VOID ? this.oh_1 : targetWeightKg;
  return $super === VOID ? this.ph(type, ratePctPerWeek, targetWeightKg) : $super.ph.call(this, type, ratePctPerWeek, targetWeightKg);
};
protoOf(Goal).toString = function () {
  return 'Goal(type=' + this.mh_1.toString() + ', ratePctPerWeek=' + this.nh_1 + ', targetWeightKg=' + this.oh_1 + ')';
};
protoOf(Goal).hashCode = function () {
  var result = this.mh_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.nh_1) | 0;
  result = imul(result, 31) + (this.oh_1 == null ? 0 : getNumberHashCode(this.oh_1)) | 0;
  return result;
};
protoOf(Goal).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Goal))
    return false;
  if (!this.mh_1.equals(other.mh_1))
    return false;
  if (!equals(this.nh_1, other.nh_1))
    return false;
  if (!equals(this.oh_1, other.oh_1))
    return false;
  return true;
};
var static_init_called_6;
function static_init_6() {
  if (static_init_called_6)
    return Unit_instance;
  static_init_called_6 = true;
  CalorieFloor_STANDARD_instance = new CalorieFloor('STANDARD', 0, 1200.0);
  CalorieFloor_LOW_instance = new CalorieFloor('LOW', 1, 800.0);
  CalorieFloor_NONE_instance = new CalorieFloor('NONE', 2, null);
}
var CalorieFloor_STANDARD_instance;
var CalorieFloor_LOW_instance;
var CalorieFloor_NONE_instance;
function values_5() {
  static_init_6();
  return [CalorieFloor_STANDARD_getInstance(), CalorieFloor_LOW_getInstance(), CalorieFloor_NONE_getInstance()];
}
function valueOf_0(value) {
  static_init_6();
  switch (value) {
    case 'STANDARD':
      return CalorieFloor_STANDARD_getInstance();
    case 'LOW':
      return CalorieFloor_LOW_getInstance();
    case 'NONE':
      return CalorieFloor_NONE_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.CalorieFloor.' + value);
      break;
  }
}
function CalorieFloor(name, ordinal, kcal) {
  Enum.call(this, name, ordinal);
  this.ih_1 = kcal;
}
var static_init_called_7;
function static_init_7() {
  if (static_init_called_7)
    return Unit_instance;
  static_init_called_7 = true;
  CheckInSmoothing_FIXED_instance = new CheckInSmoothing('FIXED', 0);
  CheckInSmoothing_NONE_instance = new CheckInSmoothing('NONE', 1);
  CheckInSmoothing_ADAPTIVE_instance = new CheckInSmoothing('ADAPTIVE', 2);
}
var CheckInSmoothing_FIXED_instance;
var CheckInSmoothing_NONE_instance;
var CheckInSmoothing_ADAPTIVE_instance;
function values_6() {
  static_init_7();
  return [CheckInSmoothing_FIXED_getInstance(), CheckInSmoothing_NONE_getInstance(), CheckInSmoothing_ADAPTIVE_getInstance()];
}
function get_entries_5() {
  static_init_7();
  if ($ENTRIES_5 == null)
    $ENTRIES_5 = enumEntries(values_6());
  return $ENTRIES_5;
}
var $ENTRIES_5;
function CheckInSmoothing(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function CheckInInput(expenditureKcal, trendWeightKg, goal, kcalPerKg, previousTargetKcal, sameDirectionWeeks, expenditureHolding, calorieFloor, floorKcal, smoothing, expenditureSdKcal) {
  sameDirectionWeeks = sameDirectionWeeks === VOID ? 0 : sameDirectionWeeks;
  expenditureHolding = expenditureHolding === VOID ? false : expenditureHolding;
  calorieFloor = calorieFloor === VOID ? CalorieFloor_STANDARD_getInstance() : calorieFloor;
  floorKcal = floorKcal === VOID ? calorieFloor.ih_1 : floorKcal;
  smoothing = smoothing === VOID ? CheckInSmoothing_FIXED_getInstance() : smoothing;
  expenditureSdKcal = expenditureSdKcal === VOID ? null : expenditureSdKcal;
  this.rh_1 = expenditureKcal;
  this.sh_1 = trendWeightKg;
  this.th_1 = goal;
  this.uh_1 = kcalPerKg;
  this.vh_1 = previousTargetKcal;
  this.wh_1 = sameDirectionWeeks;
  this.xh_1 = expenditureHolding;
  this.yh_1 = calorieFloor;
  this.zh_1 = floorKcal;
  this.ai_1 = smoothing;
  this.bi_1 = expenditureSdKcal;
}
protoOf(CheckInInput).toString = function () {
  return 'CheckInInput(expenditureKcal=' + this.rh_1 + ', trendWeightKg=' + this.sh_1 + ', goal=' + this.th_1.toString() + ', kcalPerKg=' + this.uh_1 + ', previousTargetKcal=' + this.vh_1 + ', sameDirectionWeeks=' + this.wh_1 + ', expenditureHolding=' + this.xh_1 + ', calorieFloor=' + this.yh_1.toString() + ', floorKcal=' + this.zh_1 + ', smoothing=' + this.ai_1.toString() + ', expenditureSdKcal=' + this.bi_1 + ')';
};
protoOf(CheckInInput).hashCode = function () {
  var result = getNumberHashCode(this.rh_1);
  result = imul(result, 31) + getNumberHashCode(this.sh_1) | 0;
  result = imul(result, 31) + this.th_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.uh_1) | 0;
  result = imul(result, 31) + (this.vh_1 == null ? 0 : getNumberHashCode(this.vh_1)) | 0;
  result = imul(result, 31) + this.wh_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.xh_1) | 0;
  result = imul(result, 31) + this.yh_1.hashCode() | 0;
  result = imul(result, 31) + (this.zh_1 == null ? 0 : getNumberHashCode(this.zh_1)) | 0;
  result = imul(result, 31) + this.ai_1.hashCode() | 0;
  result = imul(result, 31) + (this.bi_1 == null ? 0 : getNumberHashCode(this.bi_1)) | 0;
  return result;
};
protoOf(CheckInInput).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CheckInInput))
    return false;
  if (!equals(this.rh_1, other.rh_1))
    return false;
  if (!equals(this.sh_1, other.sh_1))
    return false;
  if (!this.th_1.equals(other.th_1))
    return false;
  if (!equals(this.uh_1, other.uh_1))
    return false;
  if (!equals(this.vh_1, other.vh_1))
    return false;
  if (!(this.wh_1 === other.wh_1))
    return false;
  if (!(this.xh_1 === other.xh_1))
    return false;
  if (!this.yh_1.equals(other.yh_1))
    return false;
  if (!equals(this.zh_1, other.zh_1))
    return false;
  if (!this.ai_1.equals(other.ai_1))
    return false;
  if (!equals(this.bi_1, other.bi_1))
    return false;
  return true;
};
function CheckInResult(targetKcal, rawTargetKcal, effectiveRatePctPerWeek, limitedByFloor, changeKcal) {
  this.ci_1 = targetKcal;
  this.di_1 = rawTargetKcal;
  this.ei_1 = effectiveRatePctPerWeek;
  this.fi_1 = limitedByFloor;
  this.gi_1 = changeKcal;
}
protoOf(CheckInResult).toString = function () {
  return 'CheckInResult(targetKcal=' + this.ci_1 + ', rawTargetKcal=' + this.di_1 + ', effectiveRatePctPerWeek=' + this.ei_1 + ', limitedByFloor=' + this.fi_1 + ', changeKcal=' + this.gi_1 + ')';
};
protoOf(CheckInResult).hashCode = function () {
  var result = getNumberHashCode(this.ci_1);
  result = imul(result, 31) + getNumberHashCode(this.di_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ei_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.fi_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.gi_1) | 0;
  return result;
};
protoOf(CheckInResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CheckInResult))
    return false;
  if (!equals(this.ci_1, other.ci_1))
    return false;
  if (!equals(this.di_1, other.di_1))
    return false;
  if (!equals(this.ei_1, other.ei_1))
    return false;
  if (!(this.fi_1 === other.fi_1))
    return false;
  if (!equals(this.gi_1, other.gi_1))
    return false;
  return true;
};
function Persistence(direction, weeks) {
  direction = direction === VOID ? 0 : direction;
  weeks = weeks === VOID ? 0 : weeks;
  this.hi_1 = direction;
  this.ii_1 = weeks;
}
protoOf(Persistence).toString = function () {
  return 'Persistence(direction=' + this.hi_1 + ', weeks=' + this.ii_1 + ')';
};
protoOf(Persistence).hashCode = function () {
  var result = this.hi_1;
  result = imul(result, 31) + this.ii_1 | 0;
  return result;
};
protoOf(Persistence).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Persistence))
    return false;
  if (!(this.hi_1 === other.hi_1))
    return false;
  if (!(this.ii_1 === other.ii_1))
    return false;
  return true;
};
function CheckIn() {
  this.ji_1 = 0.35;
  this.ki_1 = 0.6;
  this.li_1 = 3;
  this.mi_1 = 0.7;
  this.ni_1 = 0.15;
  this.oi_1 = 100.0;
}
protoOf(CheckIn).pi = function (goal, trendWeightKg) {
  var tmp;
  switch (goal.mh_1.x1_1) {
    case 0:
      // Inline function 'kotlin.math.abs' call

      var x = goal.nh_1;
      tmp = -Math.abs(x);
      break;
    case 2:
      // Inline function 'kotlin.math.abs' call

      var x_0 = goal.nh_1;
      tmp = Math.abs(x_0);
      break;
    case 1:
      var target = goal.oh_1;
      tmp = target == null ? 0.0 : trendWeightKg > target + 0.7 ? -0.15 : trendWeightKg < target - 0.7 ? 0.15 : 0.0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CheckIn).qi = function (ratePctPerWeek, trendWeightKg, kcalPerKg) {
  return ratePctPerWeek / 100.0 * trendWeightKg * kcalPerKg / 7.0;
};
protoOf(CheckIn).ri = function (smoothing, sameDirectionWeeks, expenditureSdKcal) {
  var fixed = sameDirectionWeeks >= 3 ? 0.6 : 0.35;
  var tmp;
  switch (smoothing.x1_1) {
    case 0:
      tmp = fixed;
      break;
    case 1:
      tmp = 1.0;
      break;
    case 2:
      var tmp_0;
      if (expenditureSdKcal == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_1;
        if (expenditureSdKcal >= 0.0) {
          tmp_1 = expenditureSdKcal;
        } else {
          tmp_1 = null;
        }
        tmp_0 = tmp_1;
      }

      var tmp2_safe_receiver = tmp_0;
      var tmp_2;
      if (tmp2_safe_receiver == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = coerceIn(100.0 / (100.0 + tmp2_safe_receiver), 0.35, 1.0);
      }

      var tmp3_elvis_lhs = tmp_2;
      tmp = tmp3_elvis_lhs == null ? fixed : tmp3_elvis_lhs;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(CheckIn).si = function (input) {
  var rate = this.pi(input.th_1, input.sh_1);
  var raw = input.rh_1 + this.qi(rate, input.sh_1, input.uh_1);
  var previous = input.vh_1;
  var smoothed = previous == null ? raw : input.xh_1 ? previous : previous + this.ri(input.ai_1, input.wh_1, input.bi_1) * (raw - previous);
  var floor = input.zh_1;
  var limited = !(floor == null) && smoothed < floor;
  var target = !(floor == null) && limited ? floor : smoothed;
  return new CheckInResult(target, raw, rate, limited, previous == null ? 0.0 : target - previous);
};
protoOf(CheckIn).ti = function (current, previousTargetKcal, rawTargetKcal) {
  if (previousTargetKcal == null)
    return new Persistence();
  var direction = rawTargetKcal > previousTargetKcal ? 1 : rawTargetKcal < previousTargetKcal ? -1 : 0;
  return direction === 0 ? new Persistence() : direction === current.hi_1 ? new Persistence(direction, current.ii_1 + 1 | 0) : new Persistence(direction, 1);
};
var CheckIn_instance;
function CheckIn_getInstance() {
  return CheckIn_instance;
}
function GoalType_LOSE_getInstance() {
  static_init_5();
  return GoalType_LOSE_instance;
}
function GoalType_MAINTAIN_getInstance() {
  static_init_5();
  return GoalType_MAINTAIN_instance;
}
function GoalType_GAIN_getInstance() {
  static_init_5();
  return GoalType_GAIN_instance;
}
function CalorieFloor_STANDARD_getInstance() {
  static_init_6();
  return CalorieFloor_STANDARD_instance;
}
function CalorieFloor_LOW_getInstance() {
  static_init_6();
  return CalorieFloor_LOW_instance;
}
function CalorieFloor_NONE_getInstance() {
  static_init_6();
  return CalorieFloor_NONE_instance;
}
function CheckInSmoothing_FIXED_getInstance() {
  static_init_7();
  return CheckInSmoothing_FIXED_instance;
}
function CheckInSmoothing_NONE_getInstance() {
  static_init_7();
  return CheckInSmoothing_NONE_instance;
}
function CheckInSmoothing_ADAPTIVE_getInstance() {
  static_init_7();
  return CheckInSmoothing_ADAPTIVE_instance;
}
function RecoveryTrend(weekAverage, baselineAverage) {
  this.ui_1 = weekAverage;
  this.vi_1 = baselineAverage;
}
protoOf(RecoveryTrend).toString = function () {
  return 'RecoveryTrend(weekAverage=' + this.ui_1 + ', baselineAverage=' + this.vi_1 + ')';
};
protoOf(RecoveryTrend).hashCode = function () {
  var result = getNumberHashCode(this.ui_1);
  result = imul(result, 31) + (this.vi_1 == null ? 0 : getNumberHashCode(this.vi_1)) | 0;
  return result;
};
protoOf(RecoveryTrend).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RecoveryTrend))
    return false;
  if (!equals(this.ui_1, other.ui_1))
    return false;
  if (!equals(this.vi_1, other.vi_1))
    return false;
  return true;
};
function RecoverySignals(sleepAverageMin, shortSleep, energyAvailability, lowEnergyAvailability, restingHr, hrvMs) {
  this.wi_1 = sleepAverageMin;
  this.xi_1 = shortSleep;
  this.yi_1 = energyAvailability;
  this.zi_1 = lowEnergyAvailability;
  this.aj_1 = restingHr;
  this.bj_1 = hrvMs;
}
protoOf(RecoverySignals).toString = function () {
  return 'RecoverySignals(sleepAverageMin=' + this.wi_1 + ', shortSleep=' + this.xi_1 + ', energyAvailability=' + this.yi_1 + ', lowEnergyAvailability=' + this.zi_1 + ', restingHr=' + toString_0(this.aj_1) + ', hrvMs=' + toString_0(this.bj_1) + ')';
};
protoOf(RecoverySignals).hashCode = function () {
  var result = this.wi_1 == null ? 0 : getNumberHashCode(this.wi_1);
  result = imul(result, 31) + getBooleanHashCode(this.xi_1) | 0;
  result = imul(result, 31) + (this.yi_1 == null ? 0 : getNumberHashCode(this.yi_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.zi_1) | 0;
  result = imul(result, 31) + (this.aj_1 == null ? 0 : this.aj_1.hashCode()) | 0;
  result = imul(result, 31) + (this.bj_1 == null ? 0 : this.bj_1.hashCode()) | 0;
  return result;
};
protoOf(RecoverySignals).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RecoverySignals))
    return false;
  if (!equals(this.wi_1, other.wi_1))
    return false;
  if (!(this.xi_1 === other.xi_1))
    return false;
  if (!equals(this.yi_1, other.yi_1))
    return false;
  if (!(this.zi_1 === other.zi_1))
    return false;
  if (!equals(this.aj_1, other.aj_1))
    return false;
  if (!equals(this.bj_1, other.bj_1))
    return false;
  return true;
};
function trendText($this, trend, unit) {
  var tmp = Fmt_instance.wd(trend.ui_1) + ' ' + unit + ' this week';
  var tmp0_safe_receiver = trend.vi_1;
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = ' against ' + Fmt_instance.wd(tmp0_safe_receiver) + ' ' + unit + ' over the previous 30 days';
  }
  var tmp1_elvis_lhs = tmp_0;
  return tmp + (tmp1_elvis_lhs == null ? '' : tmp1_elvis_lhs);
}
function hoursMinutes($this, minutes) {
  var total = numberToInt(round(minutes));
  return '' + (total / 60 | 0) + ' h ' + padStart((total % 60 | 0).toString(), 2, _Char___init__impl__6a9atx(48)) + ' min';
}
function average_0($this, values) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = values.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element > 0.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.takeIf' call
  var tmp;
  if (destination.o() >= 4) {
    tmp = destination;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver = tmp;
  return tmp0_safe_receiver == null ? null : average(tmp0_safe_receiver);
}
function recovery$trend(support, week, baseline, pick) {
  if (!support)
    return null;
  var tmp = CheckInSignals_instance;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = week.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = pick(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  var tmp0_elvis_lhs = average_0(tmp, destination);
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var recent = tmp_0;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = baseline.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver_0 = pick(element_0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_0);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = destination_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    if (element_1 > 0.0) {
      destination_1.f(element_1);
    }
  }
  var past = destination_1;
  // Inline function 'kotlin.takeIf' call
  var tmp_1;
  if (past.o() >= 7) {
    tmp_1 = past;
  } else {
    tmp_1 = null;
  }
  var tmp1_safe_receiver = tmp_1;
  return new RecoveryTrend(recent, tmp1_safe_receiver == null ? null : average(tmp1_safe_receiver));
}
function CheckInSignals$recovery$lambda(it) {
  return it.fj_1;
}
function CheckInSignals$recovery$lambda_0(it) {
  return it.ej_1;
}
function CheckInSignals() {
  this.gj_1 = 330.0;
  this.hj_1 = 30.0;
  this.ij_1 = 4;
  this.jj_1 = 30;
  this.kj_1 = 7;
}
protoOf(CheckInSignals).lj = function (day, recovery, intake, reviewFrom, reviewTo, fatFreeMassKg, deficit, loggingBreak, strengthFalling) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = recovery.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsLower = (day - 7 | 0) + 1 | 0;
    var containsArg = element.cj_1;
    if (containsLower <= containsArg ? containsArg <= day : false) {
      destination.f(element);
    }
  }
  var week = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = week.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver = element_0.dj_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver);
    }
  }
  var sleep = average_0(this, destination_0);
  var shortSleep = deficit && !(sleep == null) && sleep <= 330.0 + 1.0E-9;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = intake.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp;
    var containsArg_0 = element_1.mj_1;
    if (reviewFrom <= containsArg_0 ? containsArg_0 <= reviewTo : false) {
      tmp = element_1.oj_1.equals(DayStatus_COMPLETE_getInstance()) || element_1.oj_1.equals(DayStatus_FASTED_getInstance());
    } else {
      tmp = false;
    }
    if (tmp) {
      destination_1.f(element_1);
    }
  }
  var usable = destination_1;
  var tmp_0;
  var tmp_1;
  if (!(fatFreeMassKg == null) && fatFreeMassKg > 0.0 && !loggingBreak) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_1 = !usable.m();
  } else {
    tmp_1 = false;
  }
  if (tmp_1) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_2 = usable.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_2 = _iterator__ex2g4s_2.l();
      var tmp_2 = sum;
      sum = tmp_2 + (element_2.oj_1.equals(DayStatus_FASTED_getInstance()) ? 0.0 : element_2.nj_1);
    }
    tmp_0 = sum / usable.o() / fatFreeMassKg;
  } else {
    tmp_0 = null;
  }
  var ea = tmp_0;
  var lowEa = !(ea == null) && ea < 30.0;
  var support = lowEa || strengthFalling;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = recovery.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    var containsLower_0 = ((day - 7 | 0) - 30 | 0) + 1 | 0;
    var containsUpper = day - 7 | 0;
    var containsArg_1 = element_3.cj_1;
    if (containsLower_0 <= containsArg_1 ? containsArg_1 <= containsUpper : false) {
      destination_2.f(element_3);
    }
  }
  var baseline = destination_2;
  var tmp_3 = recovery$trend(support, week, baseline, CheckInSignals$recovery$lambda);
  return new RecoverySignals(sleep, shortSleep, ea, lowEa, tmp_3, recovery$trend(support, week, baseline, CheckInSignals$recovery$lambda_0));
};
protoOf(CheckInSignals).pj = function (signals) {
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList_init_$Create$_0();
  if (signals.xi_1) {
    var tmp0_elvis_lhs = signals.wi_1;
    var minutes = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    this_0.f(new CheckInFlag(CheckInModule_RECOVERY_getInstance(), CheckInFlagCode_SHORT_SLEEP_getInstance(), 'You slept about ' + hoursMinutes(CheckInSignals_instance, minutes) + ' a night this week. In a trial of dieters, sleeping 5.5 hours instead of ' + '8.5 meant less fat and more muscle lost, with more hunger. Getting more sleep may help more than cutting further.'));
  }
  if (signals.zi_1) {
    var tmp = CheckInModule_RECOVERY_getInstance();
    var tmp_0 = CheckInFlagCode_LOW_ENERGY_AVAILABILITY_getInstance();
    var tmp_1 = Fmt_instance;
    var tmp1_elvis_lhs = signals.yi_1;
    this_0.f(new CheckInFlag(tmp, tmp_0, 'Before any exercise, you ate about ' + tmp_1.wd(tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) + ' kcal per kg of fat-free mass a day ' + 'this week, and exercise leaves less than that for the rest of your body. A study found hormone changes below 30 kcal per kg of fat-free mass. This is not a diagnosis: if it carries on and you feel run down or unwell, talk to a health professional.'));
  }
  var tmp2_safe_receiver = signals.aj_1;
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = 'resting heart rate ' + trendText(CheckInSignals_instance, tmp2_safe_receiver, 'bpm');
  }
  var tmp_3 = tmp_2;
  var tmp3_safe_receiver = signals.bj_1;
  var tmp_4;
  if (tmp3_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_4 = 'HRV ' + trendText(CheckInSignals_instance, tmp3_safe_receiver, 'ms');
  }
  var context = listOfNotNull([tmp_3, tmp_4]);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!context.m()) {
    this_0.f(new CheckInFlag(CheckInModule_RECOVERY_getInstance(), CheckInFlagCode_RECOVERY_CONTEXT_getInstance(), 'For context only: ' + joinToString(context, '; ') + '. These readings are too noisy to act on by themselves.'));
  }
  return this_0.t3();
};
var CheckInSignals_instance;
function CheckInSignals_getInstance() {
  return CheckInSignals_instance;
}
var static_init_called_8;
function static_init_8() {
  if (static_init_called_8)
    return Unit_instance;
  static_init_called_8 = true;
  MacroField_KCAL_instance = new MacroField('KCAL', 0);
  MacroField_PROTEIN_instance = new MacroField('PROTEIN', 1);
  MacroField_FAT_instance = new MacroField('FAT', 2);
  MacroField_CARBS_instance = new MacroField('CARBS', 3);
}
var MacroField_KCAL_instance;
var MacroField_PROTEIN_instance;
var MacroField_FAT_instance;
var MacroField_CARBS_instance;
function valueOf_1(value) {
  static_init_8();
  switch (value) {
    case 'KCAL':
      return MacroField_KCAL_getInstance();
    case 'PROTEIN':
      return MacroField_PROTEIN_getInstance();
    case 'FAT':
      return MacroField_FAT_getInstance();
    case 'CARBS':
      return MacroField_CARBS_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.MacroField.' + value);
      break;
  }
}
function MacroField(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function editDay($this, day, field, value, bodyWeightKg, diet, keepCalories) {
  var tmp;
  switch (field.x1_1) {
    case 0:
      tmp = Macros_instance.uj(value, bodyWeightKg, day.rj_1, diet);
      break;
    case 1:
      var tmp_0;
      if (keepCalories) {
        tmp_0 = withProtein($this, day.qj_1, value, bodyWeightKg, diet);
      } else {
        tmp_0 = new MacroTargets(Macros_instance.ah(value, day.sj_1, day.tj_1), value, day.sj_1, day.tj_1);
      }

      tmp = tmp_0;
      break;
    case 2:
      var tmp_1;
      if (keepCalories) {
        // Inline function 'kotlin.math.max' call
        var b = day.qj_1 - day.rj_1 * 4.0;
        // Inline function 'kotlin.math.min' call
        var b_0 = Math.max(0.0, b) / 9.0;
        var fat = Math.min(value, b_0);
        // Inline function 'kotlin.math.max' call
        var b_1 = (day.qj_1 - day.rj_1 * 4.0 - fat * 9.0) / 4.0;
        var carbs = Math.max(0.0, b_1);
        tmp_1 = new MacroTargets(day.qj_1, day.rj_1, fat, carbs);
      } else {
        tmp_1 = new MacroTargets(Macros_instance.ah(day.rj_1, value, day.tj_1), day.rj_1, value, day.tj_1);
      }

      tmp = tmp_1;
      break;
    case 3:
      var tmp_2;
      if (keepCalories) {
        // Inline function 'kotlin.math.max' call
        var b_2 = day.qj_1 - day.rj_1 * 4.0;
        // Inline function 'kotlin.math.min' call
        var b_3 = Math.max(0.0, b_2) / 4.0;
        var carbs_0 = Math.min(value, b_3);
        // Inline function 'kotlin.math.max' call
        var b_4 = (day.qj_1 - day.rj_1 * 4.0 - carbs_0 * 4.0) / 9.0;
        var fat_0 = Math.max(0.0, b_4);
        tmp_2 = new MacroTargets(day.qj_1, day.rj_1, fat_0, carbs_0);
      } else {
        tmp_2 = new MacroTargets(Macros_instance.ah(day.rj_1, day.sj_1, value), day.rj_1, day.sj_1, value);
      }

      tmp = tmp_2;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function withProtein($this, kcal, proteinG, bodyWeightKg, diet) {
  // Inline function 'kotlin.math.min' call
  var b = kcal / 4.0;
  var protein = Math.min(proteinG, b);
  var rest = kcal - protein * 4.0;
  var tmp0 = 0.6 * bodyWeightKg;
  // Inline function 'kotlin.math.min' call
  var b_0 = rest / 9.0;
  var fatFloorG = Math.min(tmp0, b_0);
  var _destruct__k2r9zo = Macros_instance.vj(kcal, protein, fatFloorG, diet);
  var fat = _destruct__k2r9zo.ya();
  var carbs = _destruct__k2r9zo.za();
  return new MacroTargets(kcal, protein, fat, carbs);
}
function CollaborativeTargets() {
}
protoOf(CollaborativeTargets).wj = function (targets, field, value, bodyWeightKg, diet, days, keepCalories, keepWeeklyTotal) {
  // Inline function 'kotlin.require' call
  if (!(value >= 0.0)) {
    var message = 'value must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(days, Collection)) {
      tmp = days.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$2 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = days.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(0 <= element ? element <= 6 : false)) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
    }
    tmp$ret$2 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$2) {
    var message_0 = 'days must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var week = DailyTargets_instance.xj(targets);
  var edited = days.m() ? toSet(numberRangeToNumber(0, 6)) : days;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(week, 10));
  var index = 0;
  var _iterator__ex2g4s_0 = week.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$8 = !edited.r(index_0) ? item : editDay(CollaborativeTargets_instance, item, field, value, bodyWeightKg, diet, keepCalories);
    destination.f(tmp$ret$8);
  }
  var result = toMutableList(destination);
  if (field.equals(MacroField_KCAL_getInstance()) && keepWeeklyTotal && edited.o() < 7) {
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = numberRangeToNumber(0, 6);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var inductionVariable = tmp0.oc_1;
    var last = tmp0.pc_1;
    if (inductionVariable <= last)
      do {
        var element_0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = element_0;
        if (!edited.r(it)) {
          destination_0.f(element_0);
        }
      }
       while (!(element_0 === last));
    var others = destination_0;
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_1 = edited.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_1 = _iterator__ex2g4s_1.l();
      var tmp_0 = sum;
      sum = tmp_0 + (result.n(element_1).qj_1 - week.n(element_1).qj_1);
    }
    var difference = sum;
    var perDay = difference / others.o();
    var _iterator__ex2g4s_2 = others.j();
    while (_iterator__ex2g4s_2.k()) {
      var index_1 = _iterator__ex2g4s_2.l();
      // Inline function 'kotlin.math.max' call
      var b = week.n(index_1).qj_1 - perDay;
      var kcal = Math.max(0.0, b);
      result.n2(index_1, Macros_instance.uj(kcal, bodyWeightKg, week.n(index_1).rj_1, diet));
    }
  }
  return result;
};
var CollaborativeTargets_instance;
function CollaborativeTargets_getInstance() {
  return CollaborativeTargets_instance;
}
function DailyTargets() {
}
protoOf(DailyTargets).xj = function (targets) {
  var tmp;
  switch (targets.o()) {
    case 7:
      tmp = targets;
      break;
    case 1:
      // Inline function 'kotlin.collections.List' call

      // Inline function 'kotlin.collections.MutableList' call

      var list = ArrayList_init_$Create$(7);
      // Inline function 'kotlin.repeat' call

      var inductionVariable = 0;
      if (inductionVariable < 7)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var tmp$ret$4 = targets.n(0);
          list.f(tmp$ret$4);
        }
         while (inductionVariable < 7);
      tmp = list;
      break;
    default:
      throw IllegalArgumentException_init_$Create$('targets must have 1 or 7 entries, not ' + targets.o());
  }
  return tmp;
};
protoOf(DailyTargets).yj = function (targets) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = this.xj(targets).j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = sum;
    sum = tmp + element.qj_1;
  }
  return sum / 7.0;
};
var DailyTargets_instance;
function DailyTargets_getInstance() {
  return DailyTargets_instance;
}
function MacroField_KCAL_getInstance() {
  static_init_8();
  return MacroField_KCAL_instance;
}
function MacroField_PROTEIN_getInstance() {
  static_init_8();
  return MacroField_PROTEIN_instance;
}
function MacroField_FAT_getInstance() {
  static_init_8();
  return MacroField_FAT_instance;
}
function MacroField_CARBS_getInstance() {
  static_init_8();
  return MacroField_CARBS_instance;
}
function Companion_0() {
  Companion_instance_2 = this;
  this.zj_1 = 7;
  this.ak_1 = listOf([1, 2]);
  this.bk_1 = "A diet break holds your calories at maintenance. Breaks can make dieting easier on appetite; they don't speed up fat loss, and each break week adds a week to your diet.";
}
var Companion_instance_2;
function Companion_getInstance_0() {
  if (Companion_instance_2 == null)
    new Companion_0();
  return Companion_instance_2;
}
function DietBreak(startDay, weeks) {
  Companion_getInstance_0();
  this.ck_1 = startDay;
  this.dk_1 = weeks;
}
protoOf(DietBreak).ek = function () {
  return this.ck_1 + imul(this.dk_1, 7) | 0;
};
protoOf(DietBreak).fk = function (day) {
  var containsLower = this.ck_1;
  return day < this.ek() ? containsLower <= day : false;
};
protoOf(DietBreak).gk = function (day) {
  var containsLower = this.ek();
  return day < (this.ek() + 7 | 0) ? containsLower <= day : false;
};
protoOf(DietBreak).toString = function () {
  return 'DietBreak(startDay=' + this.ck_1 + ', weeks=' + this.dk_1 + ')';
};
protoOf(DietBreak).hashCode = function () {
  var result = this.ck_1;
  result = imul(result, 31) + this.dk_1 | 0;
  return result;
};
protoOf(DietBreak).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DietBreak))
    return false;
  if (!(this.ck_1 === other.ck_1))
    return false;
  if (!(this.dk_1 === other.dk_1))
    return false;
  return true;
};
function GoalPeriodStart(day, goal) {
  this.hk_1 = day;
  this.ik_1 = goal;
}
protoOf(GoalPeriodStart).toString = function () {
  return 'GoalPeriodStart(day=' + this.hk_1 + ', goal=' + this.ik_1.toString() + ')';
};
protoOf(GoalPeriodStart).hashCode = function () {
  var result = this.hk_1;
  result = imul(result, 31) + this.ik_1.hashCode() | 0;
  return result;
};
protoOf(GoalPeriodStart).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalPeriodStart))
    return false;
  if (!(this.hk_1 === other.hk_1))
    return false;
  if (!this.ik_1.equals(other.ik_1))
    return false;
  return true;
};
function ExpenditureInput(endDay, weighIns, intake, profile, trendKg, bodyFatFraction, goals, inputs, checkInExpenditure, initialKcal, kcalPerKg, gainKcalPerKg, v2Terms) {
  var tmp;
  if (bodyFatFraction === VOID) {
    tmp = profile == null ? null : profile.mk_1;
  } else {
    tmp = bodyFatFraction;
  }
  bodyFatFraction = tmp;
  goals = goals === VOID ? emptyList() : goals;
  inputs = inputs === VOID ? new DailyInputs() : inputs;
  checkInExpenditure = checkInExpenditure === VOID ? emptyMap() : checkInExpenditure;
  initialKcal = initialKcal === VOID ? null : initialKcal;
  kcalPerKg = kcalPerKg === VOID ? null : kcalPerKg;
  gainKcalPerKg = gainKcalPerKg === VOID ? null : gainKcalPerKg;
  v2Terms = v2Terms === VOID ? Companion_getInstance_3().rk_1 : v2Terms;
  this.sk_1 = endDay;
  this.tk_1 = weighIns;
  this.uk_1 = intake;
  this.vk_1 = profile;
  this.wk_1 = trendKg;
  this.xk_1 = bodyFatFraction;
  this.yk_1 = goals;
  this.zk_1 = inputs;
  this.al_1 = checkInExpenditure;
  this.bl_1 = initialKcal;
  this.cl_1 = kcalPerKg;
  this.dl_1 = gainKcalPerKg;
  this.el_1 = v2Terms;
}
protoOf(ExpenditureInput).toString = function () {
  return 'ExpenditureInput(endDay=' + this.sk_1 + ', weighIns=' + toString(this.tk_1) + ', intake=' + toString(this.uk_1) + ', profile=' + toString_0(this.vk_1) + ', trendKg=' + this.wk_1 + ', bodyFatFraction=' + this.xk_1 + ', goals=' + toString(this.yk_1) + ', inputs=' + this.zk_1.toString() + ', checkInExpenditure=' + toString(this.al_1) + ', initialKcal=' + this.bl_1 + ', kcalPerKg=' + this.cl_1 + ', gainKcalPerKg=' + this.dl_1 + ', v2Terms=' + this.el_1.toString() + ')';
};
protoOf(ExpenditureInput).hashCode = function () {
  var result = this.sk_1;
  result = imul(result, 31) + hashCode(this.tk_1) | 0;
  result = imul(result, 31) + hashCode(this.uk_1) | 0;
  result = imul(result, 31) + (this.vk_1 == null ? 0 : this.vk_1.hashCode()) | 0;
  result = imul(result, 31) + (this.wk_1 == null ? 0 : getNumberHashCode(this.wk_1)) | 0;
  result = imul(result, 31) + (this.xk_1 == null ? 0 : getNumberHashCode(this.xk_1)) | 0;
  result = imul(result, 31) + hashCode(this.yk_1) | 0;
  result = imul(result, 31) + this.zk_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.al_1) | 0;
  result = imul(result, 31) + (this.bl_1 == null ? 0 : getNumberHashCode(this.bl_1)) | 0;
  result = imul(result, 31) + (this.cl_1 == null ? 0 : getNumberHashCode(this.cl_1)) | 0;
  result = imul(result, 31) + (this.dl_1 == null ? 0 : getNumberHashCode(this.dl_1)) | 0;
  result = imul(result, 31) + this.el_1.hashCode() | 0;
  return result;
};
protoOf(ExpenditureInput).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureInput))
    return false;
  if (!(this.sk_1 === other.sk_1))
    return false;
  if (!equals(this.tk_1, other.tk_1))
    return false;
  if (!equals(this.uk_1, other.uk_1))
    return false;
  if (!equals(this.vk_1, other.vk_1))
    return false;
  if (!equals(this.wk_1, other.wk_1))
    return false;
  if (!equals(this.xk_1, other.xk_1))
    return false;
  if (!equals(this.yk_1, other.yk_1))
    return false;
  if (!this.zk_1.equals(other.zk_1))
    return false;
  if (!equals(this.al_1, other.al_1))
    return false;
  if (!equals(this.bl_1, other.bl_1))
    return false;
  if (!equals(this.cl_1, other.cl_1))
    return false;
  if (!equals(this.dl_1, other.dl_1))
    return false;
  if (!this.el_1.equals(other.el_1))
    return false;
  return true;
};
function Companion_1() {
  Companion_instance_3 = this;
  this.fl_1 = new ExpenditureRun(emptyList(), emptyList(), null, null, null, null);
}
var Companion_instance_3;
function Companion_getInstance_1() {
  if (Companion_instance_3 == null)
    new Companion_1();
  return Companion_instance_3;
}
function ExpenditureRun(series, dynamic, initialKcal, kcalPerKg, band, comparison) {
  Companion_getInstance_1();
  this.gl_1 = series;
  this.hl_1 = dynamic;
  this.il_1 = initialKcal;
  this.jl_1 = kcalPerKg;
  this.kl_1 = band;
  this.ll_1 = comparison;
}
protoOf(ExpenditureRun).toString = function () {
  return 'ExpenditureRun(series=' + toString(this.gl_1) + ', dynamic=' + toString(this.hl_1) + ', initialKcal=' + this.il_1 + ', kcalPerKg=' + this.jl_1 + ', band=' + toString_0(this.kl_1) + ', comparison=' + toString_0(this.ll_1) + ')';
};
protoOf(ExpenditureRun).hashCode = function () {
  var result = hashCode(this.gl_1);
  result = imul(result, 31) + hashCode(this.hl_1) | 0;
  result = imul(result, 31) + (this.il_1 == null ? 0 : getNumberHashCode(this.il_1)) | 0;
  result = imul(result, 31) + (this.jl_1 == null ? 0 : getNumberHashCode(this.jl_1)) | 0;
  result = imul(result, 31) + (this.kl_1 == null ? 0 : this.kl_1.hashCode()) | 0;
  result = imul(result, 31) + (this.ll_1 == null ? 0 : hashCode(this.ll_1)) | 0;
  return result;
};
protoOf(ExpenditureRun).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureRun))
    return false;
  if (!equals(this.gl_1, other.gl_1))
    return false;
  if (!equals(this.hl_1, other.hl_1))
    return false;
  if (!equals(this.il_1, other.il_1))
    return false;
  if (!equals(this.jl_1, other.jl_1))
    return false;
  if (!equals(this.kl_1, other.kl_1))
    return false;
  if (!equals(this.ll_1, other.ll_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0(function_0) {
  this.ml_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0).y9 = function (a, b) {
  return this.ml_1(a, b);
};
protoOf(sam$kotlin_Comparator$0).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0).g2 = function () {
  return this.ml_1;
};
protoOf(sam$kotlin_Comparator$0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0).hashCode = function () {
  return hashCode(this.g2());
};
function ExpenditureRunner$run$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.nl_1;
  var tmp$ret$2 = b.nl_1;
  return compareValues(tmp, tmp$ret$2);
}
function run$engine($settings, $input, goalParams, initial, start, weights, intake, kcalPerKg, changes, floor, choice) {
  var tmp0_minUsableIntakeDaysInLastWeek = $settings.ue_1;
  var tmp1_holdAfterLastWeighIn = $settings.ve_1;
  var tmp2_intakePrior = $settings.ze_1;
  var tmp3_gainKcalPerKg = $input.dl_1;
  var stateSpace = new StateSpaceParams(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_intakePrior, VOID, tmp0_minUsableIntakeDaysInLastWeek, VOID, tmp1_holdAfterLastWeighIn, tmp3_gainKcalPerKg, goalParams);
  var tmp;
  switch (choice.x1_1) {
    case 0:
      tmp = to(AdaptiveExpenditure_instance.pl(initial, start, $input.sk_1, weights, intake, kcalPerKg, changes, new ExpenditureParams(VOID, VOID, $settings.ue_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, $settings.ve_1, $input.dl_1, goalParams), floor), null);
      break;
    case 1:
      tmp = to(StateSpaceExpenditure_instance.ql(initial, start, $input.sk_1, weights, intake, kcalPerKg, changes, stateSpace, floor), null);
      break;
    case 2:
      tmp = to(ExpenditureV2_instance.tl(initial, start, $input.sk_1, weights, intake, kcalPerKg, changes, stateSpace, $input.el_1, $input.zk_1, floor), ExpenditureV2_instance.ul(initial, start, $input.sk_1, weights, intake, kcalPerKg, changes, stateSpace, $input.el_1, $input.zk_1, floor));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function ExpenditureRunner() {
  this.vl_1 = 3.0;
}
protoOf(ExpenditureRunner).wl = function (settings, input) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = input.tk_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.nl_1 <= input.sk_1) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = ExpenditureRunner$run$lambda;
  var tmp$ret$4 = new sam$kotlin_Comparator$0(tmp);
  var weights = sortedWith(destination, tmp$ret$4);
  var valid = WeightTrend_instance.bm(weights);
  var tmp0_elvis_lhs = firstOrNull(valid);
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return Companion_getInstance_1().fl_1;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var first = tmp_0;
  var tmp1_elvis_lhs = input.wk_1;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return Companion_getInstance_1().fl_1;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var trendKg = tmp_1;
  var profile = input.vk_1;
  var bodyFat = input.xk_1;
  var tmp2_elvis_lhs = input.cl_1;
  var kcalPerKg = tmp2_elvis_lhs == null ? settings.eg(trendKg, bodyFat) : tmp2_elvis_lhs;
  var tmp0_0 = first.nl_1;
  var tmp3_elvis_lhs = settings.se_1;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = tmp3_elvis_lhs == null ? first.nl_1 : tmp3_elvis_lhs;
  var tmp$ret$5 = Math.max(tmp0_0, b);
  var start = coerceAtMost(tmp$ret$5, input.sk_1);
  var tmp_2;
  if (start === first.nl_1) {
    var tmp$ret$6;
    $l$block: {
      // Inline function 'kotlin.collections.first' call
      var _iterator__ex2g4s_0 = weights.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (element_0.ol_1 >= 25.0) {
          tmp$ret$6 = element_0;
          break $l$block;
        }
      }
      throw NoSuchElementException_init_$Create$('Collection contains no element matching the predicate.');
    }
    tmp_2 = tmp$ret$6.ol_1;
  } else {
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.last' call
      var iterator = valid.p(valid.o());
      while (iterator.b3()) {
        var element_1 = iterator.c3();
        if (element_1.nl_1 <= start) {
          tmp$ret$8 = element_1;
          break $l$block_0;
        }
      }
      throw NoSuchElementException_init_$Create$('List contains no element matching the predicate.');
    }
    tmp_2 = tmp$ret$8.ol_1;
  }
  var startWeight = tmp_2;
  var tmp_3;
  if (profile == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = InitialExpenditure_instance.em(profile.jk_1, startWeight, profile.lk_1, profile.kk_1, profile.ok_1, bodyFat, settings.cf_1, profile.pk_1);
  }
  var formula = tmp_3;
  var tmp_4;
  if (!(settings.se_1 == null)) {
    // Inline function 'kotlin.collections.filterKeys' call
    var this_0 = input.al_1;
    var result = LinkedHashMap_init_$Create$_1();
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s_1 = this_0.v1().j();
    while (_iterator__ex2g4s_1.k()) {
      var entry = _iterator__ex2g4s_1.l();
      if (entry.o1() <= start) {
        result.k2(entry.o1(), entry.p1());
      }
    }
    // Inline function 'kotlin.collections.maxByOrNull' call
    var tmp0_1 = result.v1();
    var tmp$ret$16;
    $l$block_2: {
      // Inline function 'kotlin.collections.maxByOrNull' call
      var iterator_0 = tmp0_1.j();
      if (!iterator_0.k()) {
        tmp$ret$16 = null;
        break $l$block_2;
      }
      var maxElem = iterator_0.l();
      if (!iterator_0.k()) {
        tmp$ret$16 = maxElem;
        break $l$block_2;
      }
      var maxValue = maxElem.o1();
      do {
        var e = iterator_0.l();
        var v = e.o1();
        if (compareTo(maxValue, v) < 0) {
          maxElem = e;
          maxValue = v;
        }
      }
       while (iterator_0.k());
      tmp$ret$16 = maxElem;
    }
    var tmp5_safe_receiver = tmp$ret$16;
    tmp_4 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.p1();
  } else {
    tmp_4 = null;
  }
  var ownBefore = tmp_4;
  var tmp6_elvis_lhs = input.bl_1;
  var tmp_5;
  if (tmp6_elvis_lhs == null) {
    var tmp_6;
    if (formula == null) {
      tmp_6 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_6 = InitialExpenditure_instance.fm(null, ownBefore, formula);
    }
    tmp_5 = tmp_6;
  } else {
    tmp_5 = tmp6_elvis_lhs;
  }
  var tmp8_elvis_lhs = tmp_5;
  var tmp_7;
  if (tmp8_elvis_lhs == null) {
    return new ExpenditureRun(emptyList(), emptyList(), null, kcalPerKg, null, null);
  } else {
    tmp_7 = tmp8_elvis_lhs;
  }
  var initial = tmp_7;
  var tmp_8;
  if (bodyFat == null) {
    var tmp_9;
    if (profile == null) {
      tmp_9 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_9 = BodyComposition_instance.im(profile.jk_1, profile.kk_1, startWeight, profile.lk_1, profile.pk_1);
    }
    tmp_8 = tmp_9;
  } else {
    tmp_8 = bodyFat;
  }
  var tmp11_elvis_lhs = tmp_8;
  var leanFraction = 1.0 - (tmp11_elvis_lhs == null ? 0.0 : tmp11_elvis_lhs);
  var floor = ExpenditureFloor_instance.lm(settings.xe_1, leanFraction);
  var changes = this.mm(input.yk_1, valid);
  // Inline function 'kotlin.collections.filter' call
  var tmp0_2 = input.uk_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_2 = tmp0_2.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    if (element_2.mj_1 >= start) {
      destination_0.f(element_2);
    }
  }
  var intake = destination_0;
  var goalParams = new GoalAdjustmentParams(VOID, VOID, settings.we_1);
  var _destruct__k2r9zo = run$engine(settings, input, goalParams, initial, start, weights, intake, kcalPerKg, changes, floor, settings.pe_1);
  var dynamic = _destruct__k2r9zo.ya();
  var band = _destruct__k2r9zo.za();
  var tmp12_safe_receiver = settings.te_1;
  var tmp_10;
  if (tmp12_safe_receiver == null) {
    tmp_10 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_11;
    if (!tmp12_safe_receiver.equals(settings.pe_1)) {
      tmp_11 = tmp12_safe_receiver;
    } else {
      tmp_11 = null;
    }
    tmp_10 = tmp_11;
  }
  var tmp13_safe_receiver = tmp_10;
  var tmp_12;
  if (tmp13_safe_receiver == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_12 = run$engine(settings, input, goalParams, initial, start, weights, intake, kcalPerKg, changes, floor, tmp13_safe_receiver).hb_1;
  }
  var comparison = tmp_12;
  var staticKcal = settings.re_1;
  var tmp_13;
  if (settings.qe_1.equals(ExpenditureMode_STATIC_getInstance()) && !(staticKcal == null)) {
    var latest = last(valid).ol_1;
    var tmp15_elvis_lhs = floor == null ? null : floor(latest);
    var low = tmp15_elvis_lhs == null ? ExpenditureFloor_instance.nm(latest * leanFraction) : tmp15_elvis_lhs;
    var tmp_14;
    if (profile == null) {
      tmp_14 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_14 = 3.0 * InitialExpenditure_instance.om(profile.jk_1, latest, profile.lk_1, profile.kk_1, bodyFat, settings.cf_1, profile.pk_1);
    }
    var high = tmp_14;
    // Inline function 'kotlin.let' call
    var it = coerceAtLeast_0(staticKcal, low);
    var bounded = !(high == null) && high > low ? coerceAtMost_0(it, high) : it;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(dynamic, 10));
    var _iterator__ex2g4s_3 = dynamic.j();
    while (_iterator__ex2g4s_3.k()) {
      var item = _iterator__ex2g4s_3.l();
      var tmp$ret$36 = new ExpenditurePoint(item.pm_1, bounded, 0.0, ExpenditureStatus_UPDATING_getInstance());
      destination_1.f(tmp$ret$36);
    }
    tmp_13 = destination_1;
  } else {
    tmp_13 = dynamic;
  }
  var series = tmp_13;
  return new ExpenditureRun(series, dynamic, initial, kcalPerKg, band, comparison);
};
protoOf(ExpenditureRunner).mm = function (goals, weighIns) {
  if (goals.o() < 2)
    return emptyList();
  var tmp = WeightTrend_instance;
  // Inline function 'kotlin.collections.maxOf' call
  var iterator = goals.j();
  if (!iterator.k())
    throw NoSuchElementException_init_$Create$_0();
  var maxValue = iterator.l().hk_1;
  while (iterator.k()) {
    var v = iterator.l().hk_1;
    if (compareTo(maxValue, v) < 0) {
      maxValue = v;
    }
  }
  var tmp$ret$0 = maxValue;
  var trend = tmp.vm(weighIns, tmp$ret$0);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(trend, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = trend.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp_0 = element.wm_1;
    var tmp$ret$6 = element.zm_1;
    destination.k2(tmp_0, tmp$ret$6);
  }
  var trendByDay = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(goals, 10));
  var _iterator__ex2g4s_0 = goals.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp0_elvis_lhs = trendByDay.s1(item.hk_1);
    var tmp_1;
    if (tmp0_elvis_lhs == null) {
      var tmp1_safe_receiver = firstOrNull(trend);
      tmp_1 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.zm_1;
    } else {
      tmp_1 = tmp0_elvis_lhs;
    }
    var trendKg = tmp_1;
    var goal = trendKg == null ? item.ik_1.qh(VOID, VOID, null) : item.ik_1;
    var tmp_2 = CheckIn_instance;
    var tmp$ret$9 = new GoalStart(item.hk_1, tmp_2.pi(goal, trendKg == null ? 0.0 : trendKg));
    destination_0.f(tmp$ret$9);
  }
  var starts = destination_0;
  return Companion_instance_4.an(starts);
};
var ExpenditureRunner_instance;
function ExpenditureRunner_getInstance() {
  return ExpenditureRunner_instance;
}
function PacePreset(key, label, ratePctPerWeek, note) {
  this.bn_1 = key;
  this.cn_1 = label;
  this.dn_1 = ratePctPerWeek;
  this.en_1 = note;
}
protoOf(PacePreset).toString = function () {
  return 'PacePreset(key=' + this.bn_1 + ', label=' + this.cn_1 + ', ratePctPerWeek=' + this.dn_1 + ', note=' + this.en_1 + ')';
};
protoOf(PacePreset).hashCode = function () {
  var result = getStringHashCode(this.bn_1);
  result = imul(result, 31) + getStringHashCode(this.cn_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.dn_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.en_1) | 0;
  return result;
};
protoOf(PacePreset).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PacePreset))
    return false;
  if (!(this.bn_1 === other.bn_1))
    return false;
  if (!(this.cn_1 === other.cn_1))
    return false;
  if (!equals(this.dn_1, other.dn_1))
    return false;
  if (!(this.en_1 === other.en_1))
    return false;
  return true;
};
function PacePoint(day, kg) {
  this.fn_1 = day;
  this.gn_1 = kg;
}
protoOf(PacePoint).toString = function () {
  return 'PacePoint(day=' + this.fn_1 + ', kg=' + this.gn_1 + ')';
};
protoOf(PacePoint).hashCode = function () {
  var result = this.fn_1;
  result = imul(result, 31) + getNumberHashCode(this.gn_1) | 0;
  return result;
};
protoOf(PacePoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PacePoint))
    return false;
  if (!(this.fn_1 === other.fn_1))
    return false;
  if (!equals(this.gn_1, other.gn_1))
    return false;
  return true;
};
function PaceProjection(points, reachDay) {
  this.hn_1 = points;
  this.in_1 = reachDay;
}
protoOf(PaceProjection).toString = function () {
  return 'PaceProjection(points=' + toString(this.hn_1) + ', reachDay=' + this.in_1 + ')';
};
protoOf(PaceProjection).hashCode = function () {
  var result = hashCode(this.hn_1);
  result = imul(result, 31) + (this.in_1 == null ? 0 : this.in_1) | 0;
  return result;
};
protoOf(PaceProjection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PaceProjection))
    return false;
  if (!equals(this.hn_1, other.hn_1))
    return false;
  if (!(this.in_1 == other.in_1))
    return false;
  return true;
};
function CurvePoint(day, kg) {
  this.jn_1 = day;
  this.kn_1 = kg;
}
protoOf(CurvePoint).toString = function () {
  return 'CurvePoint(day=' + this.jn_1 + ', kg=' + this.kn_1 + ')';
};
protoOf(CurvePoint).hashCode = function () {
  var result = getNumberHashCode(this.jn_1);
  result = imul(result, 31) + getNumberHashCode(this.kn_1) | 0;
  return result;
};
protoOf(CurvePoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CurvePoint))
    return false;
  if (!equals(this.jn_1, other.jn_1))
    return false;
  if (!equals(this.kn_1, other.kn_1))
    return false;
  return true;
};
function GoalPace() {
  GoalPace_instance = this;
  this.ln_1 = listOf([new PacePreset('GENTLE', 'Gentle', 0.25, 'Easiest to keep'), new PacePreset('STANDARD', 'Standard', 0.5, 'Steady; most people pick this'), new PacePreset('FAST', 'Fast', 1.0, 'Harder, more hunger')]);
  this.mn_1 = listOf([new PacePreset('SLOW', 'Slow', 0.1, 'Least fat gained'), new PacePreset('STANDARD', 'Standard', 0.25, 'Steady muscle gain'), new PacePreset('FAST', 'Fast', 0.5, 'Quicker, with more fat')]);
  this.nn_1 = 0.05;
  this.on_1 = 1.5;
  this.pn_1 = 12;
  this.qn_1 = 0.1;
  this.rn_1 = 25.0;
  this.sn_1 = 23.0;
  this.tn_1 = setOf([Ethnicity_SOUTH_ASIAN_getInstance(), Ethnicity_CHINESE_getInstance(), Ethnicity_OTHER_ASIAN_getInstance(), Ethnicity_BLACK_AFRICAN_getInstance(), Ethnicity_BLACK_CARIBBEAN_getInstance(), Ethnicity_MIDDLE_EASTERN_getInstance()]);
  this.un_1 = 28.0;
  this.vn_1 = 0.25;
  this.wn_1 = 16;
}
protoOf(GoalPace).xn = function (type) {
  var tmp;
  switch (type.x1_1) {
    case 0:
      tmp = this.ln_1;
      break;
    case 2:
      tmp = this.mn_1;
      break;
    case 1:
      tmp = emptyList();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(GoalPace).yn = function (startKg, targetKg, ratePctPerWeek, today) {
  var tmp;
  if (targetKg == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Goals_instance.mo(startKg, targetKg, startKg, today, null, ratePctPerWeek).ho_1;
  }
  var reach = tmp;
  var tmp_0;
  if (reach == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = ((reach - today | 0) + 6 | 0) / 7 | 0;
  }
  var tmp2_elvis_lhs = tmp_0;
  var weeks = tmp2_elvis_lhs == null ? 12 : tmp2_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  var this_0 = numberRangeToNumber(0, weeks);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var week = item;
      var day = today + imul(week, 7) | 0;
      var tmp_1;
      if (!(reach == null) && day >= reach) {
        tmp_1 = new PacePoint(reach, targetKg);
      } else {
        // Inline function 'kotlin.math.pow' call
        var this_1 = 1.0 + ratePctPerWeek / 100.0;
        var tmp$ret$7 = Math.pow(this_1, week);
        tmp_1 = new PacePoint(day, startKg * tmp$ret$7);
      }
      var tmp$ret$6 = tmp_1;
      destination.f(tmp$ret$6);
    }
     while (!(item === last));
  var points = destination;
  // Inline function 'kotlin.collections.distinctBy' call
  var set = HashSet_init_$Create$();
  var list = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = points.j();
  while (_iterator__ex2g4s.k()) {
    var e = _iterator__ex2g4s.l();
    var key = e.fn_1;
    if (set.f(key)) {
      list.f(e);
    }
  }
  return new PaceProjection(list, reach);
};
protoOf(GoalPace).no = function (ethnicity) {
  return contains(this.tn_1, ethnicity) ? 23.0 : 25.0;
};
protoOf(GoalPace).oo = function (weightKg, heightCm, waistCm, bmiThreshold) {
  if (heightCm == null || !(heightCm > 0.0) || !(weightKg > 0.0))
    return null;
  var heightM = heightCm / 100.0;
  var bmi = weightKg / (heightM * heightM);
  var tmp;
  if (waistCm == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (waistCm > 0.0) {
      tmp_0 = waistCm;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_safe_receiver = tmp;
  var whtr = tmp1_safe_receiver == null ? null : tmp1_safe_receiver / heightCm;
  var eligible = !(whtr == null) ? whtr >= 0.5 : bmi >= bmiThreshold;
  if (!eligible)
    return null;
  return weightKg * (1.0 - 0.1);
};
protoOf(GoalPace).po = function (projection, lastDay) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = projection.hn_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new CurvePoint(item.fn_1, item.gn_1);
    destination.f(tmp$ret$2);
  }
  var points = destination;
  var tmp0_safe_receiver = projection.in_1;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return points;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var reach = tmp;
  var end = last(points);
  var start = first(points);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = 0.25 * (reach - start.jn_1);
  var ease = Math.min(28.0, b);
  var flat = lastDay > reach ? listOf_0(new CurvePoint(lastDay, end.kn_1)) : emptyList();
  if (ease <= 0.0 || points.o() < 2)
    return plus(points, flat);
  var from = reach - ease;
  var tmp0 = until(0, get_lastIndex(points));
  var tmp$ret$4;
  $l$block: {
    // Inline function 'kotlin.collections.first' call
    var inductionVariable = tmp0.oc_1;
    var last_0 = tmp0.pc_1;
    if (inductionVariable <= last_0)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = element;
        if (points.n(it + 1 | 0).jn_1 >= from) {
          tmp$ret$4 = element;
          break $l$block;
        }
      }
       while (!(element === last_0));
    throw NoSuchElementException_init_$Create$('Collection contains no element matching the predicate.');
  }
  var segment = tmp$ret$4;
  var a = points.n(segment);
  var b_0 = points.n(segment + 1 | 0);
  var slope = (b_0.kn_1 - a.kn_1) / (b_0.jn_1 - a.jn_1);
  var y0 = a.kn_1 + slope * (from - a.jn_1);
  var tmp_0 = y0 + slope * ease / 3.0;
  // Inline function 'kotlin.comparisons.minOf' call
  var b_1 = end.kn_1;
  var tmp_1 = Math.min(y0, b_1);
  // Inline function 'kotlin.comparisons.maxOf' call
  var b_2 = end.kn_1;
  var tmp$ret$7 = Math.max(y0, b_2);
  var y1 = coerceIn(tmp_0, tmp_1, tmp$ret$7);
  var y3 = end.kn_1;
  // Inline function 'kotlin.collections.map' call
  var this_1 = numberRangeToNumber(1, 16);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var inductionVariable_0 = this_1.oc_1;
  var last_1 = this_1.pc_1;
  if (inductionVariable_0 <= last_1)
    do {
      var item_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var t = item_0 / 16;
      var u = 1.0 - t;
      var tmp$ret$10 = new CurvePoint(from + ease * t, u * u * u * y0 + 3 * u * u * t * y1 + 3 * u * t * t * y3 + t * t * t * y3);
      destination_0.f(tmp$ret$10);
    }
     while (!(item_0 === last_1));
  var corner = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = points.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (element_0.jn_1 < from) {
      destination_1.f(element_0);
    }
  }
  return plus(plus(plus_0(destination_1, new CurvePoint(from, y0)), corner), flat);
};
var GoalPace_instance;
function GoalPace_getInstance() {
  if (GoalPace_instance == null)
    new GoalPace();
  return GoalPace_instance;
}
var static_init_called_9;
function static_init_9() {
  if (static_init_called_9)
    return Unit_instance;
  static_init_called_9 = true;
  Band_HEALTHY_instance = new Band('HEALTHY', 0);
  Band_INCREASED_instance = new Band('INCREASED', 1);
  Band_HIGH_instance = new Band('HIGH', 2);
}
var Band_HEALTHY_instance;
var Band_INCREASED_instance;
var Band_HIGH_instance;
function Band(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Band_HEALTHY_getInstance() {
  static_init_9();
  return Band_HEALTHY_instance;
}
function Band_INCREASED_getInstance() {
  static_init_9();
  return Band_INCREASED_instance;
}
function Band_HIGH_getInstance() {
  static_init_9();
  return Band_HIGH_instance;
}
function WaistToHeight() {
  this.qo_1 = 0.5;
  this.ro_1 = 0.6;
  this.so_1 = 'Try to keep your waist under half your height.';
}
protoOf(WaistToHeight).to = function (waistCm, heightCm) {
  if (waistCm == null || heightCm == null || !(waistCm > 0.0) || !(heightCm > 0.0))
    return null;
  var ratio = waistCm / heightCm;
  return ratio < 0.5 ? Band_HEALTHY_getInstance() : ratio < 0.6 ? Band_INCREASED_getInstance() : Band_HIGH_getInstance();
};
var WaistToHeight_instance;
function WaistToHeight_getInstance() {
  return WaistToHeight_instance;
}
function GoalProgress(startKg, currentKg, targetKg, changeKg, remainingKg, fractionDone, reached, projectedDay, projectedDayAtGoalRate) {
  this.zn_1 = startKg;
  this.ao_1 = currentKg;
  this.bo_1 = targetKg;
  this.co_1 = changeKg;
  this.do_1 = remainingKg;
  this.eo_1 = fractionDone;
  this.fo_1 = reached;
  this.go_1 = projectedDay;
  this.ho_1 = projectedDayAtGoalRate;
}
protoOf(GoalProgress).toString = function () {
  return 'GoalProgress(startKg=' + this.zn_1 + ', currentKg=' + this.ao_1 + ', targetKg=' + this.bo_1 + ', changeKg=' + this.co_1 + ', remainingKg=' + this.do_1 + ', fractionDone=' + this.eo_1 + ', reached=' + this.fo_1 + ', projectedDay=' + this.go_1 + ', projectedDayAtGoalRate=' + this.ho_1 + ')';
};
protoOf(GoalProgress).hashCode = function () {
  var result = getNumberHashCode(this.zn_1);
  result = imul(result, 31) + getNumberHashCode(this.ao_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.bo_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.co_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.do_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.eo_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.fo_1) | 0;
  result = imul(result, 31) + (this.go_1 == null ? 0 : this.go_1) | 0;
  result = imul(result, 31) + (this.ho_1 == null ? 0 : this.ho_1) | 0;
  return result;
};
protoOf(GoalProgress).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalProgress))
    return false;
  if (!equals(this.zn_1, other.zn_1))
    return false;
  if (!equals(this.ao_1, other.ao_1))
    return false;
  if (!equals(this.bo_1, other.bo_1))
    return false;
  if (!equals(this.co_1, other.co_1))
    return false;
  if (!equals(this.do_1, other.do_1))
    return false;
  if (!equals(this.eo_1, other.eo_1))
    return false;
  if (!(this.fo_1 === other.fo_1))
    return false;
  if (!(this.go_1 == other.go_1))
    return false;
  if (!(this.ho_1 == other.ho_1))
    return false;
  return true;
};
var static_init_called_10;
function static_init_10() {
  if (static_init_called_10)
    return Unit_instance;
  static_init_called_10 = true;
  MilestoneKind_KG_instance = new MilestoneKind('KG', 0);
  MilestoneKind_PERCENT_OF_GOAL_instance = new MilestoneKind('PERCENT_OF_GOAL', 1);
}
var MilestoneKind_KG_instance;
var MilestoneKind_PERCENT_OF_GOAL_instance;
function valueOf_2(value) {
  static_init_10();
  switch (value) {
    case 'KG':
      return MilestoneKind_KG_getInstance();
    case 'PERCENT_OF_GOAL':
      return MilestoneKind_PERCENT_OF_GOAL_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.MilestoneKind.' + value);
      break;
  }
}
function MilestoneKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function WeightMilestone(index, thresholdKg, changeKg, fractionOfGoal, reachedDay, isTarget) {
  this.uo_1 = index;
  this.vo_1 = thresholdKg;
  this.wo_1 = changeKg;
  this.xo_1 = fractionOfGoal;
  this.yo_1 = reachedDay;
  this.zo_1 = isTarget;
}
protoOf(WeightMilestone).toString = function () {
  return 'WeightMilestone(index=' + this.uo_1 + ', thresholdKg=' + this.vo_1 + ', changeKg=' + this.wo_1 + ', fractionOfGoal=' + this.xo_1 + ', reachedDay=' + this.yo_1 + ', isTarget=' + this.zo_1 + ')';
};
protoOf(WeightMilestone).hashCode = function () {
  var result = this.uo_1;
  result = imul(result, 31) + getNumberHashCode(this.vo_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.wo_1) | 0;
  result = imul(result, 31) + (this.xo_1 == null ? 0 : getNumberHashCode(this.xo_1)) | 0;
  result = imul(result, 31) + (this.yo_1 == null ? 0 : this.yo_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.zo_1) | 0;
  return result;
};
protoOf(WeightMilestone).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeightMilestone))
    return false;
  if (!(this.uo_1 === other.uo_1))
    return false;
  if (!equals(this.vo_1, other.vo_1))
    return false;
  if (!equals(this.wo_1, other.wo_1))
    return false;
  if (!equals(this.xo_1, other.xo_1))
    return false;
  if (!(this.yo_1 == other.yo_1))
    return false;
  if (!(this.zo_1 === other.zo_1))
    return false;
  return true;
};
function projectedDay($this, today, days) {
  if (isNaN_0(days) || days < 0.0 || days > 1826)
    return null;
  // Inline function 'kotlin.math.ceil' call
  var x = days - 1.0E-9;
  var tmp$ret$0 = Math.ceil(x);
  return today + numberToInt(tmp$ret$0) | 0;
}
function sam$kotlin_Comparator$0_0(function_0) {
  this.ap_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_0).y9 = function (a, b) {
  return this.ap_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_0).g2 = function () {
  return this.ap_1;
};
protoOf(sam$kotlin_Comparator$0_0).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_0).hashCode = function () {
  return hashCode(this.g2());
};
function Goals$milestones$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.wm_1;
  var tmp$ret$2 = b.wm_1;
  return compareValues(tmp, tmp$ret$2);
}
function milestones$reachedDay(sorted, down, threshold) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = sorted.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (down ? element.zm_1 <= threshold + 1.0E-9 : element.zm_1 >= threshold - 1.0E-9) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_safe_receiver = tmp$ret$0;
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.wm_1;
}
function Goals() {
  this.io_1 = 0.01;
  this.jo_1 = 1826;
  this.ko_1 = 1.5;
  this.lo_1 = 14;
}
protoOf(Goals).bp = function (goal, weightKg) {
  return this.cp(CheckIn_instance.pi(goal, weightKg), weightKg) / 7.0;
};
protoOf(Goals).dp = function (style, dataSlopeKgPerDay, dataDays, goal, weightKg) {
  var tmp;
  if (dataSlopeKgPerDay == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (dataDays >= 14) {
      tmp_0 = dataSlopeKgPerDay;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var data = tmp;
  var tmp_1;
  if (goal == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = Goals_instance.bp(goal, weightKg);
  }
  var goalSlope = tmp_1;
  var tmp_2;
  switch (style.x1_1) {
    case 0:
      tmp_2 = data == null ? goalSlope : data;
      break;
    case 1:
      tmp_2 = goalSlope == null ? data : goalSlope;
      break;
    case 2:
      var tmp_3;
      if (!(data == null) && !(goalSlope == null)) {
        tmp_3 = (data + goalSlope) / 2.0;
      } else {
        tmp_3 = data == null ? goalSlope : data;
      }

      tmp_2 = tmp_3;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var tmp6_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp6_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp6_elvis_lhs;
  }
  var slope = tmp_4;
  var cap = this.cp(1.5, weightKg) / 7.0;
  return coerceIn(slope, -cap, cap);
};
protoOf(Goals).cp = function (ratePctPerWeek, weightKg) {
  return ratePctPerWeek / 100.0 * weightKg;
};
protoOf(Goals).ep = function (kgPerWeek, weightKg) {
  // Inline function 'kotlin.require' call
  if (!(weightKg > 0.0)) {
    var message = 'weightKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return kgPerWeek / weightKg * 100.0;
};
protoOf(Goals).mo = function (startKg, targetKg, currentKg, today, currentRateKgPerWeek, goalRatePctPerWeek) {
  var total = targetKg - startKg;
  var remaining = targetKg - currentKg;
  var tmp;
  // Inline function 'kotlin.math.abs' call
  if (Math.abs(total) < 1.0E-9) {
    tmp = 1.0;
  } else {
    tmp = coerceIn((currentKg - startKg) / total, 0.0, 1.0);
  }
  var fraction = tmp;
  var tmp_0;
  // Inline function 'kotlin.math.abs' call
  if (Math.abs(total) < 1.0E-9) {
    tmp_0 = true;
  } else {
    tmp_0 = (currentKg - targetKg) * total >= 0.0;
  }
  var reached = tmp_0;
  var tmp_1;
  if (reached) {
    tmp_1 = today;
  } else {
    var tmp_2;
    if (currentRateKgPerWeek == null) {
      tmp_2 = true;
    } else {
      // Inline function 'kotlin.math.abs' call
      tmp_2 = Math.abs(currentRateKgPerWeek) < 0.01;
    }
    if (tmp_2) {
      tmp_1 = null;
    } else {
      if (currentRateKgPerWeek * remaining <= 0.0) {
        tmp_1 = null;
      } else {
        tmp_1 = projectedDay(this, today, remaining / (currentRateKgPerWeek / 7.0));
      }
    }
  }
  var projected = tmp_1;
  var tmp_3;
  if (reached) {
    tmp_3 = today;
  } else if (goalRatePctPerWeek == null || goalRatePctPerWeek === 0.0 || goalRatePctPerWeek <= -100.0) {
    tmp_3 = null;
  } else if (goalRatePctPerWeek * remaining <= 0.0) {
    tmp_3 = null;
  } else if (currentKg <= 0.0 || targetKg <= 0.0) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.math.ln' call
    var x = targetKg / currentKg;
    var tmp_4 = Math.log(x);
    // Inline function 'kotlin.math.ln' call
    var x_0 = 1.0 + goalRatePctPerWeek / 100.0;
    var tmp$ret$4 = Math.log(x_0);
    tmp_3 = projectedDay(this, today, tmp_4 / tmp$ret$4 * 7.0);
  }
  var projectedAtGoal = tmp_3;
  return new GoalProgress(startKg, currentKg, targetKg, currentKg - startKg, remaining, fraction, reached, projected, projectedAtGoal);
};
protoOf(Goals).fp = function (startKg, targetKg, trend, kind, step, losing) {
  // Inline function 'kotlin.require' call
  if (!(step > 0.0)) {
    var message = 'step must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  if (!(targetKg == null)) {
    // Inline function 'kotlin.math.abs' call
    var x = targetKg - startKg;
    tmp = Math.abs(x) < 1.0E-9;
  } else {
    tmp = false;
  }
  if (tmp)
    return emptyList();
  var down = !(targetKg == null) ? targetKg < startKg : losing;
  var sign = down ? -1.0 : 1.0;
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = Goals$milestones$lambda;
  var tmp$ret$4 = new sam$kotlin_Comparator$0_0(tmp_0);
  var sorted = sortedWith(trend, tmp$ret$4);
  var thresholds = ArrayList_init_$Create$_0();
  switch (kind.x1_1) {
    case 1:
      $l$block: {
        // Inline function 'kotlin.requireNotNull' call
        if (targetKg == null) {
          var message_0 = 'PERCENT_OF_GOAL milestones need a target';
          throw IllegalArgumentException_init_$Create$(toString(message_0));
        } else {
          break $l$block;
        }
      }

      // Inline function 'kotlin.require' call

      if (!(step <= 100.0)) {
        var message_1 = 'step must be at most 100 %';
        throw IllegalArgumentException_init_$Create$(toString(message_1));
      }

      // Inline function 'kotlin.math.floor' call

      var x_0 = 100.0 / step + 1.0E-9;
      var tmp$ret$9 = Math.floor(x_0);
      var count = numberToInt(tmp$ret$9);
      var inductionVariable = 1;
      if (inductionVariable <= count)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var share = n * step / 100.0;
          var tmp_1 = startKg + (targetKg - startKg) * share;
          // Inline function 'kotlin.math.abs' call
          var x_1 = share - 1.0;
          var tmp$ret$10 = Math.abs(x_1);
          thresholds.f(to(tmp_1, tmp$ret$10 < 1.0E-9));
        }
         while (!(n === count));
      var tmp1_safe_receiver = lastOrNull(thresholds);
      if (!((tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ib_1) === true)) {
        thresholds.f(to(targetKg, true));
      }

      break;
    case 0:
      if (!(targetKg == null)) {
        // Inline function 'kotlin.math.abs' call
        var x_2 = targetKg - startKg;
        // Inline function 'kotlin.math.ceil' call
        var x_3 = Math.abs(x_2) / step - 1.0E-9;
        var tmp$ret$12 = Math.ceil(x_3);
        var count_0 = numberToInt(tmp$ret$12);
        var inductionVariable_0 = 1;
        if (inductionVariable_0 < count_0)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            thresholds.f(to(startKg + sign * n_0 * step, false));
          }
           while (inductionVariable_0 < count_0);
        thresholds.f(to(targetKg, true));
      } else {
        var tmp$ret$13;
        $l$block_0: {
          // Inline function 'kotlin.collections.maxOfOrNull' call
          var iterator = sorted.j();
          if (!iterator.k()) {
            tmp$ret$13 = null;
            break $l$block_0;
          }
          var maxValue = sign * (iterator.l().zm_1 - startKg);
          while (iterator.k()) {
            var v = sign * (iterator.l().zm_1 - startKg);
            // Inline function 'kotlin.comparisons.maxOf' call
            var a = maxValue;
            maxValue = Math.max(a, v);
          }
          tmp$ret$13 = maxValue;
        }
        var tmp2_elvis_lhs = tmp$ret$13;
        var furthest = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.math.floor' call
        var x_4 = furthest / step + 1.0E-9;
        var tmp$ret$17 = Math.floor(x_4);
        var count_1 = coerceAtLeast(numberToInt(tmp$ret$17), 0) + 1 | 0;
        var inductionVariable_1 = 1;
        if (inductionVariable_1 <= count_1)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            thresholds.f(to(startKg + sign * n_1 * step, false));
          }
           while (!(n_1 === count_1));
      }

      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(thresholds, 10));
  var index = 0;
  var _iterator__ex2g4s = thresholds.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var threshold = item.ya();
    var isTarget = item.za();
    var tmp_2 = threshold - startKg;
    var tmp_3;
    if (targetKg == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = (threshold - startKg) / (targetKg - startKg);
    }
    var tmp$ret$20 = new WeightMilestone(index_0, threshold, tmp_2, tmp_3, milestones$reachedDay(sorted, down, threshold), isTarget);
    destination.f(tmp$ret$20);
  }
  return destination;
};
var Goals_instance;
function Goals_getInstance() {
  return Goals_instance;
}
function MilestoneKind_KG_getInstance() {
  static_init_10();
  return MilestoneKind_KG_instance;
}
function MilestoneKind_PERCENT_OF_GOAL_getInstance() {
  static_init_10();
  return MilestoneKind_PERCENT_OF_GOAL_instance;
}
function pct($this, value) {
  return trimEnd(trimEnd(Fmt_instance.vd(value, 2), charArrayOf([_Char___init__impl__6a9atx(48)])), charArrayOf([_Char___init__impl__6a9atx(46)]));
}
function FastLossWarning(ratePctPerWeek, deficitKcal, suggestedRatePctPerWeek) {
  this.gp_1 = ratePctPerWeek;
  this.hp_1 = deficitKcal;
  this.ip_1 = suggestedRatePctPerWeek;
}
protoOf(FastLossWarning).x6 = function () {
  return 'Losing ' + pct(this, this.gp_1) + ' % a week is about ' + Fmt_instance.wd(this.hp_1) + ' kcal a day under maintenance. ' + 'In studies of people who lift, losing faster than about 1 % of body weight a week, or eating more than about 500 kcal a day under maintenance, stopped muscle gains, while 0.5\u20130.7 % a week kept or built muscle.';
};
protoOf(FastLossWarning).jp = function () {
  return 'Use a gentler pace (' + pct(this, this.ip_1) + ' % a week)';
};
protoOf(FastLossWarning).toString = function () {
  return 'FastLossWarning(ratePctPerWeek=' + this.gp_1 + ', deficitKcal=' + this.hp_1 + ', suggestedRatePctPerWeek=' + this.ip_1 + ')';
};
protoOf(FastLossWarning).hashCode = function () {
  var result = getNumberHashCode(this.gp_1);
  result = imul(result, 31) + getNumberHashCode(this.hp_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ip_1) | 0;
  return result;
};
protoOf(FastLossWarning).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FastLossWarning))
    return false;
  if (!equals(this.gp_1, other.gp_1))
    return false;
  if (!equals(this.hp_1, other.hp_1))
    return false;
  if (!equals(this.ip_1, other.ip_1))
    return false;
  return true;
};
function LossPace() {
  this.kp_1 = 'A gentler pace may keep more muscle';
  this.lp_1 = 1.0;
  this.mp_1 = 500.0;
  this.np_1 = 0.7;
  this.op_1 = 0.5;
  this.pp_1 = 0.05;
}
protoOf(LossPace).qp = function (trainingType, weeklyHardSets) {
  // Inline function 'kotlin.let' call
  var it = ProteinTargets_getInstance().zp(trainingType, weeklyHardSets);
  return it.equals(TrainingType_STRENGTH_getInstance()) || it.equals(TrainingType_BOTH_getInstance());
};
protoOf(LossPace).aq = function (ratePctPerWeek, weightKg, kcalPerKg, lifts) {
  if (!lifts || ratePctPerWeek >= 0.0 || !(weightKg > 0.0) || !(kcalPerKg > 0.0))
    return null;
  // Inline function 'kotlin.math.abs' call
  var rate = Math.abs(ratePctPerWeek);
  if (rate <= 0.5 + 1.0E-9)
    return null;
  var deficit = -CheckIn_instance.qi(ratePctPerWeek, weightKg, kcalPerKg);
  if (rate <= 1.0 + 1.0E-9 && deficit <= 500.0 + 1.0E-9)
    return null;
  var atMaxDeficit = 500.0 * 7.0 * 100.0 / (weightKg * kcalPerKg);
  // Inline function 'kotlin.math.floor' call
  var x = coerceIn(atMaxDeficit, 0.5, 0.7) / 0.05 + 1.0E-9;
  var snapped = Math.floor(x) * 0.05;
  return new FastLossWarning(rate, deficit, snapped);
};
var LossPace_instance;
function LossPace_getInstance() {
  return LossPace_instance;
}
var static_init_called_11;
function static_init_11() {
  if (static_init_called_11)
    return Unit_instance;
  static_init_called_11 = true;
  DietType_BALANCED_instance = new DietType('BALANCED', 0);
  DietType_LOW_FAT_instance = new DietType('LOW_FAT', 1);
  DietType_LOW_CARB_instance = new DietType('LOW_CARB', 2);
  DietType_KETO_instance = new DietType('KETO', 3);
}
var DietType_BALANCED_instance;
var DietType_LOW_FAT_instance;
var DietType_LOW_CARB_instance;
var DietType_KETO_instance;
function values_7() {
  static_init_11();
  return [DietType_BALANCED_getInstance(), DietType_LOW_FAT_getInstance(), DietType_LOW_CARB_getInstance(), DietType_KETO_getInstance()];
}
function valueOf_3(value) {
  static_init_11();
  switch (value) {
    case 'BALANCED':
      return DietType_BALANCED_getInstance();
    case 'LOW_FAT':
      return DietType_LOW_FAT_getInstance();
    case 'LOW_CARB':
      return DietType_LOW_CARB_getInstance();
    case 'KETO':
      return DietType_KETO_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.DietType.' + value);
      break;
  }
}
function DietType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_12;
function static_init_12() {
  if (static_init_called_12)
    return Unit_instance;
  static_init_called_12 = true;
  ProteinPreference_LOW_instance = new ProteinPreference('LOW', 0, 1.8);
  ProteinPreference_MODERATE_instance = new ProteinPreference('MODERATE', 1, 2.2);
  ProteinPreference_HIGH_instance = new ProteinPreference('HIGH', 2, 2.6);
  ProteinPreference_EXTRA_HIGH_instance = new ProteinPreference('EXTRA_HIGH', 3, 3.0);
}
var ProteinPreference_LOW_instance;
var ProteinPreference_MODERATE_instance;
var ProteinPreference_HIGH_instance;
var ProteinPreference_EXTRA_HIGH_instance;
function values_8() {
  static_init_12();
  return [ProteinPreference_LOW_getInstance(), ProteinPreference_MODERATE_getInstance(), ProteinPreference_HIGH_getInstance(), ProteinPreference_EXTRA_HIGH_getInstance()];
}
function valueOf_4(value) {
  static_init_12();
  switch (value) {
    case 'LOW':
      return ProteinPreference_LOW_getInstance();
    case 'MODERATE':
      return ProteinPreference_MODERATE_getInstance();
    case 'HIGH':
      return ProteinPreference_HIGH_getInstance();
    case 'EXTRA_HIGH':
      return ProteinPreference_EXTRA_HIGH_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.coaching.ProteinPreference.' + value);
      break;
  }
}
function ProteinPreference(name, ordinal, gramsPerKgLean) {
  Enum.call(this, name, ordinal);
  this.dq_1 = gramsPerKgLean;
}
function MacroTargets(kcal, proteinG, fatG, carbsG) {
  this.qj_1 = kcal;
  this.rj_1 = proteinG;
  this.sj_1 = fatG;
  this.tj_1 = carbsG;
}
protoOf(MacroTargets).eq = function (kcal, proteinG, fatG, carbsG) {
  return new MacroTargets(kcal, proteinG, fatG, carbsG);
};
protoOf(MacroTargets).fq = function (kcal, proteinG, fatG, carbsG, $super) {
  kcal = kcal === VOID ? this.qj_1 : kcal;
  proteinG = proteinG === VOID ? this.rj_1 : proteinG;
  fatG = fatG === VOID ? this.sj_1 : fatG;
  carbsG = carbsG === VOID ? this.tj_1 : carbsG;
  return $super === VOID ? this.eq(kcal, proteinG, fatG, carbsG) : $super.eq.call(this, kcal, proteinG, fatG, carbsG);
};
protoOf(MacroTargets).toString = function () {
  return 'MacroTargets(kcal=' + this.qj_1 + ', proteinG=' + this.rj_1 + ', fatG=' + this.sj_1 + ', carbsG=' + this.tj_1 + ')';
};
protoOf(MacroTargets).hashCode = function () {
  var result = getNumberHashCode(this.qj_1);
  result = imul(result, 31) + getNumberHashCode(this.rj_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.sj_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.tj_1) | 0;
  return result;
};
protoOf(MacroTargets).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MacroTargets))
    return false;
  if (!equals(this.qj_1, other.qj_1))
    return false;
  if (!equals(this.rj_1, other.rj_1))
    return false;
  if (!equals(this.sj_1, other.sj_1))
    return false;
  if (!equals(this.tj_1, other.tj_1))
    return false;
  return true;
};
var static_init_called_13;
function static_init_13() {
  if (static_init_called_13)
    return Unit_instance;
  static_init_called_13 = true;
  MacroSplit_CURRENT_instance = new MacroSplit('CURRENT', 0);
  MacroSplit_REVISED_instance = new MacroSplit('REVISED', 1);
}
var MacroSplit_CURRENT_instance;
var MacroSplit_REVISED_instance;
function values_9() {
  static_init_13();
  return [MacroSplit_CURRENT_getInstance(), MacroSplit_REVISED_getInstance()];
}
function get_entries_6() {
  static_init_13();
  if ($ENTRIES_6 == null)
    $ENTRIES_6 = enumEntries(values_9());
  return $ENTRIES_6;
}
var $ENTRIES_6;
function MacroSplit(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function keto($this, kcal, proteinG, carbsG, fatMinG) {
  // Inline function 'kotlin.math.min' call
  var b = kcal / 4.0;
  var carbs = Math.min(carbsG, b);
  var fatRoom = kcal - carbs * 4.0;
  // Inline function 'kotlin.math.min' call
  var b_0 = fatRoom / 9.0;
  var tmp0 = Math.min(fatMinG, b_0);
  // Inline function 'kotlin.math.max' call
  var b_1 = (fatRoom - proteinG * 4.0) / 9.0;
  var fat = Math.max(tmp0, b_1);
  // Inline function 'kotlin.math.max' call
  var b_2 = (fatRoom - fat * 9.0) / 4.0;
  var protein = Math.max(0.0, b_2);
  // Inline function 'kotlin.math.min' call
  var tmp$ret$4 = Math.min(proteinG, protein);
  return new MacroTargets(kcal, tmp$ret$4, fat, carbs);
}
function splitByFatShare($this, kcal, remaining, fatShare, fatFloorG) {
  // Inline function 'kotlin.math.max' call
  var a = fatShare * kcal / 9.0;
  var tmp0 = Math.max(a, fatFloorG);
  // Inline function 'kotlin.math.min' call
  var b = remaining / 9.0;
  var fatG = Math.min(tmp0, b);
  // Inline function 'kotlin.math.max' call
  var b_0 = (remaining - fatG * 9.0) / 4.0;
  var carbsG = Math.max(0.0, b_0);
  return to(fatG, carbsG);
}
function splitByCarbCap($this, remaining, carbCapG, fatFloorG) {
  // Inline function 'kotlin.math.max' call
  var b = (remaining - fatFloorG * 9.0) / 4.0;
  var maxCarbsLeavingFloor = Math.max(0.0, b);
  // Inline function 'kotlin.math.min' call
  var carbsG = Math.min(carbCapG, maxCarbsLeavingFloor);
  var fatG = (remaining - carbsG * 4.0) / 9.0;
  return to(fatG, carbsG);
}
function Macros() {
  this.pg_1 = 4.0;
  this.qg_1 = 4.0;
  this.rg_1 = 9.0;
  this.sg_1 = 0.6;
  this.tg_1 = 0.3;
  this.ug_1 = 0.22;
  this.vg_1 = 0.3;
  this.wg_1 = 200.0;
  this.xg_1 = 30.0;
  this.yg_1 = 0.2;
  this.zg_1 = 0.4;
}
protoOf(Macros).gq = function (kcal, bodyWeightKg, leanMassKg, diet, protein) {
  return this.uj(kcal, bodyWeightKg, protein.dq_1 * leanMassKg, diet);
};
protoOf(Macros).uj = function (kcal, bodyWeightKg, proteinG, diet) {
  // Inline function 'kotlin.require' call
  if (!(kcal >= 0.0)) {
    var message = 'kcal must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(proteinG >= 0.0)) {
    var message_0 = 'proteinG must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var fatFloorG = 0.6 * bodyWeightKg;
  if (proteinG * 4.0 + fatFloorG * 9.0 >= kcal) {
    // Inline function 'kotlin.math.min' call
    var b = kcal / 9.0;
    var fat = Math.min(fatFloorG, b);
    // Inline function 'kotlin.math.max' call
    var b_0 = (kcal - fat * 9.0) / 4.0;
    var proteinLeft = Math.max(0.0, b_0);
    // Inline function 'kotlin.math.min' call
    var tmp$ret$6 = Math.min(proteinG, proteinLeft);
    return new MacroTargets(kcal, tmp$ret$6, fat, 0.0);
  }
  var _destruct__k2r9zo = this.vj(kcal, proteinG, fatFloorG, diet);
  var fatG = _destruct__k2r9zo.ya();
  var carbsG = _destruct__k2r9zo.za();
  return new MacroTargets(kcal, proteinG, fatG, carbsG);
};
protoOf(Macros).vj = function (kcal, proteinG, fatFloorG, diet) {
  var remaining = kcal - proteinG * 4.0;
  var tmp;
  switch (diet.x1_1) {
    case 0:
      tmp = splitByFatShare(this, kcal, remaining, 0.3, fatFloorG);
      break;
    case 1:
      tmp = splitByFatShare(this, kcal, remaining, 0.22, fatFloorG);
      break;
    case 2:
      // Inline function 'kotlin.math.min' call

      var a = 0.3 * kcal / 4.0;
      var tmp$ret$0 = Math.min(a, 200.0);
      tmp = splitByCarbCap(this, remaining, tmp$ret$0, fatFloorG);
      break;
    case 3:
      tmp = splitByCarbCap(this, remaining, 30.0, fatFloorG);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(Macros).hq = function (kcal, bodyWeightKg, proteinG, diet, split, minimums) {
  // Inline function 'kotlin.require' call
  if (!(kcal >= 0.0)) {
    var message = 'kcal must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(proteinG >= 0.0)) {
    var message_0 = 'proteinG must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  if (split.equals(MacroSplit_CURRENT_getInstance()))
    return this.uj(kcal, bodyWeightKg, proteinG, diet);
  var rest = kcal - proteinG * 4.0;
  if (!diet.equals(DietType_KETO_getInstance())) {
    var tmp;
    switch (diet.x1_1) {
      case 2:
        var tmp0 = minimums.lg_1;
        // Inline function 'kotlin.math.max' call

        var b = 0.4 * kcal / 9.0;
        tmp = Math.max(tmp0, b);
        break;
      case 1:
        var tmp0_0 = minimums.lg_1;
        // Inline function 'kotlin.math.min' call

        var a = 0.2 * kcal;
        // Inline function 'kotlin.math.max' call

        var b_0 = Math.min(a, rest) / 9.0;
        tmp = Math.max(tmp0_0, b_0);
        break;
      default:
        var tmp0_1 = minimums.lg_1;
        // Inline function 'kotlin.math.min' call

        var a_0 = 0.3 * kcal;
        // Inline function 'kotlin.math.max' call

        var b_1 = Math.min(a_0, rest) / 9.0;
        tmp = Math.max(tmp0_1, b_1);
        break;
    }
    var fat = tmp;
    var carbs = (rest - fat * 9.0) / 4.0;
    if (carbs > minimums.mg_1) {
      if (diet.equals(DietType_LOW_CARB_getInstance()) && carbs > 200.0) {
        return new MacroTargets(kcal, proteinG, fat + (carbs - 200.0) * 4.0 / 9.0, 200.0);
      }
      return new MacroTargets(kcal, proteinG, fat, carbs);
    }
    return keto(this, kcal, proteinG, minimums.mg_1, minimums.lg_1);
  }
  return keto(this, kcal, proteinG, 30.0, minimums.lg_1);
};
protoOf(Macros).ah = function (proteinG, fatG, carbsG) {
  return proteinG * 4.0 + fatG * 9.0 + carbsG * 4.0;
};
var Macros_instance;
function Macros_getInstance() {
  return Macros_instance;
}
function DietType_BALANCED_getInstance() {
  static_init_11();
  return DietType_BALANCED_instance;
}
function DietType_LOW_FAT_getInstance() {
  static_init_11();
  return DietType_LOW_FAT_instance;
}
function DietType_LOW_CARB_getInstance() {
  static_init_11();
  return DietType_LOW_CARB_instance;
}
function DietType_KETO_getInstance() {
  static_init_11();
  return DietType_KETO_instance;
}
function ProteinPreference_LOW_getInstance() {
  static_init_12();
  return ProteinPreference_LOW_instance;
}
function ProteinPreference_MODERATE_getInstance() {
  static_init_12();
  return ProteinPreference_MODERATE_instance;
}
function ProteinPreference_HIGH_getInstance() {
  static_init_12();
  return ProteinPreference_HIGH_instance;
}
function ProteinPreference_EXTRA_HIGH_getInstance() {
  static_init_12();
  return ProteinPreference_EXTRA_HIGH_instance;
}
function MacroSplit_CURRENT_getInstance() {
  static_init_13();
  return MacroSplit_CURRENT_instance;
}
function MacroSplit_REVISED_getInstance() {
  static_init_13();
  return MacroSplit_REVISED_instance;
}
function goal($this, json) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = JsonRead_instance.vf(Json_instance.uf(json), 'GOAL');
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp0_elvis_lhs = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var map = tmp_1;
  var tmp1_safe_receiver = JsonRead_instance.iq(map, 'type');
  var tmp_2;
  if (tmp1_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_entries_4();
    var tmp$ret$7;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element.w1_1 === tmp1_safe_receiver) {
          tmp$ret$7 = element;
          break $l$block;
        }
      }
      tmp$ret$7 = null;
    }
    tmp_2 = tmp$ret$7;
  }
  var tmp2_elvis_lhs = tmp_2;
  var tmp_3;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_3 = tmp2_elvis_lhs;
  }
  var type = tmp_3;
  var tmp3_elvis_lhs = JsonRead_instance.jq(map, 'ratePctPerWeek');
  return new Goal(type, tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs, JsonRead_instance.jq(map, 'targetWeightKg'));
}
function dayOneJson$missing(input) {
  return Json_instance.zf(mapOf(to('missing', input)));
}
function NewProgram() {
  this.kq_1 = 7;
}
protoOf(NewProgram).lq = function (setupDay) {
  return EpochDays_getInstance().td(setupDay);
};
protoOf(NewProgram).mq = function (setupDay) {
  return new NutritionProgram(VOID, VOID, VOID, VOID, this.lq(setupDay));
};
protoOf(NewProgram).nq = function (initialDay, weekday) {
  var earliest = initialDay + 7 | 0;
  return earliest + (((weekday - EpochDays_getInstance().td(earliest) | 0) + 7 | 0) % 7 | 0) | 0;
};
protoOf(NewProgram).oq = function (initialDay, weekday, $super) {
  weekday = weekday === VOID ? this.lq(initialDay) : weekday;
  return $super === VOID ? this.nq(initialDay, weekday) : $super.nq.call(this, initialDay, weekday);
};
protoOf(NewProgram).pq = function (day, program, goal, profile, weightKg, algorithms, trainingWeekdays) {
  if (!(weightKg > 0.0))
    return null;
  return WeeklyCheckIn_instance.rq(new WeeklyCheckInInput(day, program, goal, profile, emptyList(), listOf_0(new WeighIn(day, weightKg)), emptyList(), VOID, VOID, trainingWeekdays, VOID, algorithms));
};
protoOf(NewProgram).sq = function (goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays) {
  var tmp;
  if (goalJson == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = goal(this, goalJson);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return dayOneJson$missing('goal');
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var goal_0 = tmp_0;
  var tmp_1;
  if (profileJson == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    var tmp_2;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = JsonRead_instance.vf(Json_instance.uf(profileJson), 'profile');
      tmp_2 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_2 = tmp_3;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_2;
    tmp_1 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  var tmp3_elvis_lhs = tmp_1;
  var profile = tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs;
  var tmp4_safe_receiver = JsonRead_instance.iq(profile, 'sex');
  var tmp_4;
  if (tmp4_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.text.uppercase' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_4 = tmp4_safe_receiver.toUpperCase();
  }
  var tmp5_safe_receiver = tmp_4;
  var tmp_5;
  if (tmp5_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0 = get_entries_11();
    var tmp$ret$13;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element.w1_1 === tmp5_safe_receiver) {
          tmp$ret$13 = element;
          break $l$block;
        }
      }
      tmp$ret$13 = null;
    }
    tmp_5 = tmp$ret$13;
  }
  var tmp6_elvis_lhs = tmp_5;
  var tmp_6;
  if (tmp6_elvis_lhs == null) {
    return dayOneJson$missing('profile.sex');
  } else {
    tmp_6 = tmp6_elvis_lhs;
  }
  var sex = tmp_6;
  var tmp7_safe_receiver = JsonRead_instance.iq(profile, 'birthDate');
  var tmp_7;
  if (tmp7_safe_receiver == null) {
    tmp_7 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_7 = EpochDays_getInstance().rd(tmp7_safe_receiver);
  }
  var tmp8_elvis_lhs = tmp_7;
  var tmp_8;
  if (tmp8_elvis_lhs == null) {
    return dayOneJson$missing('profile.birthDate');
  } else {
    tmp_8 = tmp8_elvis_lhs;
  }
  var birthDay = tmp_8;
  var tmp9_safe_receiver = JsonRead_instance.jq(profile, 'heightCm');
  var tmp_9;
  if (tmp9_safe_receiver == null) {
    tmp_9 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_10;
    if (tmp9_safe_receiver > 0.0) {
      tmp_10 = tmp9_safe_receiver;
    } else {
      tmp_10 = null;
    }
    tmp_9 = tmp_10;
  }
  var tmp10_elvis_lhs = tmp_9;
  var tmp_11;
  if (tmp10_elvis_lhs == null) {
    return dayOneJson$missing('profile.heightCm');
  } else {
    tmp_11 = tmp10_elvis_lhs;
  }
  var height = tmp_11;
  var tmp11_safe_receiver = JsonRead_instance.iq(profile, 'activityLevel');
  var tmp_12;
  if (tmp11_safe_receiver == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp0_0 = get_entries_13();
    var tmp$ret$21;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (element_0.w1_1 === tmp11_safe_receiver) {
          tmp$ret$21 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$21 = null;
    }
    tmp_12 = tmp$ret$21;
  }
  var tmp12_elvis_lhs = tmp_12;
  var tmp_13;
  if (tmp12_elvis_lhs == null) {
    return dayOneJson$missing('profile.activityLevel');
  } else {
    tmp_13 = tmp12_elvis_lhs;
  }
  var activity = tmp_13;
  var tmp13_safe_receiver = JsonRead_instance.jq(profile, 'bodyFatPct');
  var bodyFat = tmp13_safe_receiver == null ? null : tmp13_safe_receiver / 100.0;
  var body = new BodyProfile(sex, this.tq(birthDay, today), height, bodyFat, null, activity);
  var tmp_14;
  if (programJson == null) {
    tmp_14 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_14 = NutritionJson_instance.uq(programJson);
  }
  var tmp15_elvis_lhs = tmp_14;
  var program = tmp15_elvis_lhs == null ? this.mq(today) : tmp15_elvis_lhs;
  var tmp16_elvis_lhs = this.pq(today, program, goal_0, body, weightKg, AlgorithmJson_getInstance().tf(algorithmsJson), trainingWeekdays);
  var tmp_15;
  if (tmp16_elvis_lhs == null) {
    return dayOneJson$missing('weightKg');
  } else {
    tmp_15 = tmp16_elvis_lhs;
  }
  var result = tmp_15;
  return NutritionJson_instance.vq(result, true, true);
};
protoOf(NewProgram).wq = function (goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays, $super) {
  trainingWeekdays = trainingWeekdays === VOID ? emptySet() : trainingWeekdays;
  return $super === VOID ? this.sq(goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays) : $super.sq.call(this, goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays);
};
protoOf(NewProgram).tq = function (birthDay, today) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = split(EpochDays_getInstance().sd(birthDay), ['-']);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = toInt(item);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.component1' call
  var by = destination.n(0);
  // Inline function 'kotlin.collections.component2' call
  var bm = destination.n(1);
  // Inline function 'kotlin.collections.component3' call
  var bd = destination.n(2);
  // Inline function 'kotlin.collections.map' call
  var this_1 = split(EpochDays_getInstance().sd(today), ['-']);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$8 = toInt(item_0);
    destination_0.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.component1' call
  var ty = destination_0.n(0);
  // Inline function 'kotlin.collections.component2' call
  var tm = destination_0.n(1);
  // Inline function 'kotlin.collections.component3' call
  var td = destination_0.n(2);
  return (ty - by | 0) - (tm < bm || (tm === bm && td < bd) ? 1 : 0) | 0;
};
var NewProgram_instance;
function NewProgram_getInstance() {
  return NewProgram_instance;
}
function dietBreak($this, value) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap) : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var map = tmp;
  var tmp1_safe_receiver = JsonRead_instance.iq(map, 'startDate');
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = EpochDays_getInstance().rd(tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp_0;
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var start = tmp_1;
  var tmp3_safe_receiver = JsonRead_instance.xq(map, 'weeks');
  var tmp_2;
  if (tmp3_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_3;
    if (Companion_getInstance_0().ak_1.r(tmp3_safe_receiver)) {
      tmp_3 = tmp3_safe_receiver;
    } else {
      tmp_3 = null;
    }
    tmp_2 = tmp_3;
  }
  var tmp4_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp4_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp4_elvis_lhs;
  }
  var weeks = tmp_4;
  return new DietBreak(start, weeks);
}
function targets($this, value) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.yq(value);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block_0: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var map = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.jq(map, 'kcal');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_0;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var kcal = tmp_0;
      var tmp2_elvis_lhs = JsonRead_instance.jq(map, 'protein');
      var tmp_1 = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
      var tmp3_elvis_lhs = JsonRead_instance.jq(map, 'fat');
      var tmp_2 = tmp3_elvis_lhs == null ? 0.0 : tmp3_elvis_lhs;
      var tmp4_elvis_lhs = JsonRead_instance.jq(map, 'carbs');
      tmp$ret$4 = new MacroTargets(kcal, tmp_1, tmp_2, tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs);
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
}
function round2($this, value) {
  return round(value * 100.0) / 100.0;
}
function NutritionJson() {
}
protoOf(NutritionJson).uq = function (json) {
  var map = JsonRead_instance.vf(Json_instance.uf(json), 'PROGRAM');
  var tmp = map.s1('distribution');
  var distribution = (!(tmp == null) ? isInterface(tmp, KtMap) : false) ? tmp : null;
  var tmp_0 = map.s1('trainingShift');
  var shift = (!(tmp_0 == null) ? isInterface(tmp_0, KtMap) : false) ? tmp_0 : null;
  var tmp0_elvis_lhs = (!(distribution == null) ? isInterface(distribution, KtMap) : false) ? distribution : null;
  var distributionMap = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = (!(shift == null) ? isInterface(shift, KtMap) : false) ? shift : null;
  var shiftMap = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var tmp2 = JsonRead_instance.iq(map, 'kind');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_0 = ProgramKind_COACHED_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0 = values_12();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = tmp0.length;
    while (inductionVariable < last) {
      var element = tmp0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === tmp2) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp0_elvis_lhs_0 = tmp$ret$2;
  var tmp_1 = tmp0_elvis_lhs_0 == null ? default_0 : tmp0_elvis_lhs_0;
  var tmp2_0 = JsonRead_instance.iq(map, 'dietType');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_1 = DietType_BALANCED_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0_0 = values_7();
  var tmp$ret$6;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_0 = 0;
    var last_0 = tmp0_0.length;
    while (inductionVariable_0 < last_0) {
      var element_0 = tmp0_0[inductionVariable_0];
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      if (element_0.w1_1 === tmp2_0) {
        tmp$ret$6 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$6 = null;
  }
  var tmp0_elvis_lhs_1 = tmp$ret$6;
  var tmp_2 = tmp0_elvis_lhs_1 == null ? default_1 : tmp0_elvis_lhs_1;
  var tmp2_1 = JsonRead_instance.iq(map, 'proteinPreference');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_2 = ProteinPreference_MODERATE_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0_1 = values_8();
  var tmp$ret$10;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_1 = 0;
    var last_1 = tmp0_1.length;
    while (inductionVariable_1 < last_1) {
      var element_1 = tmp0_1[inductionVariable_1];
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      if (element_1.w1_1 === tmp2_1) {
        tmp$ret$10 = element_1;
        break $l$block_1;
      }
    }
    tmp$ret$10 = null;
  }
  var tmp0_elvis_lhs_2 = tmp$ret$10;
  var tmp_3 = tmp0_elvis_lhs_2 == null ? default_2 : tmp0_elvis_lhs_2;
  var tmp2_2 = JsonRead_instance.iq(map, 'calorieFloor');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_3 = CalorieFloor_STANDARD_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0_2 = values_5();
  var tmp$ret$14;
  $l$block_2: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_2 = 0;
    var last_2 = tmp0_2.length;
    while (inductionVariable_2 < last_2) {
      var element_2 = tmp0_2[inductionVariable_2];
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      if (element_2.w1_1 === tmp2_2) {
        tmp$ret$14 = element_2;
        break $l$block_2;
      }
    }
    tmp$ret$14 = null;
  }
  var tmp0_elvis_lhs_3 = tmp$ret$14;
  var tmp_4 = tmp0_elvis_lhs_3 == null ? default_3 : tmp0_elvis_lhs_3;
  var tmp2_elvis_lhs = JsonRead_instance.xq(map, 'checkInWeekday');
  var tmp_5 = coerceIn_0(tmp2_elvis_lhs == null ? 1 : tmp2_elvis_lhs, 1, 7);
  var tmp2_3 = JsonRead_instance.iq(distributionMap, 'kind');
  // Inline function 'app.macrotide.core.coaching.NutritionJson.enumOrDefault' call
  var default_4 = DistributionKind_EVEN_getInstance();
  // Inline function 'kotlin.enumValues' call
  var tmp0_3 = values_13();
  var tmp$ret$18;
  $l$block_3: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable_3 = 0;
    var last_3 = tmp0_3.length;
    while (inductionVariable_3 < last_3) {
      var element_3 = tmp0_3[inductionVariable_3];
      inductionVariable_3 = inductionVariable_3 + 1 | 0;
      if (element_3.w1_1 === tmp2_3) {
        tmp$ret$18 = element_3;
        break $l$block_3;
      }
    }
    tmp$ret$18 = null;
  }
  var tmp0_elvis_lhs_4 = tmp$ret$18;
  var tmp_6 = tmp0_elvis_lhs_4 == null ? default_4 : tmp0_elvis_lhs_4;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_4 = JsonRead_instance.zq(distributionMap, 'highDays');
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0_4.j();
  while (_iterator__ex2g4s.k()) {
    var element_4 = _iterator__ex2g4s.l();
    if (1 <= element_4 ? element_4 <= 7 : false) {
      destination.f(element_4);
    }
  }
  var tmp_7 = toSet(destination);
  var tmp3_elvis_lhs = JsonRead_instance.ar(shiftMap, 'enabled');
  var tmp_8 = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  var tmp4_elvis_lhs = JsonRead_instance.jq(shiftMap, 'kcal');
  var tmp_9 = tmp4_elvis_lhs == null ? 150.0 : tmp4_elvis_lhs;
  var tmp5_elvis_lhs = JsonRead_instance.ar(shiftMap, 'carbs');
  return new NutritionProgram(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, new TrainingShiftSetting(tmp_8, tmp_9, tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs), targets(this, map.s1('manual')), dietBreak(this, map.s1('dietBreak')));
};
protoOf(NutritionJson).br = function (json, dietBreak) {
  var tmp;
  if (json == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = JsonRead_instance.vf(Json_instance.uf(json), 'PROGRAM');
  }
  var tmp1_elvis_lhs = tmp;
  var map = LinkedHashMap_init_$Create$_0(tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs);
  var tmp2 = 'dietBreak';
  var tmp_0;
  if (dietBreak == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = linkedMapOf([to('startDate', EpochDays_getInstance().sd(dietBreak.ck_1)), to('weeks', dietBreak.dk_1)]);
  }
  // Inline function 'kotlin.collections.set' call
  var value = tmp_0;
  map.k2(tmp2, value);
  return Json_instance.zf(map);
};
protoOf(NutritionJson).cr = function (json) {
  var map = JsonRead_instance.vf(Json_instance.uf(json), 'CHECKIN');
  // Inline function 'kotlin.takeIf' call
  var this_0 = targets(this, map.s1('targets'));
  var tmp;
  if (this_0.o() === 1 || this_0.o() === 7) {
    tmp = this_0;
  } else {
    tmp = null;
  }
  var tmp0_elvis_lhs = tmp;
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  var targets_0 = tmp_0;
  var tmp_1 = map.s1('persistence');
  var tmp1_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
  var persistence = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = JsonRead_instance.xq(persistence, 'direction');
  var tmp_2 = coerceIn_0(tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs, -1, 1);
  var tmp3_elvis_lhs = JsonRead_instance.xq(persistence, 'weeks');
  return new PreviousCheckIn(targets_0, new Persistence(tmp_2, coerceAtLeast(tmp3_elvis_lhs == null ? 0 : tmp3_elvis_lhs, 0)));
};
protoOf(NutritionJson).vq = function (result, accepted, initial) {
  var tmp = Json_instance;
  var tmp_0 = to('date', EpochDays_getInstance().sd(result.dr_1));
  var tmp_1 = to('expenditureKcal', round(result.jr_1.qm_1));
  var tmp_2 = to('trendWeightKg', round2(this, result.lr_1));
  var tmp0_safe_receiver = result.mr_1;
  var tmp_3;
  if (tmp0_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_3 = round2(NutritionJson_instance, tmp0_safe_receiver);
  }
  var tmp_4 = to('weeklyChangeKg', tmp_3);
  var tmp_5 = to('rawTargetKcal', round(result.qr_1));
  // Inline function 'kotlin.collections.map' call
  var this_0 = result.ur_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$4 = linkedMapOf([to('kcal', round(item.qj_1)), to('protein', round(item.rj_1)), to('fat', round(item.sj_1)), to('carbs', round(item.tj_1))]);
    destination.f(tmp$ret$4);
  }
  var tmp_6 = to('targets', destination);
  // Inline function 'kotlin.collections.map' call
  var this_1 = result.er_1.is_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$7 = EpochDays_getInstance().sd(item_0);
    destination_0.f(tmp$ret$7);
  }
  var tmp_7 = to('partialDays', destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_2 = result.er_1.js_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_1 = this_2.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$10 = EpochDays_getInstance().sd(item_1);
    destination_1.f(tmp$ret$10);
  }
  // Inline function 'kotlin.apply' call
  var this_3 = linkedMapOf([tmp_0, tmp_1, tmp_2, tmp_4, tmp_5, tmp_6, to('loggingReview', linkedMapOf([tmp_7, to('fastedDays', destination_1)])), to('persistence', linkedMapOf([to('direction', result.wr_1.hi_1), to('weeks', result.wr_1.ii_1)])), to('accepted', accepted)]);
  if (initial) {
    this_3.k2('initial', true);
  }
  return tmp.zf(this_3);
};
protoOf(NutritionJson).ms = function (result, accepted, initial, $super) {
  accepted = accepted === VOID ? true : accepted;
  initial = initial === VOID ? false : initial;
  return $super === VOID ? this.vq(result, accepted, initial) : $super.vq.call(this, result, accepted, initial);
};
var NutritionJson_instance;
function NutritionJson_getInstance() {
  return NutritionJson_instance;
}
function LoggingReview(likelyPartialDays, possibleFastingDays) {
  this.ns_1 = likelyPartialDays;
  this.os_1 = possibleFastingDays;
}
protoOf(LoggingReview).toString = function () {
  return 'LoggingReview(likelyPartialDays=' + toString(this.ns_1) + ', possibleFastingDays=' + toString(this.os_1) + ')';
};
protoOf(LoggingReview).hashCode = function () {
  var result = hashCode(this.ns_1);
  result = imul(result, 31) + hashCode(this.os_1) | 0;
  return result;
};
protoOf(LoggingReview).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LoggingReview))
    return false;
  if (!equals(this.ns_1, other.ns_1))
    return false;
  if (!equals(this.os_1, other.os_1))
    return false;
  return true;
};
function PartialDays() {
  this.ps_1 = 0.5;
}
protoOf(PartialDays).qs = function (intake, fromDay, toDay, threshold) {
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = intake.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$2 = element.mj_1;
    destination.k2(tmp$ret$2, element);
  }
  var byDay = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = numberRangeToNumber(fromDay, toDay);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = tmp0.oc_1;
  var last = tmp0.pc_1;
  if (inductionVariable <= last)
    do {
      var element_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element_0;
      var tmp0_safe_receiver = byDay.s1(it);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.f(tmp0_safe_receiver);
      }
    }
     while (!(element_0 === last));
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = destination_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_1 = _iterator__ex2g4s_0.l();
    if (element_1.oj_1.equals(DayStatus_COMPLETE_getInstance()) && element_1.nj_1 > 0.0) {
      destination_1.f(element_1);
    }
  }
  var logged = destination_1;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = logged.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_2 = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_2 = logged.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_3 = _iterator__ex2g4s_2.l();
      if (!(element_3.mj_1 === element_2.mj_1)) {
        destination_3.f(element_3);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_3, 10));
    var _iterator__ex2g4s_3 = destination_3.j();
    while (_iterator__ex2g4s_3.k()) {
      var item = _iterator__ex2g4s_3.l();
      var tmp$ret$21 = item.nj_1;
      destination_4.f(tmp$ret$21);
    }
    var others = destination_4;
    var tmp;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!others.m()) {
      tmp = element_2.nj_1 < threshold * PartialDays_instance.rs(others);
    } else {
      tmp = false;
    }
    if (tmp) {
      destination_2.f(element_2);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_2, 10));
  var _iterator__ex2g4s_4 = destination_2.j();
  while (_iterator__ex2g4s_4.k()) {
    var item_0 = _iterator__ex2g4s_4.l();
    var tmp$ret$25 = item_0.mj_1;
    destination_5.f(tmp$ret$25);
  }
  var partial = destination_5;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = numberRangeToNumber(fromDay, toDay);
  // Inline function 'kotlin.collections.filterTo' call
  var destination_6 = ArrayList_init_$Create$_0();
  var inductionVariable_0 = tmp0_0.oc_1;
  var last_0 = tmp0_0.pc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var element_4 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var day = element_4;
      var entry = byDay.s1(day);
      if (entry == null ? true : entry.oj_1.equals(DayStatus_UNLOGGED_getInstance()) ? true : entry.oj_1.equals(DayStatus_COMPLETE_getInstance()) && entry.nj_1 <= 0.0 ? true : false) {
        destination_6.f(element_4);
      }
    }
     while (!(element_4 === last_0));
  var fasting = destination_6;
  return new LoggingReview(partial, fasting);
};
protoOf(PartialDays).rs = function (values) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.require' call
  if (!!values.m()) {
    var message = 'values must not be empty';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var sorted_0 = sorted(values);
  var middle = sorted_0.o() / 2 | 0;
  return (sorted_0.o() % 2 | 0) === 1 ? sorted_0.n(middle) : (sorted_0.n(middle - 1 | 0) + sorted_0.n(middle)) / 2.0;
};
var PartialDays_instance;
function PartialDays_getInstance() {
  return PartialDays_instance;
}
function StrengthIndexPoint(day, index) {
  this.ss_1 = day;
  this.ts_1 = index;
}
protoOf(StrengthIndexPoint).toString = function () {
  return 'StrengthIndexPoint(day=' + this.ss_1 + ', index=' + this.ts_1 + ')';
};
protoOf(StrengthIndexPoint).hashCode = function () {
  var result = this.ss_1;
  result = imul(result, 31) + getNumberHashCode(this.ts_1) | 0;
  return result;
};
protoOf(StrengthIndexPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StrengthIndexPoint))
    return false;
  if (!(this.ss_1 === other.ss_1))
    return false;
  if (!equals(this.ts_1, other.ts_1))
    return false;
  return true;
};
function GuardrailResult(triggered, changePct, sessions, suggestedRatePctPerWeek, suggestDietBreak) {
  this.us_1 = triggered;
  this.vs_1 = changePct;
  this.ws_1 = sessions;
  this.xs_1 = suggestedRatePctPerWeek;
  this.ys_1 = suggestDietBreak;
}
protoOf(GuardrailResult).toString = function () {
  return 'GuardrailResult(triggered=' + this.us_1 + ', changePct=' + this.vs_1 + ', sessions=' + this.ws_1 + ', suggestedRatePctPerWeek=' + this.xs_1 + ', suggestDietBreak=' + this.ys_1 + ')';
};
protoOf(GuardrailResult).hashCode = function () {
  var result = getBooleanHashCode(this.us_1);
  result = imul(result, 31) + (this.vs_1 == null ? 0 : getNumberHashCode(this.vs_1)) | 0;
  result = imul(result, 31) + this.ws_1 | 0;
  result = imul(result, 31) + (this.xs_1 == null ? 0 : getNumberHashCode(this.xs_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ys_1) | 0;
  return result;
};
protoOf(GuardrailResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GuardrailResult))
    return false;
  if (!(this.us_1 === other.us_1))
    return false;
  if (!equals(this.vs_1, other.vs_1))
    return false;
  if (!(this.ws_1 === other.ws_1))
    return false;
  if (!equals(this.xs_1, other.xs_1))
    return false;
  if (!(this.ys_1 === other.ys_1))
    return false;
  return true;
};
function trendChangePct($this, window_0, minSessions) {
  if (window_0.o() < minSessions || (last(window_0).ss_1 - first(window_0).ss_1 | 0) < 7)
    return null;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(window_0, 10));
  var _iterator__ex2g4s = window_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.ss_1;
    destination.f(tmp$ret$2);
  }
  var xs = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(window_0, 10));
  var _iterator__ex2g4s_0 = window_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.ts_1;
    destination_0.f(tmp$ret$5);
  }
  var ys = destination_0;
  var meanX = average(xs);
  var meanY = average(ys);
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s_1 = xs.j();
  while (_iterator__ex2g4s_1.k()) {
    var element = _iterator__ex2g4s_1.l();
    var tmp = sum;
    sum = tmp + (element - meanX) * (element - meanX);
  }
  var sxx = sum;
  // Inline function 'kotlin.collections.sumOf' call
  var sum_0 = 0;
  var progression = get_indices(xs);
  var inductionVariable = progression.oc_1;
  var last_0 = progression.pc_1;
  if (inductionVariable <= last_0)
    do {
      var element_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_0 = sum_0;
      var it = element_0;
      sum_0 = tmp_0 + (xs.n(it) - meanX) * (ys.n(it) - meanY);
    }
     while (!(element_0 === last_0));
  var slope = sum_0 / sxx;
  var start = meanY + slope * (first(xs) - meanX);
  if (start <= 0.0)
    return null;
  return slope * (last(xs) - first(xs)) / start * 100.0;
}
function sam$kotlin_Comparator$0_1(function_0) {
  this.zs_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_1).y9 = function (a, b) {
  return this.zs_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_1).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_1).g2 = function () {
  return this.zs_1;
};
protoOf(sam$kotlin_Comparator$0_1).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_1).hashCode = function () {
  return hashCode(this.g2());
};
function PerformanceGuardrail$evaluate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.ss_1;
  var tmp$ret$2 = b.ss_1;
  return compareValues(tmp, tmp$ret$2);
}
function PerformanceGuardrail() {
  this.at_1 = 21;
  this.bt_1 = 3.0;
  this.ct_1 = 3;
  this.dt_1 = 7;
  this.et_1 = 0.25;
  this.ft_1 = 0.05;
}
protoOf(PerformanceGuardrail).gt = function (points, today, ratePctPerWeek, windowDays, dropThresholdPct, minSessions) {
  // Inline function 'kotlin.require' call
  if (!(windowDays > 0)) {
    var message = 'windowDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = points.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp;
    var containsLower = today - windowDays | 0;
    var containsArg = element.ss_1;
    if (containsLower <= containsArg ? containsArg <= today : false) {
      tmp = element.ts_1 > 0.0;
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = PerformanceGuardrail$evaluate$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_1(tmp_0);
  var window_0 = sortedWith(destination, tmp$ret$6);
  var change = trendChangePct(this, window_0, minSessions);
  var triggered = !(change == null) && ratePctPerWeek < 0.0 && change < -dropThresholdPct;
  if (!triggered)
    return new GuardrailResult(false, change, window_0.o(), null, false);
  // Inline function 'kotlin.math.abs' call
  var magnitude = Math.abs(ratePctPerWeek);
  var dietBreak = magnitude <= 0.25 + 1.0E-9;
  var tmp_1;
  if (dietBreak) {
    tmp_1 = 0.0;
  } else {
    // Inline function 'kotlin.math.floor' call
    var x = magnitude / 2.0 / 0.05 + 1.0E-9;
    tmp_1 = -(Math.floor(x) * 0.05);
  }
  var suggested = tmp_1;
  return new GuardrailResult(true, change, window_0.o(), suggested, dietBreak);
};
protoOf(PerformanceGuardrail).ht = function (points, today, ratePctPerWeek, windowDays, dropThresholdPct, minSessions, $super) {
  windowDays = windowDays === VOID ? 21 : windowDays;
  dropThresholdPct = dropThresholdPct === VOID ? 3.0 : dropThresholdPct;
  minSessions = minSessions === VOID ? 3 : minSessions;
  return $super === VOID ? this.gt(points, today, ratePctPerWeek, windowDays, dropThresholdPct, minSessions) : $super.gt.call(this, points, today, ratePctPerWeek, windowDays, dropThresholdPct, minSessions);
};
var PerformanceGuardrail_instance;
function PerformanceGuardrail_getInstance() {
  return PerformanceGuardrail_instance;
}
var static_init_called_14;
function static_init_14() {
  if (static_init_called_14)
    return Unit_instance;
  static_init_called_14 = true;
  TrainingType_AUTO_instance = new TrainingType('AUTO', 0);
  TrainingType_NONE_instance = new TrainingType('NONE', 1);
  TrainingType_CARDIO_instance = new TrainingType('CARDIO', 2);
  TrainingType_STRENGTH_instance = new TrainingType('STRENGTH', 3);
  TrainingType_BOTH_instance = new TrainingType('BOTH', 4);
}
var TrainingType_AUTO_instance;
var TrainingType_NONE_instance;
var TrainingType_CARDIO_instance;
var TrainingType_STRENGTH_instance;
var TrainingType_BOTH_instance;
function values_10() {
  static_init_14();
  return [TrainingType_AUTO_getInstance(), TrainingType_NONE_getInstance(), TrainingType_CARDIO_getInstance(), TrainingType_STRENGTH_getInstance(), TrainingType_BOTH_getInstance()];
}
function get_entries_7() {
  static_init_14();
  if ($ENTRIES_7 == null)
    $ENTRIES_7 = enumEntries(values_10());
  return $ENTRIES_7;
}
var $ENTRIES_7;
function TrainingType(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_15;
function static_init_15() {
  if (static_init_called_15)
    return Unit_instance;
  static_init_called_15 = true;
  ProteinMethod_LEAN_TABLE_instance = new ProteinMethod('LEAN_TABLE', 0);
  ProteinMethod_GOAL_TRAINING_instance = new ProteinMethod('GOAL_TRAINING', 1);
}
var ProteinMethod_LEAN_TABLE_instance;
var ProteinMethod_GOAL_TRAINING_instance;
function values_11() {
  static_init_15();
  return [ProteinMethod_LEAN_TABLE_getInstance(), ProteinMethod_GOAL_TRAINING_getInstance()];
}
function get_entries_8() {
  static_init_15();
  if ($ENTRIES_8 == null)
    $ENTRIES_8 = enumEntries(values_11());
  return $ENTRIES_8;
}
var $ENTRIES_8;
function ProteinMethod(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ProteinTargets() {
  ProteinTargets_instance = this;
  this.rp_1 = 80.0;
  this.sp_1 = 6.0;
  this.tp_1 = mapOf_0([to(ProteinPreference_LOW_getInstance(), 1.6), to(ProteinPreference_MODERATE_getInstance(), 2.0), to(ProteinPreference_HIGH_getInstance(), 2.4), to(ProteinPreference_EXTRA_HIGH_getInstance(), 2.8)]);
  this.up_1 = 0.3;
  this.vp_1 = 0.3;
  this.wp_1 = 0.15;
  this.xp_1 = 65;
  this.yp_1 = 1.0;
}
protoOf(ProteinTargets).zp = function (choice, weeklyHardSets) {
  return !choice.equals(TrainingType_AUTO_getInstance()) ? choice : !(weeklyHardSets == null) && weeklyHardSets >= 6.0 ? TrainingType_STRENGTH_getInstance() : TrainingType_NONE_getInstance();
};
protoOf(ProteinTargets).it = function (method, preference, leanMassKg, cutting, training, leanCapKg, ageYears, weightKg) {
  // Inline function 'kotlin.math.min' call
  var capped = Math.min(leanMassKg, leanCapKg);
  var tmp;
  switch (method.x1_1) {
    case 0:
      tmp = preference.dq_1 * leanMassKg;
      break;
    case 1:
      var tmp_0;
      switch (training.x1_1) {
        case 3:
        case 4:
          tmp_0 = 0.3;
          break;
        case 2:
          tmp_0 = 0.15;
          break;
        case 1:
        case 0:
          tmp_0 = 0.0;
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }

      var train = tmp_0;
      tmp = capped * (getValue(this.tp_1, preference) + (cutting ? 0.3 : 0.0) + train);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var result = tmp;
  var floor = !(ageYears == null) && ageYears >= 65 && !(weightKg == null) ? 1.0 * weightKg : null;
  var tmp_1;
  if (!(floor == null)) {
    // Inline function 'kotlin.comparisons.maxOf' call
    tmp_1 = Math.max(result, floor);
  } else {
    tmp_1 = result;
  }
  return tmp_1;
};
var ProteinTargets_instance;
function ProteinTargets_getInstance() {
  if (ProteinTargets_instance == null)
    new ProteinTargets();
  return ProteinTargets_instance;
}
function TrainingType_AUTO_getInstance() {
  static_init_14();
  return TrainingType_AUTO_instance;
}
function TrainingType_NONE_getInstance() {
  static_init_14();
  return TrainingType_NONE_instance;
}
function TrainingType_CARDIO_getInstance() {
  static_init_14();
  return TrainingType_CARDIO_instance;
}
function TrainingType_STRENGTH_getInstance() {
  static_init_14();
  return TrainingType_STRENGTH_instance;
}
function TrainingType_BOTH_getInstance() {
  static_init_14();
  return TrainingType_BOTH_instance;
}
function ProteinMethod_LEAN_TABLE_getInstance() {
  static_init_15();
  return ProteinMethod_LEAN_TABLE_instance;
}
function ProteinMethod_GOAL_TRAINING_getInstance() {
  static_init_15();
  return ProteinMethod_GOAL_TRAINING_instance;
}
function ShiftResult(kcal, shiftKcal, limitedByFloor) {
  this.jt_1 = kcal;
  this.kt_1 = shiftKcal;
  this.lt_1 = limitedByFloor;
}
protoOf(ShiftResult).toString = function () {
  return 'ShiftResult(kcal=' + toString(this.jt_1) + ', shiftKcal=' + this.kt_1 + ', limitedByFloor=' + this.lt_1 + ')';
};
protoOf(ShiftResult).hashCode = function () {
  var result = hashCode(this.jt_1);
  result = imul(result, 31) + getNumberHashCode(this.kt_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.lt_1) | 0;
  return result;
};
protoOf(ShiftResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ShiftResult))
    return false;
  if (!equals(this.jt_1, other.jt_1))
    return false;
  if (!equals(this.kt_1, other.kt_1))
    return false;
  if (!(this.lt_1 === other.lt_1))
    return false;
  return true;
};
function TrainingShift() {
  this.mt_1 = 150.0;
  this.nt_1 = "The extra calories on training days are carbohydrate, to fuel harder sessions, and rest days have a little less. Protein and fat stay the same and so does the weekly total; it supports performance, it doesn't speed up fat loss.";
}
protoOf(TrainingShift).ot = function (dailyKcal, trainingDays, kcalPerTrainingDay, floorKcal) {
  // Inline function 'kotlin.require' call
  if (!(dailyKcal.o() === 7)) {
    var message = 'dailyKcal must have 7 days';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(trainingDays, Collection)) {
      tmp = trainingDays.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$2 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = trainingDays.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(0 <= element ? element <= 6 : false)) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
    }
    tmp$ret$2 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$2) {
    var message_0 = 'trainingDays must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(kcalPerTrainingDay >= 0.0)) {
    var message_1 = 'kcalPerTrainingDay must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  if (trainingDays.m() || trainingDays.o() === 7 || kcalPerTrainingDay === 0.0) {
    return new ShiftResult(dailyKcal, 0.0, false);
  }
  var training = trainingDays.o();
  var rest = 7.0 - training;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = numberRangeToNumber(0, 6);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.oc_1;
  var last = tmp0.pc_1;
  if (inductionVariable <= last)
    do {
      var element_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element_0;
      if (!trainingDays.r(it)) {
        destination.f(element_0);
      }
    }
     while (!(element_0 === last));
  // Inline function 'kotlin.collections.minOf' call
  var iterator = destination.j();
  if (!iterator.k())
    throw NoSuchElementException_init_$Create$_0();
  var it_0 = iterator.l();
  var minValue = dailyKcal.n(it_0);
  while (iterator.k()) {
    var it_1 = iterator.l();
    var v = dailyKcal.n(it_1);
    // Inline function 'kotlin.comparisons.minOf' call
    var a = minValue;
    minValue = Math.min(a, v);
  }
  var lowestRest = minValue;
  var tmp_0;
  if (floorKcal == null) {
    tmp_0 = kcalPerTrainingDay;
  } else {
    // Inline function 'kotlin.math.max' call
    var b = (lowestRest - floorKcal) * rest / training;
    tmp_0 = Math.max(0.0, b);
  }
  var allowed = tmp_0;
  // Inline function 'kotlin.math.min' call
  var shift = Math.min(kcalPerTrainingDay, allowed);
  var restLoss = shift * training / rest;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(dailyKcal, 10));
  var index = 0;
  var _iterator__ex2g4s_0 = dailyKcal.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$19 = trainingDays.r(index_0) ? item + shift : item - restLoss;
    destination_0.f(tmp$ret$19);
  }
  var days = destination_0;
  return new ShiftResult(days, shift, shift < kcalPerTrainingDay - 1.0E-9);
};
protoOf(TrainingShift).pt = function (even, shiftedKcal) {
  // Inline function 'kotlin.require' call
  if (!(even.o() === 7 && shiftedKcal.o() === 7)) {
    var message = 'even and shiftedKcal must have 7 days';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices(even);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = item;
      var day = even.n(index);
      var tmp$ret$4 = day.fq(shiftedKcal.n(index), VOID, VOID, day.tj_1 + (shiftedKcal.n(index) - day.qj_1) / 4.0);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var days = destination;
  // Inline function 'kotlin.takeIf' call
  var tmp;
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp_0;
    if (isInterface(days, Collection)) {
      tmp_0 = days.m();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$7 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = days.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(element.tj_1 >= 0.0)) {
        tmp$ret$7 = false;
        break $l$block_0;
      }
    }
    tmp$ret$7 = true;
  }
  if (tmp$ret$7) {
    tmp = days;
  } else {
    tmp = null;
  }
  return tmp;
};
var TrainingShift_instance;
function TrainingShift_getInstance() {
  return TrainingShift_instance;
}
function BandPoint(day, lowKg, highKg) {
  this.qt_1 = day;
  this.rt_1 = lowKg;
  this.st_1 = highKg;
}
protoOf(BandPoint).toString = function () {
  return 'BandPoint(day=' + this.qt_1 + ', lowKg=' + this.rt_1 + ', highKg=' + this.st_1 + ')';
};
protoOf(BandPoint).hashCode = function () {
  var result = this.qt_1;
  result = imul(result, 31) + getNumberHashCode(this.rt_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.st_1) | 0;
  return result;
};
protoOf(BandPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BandPoint))
    return false;
  if (!(this.qt_1 === other.qt_1))
    return false;
  if (!equals(this.rt_1, other.rt_1))
    return false;
  if (!equals(this.st_1, other.st_1))
    return false;
  return true;
};
function TrendProjection(fromDay, fromKg, toDay, toKg, style) {
  this.tt_1 = fromDay;
  this.ut_1 = fromKg;
  this.vt_1 = toDay;
  this.wt_1 = toKg;
  this.xt_1 = style;
}
protoOf(TrendProjection).toString = function () {
  return 'TrendProjection(fromDay=' + this.tt_1 + ', fromKg=' + this.ut_1 + ', toDay=' + this.vt_1 + ', toKg=' + this.wt_1 + ', style=' + this.xt_1.toString() + ')';
};
protoOf(TrendProjection).hashCode = function () {
  var result = this.tt_1;
  result = imul(result, 31) + getNumberHashCode(this.ut_1) | 0;
  result = imul(result, 31) + this.vt_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.wt_1) | 0;
  result = imul(result, 31) + this.xt_1.hashCode() | 0;
  return result;
};
protoOf(TrendProjection).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrendProjection))
    return false;
  if (!(this.tt_1 === other.tt_1))
    return false;
  if (!equals(this.ut_1, other.ut_1))
    return false;
  if (!(this.vt_1 === other.vt_1))
    return false;
  if (!equals(this.wt_1, other.wt_1))
    return false;
  if (!this.xt_1.equals(other.xt_1))
    return false;
  return true;
};
function TrendChart() {
  this.yt_1 = 30;
}
protoOf(TrendChart).zt = function (trend, weighIns, params) {
  if (trend.m())
    return emptyList();
  // Inline function 'kotlin.collections.associate' call
  var this_0 = TransientTrend_instance.cu(weighIns, last(trend).wm_1, params);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.du_1.wm_1, element.fu_1);
    destination.k2(pair.hb_1, pair.ib_1);
  }
  var noise = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = trend.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver = noise.s1(element_0.wm_1);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp = new BandPoint(element_0.wm_1, element_0.zm_1 - tmp0_safe_receiver, element_0.zm_1 + tmp0_safe_receiver);
    }
    var tmp0_safe_receiver_0 = tmp;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_0);
    }
  }
  return destination_0;
};
protoOf(TrendChart).gu = function (trend, weighIns, params, $super) {
  params = params === VOID ? new TransientTrendParams() : params;
  return $super === VOID ? this.zt(trend, weighIns, params) : $super.zt.call(this, trend, weighIns, params);
};
protoOf(TrendChart).hu = function (trend, style, goal, days) {
  // Inline function 'kotlin.require' call
  if (!(days > 0)) {
    var message = 'days must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0_elvis_lhs = lastOrNull(trend);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var last = tmp;
  var tmp1_safe_receiver = WeightTrend_instance.iu(trend);
  var dataSlope = tmp1_safe_receiver == null ? null : tmp1_safe_receiver / 7.0;
  var tmp2_elvis_lhs = Goals_instance.dp(style, dataSlope, trend.o(), goal, last.zm_1);
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  var slope = tmp_0;
  return new TrendProjection(last.wm_1, last.zm_1, last.wm_1 + days | 0, last.zm_1 + slope * days, style);
};
protoOf(TrendChart).ju = function (trend, style, goal, days, $super) {
  days = days === VOID ? 30 : days;
  return $super === VOID ? this.hu(trend, style, goal, days) : $super.hu.call(this, trend, style, goal, days);
};
var TrendChart_instance;
function TrendChart_getInstance() {
  return TrendChart_instance;
}
var static_init_called_16;
function static_init_16() {
  if (static_init_called_16)
    return Unit_instance;
  static_init_called_16 = true;
  ProgramKind_COACHED_instance = new ProgramKind('COACHED', 0);
  ProgramKind_COLLABORATIVE_instance = new ProgramKind('COLLABORATIVE', 1);
  ProgramKind_MANUAL_instance = new ProgramKind('MANUAL', 2);
}
var ProgramKind_COACHED_instance;
var ProgramKind_COLLABORATIVE_instance;
var ProgramKind_MANUAL_instance;
function values_12() {
  static_init_16();
  return [ProgramKind_COACHED_getInstance(), ProgramKind_COLLABORATIVE_getInstance(), ProgramKind_MANUAL_getInstance()];
}
function ProgramKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_17;
function static_init_17() {
  if (static_init_called_17)
    return Unit_instance;
  static_init_called_17 = true;
  DistributionKind_EVEN_instance = new DistributionKind('EVEN', 0);
  DistributionKind_HIGH_DAYS_instance = new DistributionKind('HIGH_DAYS', 1);
}
var DistributionKind_EVEN_instance;
var DistributionKind_HIGH_DAYS_instance;
function values_13() {
  static_init_17();
  return [DistributionKind_EVEN_getInstance(), DistributionKind_HIGH_DAYS_getInstance()];
}
function DistributionKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TrainingShiftSetting(enabled, kcal, carbs) {
  enabled = enabled === VOID ? false : enabled;
  kcal = kcal === VOID ? 150.0 : kcal;
  carbs = carbs === VOID ? false : carbs;
  this.ku_1 = enabled;
  this.lu_1 = kcal;
  this.mu_1 = carbs;
}
protoOf(TrainingShiftSetting).toString = function () {
  return 'TrainingShiftSetting(enabled=' + this.ku_1 + ', kcal=' + this.lu_1 + ', carbs=' + this.mu_1 + ')';
};
protoOf(TrainingShiftSetting).hashCode = function () {
  var result = getBooleanHashCode(this.ku_1);
  result = imul(result, 31) + getNumberHashCode(this.lu_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.mu_1) | 0;
  return result;
};
protoOf(TrainingShiftSetting).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingShiftSetting))
    return false;
  if (!(this.ku_1 === other.ku_1))
    return false;
  if (!equals(this.lu_1, other.lu_1))
    return false;
  if (!(this.mu_1 === other.mu_1))
    return false;
  return true;
};
function NutritionProgram(kind, dietType, proteinPreference, calorieFloor, checkInWeekday, distribution, highDays, trainingShift, manual, dietBreak) {
  kind = kind === VOID ? ProgramKind_COACHED_getInstance() : kind;
  dietType = dietType === VOID ? DietType_BALANCED_getInstance() : dietType;
  proteinPreference = proteinPreference === VOID ? ProteinPreference_MODERATE_getInstance() : proteinPreference;
  calorieFloor = calorieFloor === VOID ? CalorieFloor_STANDARD_getInstance() : calorieFloor;
  checkInWeekday = checkInWeekday === VOID ? 1 : checkInWeekday;
  distribution = distribution === VOID ? DistributionKind_EVEN_getInstance() : distribution;
  highDays = highDays === VOID ? emptySet() : highDays;
  trainingShift = trainingShift === VOID ? new TrainingShiftSetting() : trainingShift;
  manual = manual === VOID ? emptyList() : manual;
  dietBreak = dietBreak === VOID ? null : dietBreak;
  this.nu_1 = kind;
  this.ou_1 = dietType;
  this.pu_1 = proteinPreference;
  this.qu_1 = calorieFloor;
  this.ru_1 = checkInWeekday;
  this.su_1 = distribution;
  this.tu_1 = highDays;
  this.uu_1 = trainingShift;
  this.vu_1 = manual;
  this.wu_1 = dietBreak;
}
protoOf(NutritionProgram).toString = function () {
  return 'NutritionProgram(kind=' + this.nu_1.toString() + ', dietType=' + this.ou_1.toString() + ', proteinPreference=' + this.pu_1.toString() + ', calorieFloor=' + this.qu_1.toString() + ', checkInWeekday=' + this.ru_1 + ', distribution=' + this.su_1.toString() + ', highDays=' + toString(this.tu_1) + ', trainingShift=' + this.uu_1.toString() + ', manual=' + toString(this.vu_1) + ', dietBreak=' + toString_0(this.wu_1) + ')';
};
protoOf(NutritionProgram).hashCode = function () {
  var result = this.nu_1.hashCode();
  result = imul(result, 31) + this.ou_1.hashCode() | 0;
  result = imul(result, 31) + this.pu_1.hashCode() | 0;
  result = imul(result, 31) + this.qu_1.hashCode() | 0;
  result = imul(result, 31) + this.ru_1 | 0;
  result = imul(result, 31) + this.su_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.tu_1) | 0;
  result = imul(result, 31) + this.uu_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.vu_1) | 0;
  result = imul(result, 31) + (this.wu_1 == null ? 0 : this.wu_1.hashCode()) | 0;
  return result;
};
protoOf(NutritionProgram).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutritionProgram))
    return false;
  if (!this.nu_1.equals(other.nu_1))
    return false;
  if (!this.ou_1.equals(other.ou_1))
    return false;
  if (!this.pu_1.equals(other.pu_1))
    return false;
  if (!this.qu_1.equals(other.qu_1))
    return false;
  if (!(this.ru_1 === other.ru_1))
    return false;
  if (!this.su_1.equals(other.su_1))
    return false;
  if (!equals(this.tu_1, other.tu_1))
    return false;
  if (!this.uu_1.equals(other.uu_1))
    return false;
  if (!equals(this.vu_1, other.vu_1))
    return false;
  if (!equals(this.wu_1, other.wu_1))
    return false;
  return true;
};
function BodyProfile(sex, ageYears, heightCm, bodyFatFraction, leanMassKg, activityLevel, waistCm) {
  bodyFatFraction = bodyFatFraction === VOID ? null : bodyFatFraction;
  leanMassKg = leanMassKg === VOID ? null : leanMassKg;
  activityLevel = activityLevel === VOID ? ActivityLevel_MODERATE_getInstance() : activityLevel;
  waistCm = waistCm === VOID ? null : waistCm;
  this.jk_1 = sex;
  this.kk_1 = ageYears;
  this.lk_1 = heightCm;
  this.mk_1 = bodyFatFraction;
  this.nk_1 = leanMassKg;
  this.ok_1 = activityLevel;
  this.pk_1 = waistCm;
}
protoOf(BodyProfile).toString = function () {
  return 'BodyProfile(sex=' + this.jk_1.toString() + ', ageYears=' + this.kk_1 + ', heightCm=' + this.lk_1 + ', bodyFatFraction=' + this.mk_1 + ', leanMassKg=' + this.nk_1 + ', activityLevel=' + this.ok_1.toString() + ', waistCm=' + this.pk_1 + ')';
};
protoOf(BodyProfile).hashCode = function () {
  var result = this.jk_1.hashCode();
  result = imul(result, 31) + this.kk_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.lk_1) | 0;
  result = imul(result, 31) + (this.mk_1 == null ? 0 : getNumberHashCode(this.mk_1)) | 0;
  result = imul(result, 31) + (this.nk_1 == null ? 0 : getNumberHashCode(this.nk_1)) | 0;
  result = imul(result, 31) + this.ok_1.hashCode() | 0;
  result = imul(result, 31) + (this.pk_1 == null ? 0 : getNumberHashCode(this.pk_1)) | 0;
  return result;
};
protoOf(BodyProfile).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof BodyProfile))
    return false;
  if (!this.jk_1.equals(other.jk_1))
    return false;
  if (!(this.kk_1 === other.kk_1))
    return false;
  if (!equals(this.lk_1, other.lk_1))
    return false;
  if (!equals(this.mk_1, other.mk_1))
    return false;
  if (!equals(this.nk_1, other.nk_1))
    return false;
  if (!this.ok_1.equals(other.ok_1))
    return false;
  if (!equals(this.pk_1, other.pk_1))
    return false;
  return true;
};
function PreviousCheckIn(targets, persistence) {
  persistence = persistence === VOID ? new Persistence() : persistence;
  this.xu_1 = targets;
  this.yu_1 = persistence;
}
protoOf(PreviousCheckIn).zu = function () {
  return DailyTargets_instance.yj(this.xu_1);
};
protoOf(PreviousCheckIn).toString = function () {
  return 'PreviousCheckIn(targets=' + toString(this.xu_1) + ', persistence=' + this.yu_1.toString() + ')';
};
protoOf(PreviousCheckIn).hashCode = function () {
  var result = hashCode(this.xu_1);
  result = imul(result, 31) + this.yu_1.hashCode() | 0;
  return result;
};
protoOf(PreviousCheckIn).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PreviousCheckIn))
    return false;
  if (!equals(this.xu_1, other.xu_1))
    return false;
  if (!this.yu_1.equals(other.yu_1))
    return false;
  return true;
};
function CheckInParams(loggingBreakMinUnusableDays, weighInLookbackDays, partialThreshold, highDayMultiplier) {
  loggingBreakMinUnusableDays = loggingBreakMinUnusableDays === VOID ? 4 : loggingBreakMinUnusableDays;
  weighInLookbackDays = weighInLookbackDays === VOID ? 3 : weighInLookbackDays;
  partialThreshold = partialThreshold === VOID ? 0.5 : partialThreshold;
  highDayMultiplier = highDayMultiplier === VOID ? 1.1 : highDayMultiplier;
  this.av_1 = loggingBreakMinUnusableDays;
  this.bv_1 = weighInLookbackDays;
  this.cv_1 = partialThreshold;
  this.dv_1 = highDayMultiplier;
}
protoOf(CheckInParams).toString = function () {
  return 'CheckInParams(loggingBreakMinUnusableDays=' + this.av_1 + ', weighInLookbackDays=' + this.bv_1 + ', partialThreshold=' + this.cv_1 + ', highDayMultiplier=' + this.dv_1 + ')';
};
protoOf(CheckInParams).hashCode = function () {
  var result = this.av_1;
  result = imul(result, 31) + this.bv_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.cv_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.dv_1) | 0;
  return result;
};
protoOf(CheckInParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CheckInParams))
    return false;
  if (!(this.av_1 === other.av_1))
    return false;
  if (!(this.bv_1 === other.bv_1))
    return false;
  if (!equals(this.cv_1, other.cv_1))
    return false;
  if (!equals(this.dv_1, other.dv_1))
    return false;
  return true;
};
function WeeklyCheckInInput(day, program, goal, profile, intake, weighIns, expenditure, previous, trendMethod, trainingWeekdays, strength, algorithms, weeklyHardSets, params, recovery) {
  previous = previous === VOID ? null : previous;
  trendMethod = trendMethod === VOID ? TrendMethod_CLASSIC_getInstance() : trendMethod;
  trainingWeekdays = trainingWeekdays === VOID ? emptySet() : trainingWeekdays;
  strength = strength === VOID ? emptyList() : strength;
  algorithms = algorithms === VOID ? new AlgorithmSettings() : algorithms;
  weeklyHardSets = weeklyHardSets === VOID ? null : weeklyHardSets;
  params = params === VOID ? algorithms.dg() : params;
  recovery = recovery === VOID ? emptyList() : recovery;
  this.ev_1 = day;
  this.fv_1 = program;
  this.gv_1 = goal;
  this.hv_1 = profile;
  this.iv_1 = intake;
  this.jv_1 = weighIns;
  this.kv_1 = expenditure;
  this.lv_1 = previous;
  this.mv_1 = trendMethod;
  this.nv_1 = trainingWeekdays;
  this.ov_1 = strength;
  this.pv_1 = algorithms;
  this.qv_1 = weeklyHardSets;
  this.rv_1 = params;
  this.sv_1 = recovery;
}
protoOf(WeeklyCheckInInput).toString = function () {
  return 'WeeklyCheckInInput(day=' + this.ev_1 + ', program=' + this.fv_1.toString() + ', goal=' + this.gv_1.toString() + ', profile=' + this.hv_1.toString() + ', intake=' + toString(this.iv_1) + ', weighIns=' + toString(this.jv_1) + ', expenditure=' + toString(this.kv_1) + ', previous=' + toString_0(this.lv_1) + ', trendMethod=' + this.mv_1.toString() + ', trainingWeekdays=' + toString(this.nv_1) + ', strength=' + toString(this.ov_1) + ', algorithms=' + this.pv_1.toString() + ', weeklyHardSets=' + this.qv_1 + ', params=' + this.rv_1.toString() + ', recovery=' + toString(this.sv_1) + ')';
};
protoOf(WeeklyCheckInInput).hashCode = function () {
  var result = this.ev_1;
  result = imul(result, 31) + this.fv_1.hashCode() | 0;
  result = imul(result, 31) + this.gv_1.hashCode() | 0;
  result = imul(result, 31) + this.hv_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.iv_1) | 0;
  result = imul(result, 31) + hashCode(this.jv_1) | 0;
  result = imul(result, 31) + hashCode(this.kv_1) | 0;
  result = imul(result, 31) + (this.lv_1 == null ? 0 : this.lv_1.hashCode()) | 0;
  result = imul(result, 31) + this.mv_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.nv_1) | 0;
  result = imul(result, 31) + hashCode(this.ov_1) | 0;
  result = imul(result, 31) + this.pv_1.hashCode() | 0;
  result = imul(result, 31) + (this.qv_1 == null ? 0 : getNumberHashCode(this.qv_1)) | 0;
  result = imul(result, 31) + this.rv_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.sv_1) | 0;
  return result;
};
protoOf(WeeklyCheckInInput).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeeklyCheckInInput))
    return false;
  if (!(this.ev_1 === other.ev_1))
    return false;
  if (!this.fv_1.equals(other.fv_1))
    return false;
  if (!this.gv_1.equals(other.gv_1))
    return false;
  if (!this.hv_1.equals(other.hv_1))
    return false;
  if (!equals(this.iv_1, other.iv_1))
    return false;
  if (!equals(this.jv_1, other.jv_1))
    return false;
  if (!equals(this.kv_1, other.kv_1))
    return false;
  if (!equals(this.lv_1, other.lv_1))
    return false;
  if (!this.mv_1.equals(other.mv_1))
    return false;
  if (!equals(this.nv_1, other.nv_1))
    return false;
  if (!equals(this.ov_1, other.ov_1))
    return false;
  if (!this.pv_1.equals(other.pv_1))
    return false;
  if (!equals(this.qv_1, other.qv_1))
    return false;
  if (!this.rv_1.equals(other.rv_1))
    return false;
  if (!equals(this.sv_1, other.sv_1))
    return false;
  return true;
};
function WeekReview(fromDay, toDay, likelyPartialDays, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays) {
  this.es_1 = fromDay;
  this.fs_1 = toDay;
  this.gs_1 = likelyPartialDays;
  this.hs_1 = possibleFastingDays;
  this.is_1 = partialDays;
  this.js_1 = fastedDays;
  this.ks_1 = unloggedDays;
  this.ls_1 = usableDays;
}
protoOf(WeekReview).toString = function () {
  return 'WeekReview(fromDay=' + this.es_1 + ', toDay=' + this.fs_1 + ', likelyPartialDays=' + toString(this.gs_1) + ', possibleFastingDays=' + toString(this.hs_1) + ', partialDays=' + toString(this.is_1) + ', fastedDays=' + toString(this.js_1) + ', unloggedDays=' + toString(this.ks_1) + ', usableDays=' + this.ls_1 + ')';
};
protoOf(WeekReview).hashCode = function () {
  var result = this.es_1;
  result = imul(result, 31) + this.fs_1 | 0;
  result = imul(result, 31) + hashCode(this.gs_1) | 0;
  result = imul(result, 31) + hashCode(this.hs_1) | 0;
  result = imul(result, 31) + hashCode(this.is_1) | 0;
  result = imul(result, 31) + hashCode(this.js_1) | 0;
  result = imul(result, 31) + hashCode(this.ks_1) | 0;
  result = imul(result, 31) + this.ls_1 | 0;
  return result;
};
protoOf(WeekReview).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeekReview))
    return false;
  if (!(this.es_1 === other.es_1))
    return false;
  if (!(this.fs_1 === other.fs_1))
    return false;
  if (!equals(this.gs_1, other.gs_1))
    return false;
  if (!equals(this.hs_1, other.hs_1))
    return false;
  if (!equals(this.is_1, other.is_1))
    return false;
  if (!equals(this.js_1, other.js_1))
    return false;
  if (!equals(this.ks_1, other.ks_1))
    return false;
  if (!(this.ls_1 === other.ls_1))
    return false;
  return true;
};
var static_init_called_18;
function static_init_18() {
  if (static_init_called_18)
    return Unit_instance;
  static_init_called_18 = true;
  CheckInModule_PARTIAL_LOGGING_instance = new CheckInModule('PARTIAL_LOGGING', 0);
  CheckInModule_WEIGH_IN_instance = new CheckInModule('WEIGH_IN', 1);
  CheckInModule_FASTING_instance = new CheckInModule('FASTING', 2);
  CheckInModule_LOGGING_BREAK_instance = new CheckInModule('LOGGING_BREAK', 3);
  CheckInModule_PROGRAM_UPDATE_instance = new CheckInModule('PROGRAM_UPDATE', 4);
  CheckInModule_TRAINING_PERFORMANCE_instance = new CheckInModule('TRAINING_PERFORMANCE', 5);
  CheckInModule_TRAINING_SPLIT_instance = new CheckInModule('TRAINING_SPLIT', 6);
  CheckInModule_RECOVERY_instance = new CheckInModule('RECOVERY', 7);
}
var CheckInModule_PARTIAL_LOGGING_instance;
var CheckInModule_WEIGH_IN_instance;
var CheckInModule_FASTING_instance;
var CheckInModule_LOGGING_BREAK_instance;
var CheckInModule_PROGRAM_UPDATE_instance;
var CheckInModule_TRAINING_PERFORMANCE_instance;
var CheckInModule_TRAINING_SPLIT_instance;
var CheckInModule_RECOVERY_instance;
function CheckInModule(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_19;
function static_init_19() {
  if (static_init_called_19)
    return Unit_instance;
  static_init_called_19 = true;
  CheckInFlagCode_LIKELY_PARTIAL_DAYS_instance = new CheckInFlagCode('LIKELY_PARTIAL_DAYS', 0);
  CheckInFlagCode_POSSIBLE_FASTING_DAYS_instance = new CheckInFlagCode('POSSIBLE_FASTING_DAYS', 1);
  CheckInFlagCode_WEIGH_IN_NEEDED_instance = new CheckInFlagCode('WEIGH_IN_NEEDED', 2);
  CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_instance = new CheckInFlagCode('NO_WEIGH_IN_THIS_WEEK', 3);
  CheckInFlagCode_LOGGING_BREAK_instance = new CheckInFlagCode('LOGGING_BREAK', 4);
  CheckInFlagCode_EXPENDITURE_HOLDING_instance = new CheckInFlagCode('EXPENDITURE_HOLDING', 5);
  CheckInFlagCode_FIRST_CHECK_IN_instance = new CheckInFlagCode('FIRST_CHECK_IN', 6);
  CheckInFlagCode_TARGETS_UPDATED_instance = new CheckInFlagCode('TARGETS_UPDATED', 7);
  CheckInFlagCode_TARGETS_KEPT_instance = new CheckInFlagCode('TARGETS_KEPT', 8);
  CheckInFlagCode_MANUAL_TARGETS_instance = new CheckInFlagCode('MANUAL_TARGETS', 9);
  CheckInFlagCode_FLOOR_LIMITED_instance = new CheckInFlagCode('FLOOR_LIMITED', 10);
  CheckInFlagCode_EVEN_SPLIT_FALLBACK_instance = new CheckInFlagCode('EVEN_SPLIT_FALLBACK', 11);
  CheckInFlagCode_MAINTENANCE_CORRECTION_instance = new CheckInFlagCode('MAINTENANCE_CORRECTION', 12);
  CheckInFlagCode_STRENGTH_FALLING_instance = new CheckInFlagCode('STRENGTH_FALLING', 13);
  CheckInFlagCode_TRAINING_SHIFT_APPLIED_instance = new CheckInFlagCode('TRAINING_SHIFT_APPLIED', 14);
  CheckInFlagCode_TRAINING_SHIFT_LIMITED_instance = new CheckInFlagCode('TRAINING_SHIFT_LIMITED', 15);
  CheckInFlagCode_FAST_LOSS_instance = new CheckInFlagCode('FAST_LOSS', 16);
  CheckInFlagCode_STRENGTH_TREND_instance = new CheckInFlagCode('STRENGTH_TREND', 17);
  CheckInFlagCode_SHORT_SLEEP_instance = new CheckInFlagCode('SHORT_SLEEP', 18);
  CheckInFlagCode_LOW_ENERGY_AVAILABILITY_instance = new CheckInFlagCode('LOW_ENERGY_AVAILABILITY', 19);
  CheckInFlagCode_RECOVERY_CONTEXT_instance = new CheckInFlagCode('RECOVERY_CONTEXT', 20);
  CheckInFlagCode_DIET_BREAK_instance = new CheckInFlagCode('DIET_BREAK', 21);
  CheckInFlagCode_DIET_BREAK_ENDED_instance = new CheckInFlagCode('DIET_BREAK_ENDED', 22);
}
var CheckInFlagCode_LIKELY_PARTIAL_DAYS_instance;
var CheckInFlagCode_POSSIBLE_FASTING_DAYS_instance;
var CheckInFlagCode_WEIGH_IN_NEEDED_instance;
var CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_instance;
var CheckInFlagCode_LOGGING_BREAK_instance;
var CheckInFlagCode_EXPENDITURE_HOLDING_instance;
var CheckInFlagCode_FIRST_CHECK_IN_instance;
var CheckInFlagCode_TARGETS_UPDATED_instance;
var CheckInFlagCode_TARGETS_KEPT_instance;
var CheckInFlagCode_MANUAL_TARGETS_instance;
var CheckInFlagCode_FLOOR_LIMITED_instance;
var CheckInFlagCode_EVEN_SPLIT_FALLBACK_instance;
var CheckInFlagCode_MAINTENANCE_CORRECTION_instance;
var CheckInFlagCode_STRENGTH_FALLING_instance;
var CheckInFlagCode_TRAINING_SHIFT_APPLIED_instance;
var CheckInFlagCode_TRAINING_SHIFT_LIMITED_instance;
var CheckInFlagCode_FAST_LOSS_instance;
var CheckInFlagCode_STRENGTH_TREND_instance;
var CheckInFlagCode_SHORT_SLEEP_instance;
var CheckInFlagCode_LOW_ENERGY_AVAILABILITY_instance;
var CheckInFlagCode_RECOVERY_CONTEXT_instance;
var CheckInFlagCode_DIET_BREAK_instance;
var CheckInFlagCode_DIET_BREAK_ENDED_instance;
function CheckInFlagCode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function CheckInFlag(module_0, code, message, days) {
  days = days === VOID ? emptyList() : days;
  this.tv_1 = module_0;
  this.uv_1 = code;
  this.vv_1 = message;
  this.wv_1 = days;
}
protoOf(CheckInFlag).toString = function () {
  return 'CheckInFlag(module=' + this.tv_1.toString() + ', code=' + this.uv_1.toString() + ', message=' + this.vv_1 + ', days=' + toString(this.wv_1) + ')';
};
protoOf(CheckInFlag).hashCode = function () {
  var result = this.tv_1.hashCode();
  result = imul(result, 31) + this.uv_1.hashCode() | 0;
  result = imul(result, 31) + getStringHashCode(this.vv_1) | 0;
  result = imul(result, 31) + hashCode(this.wv_1) | 0;
  return result;
};
protoOf(CheckInFlag).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CheckInFlag))
    return false;
  if (!this.tv_1.equals(other.tv_1))
    return false;
  if (!this.uv_1.equals(other.uv_1))
    return false;
  if (!(this.vv_1 === other.vv_1))
    return false;
  if (!equals(this.wv_1, other.wv_1))
    return false;
  return true;
};
function WeeklyCheckInResult(day, review, weighInsThisWeek, hasWeighInThisWeek, needsWeighIn, loggingBreak, expenditure, expenditureHolding, trendWeightKg, weeklyChangeKg, kcalPerKg, leanMassKg, effectiveRatePctPerWeek, rawTargetKcal, averageTargetKcal, changeKcal, limitedByFloor, targets, targetsUpdated, persistence, trainingShiftKcal, guardrail, flags, lifts, fastLoss, recoverySignals, onDietBreak) {
  lifts = lifts === VOID ? false : lifts;
  fastLoss = fastLoss === VOID ? null : fastLoss;
  recoverySignals = recoverySignals === VOID ? null : recoverySignals;
  onDietBreak = onDietBreak === VOID ? false : onDietBreak;
  this.dr_1 = day;
  this.er_1 = review;
  this.fr_1 = weighInsThisWeek;
  this.gr_1 = hasWeighInThisWeek;
  this.hr_1 = needsWeighIn;
  this.ir_1 = loggingBreak;
  this.jr_1 = expenditure;
  this.kr_1 = expenditureHolding;
  this.lr_1 = trendWeightKg;
  this.mr_1 = weeklyChangeKg;
  this.nr_1 = kcalPerKg;
  this.or_1 = leanMassKg;
  this.pr_1 = effectiveRatePctPerWeek;
  this.qr_1 = rawTargetKcal;
  this.rr_1 = averageTargetKcal;
  this.sr_1 = changeKcal;
  this.tr_1 = limitedByFloor;
  this.ur_1 = targets;
  this.vr_1 = targetsUpdated;
  this.wr_1 = persistence;
  this.xr_1 = trainingShiftKcal;
  this.yr_1 = guardrail;
  this.zr_1 = flags;
  this.as_1 = lifts;
  this.bs_1 = fastLoss;
  this.cs_1 = recoverySignals;
  this.ds_1 = onDietBreak;
}
protoOf(WeeklyCheckInResult).toString = function () {
  return 'WeeklyCheckInResult(day=' + this.dr_1 + ', review=' + this.er_1.toString() + ', weighInsThisWeek=' + this.fr_1 + ', hasWeighInThisWeek=' + this.gr_1 + ', needsWeighIn=' + this.hr_1 + ', loggingBreak=' + this.ir_1 + ', expenditure=' + this.jr_1.toString() + ', expenditureHolding=' + this.kr_1 + ', trendWeightKg=' + this.lr_1 + ', weeklyChangeKg=' + this.mr_1 + ', kcalPerKg=' + this.nr_1 + ', leanMassKg=' + this.or_1 + ', effectiveRatePctPerWeek=' + this.pr_1 + ', rawTargetKcal=' + this.qr_1 + ', averageTargetKcal=' + this.rr_1 + ', changeKcal=' + this.sr_1 + ', limitedByFloor=' + this.tr_1 + ', targets=' + toString(this.ur_1) + ', targetsUpdated=' + this.vr_1 + ', persistence=' + this.wr_1.toString() + ', trainingShiftKcal=' + this.xr_1 + ', guardrail=' + toString_0(this.yr_1) + ', flags=' + toString(this.zr_1) + ', lifts=' + this.as_1 + ', fastLoss=' + toString_0(this.bs_1) + ', recoverySignals=' + toString_0(this.cs_1) + ', onDietBreak=' + this.ds_1 + ')';
};
protoOf(WeeklyCheckInResult).hashCode = function () {
  var result = this.dr_1;
  result = imul(result, 31) + this.er_1.hashCode() | 0;
  result = imul(result, 31) + this.fr_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.gr_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.hr_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ir_1) | 0;
  result = imul(result, 31) + this.jr_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.kr_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.lr_1) | 0;
  result = imul(result, 31) + (this.mr_1 == null ? 0 : getNumberHashCode(this.mr_1)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.nr_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.or_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.pr_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.qr_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.rr_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.sr_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.tr_1) | 0;
  result = imul(result, 31) + hashCode(this.ur_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.vr_1) | 0;
  result = imul(result, 31) + this.wr_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.xr_1) | 0;
  result = imul(result, 31) + (this.yr_1 == null ? 0 : this.yr_1.hashCode()) | 0;
  result = imul(result, 31) + hashCode(this.zr_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.as_1) | 0;
  result = imul(result, 31) + (this.bs_1 == null ? 0 : this.bs_1.hashCode()) | 0;
  result = imul(result, 31) + (this.cs_1 == null ? 0 : this.cs_1.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ds_1) | 0;
  return result;
};
protoOf(WeeklyCheckInResult).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeeklyCheckInResult))
    return false;
  if (!(this.dr_1 === other.dr_1))
    return false;
  if (!this.er_1.equals(other.er_1))
    return false;
  if (!(this.fr_1 === other.fr_1))
    return false;
  if (!(this.gr_1 === other.gr_1))
    return false;
  if (!(this.hr_1 === other.hr_1))
    return false;
  if (!(this.ir_1 === other.ir_1))
    return false;
  if (!this.jr_1.equals(other.jr_1))
    return false;
  if (!(this.kr_1 === other.kr_1))
    return false;
  if (!equals(this.lr_1, other.lr_1))
    return false;
  if (!equals(this.mr_1, other.mr_1))
    return false;
  if (!equals(this.nr_1, other.nr_1))
    return false;
  if (!equals(this.or_1, other.or_1))
    return false;
  if (!equals(this.pr_1, other.pr_1))
    return false;
  if (!equals(this.qr_1, other.qr_1))
    return false;
  if (!equals(this.rr_1, other.rr_1))
    return false;
  if (!equals(this.sr_1, other.sr_1))
    return false;
  if (!(this.tr_1 === other.tr_1))
    return false;
  if (!equals(this.ur_1, other.ur_1))
    return false;
  if (!(this.vr_1 === other.vr_1))
    return false;
  if (!this.wr_1.equals(other.wr_1))
    return false;
  if (!equals(this.xr_1, other.xr_1))
    return false;
  if (!equals(this.yr_1, other.yr_1))
    return false;
  if (!equals(this.zr_1, other.zr_1))
    return false;
  if (!(this.as_1 === other.as_1))
    return false;
  if (!equals(this.bs_1, other.bs_1))
    return false;
  if (!equals(this.cs_1, other.cs_1))
    return false;
  if (!(this.ds_1 === other.ds_1))
    return false;
  return true;
};
function addReviewFlags($this, flags, review, needsWeighIn, weighInsThisWeek, lookback) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!review.gs_1.m()) {
    var count = review.gs_1.o();
    flags.f(new CheckInFlag(CheckInModule_PARTIAL_LOGGING_getInstance(), CheckInFlagCode_LIKELY_PARTIAL_DAYS_getInstance(), Fmt_instance.ae(count, 'day') + ' look' + (count === 1 ? 's' : '') + ' partly logged (under half a typical day). Mark ' + (count === 1 ? 'it' : 'them') + ' partial to leave ' + (count === 1 ? 'it' : 'them') + ' out.', review.gs_1));
  }
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!review.hs_1.m()) {
    var count_0 = review.hs_1.o();
    flags.f(new CheckInFlag(CheckInModule_FASTING_getInstance(), CheckInFlagCode_POSSIBLE_FASTING_DAYS_getInstance(), 'Nothing was logged on ' + Fmt_instance.ae(count_0, 'day') + '. Mark a day fasted (counts as 0 kcal) or leave it unlogged (ignored).', review.hs_1));
  }
  if (needsWeighIn) {
    flags.f(new CheckInFlag(CheckInModule_WEIGH_IN_getInstance(), CheckInFlagCode_WEIGH_IN_NEEDED_getInstance(), 'No weigh-in today or in the previous ' + lookback + ' days. Add one before new targets are set.'));
  }
  if (weighInsThisWeek === 0) {
    flags.f(new CheckInFlag(CheckInModule_WEIGH_IN_getInstance(), CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_getInstance(), 'No weigh-in in the last 7 days; at least one a week keeps expenditure updating.'));
  }
}
function run$macros(trendKg, proteinG, program, algorithms, minimums, kcal) {
  return Macros_instance.hq(kcal, trendKg, proteinG, program.ou_1, algorithms.hf_1, minimums);
}
function WeeklyCheckIn() {
  this.qq_1 = 350.0;
}
protoOf(WeeklyCheckIn).rq = function (input) {
  var day = input.ev_1;
  var params = input.rv_1;
  var program = input.fv_1;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = input.jv_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.nl_1 <= day) {
      destination.f(element);
    }
  }
  var weighIns = destination;
  var trend = Trend_instance.xv(weighIns, day, input.mv_1);
  var tmp0_elvis_lhs = lastOrNull(trend);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var current = tmp;
  var trendKg = current.zm_1;
  var review = this.qs(input.iv_1, day - 7 | 0, day - 1 | 0, params.cv_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(weighIns, 10));
  var _iterator__ex2g4s_0 = weighIns.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item.nl_1;
    destination_0.f(tmp$ret$5);
  }
  var weighInDays = toSet(destination_0);
  var tmp$ret$6;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_0;
    if (isInterface(weighInDays, Collection)) {
      tmp_0 = weighInDays.m();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$6 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s_1 = weighInDays.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      if ((day - 6 | 0) <= element_0 ? element_0 <= day : false) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$6 = count;
  }
  var weighInsThisWeek = tmp$ret$6;
  var tmp$ret$8;
  $l$block_1: {
    // Inline function 'kotlin.collections.none' call
    var tmp_1;
    if (isInterface(weighInDays, Collection)) {
      tmp_1 = weighInDays.m();
    } else {
      tmp_1 = false;
    }
    if (tmp_1) {
      tmp$ret$8 = true;
      break $l$block_1;
    }
    var _iterator__ex2g4s_2 = weighInDays.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      if ((day - params.bv_1 | 0) <= element_1 ? element_1 <= day : false) {
        tmp$ret$8 = false;
        break $l$block_1;
      }
    }
    tmp$ret$8 = true;
  }
  var needsWeighIn = tmp$ret$8;
  var profile = input.hv_1;
  var algorithms = input.pv_1;
  var tmp1_elvis_lhs = profile.mk_1;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = profile.nk_1;
    var tmp_3;
    if (tmp2_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.takeIf' call
      var this_0 = 1.0 - tmp2_safe_receiver / trendKg;
      var tmp_4;
      if (this_0 > 0.0 && this_0 < 1.0) {
        tmp_4 = this_0;
      } else {
        tmp_4 = null;
      }
      tmp_3 = tmp_4;
    }
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var bodyFat = tmp_2;
  var kcalPerKg = algorithms.eg(trendKg, bodyFat);
  var tmp3_elvis_lhs = profile.nk_1;
  var leanMass = tmp3_elvis_lhs == null ? BodyComposition_instance.yv(profile.jk_1, profile.kk_1, trendKg, profile.lk_1, bodyFat, profile.pk_1) : tmp3_elvis_lhs;
  var tmp_5 = ExpenditureInsights_getInstance();
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = input.kv_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = tmp0_0.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_2 = _iterator__ex2g4s_3.l();
    if (element_2.pm_1 <= day) {
      destination_1.f(element_2);
    }
  }
  var shown = tmp_5.bw(destination_1, day, weighInDays.r(day));
  var tmp5_elvis_lhs = shown == null ? null : shown.cw_1;
  var expenditure = tmp5_elvis_lhs == null ? new ExpenditurePoint(day, InitialExpenditure_instance.em(profile.jk_1, trendKg, profile.lk_1, profile.kk_1, profile.ok_1, bodyFat, algorithms.cf_1, profile.pk_1), 350.0, ExpenditureStatus_INITIAL_getInstance()) : tmp5_elvis_lhs;
  var holding = expenditure.sm_1.equals(ExpenditureStatus_HOLDING_getInstance());
  var unusable = 7 - review.ls_1 | 0;
  var loggingBreak = holding || unusable >= params.av_1;
  var tmp6_safe_receiver = program.wu_1;
  var tmp_6;
  if (tmp6_safe_receiver == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_7;
    if (input.gv_1.mh_1.equals(GoalType_LOSE_getInstance())) {
      tmp_7 = tmp6_safe_receiver;
    } else {
      tmp_7 = null;
    }
    tmp_6 = tmp_7;
  }
  var dietBreak = tmp_6;
  var onBreak = (dietBreak == null ? null : dietBreak.fk(day)) === true;
  var tmp_8;
  var tmp_9;
  if (onBreak) {
    tmp_9 = true;
  } else {
    tmp_9 = (dietBreak == null ? null : dietBreak.gk(day)) === true;
  }
  if (tmp_9) {
    tmp_8 = CheckInSmoothing_NONE_getInstance();
  } else {
    tmp_8 = algorithms.af_1;
  }
  var smoothing = tmp_8;
  var goal = onBreak ? new Goal(GoalType_MAINTAIN_getInstance(), 0.0, null) : input.gv_1;
  var goalRate = CheckIn_instance.pi(input.gv_1, trendKg);
  var rate = CheckIn_instance.pi(goal, trendKg);
  var raw = expenditure.qm_1 + CheckIn_instance.qi(rate, trendKg, kcalPerKg);
  var previous = input.lv_1;
  var previousAverage = previous == null ? null : previous.zu();
  var minimums = CalorieFloors_instance.eh(algorithms.gf_1, trendKg, leanMass, profile.lk_1, algorithms.ff_1);
  var floor = CalorieFloors_instance.fh(algorithms.gf_1, program.qu_1, minimums);
  var training = ProteinTargets_getInstance().zp(algorithms.ef_1, input.qv_1);
  var proteinG = ProteinTargets_getInstance().it(algorithms.df_1, program.pu_1, leanMass, goalRate < 0.0, training, algorithms.ff_1, profile.kk_1, trendKg);
  var flags = ArrayList_init_$Create$_0();
  var limitedByFloor = false;
  var shiftKcal = 0.0;
  var updated;
  var persistence;
  var targets;
  var tmp_10;
  if (program.nu_1.equals(ProgramKind_MANUAL_getInstance())) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_10 = !program.vu_1.m();
  } else {
    tmp_10 = false;
  }
  var manual = tmp_10;
  if (manual) {
    targets = DailyTargets_instance.xj(program.vu_1);
    var tmp11_elvis_lhs = previous == null ? null : previous.yu_1;
    persistence = tmp11_elvis_lhs == null ? new Persistence() : tmp11_elvis_lhs;
    updated = false;
    flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_MANUAL_TARGETS_getInstance(), 'Manual program: your targets stay as you set them.'));
  } else if (loggingBreak && !(previous == null)) {
    targets = DailyTargets_instance.xj(previous.xu_1);
    persistence = previous.yu_1;
    updated = false;
    flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_TARGETS_KEPT_getInstance(), "Last week's targets are kept until there is enough data again."));
  } else {
    var tmp_11 = CheckIn_instance;
    var tmp13_elvis_lhs = previous == null ? null : previous.yu_1;
    persistence = tmp_11.ti(tmp13_elvis_lhs == null ? new Persistence() : tmp13_elvis_lhs, previousAverage, raw);
    var result = CheckIn_instance.si(new CheckInInput(expenditure.qm_1, trendKg, goal, kcalPerKg, previousAverage, persistence.ii_1, VOID, program.qu_1, floor, smoothing, expenditure.rm_1));
    limitedByFloor = result.fi_1;
    var tmp_12;
    if (program.su_1.equals(DistributionKind_HIGH_DAYS_getInstance())) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0_1 = program.tu_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_4 = tmp0_1.j();
      while (_iterator__ex2g4s_4.k()) {
        var element_3 = _iterator__ex2g4s_4.l();
        if (1 <= element_3 ? element_3 <= 7 : false) {
          destination_2.f(element_3);
        }
      }
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_2, 10));
      var _iterator__ex2g4s_5 = destination_2.j();
      while (_iterator__ex2g4s_5.k()) {
        var item_0 = _iterator__ex2g4s_5.l();
        var tmp$ret$25 = item_0 - 1 | 0;
        destination_3.f(tmp$ret$25);
      }
      tmp_12 = toSet(destination_3);
    } else {
      tmp_12 = emptySet();
    }
    var highDays = tmp_12;
    var daily = WeeklyDistribution_instance.jw(result.ci_1, highDays, algorithms.if_1, floor, params.dv_1);
    var tmp_13;
    var tmp_14;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!highDays.m()) {
      tmp_14 = highDays.o() < 7;
    } else {
      tmp_14 = false;
    }
    if (tmp_14) {
      tmp_13 = distinct(daily).o() === 1;
    } else {
      tmp_13 = false;
    }
    if (tmp_13) {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_EVEN_SPLIT_FALLBACK_getInstance(), 'High days would push a low day under the calorie floor, so the week is split evenly.'));
    }
    var carbShift = null;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_2 = input.nv_1;
    // Inline function 'kotlin.collections.filterTo' call
    var destination_4 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_6 = tmp0_2.j();
    while (_iterator__ex2g4s_6.k()) {
      var element_4 = _iterator__ex2g4s_6.l();
      if (1 <= element_4 ? element_4 <= 7 : false) {
        destination_4.f(element_4);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_4, 10));
    var _iterator__ex2g4s_7 = destination_4.j();
    while (_iterator__ex2g4s_7.k()) {
      var item_1 = _iterator__ex2g4s_7.l();
      var tmp$ret$32 = item_1 - 1 | 0;
      destination_5.f(tmp$ret$32);
    }
    var trainingDays = toSet(destination_5);
    var tmp_15;
    var tmp_16;
    if (program.uu_1.ku_1) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp_16 = !trainingDays.m();
    } else {
      tmp_16 = false;
    }
    if (tmp_16) {
      tmp_15 = trainingDays.o() < 7;
    } else {
      tmp_15 = false;
    }
    if (tmp_15) {
      var shift = TrainingShift_instance.ot(daily, trainingDays, program.uu_1.lu_1, floor);
      if (program.uu_1.mu_1 && shift.kt_1 > 0.0) {
        var tmp_17 = TrainingShift_instance;
        // Inline function 'kotlin.collections.map' call
        var this_1 = daily;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_6 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
        var _iterator__ex2g4s_8 = this_1.j();
        while (_iterator__ex2g4s_8.k()) {
          var item_2 = _iterator__ex2g4s_8.l();
          var tmp$ret$36 = run$macros(trendKg, proteinG, program, algorithms, minimums, item_2);
          destination_6.f(tmp$ret$36);
        }
        carbShift = tmp_17.pt(destination_6, shift.jt_1);
      }
      daily = shift.jt_1;
      shiftKcal = shift.kt_1;
      var asCarbs = !(carbShift == null) ? ' as carbohydrate' : '';
      if (shift.lt_1) {
        flags.f(new CheckInFlag(CheckInModule_TRAINING_SPLIT_getInstance(), CheckInFlagCode_TRAINING_SHIFT_LIMITED_getInstance(), 'Training days get ' + Fmt_instance.wd(shift.kt_1) + ' kcal more' + asCarbs + ' instead of ' + Fmt_instance.wd(program.uu_1.lu_1) + ', so rest days stay above the floor.'));
      } else {
        flags.f(new CheckInFlag(CheckInModule_TRAINING_SPLIT_getInstance(), CheckInFlagCode_TRAINING_SHIFT_APPLIED_getInstance(), Fmt_instance.wd(shift.kt_1) + ' kcal moved to each training day' + asCarbs + '; the weekly total is unchanged.'));
      }
    }
    var tmp14_elvis_lhs = carbShift;
    var tmp_18;
    if (tmp14_elvis_lhs == null) {
      // Inline function 'kotlin.collections.map' call
      var this_2 = daily;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_7 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_9 = this_2.j();
      while (_iterator__ex2g4s_9.k()) {
        var item_3 = _iterator__ex2g4s_9.l();
        var tmp$ret$39 = run$macros(trendKg, proteinG, program, algorithms, minimums, item_3);
        destination_7.f(tmp$ret$39);
      }
      tmp_18 = destination_7;
    } else {
      tmp_18 = tmp14_elvis_lhs;
    }
    targets = tmp_18;
    updated = true;
    if (onBreak && !(dietBreak == null)) {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_DIET_BREAK_getInstance(), 'Diet break: targets are at maintenance until ' + EpochDays_getInstance().sd(dietBreak.ek() - 1 | 0) + ". A diet break holds your calories at maintenance. Breaks can make dieting easier on appetite; they don't speed up fat loss, and each break week adds a week to your diet."));
    } else {
      if ((dietBreak == null ? null : dietBreak.gk(day)) === true) {
        flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_DIET_BREAK_ENDED_getInstance(), 'Your diet break is over, so targets return to your goal pace.'));
      }
    }
    if (previous == null) {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_FIRST_CHECK_IN_getInstance(), 'First check-in: targets start at ' + Fmt_instance.wd(result.ci_1) + ' kcal a day.'));
    } else {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_TARGETS_UPDATED_getInstance(), 'Average daily target ' + Fmt_instance.wd(result.ci_1) + ' kcal (' + Fmt_instance.yd(result.ci_1 - previous.zu()) + ' kcal).'));
    }
    if (limitedByFloor && !(floor == null)) {
      flags.f(new CheckInFlag(CheckInModule_PROGRAM_UPDATE_getInstance(), CheckInFlagCode_FLOOR_LIMITED_getInstance(), 'Targets are held at the ' + Fmt_instance.wd(floor) + ' kcal floor; a slower rate would avoid it.'));
    }
  }
  var average = DailyTargets_instance.yj(targets);
  addReviewFlags(this, flags, review, needsWeighIn, weighInsThisWeek, params.bv_1);
  if (loggingBreak) {
    if (holding) {
      flags.f(new CheckInFlag(CheckInModule_LOGGING_BREAK_getInstance(), CheckInFlagCode_EXPENDITURE_HOLDING_getInstance(), 'Expenditure is holding for lack of recent data; it resumes after a few days of logging and a weigh-in.'));
    }
    if (unusable >= params.av_1) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0_3 = numberRangeToNumber(review.es_1, review.fs_1);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_8 = ArrayList_init_$Create$_0();
      var inductionVariable = tmp0_3.oc_1;
      var last = tmp0_3.pc_1;
      if (inductionVariable <= last)
        do {
          var element_5 = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var it = element_5;
          if (review.ks_1.r(it) || review.is_1.r(it)) {
            destination_8.f(element_5);
          }
        }
         while (!(element_5 === last));
      var missing = destination_8;
      flags.f(new CheckInFlag(CheckInModule_LOGGING_BREAK_getInstance(), CheckInFlagCode_LOGGING_BREAK_getInstance(), Fmt_instance.ae(unusable, 'day') + ' of the last 7 had no usable food log, so this week is treated as a logging break.', missing));
    }
  }
  if (input.gv_1.mh_1.equals(GoalType_MAINTAIN_getInstance()) && !(rate === 0.0)) {
    var tmp16_elvis_lhs = input.gv_1.oh_1;
    var target = tmp16_elvis_lhs == null ? trendKg : tmp16_elvis_lhs;
    var side = trendKg > target ? 'above' : 'below';
    var tmp_19 = CheckInModule_PROGRAM_UPDATE_getInstance();
    var tmp_20 = CheckInFlagCode_MAINTENANCE_CORRECTION_getInstance();
    var tmp_21 = Fmt_instance;
    // Inline function 'kotlin.math.abs' call
    var x = trendKg - target;
    var tmp$ret$43 = Math.abs(x);
    var tmp_22 = tmp_21.vd(tmp$ret$43, 1);
    var tmp_23 = Fmt_instance;
    // Inline function 'kotlin.math.abs' call
    var tmp$ret$44 = Math.abs(rate);
    flags.f(new CheckInFlag(tmp_19, tmp_20, 'Trend is ' + tmp_22 + ' kg ' + side + ' the target weight; aiming for a ' + tmp_23.vd(tmp$ret$44, 2) + ' %/week correction.'));
  }
  var guardrail = input.ov_1.m() ? null : PerformanceGuardrail_instance.ht(input.ov_1, day, rate);
  if (!(guardrail == null) && guardrail.us_1) {
    var tmp_24;
    if (guardrail.ys_1) {
      tmp_24 = 'Consider a 1\u20132 week diet break at maintenance.';
    } else {
      var tmp_25 = Fmt_instance;
      var tmp17_elvis_lhs = guardrail.xs_1;
      tmp_24 = 'Consider a slower rate (' + tmp_25.vd(tmp17_elvis_lhs == null ? 0.0 : tmp17_elvis_lhs, 2) + ' %/week) or a 1\u20132 week diet break.';
    }
    var advice = tmp_24;
    var tmp_26 = CheckInModule_TRAINING_PERFORMANCE_getInstance();
    var tmp_27 = CheckInFlagCode_STRENGTH_FALLING_getInstance();
    var tmp_28 = Fmt_instance;
    var tmp18_elvis_lhs = guardrail.vs_1;
    // Inline function 'kotlin.math.abs' call
    var x_0 = tmp18_elvis_lhs == null ? 0.0 : tmp18_elvis_lhs;
    var tmp$ret$45 = Math.abs(x_0);
    flags.f(new CheckInFlag(tmp_26, tmp_27, 'Estimated strength fell ' + tmp_28.vd(tmp$ret$45, 1) + ' % over the last 3 weeks while in a deficit. ' + advice));
  }
  var lifts = LossPace_instance.qp(algorithms.ef_1, input.qv_1);
  var change = guardrail == null ? null : guardrail.vs_1;
  var tmp_29;
  if (lifts && !(change == null)) {
    tmp_29 = !((guardrail == null ? null : guardrail.us_1) === true);
  } else {
    tmp_29 = false;
  }
  if (tmp_29) {
    var note = rate < 0.0 ? ' Strength usually holds during a diet, so a steady line is a good sign.' : '';
    flags.f(new CheckInFlag(CheckInModule_TRAINING_PERFORMANCE_getInstance(), CheckInFlagCode_STRENGTH_TREND_getInstance(), 'Estimated strength on your logged lifts: ' + Fmt_instance.xd(change, 1) + ' % over the last 3 weeks.' + note));
  }
  var fastLoss = LossPace_instance.aq(rate, trendKg, kcalPerKg, lifts);
  if (!(fastLoss == null)) {
    flags.f(new CheckInFlag(CheckInModule_TRAINING_PERFORMANCE_getInstance(), CheckInFlagCode_FAST_LOSS_getInstance(), fastLoss.x6()));
  }
  var tmp_30 = CheckInSignals_instance;
  var tmp_31 = !(profile.nk_1 == null) || !(bodyFat == null) ? leanMass : null;
  var tmp_32 = rate < 0.0;
  var signals = tmp_30.lj(day, input.sv_1, input.iv_1, review.es_1, review.fs_1, tmp_31, tmp_32, loggingBreak, (guardrail == null ? null : guardrail.us_1) === true);
  flags.q(CheckInSignals_instance.pj(signals));
  return new WeeklyCheckInResult(day, review, weighInsThisWeek, weighInsThisWeek > 0, needsWeighIn, loggingBreak, expenditure, holding, trendKg, Companion_getInstance_26().ow(trend, 7), kcalPerKg, leanMass, rate, raw, average, previousAverage == null ? 0.0 : average - previousAverage, limitedByFloor, targets, updated, persistence, shiftKcal, guardrail, flags, lifts, fastLoss, signals, onBreak);
};
protoOf(WeeklyCheckIn).qs = function (intake, fromDay, toDay, partialThreshold) {
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = intake.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$2 = element.mj_1;
    destination.k2(tmp$ret$2, element);
  }
  var byDay = destination;
  var days = numberRangeToNumber(fromDay, toDay);
  var logging = PartialDays_instance.qs(intake, fromDay, toDay, partialThreshold);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var inductionVariable = days.oc_1;
  var last = days.pc_1;
  if (inductionVariable <= last)
    do {
      var element_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element_0;
      var tmp0_safe_receiver = byDay.s1(it);
      if (equals(tmp0_safe_receiver == null ? null : tmp0_safe_receiver.oj_1, DayStatus_PARTIAL_getInstance())) {
        destination_0.f(element_0);
      }
    }
     while (!(element_0 === last));
  var tmp = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var inductionVariable_0 = days.oc_1;
  var last_0 = days.pc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var element_1 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = element_1;
      var tmp0_safe_receiver_0 = byDay.s1(it_0);
      if (equals(tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.oj_1, DayStatus_FASTED_getInstance())) {
        destination_1.f(element_1);
      }
    }
     while (!(element_1 === last_0));
  var tmp_0 = destination_1;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  var inductionVariable_1 = days.oc_1;
  var last_1 = days.pc_1;
  if (inductionVariable_1 <= last_1)
    do {
      var element_2 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var it_1 = element_2;
      var tmp_1;
      if (byDay.s1(it_1) == null) {
        tmp_1 = true;
      } else {
        var tmp0_safe_receiver_1 = byDay.s1(it_1);
        tmp_1 = equals(tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.oj_1, DayStatus_UNLOGGED_getInstance());
      }
      if (tmp_1) {
        destination_2.f(element_2);
      }
    }
     while (!(element_2 === last_1));
  var tmp_2 = destination_2;
  var tmp$ret$12;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_3;
    if (isInterface(days, Collection)) {
      tmp_3 = days.m();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp$ret$12 = 0;
      break $l$block;
    }
    var count = 0;
    var inductionVariable_2 = days.oc_1;
    var last_2 = days.pc_1;
    if (inductionVariable_2 <= last_2)
      do {
        var element_3 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var it_2 = element_3;
        var tmp_4;
        var tmp0_safe_receiver_2 = byDay.s1(it_2);
        if (equals(tmp0_safe_receiver_2 == null ? null : tmp0_safe_receiver_2.oj_1, DayStatus_COMPLETE_getInstance())) {
          tmp_4 = true;
        } else {
          var tmp1_safe_receiver = byDay.s1(it_2);
          tmp_4 = equals(tmp1_safe_receiver == null ? null : tmp1_safe_receiver.oj_1, DayStatus_FASTED_getInstance());
        }
        if (tmp_4) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
       while (!(element_3 === last_2));
    tmp$ret$12 = count;
  }
  return new WeekReview(fromDay, toDay, logging.ns_1, logging.os_1, tmp, tmp_0, tmp_2, tmp$ret$12);
};
var WeeklyCheckIn_instance;
function WeeklyCheckIn_getInstance() {
  return WeeklyCheckIn_instance;
}
function ProgramKind_COACHED_getInstance() {
  static_init_16();
  return ProgramKind_COACHED_instance;
}
function ProgramKind_COLLABORATIVE_getInstance() {
  static_init_16();
  return ProgramKind_COLLABORATIVE_instance;
}
function ProgramKind_MANUAL_getInstance() {
  static_init_16();
  return ProgramKind_MANUAL_instance;
}
function DistributionKind_EVEN_getInstance() {
  static_init_17();
  return DistributionKind_EVEN_instance;
}
function DistributionKind_HIGH_DAYS_getInstance() {
  static_init_17();
  return DistributionKind_HIGH_DAYS_instance;
}
function CheckInModule_PARTIAL_LOGGING_getInstance() {
  static_init_18();
  return CheckInModule_PARTIAL_LOGGING_instance;
}
function CheckInModule_WEIGH_IN_getInstance() {
  static_init_18();
  return CheckInModule_WEIGH_IN_instance;
}
function CheckInModule_FASTING_getInstance() {
  static_init_18();
  return CheckInModule_FASTING_instance;
}
function CheckInModule_LOGGING_BREAK_getInstance() {
  static_init_18();
  return CheckInModule_LOGGING_BREAK_instance;
}
function CheckInModule_PROGRAM_UPDATE_getInstance() {
  static_init_18();
  return CheckInModule_PROGRAM_UPDATE_instance;
}
function CheckInModule_TRAINING_PERFORMANCE_getInstance() {
  static_init_18();
  return CheckInModule_TRAINING_PERFORMANCE_instance;
}
function CheckInModule_TRAINING_SPLIT_getInstance() {
  static_init_18();
  return CheckInModule_TRAINING_SPLIT_instance;
}
function CheckInModule_RECOVERY_getInstance() {
  static_init_18();
  return CheckInModule_RECOVERY_instance;
}
function CheckInFlagCode_LIKELY_PARTIAL_DAYS_getInstance() {
  static_init_19();
  return CheckInFlagCode_LIKELY_PARTIAL_DAYS_instance;
}
function CheckInFlagCode_POSSIBLE_FASTING_DAYS_getInstance() {
  static_init_19();
  return CheckInFlagCode_POSSIBLE_FASTING_DAYS_instance;
}
function CheckInFlagCode_WEIGH_IN_NEEDED_getInstance() {
  static_init_19();
  return CheckInFlagCode_WEIGH_IN_NEEDED_instance;
}
function CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_getInstance() {
  static_init_19();
  return CheckInFlagCode_NO_WEIGH_IN_THIS_WEEK_instance;
}
function CheckInFlagCode_LOGGING_BREAK_getInstance() {
  static_init_19();
  return CheckInFlagCode_LOGGING_BREAK_instance;
}
function CheckInFlagCode_EXPENDITURE_HOLDING_getInstance() {
  static_init_19();
  return CheckInFlagCode_EXPENDITURE_HOLDING_instance;
}
function CheckInFlagCode_FIRST_CHECK_IN_getInstance() {
  static_init_19();
  return CheckInFlagCode_FIRST_CHECK_IN_instance;
}
function CheckInFlagCode_TARGETS_UPDATED_getInstance() {
  static_init_19();
  return CheckInFlagCode_TARGETS_UPDATED_instance;
}
function CheckInFlagCode_TARGETS_KEPT_getInstance() {
  static_init_19();
  return CheckInFlagCode_TARGETS_KEPT_instance;
}
function CheckInFlagCode_MANUAL_TARGETS_getInstance() {
  static_init_19();
  return CheckInFlagCode_MANUAL_TARGETS_instance;
}
function CheckInFlagCode_FLOOR_LIMITED_getInstance() {
  static_init_19();
  return CheckInFlagCode_FLOOR_LIMITED_instance;
}
function CheckInFlagCode_EVEN_SPLIT_FALLBACK_getInstance() {
  static_init_19();
  return CheckInFlagCode_EVEN_SPLIT_FALLBACK_instance;
}
function CheckInFlagCode_MAINTENANCE_CORRECTION_getInstance() {
  static_init_19();
  return CheckInFlagCode_MAINTENANCE_CORRECTION_instance;
}
function CheckInFlagCode_STRENGTH_FALLING_getInstance() {
  static_init_19();
  return CheckInFlagCode_STRENGTH_FALLING_instance;
}
function CheckInFlagCode_TRAINING_SHIFT_APPLIED_getInstance() {
  static_init_19();
  return CheckInFlagCode_TRAINING_SHIFT_APPLIED_instance;
}
function CheckInFlagCode_TRAINING_SHIFT_LIMITED_getInstance() {
  static_init_19();
  return CheckInFlagCode_TRAINING_SHIFT_LIMITED_instance;
}
function CheckInFlagCode_FAST_LOSS_getInstance() {
  static_init_19();
  return CheckInFlagCode_FAST_LOSS_instance;
}
function CheckInFlagCode_STRENGTH_TREND_getInstance() {
  static_init_19();
  return CheckInFlagCode_STRENGTH_TREND_instance;
}
function CheckInFlagCode_SHORT_SLEEP_getInstance() {
  static_init_19();
  return CheckInFlagCode_SHORT_SLEEP_instance;
}
function CheckInFlagCode_LOW_ENERGY_AVAILABILITY_getInstance() {
  static_init_19();
  return CheckInFlagCode_LOW_ENERGY_AVAILABILITY_instance;
}
function CheckInFlagCode_RECOVERY_CONTEXT_getInstance() {
  static_init_19();
  return CheckInFlagCode_RECOVERY_CONTEXT_instance;
}
function CheckInFlagCode_DIET_BREAK_getInstance() {
  static_init_19();
  return CheckInFlagCode_DIET_BREAK_instance;
}
function CheckInFlagCode_DIET_BREAK_ENDED_getInstance() {
  static_init_19();
  return CheckInFlagCode_DIET_BREAK_ENDED_instance;
}
var static_init_called_20;
function static_init_20() {
  if (static_init_called_20)
    return Unit_instance;
  static_init_called_20 = true;
  HighDayMode_FIXED_instance = new HighDayMode('FIXED', 0);
  HighDayMode_SCALED_instance = new HighDayMode('SCALED', 1);
}
var HighDayMode_FIXED_instance;
var HighDayMode_SCALED_instance;
function values_14() {
  static_init_20();
  return [HighDayMode_FIXED_getInstance(), HighDayMode_SCALED_getInstance()];
}
function get_entries_9() {
  static_init_20();
  if ($ENTRIES_9 == null)
    $ENTRIES_9 = enumEntries(values_14());
  return $ENTRIES_9;
}
var $ENTRIES_9;
function HighDayMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function WeeklyDistribution() {
  this.ew_1 = 1.1;
  this.fw_1 = 0.3;
  this.gw_1 = 1.05;
  this.hw_1 = 1.15;
  this.iw_1 = 10.0;
}
protoOf(WeeklyDistribution).pw = function (mode, highDays, fixed) {
  var tmp;
  switch (mode.x1_1) {
    case 0:
      tmp = fixed;
      break;
    case 1:
      tmp = coerceIn(1.0 + 0.3 / highDays, 1.05, 1.15);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(WeeklyDistribution).jw = function (averageDailyKcal, highDays, mode, floorKcal, fixedMultiplier) {
  if (mode.equals(HighDayMode_FIXED_getInstance()) || highDays.m() || highDays.o() === 7)
    return this.qw(averageDailyKcal, highDays, fixedMultiplier, floorKcal);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(highDays, Collection)) {
      tmp = highDays.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = highDays.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(0 <= element ? element <= 6 : false)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$0) {
    var message = 'highDays must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var lowDays = 7 - highDays.o() | 0;
  var m = this.pw(mode, highDays.o(), fixedMultiplier);
  var low = averageDailyKcal * 7.0 / (lowDays + m * highDays.o());
  var high = low * m;
  if (!(floorKcal == null) && low < floorKcal) {
    if (averageDailyKcal - floorKcal < 10.0) {
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var list = ArrayList_init_$Create$(7);
      // Inline function 'kotlin.repeat' call
      var inductionVariable = 0;
      if (inductionVariable < 7)
        do {
          var index = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          list.f(averageDailyKcal);
        }
         while (inductionVariable < 7);
      return list;
    }
    low = floorKcal;
    high = (averageDailyKcal * 7.0 - lowDays * floorKcal) / highDays.o();
  }
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list_0 = ArrayList_init_$Create$(7);
  // Inline function 'kotlin.repeat' call
  var inductionVariable_0 = 0;
  if (inductionVariable_0 < 7)
    do {
      var index_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var tmp$ret$13 = highDays.r(index_0) ? high : low;
      list_0.f(tmp$ret$13);
    }
     while (inductionVariable_0 < 7);
  return list_0;
};
protoOf(WeeklyDistribution).qw = function (averageDailyKcal, highDays, highDayMultiplier, floorKcal) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(highDays, Collection)) {
      tmp = highDays.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = highDays.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(0 <= element ? element <= 6 : false)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$0) {
    var message = 'highDays must be 0\u20136';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(highDayMultiplier >= 1.0)) {
    var message_0 = 'highDayMultiplier must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  if (highDays.m() || highDays.o() === 7) {
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var list = ArrayList_init_$Create$(7);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < 7)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        list.f(averageDailyKcal);
      }
       while (inductionVariable < 7);
    return list;
  }
  var lowDays = 7 - highDays.o() | 0;
  var low = averageDailyKcal * 7.0 / (lowDays + highDayMultiplier * highDays.o());
  if (!(floorKcal == null) && low < floorKcal) {
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var list_0 = ArrayList_init_$Create$(7);
    // Inline function 'kotlin.repeat' call
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < 7)
      do {
        var index_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        list_0.f(averageDailyKcal);
      }
       while (inductionVariable_0 < 7);
    return list_0;
  }
  var high = low * highDayMultiplier;
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var list_1 = ArrayList_init_$Create$(7);
  // Inline function 'kotlin.repeat' call
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < 7)
    do {
      var index_1 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var tmp$ret$20 = highDays.r(index_1) ? high : low;
      list_1.f(tmp$ret$20);
    }
     while (inductionVariable_1 < 7);
  return list_1;
};
var WeeklyDistribution_instance;
function WeeklyDistribution_getInstance() {
  return WeeklyDistribution_instance;
}
function HighDayMode_FIXED_getInstance() {
  static_init_20();
  return HighDayMode_FIXED_instance;
}
function HighDayMode_SCALED_getInstance() {
  static_init_20();
  return HighDayMode_SCALED_instance;
}
var static_init_called_21;
function static_init_21() {
  if (static_init_called_21)
    return Unit_instance;
  static_init_called_21 = true;
  DayStatus_COMPLETE_instance = new DayStatus('COMPLETE', 0);
  DayStatus_PARTIAL_instance = new DayStatus('PARTIAL', 1);
  DayStatus_FASTED_instance = new DayStatus('FASTED', 2);
  DayStatus_UNLOGGED_instance = new DayStatus('UNLOGGED', 3);
}
var DayStatus_COMPLETE_instance;
var DayStatus_PARTIAL_instance;
var DayStatus_FASTED_instance;
var DayStatus_UNLOGGED_instance;
function valueOf_5(value) {
  static_init_21();
  switch (value) {
    case 'COMPLETE':
      return DayStatus_COMPLETE_getInstance();
    case 'PARTIAL':
      return DayStatus_PARTIAL_getInstance();
    case 'FASTED':
      return DayStatus_FASTED_getInstance();
    case 'UNLOGGED':
      return DayStatus_UNLOGGED_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.energy.DayStatus.' + value);
      break;
  }
}
function DayStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function IntakeDay(day, kcal, status) {
  this.mj_1 = day;
  this.nj_1 = kcal;
  this.oj_1 = status;
}
protoOf(IntakeDay).toString = function () {
  return 'IntakeDay(day=' + this.mj_1 + ', kcal=' + this.nj_1 + ', status=' + this.oj_1.toString() + ')';
};
protoOf(IntakeDay).hashCode = function () {
  var result = this.mj_1;
  result = imul(result, 31) + getNumberHashCode(this.nj_1) | 0;
  result = imul(result, 31) + this.oj_1.hashCode() | 0;
  return result;
};
protoOf(IntakeDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof IntakeDay))
    return false;
  if (!(this.mj_1 === other.mj_1))
    return false;
  if (!equals(this.nj_1, other.nj_1))
    return false;
  if (!this.oj_1.equals(other.oj_1))
    return false;
  return true;
};
var static_init_called_22;
function static_init_22() {
  if (static_init_called_22)
    return Unit_instance;
  static_init_called_22 = true;
  ExpenditureStatus_INITIAL_instance = new ExpenditureStatus('INITIAL', 0);
  ExpenditureStatus_UPDATING_instance = new ExpenditureStatus('UPDATING', 1);
  ExpenditureStatus_HOLDING_instance = new ExpenditureStatus('HOLDING', 2);
}
var ExpenditureStatus_INITIAL_instance;
var ExpenditureStatus_UPDATING_instance;
var ExpenditureStatus_HOLDING_instance;
function valueOf_6(value) {
  static_init_22();
  switch (value) {
    case 'INITIAL':
      return ExpenditureStatus_INITIAL_getInstance();
    case 'UPDATING':
      return ExpenditureStatus_UPDATING_getInstance();
    case 'HOLDING':
      return ExpenditureStatus_HOLDING_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.energy.ExpenditureStatus.' + value);
      break;
  }
}
function ExpenditureStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ExpenditurePoint(day, kcal, sdKcal, status, floored, goalAdjustmentKcal) {
  floored = floored === VOID ? false : floored;
  goalAdjustmentKcal = goalAdjustmentKcal === VOID ? 0.0 : goalAdjustmentKcal;
  this.pm_1 = day;
  this.qm_1 = kcal;
  this.rm_1 = sdKcal;
  this.sm_1 = status;
  this.tm_1 = floored;
  this.um_1 = goalAdjustmentKcal;
}
protoOf(ExpenditurePoint).rw = function (day, kcal, sdKcal, status, floored, goalAdjustmentKcal) {
  return new ExpenditurePoint(day, kcal, sdKcal, status, floored, goalAdjustmentKcal);
};
protoOf(ExpenditurePoint).sw = function (day, kcal, sdKcal, status, floored, goalAdjustmentKcal, $super) {
  day = day === VOID ? this.pm_1 : day;
  kcal = kcal === VOID ? this.qm_1 : kcal;
  sdKcal = sdKcal === VOID ? this.rm_1 : sdKcal;
  status = status === VOID ? this.sm_1 : status;
  floored = floored === VOID ? this.tm_1 : floored;
  goalAdjustmentKcal = goalAdjustmentKcal === VOID ? this.um_1 : goalAdjustmentKcal;
  return $super === VOID ? this.rw(day, kcal, sdKcal, status, floored, goalAdjustmentKcal) : $super.rw.call(this, day, kcal, sdKcal, status, floored, goalAdjustmentKcal);
};
protoOf(ExpenditurePoint).toString = function () {
  return 'ExpenditurePoint(day=' + this.pm_1 + ', kcal=' + this.qm_1 + ', sdKcal=' + this.rm_1 + ', status=' + this.sm_1.toString() + ', floored=' + this.tm_1 + ', goalAdjustmentKcal=' + this.um_1 + ')';
};
protoOf(ExpenditurePoint).hashCode = function () {
  var result = this.pm_1;
  result = imul(result, 31) + getNumberHashCode(this.qm_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.rm_1) | 0;
  result = imul(result, 31) + this.sm_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.tm_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.um_1) | 0;
  return result;
};
protoOf(ExpenditurePoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditurePoint))
    return false;
  if (!(this.pm_1 === other.pm_1))
    return false;
  if (!equals(this.qm_1, other.qm_1))
    return false;
  if (!equals(this.rm_1, other.rm_1))
    return false;
  if (!this.sm_1.equals(other.sm_1))
    return false;
  if (!(this.tm_1 === other.tm_1))
    return false;
  if (!equals(this.um_1, other.um_1))
    return false;
  return true;
};
function GoalChange(day, fromRatePctPerWeek, toRatePctPerWeek) {
  this.tw_1 = day;
  this.uw_1 = fromRatePctPerWeek;
  this.vw_1 = toRatePctPerWeek;
}
protoOf(GoalChange).toString = function () {
  return 'GoalChange(day=' + this.tw_1 + ', fromRatePctPerWeek=' + this.uw_1 + ', toRatePctPerWeek=' + this.vw_1 + ')';
};
protoOf(GoalChange).hashCode = function () {
  var result = this.tw_1;
  result = imul(result, 31) + getNumberHashCode(this.uw_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.vw_1) | 0;
  return result;
};
protoOf(GoalChange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalChange))
    return false;
  if (!(this.tw_1 === other.tw_1))
    return false;
  if (!equals(this.uw_1, other.uw_1))
    return false;
  if (!equals(this.vw_1, other.vw_1))
    return false;
  return true;
};
function ExpenditureParams(windowDays, minUsableIntakeDaysInWindow, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, minWeighInDaysInWindow, firstUpdateAfterDays, weightNoiseKg, intakeNoiseKcal, processNoiseKcal, initialUncertaintyKcal, overlapFactor, maxDailyChangeKcal, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment) {
  windowDays = windowDays === VOID ? 14 : windowDays;
  minUsableIntakeDaysInWindow = minUsableIntakeDaysInWindow === VOID ? 4 : minUsableIntakeDaysInWindow;
  minUsableIntakeDaysInLastWeek = minUsableIntakeDaysInLastWeek === VOID ? 4 : minUsableIntakeDaysInLastWeek;
  maxDaysSinceWeighIn = maxDaysSinceWeighIn === VOID ? 7 : maxDaysSinceWeighIn;
  minWeighInDaysInWindow = minWeighInDaysInWindow === VOID ? 2 : minWeighInDaysInWindow;
  firstUpdateAfterDays = firstUpdateAfterDays === VOID ? 2 : firstUpdateAfterDays;
  weightNoiseKg = weightNoiseKg === VOID ? 0.6 : weightNoiseKg;
  intakeNoiseKcal = intakeNoiseKcal === VOID ? 350.0 : intakeNoiseKcal;
  processNoiseKcal = processNoiseKcal === VOID ? 40.0 : processNoiseKcal;
  initialUncertaintyKcal = initialUncertaintyKcal === VOID ? 350.0 : initialUncertaintyKcal;
  overlapFactor = overlapFactor === VOID ? 0.5 : overlapFactor;
  maxDailyChangeKcal = maxDailyChangeKcal === VOID ? 150.0 : maxDailyChangeKcal;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? false : holdAfterLastWeighIn;
  gainKcalPerKg = gainKcalPerKg === VOID ? null : gainKcalPerKg;
  goalAdjustment = goalAdjustment === VOID ? new GoalAdjustmentParams() : goalAdjustment;
  this.ww_1 = windowDays;
  this.xw_1 = minUsableIntakeDaysInWindow;
  this.yw_1 = minUsableIntakeDaysInLastWeek;
  this.zw_1 = maxDaysSinceWeighIn;
  this.ax_1 = minWeighInDaysInWindow;
  this.bx_1 = firstUpdateAfterDays;
  this.cx_1 = weightNoiseKg;
  this.dx_1 = intakeNoiseKcal;
  this.ex_1 = processNoiseKcal;
  this.fx_1 = initialUncertaintyKcal;
  this.gx_1 = overlapFactor;
  this.hx_1 = maxDailyChangeKcal;
  this.ix_1 = holdAfterLastWeighIn;
  this.jx_1 = gainKcalPerKg;
  this.kx_1 = goalAdjustment;
}
protoOf(ExpenditureParams).toString = function () {
  return 'ExpenditureParams(windowDays=' + this.ww_1 + ', minUsableIntakeDaysInWindow=' + this.xw_1 + ', minUsableIntakeDaysInLastWeek=' + this.yw_1 + ', maxDaysSinceWeighIn=' + this.zw_1 + ', minWeighInDaysInWindow=' + this.ax_1 + ', firstUpdateAfterDays=' + this.bx_1 + ', weightNoiseKg=' + this.cx_1 + ', intakeNoiseKcal=' + this.dx_1 + ', processNoiseKcal=' + this.ex_1 + ', initialUncertaintyKcal=' + this.fx_1 + ', overlapFactor=' + this.gx_1 + ', maxDailyChangeKcal=' + this.hx_1 + ', holdAfterLastWeighIn=' + this.ix_1 + ', gainKcalPerKg=' + this.jx_1 + ', goalAdjustment=' + this.kx_1.toString() + ')';
};
protoOf(ExpenditureParams).hashCode = function () {
  var result = this.ww_1;
  result = imul(result, 31) + this.xw_1 | 0;
  result = imul(result, 31) + this.yw_1 | 0;
  result = imul(result, 31) + this.zw_1 | 0;
  result = imul(result, 31) + this.ax_1 | 0;
  result = imul(result, 31) + this.bx_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.cx_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.dx_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ex_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.fx_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.gx_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.hx_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.ix_1) | 0;
  result = imul(result, 31) + (this.jx_1 == null ? 0 : getNumberHashCode(this.jx_1)) | 0;
  result = imul(result, 31) + this.kx_1.hashCode() | 0;
  return result;
};
protoOf(ExpenditureParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureParams))
    return false;
  if (!(this.ww_1 === other.ww_1))
    return false;
  if (!(this.xw_1 === other.xw_1))
    return false;
  if (!(this.yw_1 === other.yw_1))
    return false;
  if (!(this.zw_1 === other.zw_1))
    return false;
  if (!(this.ax_1 === other.ax_1))
    return false;
  if (!(this.bx_1 === other.bx_1))
    return false;
  if (!equals(this.cx_1, other.cx_1))
    return false;
  if (!equals(this.dx_1, other.dx_1))
    return false;
  if (!equals(this.ex_1, other.ex_1))
    return false;
  if (!equals(this.fx_1, other.fx_1))
    return false;
  if (!equals(this.gx_1, other.gx_1))
    return false;
  if (!equals(this.hx_1, other.hx_1))
    return false;
  if (!(this.ix_1 === other.ix_1))
    return false;
  if (!equals(this.jx_1, other.jx_1))
    return false;
  if (!this.kx_1.equals(other.kx_1))
    return false;
  return true;
};
function usableIntakeBetween($this, intakeByDay, fromDay, toDay) {
  var values = ArrayList_init_$Create$_0();
  var inductionVariable = fromDay;
  if (inductionVariable <= toDay)
    $l$loop: do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp0_elvis_lhs = intakeByDay.s1(day);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var entry = tmp;
      switch (entry.oj_1.x1_1) {
        case 0:
          values.f(entry.nj_1);
          break;
        case 2:
          values.f(0.0);
          break;
        case 1:
        case 3:
          break;
        default:
          noWhenBranchMatchedException();
          break;
      }
    }
     while (!(day === toDay));
  return values;
}
function AdaptiveExpenditure() {
}
protoOf(AdaptiveExpenditure).pl = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, floorKcal) {
  // Inline function 'kotlin.require' call
  if (!(endDay >= startDay)) {
    var message = 'endDay must not be before startDay';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(kcalPerKg > 0.0)) {
    var message_0 = 'kcalPerKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = WeightTrend_instance.bm(weighIns);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = element.nl_1;
    var tmp$ret$7 = element.ol_1;
    destination.k2(tmp, tmp$ret$7);
  }
  var weights = destination;
  var weighInDays = sorted(weights.t1());
  var finalWeighIn = lastOrNull(weighInDays);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
  var _iterator__ex2g4s_0 = intake.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$10 = element_0.mj_1;
    destination_0.k2(tmp$ret$10, element_0);
  }
  var intakeByDay = destination_0;
  var adjuster = new GoalAdjuster(goalChanges, params.kx_1);
  var estimate = initialKcal;
  var variance = params.fx_1 * params.fx_1;
  var processVariance = params.ex_1 * params.ex_1;
  var everUpdated = false;
  var points = ArrayList_init_$Create$((endDay - startDay | 0) + 1 | 0);
  var inductionVariable = startDay;
  if (inductionVariable <= endDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      variance = variance + processVariance;
      var windowStart = (day - params.ww_1 | 0) + 1 | 0;
      var usableIntake = usableIntakeBetween(this, intakeByDay, windowStart, day);
      var usableLastWeek = usableIntakeBetween(this, intakeByDay, day - 6 | 0, day).o();
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_1 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_1 = weighInDays.j();
      while (_iterator__ex2g4s_1.k()) {
        var element_1 = _iterator__ex2g4s_1.l();
        if (windowStart <= element_1 ? element_1 <= day : false) {
          destination_1.f(element_1);
        }
      }
      var windowWeights = destination_1;
      var tmp$ret$14;
      $l$block: {
        // Inline function 'kotlin.collections.lastOrNull' call
        var iterator = weighInDays.p(weighInDays.o());
        while (iterator.b3()) {
          var element_2 = iterator.c3();
          if (element_2 <= day) {
            tmp$ret$14 = element_2;
            break $l$block;
          }
        }
        tmp$ret$14 = null;
      }
      var lastWeighIn = tmp$ret$14;
      var tmp_0;
      if (lastWeighIn == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = floorKcal == null ? null : floorKcal(getValue(weights, lastWeighIn));
      }
      var floor = tmp_0;
      var eligible = (day - startDay | 0) >= params.bx_1 && usableIntake.o() >= params.xw_1 && usableLastWeek >= params.yw_1 && windowWeights.o() >= params.ax_1 && !(lastWeighIn == null) && (day - lastWeighIn | 0) < params.zw_1 && !(params.ix_1 && !(finalWeighIn == null) && day > finalWeighIn);
      var shiftToday = adjuster.rx(day, estimate, !eligible, floor);
      estimate = estimate + shiftToday;
      var tmp_1;
      if (eligible) {
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(windowWeights, 10));
        var _iterator__ex2g4s_2 = windowWeights.j();
        while (_iterator__ex2g4s_2.k()) {
          var item = _iterator__ex2g4s_2.l();
          destination_2.f(item);
        }
        var xs = destination_2;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(windowWeights, 10));
        var _iterator__ex2g4s_3 = windowWeights.j();
        while (_iterator__ex2g4s_3.k()) {
          var item_0 = _iterator__ex2g4s_3.l();
          var tmp$ret$23 = getValue(weights, item_0);
          destination_3.f(tmp$ret$23);
        }
        var ys = destination_3;
        var meanX = average(xs);
        var meanY = average(ys);
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s_4 = xs.j();
        while (_iterator__ex2g4s_4.k()) {
          var element_3 = _iterator__ex2g4s_4.l();
          var tmp_2 = sum;
          sum = tmp_2 + (element_3 - meanX) * (element_3 - meanX);
        }
        var sxx = sum;
        // Inline function 'kotlin.collections.sumOf' call
        var sum_0 = 0;
        var progression = get_indices(xs);
        var inductionVariable_0 = progression.oc_1;
        var last = progression.pc_1;
        if (inductionVariable_0 <= last)
          do {
            var element_4 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp_3 = sum_0;
            var it = element_4;
            sum_0 = tmp_3 + (xs.n(it) - meanX) * (ys.n(it) - meanY);
          }
           while (!(element_4 === last));
        var sxy = sum_0;
        var slopeKgPerDay = sxy / sxx;
        var meanIntake = average(usableIntake);
        var tmp1_safe_receiver = params.jx_1;
        var tmp_4;
        if (tmp1_safe_receiver == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_5;
          if (slopeKgPerDay > 0.0) {
            tmp_5 = tmp1_safe_receiver;
          } else {
            tmp_5 = null;
          }
          tmp_4 = tmp_5;
        }
        var tmp2_elvis_lhs = tmp_4;
        var density = tmp2_elvis_lhs == null ? kcalPerKg : tmp2_elvis_lhs;
        var raw = meanIntake - density * slopeKgPerDay;
        // Inline function 'kotlin.let' call
        var it_0 = density * params.cx_1;
        var weightTerm = it_0 * it_0 / sxx;
        var intakeTerm = params.dx_1 * params.dx_1 / usableIntake.o();
        var measurementVariance = (weightTerm + intakeTerm) * params.ww_1 * params.gx_1;
        var gain = variance / (variance + measurementVariance);
        var step = gain * (raw - estimate);
        estimate = estimate + coerceIn(step, -params.hx_1, params.hx_1);
        variance = variance * (1.0 - gain);
        everUpdated = true;
        tmp_1 = ExpenditureStatus_UPDATING_getInstance();
      } else if (everUpdated) {
        tmp_1 = ExpenditureStatus_HOLDING_getInstance();
      } else {
        tmp_1 = ExpenditureStatus_INITIAL_getInstance();
      }
      var status = tmp_1;
      var floored = !(floor == null) && estimate < floor;
      if (!(floor == null) && floored)
        estimate = floor;
      var tmp_6 = estimate;
      // Inline function 'kotlin.math.sqrt' call
      var x = variance;
      var tmp$ret$32 = Math.sqrt(x);
      points.f(new ExpenditurePoint(day, tmp_6, tmp$ret$32, status, floored, shiftToday));
    }
     while (!(day === endDay));
  return points;
};
var AdaptiveExpenditure_instance;
function AdaptiveExpenditure_getInstance() {
  return AdaptiveExpenditure_instance;
}
function DayStatus_COMPLETE_getInstance() {
  static_init_21();
  return DayStatus_COMPLETE_instance;
}
function DayStatus_PARTIAL_getInstance() {
  static_init_21();
  return DayStatus_PARTIAL_instance;
}
function DayStatus_FASTED_getInstance() {
  static_init_21();
  return DayStatus_FASTED_instance;
}
function DayStatus_UNLOGGED_getInstance() {
  static_init_21();
  return DayStatus_UNLOGGED_instance;
}
function ExpenditureStatus_INITIAL_getInstance() {
  static_init_22();
  return ExpenditureStatus_INITIAL_instance;
}
function ExpenditureStatus_UPDATING_getInstance() {
  static_init_22();
  return ExpenditureStatus_UPDATING_instance;
}
function ExpenditureStatus_HOLDING_getInstance() {
  static_init_22();
  return ExpenditureStatus_HOLDING_instance;
}
function BodyComposition() {
  this.gm_1 = 0.03;
  this.hm_1 = 0.6;
}
protoOf(BodyComposition).sx = function (sex, ageYears, weightKg, heightCm) {
  // Inline function 'kotlin.require' call
  if (!(weightKg > 0.0 && heightCm > 0.0)) {
    var message = 'weight and height must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var heightM = heightCm / 100.0;
  var bmi = weightKg / (heightM * heightM);
  var male = sex.equals(Sex_MALE_getInstance()) ? 1.0 : 0.0;
  var percent = 1.2 * bmi + 0.23 * ageYears - 10.8 * male - 5.4;
  return coerceIn(percent / 100.0, 0.03, 0.6);
};
protoOf(BodyComposition).tx = function (sex, heightCm, waistCm) {
  // Inline function 'kotlin.require' call
  if (!(heightCm > 0.0 && waistCm > 0.0)) {
    var message = 'height and waist must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var base = sex.equals(Sex_MALE_getInstance()) ? 64.0 : 76.0;
  var percent = base - 20.0 * (heightCm / waistCm);
  return coerceIn(percent / 100.0, 0.03, 0.6);
};
protoOf(BodyComposition).im = function (sex, ageYears, weightKg, heightCm, waistCm) {
  var tmp;
  if (!(waistCm == null) && waistCm > 0.0) {
    tmp = this.tx(sex, heightCm, waistCm);
  } else {
    tmp = this.sx(sex, ageYears, weightKg, heightCm);
  }
  return tmp;
};
protoOf(BodyComposition).yv = function (sex, ageYears, weightKg, heightCm, bodyFatFraction, waistCm) {
  var fraction = bodyFatFraction == null ? this.im(sex, ageYears, weightKg, heightCm, waistCm) : bodyFatFraction;
  // Inline function 'kotlin.require' call
  if (!(fraction > 0.0 && fraction < 1.0)) {
    var message = 'bodyFatFraction must be in (0, 1)';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return weightKg * (1.0 - fraction);
};
var BodyComposition_instance;
function BodyComposition_getInstance() {
  return BodyComposition_instance;
}
function EnergyBalancePoint(day, intakeKcal, status, usable, expenditureKcal, targetKcal, balanceKcal, intakeAverageKcal, expenditureAverageKcal, balanceAverageKcal) {
  this.ux_1 = day;
  this.vx_1 = intakeKcal;
  this.wx_1 = status;
  this.xx_1 = usable;
  this.yx_1 = expenditureKcal;
  this.zx_1 = targetKcal;
  this.ay_1 = balanceKcal;
  this.by_1 = intakeAverageKcal;
  this.cy_1 = expenditureAverageKcal;
  this.dy_1 = balanceAverageKcal;
}
protoOf(EnergyBalancePoint).toString = function () {
  return 'EnergyBalancePoint(day=' + this.ux_1 + ', intakeKcal=' + this.vx_1 + ', status=' + toString_0(this.wx_1) + ', usable=' + this.xx_1 + ', expenditureKcal=' + this.yx_1 + ', targetKcal=' + this.zx_1 + ', balanceKcal=' + this.ay_1 + ', intakeAverageKcal=' + this.by_1 + ', expenditureAverageKcal=' + this.cy_1 + ', balanceAverageKcal=' + this.dy_1 + ')';
};
protoOf(EnergyBalancePoint).hashCode = function () {
  var result = this.ux_1;
  result = imul(result, 31) + (this.vx_1 == null ? 0 : getNumberHashCode(this.vx_1)) | 0;
  result = imul(result, 31) + (this.wx_1 == null ? 0 : this.wx_1.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.xx_1) | 0;
  result = imul(result, 31) + (this.yx_1 == null ? 0 : getNumberHashCode(this.yx_1)) | 0;
  result = imul(result, 31) + (this.zx_1 == null ? 0 : getNumberHashCode(this.zx_1)) | 0;
  result = imul(result, 31) + (this.ay_1 == null ? 0 : getNumberHashCode(this.ay_1)) | 0;
  result = imul(result, 31) + (this.by_1 == null ? 0 : getNumberHashCode(this.by_1)) | 0;
  result = imul(result, 31) + (this.cy_1 == null ? 0 : getNumberHashCode(this.cy_1)) | 0;
  result = imul(result, 31) + (this.dy_1 == null ? 0 : getNumberHashCode(this.dy_1)) | 0;
  return result;
};
protoOf(EnergyBalancePoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EnergyBalancePoint))
    return false;
  if (!(this.ux_1 === other.ux_1))
    return false;
  if (!equals(this.vx_1, other.vx_1))
    return false;
  if (!equals(this.wx_1, other.wx_1))
    return false;
  if (!(this.xx_1 === other.xx_1))
    return false;
  if (!equals(this.yx_1, other.yx_1))
    return false;
  if (!equals(this.zx_1, other.zx_1))
    return false;
  if (!equals(this.ay_1, other.ay_1))
    return false;
  if (!equals(this.by_1, other.by_1))
    return false;
  if (!equals(this.cy_1, other.cy_1))
    return false;
  if (!equals(this.dy_1, other.dy_1))
    return false;
  return true;
};
function EnergyBalanceSummary(days, usableDays, averageIntakeKcal, averageExpenditureKcal, averageBalanceKcal, averageTargetKcal, impliedChangeKg) {
  this.ey_1 = days;
  this.fy_1 = usableDays;
  this.gy_1 = averageIntakeKcal;
  this.hy_1 = averageExpenditureKcal;
  this.iy_1 = averageBalanceKcal;
  this.jy_1 = averageTargetKcal;
  this.ky_1 = impliedChangeKg;
}
protoOf(EnergyBalanceSummary).toString = function () {
  return 'EnergyBalanceSummary(days=' + this.ey_1 + ', usableDays=' + this.fy_1 + ', averageIntakeKcal=' + this.gy_1 + ', averageExpenditureKcal=' + this.hy_1 + ', averageBalanceKcal=' + this.iy_1 + ', averageTargetKcal=' + this.jy_1 + ', impliedChangeKg=' + this.ky_1 + ')';
};
protoOf(EnergyBalanceSummary).hashCode = function () {
  var result = this.ey_1;
  result = imul(result, 31) + this.fy_1 | 0;
  result = imul(result, 31) + (this.gy_1 == null ? 0 : getNumberHashCode(this.gy_1)) | 0;
  result = imul(result, 31) + (this.hy_1 == null ? 0 : getNumberHashCode(this.hy_1)) | 0;
  result = imul(result, 31) + (this.iy_1 == null ? 0 : getNumberHashCode(this.iy_1)) | 0;
  result = imul(result, 31) + (this.jy_1 == null ? 0 : getNumberHashCode(this.jy_1)) | 0;
  result = imul(result, 31) + (this.ky_1 == null ? 0 : getNumberHashCode(this.ky_1)) | 0;
  return result;
};
protoOf(EnergyBalanceSummary).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EnergyBalanceSummary))
    return false;
  if (!(this.ey_1 === other.ey_1))
    return false;
  if (!(this.fy_1 === other.fy_1))
    return false;
  if (!equals(this.gy_1, other.gy_1))
    return false;
  if (!equals(this.hy_1, other.hy_1))
    return false;
  if (!equals(this.iy_1, other.iy_1))
    return false;
  if (!equals(this.jy_1, other.jy_1))
    return false;
  if (!equals(this.ky_1, other.ky_1))
    return false;
  return true;
};
function averageOrNull($this, $receiver) {
  return $receiver.m() ? null : average($receiver);
}
function series$usableIntake(intakeByDay, day) {
  var tmp0_safe_receiver = intakeByDay.s1(day);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp_0;
    switch (tmp0_safe_receiver.oj_1.x1_1) {
      case 0:
        tmp_0 = tmp0_safe_receiver.nj_1;
        break;
      case 2:
        tmp_0 = 0.0;
        break;
      case 1:
      case 3:
        tmp_0 = null;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function EnergyBalance() {
  this.ly_1 = 7;
}
protoOf(EnergyBalance).my = function (intake, expenditure, fromDay, toDay, targetKcalByDay, averageDays) {
  // Inline function 'kotlin.require' call
  if (!(toDay >= fromDay)) {
    var message = 'toDay must not be before fromDay';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(averageDays > 0)) {
    var message_0 = 'averageDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = intake.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$6 = element.mj_1;
    destination.k2(tmp$ret$6, element);
  }
  var intakeByDay = destination;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(expenditure, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity_0);
  var _iterator__ex2g4s_0 = expenditure.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp = element_0.pm_1;
    var tmp$ret$10 = element_0.qm_1;
    destination_0.k2(tmp, tmp$ret$10);
  }
  var expenditureByDay = destination_0;
  // Inline function 'kotlin.collections.map' call
  var this_0 = numberRangeToNumber(fromDay, toDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var day = item;
      var entry = intakeByDay.s1(day);
      var shown = entry == null ? null : entry.oj_1.equals(DayStatus_FASTED_getInstance()) ? 0.0 : entry.oj_1.equals(DayStatus_UNLOGGED_getInstance()) && entry.nj_1 <= 0.0 ? null : entry.nj_1;
      var usable = series$usableIntake(intakeByDay, day);
      var expenditureKcal = expenditureByDay.s1(day);
      var window_0 = numberRangeToNumber((day - averageDays | 0) + 1 | 0, day);
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = window_0.oc_1;
      var last_0 = window_0.pc_1;
      if (inductionVariable_0 <= last_0)
        do {
          var element_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var it = element_1;
          var tmp0_safe_receiver = series$usableIntake(intakeByDay, it);
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_2.f(tmp0_safe_receiver);
          }
        }
         while (!(element_1 === last_0));
      var intakes = destination_2;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_3 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_1 = window_0.oc_1;
      var last_1 = window_0.pc_1;
      if (inductionVariable_1 <= last_1)
        do {
          var element_2 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var it_0 = element_2;
          var tmp0_safe_receiver_0 = expenditureByDay.s1(it_0);
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_3.f(tmp0_safe_receiver_0);
          }
        }
         while (!(element_2 === last_1));
      var expenditures = destination_3;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_4 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_2 = window_0.oc_1;
      var last_2 = window_0.pc_1;
      if (inductionVariable_2 <= last_2)
        do {
          var element_3 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var d = element_3;
          var tmp0_safe_receiver_1 = series$usableIntake(intakeByDay, d);
          var tmp_0;
          if (tmp0_safe_receiver_1 == null) {
            tmp_0 = null;
          } else {
            // Inline function 'kotlin.let' call
            var tmp0_safe_receiver_2 = expenditureByDay.s1(d);
            var tmp_1;
            if (tmp0_safe_receiver_2 == null) {
              tmp_1 = null;
            } else {
              // Inline function 'kotlin.let' call
              tmp_1 = tmp0_safe_receiver_1 - tmp0_safe_receiver_2;
            }
            tmp_0 = tmp_1;
          }
          var tmp0_safe_receiver_3 = tmp_0;
          if (tmp0_safe_receiver_3 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_4.f(tmp0_safe_receiver_3);
          }
        }
         while (!(element_3 === last_2));
      var balances = destination_4;
      var tmp_2 = entry == null ? null : entry.oj_1;
      var tmp_3 = !(usable == null);
      var tmp_4 = targetKcalByDay.s1(day);
      var tmp_5;
      if (usable == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp_6;
        if (expenditureKcal == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_6 = usable - expenditureKcal;
        }
        tmp_5 = tmp_6;
      }
      var tmp$ret$13 = new EnergyBalancePoint(day, shown, tmp_2, tmp_3, expenditureKcal, tmp_4, tmp_5, averageOrNull(EnergyBalance_instance, intakes), averageOrNull(EnergyBalance_instance, expenditures), averageOrNull(EnergyBalance_instance, balances));
      destination_1.f(tmp$ret$13);
    }
     while (!(item === last));
  return destination_1;
};
protoOf(EnergyBalance).ny = function (intake, expenditure, fromDay, toDay, targetKcalByDay, averageDays, $super) {
  targetKcalByDay = targetKcalByDay === VOID ? emptyMap() : targetKcalByDay;
  averageDays = averageDays === VOID ? 7 : averageDays;
  return $super === VOID ? this.my(intake, expenditure, fromDay, toDay, targetKcalByDay, averageDays) : $super.my.call(this, intake, expenditure, fromDay, toDay, targetKcalByDay, averageDays);
};
protoOf(EnergyBalance).oy = function (points, kcalPerKg) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = points.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.xx_1) {
      destination.f(element);
    }
  }
  var usable = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = points.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver = element_0.ay_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver);
    }
  }
  var balances = destination_0;
  var tmp = points.o();
  var tmp_0 = usable.o();
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = usable.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp0_safe_receiver_0 = element_1.vx_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_1 = averageOrNull(this, destination_1);
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = points.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    var tmp0_safe_receiver_1 = element_2.yx_1;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_2.f(tmp0_safe_receiver_1);
    }
  }
  var tmp_2 = averageOrNull(this, destination_2);
  var tmp_3 = averageOrNull(this, balances);
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_3 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_3 = points.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    var tmp0_safe_receiver_2 = element_3.zx_1;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_3.f(tmp0_safe_receiver_2);
    }
  }
  var tmp_4 = averageOrNull(this, destination_3);
  var tmp_5;
  var tmp_6;
  if (!(kcalPerKg == null)) {
    // Inline function 'kotlin.collections.isNotEmpty' call
    tmp_6 = !balances.m();
  } else {
    tmp_6 = false;
  }
  if (tmp_6) {
    tmp_5 = sum(balances) / kcalPerKg;
  } else {
    tmp_5 = null;
  }
  return new EnergyBalanceSummary(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5);
};
var EnergyBalance_instance;
function EnergyBalance_getInstance() {
  return EnergyBalance_instance;
}
function EnergyDensity() {
  this.fg_1 = 239.0057361376673;
  this.gg_1 = 9440.726577437857;
  this.hg_1 = 1816.4435946462713;
  this.ig_1 = 7700.0;
  this.jg_1 = 10.4;
}
protoOf(EnergyDensity).py = function (fatMassKg) {
  // Inline function 'kotlin.require' call
  if (!(fatMassKg > 0.0)) {
    var message = 'fatMassKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return 10.4 / (10.4 + fatMassKg);
};
protoOf(EnergyDensity).qy = function (fatMassKg) {
  var lean = this.py(fatMassKg);
  return lean * 1816.4435946462713 + (1.0 - lean) * 9440.726577437857;
};
protoOf(EnergyDensity).eg = function (bodyWeightKg, bodyFatFraction) {
  if (bodyFatFraction == null)
    return 7700.0;
  // Inline function 'kotlin.require' call
  if (!(bodyFatFraction > 0.0 && bodyFatFraction < 1.0)) {
    var message = 'bodyFatFraction must be in (0, 1)';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return this.qy(bodyWeightKg * bodyFatFraction);
};
var EnergyDensity_instance;
function EnergyDensity_getInstance() {
  return EnergyDensity_instance;
}
var static_init_called_23;
function static_init_23() {
  if (static_init_called_23)
    return Unit_instance;
  static_init_called_23 = true;
  ExpenditureFloorKind_NONE_instance = new ExpenditureFloorKind('NONE', 0);
  ExpenditureFloorKind_BMR_instance = new ExpenditureFloorKind('BMR', 1);
}
var ExpenditureFloorKind_NONE_instance;
var ExpenditureFloorKind_BMR_instance;
function values_15() {
  static_init_23();
  return [ExpenditureFloorKind_NONE_getInstance(), ExpenditureFloorKind_BMR_getInstance()];
}
function get_entries_10() {
  static_init_23();
  if ($ENTRIES_10 == null)
    $ENTRIES_10 = enumEntries(values_15());
  return $ENTRIES_10;
}
var $ENTRIES_10;
function ExpenditureFloorKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ExpenditureFloor$of$lambda($leanFraction) {
  return function (weightKg) {
    return ExpenditureFloor_instance.nm(weightKg * $leanFraction);
  };
}
function ExpenditureFloor() {
  this.jm_1 = 1000.0;
  this.km_1 = 1.0;
}
protoOf(ExpenditureFloor).ry = function (leanMassKg, factor) {
  // Inline function 'kotlin.math.max' call
  var b = factor * InitialExpenditure_instance.sy(leanMassKg);
  return Math.max(1000.0, b);
};
protoOf(ExpenditureFloor).nm = function (leanMassKg, factor, $super) {
  factor = factor === VOID ? 1.0 : factor;
  return $super === VOID ? this.ry(leanMassKg, factor) : $super.ry.call(this, leanMassKg, factor);
};
protoOf(ExpenditureFloor).lm = function (kind, leanFraction) {
  var tmp;
  switch (kind.x1_1) {
    case 0:
      tmp = null;
      break;
    case 1:
      tmp = ExpenditureFloor$of$lambda(leanFraction);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var ExpenditureFloor_instance;
function ExpenditureFloor_getInstance() {
  return ExpenditureFloor_instance;
}
function ExpenditureFloorKind_NONE_getInstance() {
  static_init_23();
  return ExpenditureFloorKind_NONE_instance;
}
function ExpenditureFloorKind_BMR_getInstance() {
  static_init_23();
  return ExpenditureFloorKind_BMR_instance;
}
function ExpenditureChange(days, kcal) {
  this.ty_1 = days;
  this.uy_1 = kcal;
}
protoOf(ExpenditureChange).vy = function () {
  var tmp0_safe_receiver = this.uy_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp0_safe_receiver >= 0.5 ? Direction_INCREASE_getInstance() : tmp0_safe_receiver <= -0.5 ? Direction_DECREASE_getInstance() : Direction_NO_CHANGE_getInstance();
  }
  return tmp;
};
protoOf(ExpenditureChange).toString = function () {
  return 'ExpenditureChange(days=' + this.ty_1 + ', kcal=' + this.uy_1 + ')';
};
protoOf(ExpenditureChange).hashCode = function () {
  var result = this.ty_1;
  result = imul(result, 31) + (this.uy_1 == null ? 0 : getNumberHashCode(this.uy_1)) | 0;
  return result;
};
protoOf(ExpenditureChange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureChange))
    return false;
  if (!(this.ty_1 === other.ty_1))
    return false;
  if (!equals(this.uy_1, other.uy_1))
    return false;
  return true;
};
function DisplayedExpenditure(point, waitingForWeighIn) {
  this.cw_1 = point;
  this.dw_1 = waitingForWeighIn;
}
protoOf(DisplayedExpenditure).toString = function () {
  return 'DisplayedExpenditure(point=' + this.cw_1.toString() + ', waitingForWeighIn=' + this.dw_1 + ')';
};
protoOf(DisplayedExpenditure).hashCode = function () {
  var result = this.cw_1.hashCode();
  result = imul(result, 31) + getBooleanHashCode(this.dw_1) | 0;
  return result;
};
protoOf(DisplayedExpenditure).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DisplayedExpenditure))
    return false;
  if (!this.cw_1.equals(other.cw_1))
    return false;
  if (!(this.dw_1 === other.dw_1))
    return false;
  return true;
};
function ExpenditureInsights() {
  ExpenditureInsights_instance = this;
  this.zv_1 = listOf([3, 7, 14, 30, 90]);
  this.aw_1 = 0.5;
}
protoOf(ExpenditureInsights).bw = function (points, today, weighedInToday) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.lastOrNull' call
    var iterator = points.p(points.o());
    while (iterator.b3()) {
      var element = iterator.c3();
      if (element.pm_1 === today) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var todayPoint = tmp$ret$0;
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.lastOrNull' call
    var iterator_0 = points.p(points.o());
    while (iterator_0.b3()) {
      var element_0 = iterator_0.c3();
      if (element_0.pm_1 < today) {
        tmp$ret$2 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$2 = null;
  }
  var before = tmp$ret$2;
  var tmp;
  if (todayPoint == null) {
    var tmp_0;
    if (before == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = new DisplayedExpenditure(before.sw(today), !weighedInToday);
    }
    tmp = tmp_0;
  } else if (weighedInToday || before == null) {
    tmp = new DisplayedExpenditure(todayPoint, false);
  } else {
    tmp = new DisplayedExpenditure(before.sw(today), true);
  }
  return tmp;
};
protoOf(ExpenditureInsights).wy = function (points, windows) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(windows, 10));
  var _iterator__ex2g4s = windows.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new ExpenditureChange(item, ExpenditureInsights_getInstance().xy(points, item));
    destination.f(tmp$ret$2);
  }
  return destination;
};
protoOf(ExpenditureInsights).yy = function (points, windows, $super) {
  windows = windows === VOID ? this.zv_1 : windows;
  return $super === VOID ? this.wy(points, windows) : $super.wy.call(this, points, windows);
};
protoOf(ExpenditureInsights).xy = function (points, days) {
  // Inline function 'kotlin.require' call
  if (!(days > 0)) {
    var message = 'days must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0_elvis_lhs = lastOrNull(points);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var last = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = points.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.pm_1 === (last.pm_1 - days | 0)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$2;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var start = tmp_0;
  return last.qm_1 - start.qm_1;
};
protoOf(ExpenditureInsights).zy = function (points) {
  if (points.o() < 2)
    return null;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var progression = until(1, points.o());
  var inductionVariable = progression.oc_1;
  var last = progression.pc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = sum;
      var it = element;
      // Inline function 'kotlin.math.abs' call
      var x = points.n(it).qm_1 - points.n(it - 1 | 0).qm_1;
      sum = tmp + Math.abs(x);
    }
     while (!(element === last));
  return sum / (points.o() - 1 | 0);
};
var ExpenditureInsights_instance;
function ExpenditureInsights_getInstance() {
  if (ExpenditureInsights_instance == null)
    new ExpenditureInsights();
  return ExpenditureInsights_instance;
}
function ExpenditureBand(days, settledKcal, responsiveKcal) {
  this.az_1 = days;
  this.bz_1 = settledKcal;
  this.cz_1 = responsiveKcal;
}
protoOf(ExpenditureBand).toString = function () {
  return 'ExpenditureBand(days=' + toString(this.az_1) + ', settledKcal=' + toString(this.bz_1) + ', responsiveKcal=' + toString(this.cz_1) + ')';
};
protoOf(ExpenditureBand).hashCode = function () {
  var result = hashCode(this.az_1);
  result = imul(result, 31) + hashCode(this.bz_1) | 0;
  result = imul(result, 31) + hashCode(this.cz_1) | 0;
  return result;
};
protoOf(ExpenditureBand).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureBand))
    return false;
  if (!equals(this.az_1, other.az_1))
    return false;
  if (!equals(this.bz_1, other.bz_1))
    return false;
  if (!equals(this.cz_1, other.cz_1))
    return false;
  return true;
};
function band$run($initialKcal, $startDay, $endDay, $weighIns, $intake, $kcalPerKg, $goalChanges, $params, $terms, $inputs, $floorKcal, scale) {
  return ExpenditureV2_instance.tl($initialKcal, $startDay, $endDay, $weighIns, $intake, $kcalPerKg, $goalChanges, $params.uz(VOID, VOID, VOID, VOID, $params.hz_1 * scale), $terms, $inputs, $floorKcal);
}
function ExpenditureV2() {
  this.rl_1 = 0.5;
  this.sl_1 = 2.0;
}
protoOf(ExpenditureV2).tl = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal) {
  return StateSpaceExpenditure_instance.vz(initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal);
};
protoOf(ExpenditureV2).ul = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal) {
  var settled = band$run(initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal, 0.5);
  var responsive = band$run(initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal, 2.0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(settled, 10));
  var _iterator__ex2g4s = settled.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.pm_1;
    destination.f(tmp$ret$2);
  }
  var tmp = destination;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(settled, 10));
  var _iterator__ex2g4s_0 = settled.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.qm_1;
    destination_0.f(tmp$ret$5);
  }
  var tmp_0 = destination_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(responsive, 10));
  var _iterator__ex2g4s_1 = responsive.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$8 = item_1.qm_1;
    destination_1.f(tmp$ret$8);
  }
  return new ExpenditureBand(tmp, tmp_0, destination_1);
};
var ExpenditureV2_instance;
function ExpenditureV2_getInstance() {
  return ExpenditureV2_instance;
}
function GoalAdjustmentParams(multiplier, days, capped, capPerDayKcal, budgetKcal, refillKcalPerDay, floorMarginKcal) {
  multiplier = multiplier === VOID ? 4.0 : multiplier;
  days = days === VOID ? 14 : days;
  capped = capped === VOID ? false : capped;
  capPerDayKcal = capPerDayKcal === VOID ? 25.0 : capPerDayKcal;
  budgetKcal = budgetKcal === VOID ? 300.0 : budgetKcal;
  refillKcalPerDay = refillKcalPerDay === VOID ? 5.0 : refillKcalPerDay;
  floorMarginKcal = floorMarginKcal === VOID ? 0.0 : floorMarginKcal;
  this.wz_1 = multiplier;
  this.xz_1 = days;
  this.yz_1 = capped;
  this.zz_1 = capPerDayKcal;
  this.a10_1 = budgetKcal;
  this.b10_1 = refillKcalPerDay;
  this.c10_1 = floorMarginKcal;
  // Inline function 'kotlin.require' call
  if (!(this.xz_1 > 0)) {
    var message = 'days must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.zz_1 >= 0.0 && this.a10_1 >= 0.0 && this.b10_1 >= 0.0 && this.c10_1 >= 0.0)) {
    var message_0 = 'caps must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(GoalAdjustmentParams).toString = function () {
  return 'GoalAdjustmentParams(multiplier=' + this.wz_1 + ', days=' + this.xz_1 + ', capped=' + this.yz_1 + ', capPerDayKcal=' + this.zz_1 + ', budgetKcal=' + this.a10_1 + ', refillKcalPerDay=' + this.b10_1 + ', floorMarginKcal=' + this.c10_1 + ')';
};
protoOf(GoalAdjustmentParams).hashCode = function () {
  var result = getNumberHashCode(this.wz_1);
  result = imul(result, 31) + this.xz_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.yz_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.zz_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.a10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.b10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.c10_1) | 0;
  return result;
};
protoOf(GoalAdjustmentParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalAdjustmentParams))
    return false;
  if (!equals(this.wz_1, other.wz_1))
    return false;
  if (!(this.xz_1 === other.xz_1))
    return false;
  if (!(this.yz_1 === other.yz_1))
    return false;
  if (!equals(this.zz_1, other.zz_1))
    return false;
  if (!equals(this.a10_1, other.a10_1))
    return false;
  if (!equals(this.b10_1, other.b10_1))
    return false;
  if (!equals(this.c10_1, other.c10_1))
    return false;
  return true;
};
function GoalStart(day, ratePctPerWeek) {
  this.d10_1 = day;
  this.e10_1 = ratePctPerWeek;
}
protoOf(GoalStart).toString = function () {
  return 'GoalStart(day=' + this.d10_1 + ', ratePctPerWeek=' + this.e10_1 + ')';
};
protoOf(GoalStart).hashCode = function () {
  var result = this.d10_1;
  result = imul(result, 31) + getNumberHashCode(this.e10_1) | 0;
  return result;
};
protoOf(GoalStart).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GoalStart))
    return false;
  if (!(this.d10_1 === other.d10_1))
    return false;
  if (!equals(this.e10_1, other.e10_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_2(function_0) {
  this.f10_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_2).y9 = function (a, b) {
  return this.f10_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_2).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_2).g2 = function () {
  return this.f10_1;
};
protoOf(sam$kotlin_Comparator$0_2).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_2).hashCode = function () {
  return hashCode(this.g2());
};
function GoalAdjuster$Companion$changes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.d10_1;
  var tmp$ret$2 = b.d10_1;
  return compareValues(tmp, tmp$ret$2);
}
function capped($this, wanted, running, held, estimate, floorKcal) {
  if (!running) {
    var tmp = $this;
    var tmp0 = $this.lx_1.a10_1;
    // Inline function 'kotlin.math.min' call
    var b = $this.ox_1 + $this.lx_1.b10_1;
    tmp.ox_1 = Math.min(tmp0, b);
    var tmp_0 = $this;
    var tmp0_0 = $this.lx_1.a10_1;
    // Inline function 'kotlin.math.min' call
    var b_0 = $this.px_1 + $this.lx_1.b10_1;
    tmp_0.px_1 = Math.min(tmp0_0, b_0);
    return 0.0;
  }
  if (held || wanted === 0.0)
    return 0.0;
  var step = coerceIn(wanted, -$this.lx_1.zz_1, $this.lx_1.zz_1);
  if (step > 0.0) {
    var tmp0_1 = step;
    // Inline function 'kotlin.math.min' call
    var b_1 = $this.ox_1;
    step = Math.min(tmp0_1, b_1);
    $this.ox_1 = $this.ox_1 - step;
  } else {
    if (!(floorKcal == null) && estimate + step < floorKcal + $this.lx_1.c10_1)
      return 0.0;
    // Inline function 'kotlin.math.abs' call
    var x = step;
    var tmp0_2 = Math.abs(x);
    // Inline function 'kotlin.math.min' call
    var b_2 = $this.px_1;
    step = -Math.min(tmp0_2, b_2);
    var tmp_1 = $this;
    var tmp_2 = $this.px_1;
    // Inline function 'kotlin.math.abs' call
    var x_0 = step;
    tmp_1.px_1 = tmp_2 - Math.abs(x_0);
  }
  return step;
}
function Active(perDay, remaining) {
  this.g10_1 = perDay;
  this.h10_1 = remaining;
}
function Companion_2() {
}
protoOf(Companion_2).an = function (starts) {
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = GoalAdjuster$Companion$changes$lambda;
  var tmp$ret$1 = new sam$kotlin_Comparator$0_2(tmp);
  var sorted = sortedWith(starts, tmp$ret$1);
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = zipWithNext(sorted);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var previous = element.ya();
    var current = element.za();
    var tmp0_safe_receiver = current.e10_1 === previous.e10_1 ? null : new GoalChange(current.d10_1, previous.e10_1, current.e10_1);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
};
var Companion_instance_4;
function Companion_getInstance_2() {
  return Companion_instance_4;
}
function GoalAdjuster(changes, params) {
  params = params === VOID ? new GoalAdjustmentParams() : params;
  this.lx_1 = params;
  var tmp = this;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = changes.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key = element.tw_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.s1(key);
    var tmp_0;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.k2(key, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
    var list = tmp_0;
    list.f(element);
  }
  tmp.mx_1 = destination;
  var tmp_1 = this;
  // Inline function 'kotlin.collections.mutableListOf' call
  tmp_1.nx_1 = ArrayList_init_$Create$_0();
  this.ox_1 = this.lx_1.a10_1;
  this.px_1 = this.lx_1.a10_1;
  this.qx_1 = 0.0;
}
protoOf(GoalAdjuster).rx = function (day, estimate, held, floorKcal) {
  var tmp0_safe_receiver = this.mx_1.s1(day);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s = tmp0_safe_receiver.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      var total = estimate * this.lx_1.wz_1 * (element.vw_1 - element.uw_1) / 100.0;
      this.nx_1.f(new Active(total / this.lx_1.xz_1, this.lx_1.xz_1));
    }
  }
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s_0 = this.nx_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp = sum;
    sum = tmp + element_0.g10_1;
  }
  var wanted = sum;
  // Inline function 'kotlin.collections.isNotEmpty' call
  var running = !this.nx_1.m();
  var iterator = this.nx_1.j();
  while (iterator.k()) {
    var adjustment = iterator.l();
    adjustment.h10_1 = adjustment.h10_1 - 1 | 0;
    if (adjustment.h10_1 <= 0) {
      iterator.q2();
    }
  }
  this.qx_1 = this.lx_1.yz_1 ? capped(this, wanted, running, held, estimate, floorKcal) : wanted;
  return this.qx_1;
};
var static_init_called_24;
function static_init_24() {
  if (static_init_called_24)
    return Unit_instance;
  static_init_called_24 = true;
  Sex_MALE_instance = new Sex('MALE', 0);
  Sex_FEMALE_instance = new Sex('FEMALE', 1);
}
var Sex_MALE_instance;
var Sex_FEMALE_instance;
function values_16() {
  static_init_24();
  return [Sex_MALE_getInstance(), Sex_FEMALE_getInstance()];
}
function valueOf_7(value) {
  static_init_24();
  switch (value) {
    case 'MALE':
      return Sex_MALE_getInstance();
    case 'FEMALE':
      return Sex_FEMALE_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.energy.Sex.' + value);
      break;
  }
}
function get_entries_11() {
  static_init_24();
  if ($ENTRIES_11 == null)
    $ENTRIES_11 = enumEntries(values_16());
  return $ENTRIES_11;
}
var $ENTRIES_11;
function Sex(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_25;
function static_init_25() {
  if (static_init_called_25)
    return Unit_instance;
  static_init_called_25 = true;
  Ethnicity_SOUTH_ASIAN_instance = new Ethnicity('SOUTH_ASIAN', 0);
  Ethnicity_CHINESE_instance = new Ethnicity('CHINESE', 1);
  Ethnicity_OTHER_ASIAN_instance = new Ethnicity('OTHER_ASIAN', 2);
  Ethnicity_BLACK_AFRICAN_instance = new Ethnicity('BLACK_AFRICAN', 3);
  Ethnicity_BLACK_CARIBBEAN_instance = new Ethnicity('BLACK_CARIBBEAN', 4);
  Ethnicity_MIDDLE_EASTERN_instance = new Ethnicity('MIDDLE_EASTERN', 5);
  Ethnicity_WHITE_OR_OTHER_instance = new Ethnicity('WHITE_OR_OTHER', 6);
  Ethnicity_PREFER_NOT_TO_SAY_instance = new Ethnicity('PREFER_NOT_TO_SAY', 7);
}
var Ethnicity_SOUTH_ASIAN_instance;
var Ethnicity_CHINESE_instance;
var Ethnicity_OTHER_ASIAN_instance;
var Ethnicity_BLACK_AFRICAN_instance;
var Ethnicity_BLACK_CARIBBEAN_instance;
var Ethnicity_MIDDLE_EASTERN_instance;
var Ethnicity_WHITE_OR_OTHER_instance;
var Ethnicity_PREFER_NOT_TO_SAY_instance;
function values_17() {
  static_init_25();
  return [Ethnicity_SOUTH_ASIAN_getInstance(), Ethnicity_CHINESE_getInstance(), Ethnicity_OTHER_ASIAN_getInstance(), Ethnicity_BLACK_AFRICAN_getInstance(), Ethnicity_BLACK_CARIBBEAN_getInstance(), Ethnicity_MIDDLE_EASTERN_getInstance(), Ethnicity_WHITE_OR_OTHER_getInstance(), Ethnicity_PREFER_NOT_TO_SAY_getInstance()];
}
function get_entries_12() {
  static_init_25();
  if ($ENTRIES_12 == null)
    $ENTRIES_12 = enumEntries(values_17());
  return $ENTRIES_12;
}
var $ENTRIES_12;
function Ethnicity(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_26;
function static_init_26() {
  if (static_init_called_26)
    return Unit_instance;
  static_init_called_26 = true;
  ActivityLevel_SEDENTARY_instance = new ActivityLevel('SEDENTARY', 0, 1.2);
  ActivityLevel_LIGHT_instance = new ActivityLevel('LIGHT', 1, 1.375);
  ActivityLevel_MODERATE_instance = new ActivityLevel('MODERATE', 2, 1.55);
  ActivityLevel_VERY_instance = new ActivityLevel('VERY', 3, 1.725);
  ActivityLevel_EXTREME_instance = new ActivityLevel('EXTREME', 4, 1.9);
}
var ActivityLevel_SEDENTARY_instance;
var ActivityLevel_LIGHT_instance;
var ActivityLevel_MODERATE_instance;
var ActivityLevel_VERY_instance;
var ActivityLevel_EXTREME_instance;
function values_18() {
  static_init_26();
  return [ActivityLevel_SEDENTARY_getInstance(), ActivityLevel_LIGHT_getInstance(), ActivityLevel_MODERATE_getInstance(), ActivityLevel_VERY_getInstance(), ActivityLevel_EXTREME_getInstance()];
}
function valueOf_8(value) {
  static_init_26();
  switch (value) {
    case 'SEDENTARY':
      return ActivityLevel_SEDENTARY_getInstance();
    case 'LIGHT':
      return ActivityLevel_LIGHT_getInstance();
    case 'MODERATE':
      return ActivityLevel_MODERATE_getInstance();
    case 'VERY':
      return ActivityLevel_VERY_getInstance();
    case 'EXTREME':
      return ActivityLevel_EXTREME_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.energy.ActivityLevel.' + value);
      break;
  }
}
function get_entries_13() {
  static_init_26();
  if ($ENTRIES_13 == null)
    $ENTRIES_13 = enumEntries(values_18());
  return $ENTRIES_13;
}
var $ENTRIES_13;
function ActivityLevel(name, ordinal, factor) {
  Enum.call(this, name, ordinal);
  this.k10_1 = factor;
}
var static_init_called_27;
function static_init_27() {
  if (static_init_called_27)
    return Unit_instance;
  static_init_called_27 = true;
  BmrEquation_AUTO_instance = new BmrEquation('AUTO', 0);
  BmrEquation_KATCH_instance = new BmrEquation('KATCH', 1);
  BmrEquation_MIFFLIN_instance = new BmrEquation('MIFFLIN', 2);
  BmrEquation_CUNNINGHAM_instance = new BmrEquation('CUNNINGHAM', 3);
  BmrEquation_TEN_HAAF_instance = new BmrEquation('TEN_HAAF', 4);
}
var BmrEquation_AUTO_instance;
var BmrEquation_KATCH_instance;
var BmrEquation_MIFFLIN_instance;
var BmrEquation_CUNNINGHAM_instance;
var BmrEquation_TEN_HAAF_instance;
function values_19() {
  static_init_27();
  return [BmrEquation_AUTO_getInstance(), BmrEquation_KATCH_getInstance(), BmrEquation_MIFFLIN_getInstance(), BmrEquation_CUNNINGHAM_getInstance(), BmrEquation_TEN_HAAF_getInstance()];
}
function get_entries_14() {
  static_init_27();
  if ($ENTRIES_14 == null)
    $ENTRIES_14 = enumEntries(values_19());
  return $ENTRIES_14;
}
var $ENTRIES_14;
function BmrEquation(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_28;
function static_init_28() {
  if (static_init_called_28)
    return Unit_instance;
  static_init_called_28 = true;
  DailyActivity_SEDENTARY_instance = new DailyActivity('SEDENTARY', 0, 1.2);
  DailyActivity_MODERATE_instance = new DailyActivity('MODERATE', 1, 1.4);
  DailyActivity_VERY_instance = new DailyActivity('VERY', 2, 1.6);
}
var DailyActivity_SEDENTARY_instance;
var DailyActivity_MODERATE_instance;
var DailyActivity_VERY_instance;
function values_20() {
  static_init_28();
  return [DailyActivity_SEDENTARY_getInstance(), DailyActivity_MODERATE_getInstance(), DailyActivity_VERY_getInstance()];
}
function get_entries_15() {
  static_init_28();
  if ($ENTRIES_15 == null)
    $ENTRIES_15 = enumEntries(values_20());
  return $ENTRIES_15;
}
var $ENTRIES_15;
function DailyActivity(name, ordinal, factor) {
  Enum.call(this, name, ordinal);
  this.n10_1 = factor;
}
var static_init_called_29;
function static_init_29() {
  if (static_init_called_29)
    return Unit_instance;
  static_init_called_29 = true;
  ExerciseSessions_NONE_instance = new ExerciseSessions('NONE', 0, 0.0);
  ExerciseSessions_ONE_TO_THREE_instance = new ExerciseSessions('ONE_TO_THREE', 1, 0.1);
  ExerciseSessions_FOUR_TO_SIX_instance = new ExerciseSessions('FOUR_TO_SIX', 2, 0.2);
  ExerciseSessions_SEVEN_PLUS_instance = new ExerciseSessions('SEVEN_PLUS', 3, 0.3);
}
var ExerciseSessions_NONE_instance;
var ExerciseSessions_ONE_TO_THREE_instance;
var ExerciseSessions_FOUR_TO_SIX_instance;
var ExerciseSessions_SEVEN_PLUS_instance;
function values_21() {
  static_init_29();
  return [ExerciseSessions_NONE_getInstance(), ExerciseSessions_ONE_TO_THREE_getInstance(), ExerciseSessions_FOUR_TO_SIX_getInstance(), ExerciseSessions_SEVEN_PLUS_getInstance()];
}
function get_entries_16() {
  static_init_29();
  if ($ENTRIES_16 == null)
    $ENTRIES_16 = enumEntries(values_21());
  return $ENTRIES_16;
}
var $ENTRIES_16;
function ExerciseSessions(name, ordinal, add) {
  Enum.call(this, name, ordinal);
  this.q10_1 = add;
}
function InitialExpenditureOptions(bmrEquation, dailyActivity, exerciseSessions, recentlyLosing) {
  bmrEquation = bmrEquation === VOID ? BmrEquation_AUTO_getInstance() : bmrEquation;
  dailyActivity = dailyActivity === VOID ? null : dailyActivity;
  exerciseSessions = exerciseSessions === VOID ? ExerciseSessions_NONE_getInstance() : exerciseSessions;
  recentlyLosing = recentlyLosing === VOID ? false : recentlyLosing;
  this.kf_1 = bmrEquation;
  this.lf_1 = dailyActivity;
  this.mf_1 = exerciseSessions;
  this.nf_1 = recentlyLosing;
}
protoOf(InitialExpenditureOptions).r10 = function (bmrEquation, dailyActivity, exerciseSessions, recentlyLosing) {
  return new InitialExpenditureOptions(bmrEquation, dailyActivity, exerciseSessions, recentlyLosing);
};
protoOf(InitialExpenditureOptions).of = function (bmrEquation, dailyActivity, exerciseSessions, recentlyLosing, $super) {
  bmrEquation = bmrEquation === VOID ? this.kf_1 : bmrEquation;
  dailyActivity = dailyActivity === VOID ? this.lf_1 : dailyActivity;
  exerciseSessions = exerciseSessions === VOID ? this.mf_1 : exerciseSessions;
  recentlyLosing = recentlyLosing === VOID ? this.nf_1 : recentlyLosing;
  return $super === VOID ? this.r10(bmrEquation, dailyActivity, exerciseSessions, recentlyLosing) : $super.r10.call(this, bmrEquation, dailyActivity, exerciseSessions, recentlyLosing);
};
protoOf(InitialExpenditureOptions).toString = function () {
  return 'InitialExpenditureOptions(bmrEquation=' + this.kf_1.toString() + ', dailyActivity=' + toString_0(this.lf_1) + ', exerciseSessions=' + this.mf_1.toString() + ', recentlyLosing=' + this.nf_1 + ')';
};
protoOf(InitialExpenditureOptions).hashCode = function () {
  var result = this.kf_1.hashCode();
  result = imul(result, 31) + (this.lf_1 == null ? 0 : this.lf_1.hashCode()) | 0;
  result = imul(result, 31) + this.mf_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.nf_1) | 0;
  return result;
};
protoOf(InitialExpenditureOptions).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof InitialExpenditureOptions))
    return false;
  if (!this.kf_1.equals(other.kf_1))
    return false;
  if (!equals(this.lf_1, other.lf_1))
    return false;
  if (!this.mf_1.equals(other.mf_1))
    return false;
  if (!(this.nf_1 === other.nf_1))
    return false;
  return true;
};
function InitialExpenditure() {
  this.cm_1 = 100.0;
  this.dm_1 = 0.95;
}
protoOf(InitialExpenditure).s10 = function (leanMassKg) {
  // Inline function 'kotlin.comparisons.minOf' call
  return 500.0 + 22.0 * Math.min(leanMassKg, 100.0);
};
protoOf(InitialExpenditure).t10 = function (recentlyLosing) {
  return recentlyLosing ? 0.95 : 1.0;
};
protoOf(InitialExpenditure).u10 = function (daily, sessions) {
  return daily.n10_1 + sessions.q10_1;
};
protoOf(InitialExpenditure).em = function (sex, weightKg, heightCm, ageYears, activity, bodyFatFraction, options, waistCm) {
  var tmp0_safe_receiver = options.lf_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = InitialExpenditure_instance.u10(tmp0_safe_receiver, options.mf_1);
  }
  var tmp1_elvis_lhs = tmp;
  var factor = tmp1_elvis_lhs == null ? activity.k10_1 : tmp1_elvis_lhs;
  return this.om(sex, weightKg, heightCm, ageYears, bodyFatFraction, options, waistCm) * factor;
};
protoOf(InitialExpenditure).om = function (sex, weightKg, heightCm, ageYears, bodyFatFraction, options, waistCm) {
  var fat = bodyFatFraction == null ? BodyComposition_instance.im(sex, ageYears, weightKg, heightCm, waistCm) : bodyFatFraction;
  var lean = weightKg * (1.0 - fat);
  var tmp;
  switch (options.kf_1.x1_1) {
    case 0:
      tmp = !(bodyFatFraction == null) ? this.sy(lean) : this.v10(sex, weightKg, heightCm, ageYears);
      break;
    case 1:
      tmp = this.sy(lean);
      break;
    case 2:
      tmp = this.v10(sex, weightKg, heightCm, ageYears);
      break;
    case 3:
      tmp = this.s10(lean);
      break;
    case 4:
      tmp = this.w10(sex, weightKg, heightCm, ageYears);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var bmr = tmp;
  return bmr * this.t10(options.nf_1);
};
protoOf(InitialExpenditure).fm = function (importedKcal, lastOwnKcal, formulaKcal) {
  var tmp1_elvis_lhs = importedKcal == null ? lastOwnKcal : importedKcal;
  return tmp1_elvis_lhs == null ? formulaKcal : tmp1_elvis_lhs;
};
protoOf(InitialExpenditure).v10 = function (sex, weightKg, heightCm, ageYears) {
  var base = 10.0 * weightKg + 6.25 * heightCm - 5.0 * ageYears;
  var tmp;
  switch (sex.x1_1) {
    case 0:
      tmp = base + 5.0;
      break;
    case 1:
      tmp = base - 161.0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(InitialExpenditure).sy = function (leanMassKg) {
  return 370.0 + 21.6 * leanMassKg;
};
protoOf(InitialExpenditure).w10 = function (sex, weightKg, heightCm, ageYears) {
  var male = sex.equals(Sex_MALE_getInstance()) ? 1.0 : 0.0;
  return 11.936 * weightKg + 587.728 * (heightCm / 100.0) - 8.129 * ageYears + 191.027 * male + 29.279;
};
var InitialExpenditure_instance;
function InitialExpenditure_getInstance() {
  return InitialExpenditure_instance;
}
function Sex_MALE_getInstance() {
  static_init_24();
  return Sex_MALE_instance;
}
function Sex_FEMALE_getInstance() {
  static_init_24();
  return Sex_FEMALE_instance;
}
function Ethnicity_SOUTH_ASIAN_getInstance() {
  static_init_25();
  return Ethnicity_SOUTH_ASIAN_instance;
}
function Ethnicity_CHINESE_getInstance() {
  static_init_25();
  return Ethnicity_CHINESE_instance;
}
function Ethnicity_OTHER_ASIAN_getInstance() {
  static_init_25();
  return Ethnicity_OTHER_ASIAN_instance;
}
function Ethnicity_BLACK_AFRICAN_getInstance() {
  static_init_25();
  return Ethnicity_BLACK_AFRICAN_instance;
}
function Ethnicity_BLACK_CARIBBEAN_getInstance() {
  static_init_25();
  return Ethnicity_BLACK_CARIBBEAN_instance;
}
function Ethnicity_MIDDLE_EASTERN_getInstance() {
  static_init_25();
  return Ethnicity_MIDDLE_EASTERN_instance;
}
function Ethnicity_WHITE_OR_OTHER_getInstance() {
  static_init_25();
  return Ethnicity_WHITE_OR_OTHER_instance;
}
function Ethnicity_PREFER_NOT_TO_SAY_getInstance() {
  static_init_25();
  return Ethnicity_PREFER_NOT_TO_SAY_instance;
}
function ActivityLevel_SEDENTARY_getInstance() {
  static_init_26();
  return ActivityLevel_SEDENTARY_instance;
}
function ActivityLevel_LIGHT_getInstance() {
  static_init_26();
  return ActivityLevel_LIGHT_instance;
}
function ActivityLevel_MODERATE_getInstance() {
  static_init_26();
  return ActivityLevel_MODERATE_instance;
}
function ActivityLevel_VERY_getInstance() {
  static_init_26();
  return ActivityLevel_VERY_instance;
}
function ActivityLevel_EXTREME_getInstance() {
  static_init_26();
  return ActivityLevel_EXTREME_instance;
}
function BmrEquation_AUTO_getInstance() {
  static_init_27();
  return BmrEquation_AUTO_instance;
}
function BmrEquation_KATCH_getInstance() {
  static_init_27();
  return BmrEquation_KATCH_instance;
}
function BmrEquation_MIFFLIN_getInstance() {
  static_init_27();
  return BmrEquation_MIFFLIN_instance;
}
function BmrEquation_CUNNINGHAM_getInstance() {
  static_init_27();
  return BmrEquation_CUNNINGHAM_instance;
}
function BmrEquation_TEN_HAAF_getInstance() {
  static_init_27();
  return BmrEquation_TEN_HAAF_instance;
}
function DailyActivity_SEDENTARY_getInstance() {
  static_init_28();
  return DailyActivity_SEDENTARY_instance;
}
function DailyActivity_MODERATE_getInstance() {
  static_init_28();
  return DailyActivity_MODERATE_instance;
}
function DailyActivity_VERY_getInstance() {
  static_init_28();
  return DailyActivity_VERY_instance;
}
function ExerciseSessions_NONE_getInstance() {
  static_init_29();
  return ExerciseSessions_NONE_instance;
}
function ExerciseSessions_ONE_TO_THREE_getInstance() {
  static_init_29();
  return ExerciseSessions_ONE_TO_THREE_instance;
}
function ExerciseSessions_FOUR_TO_SIX_getInstance() {
  static_init_29();
  return ExerciseSessions_FOUR_TO_SIX_instance;
}
function ExerciseSessions_SEVEN_PLUS_getInstance() {
  static_init_29();
  return ExerciseSessions_SEVEN_PLUS_instance;
}
var static_init_called_30;
function static_init_30() {
  if (static_init_called_30)
    return Unit_instance;
  static_init_called_30 = true;
  IntakePrior_RECENT_MEAN_instance = new IntakePrior('RECENT_MEAN', 0);
  IntakePrior_EXPENDITURE_instance = new IntakePrior('EXPENDITURE', 1);
}
var IntakePrior_RECENT_MEAN_instance;
var IntakePrior_EXPENDITURE_instance;
function values_22() {
  static_init_30();
  return [IntakePrior_RECENT_MEAN_getInstance(), IntakePrior_EXPENDITURE_getInstance()];
}
function get_entries_17() {
  static_init_30();
  if ($ENTRIES_17 == null)
    $ENTRIES_17 = enumEntries(values_22());
  return $ENTRIES_17;
}
var $ENTRIES_17;
function IntakePrior(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function StateSpaceParams(scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment) {
  scaleNoiseKg = scaleNoiseKg === VOID ? 0.4 : scaleNoiseKg;
  waterSdKg = waterSdKg === VOID ? 0.4 : waterSdKg;
  waterHalfLifeDays = waterHalfLifeDays === VOID ? 4.0 : waterHalfLifeDays;
  tissueNoiseKg = tissueNoiseKg === VOID ? 0.01 : tissueNoiseKg;
  expenditureNoiseKcal = expenditureNoiseKcal === VOID ? 15.0 : expenditureNoiseKcal;
  initialUncertaintyKcal = initialUncertaintyKcal === VOID ? 350.0 : initialUncertaintyKcal;
  initialWeightSdKg = initialWeightSdKg === VOID ? 0.5 : initialWeightSdKg;
  loggedIntakeRelativeNoise = loggedIntakeRelativeNoise === VOID ? 0.1 : loggedIntakeRelativeNoise;
  unknownIntakeSdKcal = unknownIntakeSdKcal === VOID ? 600.0 : unknownIntakeSdKcal;
  unknownIntakeWindowDays = unknownIntakeWindowDays === VOID ? 14 : unknownIntakeWindowDays;
  intakePrior = intakePrior === VOID ? IntakePrior_RECENT_MEAN_getInstance() : intakePrior;
  firstUpdateAfterDays = firstUpdateAfterDays === VOID ? 2 : firstUpdateAfterDays;
  minUsableIntakeDaysInLastWeek = minUsableIntakeDaysInLastWeek === VOID ? 4 : minUsableIntakeDaysInLastWeek;
  maxDaysSinceWeighIn = maxDaysSinceWeighIn === VOID ? 7 : maxDaysSinceWeighIn;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? false : holdAfterLastWeighIn;
  gainKcalPerKg = gainKcalPerKg === VOID ? null : gainKcalPerKg;
  goalAdjustment = goalAdjustment === VOID ? new GoalAdjustmentParams() : goalAdjustment;
  this.dz_1 = scaleNoiseKg;
  this.ez_1 = waterSdKg;
  this.fz_1 = waterHalfLifeDays;
  this.gz_1 = tissueNoiseKg;
  this.hz_1 = expenditureNoiseKcal;
  this.iz_1 = initialUncertaintyKcal;
  this.jz_1 = initialWeightSdKg;
  this.kz_1 = loggedIntakeRelativeNoise;
  this.lz_1 = unknownIntakeSdKcal;
  this.mz_1 = unknownIntakeWindowDays;
  this.nz_1 = intakePrior;
  this.oz_1 = firstUpdateAfterDays;
  this.pz_1 = minUsableIntakeDaysInLastWeek;
  this.qz_1 = maxDaysSinceWeighIn;
  this.rz_1 = holdAfterLastWeighIn;
  this.sz_1 = gainKcalPerKg;
  this.tz_1 = goalAdjustment;
  // Inline function 'kotlin.require' call
  if (!(this.dz_1 > 0.0 && this.ez_1 >= 0.0 && this.gz_1 >= 0.0 && this.hz_1 >= 0.0)) {
    var message = 'noise must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.fz_1 > 0.0 && this.iz_1 > 0.0 && this.jz_1 > 0.0)) {
    var message_0 = 'settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(this.kz_1 >= 0.0 && this.lz_1 > 0.0 && this.mz_1 > 0)) {
    var message_1 = 'intake settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
}
protoOf(StateSpaceParams).x10 = function (scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment) {
  return new StateSpaceParams(scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment);
};
protoOf(StateSpaceParams).uz = function (scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment, $super) {
  scaleNoiseKg = scaleNoiseKg === VOID ? this.dz_1 : scaleNoiseKg;
  waterSdKg = waterSdKg === VOID ? this.ez_1 : waterSdKg;
  waterHalfLifeDays = waterHalfLifeDays === VOID ? this.fz_1 : waterHalfLifeDays;
  tissueNoiseKg = tissueNoiseKg === VOID ? this.gz_1 : tissueNoiseKg;
  expenditureNoiseKcal = expenditureNoiseKcal === VOID ? this.hz_1 : expenditureNoiseKcal;
  initialUncertaintyKcal = initialUncertaintyKcal === VOID ? this.iz_1 : initialUncertaintyKcal;
  initialWeightSdKg = initialWeightSdKg === VOID ? this.jz_1 : initialWeightSdKg;
  loggedIntakeRelativeNoise = loggedIntakeRelativeNoise === VOID ? this.kz_1 : loggedIntakeRelativeNoise;
  unknownIntakeSdKcal = unknownIntakeSdKcal === VOID ? this.lz_1 : unknownIntakeSdKcal;
  unknownIntakeWindowDays = unknownIntakeWindowDays === VOID ? this.mz_1 : unknownIntakeWindowDays;
  intakePrior = intakePrior === VOID ? this.nz_1 : intakePrior;
  firstUpdateAfterDays = firstUpdateAfterDays === VOID ? this.oz_1 : firstUpdateAfterDays;
  minUsableIntakeDaysInLastWeek = minUsableIntakeDaysInLastWeek === VOID ? this.pz_1 : minUsableIntakeDaysInLastWeek;
  maxDaysSinceWeighIn = maxDaysSinceWeighIn === VOID ? this.qz_1 : maxDaysSinceWeighIn;
  holdAfterLastWeighIn = holdAfterLastWeighIn === VOID ? this.rz_1 : holdAfterLastWeighIn;
  gainKcalPerKg = gainKcalPerKg === VOID ? this.sz_1 : gainKcalPerKg;
  goalAdjustment = goalAdjustment === VOID ? this.tz_1 : goalAdjustment;
  return $super === VOID ? this.x10(scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment) : $super.x10.call(this, scaleNoiseKg, waterSdKg, waterHalfLifeDays, tissueNoiseKg, expenditureNoiseKcal, initialUncertaintyKcal, initialWeightSdKg, loggedIntakeRelativeNoise, unknownIntakeSdKcal, unknownIntakeWindowDays, intakePrior, firstUpdateAfterDays, minUsableIntakeDaysInLastWeek, maxDaysSinceWeighIn, holdAfterLastWeighIn, gainKcalPerKg, goalAdjustment);
};
protoOf(StateSpaceParams).toString = function () {
  return 'StateSpaceParams(scaleNoiseKg=' + this.dz_1 + ', waterSdKg=' + this.ez_1 + ', waterHalfLifeDays=' + this.fz_1 + ', tissueNoiseKg=' + this.gz_1 + ', expenditureNoiseKcal=' + this.hz_1 + ', initialUncertaintyKcal=' + this.iz_1 + ', initialWeightSdKg=' + this.jz_1 + ', loggedIntakeRelativeNoise=' + this.kz_1 + ', unknownIntakeSdKcal=' + this.lz_1 + ', unknownIntakeWindowDays=' + this.mz_1 + ', intakePrior=' + this.nz_1.toString() + ', firstUpdateAfterDays=' + this.oz_1 + ', minUsableIntakeDaysInLastWeek=' + this.pz_1 + ', maxDaysSinceWeighIn=' + this.qz_1 + ', holdAfterLastWeighIn=' + this.rz_1 + ', gainKcalPerKg=' + this.sz_1 + ', goalAdjustment=' + this.tz_1.toString() + ')';
};
protoOf(StateSpaceParams).hashCode = function () {
  var result = getNumberHashCode(this.dz_1);
  result = imul(result, 31) + getNumberHashCode(this.ez_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.fz_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.gz_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.hz_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.iz_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.jz_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.kz_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.lz_1) | 0;
  result = imul(result, 31) + this.mz_1 | 0;
  result = imul(result, 31) + this.nz_1.hashCode() | 0;
  result = imul(result, 31) + this.oz_1 | 0;
  result = imul(result, 31) + this.pz_1 | 0;
  result = imul(result, 31) + this.qz_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.rz_1) | 0;
  result = imul(result, 31) + (this.sz_1 == null ? 0 : getNumberHashCode(this.sz_1)) | 0;
  result = imul(result, 31) + this.tz_1.hashCode() | 0;
  return result;
};
protoOf(StateSpaceParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StateSpaceParams))
    return false;
  if (!equals(this.dz_1, other.dz_1))
    return false;
  if (!equals(this.ez_1, other.ez_1))
    return false;
  if (!equals(this.fz_1, other.fz_1))
    return false;
  if (!equals(this.gz_1, other.gz_1))
    return false;
  if (!equals(this.hz_1, other.hz_1))
    return false;
  if (!equals(this.iz_1, other.iz_1))
    return false;
  if (!equals(this.jz_1, other.jz_1))
    return false;
  if (!equals(this.kz_1, other.kz_1))
    return false;
  if (!equals(this.lz_1, other.lz_1))
    return false;
  if (!(this.mz_1 === other.mz_1))
    return false;
  if (!this.nz_1.equals(other.nz_1))
    return false;
  if (!(this.oz_1 === other.oz_1))
    return false;
  if (!(this.pz_1 === other.pz_1))
    return false;
  if (!(this.qz_1 === other.qz_1))
    return false;
  if (!(this.rz_1 === other.rz_1))
    return false;
  if (!equals(this.sz_1, other.sz_1))
    return false;
  if (!this.tz_1.equals(other.tz_1))
    return false;
  return true;
};
function Companion_3() {
  Companion_instance_5 = this;
  this.qk_1 = new ExpenditureV2Terms();
  this.rk_1 = new ExpenditureV2Terms(0.5, 1.0, 5.0E-4, 6.0E-5, 1.0);
}
var Companion_instance_5;
function Companion_getInstance_3() {
  if (Companion_instance_5 == null)
    new Companion_3();
  return Companion_instance_5;
}
function ExpenditureV2Terms(adaptation, massScaling, carbsWaterKgPerG, sodiumWaterKgPerMg, stepsFlexibility, setsFlexibility, creatineWaterKg, creatineDays, baselineDays) {
  Companion_getInstance_3();
  adaptation = adaptation === VOID ? 0.0 : adaptation;
  massScaling = massScaling === VOID ? 0.0 : massScaling;
  carbsWaterKgPerG = carbsWaterKgPerG === VOID ? 0.0 : carbsWaterKgPerG;
  sodiumWaterKgPerMg = sodiumWaterKgPerMg === VOID ? 0.0 : sodiumWaterKgPerMg;
  stepsFlexibility = stepsFlexibility === VOID ? 0.0 : stepsFlexibility;
  setsFlexibility = setsFlexibility === VOID ? 0.0 : setsFlexibility;
  creatineWaterKg = creatineWaterKg === VOID ? 0.0 : creatineWaterKg;
  creatineDays = creatineDays === VOID ? 14 : creatineDays;
  baselineDays = baselineDays === VOID ? 14 : baselineDays;
  this.y10_1 = adaptation;
  this.z10_1 = massScaling;
  this.a11_1 = carbsWaterKgPerG;
  this.b11_1 = sodiumWaterKgPerMg;
  this.c11_1 = stepsFlexibility;
  this.d11_1 = setsFlexibility;
  this.e11_1 = creatineWaterKg;
  this.f11_1 = creatineDays;
  this.g11_1 = baselineDays;
  // Inline function 'kotlin.require' call
  if (!(this.c11_1 >= 0.0 && this.d11_1 >= 0.0)) {
    var message = 'flexibility must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.f11_1 > 0 && this.g11_1 > 0)) {
    var message_0 = 'windows must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(ExpenditureV2Terms).toString = function () {
  return 'ExpenditureV2Terms(adaptation=' + this.y10_1 + ', massScaling=' + this.z10_1 + ', carbsWaterKgPerG=' + this.a11_1 + ', sodiumWaterKgPerMg=' + this.b11_1 + ', stepsFlexibility=' + this.c11_1 + ', setsFlexibility=' + this.d11_1 + ', creatineWaterKg=' + this.e11_1 + ', creatineDays=' + this.f11_1 + ', baselineDays=' + this.g11_1 + ')';
};
protoOf(ExpenditureV2Terms).hashCode = function () {
  var result = getNumberHashCode(this.y10_1);
  result = imul(result, 31) + getNumberHashCode(this.z10_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.a11_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.b11_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.c11_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.d11_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.e11_1) | 0;
  result = imul(result, 31) + this.f11_1 | 0;
  result = imul(result, 31) + this.g11_1 | 0;
  return result;
};
protoOf(ExpenditureV2Terms).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExpenditureV2Terms))
    return false;
  if (!equals(this.y10_1, other.y10_1))
    return false;
  if (!equals(this.z10_1, other.z10_1))
    return false;
  if (!equals(this.a11_1, other.a11_1))
    return false;
  if (!equals(this.b11_1, other.b11_1))
    return false;
  if (!equals(this.c11_1, other.c11_1))
    return false;
  if (!equals(this.d11_1, other.d11_1))
    return false;
  if (!equals(this.e11_1, other.e11_1))
    return false;
  if (!(this.f11_1 === other.f11_1))
    return false;
  if (!(this.g11_1 === other.g11_1))
    return false;
  return true;
};
function DailyInputs(carbsG, sodiumMg, steps, hardSets, creatineStartDays) {
  carbsG = carbsG === VOID ? emptyMap() : carbsG;
  sodiumMg = sodiumMg === VOID ? emptyMap() : sodiumMg;
  steps = steps === VOID ? emptyMap() : steps;
  hardSets = hardSets === VOID ? emptyMap() : hardSets;
  creatineStartDays = creatineStartDays === VOID ? emptySet() : creatineStartDays;
  this.h11_1 = carbsG;
  this.i11_1 = sodiumMg;
  this.j11_1 = steps;
  this.k11_1 = hardSets;
  this.l11_1 = creatineStartDays;
}
protoOf(DailyInputs).toString = function () {
  return 'DailyInputs(carbsG=' + toString(this.h11_1) + ', sodiumMg=' + toString(this.i11_1) + ', steps=' + toString(this.j11_1) + ', hardSets=' + toString(this.k11_1) + ', creatineStartDays=' + toString(this.l11_1) + ')';
};
protoOf(DailyInputs).hashCode = function () {
  var result = hashCode(this.h11_1);
  result = imul(result, 31) + hashCode(this.i11_1) | 0;
  result = imul(result, 31) + hashCode(this.j11_1) | 0;
  result = imul(result, 31) + hashCode(this.k11_1) | 0;
  result = imul(result, 31) + hashCode(this.l11_1) | 0;
  return result;
};
protoOf(DailyInputs).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DailyInputs))
    return false;
  if (!equals(this.h11_1, other.h11_1))
    return false;
  if (!equals(this.i11_1, other.i11_1))
    return false;
  if (!equals(this.j11_1, other.j11_1))
    return false;
  if (!equals(this.k11_1, other.k11_1))
    return false;
  if (!equals(this.l11_1, other.l11_1))
    return false;
  return true;
};
function intakeFor($this, day, intakeByDay, expenditure, params) {
  var entry = intakeByDay.s1(day);
  if (!(entry == null) && entry.oj_1.equals(DayStatus_COMPLETE_getInstance())) {
    var sd = params.kz_1 * entry.nj_1;
    return to(entry.nj_1, sd * sd);
  }
  if (!(entry == null) && entry.oj_1.equals(DayStatus_FASTED_getInstance()))
    return to(0.0, 0.0);
  var tmp;
  if (params.nz_1.equals(IntakePrior_EXPENDITURE_getInstance())) {
    tmp = expenditure;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = until(day - params.mz_1 | 0, day);
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var inductionVariable = tmp0.oc_1;
    var last = tmp0.pc_1;
    if (inductionVariable <= last)
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var d = element;
        var tmp0_safe_receiver = intakeByDay.s1(d);
        var tmp_0;
        if (tmp0_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.let' call
          var tmp_1;
          switch (tmp0_safe_receiver.oj_1.x1_1) {
            case 0:
              tmp_1 = tmp0_safe_receiver.nj_1;
              break;
            case 2:
              tmp_1 = 0.0;
              break;
            case 1:
            case 3:
              tmp_1 = null;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp_0 = tmp_1;
        }
        var tmp0_safe_receiver_0 = tmp_0;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.f(tmp0_safe_receiver_0);
        }
      }
       while (!(element === last));
    var recent = destination;
    tmp = recent.m() ? expenditure : average(recent);
  }
  var prior = tmp;
  return to(prior, params.lz_1 * params.lz_1);
}
function waterInput($this, day, inputs, terms) {
  return waterInput$excess(day, terms, inputs.h11_1, terms.a11_1) + waterInput$excess(day, terms, inputs.i11_1, terms.b11_1);
}
function creatine($this, day, starts, terms) {
  var tmp;
  var tmp_0;
  if (!(terms.e11_1 === 0.0)) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_1;
      if (isInterface(starts, Collection)) {
        tmp_1 = starts.m();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = starts.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (day >= element && day < (element + terms.f11_1 | 0)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    tmp_0 = tmp$ret$0;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = terms.e11_1;
  } else {
    tmp = 0.0;
  }
  return tmp;
}
function relativeChange($this, day, series, gain) {
  if (gain === 0.0 || series.m())
    return 0.0;
  var tmp0_elvis_lhs = relativeChange$mean(series, day - 6 | 0, day);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return 0.0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var recent = tmp;
  var tmp1_elvis_lhs = relativeChange$mean(series, day - 13 | 0, day - 7 | 0);
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return 0.0;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var before = tmp_0;
  var tmp2_safe_receiver = relativeChange$mean(series, day - 27 | 0, day);
  var tmp_1;
  if (tmp2_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_2;
    if (tmp2_safe_receiver > 0.0) {
      tmp_2 = tmp2_safe_receiver;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  var tmp3_elvis_lhs = tmp_1;
  var tmp_3;
  if (tmp3_elvis_lhs == null) {
    return 0.0;
  } else {
    tmp_3 = tmp3_elvis_lhs;
  }
  var level = tmp_3;
  // Inline function 'kotlin.math.abs' call
  var x = recent - before;
  // Inline function 'kotlin.math.min' call
  var b = Math.abs(x) / level;
  return Math.min(1.0, b);
}
function update($this, x, p, reading, r) {
  var tmp = 0;
  var tmp_0 = new Float64Array(3);
  while (tmp < 3) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = p.n11(tmp_1, 0) + p.n11(tmp_1, 1);
    tmp = tmp + 1 | 0;
  }
  var ph = tmp_0;
  var s = ph[0] + ph[1] + r;
  var tmp_2 = 0;
  var tmp_3 = new Float64Array(3);
  while (tmp_2 < 3) {
    var tmp_4 = tmp_2;
    tmp_3[tmp_4] = ph[tmp_4] / s;
    tmp_2 = tmp_2 + 1 | 0;
  }
  var gain = tmp_3;
  var innovation = reading - (x[0] + x[1]);
  var inductionVariable = 0;
  if (inductionVariable <= 2)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      x[i] = x[i] + gain[i] * innovation;
    }
     while (inductionVariable <= 2);
  var tmp_5 = 0;
  var tmp_6 = new Float64Array(9);
  while (tmp_5 < 9) {
    var tmp_7 = tmp_5;
    var i_0 = tmp_7 / 3 | 0;
    var j = tmp_7 % 3 | 0;
    tmp_6[tmp_7] = (i_0 === j ? 1.0 : 0.0) - gain[i_0] * (j < 2 ? 1.0 : 0.0);
    tmp_5 = tmp_5 + 1 | 0;
  }
  var a = new Matrix3(tmp_6);
  var joseph = a.o11(p).p11(a);
  var tmp_8 = 0;
  var tmp_9 = new Float64Array(9);
  while (tmp_8 < 9) {
    var tmp_10 = tmp_8;
    tmp_9[tmp_10] = joseph.m11_1[tmp_10] + gain[tmp_10 / 3 | 0] * r * gain[tmp_10 % 3 | 0];
    tmp_8 = tmp_8 + 1 | 0;
  }
  return new Matrix3(tmp_9);
}
function isUsable($this, entry) {
  return !(entry == null) && (entry.oj_1.equals(DayStatus_COMPLETE_getInstance()) || entry.oj_1.equals(DayStatus_FASTED_getInstance()));
}
function StateSpaceExpenditure$filter$$inlined$groupingBy$1($this) {
  this.q11_1 = $this;
}
protoOf(StateSpaceExpenditure$filter$$inlined$groupingBy$1).i2 = function () {
  return this.q11_1.j();
};
protoOf(StateSpaceExpenditure$filter$$inlined$groupingBy$1).r11 = function (element) {
  return element.nl_1;
};
protoOf(StateSpaceExpenditure$filter$$inlined$groupingBy$1).j2 = function (element) {
  return this.r11(element);
};
function waterInput$excess($day, $terms, series, gain) {
  if (gain === 0.0)
    return 0.0;
  var tmp0_elvis_lhs = series.s1($day);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return 0.0;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var today = tmp;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = until($day - $terms.g11_1 | 0, $day);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = tmp0.oc_1;
  var last = tmp0.pc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      var tmp0_safe_receiver = series.s1(it);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.f(tmp0_safe_receiver);
      }
    }
     while (!(element === last));
  var baseline = destination;
  return baseline.m() ? 0.0 : gain * (today - average(baseline));
}
function relativeChange$mean($series, from, to) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = numberRangeToNumber(from, to);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = tmp0.oc_1;
  var last = tmp0.pc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      var tmp0_safe_receiver = $series.s1(it);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.f(tmp0_safe_receiver);
      }
    }
     while (!(element === last));
  // Inline function 'kotlin.takeIf' call
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!destination.m()) {
    tmp = destination;
  } else {
    tmp = null;
  }
  var tmp0_safe_receiver_0 = tmp;
  return tmp0_safe_receiver_0 == null ? null : average(tmp0_safe_receiver_0);
}
function StateSpaceExpenditure() {
}
protoOf(StateSpaceExpenditure).ql = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, floorKcal) {
  return this.vz(initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, Companion_getInstance_3().qk_1, new DailyInputs(), floorKcal);
};
protoOf(StateSpaceExpenditure).vz = function (initialKcal, startDay, endDay, weighIns, intake, kcalPerKg, goalChanges, params, terms, inputs, floorKcal) {
  // Inline function 'kotlin.require' call
  if (!(endDay >= startDay)) {
    var message = 'endDay must not be before startDay';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(kcalPerKg > 0.0)) {
    var message_0 = 'kcalPerKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var daily = WeightTrend_instance.bm(weighIns);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(daily, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = daily.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = element.nl_1;
    var tmp$ret$7 = element.ol_1;
    destination.k2(tmp, tmp$ret$7);
  }
  var weights = destination;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = weighIns.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (element_0.ol_1 >= 25.0) {
      destination_0.f(element_0);
    }
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$11 = new StateSpaceExpenditure$filter$$inlined$groupingBy$1(destination_0);
  var counts = eachCount(tmp$ret$11);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(daily, 10));
  var _iterator__ex2g4s_1 = daily.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$14 = item.nl_1;
    destination_1.f(tmp$ret$14);
  }
  var weighInDays = destination_1;
  var finalWeighIn = lastOrNull(weighInDays);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(intake, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_2 = LinkedHashMap_init_$Create$(capacity_0);
  var _iterator__ex2g4s_2 = intake.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_1 = _iterator__ex2g4s_2.l();
    var tmp$ret$17 = element_1.mj_1;
    destination_2.k2(tmp$ret$17, element_1);
  }
  var intakeByDay = destination_2;
  var adjuster = new GoalAdjuster(goalChanges, params.tz_1);
  // Inline function 'kotlin.math.pow' call
  var x = 1.0 / params.fz_1;
  var phi = Math.pow(0.5, x);
  var waterVariance = params.ez_1 * params.ez_1;
  var tmp$ret$19;
  $l$block: {
    // Inline function 'kotlin.collections.lastOrNull' call
    var iterator = daily.p(daily.o());
    while (iterator.b3()) {
      var element_2 = iterator.c3();
      if (element_2.nl_1 <= startDay) {
        tmp$ret$19 = element_2;
        break $l$block;
      }
    }
    tmp$ret$19 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$19;
  var tmp1_safe_receiver = tmp0_elvis_lhs == null ? firstOrNull(daily) : tmp0_elvis_lhs;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ol_1;
  var startWeight = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  // Inline function 'kotlin.doubleArrayOf' call
  var x_0 = new Float64Array([startWeight, 0.0, initialKcal]);
  var p = Companion_instance_6.s11(params.jz_1 * params.jz_1, waterVariance, params.iz_1 * params.iz_1);
  var qWater = waterVariance * (1.0 - phi * phi);
  var qTissue = params.gz_1 * params.gz_1;
  var qExpenditure = params.hz_1 * params.hz_1;
  var feedback = terms.y10_1 + terms.z10_1;
  var covariance = p;
  var reported = initialKcal;
  var everUpdated = false;
  var points = ArrayList_init_$Create$((endDay - startDay | 0) + 1 | 0);
  var inductionVariable = startDay;
  if (inductionVariable <= endDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (day > startDay) {
        var _destruct__k2r9zo = intakeFor(this, day - 1 | 0, intakeByDay, x_0[2], params);
        var intakeKcal = _destruct__k2r9zo.ya();
        var intakeVariance = _destruct__k2r9zo.za();
        var tmp3_safe_receiver = params.sz_1;
        var tmp_0;
        if (tmp3_safe_receiver == null) {
          tmp_0 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_1;
          if (intakeKcal - x_0[2] > 0.0) {
            tmp_1 = tmp3_safe_receiver;
          } else {
            tmp_1 = null;
          }
          tmp_0 = tmp_1;
        }
        var tmp4_elvis_lhs = tmp_0;
        var density = tmp4_elvis_lhs == null ? kcalPerKg : tmp4_elvis_lhs;
        var mass = x_0[0];
        var energy = x_0[2];
        var c = !(feedback === 0.0) && mass > 0.0 ? feedback / (density * mass) : 0.0;
        var dEdM = c === 0.0 ? 0.0 : -c * energy * (intakeKcal - energy) / mass;
        // Inline function 'kotlin.doubleArrayOf' call
        var tmp$ret$24 = new Float64Array([1.0, 0.0, -1.0 / density, 0.0, phi, 0.0, dEdM, 0.0, 1.0 + c * (intakeKcal - 2.0 * energy)]);
        var f = new Matrix3(tmp$ret$24);
        var water = creatine(this, day - 1 | 0, inputs.l11_1, terms);
        x_0[0] = x_0[0] + (intakeKcal - x_0[2]) / density;
        x_0[1] = water + phi * (x_0[1] - water) + waterInput(this, day - 1 | 0, inputs, terms);
        x_0[2] = energy + c * energy * (intakeKcal - energy);
        var flex = (1.0 + terms.c11_1 * relativeChange(this, day - 1 | 0, inputs.j11_1, terms.c11_1)) * (1.0 + terms.d11_1 * relativeChange(this, day - 1 | 0, inputs.k11_1, terms.d11_1));
        covariance = f.o11(covariance).p11(f).t11(qTissue + intakeVariance / (density * density), qWater, qExpenditure * flex);
        if (!(c === 0.0)) {
          var ce = c * energy;
          covariance = covariance.u11(0, 2, intakeVariance * ce / density).t11(0.0, 0.0, intakeVariance * ce * ce);
        }
      }
      var tmp$ret$25;
      $l$block_0: {
        // Inline function 'kotlin.collections.lastOrNull' call
        var iterator_0 = weighInDays.p(weighInDays.o());
        while (iterator_0.b3()) {
          var element_3 = iterator_0.c3();
          if (element_3 <= day) {
            tmp$ret$25 = element_3;
            break $l$block_0;
          }
        }
        tmp$ret$25 = null;
      }
      var lastWeighIn = tmp$ret$25;
      var tmp_2;
      if (lastWeighIn == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = floorKcal == null ? null : floorKcal(getValue(weights, lastWeighIn));
      }
      var floor = tmp_2;
      var tmp0 = numberRangeToNumber(day - 6 | 0, day);
      var tmp$ret$29;
      $l$block_1: {
        // Inline function 'kotlin.collections.count' call
        var tmp_3;
        if (isInterface(tmp0, Collection)) {
          tmp_3 = tmp0.m();
        } else {
          tmp_3 = false;
        }
        if (tmp_3) {
          tmp$ret$29 = 0;
          break $l$block_1;
        }
        var count = 0;
        var inductionVariable_0 = tmp0.oc_1;
        var last = tmp0.pc_1;
        if (inductionVariable_0 <= last)
          do {
            var element_4 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var it = element_4;
            if (isUsable(StateSpaceExpenditure_instance, intakeByDay.s1(it))) {
              count = count + 1 | 0;
              checkCountOverflow(count);
            }
          }
           while (!(element_4 === last));
        tmp$ret$29 = count;
      }
      var usableLastWeek = tmp$ret$29;
      var eligible = (day - startDay | 0) >= params.oz_1 && usableLastWeek >= params.pz_1 && !(lastWeighIn == null) && (day - lastWeighIn | 0) < params.qz_1 && !(params.rz_1 && !(finalWeighIn == null) && day > finalWeighIn);
      var shiftToday = adjuster.rx(day, x_0[2], !eligible, floor);
      x_0[2] = x_0[2] + shiftToday;
      var reading = weights.s1(day);
      if (!(reading == null)) {
        var tmp_4 = params.dz_1 * params.dz_1;
        var tmp6_elvis_lhs = counts.s1(day);
        var r = tmp_4 / (tmp6_elvis_lhs == null ? 1 : tmp6_elvis_lhs);
        covariance = update(this, x_0, covariance, reading, r);
      }
      if (!(floor == null) && x_0[2] < floor) {
        x_0[2] = floor;
      }
      var tmp_5;
      if (eligible) {
        reported = x_0[2];
        everUpdated = true;
        tmp_5 = ExpenditureStatus_UPDATING_getInstance();
      } else if (everUpdated) {
        reported = reported + shiftToday;
        tmp_5 = ExpenditureStatus_HOLDING_getInstance();
      } else {
        reported = reported + shiftToday;
        tmp_5 = ExpenditureStatus_INITIAL_getInstance();
      }
      var status = tmp_5;
      var floored = !(floor == null) && reported <= floor;
      if (!(floor == null) && reported < floor)
        reported = floor;
      var tmp_6 = reported;
      // Inline function 'kotlin.math.abs' call
      var x_1 = covariance.n11(2, 2);
      // Inline function 'kotlin.math.sqrt' call
      var x_2 = Math.abs(x_1);
      var tmp$ret$32 = Math.sqrt(x_2);
      points.f(new ExpenditurePoint(day, tmp_6, tmp$ret$32, status, floored, shiftToday));
    }
     while (!(day === endDay));
  return points;
};
var StateSpaceExpenditure_instance;
function StateSpaceExpenditure_getInstance() {
  return StateSpaceExpenditure_instance;
}
function Companion_4() {
}
protoOf(Companion_4).s11 = function (a, b, c) {
  // Inline function 'kotlin.doubleArrayOf' call
  var tmp$ret$0 = new Float64Array([a, 0.0, 0.0, 0.0, b, 0.0, 0.0, 0.0, c]);
  return new Matrix3(tmp$ret$0);
};
var Companion_instance_6;
function Companion_getInstance_4() {
  return Companion_instance_6;
}
function Matrix3(values) {
  this.m11_1 = values;
  // Inline function 'kotlin.require' call
  if (!(this.m11_1.length === 9)) {
    var message = 'a 3\xD73 matrix has 9 values';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(Matrix3).n11 = function (row, column) {
  return this.m11_1[imul(row, 3) + column | 0];
};
protoOf(Matrix3).o11 = function (other) {
  var tmp = 0;
  var tmp_0 = new Float64Array(9);
  while (tmp < 9) {
    var tmp_1 = tmp;
    var i = tmp_1 / 3 | 0;
    var j = tmp_1 % 3 | 0;
    tmp_0[tmp_1] = this.n11(i, 0) * other.n11(0, j) + this.n11(i, 1) * other.n11(1, j) + this.n11(i, 2) * other.n11(2, j);
    tmp = tmp + 1 | 0;
  }
  return new Matrix3(tmp_0);
};
protoOf(Matrix3).p11 = function (other) {
  var tmp = 0;
  var tmp_0 = new Float64Array(9);
  while (tmp < 9) {
    var tmp_1 = tmp;
    var i = tmp_1 / 3 | 0;
    var j = tmp_1 % 3 | 0;
    tmp_0[tmp_1] = this.n11(i, 0) * other.n11(j, 0) + this.n11(i, 1) * other.n11(j, 1) + this.n11(i, 2) * other.n11(j, 2);
    tmp = tmp + 1 | 0;
  }
  return new Matrix3(tmp_0);
};
protoOf(Matrix3).t11 = function (a, b, c) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.also' call
  var this_0 = this.m11_1.slice();
  this_0[0] = this_0[0] + a;
  this_0[4] = this_0[4] + b;
  this_0[8] = this_0[8] + c;
  return new Matrix3(this_0);
};
protoOf(Matrix3).u11 = function (row, column, value) {
  // Inline function 'kotlin.collections.copyOf' call
  // Inline function 'kotlin.js.asDynamic' call
  // Inline function 'kotlin.also' call
  var this_0 = this.m11_1.slice();
  var _index_0__fvwizt = imul(row, 3) + column | 0;
  this_0[_index_0__fvwizt] = this_0[_index_0__fvwizt] + value;
  var _index_0__fvwizt_0 = imul(column, 3) + row | 0;
  this_0[_index_0__fvwizt_0] = this_0[_index_0__fvwizt_0] + value;
  return new Matrix3(this_0);
};
protoOf(Matrix3).v11 = function () {
  var a = this.m11_1;
  var c00 = a[4] * a[8] - a[5] * a[7];
  var c01 = a[5] * a[6] - a[3] * a[8];
  var c02 = a[3] * a[7] - a[4] * a[6];
  var det = a[0] * c00 + a[1] * c01 + a[2] * c02;
  // Inline function 'kotlin.require' call
  if (!!(det === 0.0)) {
    var message = 'matrix is singular';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.doubleArrayOf' call
  var tmp$ret$2 = new Float64Array([c00 / det, (a[2] * a[7] - a[1] * a[8]) / det, (a[1] * a[5] - a[2] * a[4]) / det, c01 / det, (a[0] * a[8] - a[2] * a[6]) / det, (a[2] * a[3] - a[0] * a[5]) / det, c02 / det, (a[1] * a[6] - a[0] * a[7]) / det, (a[0] * a[4] - a[1] * a[3]) / det]);
  return new Matrix3(tmp$ret$2);
};
function IntakePrior_RECENT_MEAN_getInstance() {
  static_init_30();
  return IntakePrior_RECENT_MEAN_instance;
}
function IntakePrior_EXPENDITURE_getInstance() {
  static_init_30();
  return IntakePrior_EXPENDITURE_instance;
}
function round1($this, value) {
  return round(value * 10.0) / 10.0;
}
function number($this, value) {
  var tmp;
  if (!(value == null) ? typeof value === 'number' : false) {
    tmp = value;
  } else {
    if (isNumber(value)) {
      tmp = numberToDouble(value);
    } else {
      if (!(value == null) ? typeof value === 'string' : false) {
        // Inline function 'kotlin.text.trim' call
        var tmp$ret$0 = toString(trim(isCharSequence(value) ? value : THROW_CCE()));
        tmp = toDoubleOrNull(tmp$ret$0);
      } else {
        tmp = null;
      }
    }
  }
  var tmp1_safe_receiver = tmp;
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    if (isFinite(tmp1_safe_receiver)) {
      tmp_1 = tmp1_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  return tmp_0;
}
function text_0($this, value) {
  var tmp0_safe_receiver = (!(value == null) ? typeof value === 'string' : false) ? value : null;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.text.ifEmpty' call
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(tmp0_safe_receiver) === 0) {
      tmp_0 = null;
    } else {
      tmp_0 = tmp0_safe_receiver;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function normalise$nutrient(nutriments, key) {
  var tmp = OffProduct_getInstance();
  // Inline function 'kotlin.collections.get' call
  var key_0 = key + '_100g';
  var tmp$ret$0 = (isInterface(nutriments, KtMap) ? nutriments : THROW_CCE()).s1(key_0);
  return number(tmp, tmp$ret$0);
}
function OffProduct() {
  OffProduct_instance = this;
  this.w11_1 = 'https://world.openfoodfacts.org';
  this.x11_1 = 'code,product_name,generic_name,brands,nutriments,serving_size,serving_quantity,product_quantity,lang,countries_tags';
  this.y11_1 = Regex_init_$Create$('^\\d{8,14}$');
  this.z11_1 = 4.184;
  this.a12_1 = 2.5;
  this.b12_1 = 'Macrotide';
}
protoOf(OffProduct).c12 = function (code) {
  return this.y11_1.v8(code);
};
protoOf(OffProduct).d12 = function (code, baseUrl) {
  return this.c12(code) ? baseUrl + '/api/v3/product/' + code + '?fields=code,product_name,generic_name,brands,nutriments,serving_size,serving_quantity,product_quantity,lang,countries_tags&app_name=Macrotide' : null;
};
protoOf(OffProduct).e12 = function (code, baseUrl, $super) {
  baseUrl = baseUrl === VOID ? 'https://world.openfoodfacts.org' : baseUrl;
  return $super === VOID ? this.d12(code, baseUrl) : $super.d12.call(this, code, baseUrl);
};
protoOf(OffProduct).f12 = function (code, response) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = Json_instance.uf(response);
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp_1 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp0_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
  var tmp_2;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp_2 = tmp0_elvis_lhs;
  }
  var payload = tmp_2;
  // Inline function 'kotlin.collections.get' call
  var status = (isInterface(payload, KtMap) ? payload : THROW_CCE()).s1('status');
  if (!equals(status, 'success') && !equals(status, 1.0))
    return null;
  // Inline function 'kotlin.collections.get' call
  var tmp_3 = (isInterface(payload, KtMap) ? payload : THROW_CCE()).s1('product');
  var tmp1_elvis_lhs = (!(tmp_3 == null) ? isInterface(tmp_3, KtMap) : false) ? tmp_3 : null;
  var tmp_4;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp1_elvis_lhs;
  }
  var product = tmp_4;
  var tmp2_safe_receiver = this.g12(code, product);
  var tmp_5;
  if (tmp2_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_5 = Json_instance.zf(tmp2_safe_receiver);
  }
  return tmp_5;
};
protoOf(OffProduct).g12 = function (code, product) {
  // Inline function 'kotlin.collections.get' call
  var key = 'nutriments';
  var tmp = (isInterface(product, KtMap) ? product : THROW_CCE()).s1(key);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KtMap) : false) ? tmp : null;
  var nutriments = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = normalise$nutrient(nutriments, 'energy-kcal');
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    var tmp2_safe_receiver = normalise$nutrient(nutriments, 'energy');
    var tmp_1;
    if (tmp2_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = round1(OffProduct_getInstance(), tmp2_safe_receiver / 4.184);
    }
    tmp_0 = tmp_1;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var kcal = tmp_0;
  var protein = normalise$nutrient(nutriments, 'proteins');
  var fat = normalise$nutrient(nutriments, 'fat');
  var carbs = normalise$nutrient(nutriments, 'carbohydrates');
  if (kcal == null || protein == null || fat == null || carbs == null)
    return null;
  var tmp3_elvis_lhs = normalise$nutrient(nutriments, 'sodium');
  var tmp_2;
  if (tmp3_elvis_lhs == null) {
    var tmp4_safe_receiver = normalise$nutrient(nutriments, 'salt');
    var tmp_3;
    if (tmp4_safe_receiver == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_3 = tmp4_safe_receiver / 2.5;
    }
    tmp_2 = tmp_3;
  } else {
    tmp_2 = tmp3_elvis_lhs;
  }
  var sodiumGrams = tmp_2;
  // Inline function 'kotlin.collections.get' call
  var key_0 = 'product_name';
  var tmp$ret$5 = (isInterface(product, KtMap) ? product : THROW_CCE()).s1(key_0);
  var tmp5_elvis_lhs = text_0(this, tmp$ret$5);
  var tmp_4;
  if (tmp5_elvis_lhs == null) {
    // Inline function 'kotlin.collections.get' call
    var key_1 = 'generic_name';
    var tmp$ret$6 = (isInterface(product, KtMap) ? product : THROW_CCE()).s1(key_1);
    tmp_4 = text_0(this, tmp$ret$6);
  } else {
    tmp_4 = tmp5_elvis_lhs;
  }
  var tmp6_elvis_lhs = tmp_4;
  // Inline function 'kotlin.text.trim' call
  var this_0 = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
  // Inline function 'kotlin.text.ifEmpty' call
  var this_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var tmp_5;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_1) === 0) {
    tmp_5 = 'Product ' + code;
  } else {
    tmp_5 = this_1;
  }
  var name = tmp_5;
  // Inline function 'kotlin.collections.get' call
  var tmp$ret$11 = (isInterface(product, KtMap) ? product : THROW_CCE()).s1('brands');
  var tmp7_elvis_lhs = text_0(this, tmp$ret$11);
  // Inline function 'kotlin.text.trim' call
  var this_2 = split(tmp7_elvis_lhs == null ? '' : tmp7_elvis_lhs, [',']).n(0);
  // Inline function 'kotlin.text.ifEmpty' call
  var this_3 = toString(trim(isCharSequence(this_2) ? this_2 : THROW_CCE()));
  var tmp_6;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_3) === 0) {
    tmp_6 = null;
  } else {
    tmp_6 = this_3;
  }
  var brand = tmp_6;
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_4 = ArrayList_init_$Create$_0();
  var tmp_7 = OffProduct_getInstance();
  // Inline function 'kotlin.collections.get' call
  var key_2 = 'serving_quantity';
  var tmp$ret$20 = (isInterface(product, KtMap) ? product : THROW_CCE()).s1(key_2);
  var tmp0_safe_receiver = number(tmp_7, tmp$ret$20);
  var tmp_8;
  if (tmp0_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_9;
    if (!(tmp0_safe_receiver === 0.0)) {
      tmp_9 = tmp0_safe_receiver;
    } else {
      tmp_9 = null;
    }
    tmp_8 = tmp_9;
  }
  var tmp1_safe_receiver = tmp_8;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp_10 = OffProduct_getInstance();
    // Inline function 'kotlin.collections.get' call
    var key_3 = 'serving_size';
    var tmp$ret$25 = (isInterface(product, KtMap) ? product : THROW_CCE()).s1(key_3);
    var tmp0_elvis_lhs_0 = text_0(tmp_10, tmp$ret$25);
    this_4.f(mapOf_0([to('label', tmp0_elvis_lhs_0 == null ? '1 serving' : tmp0_elvis_lhs_0), to('grams', tmp1_safe_receiver)]));
  }
  var tmp_11 = OffProduct_getInstance();
  // Inline function 'kotlin.collections.get' call
  var key_4 = 'product_quantity';
  var tmp$ret$26 = (isInterface(product, KtMap) ? product : THROW_CCE()).s1(key_4);
  var tmp2_safe_receiver_0 = number(tmp_11, tmp$ret$26);
  var tmp_12;
  if (tmp2_safe_receiver_0 == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_13;
    if (!(tmp2_safe_receiver_0 === 0.0)) {
      tmp_13 = tmp2_safe_receiver_0;
    } else {
      tmp_13 = null;
    }
    tmp_12 = tmp_13;
  }
  var tmp3_safe_receiver = tmp_12;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_4.f(mapOf_0([to('label', '1 package'), to('grams', tmp3_safe_receiver)]));
  }
  var portions = this_4.t3();
  var tmp_14 = to('id', 'off:' + code);
  var tmp_15 = to('name', name);
  var tmp_16 = to('brand', brand);
  var tmp_17 = to('source', 'OFF');
  var tmp_18 = to('kind', 'branded');
  // Inline function 'kotlin.collections.get' call
  var tmp$ret$31 = (isInterface(product, KtMap) ? product : THROW_CCE()).s1('lang');
  var tmp8_elvis_lhs = text_0(this, tmp$ret$31);
  var tmp_19 = to('lang', tmp8_elvis_lhs == null ? 'en' : tmp8_elvis_lhs);
  var tmp_20 = to('barcode', code);
  var tmp_21 = to('kcal', kcal);
  var tmp_22 = to('protein', protein);
  var tmp_23 = to('fat', fat);
  var tmp_24 = to('carbs', carbs);
  var tmp_25 = to('fiber', normalise$nutrient(nutriments, 'fiber'));
  var tmp_26 = to('sugar', normalise$nutrient(nutriments, 'sugars'));
  var tmp_27 = to('satFat', normalise$nutrient(nutriments, 'saturated-fat'));
  var tmp_28;
  if (sodiumGrams == null) {
    tmp_28 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_28 = round1(OffProduct_getInstance(), sodiumGrams * 1000.0);
  }
  return linkedMapOf([tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp_19, tmp_20, to('per100g', linkedMapOf([tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, to('sodiumMg', tmp_28), to('alcohol', normalise$nutrient(nutriments, 'alcohol'))])), to('portions', portions)]);
};
var OffProduct_instance;
function OffProduct_getInstance() {
  if (OffProduct_instance == null)
    new OffProduct();
  return OffProduct_instance;
}
function obj($this) {
  $this.i12_1 = $this.i12_1 + 1 | 0;
  var map = LinkedHashMap_init_$Create$_1();
  $this.j12();
  var tmp = peek($this);
  if (equals(tmp == null ? null : new Char(tmp), new Char(_Char___init__impl__6a9atx(125)))) {
    $this.i12_1 = $this.i12_1 + 1 | 0;
    return map;
  }
  while (true) {
    $this.j12();
    var tmp_0 = peek($this);
    // Inline function 'kotlin.require' call
    if (!equals(tmp_0 == null ? null : new Char(tmp_0), new Char(_Char___init__impl__6a9atx(34)))) {
      var message = 'expected a key at ' + $this.i12_1;
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var key = string($this);
    $this.j12();
    expect($this, _Char___init__impl__6a9atx(58));
    // Inline function 'kotlin.collections.set' call
    var value = $this.k12();
    map.k2(key, value);
    $this.j12();
    var tmp0_subject = peek($this);
    var tmp_1 = tmp0_subject;
    if (equals(tmp_1 == null ? null : new Char(tmp_1), new Char(_Char___init__impl__6a9atx(44)))) {
      $this.i12_1 = $this.i12_1 + 1 | 0;
    } else {
      var tmp_2 = tmp0_subject;
      if (equals(tmp_2 == null ? null : new Char(tmp_2), new Char(_Char___init__impl__6a9atx(125)))) {
        $this.i12_1 = $this.i12_1 + 1 | 0;
        return map;
      } else {
        throw IllegalArgumentException_init_$Create$("expected ',' or '}' at " + $this.i12_1);
      }
    }
  }
}
function array($this) {
  $this.i12_1 = $this.i12_1 + 1 | 0;
  var list = ArrayList_init_$Create$_0();
  $this.j12();
  var tmp = peek($this);
  if (equals(tmp == null ? null : new Char(tmp), new Char(_Char___init__impl__6a9atx(93)))) {
    $this.i12_1 = $this.i12_1 + 1 | 0;
    return list;
  }
  while (true) {
    list.f($this.k12());
    $this.j12();
    var tmp0_subject = peek($this);
    var tmp_0 = tmp0_subject;
    if (equals(tmp_0 == null ? null : new Char(tmp_0), new Char(_Char___init__impl__6a9atx(44)))) {
      $this.i12_1 = $this.i12_1 + 1 | 0;
    } else {
      var tmp_1 = tmp0_subject;
      if (equals(tmp_1 == null ? null : new Char(tmp_1), new Char(_Char___init__impl__6a9atx(93)))) {
        $this.i12_1 = $this.i12_1 + 1 | 0;
        return list;
      } else {
        throw IllegalArgumentException_init_$Create$("expected ',' or ']' at " + $this.i12_1);
      }
    }
  }
}
function string($this) {
  expect($this, _Char___init__impl__6a9atx(34));
  var out = StringBuilder_init_$Create$();
  while (true) {
    // Inline function 'kotlin.require' call
    if (!($this.i12_1 < $this.h12_1.length)) {
      var message = 'unterminated string';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var _unary__edvuaz = $this.i12_1;
    $this.i12_1 = _unary__edvuaz + 1 | 0;
    var c = charCodeAt($this.h12_1, _unary__edvuaz);
    if (c === _Char___init__impl__6a9atx(34))
      return out.toString();
    else if (c === _Char___init__impl__6a9atx(92)) {
      // Inline function 'kotlin.require' call
      if (!($this.i12_1 < $this.h12_1.length)) {
        var message_0 = 'unterminated escape';
        throw IllegalArgumentException_init_$Create$(toString(message_0));
      }
      var _unary__edvuaz_0 = $this.i12_1;
      $this.i12_1 = _unary__edvuaz_0 + 1 | 0;
      var e = charCodeAt($this.h12_1, _unary__edvuaz_0);
      if (e === _Char___init__impl__6a9atx(34))
        out.o6(_Char___init__impl__6a9atx(34));
      else if (e === _Char___init__impl__6a9atx(92))
        out.o6(_Char___init__impl__6a9atx(92));
      else if (e === _Char___init__impl__6a9atx(47))
        out.o6(_Char___init__impl__6a9atx(47));
      else if (e === _Char___init__impl__6a9atx(98))
        out.o6(_Char___init__impl__6a9atx(8));
      else if (e === _Char___init__impl__6a9atx(102))
        out.o6(_Char___init__impl__6a9atx(12));
      else if (e === _Char___init__impl__6a9atx(110))
        out.o6(_Char___init__impl__6a9atx(10));
      else if (e === _Char___init__impl__6a9atx(114))
        out.o6(_Char___init__impl__6a9atx(13));
      else if (e === _Char___init__impl__6a9atx(116))
        out.o6(_Char___init__impl__6a9atx(9));
      else if (e === _Char___init__impl__6a9atx(117)) {
        // Inline function 'kotlin.require' call
        if (!(($this.i12_1 + 4 | 0) <= $this.h12_1.length)) {
          var message_1 = 'bad unicode escape at ' + $this.i12_1;
          throw IllegalArgumentException_init_$Create$(toString(message_1));
        }
        var tmp1_elvis_lhs = toIntOrNull_0(substring($this.h12_1, $this.i12_1, $this.i12_1 + 4 | 0), 16);
        var tmp;
        if (tmp1_elvis_lhs == null) {
          throw IllegalArgumentException_init_$Create$('bad unicode escape at ' + $this.i12_1);
        } else {
          tmp = tmp1_elvis_lhs;
        }
        var code = tmp;
        out.o6(numberToChar(code));
        $this.i12_1 = $this.i12_1 + 4 | 0;
      } else
        throw IllegalArgumentException_init_$Create$("bad escape '\\" + toString_1(e) + "' at " + $this.i12_1);
    } else
      out.o6(c);
  }
}
function number_0($this) {
  var start = $this.i12_1;
  var tmp = peek($this);
  if (equals(tmp == null ? null : new Char(tmp), new Char(_Char___init__impl__6a9atx(45)))) {
    $this.i12_1 = $this.i12_1 + 1 | 0;
  }
  while ($this.i12_1 < $this.h12_1.length && (isDigit(charCodeAt($this.h12_1, $this.i12_1)) || contains_0('.eE+-', charCodeAt($this.h12_1, $this.i12_1)))) {
    $this.i12_1 = $this.i12_1 + 1 | 0;
  }
  var token = substring($this.h12_1, start, $this.i12_1);
  var tmp0_elvis_lhs = toDoubleOrNull(token);
  var tmp_0;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$("bad number '" + token + "' at " + start);
  } else {
    tmp_0 = tmp0_elvis_lhs;
  }
  return tmp_0;
}
function literal($this, word, value) {
  // Inline function 'kotlin.require' call
  if (!startsWith_0($this.h12_1, word, $this.i12_1)) {
    var message = 'unexpected token at ' + $this.i12_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  $this.i12_1 = $this.i12_1 + word.length | 0;
  return value;
}
function peek($this) {
  return getOrNull($this.h12_1, $this.i12_1);
}
function expect($this, c) {
  var tmp = peek($this);
  // Inline function 'kotlin.require' call
  if (!equals(tmp == null ? null : new Char(tmp), new Char(c))) {
    var message = "expected '" + toString_1(c) + "' at " + $this.i12_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  $this.i12_1 = $this.i12_1 + 1 | 0;
}
function write($this, out, value) {
  if (value == null)
    out.n6('null');
  else {
    if (typeof value === 'boolean')
      out.f8(value);
    else {
      if (typeof value === 'number')
        out.g8(value);
      else {
        if (value instanceof Long)
          out.h8(value);
        else {
          if (typeof value === 'number')
            out.n6(number_1($this, value));
          else {
            if (typeof value === 'number')
              out.n6(number_1($this, value));
            else {
              if (typeof value === 'string') {
                string_0($this, out, value);
              } else {
                if (isInterface(value, KtMap)) {
                  out.o6(_Char___init__impl__6a9atx(123));
                  var first = true;
                  // Inline function 'kotlin.collections.iterator' call
                  var _iterator__ex2g4s = value.v1().j();
                  while (_iterator__ex2g4s.k()) {
                    var _destruct__k2r9zo = _iterator__ex2g4s.l();
                    // Inline function 'kotlin.collections.component1' call
                    var key = _destruct__k2r9zo.o1();
                    // Inline function 'kotlin.collections.component2' call
                    var item = _destruct__k2r9zo.p1();
                    if (!first) {
                      out.o6(_Char___init__impl__6a9atx(44));
                    }
                    first = false;
                    string_0($this, out, toString_0(key));
                    out.o6(_Char___init__impl__6a9atx(58));
                    write($this, out, item);
                  }
                  out.o6(_Char___init__impl__6a9atx(125));
                } else {
                  if (isInterface(value, Iterable)) {
                    out.o6(_Char___init__impl__6a9atx(91));
                    var first_0 = true;
                    var _iterator__ex2g4s_0 = value.j();
                    while (_iterator__ex2g4s_0.k()) {
                      var item_0 = _iterator__ex2g4s_0.l();
                      if (!first_0) {
                        out.o6(_Char___init__impl__6a9atx(44));
                      }
                      first_0 = false;
                      write($this, out, item_0);
                    }
                    out.o6(_Char___init__impl__6a9atx(93));
                  } else {
                    throw IllegalArgumentException_init_$Create$('cannot write ' + getKClassFromExpression(value).z6() + ' as JSON');
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
function number_1($this, value) {
  // Inline function 'kotlin.require' call
  if (!(!isNaN_0(value) && !isInfinite(value))) {
    var message = 'JSON has no NaN or infinity';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  // Inline function 'kotlin.math.floor' call
  if (value === Math.floor(value)) {
    // Inline function 'kotlin.math.abs' call
    tmp = Math.abs(value) < 1.0E15;
  } else {
    tmp = false;
  }
  if (tmp)
    return numberToLong(value).toString();
  return value.toString();
}
function string_0($this, out, value) {
  out.o6(_Char___init__impl__6a9atx(34));
  var inductionVariable = 0;
  var last = value.length;
  while (inductionVariable < last) {
    var c = charCodeAt(value, inductionVariable);
    inductionVariable = inductionVariable + 1 | 0;
    if (c === _Char___init__impl__6a9atx(34))
      out.n6('\\"');
    else if (c === _Char___init__impl__6a9atx(92))
      out.n6('\\\\');
    else if (c === _Char___init__impl__6a9atx(10))
      out.n6('\\n');
    else if (c === _Char___init__impl__6a9atx(13))
      out.n6('\\r');
    else if (c === _Char___init__impl__6a9atx(9))
      out.n6('\\t');
    else if (c === _Char___init__impl__6a9atx(8))
      out.n6('\\b');
    else if (c === _Char___init__impl__6a9atx(12))
      out.n6('\\f');
    else if (Char__compareTo_impl_ypi4mb(c, _Char___init__impl__6a9atx(32)) < 0) {
      var tmp = out.n6('\\u');
      // Inline function 'kotlin.code' call
      var tmp$ret$0 = Char__toInt_impl_vasixd(c);
      tmp.n6(padStart(toString_2(tmp$ret$0, 16), 4, _Char___init__impl__6a9atx(48)));
    } else
      out.o6(c);
  }
  out.o6(_Char___init__impl__6a9atx(34));
}
function Parser(text) {
  this.h12_1 = text;
  this.i12_1 = 0;
}
protoOf(Parser).j12 = function () {
  while (this.i12_1 < this.h12_1.length && contains_0(' \t\r\n', charCodeAt(this.h12_1, this.i12_1))) {
    this.i12_1 = this.i12_1 + 1 | 0;
  }
};
protoOf(Parser).k12 = function () {
  this.j12();
  // Inline function 'kotlin.require' call
  if (!(this.i12_1 < this.h12_1.length)) {
    var message = 'unexpected end of JSON';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var c = charCodeAt(this.h12_1, this.i12_1);
  var tmp;
  if (c === _Char___init__impl__6a9atx(123)) {
    tmp = obj(this);
  } else if (c === _Char___init__impl__6a9atx(91)) {
    tmp = array(this);
  } else if (c === _Char___init__impl__6a9atx(34)) {
    tmp = string(this);
  } else if (c === _Char___init__impl__6a9atx(116)) {
    tmp = literal(this, 'true', true);
  } else if (c === _Char___init__impl__6a9atx(102)) {
    tmp = literal(this, 'false', false);
  } else if (c === _Char___init__impl__6a9atx(110)) {
    tmp = literal(this, 'null', null);
  } else {
    var tmp_0;
    if (c === _Char___init__impl__6a9atx(45) || (_Char___init__impl__6a9atx(48) <= c ? c <= _Char___init__impl__6a9atx(57) : false)) {
      tmp_0 = number_0(this);
    } else {
      throw IllegalArgumentException_init_$Create$("unexpected '" + toString_1(c) + "' at " + this.i12_1);
    }
    tmp = tmp_0;
  }
  return tmp;
};
function Json() {
}
protoOf(Json).uf = function (text) {
  var parser = new Parser(text);
  var value = parser.k12();
  parser.j12();
  // Inline function 'kotlin.require' call
  if (!(parser.i12_1 === text.length)) {
    var message = "unexpected '" + toString_1(charCodeAt(text, parser.i12_1)) + "' at " + parser.i12_1;
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return value;
};
protoOf(Json).zf = function (value) {
  // Inline function 'kotlin.also' call
  var this_0 = StringBuilder_init_$Create$();
  write(Json_instance, this_0, value);
  return this_0.toString();
};
var Json_instance;
function Json_getInstance() {
  return Json_instance;
}
function JsonRead() {
}
protoOf(JsonRead).vf = function (value, what) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap) : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException_init_$Create$(what + ' must be a JSON object');
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(JsonRead).l12 = function (value, what, $super) {
  what = what === VOID ? 'value' : what;
  return $super === VOID ? this.vf(value, what) : $super.vf.call(this, value, what);
};
protoOf(JsonRead).yq = function (value) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtList) : false) ? value : null;
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
protoOf(JsonRead).iq = function (map, key) {
  var tmp = map.s1(key);
  return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
};
protoOf(JsonRead).jq = function (map, key) {
  var tmp = map.s1(key);
  var tmp0_safe_receiver = isNumber(tmp) ? tmp : null;
  return tmp0_safe_receiver == null ? null : numberToDouble(tmp0_safe_receiver);
};
protoOf(JsonRead).xq = function (map, key) {
  var tmp = map.s1(key);
  var tmp0_safe_receiver = isNumber(tmp) ? tmp : null;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : numberToDouble(tmp0_safe_receiver);
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = numberToInt(round(tmp1_safe_receiver));
  }
  return tmp_0;
};
protoOf(JsonRead).ar = function (map, key) {
  var tmp = map.s1(key);
  return (!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null;
};
protoOf(JsonRead).m12 = function (map, key) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = this.yq(map.s1(key));
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!(element == null) ? typeof element === 'string' : false) {
      destination.f(element);
    }
  }
  return destination;
};
protoOf(JsonRead).n12 = function (map, key) {
  // Inline function 'kotlin.collections.filterIsInstance' call
  var tmp0 = this.yq(map.s1(key));
  // Inline function 'kotlin.collections.filterIsInstanceTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (isNumber(element)) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$4 = numberToDouble(item);
    destination_0.f(tmp$ret$4);
  }
  return destination_0;
};
protoOf(JsonRead).zq = function (map, key) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.n12(map, key);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = numberToInt(round(item));
    destination.f(tmp$ret$2);
  }
  return destination;
};
var JsonRead_instance;
function JsonRead_getInstance() {
  return JsonRead_instance;
}
var static_init_called_31;
function static_init_31() {
  if (static_init_called_31)
    return Unit_instance;
  static_init_called_31 = true;
  DrinkType_BEER_instance = new DrinkType('BEER', 0, 'Beer (ale, bitter)', 5.0, 3.6, 1.01, 568.0);
  DrinkType_LAGER_instance = new DrinkType('LAGER', 1, 'Lager', 4.5, 3.0, 1.008, 568.0);
  DrinkType_CIDER_instance = new DrinkType('CIDER', 2, 'Cider', 5.0, 4.0, 1.01, 568.0);
  DrinkType_RED_WINE_instance = new DrinkType('RED_WINE', 3, 'Red wine', 13.5, 2.6, 0.993, 175.0);
  DrinkType_WHITE_WINE_instance = new DrinkType('WHITE_WINE', 4, 'White wine', 12.5, 2.6, 0.993, 175.0);
  DrinkType_ROSE_WINE_instance = new DrinkType('ROSE_WINE', 5, 'Ros\xE9 wine', 12.0, 3.8, 0.995, 175.0);
  DrinkType_SPARKLING_WINE_instance = new DrinkType('SPARKLING_WINE', 6, 'Sparkling wine', 12.0, 1.5, 0.995, 125.0);
  DrinkType_SPIRITS_instance = new DrinkType('SPIRITS', 7, 'Spirits', 40.0, 0.0, 0.948, 25.0);
  DrinkType_SPIRIT_AND_MIXER_instance = new DrinkType('SPIRIT_AND_MIXER', 8, 'Spirit and mixer (e.g. gin and tonic)', 10.0, 6.6, 1.02, 200.0);
  DrinkType_COCKTAIL_instance = new DrinkType('COCKTAIL', 9, 'Cocktail (sweetened)', 12.0, 12.0, 1.04, 200.0);
}
var DrinkType_BEER_instance;
var DrinkType_LAGER_instance;
var DrinkType_CIDER_instance;
var DrinkType_RED_WINE_instance;
var DrinkType_WHITE_WINE_instance;
var DrinkType_ROSE_WINE_instance;
var DrinkType_SPARKLING_WINE_instance;
var DrinkType_SPIRITS_instance;
var DrinkType_SPIRIT_AND_MIXER_instance;
var DrinkType_COCKTAIL_instance;
function values_23() {
  static_init_31();
  return [DrinkType_BEER_getInstance(), DrinkType_LAGER_getInstance(), DrinkType_CIDER_getInstance(), DrinkType_RED_WINE_getInstance(), DrinkType_WHITE_WINE_getInstance(), DrinkType_ROSE_WINE_getInstance(), DrinkType_SPARKLING_WINE_getInstance(), DrinkType_SPIRITS_getInstance(), DrinkType_SPIRIT_AND_MIXER_getInstance(), DrinkType_COCKTAIL_getInstance()];
}
function valueOf_9(value) {
  static_init_31();
  switch (value) {
    case 'BEER':
      return DrinkType_BEER_getInstance();
    case 'LAGER':
      return DrinkType_LAGER_getInstance();
    case 'CIDER':
      return DrinkType_CIDER_getInstance();
    case 'RED_WINE':
      return DrinkType_RED_WINE_getInstance();
    case 'WHITE_WINE':
      return DrinkType_WHITE_WINE_getInstance();
    case 'ROSE_WINE':
      return DrinkType_ROSE_WINE_getInstance();
    case 'SPARKLING_WINE':
      return DrinkType_SPARKLING_WINE_getInstance();
    case 'SPIRITS':
      return DrinkType_SPIRITS_getInstance();
    case 'SPIRIT_AND_MIXER':
      return DrinkType_SPIRIT_AND_MIXER_getInstance();
    case 'COCKTAIL':
      return DrinkType_COCKTAIL_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.nutrients.DrinkType.' + value);
      break;
  }
}
function get_entries_18() {
  static_init_31();
  if ($ENTRIES_18 == null)
    $ENTRIES_18 = enumEntries(values_23());
  return $ENTRIES_18;
}
var $ENTRIES_18;
function DrinkType(name, ordinal, label, abvPct, carbsPer100Ml, densityGPerMl, servingMl) {
  Enum.call(this, name, ordinal);
  this.q12_1 = label;
  this.r12_1 = abvPct;
  this.s12_1 = carbsPer100Ml;
  this.t12_1 = densityGPerMl;
  this.u12_1 = servingMl;
}
function AlcoholEstimate(volumeMl, abvPct, alcoholG, alcoholKcal, carbsG, kcal, ukUnits, grams, per100g) {
  this.v12_1 = volumeMl;
  this.w12_1 = abvPct;
  this.x12_1 = alcoholG;
  this.y12_1 = alcoholKcal;
  this.z12_1 = carbsG;
  this.a13_1 = kcal;
  this.b13_1 = ukUnits;
  this.c13_1 = grams;
  this.d13_1 = per100g;
}
protoOf(AlcoholEstimate).toString = function () {
  return 'AlcoholEstimate(volumeMl=' + this.v12_1 + ', abvPct=' + this.w12_1 + ', alcoholG=' + this.x12_1 + ', alcoholKcal=' + this.y12_1 + ', carbsG=' + this.z12_1 + ', kcal=' + this.a13_1 + ', ukUnits=' + this.b13_1 + ', grams=' + this.c13_1 + ', per100g=' + this.d13_1.toString() + ')';
};
protoOf(AlcoholEstimate).hashCode = function () {
  var result = getNumberHashCode(this.v12_1);
  result = imul(result, 31) + getNumberHashCode(this.w12_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.x12_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.y12_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.z12_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.a13_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.b13_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.c13_1) | 0;
  result = imul(result, 31) + this.d13_1.hashCode() | 0;
  return result;
};
protoOf(AlcoholEstimate).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof AlcoholEstimate))
    return false;
  if (!equals(this.v12_1, other.v12_1))
    return false;
  if (!equals(this.w12_1, other.w12_1))
    return false;
  if (!equals(this.x12_1, other.x12_1))
    return false;
  if (!equals(this.y12_1, other.y12_1))
    return false;
  if (!equals(this.z12_1, other.z12_1))
    return false;
  if (!equals(this.a13_1, other.a13_1))
    return false;
  if (!equals(this.b13_1, other.b13_1))
    return false;
  if (!equals(this.c13_1, other.c13_1))
    return false;
  if (!this.d13_1.equals(other.d13_1))
    return false;
  return true;
};
function Alcohol() {
  this.e13_1 = 0.789;
  this.f13_1 = 7.0;
  this.g13_1 = 10.0;
}
protoOf(Alcohol).h13 = function (volumeMl, abvPct) {
  // Inline function 'kotlin.require' call
  if (!(volumeMl >= 0.0)) {
    var message = 'volumeMl must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(0.0 <= abvPct ? abvPct <= 100.0 : false)) {
    var message_0 = 'abvPct must be 0\u2013100';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  return volumeMl * abvPct / 100.0 * 0.789;
};
protoOf(Alcohol).i13 = function (volumeMl, abvPct, carbsPer100Ml, densityGPerMl) {
  // Inline function 'kotlin.require' call
  if (!(carbsPer100Ml >= 0.0)) {
    var message = 'carbsPer100Ml must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(densityGPerMl > 0.0)) {
    var message_0 = 'densityGPerMl must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var alcohol = this.h13(volumeMl, abvPct);
  var carbs = volumeMl * carbsPer100Ml / 100.0;
  var alcoholKcal = alcohol * 7.0;
  var kcal = alcoholKcal + carbs * 4.0;
  var grams = volumeMl * densityGPerMl;
  var tmp;
  if (grams > 0.0) {
    tmp = new Per100g(kcal / grams * 100.0, 0.0, 0.0, carbs / grams * 100.0, VOID, VOID, VOID, VOID, alcohol / grams * 100.0);
  } else {
    tmp = new Per100g(0.0, 0.0, 0.0, 0.0, VOID, VOID, VOID, VOID, 0.0);
  }
  var per100g = tmp;
  return new AlcoholEstimate(volumeMl, abvPct, alcohol, alcoholKcal, carbs, kcal, volumeMl * abvPct / 100.0 / 10.0, grams, per100g);
};
protoOf(Alcohol).j13 = function (drink, volumeMl, abvPct) {
  return this.i13(volumeMl, abvPct, drink.s12_1, drink.t12_1);
};
var Alcohol_instance;
function Alcohol_getInstance() {
  return Alcohol_instance;
}
function DrinkType_BEER_getInstance() {
  static_init_31();
  return DrinkType_BEER_instance;
}
function DrinkType_LAGER_getInstance() {
  static_init_31();
  return DrinkType_LAGER_instance;
}
function DrinkType_CIDER_getInstance() {
  static_init_31();
  return DrinkType_CIDER_instance;
}
function DrinkType_RED_WINE_getInstance() {
  static_init_31();
  return DrinkType_RED_WINE_instance;
}
function DrinkType_WHITE_WINE_getInstance() {
  static_init_31();
  return DrinkType_WHITE_WINE_instance;
}
function DrinkType_ROSE_WINE_getInstance() {
  static_init_31();
  return DrinkType_ROSE_WINE_instance;
}
function DrinkType_SPARKLING_WINE_getInstance() {
  static_init_31();
  return DrinkType_SPARKLING_WINE_instance;
}
function DrinkType_SPIRITS_getInstance() {
  static_init_31();
  return DrinkType_SPIRITS_instance;
}
function DrinkType_SPIRIT_AND_MIXER_getInstance() {
  static_init_31();
  return DrinkType_SPIRIT_AND_MIXER_instance;
}
function DrinkType_COCKTAIL_getInstance() {
  static_init_31();
  return DrinkType_COCKTAIL_instance;
}
function Companion_5() {
}
protoOf(Companion_5).k13 = function (day, foodKey, name, grams, per100g) {
  return new NutrientEntry(day, foodKey, name, per100g.l13_1 * grams / 100.0, per100g.v13(grams));
};
var Companion_instance_7;
function Companion_getInstance_5() {
  return Companion_instance_7;
}
function NutrientEntry(day, foodKey, name, kcal, amounts) {
  this.w13_1 = day;
  this.x13_1 = foodKey;
  this.y13_1 = name;
  this.z13_1 = kcal;
  this.a14_1 = amounts;
}
protoOf(NutrientEntry).toString = function () {
  return 'NutrientEntry(day=' + this.w13_1 + ', foodKey=' + this.x13_1 + ', name=' + this.y13_1 + ', kcal=' + this.z13_1 + ', amounts=' + toString(this.a14_1) + ')';
};
protoOf(NutrientEntry).hashCode = function () {
  var result = this.w13_1;
  result = imul(result, 31) + getStringHashCode(this.x13_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.y13_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.z13_1) | 0;
  result = imul(result, 31) + hashCode(this.a14_1) | 0;
  return result;
};
protoOf(NutrientEntry).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientEntry))
    return false;
  if (!(this.w13_1 === other.w13_1))
    return false;
  if (!(this.x13_1 === other.x13_1))
    return false;
  if (!(this.y13_1 === other.y13_1))
    return false;
  if (!equals(this.z13_1, other.z13_1))
    return false;
  if (!equals(this.a14_1, other.a14_1))
    return false;
  return true;
};
function Completeness(key, byKcal, byEntries, entries, entriesWithValue) {
  this.b14_1 = key;
  this.c14_1 = byKcal;
  this.d14_1 = byEntries;
  this.e14_1 = entries;
  this.f14_1 = entriesWithValue;
}
protoOf(Completeness).toString = function () {
  return 'Completeness(key=' + this.b14_1 + ', byKcal=' + this.c14_1 + ', byEntries=' + this.d14_1 + ', entries=' + this.e14_1 + ', entriesWithValue=' + this.f14_1 + ')';
};
protoOf(Completeness).hashCode = function () {
  var result = getStringHashCode(this.b14_1);
  result = imul(result, 31) + (this.c14_1 == null ? 0 : getNumberHashCode(this.c14_1)) | 0;
  result = imul(result, 31) + (this.d14_1 == null ? 0 : getNumberHashCode(this.d14_1)) | 0;
  result = imul(result, 31) + this.e14_1 | 0;
  result = imul(result, 31) + this.f14_1 | 0;
  return result;
};
protoOf(Completeness).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Completeness))
    return false;
  if (!(this.b14_1 === other.b14_1))
    return false;
  if (!equals(this.c14_1, other.c14_1))
    return false;
  if (!equals(this.d14_1, other.d14_1))
    return false;
  if (!(this.e14_1 === other.e14_1))
    return false;
  if (!(this.f14_1 === other.f14_1))
    return false;
  return true;
};
function Contributor(foodKey, name, amount, share, entries) {
  this.g14_1 = foodKey;
  this.h14_1 = name;
  this.i14_1 = amount;
  this.j14_1 = share;
  this.k14_1 = entries;
}
protoOf(Contributor).toString = function () {
  return 'Contributor(foodKey=' + this.g14_1 + ', name=' + this.h14_1 + ', amount=' + this.i14_1 + ', share=' + this.j14_1 + ', entries=' + this.k14_1 + ')';
};
protoOf(Contributor).hashCode = function () {
  var result = getStringHashCode(this.g14_1);
  result = imul(result, 31) + getStringHashCode(this.h14_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.i14_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.j14_1) | 0;
  result = imul(result, 31) + this.k14_1 | 0;
  return result;
};
protoOf(Contributor).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Contributor))
    return false;
  if (!(this.g14_1 === other.g14_1))
    return false;
  if (!(this.h14_1 === other.h14_1))
    return false;
  if (!equals(this.i14_1, other.i14_1))
    return false;
  if (!equals(this.j14_1, other.j14_1))
    return false;
  if (!(this.k14_1 === other.k14_1))
    return false;
  return true;
};
function DailyNutrient(day, amount, completenessByKcal) {
  this.l14_1 = day;
  this.m14_1 = amount;
  this.n14_1 = completenessByKcal;
}
protoOf(DailyNutrient).toString = function () {
  return 'DailyNutrient(day=' + this.l14_1 + ', amount=' + this.m14_1 + ', completenessByKcal=' + this.n14_1 + ')';
};
protoOf(DailyNutrient).hashCode = function () {
  var result = this.l14_1;
  result = imul(result, 31) + getNumberHashCode(this.m14_1) | 0;
  result = imul(result, 31) + (this.n14_1 == null ? 0 : getNumberHashCode(this.n14_1)) | 0;
  return result;
};
protoOf(DailyNutrient).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DailyNutrient))
    return false;
  if (!(this.l14_1 === other.l14_1))
    return false;
  if (!equals(this.m14_1, other.m14_1))
    return false;
  if (!equals(this.n14_1, other.n14_1))
    return false;
  return true;
};
function NutrientDay(day, amount, completenessByKcal, average7) {
  this.o14_1 = day;
  this.p14_1 = amount;
  this.q14_1 = completenessByKcal;
  this.r14_1 = average7;
}
protoOf(NutrientDay).toString = function () {
  return 'NutrientDay(day=' + this.o14_1 + ', amount=' + this.p14_1 + ', completenessByKcal=' + this.q14_1 + ', average7=' + this.r14_1 + ')';
};
protoOf(NutrientDay).hashCode = function () {
  var result = this.o14_1;
  result = imul(result, 31) + (this.p14_1 == null ? 0 : getNumberHashCode(this.p14_1)) | 0;
  result = imul(result, 31) + (this.q14_1 == null ? 0 : getNumberHashCode(this.q14_1)) | 0;
  result = imul(result, 31) + (this.r14_1 == null ? 0 : getNumberHashCode(this.r14_1)) | 0;
  return result;
};
protoOf(NutrientDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientDay))
    return false;
  if (!(this.o14_1 === other.o14_1))
    return false;
  if (!equals(this.p14_1, other.p14_1))
    return false;
  if (!equals(this.q14_1, other.q14_1))
    return false;
  if (!equals(this.r14_1, other.r14_1))
    return false;
  return true;
};
function WeeklyNutrient(weekStart, dailyAverage, days) {
  this.s14_1 = weekStart;
  this.t14_1 = dailyAverage;
  this.u14_1 = days;
}
protoOf(WeeklyNutrient).toString = function () {
  return 'WeeklyNutrient(weekStart=' + this.s14_1 + ', dailyAverage=' + this.t14_1 + ', days=' + this.u14_1 + ')';
};
protoOf(WeeklyNutrient).hashCode = function () {
  var result = this.s14_1;
  result = imul(result, 31) + getNumberHashCode(this.t14_1) | 0;
  result = imul(result, 31) + this.u14_1 | 0;
  return result;
};
protoOf(WeeklyNutrient).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeeklyNutrient))
    return false;
  if (!(this.s14_1 === other.s14_1))
    return false;
  if (!equals(this.t14_1, other.t14_1))
    return false;
  if (!(this.u14_1 === other.u14_1))
    return false;
  return true;
};
function NutrientAverages(key, dailyAverage, days, weekly) {
  this.v14_1 = key;
  this.w14_1 = dailyAverage;
  this.x14_1 = days;
  this.y14_1 = weekly;
}
protoOf(NutrientAverages).toString = function () {
  return 'NutrientAverages(key=' + this.v14_1 + ', dailyAverage=' + this.w14_1 + ', days=' + this.x14_1 + ', weekly=' + toString(this.y14_1) + ')';
};
protoOf(NutrientAverages).hashCode = function () {
  var result = getStringHashCode(this.v14_1);
  result = imul(result, 31) + (this.w14_1 == null ? 0 : getNumberHashCode(this.w14_1)) | 0;
  result = imul(result, 31) + this.x14_1 | 0;
  result = imul(result, 31) + hashCode(this.y14_1) | 0;
  return result;
};
protoOf(NutrientAverages).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientAverages))
    return false;
  if (!(this.v14_1 === other.v14_1))
    return false;
  if (!equals(this.w14_1, other.w14_1))
    return false;
  if (!(this.x14_1 === other.x14_1))
    return false;
  if (!equals(this.y14_1, other.y14_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_3(function_0) {
  this.z14_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_3).y9 = function (a, b) {
  return this.z14_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_3).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_3).g2 = function () {
  return this.z14_1;
};
protoOf(sam$kotlin_Comparator$0_3).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_3).hashCode = function () {
  return hashCode(this.g2());
};
function sam$kotlin_Comparator$0_4(function_0) {
  this.a15_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_4).y9 = function (a, b) {
  return this.a15_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_4).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_4).g2 = function () {
  return this.a15_1;
};
protoOf(sam$kotlin_Comparator$0_4).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_4).hashCode = function () {
  return hashCode(this.g2());
};
function sam$kotlin_Comparator$0_5(function_0) {
  this.b15_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_5).y9 = function (a, b) {
  return this.b15_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_5).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_5).g2 = function () {
  return this.b15_1;
};
protoOf(sam$kotlin_Comparator$0_5).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_5).hashCode = function () {
  return hashCode(this.g2());
};
function NutrientAnalysis$topContributors$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.i14_1;
  var tmp$ret$2 = a.i14_1;
  return compareValues(tmp, tmp$ret$2);
}
function NutrientAnalysis$topContributors$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.h14_1;
      var tmp$ret$2 = b.h14_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function NutrientAnalysis$topContributors$lambda_1($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.g14_1;
      var tmp$ret$2 = b.g14_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function NutrientAnalysis$dailyTotals$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o1();
  var tmp$ret$2 = b.o1();
  return compareValues(tmp, tmp$ret$2);
}
function NutrientAnalysis$averages$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o1();
  var tmp$ret$2 = b.o1();
  return compareValues(tmp, tmp$ret$2);
}
function NutrientAnalysis() {
  this.c15_1 = 7;
}
protoOf(NutrientAnalysis).d15 = function (entries, key, fromDay, toDay) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = entries.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsArg = element.w13_1;
    if (fromDay <= containsArg ? containsArg <= toDay : false) {
      destination.f(element);
    }
  }
  var inRange = destination;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = inRange.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = element_0.a14_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).q1(key)) {
      destination_0.f(element_0);
    }
  }
  var known = destination_0;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s_1 = inRange.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp = sum;
    sum = tmp + element_1.z13_1;
  }
  var totalKcal = sum;
  var tmp_0;
  if (totalKcal > 0.0) {
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_2 = known.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_2 = _iterator__ex2g4s_2.l();
      var tmp_1 = sum_0;
      sum_0 = tmp_1 + element_2.z13_1;
    }
    tmp_0 = sum_0 / totalKcal;
  } else {
    tmp_0 = null;
  }
  return new Completeness(key, tmp_0, inRange.m() ? null : known.o() / inRange.o(), inRange.o(), known.o());
};
protoOf(NutrientAnalysis).e15 = function (entries, fromDay, toDay, keys) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(keys, 10));
  var _iterator__ex2g4s = keys.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = NutrientAnalysis_instance.d15(entries, item, fromDay, toDay);
    destination.f(tmp$ret$2);
  }
  return destination;
};
protoOf(NutrientAnalysis).f15 = function (entries, fromDay, toDay, keys, $super) {
  keys = keys === VOID ? Nutrients_getInstance().q15_1 : keys;
  return $super === VOID ? this.e15(entries, fromDay, toDay, keys) : $super.e15.call(this, entries, fromDay, toDay, keys);
};
protoOf(NutrientAnalysis).r15 = function (entries, key, fromDay, toDay, limit) {
  // Inline function 'kotlin.require' call
  if (!(limit > 0)) {
    var message = 'limit must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = entries.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp;
    var containsArg = element.w13_1;
    if (fromDay <= containsArg ? containsArg <= toDay : false) {
      var tmp0_elvis_lhs = element.a14_1.s1(key);
      tmp = (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) > 0.0;
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.f(element);
    }
  }
  var known = destination;
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s_0 = known.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp_0 = sum;
    sum = tmp_0 + getValue(element_0.a14_1, key);
  }
  var total = sum;
  if (total <= 0.0)
    return emptyList();
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_1 = known.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var key_0 = element_1.x13_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.s1(key_0);
    var tmp_1;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.k2(key_0, answer);
      tmp_1 = answer;
    } else {
      tmp_1 = value;
    }
    var list = tmp_1;
    list.f(element_1);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(destination_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = destination_0.v1().j();
  while (_iterator__ex2g4s_2.k()) {
    var item = _iterator__ex2g4s_2.l();
    // Inline function 'kotlin.collections.component1' call
    var foodKey = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var group = item.p1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_3 = group.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_2 = _iterator__ex2g4s_3.l();
      var tmp_2 = sum_0;
      sum_0 = tmp_2 + getValue(element_2.a14_1, key);
    }
    var amount = sum_0;
    var tmp$ret$15 = new Contributor(foodKey, first(group).y13_1, amount, amount / total, group.o());
    destination_1.f(tmp$ret$15);
  }
  var tmp_3 = destination_1;
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_4 = NutrientAnalysis$topContributors$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_3(tmp_4);
  var tmp_5 = NutrientAnalysis$topContributors$lambda_0(this_0);
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_1 = new sam$kotlin_Comparator$0_3(tmp_5);
  var tmp_6 = NutrientAnalysis$topContributors$lambda_1(this_1);
  var tmp$ret$22 = new sam$kotlin_Comparator$0_3(tmp_6);
  return take(sortedWith(tmp_3, tmp$ret$22), limit);
};
protoOf(NutrientAnalysis).s15 = function (entries, key, fromDay, toDay) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = entries.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsArg = element.w13_1;
    if (fromDay <= containsArg ? containsArg <= toDay : false) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key_0 = element_0.w13_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.s1(key_0);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.k2(key_0, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination_0.v1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = NutrientAnalysis$dailyTotals$lambda;
  var tmp$ret$9 = new sam$kotlin_Comparator$0_4(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$9);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_1 = this_1.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var day = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var group = item.p1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_2 = group.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_1 = sum;
      sum = tmp_1 + element_1.z13_1;
    }
    var kcal = sum;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_2 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_3 = group.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_2 = _iterator__ex2g4s_3.l();
      // Inline function 'kotlin.collections.contains' call
      // Inline function 'kotlin.collections.containsKey' call
      var this_2 = element_2.a14_1;
      if ((isInterface(this_2, KtMap) ? this_2 : THROW_CCE()).q1(key)) {
        destination_2.f(element_2);
      }
    }
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_4 = destination_2.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_3 = _iterator__ex2g4s_4.l();
      var tmp_2 = sum_0;
      sum_0 = tmp_2 + element_3.z13_1;
    }
    var knownKcal = sum_0;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_1 = 0;
    var _iterator__ex2g4s_5 = group.j();
    while (_iterator__ex2g4s_5.k()) {
      var element_4 = _iterator__ex2g4s_5.l();
      var tmp_3 = sum_1;
      var tmp0_elvis_lhs = element_4.a14_1.s1(key);
      sum_1 = tmp_3 + (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
    }
    var tmp$ret$24 = sum_1;
    var tmp$ret$12 = new DailyNutrient(day, tmp$ret$24, kcal > 0.0 ? knownKcal / kcal : null);
    destination_1.f(tmp$ret$12);
  }
  return destination_1;
};
protoOf(NutrientAnalysis).t15 = function (entries, key, fromDay, toDay) {
  // Inline function 'kotlin.require' call
  if (!(toDay >= fromDay)) {
    var message = 'toDay must not be before fromDay';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = entries.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.contains' call
    // Inline function 'kotlin.collections.containsKey' call
    var this_0 = element.a14_1;
    if ((isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).q1(key)) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$9 = item.w13_1;
    destination_0.f(tmp$ret$9);
  }
  var daysWithValue = toSet(destination_0);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = this.s15(entries, key, fromDay - 6 | 0, toDay);
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = tmp0.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_0 = _iterator__ex2g4s_1.l();
    if (daysWithValue.r(element_0.l14_1)) {
      destination_1.f(element_0);
    }
  }
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination_1, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_2 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_2 = destination_1.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_1 = _iterator__ex2g4s_2.l();
    var tmp$ret$15 = element_1.l14_1;
    destination_2.k2(tmp$ret$15, element_1);
  }
  var known = destination_2;
  // Inline function 'kotlin.collections.map' call
  var this_1 = numberRangeToNumber(fromDay, toDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var inductionVariable = this_1.oc_1;
  var last = this_1.pc_1;
  if (inductionVariable <= last)
    do {
      var item_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var day = item_0;
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = numberRangeToNumber(day - 6 | 0, day);
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_4 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var inductionVariable_0 = tmp0_0.oc_1;
      var last_0 = tmp0_0.pc_1;
      if (inductionVariable_0 <= last_0)
        do {
          var element_2 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var it = element_2;
          var tmp0_safe_receiver = known.s1(it);
          var tmp0_safe_receiver_0 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m14_1;
          if (tmp0_safe_receiver_0 == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination_4.f(tmp0_safe_receiver_0);
          }
        }
         while (!(element_2 === last_0));
      var window_0 = destination_4;
      var tmp0_safe_receiver_1 = known.s1(day);
      var tmp = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1.m14_1;
      var tmp1_safe_receiver = known.s1(day);
      var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.n14_1;
      // Inline function 'kotlin.takeIf' call
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!window_0.m()) {
        tmp_1 = window_0;
      } else {
        tmp_1 = null;
      }
      var tmp2_safe_receiver = tmp_1;
      var tmp$ret$18 = new NutrientDay(day, tmp, tmp_0, tmp2_safe_receiver == null ? null : average(tmp2_safe_receiver));
      destination_3.f(tmp$ret$18);
    }
     while (!(item_0 === last));
  return destination_3;
};
protoOf(NutrientAnalysis).u15 = function (entries, key, fromDay, toDay) {
  var daily = this.s15(entries, key, fromDay, toDay);
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = daily.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key_0 = EpochDays_getInstance().ud(element.l14_1);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.s1(key_0);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.k2(key_0, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination.v1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = NutrientAnalysis$averages$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_5(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$6);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var start = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var days = item.p1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_1 = days.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      var tmp_1 = sum;
      sum = tmp_1 + element_0.m14_1;
    }
    var tmp$ret$12 = sum;
    var tmp$ret$9 = new WeeklyNutrient(start, tmp$ret$12 / days.o(), days.o());
    destination_0.f(tmp$ret$9);
  }
  var weekly = destination_0;
  var tmp_2;
  if (daily.m()) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_2 = daily.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_3 = sum_0;
      sum_0 = tmp_3 + element_1.m14_1;
    }
    tmp_2 = sum_0 / daily.o();
  }
  return new NutrientAverages(key, tmp_2, daily.o(), weekly);
};
var NutrientAnalysis_instance;
function NutrientAnalysis_getInstance() {
  return NutrientAnalysis_instance;
}
function FocusDay(day, amount, average7, goal, status) {
  this.v15_1 = day;
  this.w15_1 = amount;
  this.x15_1 = average7;
  this.y15_1 = goal;
  this.z15_1 = status;
}
protoOf(FocusDay).toString = function () {
  return 'FocusDay(day=' + this.v15_1 + ', amount=' + this.w15_1 + ', average7=' + this.x15_1 + ', goal=' + toString_0(this.y15_1) + ', status=' + this.z15_1.toString() + ')';
};
protoOf(FocusDay).hashCode = function () {
  var result = this.v15_1;
  result = imul(result, 31) + (this.w15_1 == null ? 0 : getNumberHashCode(this.w15_1)) | 0;
  result = imul(result, 31) + (this.x15_1 == null ? 0 : getNumberHashCode(this.x15_1)) | 0;
  result = imul(result, 31) + (this.y15_1 == null ? 0 : this.y15_1.hashCode()) | 0;
  result = imul(result, 31) + this.z15_1.hashCode() | 0;
  return result;
};
protoOf(FocusDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FocusDay))
    return false;
  if (!(this.v15_1 === other.v15_1))
    return false;
  if (!equals(this.w15_1, other.w15_1))
    return false;
  if (!equals(this.x15_1, other.x15_1))
    return false;
  if (!equals(this.y15_1, other.y15_1))
    return false;
  if (!this.z15_1.equals(other.z15_1))
    return false;
  return true;
};
function Companion_6() {
}
protoOf(Companion_6).a16 = function (entries, key, fromDay, toDay, setting, default_0, bodyWeightKg, energyKcal) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientAnalysis_instance.t15(entries, key, fromDay, toDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var goal = NutrientGoalHistory_instance.b16(item.o14_1, key, setting, default_0, bodyWeightKg, energyKcal);
    var tmp$ret$2 = new FocusDay(item.o14_1, item.p14_1, item.r14_1, goal, NutrientGoalMethods_getInstance().d16(item.p14_1, goal));
    destination.f(tmp$ret$2);
  }
  var days = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = days.j();
  while (_iterator__ex2g4s_0.k()) {
    var element = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver = element.w15_1;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver);
    }
  }
  var known = destination_0;
  var tmp0_elvis_lhs = Nutrients_getInstance().e16(key);
  var tmp = tmp0_elvis_lhs == null ? new NutrientInfo(key, key, '') : tmp0_elvis_lhs;
  // Inline function 'kotlin.takeIf' call
  var tmp_0;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!known.m()) {
    tmp_0 = known;
  } else {
    tmp_0 = null;
  }
  var tmp1_safe_receiver = tmp_0;
  var tmp_1 = tmp1_safe_receiver == null ? null : average(tmp1_safe_receiver);
  var tmp_2 = known.o();
  var tmp$ret$13;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp_3;
    if (isInterface(days, Collection)) {
      tmp_3 = days.m();
    } else {
      tmp_3 = false;
    }
    if (tmp_3) {
      tmp$ret$13 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s_1 = days.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      if (element_0.z15_1.equals(GoalStatus_ON_TARGET_getInstance())) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$13 = count;
  }
  return new NutrientFocus(tmp, days, tmp_1, tmp_2, tmp$ret$13, setting, NutrientGoalHistory_instance.f16(key, setting, default_0, bodyWeightKg, energyKcal));
};
var Companion_instance_8;
function Companion_getInstance_6() {
  return Companion_instance_8;
}
function NutrientFocus(info, days, average, loggedDays, goalDays, setting, periods) {
  this.g16_1 = info;
  this.h16_1 = days;
  this.i16_1 = average;
  this.j16_1 = loggedDays;
  this.k16_1 = goalDays;
  this.l16_1 = setting;
  this.m16_1 = periods;
}
protoOf(NutrientFocus).toString = function () {
  return 'NutrientFocus(info=' + this.g16_1.toString() + ', days=' + toString(this.h16_1) + ', average=' + this.i16_1 + ', loggedDays=' + this.j16_1 + ', goalDays=' + this.k16_1 + ', setting=' + toString_0(this.l16_1) + ', periods=' + toString(this.m16_1) + ')';
};
protoOf(NutrientFocus).hashCode = function () {
  var result = this.g16_1.hashCode();
  result = imul(result, 31) + hashCode(this.h16_1) | 0;
  result = imul(result, 31) + (this.i16_1 == null ? 0 : getNumberHashCode(this.i16_1)) | 0;
  result = imul(result, 31) + this.j16_1 | 0;
  result = imul(result, 31) + this.k16_1 | 0;
  result = imul(result, 31) + (this.l16_1 == null ? 0 : this.l16_1.hashCode()) | 0;
  result = imul(result, 31) + hashCode(this.m16_1) | 0;
  return result;
};
protoOf(NutrientFocus).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientFocus))
    return false;
  if (!this.g16_1.equals(other.g16_1))
    return false;
  if (!equals(this.h16_1, other.h16_1))
    return false;
  if (!equals(this.i16_1, other.i16_1))
    return false;
  if (!(this.j16_1 === other.j16_1))
    return false;
  if (!(this.k16_1 === other.k16_1))
    return false;
  if (!equals(this.l16_1, other.l16_1))
    return false;
  if (!equals(this.m16_1, other.m16_1))
    return false;
  return true;
};
var static_init_called_32;
function static_init_32() {
  if (static_init_called_32)
    return Unit_instance;
  static_init_called_32 = true;
  GoalMethod_FIXED_instance = new GoalMethod('FIXED', 0, 'fixed', 'Fixed amount');
  GoalMethod_PER_KG_instance = new GoalMethod('PER_KG', 1, 'perKg', 'Per kg of body weight');
  GoalMethod_PER_1000_KCAL_instance = new GoalMethod('PER_1000_KCAL', 2, 'perKcal', 'Per 1,000 kcal of the calorie target');
  GoalMethod_PCT_ENERGY_instance = new GoalMethod('PCT_ENERGY', 3, 'pctEnergy', '% of the calorie target');
  if (Companion_instance_9 == null) {
    Companion_instance_0;
    new Companion_7();
  }
}
var GoalMethod_FIXED_instance;
var GoalMethod_PER_KG_instance;
var GoalMethod_PER_1000_KCAL_instance;
var GoalMethod_PCT_ENERGY_instance;
function Companion_7() {
}
protoOf(Companion_7).n16 = function (value) {
  var tmp0 = get_entries_19();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.q16_1 === value) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_9;
function Companion_getInstance_7() {
  return Companion_instance_9;
}
function values_24() {
  static_init_32();
  return [GoalMethod_FIXED_getInstance(), GoalMethod_PER_KG_getInstance(), GoalMethod_PER_1000_KCAL_getInstance(), GoalMethod_PCT_ENERGY_getInstance()];
}
function get_entries_19() {
  static_init_32();
  if ($ENTRIES_19 == null)
    $ENTRIES_19 = enumEntries(values_24());
  return $ENTRIES_19;
}
var $ENTRIES_19;
function GoalMethod(name, ordinal, json, label) {
  Enum.call(this, name, ordinal);
  this.q16_1 = json;
  this.r16_1 = label;
}
var static_init_called_33;
function static_init_33() {
  if (static_init_called_33)
    return Unit_instance;
  static_init_called_33 = true;
  GoalStatus_UNKNOWN_instance = new GoalStatus('UNKNOWN', 0);
  GoalStatus_BELOW_FLOOR_instance = new GoalStatus('BELOW_FLOOR', 1);
  GoalStatus_BELOW_TARGET_instance = new GoalStatus('BELOW_TARGET', 2);
  GoalStatus_ON_TARGET_instance = new GoalStatus('ON_TARGET', 3);
  GoalStatus_ABOVE_CEILING_instance = new GoalStatus('ABOVE_CEILING', 4);
}
var GoalStatus_UNKNOWN_instance;
var GoalStatus_BELOW_FLOOR_instance;
var GoalStatus_BELOW_TARGET_instance;
var GoalStatus_ON_TARGET_instance;
var GoalStatus_ABOVE_CEILING_instance;
function GoalStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function NutrientGoalSetting(floor, target, ceiling, method, since) {
  method = method === VOID ? GoalMethod_FIXED_getInstance() : method;
  since = since === VOID ? null : since;
  this.s16_1 = floor;
  this.t16_1 = target;
  this.u16_1 = ceiling;
  this.v16_1 = method;
  this.w16_1 = since;
}
protoOf(NutrientGoalSetting).x16 = function () {
  var tmp0_safe_receiver = this.w16_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = EpochDays_getInstance().rd(tmp0_safe_receiver);
  }
  return tmp;
};
protoOf(NutrientGoalSetting).y16 = function (key, bodyWeightKg, energyKcal) {
  var tmp0_elvis_lhs = NutrientGoalMethods_getInstance().z16(key, this.v16_1, bodyWeightKg, energyKcal);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var factor = tmp;
  var tmp1_safe_receiver = this.s16_1;
  var tmp_0 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver * factor;
  var tmp2_safe_receiver = this.t16_1;
  var tmp_1 = tmp2_safe_receiver == null ? null : tmp2_safe_receiver * factor;
  var tmp3_safe_receiver = this.u16_1;
  return new NutrientGoal(tmp_0, tmp_1, tmp3_safe_receiver == null ? null : tmp3_safe_receiver * factor);
};
protoOf(NutrientGoalSetting).toString = function () {
  return 'NutrientGoalSetting(floor=' + this.s16_1 + ', target=' + this.t16_1 + ', ceiling=' + this.u16_1 + ', method=' + this.v16_1.toString() + ', since=' + this.w16_1 + ')';
};
protoOf(NutrientGoalSetting).hashCode = function () {
  var result = this.s16_1 == null ? 0 : getNumberHashCode(this.s16_1);
  result = imul(result, 31) + (this.t16_1 == null ? 0 : getNumberHashCode(this.t16_1)) | 0;
  result = imul(result, 31) + (this.u16_1 == null ? 0 : getNumberHashCode(this.u16_1)) | 0;
  result = imul(result, 31) + this.v16_1.hashCode() | 0;
  result = imul(result, 31) + (this.w16_1 == null ? 0 : getStringHashCode(this.w16_1)) | 0;
  return result;
};
protoOf(NutrientGoalSetting).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientGoalSetting))
    return false;
  if (!equals(this.s16_1, other.s16_1))
    return false;
  if (!equals(this.t16_1, other.t16_1))
    return false;
  if (!equals(this.u16_1, other.u16_1))
    return false;
  if (!this.v16_1.equals(other.v16_1))
    return false;
  if (!(this.w16_1 == other.w16_1))
    return false;
  return true;
};
function NutrientGoalMethods() {
  NutrientGoalMethods_instance = this;
  this.c16_1 = mapOf_0([to('protein', 4.0), to('carbs', 4.0), to('sugar', 4.0), to('fat', 9.0), to('satFat', 9.0), to('monoFat', 9.0), to('polyFat', 9.0), to('transFat', 9.0), to('alcohol', 7.0)]);
}
protoOf(NutrientGoalMethods).a17 = function (key) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_entries_19();
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp;
    switch (element.x1_1) {
      case 3:
        // Inline function 'kotlin.collections.contains' call

        // Inline function 'kotlin.collections.containsKey' call

        var this_0 = NutrientGoalMethods_getInstance().c16_1;
        tmp = (isInterface(this_0, KtMap) ? this_0 : THROW_CCE()).q1(key);
        break;
      case 2:
        tmp = !(key === 'kcal');
        break;
      default:
        tmp = true;
        break;
    }
    if (tmp) {
      destination.f(element);
    }
  }
  return destination;
};
protoOf(NutrientGoalMethods).z16 = function (key, method, bodyWeightKg, energyKcal) {
  if (!this.a17(key).r(method))
    return null;
  var tmp;
  if (bodyWeightKg == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (bodyWeightKg > 0.0 && isFinite(bodyWeightKg)) {
      tmp_0 = bodyWeightKg;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var weight = tmp;
  var tmp_1;
  if (energyKcal == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_2;
    if (energyKcal > 0.0 && isFinite(energyKcal)) {
      tmp_2 = energyKcal;
    } else {
      tmp_2 = null;
    }
    tmp_1 = tmp_2;
  }
  var energy = tmp_1;
  var tmp_3;
  switch (method.x1_1) {
    case 0:
      tmp_3 = 1.0;
      break;
    case 1:
      tmp_3 = weight;
      break;
    case 2:
      tmp_3 = energy == null ? null : energy / 1000.0;
      break;
    case 3:
      var tmp_4;
      if (energy == null) {
        tmp_4 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_4 = energy / 100.0 / getValue(NutrientGoalMethods_getInstance().c16_1, key);
      }

      tmp_3 = tmp_4;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_3;
};
protoOf(NutrientGoalMethods).d16 = function (amount, goal) {
  if (amount == null || goal == null)
    return GoalStatus_UNKNOWN_getInstance();
  var floor = goal.ya();
  var target = goal.za();
  var ceiling = goal.e17();
  return !(ceiling == null) && amount > ceiling ? GoalStatus_ABOVE_CEILING_getInstance() : !(floor == null) && amount < floor ? GoalStatus_BELOW_FLOOR_getInstance() : !(target == null) && amount < target ? GoalStatus_BELOW_TARGET_getInstance() : floor == null && target == null && ceiling == null ? GoalStatus_UNKNOWN_getInstance() : GoalStatus_ON_TARGET_getInstance();
};
var NutrientGoalMethods_instance;
function NutrientGoalMethods_getInstance() {
  if (NutrientGoalMethods_instance == null)
    new NutrientGoalMethods();
  return NutrientGoalMethods_instance;
}
function NutrientGoalPeriod(fromDay, toDay, goal, custom, method) {
  this.f17_1 = fromDay;
  this.g17_1 = toDay;
  this.h17_1 = goal;
  this.i17_1 = custom;
  this.j17_1 = method;
}
protoOf(NutrientGoalPeriod).toString = function () {
  return 'NutrientGoalPeriod(fromDay=' + this.f17_1 + ', toDay=' + this.g17_1 + ', goal=' + toString_0(this.h17_1) + ', custom=' + this.i17_1 + ', method=' + this.j17_1.toString() + ')';
};
protoOf(NutrientGoalPeriod).hashCode = function () {
  var result = this.f17_1 == null ? 0 : this.f17_1;
  result = imul(result, 31) + (this.g17_1 == null ? 0 : this.g17_1) | 0;
  result = imul(result, 31) + (this.h17_1 == null ? 0 : this.h17_1.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.i17_1) | 0;
  result = imul(result, 31) + this.j17_1.hashCode() | 0;
  return result;
};
protoOf(NutrientGoalPeriod).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientGoalPeriod))
    return false;
  if (!(this.f17_1 == other.f17_1))
    return false;
  if (!(this.g17_1 == other.g17_1))
    return false;
  if (!equals(this.h17_1, other.h17_1))
    return false;
  if (!(this.i17_1 === other.i17_1))
    return false;
  if (!this.j17_1.equals(other.j17_1))
    return false;
  return true;
};
function NutrientGoalChange(key, name, unit, setting) {
  this.k17_1 = key;
  this.l17_1 = name;
  this.m17_1 = unit;
  this.n17_1 = setting;
}
protoOf(NutrientGoalChange).toString = function () {
  return 'NutrientGoalChange(key=' + this.k17_1 + ', name=' + this.l17_1 + ', unit=' + this.m17_1 + ', setting=' + this.n17_1.toString() + ')';
};
protoOf(NutrientGoalChange).hashCode = function () {
  var result = getStringHashCode(this.k17_1);
  result = imul(result, 31) + getStringHashCode(this.l17_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.m17_1) | 0;
  result = imul(result, 31) + this.n17_1.hashCode() | 0;
  return result;
};
protoOf(NutrientGoalChange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientGoalChange))
    return false;
  if (!(this.k17_1 === other.k17_1))
    return false;
  if (!(this.l17_1 === other.l17_1))
    return false;
  if (!(this.m17_1 === other.m17_1))
    return false;
  if (!this.n17_1.equals(other.n17_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_6(function_0) {
  this.o17_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_6).y9 = function (a, b) {
  return this.o17_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_6).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_6).g2 = function () {
  return this.o17_1;
};
protoOf(sam$kotlin_Comparator$0_6).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_6).hashCode = function () {
  return hashCode(this.g2());
};
function NutrientGoalHistory$changes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp0_elvis_lhs = b.n17_1.x16();
  var tmp = tmp0_elvis_lhs == null ? -2147483648 : tmp0_elvis_lhs;
  var tmp0_elvis_lhs_0 = a.n17_1.x16();
  var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? -2147483648 : tmp0_elvis_lhs_0;
  return compareValues(tmp, tmp$ret$2);
}
function NutrientGoalHistory$changes$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.l17_1;
      var tmp$ret$2 = b.l17_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function NutrientGoalHistory() {
}
protoOf(NutrientGoalHistory).b16 = function (day, key, setting, default_0, bodyWeightKg, energyKcal) {
  var since = setting == null ? null : setting.x16();
  return !(setting == null) && (since == null || day >= since) ? setting.y16(key, bodyWeightKg, energyKcal) : default_0;
};
protoOf(NutrientGoalHistory).f16 = function (key, setting, default_0, bodyWeightKg, energyKcal) {
  if (setting == null)
    return listOf_0(new NutrientGoalPeriod(null, null, default_0, false, GoalMethod_FIXED_getInstance()));
  var custom = new NutrientGoalPeriod(setting.x16(), null, setting.y16(key, bodyWeightKg, energyKcal), true, setting.v16_1);
  var tmp0_elvis_lhs = setting.x16();
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return listOf_0(custom);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var since = tmp;
  return listOf([new NutrientGoalPeriod(null, since - 1 | 0, default_0, false, GoalMethod_FIXED_getInstance()), custom]);
};
protoOf(NutrientGoalHistory).p17 = function (settings) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(settings.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = settings.v1().j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var setting = item.p1();
    var info = Nutrients_getInstance().e16(key);
    var tmp1_elvis_lhs = info == null ? null : info.r17_1;
    var tmp = tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = info == null ? null : info.s17_1;
    var tmp$ret$3 = new NutrientGoalChange(key, tmp, tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs, setting);
    destination.f(tmp$ret$3);
  }
  var tmp_0 = destination;
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_1 = NutrientGoalHistory$changes$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_6(tmp_1);
  var tmp_2 = NutrientGoalHistory$changes$lambda_0(this_0);
  var tmp$ret$7 = new sam$kotlin_Comparator$0_6(tmp_2);
  return sortedWith(tmp_0, tmp$ret$7);
};
var NutrientGoalHistory_instance;
function NutrientGoalHistory_getInstance() {
  return NutrientGoalHistory_instance;
}
function read$amount(map, name) {
  var tmp0_safe_receiver = JsonRead_instance.jq(map, name);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (isFinite(tmp0_safe_receiver) && tmp0_safe_receiver >= 0.0) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function NutrientGoalJson() {
}
protoOf(NutrientGoalJson).t17 = function (nutrientsJson) {
  // Inline function 'kotlin.runCatching' call
  var tmp;
  try {
    // Inline function 'kotlin.Companion.success' call
    var value = JsonRead_instance.l12(Json_instance.uf(nutrientsJson));
    tmp = _Result___init__impl__xyqfz8(value);
  } catch ($p) {
    var tmp_0;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_0 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp = tmp_0;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp;
  var tmp0_safe_receiver = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  var tmp_1 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s1('goals');
  var tmp1_elvis_lhs = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return emptyMap();
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var goals = tmp_2;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = goals.v1();
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$9;
    $l$block_1: {
      // Inline function 'kotlin.collections.component1' call
      var key = element.o1();
      // Inline function 'kotlin.collections.component2' call
      var value_0 = element.p1();
      var tmp0_elvis_lhs = (!(value_0 == null) ? isInterface(value_0, KtMap) : false) ? value_0 : null;
      var tmp_3;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$9 = null;
        break $l$block_1;
      } else {
        tmp_3 = tmp0_elvis_lhs;
      }
      var map = tmp_3;
      if (!(!(key == null) ? typeof key === 'string' : false)) {
        tmp$ret$9 = null;
        break $l$block_1;
      }
      var tmp_4;
      if (map.s1('method') == null) {
        tmp_4 = GoalMethod_FIXED_getInstance();
      } else {
        var tmp_5 = Companion_instance_9;
        var tmp_6 = map.s1('method');
        var tmp1_elvis_lhs_0 = tmp_5.n16((!(tmp_6 == null) ? typeof tmp_6 === 'string' : false) ? tmp_6 : null);
        var tmp_7;
        if (tmp1_elvis_lhs_0 == null) {
          tmp$ret$9 = null;
          break $l$block_1;
        } else {
          tmp_7 = tmp1_elvis_lhs_0;
        }
        tmp_4 = tmp_7;
      }
      var method = tmp_4;
      var tmp2_safe_receiver = JsonRead_instance.iq(map, 'since');
      var tmp_8;
      if (tmp2_safe_receiver == null) {
        tmp_8 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_9;
        if (!(EpochDays_getInstance().rd(tmp2_safe_receiver) == null)) {
          tmp_9 = tmp2_safe_receiver;
        } else {
          tmp_9 = null;
        }
        tmp_8 = tmp_9;
      }
      var since = tmp_8;
      tmp$ret$9 = to(key, new NutrientGoalSetting(read$amount(map, 'floor'), read$amount(map, 'target'), read$amount(map, 'ceiling'), method, since));
    }
    var tmp0_safe_receiver_0 = tmp$ret$9;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver_0);
    }
  }
  return toMap(destination);
};
protoOf(NutrientGoalJson).u17 = function (nutrientsJson, key, setting) {
  var tmp;
  if (nutrientsJson == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(nutrientsJson)) {
      tmp_0 = nutrientsJson;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_safe_receiver = tmp;
  var tmp_1;
  if (tmp1_safe_receiver == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    var tmp_2;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = JsonRead_instance.l12(Json_instance.uf(tmp1_safe_receiver));
      tmp_2 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_3;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_3 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_2 = tmp_3;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_2;
    tmp_1 = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  var tmp2_elvis_lhs = tmp_1;
  var data = tmp2_elvis_lhs == null ? emptyMap() : tmp2_elvis_lhs;
  var tmp_4 = data.s1('goals');
  var tmp3_elvis_lhs = (!(tmp_4 == null) ? isInterface(tmp_4, KtMap) : false) ? tmp_4 : null;
  var goals = LinkedHashMap_init_$Create$_0(tmp3_elvis_lhs == null ? emptyMap() : tmp3_elvis_lhs);
  if (setting == null) {
    goals.d4(key);
  } else {
    var tmp_5 = goals.s1(key);
    var tmp4_elvis_lhs = (!(tmp_5 == null) ? isInterface(tmp_5, KtMap) : false) ? tmp_5 : null;
    var previous = tmp4_elvis_lhs == null ? emptyMap() : tmp4_elvis_lhs;
    var goal = LinkedHashMap_init_$Create$_0(previous);
    // Inline function 'kotlin.collections.set' call
    var value_0 = setting.s16_1;
    goal.k2('floor', value_0);
    // Inline function 'kotlin.collections.set' call
    var value_1 = setting.t16_1;
    goal.k2('target', value_1);
    // Inline function 'kotlin.collections.set' call
    var value_2 = setting.u16_1;
    goal.k2('ceiling', value_2);
    if (setting.v16_1.equals(GoalMethod_FIXED_getInstance()))
      goal.d4('method');
    else {
      // Inline function 'kotlin.collections.set' call
      var value_3 = setting.v16_1.q16_1;
      goal.k2('method', value_3);
    }
    if (setting.w16_1 == null)
      goal.d4('since');
    else {
      // Inline function 'kotlin.collections.set' call
      var value_4 = setting.w16_1;
      goal.k2('since', value_4);
    }
    // Inline function 'kotlin.collections.set' call
    goals.k2(key, goal);
  }
  var out = LinkedHashMap_init_$Create$_0(data);
  if (out.s1('pinned') == null) {
    // Inline function 'kotlin.collections.set' call
    var value_5 = emptyList();
    out.k2('pinned', value_5);
  }
  // Inline function 'kotlin.collections.set' call
  out.k2('goals', goals);
  return Json_instance.zf(out);
};
var NutrientGoalJson_instance;
function NutrientGoalJson_getInstance() {
  return NutrientGoalJson_instance;
}
function GoalMethod_FIXED_getInstance() {
  static_init_32();
  return GoalMethod_FIXED_instance;
}
function GoalMethod_PER_KG_getInstance() {
  static_init_32();
  return GoalMethod_PER_KG_instance;
}
function GoalMethod_PER_1000_KCAL_getInstance() {
  static_init_32();
  return GoalMethod_PER_1000_KCAL_instance;
}
function GoalMethod_PCT_ENERGY_getInstance() {
  static_init_32();
  return GoalMethod_PCT_ENERGY_instance;
}
function GoalStatus_UNKNOWN_getInstance() {
  static_init_33();
  return GoalStatus_UNKNOWN_instance;
}
function GoalStatus_BELOW_FLOOR_getInstance() {
  static_init_33();
  return GoalStatus_BELOW_FLOOR_instance;
}
function GoalStatus_BELOW_TARGET_getInstance() {
  static_init_33();
  return GoalStatus_BELOW_TARGET_instance;
}
function GoalStatus_ON_TARGET_getInstance() {
  static_init_33();
  return GoalStatus_ON_TARGET_instance;
}
function GoalStatus_ABOVE_CEILING_getInstance() {
  static_init_33();
  return GoalStatus_ABOVE_CEILING_instance;
}
function NutrientJson() {
}
protoOf(NutrientJson).v17 = function (json) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.yq(Json_instance.uf(json));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block_2: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_2;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var map = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.xq(map, 'day');
      var tmp_0;
      if (tmp1_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_2;
      } else {
        tmp_0 = tmp1_elvis_lhs;
      }
      var day = tmp_0;
      var tmp2_safe_receiver = JsonRead_instance.jq(map, 'grams');
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_2;
        if (tmp2_safe_receiver > 0.0) {
          tmp_2 = tmp2_safe_receiver;
        } else {
          tmp_2 = null;
        }
        tmp_1 = tmp_2;
      }
      var tmp3_elvis_lhs = tmp_1;
      var tmp_3;
      if (tmp3_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_2;
      } else {
        tmp_3 = tmp3_elvis_lhs;
      }
      var grams = tmp_3;
      var tmp_4 = map.s1('per100g');
      var tmp4_safe_receiver = (!(tmp_4 == null) ? isInterface(tmp_4, KtMap) : false) ? tmp_4 : null;
      var tmp_5;
      if (tmp4_safe_receiver == null) {
        tmp_5 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_5 = NutrientJson_instance.w17(tmp4_safe_receiver);
      }
      var tmp5_elvis_lhs = tmp_5;
      var tmp_6;
      if (tmp5_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block_2;
      } else {
        tmp_6 = tmp5_elvis_lhs;
      }
      var per100g = tmp_6;
      var tmp6_elvis_lhs = JsonRead_instance.iq(map, 'name');
      var name = tmp6_elvis_lhs == null ? '' : tmp6_elvis_lhs;
      var tmp7_elvis_lhs = JsonRead_instance.iq(map, 'foodKey');
      var tmp8_elvis_lhs = tmp7_elvis_lhs == null ? JsonRead_instance.iq(map, 'foodId') : tmp7_elvis_lhs;
      var key = tmp8_elvis_lhs == null ? name : tmp8_elvis_lhs;
      tmp$ret$4 = Companion_instance_7.k13(day, key, name, grams, per100g);
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
};
protoOf(NutrientJson).w17 = function (map) {
  var tmp0_safe_receiver = JsonRead_instance.jq(map, 'kcal');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp0_safe_receiver >= 0.0) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var kcal = tmp_1;
  var tmp2_safe_receiver = JsonRead_instance.jq(map, 'protein');
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_3;
    if (tmp2_safe_receiver >= 0.0) {
      tmp_3 = tmp2_safe_receiver;
    } else {
      tmp_3 = null;
    }
    tmp_2 = tmp_3;
  }
  var tmp3_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var protein = tmp_4;
  var tmp4_safe_receiver = JsonRead_instance.jq(map, 'fat');
  var tmp_5;
  if (tmp4_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_6;
    if (tmp4_safe_receiver >= 0.0) {
      tmp_6 = tmp4_safe_receiver;
    } else {
      tmp_6 = null;
    }
    tmp_5 = tmp_6;
  }
  var tmp5_elvis_lhs = tmp_5;
  var tmp_7;
  if (tmp5_elvis_lhs == null) {
    return null;
  } else {
    tmp_7 = tmp5_elvis_lhs;
  }
  var fat = tmp_7;
  var tmp6_safe_receiver = JsonRead_instance.jq(map, 'carbs');
  var tmp_8;
  if (tmp6_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_9;
    if (tmp6_safe_receiver >= 0.0) {
      tmp_9 = tmp6_safe_receiver;
    } else {
      tmp_9 = null;
    }
    tmp_8 = tmp_9;
  }
  var tmp7_elvis_lhs = tmp_8;
  var tmp_10;
  if (tmp7_elvis_lhs == null) {
    return null;
  } else {
    tmp_10 = tmp7_elvis_lhs;
  }
  var carbs = tmp_10;
  var tmp_11 = map.s1('micros');
  var tmp8_safe_receiver = (!(tmp_11 == null) ? isInterface(tmp_11, KtMap) : false) ? tmp_11 : null;
  var tmp_12;
  if (tmp8_safe_receiver == null) {
    tmp_12 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    // Inline function 'kotlin.collections.iterator' call
    var _iterator__ex2g4s = tmp8_safe_receiver.v1().j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      // Inline function 'kotlin.collections.component1' call
      var key = element.o1();
      // Inline function 'kotlin.collections.component2' call
      var value = element.p1();
      var tmp0_safe_receiver_0 = isNumber(value) ? value : null;
      var tmp1_safe_receiver = tmp0_safe_receiver_0 == null ? null : numberToDouble(tmp0_safe_receiver_0);
      var tmp_13;
      if (tmp1_safe_receiver == null) {
        tmp_13 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_13 = to(key, tmp1_safe_receiver);
      }
      var tmp0_safe_receiver_1 = tmp_13;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination.f(tmp0_safe_receiver_1);
      }
    }
    tmp_12 = destination;
  }
  var tmp9_safe_receiver = tmp_12;
  var tmp10_elvis_lhs = tmp9_safe_receiver == null ? null : toMap(tmp9_safe_receiver);
  var micros = tmp10_elvis_lhs == null ? emptyMap() : tmp10_elvis_lhs;
  return new Per100g(kcal, protein, fat, carbs, JsonRead_instance.jq(map, 'fiber'), JsonRead_instance.jq(map, 'sugar'), JsonRead_instance.jq(map, 'satFat'), JsonRead_instance.jq(map, 'sodiumMg'), JsonRead_instance.jq(map, 'alcohol'), micros);
};
var NutrientJson_instance;
function NutrientJson_getInstance() {
  return NutrientJson_instance;
}
function NutrientInfo(key, name, unit) {
  this.q17_1 = key;
  this.r17_1 = name;
  this.s17_1 = unit;
}
protoOf(NutrientInfo).toString = function () {
  return 'NutrientInfo(key=' + this.q17_1 + ', name=' + this.r17_1 + ', unit=' + this.s17_1 + ')';
};
protoOf(NutrientInfo).hashCode = function () {
  var result = getStringHashCode(this.q17_1);
  result = imul(result, 31) + getStringHashCode(this.r17_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.s17_1) | 0;
  return result;
};
protoOf(NutrientInfo).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientInfo))
    return false;
  if (!(this.q17_1 === other.q17_1))
    return false;
  if (!(this.r17_1 === other.r17_1))
    return false;
  if (!(this.s17_1 === other.s17_1))
    return false;
  return true;
};
function Per100g(kcal, protein, fat, carbs, fiber, sugar, satFat, sodiumMg, alcohol, micros) {
  fiber = fiber === VOID ? null : fiber;
  sugar = sugar === VOID ? null : sugar;
  satFat = satFat === VOID ? null : satFat;
  sodiumMg = sodiumMg === VOID ? null : sodiumMg;
  alcohol = alcohol === VOID ? null : alcohol;
  micros = micros === VOID ? emptyMap() : micros;
  this.l13_1 = kcal;
  this.m13_1 = protein;
  this.n13_1 = fat;
  this.o13_1 = carbs;
  this.p13_1 = fiber;
  this.q13_1 = sugar;
  this.r13_1 = satFat;
  this.s13_1 = sodiumMg;
  this.t13_1 = alcohol;
  this.u13_1 = micros;
}
protoOf(Per100g).v13 = function (grams) {
  // Inline function 'kotlin.require' call
  if (!(grams >= 0.0)) {
    var message = 'grams must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var factor = grams / 100.0;
  var amounts = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.set' call
  var value = this.l13_1 * factor;
  amounts.k2('kcal', value);
  // Inline function 'kotlin.collections.set' call
  var value_0 = this.m13_1 * factor;
  amounts.k2('protein', value_0);
  // Inline function 'kotlin.collections.set' call
  var value_1 = this.n13_1 * factor;
  amounts.k2('fat', value_1);
  // Inline function 'kotlin.collections.set' call
  var value_2 = this.o13_1 * factor;
  amounts.k2('carbs', value_2);
  var tmp0_safe_receiver = this.p13_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.set' call
    var value_3 = tmp0_safe_receiver * factor;
    amounts.k2('fiber', value_3);
  }
  var tmp1_safe_receiver = this.q13_1;
  if (tmp1_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.set' call
    var value_4 = tmp1_safe_receiver * factor;
    amounts.k2('sugar', value_4);
  }
  var tmp2_safe_receiver = this.r13_1;
  if (tmp2_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.set' call
    var value_5 = tmp2_safe_receiver * factor;
    amounts.k2('satFat', value_5);
  }
  var tmp3_safe_receiver = this.s13_1;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var tmp2 = 'sodiumMg';
    // Inline function 'kotlin.collections.set' call
    var value_6 = tmp3_safe_receiver * factor;
    amounts.k2(tmp2, value_6);
  }
  var tmp4_safe_receiver = this.t13_1;
  if (tmp4_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.set' call
    var value_7 = tmp4_safe_receiver * factor;
    amounts.k2('alcohol', value_7);
  }
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this.u13_1.v1().j();
  while (_iterator__ex2g4s.k()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = _destruct__k2r9zo.o1();
    // Inline function 'kotlin.collections.component2' call
    var value_8 = _destruct__k2r9zo.p1();
    // Inline function 'kotlin.collections.set' call
    var value_9 = value_8 * factor;
    amounts.k2(key, value_9);
  }
  return amounts;
};
protoOf(Per100g).toString = function () {
  return 'Per100g(kcal=' + this.l13_1 + ', protein=' + this.m13_1 + ', fat=' + this.n13_1 + ', carbs=' + this.o13_1 + ', fiber=' + this.p13_1 + ', sugar=' + this.q13_1 + ', satFat=' + this.r13_1 + ', sodiumMg=' + this.s13_1 + ', alcohol=' + this.t13_1 + ', micros=' + toString(this.u13_1) + ')';
};
protoOf(Per100g).hashCode = function () {
  var result = getNumberHashCode(this.l13_1);
  result = imul(result, 31) + getNumberHashCode(this.m13_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.n13_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.o13_1) | 0;
  result = imul(result, 31) + (this.p13_1 == null ? 0 : getNumberHashCode(this.p13_1)) | 0;
  result = imul(result, 31) + (this.q13_1 == null ? 0 : getNumberHashCode(this.q13_1)) | 0;
  result = imul(result, 31) + (this.r13_1 == null ? 0 : getNumberHashCode(this.r13_1)) | 0;
  result = imul(result, 31) + (this.s13_1 == null ? 0 : getNumberHashCode(this.s13_1)) | 0;
  result = imul(result, 31) + (this.t13_1 == null ? 0 : getNumberHashCode(this.t13_1)) | 0;
  result = imul(result, 31) + hashCode(this.u13_1) | 0;
  return result;
};
protoOf(Per100g).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Per100g))
    return false;
  if (!equals(this.l13_1, other.l13_1))
    return false;
  if (!equals(this.m13_1, other.m13_1))
    return false;
  if (!equals(this.n13_1, other.n13_1))
    return false;
  if (!equals(this.o13_1, other.o13_1))
    return false;
  if (!equals(this.p13_1, other.p13_1))
    return false;
  if (!equals(this.q13_1, other.q13_1))
    return false;
  if (!equals(this.r13_1, other.r13_1))
    return false;
  if (!equals(this.s13_1, other.s13_1))
    return false;
  if (!equals(this.t13_1, other.t13_1))
    return false;
  if (!equals(this.u13_1, other.u13_1))
    return false;
  return true;
};
function Nutrients() {
  Nutrients_instance = this;
  this.g15_1 = 'kcal';
  this.h15_1 = 'protein';
  this.i15_1 = 'fat';
  this.j15_1 = 'carbs';
  this.k15_1 = 'fiber';
  this.l15_1 = 'sugar';
  this.m15_1 = 'satFat';
  this.n15_1 = 'sodiumMg';
  this.o15_1 = 'alcohol';
  this.p15_1 = listOf([new NutrientInfo('kcal', 'Energy', 'kcal'), new NutrientInfo('protein', 'Protein', 'g'), new NutrientInfo('fat', 'Fat', 'g'), new NutrientInfo('carbs', 'Carbohydrate', 'g'), new NutrientInfo('fiber', 'Fibre', 'g'), new NutrientInfo('sugar', 'Sugars', 'g'), new NutrientInfo('satFat', 'Saturated fat', 'g'), new NutrientInfo('sodiumMg', 'Sodium', 'mg'), new NutrientInfo('alcohol', 'Alcohol', 'g'), new NutrientInfo('water', 'Water', 'g'), new NutrientInfo('monoFat', 'Monounsaturated fat', 'g'), new NutrientInfo('polyFat', 'Polyunsaturated fat', 'g'), new NutrientInfo('transFat', 'Trans fat', 'g'), new NutrientInfo('cholesterolMg', 'Cholesterol', 'mg'), new NutrientInfo('potassiumMg', 'Potassium', 'mg'), new NutrientInfo('calciumMg', 'Calcium', 'mg'), new NutrientInfo('ironMg', 'Iron', 'mg'), new NutrientInfo('magnesiumMg', 'Magnesium', 'mg'), new NutrientInfo('zincMg', 'Zinc', 'mg'), new NutrientInfo('phosphorusMg', 'Phosphorus', 'mg'), new NutrientInfo('copperMg', 'Copper', 'mg'), new NutrientInfo('seleniumUg', 'Selenium', '\xB5g'), new NutrientInfo('iodineUg', 'Iodine', '\xB5g'), new NutrientInfo('vitaminAUg', 'Vitamin A (RAE)', '\xB5g'), new NutrientInfo('vitaminDUg', 'Vitamin D', '\xB5g'), new NutrientInfo('vitaminEMg', 'Vitamin E', 'mg'), new NutrientInfo('vitaminKUg', 'Vitamin K', '\xB5g'), new NutrientInfo('vitaminCMg', 'Vitamin C', 'mg'), new NutrientInfo('thiaminMg', 'Thiamin (B1)', 'mg'), new NutrientInfo('riboflavinMg', 'Riboflavin (B2)', 'mg'), new NutrientInfo('niacinMg', 'Niacin (B3)', 'mg'), new NutrientInfo('vitaminB6Mg', 'Vitamin B6', 'mg'), new NutrientInfo('folateUg', 'Folate (DFE)', '\xB5g'), new NutrientInfo('vitaminB12Ug', 'Vitamin B12', '\xB5g'), new NutrientInfo('caffeineMg', 'Caffeine', 'mg')]);
  var tmp = this;
  // Inline function 'kotlin.collections.map' call
  var this_0 = this.p15_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.q17_1;
    destination.f(tmp$ret$2);
  }
  tmp.q15_1 = destination;
}
protoOf(Nutrients).e16 = function (key) {
  var tmp0 = this.p15_1;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.q17_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Nutrients_instance;
function Nutrients_getInstance() {
  if (Nutrients_instance == null)
    new Nutrients();
  return Nutrients_instance;
}
function NutrientGoal(floor, target, ceiling) {
  this.b17_1 = floor;
  this.c17_1 = target;
  this.d17_1 = ceiling;
}
protoOf(NutrientGoal).ya = function () {
  return this.b17_1;
};
protoOf(NutrientGoal).za = function () {
  return this.c17_1;
};
protoOf(NutrientGoal).e17 = function () {
  return this.d17_1;
};
protoOf(NutrientGoal).toString = function () {
  return 'NutrientGoal(floor=' + this.b17_1 + ', target=' + this.c17_1 + ', ceiling=' + this.d17_1 + ')';
};
protoOf(NutrientGoal).hashCode = function () {
  var result = this.b17_1 == null ? 0 : getNumberHashCode(this.b17_1);
  result = imul(result, 31) + (this.c17_1 == null ? 0 : getNumberHashCode(this.c17_1)) | 0;
  result = imul(result, 31) + (this.d17_1 == null ? 0 : getNumberHashCode(this.d17_1)) | 0;
  return result;
};
protoOf(NutrientGoal).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof NutrientGoal))
    return false;
  if (!equals(this.b17_1, other.b17_1))
    return false;
  if (!equals(this.c17_1, other.c17_1))
    return false;
  if (!equals(this.d17_1, other.d17_1))
    return false;
  return true;
};
function defaults$pick(male, stage, values) {
  // Inline function 'kotlin.require' call
  if (!(values.length === 10)) {
    var message = 'need 10 values';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return values[male ? stage : 5 + stage | 0];
}
function defaults$teen(stage, teen, adult) {
  return stage === 0 ? teen : adult;
}
function defaults$sexes(male, men, women) {
  return male ? men : women;
}
function NutrientGoals() {
  this.x17_1 = 2000.0;
  this.y17_1 = 14.0;
}
protoOf(NutrientGoals).z17 = function (ageYears) {
  return ageYears <= 18 ? 0 : ageYears <= 30 ? 1 : ageYears <= 50 ? 2 : ageYears <= 70 ? 3 : 4;
};
protoOf(NutrientGoals).a18 = function (sex, ageYears, energyKcal) {
  // Inline function 'kotlin.require' call
  if (!(energyKcal == null || energyKcal > 0.0)) {
    var message = 'energyKcal must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var stage = this.z17(ageYears);
  var male = sex.equals(Sex_MALE_getInstance());
  var kcal = energyKcal == null ? 2000.0 : energyKcal;
  var tmp;
  if (energyKcal == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = energyKcal / 1000.0 * 14.0;
  }
  var tmp2_elvis_lhs = tmp;
  return linkedMapOf([to('fiber', new NutrientGoal(null, tmp2_elvis_lhs == null ? defaults$pick(male, stage, new Float64Array([38.0, 38.0, 38.0, 30.0, 30.0, 26.0, 25.0, 25.0, 21.0, 21.0])) : tmp2_elvis_lhs, null)), to('sugar', new NutrientGoal(null, null, null)), to('satFat', new NutrientGoal(null, null, 0.1 * kcal / 9.0)), to('sodiumMg', new NutrientGoal(null, 1500.0, 2300.0)), to('water', new NutrientGoal(null, defaults$pick(male, stage, new Float64Array([3300.0, 3700.0, 3700.0, 3700.0, 3700.0, 2300.0, 2700.0, 2700.0, 2700.0, 2700.0])), null)), to('monoFat', new NutrientGoal(null, null, null)), to('polyFat', new NutrientGoal(null, defaults$pick(male, stage, new Float64Array([17.6, 18.6, 18.6, 15.6, 15.6, 12.1, 13.1, 13.1, 12.1, 12.1])), null)), to('transFat', new NutrientGoal(null, null, 0.01 * kcal / 9.0)), to('cholesterolMg', new NutrientGoal(null, null, 300.0)), to('potassiumMg', new NutrientGoal(null, defaults$pick(male, stage, new Float64Array([3000.0, 3400.0, 3400.0, 3400.0, 3400.0, 2300.0, 2600.0, 2600.0, 2600.0, 2600.0])), null)), to('calciumMg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([1100.0, 800.0, 800.0, 800.0, 1000.0, 1100.0, 800.0, 800.0, 1000.0, 1000.0])), defaults$pick(male, stage, new Float64Array([1300.0, 1000.0, 1000.0, 1000.0, 1200.0, 1300.0, 1000.0, 1000.0, 1200.0, 1200.0])), defaults$pick(male, stage, new Float64Array([3000.0, 2500.0, 2500.0, 2000.0, 2000.0, 3000.0, 2500.0, 2500.0, 2000.0, 2000.0])))), to('ironMg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([7.7, 6.0, 6.0, 6.0, 6.0, 7.9, 8.1, 8.1, 5.0, 5.0])), defaults$pick(male, stage, new Float64Array([11.0, 8.0, 8.0, 8.0, 8.0, 15.0, 18.0, 18.0, 8.0, 8.0])), 45.0)), to('magnesiumMg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([340.0, 330.0, 350.0, 350.0, 350.0, 300.0, 255.0, 265.0, 265.0, 265.0])), defaults$pick(male, stage, new Float64Array([410.0, 400.0, 420.0, 420.0, 420.0, 360.0, 310.0, 320.0, 320.0, 320.0])), null)), to('zincMg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([8.5, 9.4, 9.4, 9.4, 9.4, 7.3, 6.8, 6.8, 6.8, 6.8])), defaults$pick(male, stage, new Float64Array([11.0, 11.0, 11.0, 11.0, 11.0, 9.0, 8.0, 8.0, 8.0, 8.0])), defaults$teen(stage, 34.0, 40.0))), to('phosphorusMg', new NutrientGoal(defaults$teen(stage, 1055.0, 580.0), defaults$teen(stage, 1250.0, 700.0), stage === 4 ? 3000.0 : 4000.0)), to('copperMg', new NutrientGoal(defaults$teen(stage, 0.685, 0.7), defaults$teen(stage, 0.89, 0.9), defaults$teen(stage, 8.0, 10.0))), to('seleniumUg', new NutrientGoal(45.0, 55.0, 400.0)), to('iodineUg', new NutrientGoal(95.0, 150.0, defaults$teen(stage, 900.0, 1100.0))), to('vitaminAUg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([630.0, 625.0, 625.0, 625.0, 625.0, 485.0, 500.0, 500.0, 500.0, 500.0])), defaults$sexes(male, 900.0, 700.0), defaults$teen(stage, 2800.0, 3000.0))), to('vitaminDUg', new NutrientGoal(10.0, stage === 4 ? 20.0 : 15.0, 100.0)), to('vitaminEMg', new NutrientGoal(12.0, 15.0, defaults$teen(stage, 800.0, 1000.0))), to('vitaminKUg', new NutrientGoal(null, defaults$teen(stage, 75.0, defaults$sexes(male, 120.0, 90.0)), null)), to('vitaminCMg', new NutrientGoal(defaults$teen(stage, defaults$sexes(male, 63.0, 56.0), defaults$sexes(male, 75.0, 60.0)), defaults$teen(stage, defaults$sexes(male, 75.0, 65.0), defaults$sexes(male, 90.0, 75.0)), defaults$teen(stage, 1800.0, 2000.0))), to('thiaminMg', new NutrientGoal(defaults$sexes(male, 1.0, 0.9), defaults$teen(stage, defaults$sexes(male, 1.2, 1.0), defaults$sexes(male, 1.2, 1.1)), null)), to('riboflavinMg', new NutrientGoal(defaults$sexes(male, 1.1, 0.9), defaults$teen(stage, defaults$sexes(male, 1.3, 1.0), defaults$sexes(male, 1.3, 1.1)), null)), to('niacinMg', new NutrientGoal(defaults$sexes(male, 12.0, 11.0), defaults$sexes(male, 16.0, 14.0), defaults$teen(stage, 30.0, 35.0))), to('vitaminB6Mg', new NutrientGoal(defaults$pick(male, stage, new Float64Array([1.1, 1.1, 1.1, 1.4, 1.4, 1.0, 1.1, 1.1, 1.3, 1.3])), defaults$pick(male, stage, new Float64Array([1.3, 1.3, 1.3, 1.7, 1.7, 1.2, 1.3, 1.3, 1.5, 1.5])), defaults$teen(stage, 80.0, 100.0))), to('folateUg', new NutrientGoal(330.0, 400.0, defaults$teen(stage, 800.0, 1000.0))), to('vitaminB12Ug', new NutrientGoal(2.0, 2.4, null)), to('caffeineMg', new NutrientGoal(null, null, defaults$teen(stage, 100.0, 400.0)))]);
};
var NutrientGoals_instance;
function NutrientGoals_getInstance() {
  return NutrientGoals_instance;
}
function RecoveryDay(day, sleepMin, hrvMs, restingHr) {
  sleepMin = sleepMin === VOID ? null : sleepMin;
  hrvMs = hrvMs === VOID ? null : hrvMs;
  restingHr = restingHr === VOID ? null : restingHr;
  this.cj_1 = day;
  this.dj_1 = sleepMin;
  this.ej_1 = hrvMs;
  this.fj_1 = restingHr;
}
protoOf(RecoveryDay).toString = function () {
  return 'RecoveryDay(day=' + this.cj_1 + ', sleepMin=' + this.dj_1 + ', hrvMs=' + this.ej_1 + ', restingHr=' + this.fj_1 + ')';
};
protoOf(RecoveryDay).hashCode = function () {
  var result = this.cj_1;
  result = imul(result, 31) + (this.dj_1 == null ? 0 : getNumberHashCode(this.dj_1)) | 0;
  result = imul(result, 31) + (this.ej_1 == null ? 0 : getNumberHashCode(this.ej_1)) | 0;
  result = imul(result, 31) + (this.fj_1 == null ? 0 : getNumberHashCode(this.fj_1)) | 0;
  return result;
};
protoOf(RecoveryDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RecoveryDay))
    return false;
  if (!(this.cj_1 === other.cj_1))
    return false;
  if (!equals(this.dj_1, other.dj_1))
    return false;
  if (!equals(this.ej_1, other.ej_1))
    return false;
  if (!equals(this.fj_1, other.fj_1))
    return false;
  return true;
};
function BodyMapArt() {
  BodyMapArt_instance = this;
  this.b18_1 = mapOf_0([to('sternocleidomastoid', listOf_0(Muscle_NECK_getInstance())), to('trapezius', listOf([Muscle_TRAPS_getInstance(), Muscle_MIDDLE_BACK_getInstance()])), to('anterior_deltoid', listOf_0(Muscle_SHOULDERS_getInstance())), to('lateral_deltoid', listOf_0(Muscle_SHOULDERS_getInstance())), to('posterior_deltoid', listOf_0(Muscle_SHOULDERS_getInstance())), to('pectoralis_major', listOf_0(Muscle_CHEST_getInstance())), to('serratus_anterior', listOf_0(Muscle_CHEST_getInstance())), to('biceps_brachii', listOf_0(Muscle_BICEPS_getInstance())), to('brachialis', listOf_0(Muscle_BICEPS_getInstance())), to('triceps_brachii', listOf_0(Muscle_TRICEPS_getInstance())), to('forearm_flexors', listOf_0(Muscle_FOREARMS_getInstance())), to('forearm_extensors', listOf_0(Muscle_FOREARMS_getInstance())), to('latissimus_dorsi', listOf_0(Muscle_LATS_getInstance())), to('posterior_rotator_cuff', listOf_0(Muscle_MIDDLE_BACK_getInstance())), to('erector_spinae', listOf_0(Muscle_LOWER_BACK_getInstance())), to('rectus_abdominis', listOf_0(Muscle_ABDOMINALS_getInstance())), to('external_oblique', listOf_0(Muscle_ABDOMINALS_getInstance())), to('rectus_femoris', listOf_0(Muscle_QUADRICEPS_getInstance())), to('vastus_lateralis', listOf_0(Muscle_QUADRICEPS_getInstance())), to('vastus_medialis', listOf_0(Muscle_QUADRICEPS_getInstance())), to('biceps_femoris', listOf_0(Muscle_HAMSTRINGS_getInstance())), to('medial_hamstrings', listOf_0(Muscle_HAMSTRINGS_getInstance())), to('gluteus_maximus', listOf_0(Muscle_GLUTES_getInstance())), to('gluteus_medius', listOf_0(Muscle_ABDUCTORS_getInstance())), to('tensor_fasciae_latae', listOf_0(Muscle_ABDUCTORS_getInstance())), to('hip_adductors', listOf_0(Muscle_ADDUCTORS_getInstance())), to('gastrocnemius', listOf_0(Muscle_CALVES_getInstance())), to('soleus', listOf_0(Muscle_CALVES_getInstance()))]);
}
protoOf(BodyMapArt).c18 = function (muscleId) {
  var tmp;
  if (muscleId == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = BodyMapArt_getInstance().b18_1.s1(muscleId);
  }
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
};
var BodyMapArt_instance;
function BodyMapArt_getInstance() {
  if (BodyMapArt_instance == null)
    new BodyMapArt();
  return BodyMapArt_instance;
}
function Point(loadKg, rtf) {
  this.d18_1 = loadKg;
  this.e18_1 = rtf;
}
protoOf(Point).toString = function () {
  return 'Point(loadKg=' + this.d18_1 + ', rtf=' + this.e18_1 + ')';
};
protoOf(Point).hashCode = function () {
  var result = getNumberHashCode(this.d18_1);
  result = imul(result, 31) + getNumberHashCode(this.e18_1) | 0;
  return result;
};
protoOf(Point).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Point))
    return false;
  if (!equals(this.d18_1, other.d18_1))
    return false;
  if (!equals(this.e18_1, other.e18_1))
    return false;
  return true;
};
function Fit(base, sessions) {
  this.f18_1 = base;
  this.g18_1 = sessions;
}
protoOf(Fit).toString = function () {
  return 'Fit(base=' + this.f18_1 + ', sessions=' + this.g18_1 + ')';
};
protoOf(Fit).hashCode = function () {
  var result = getNumberHashCode(this.f18_1);
  result = imul(result, 31) + this.g18_1 | 0;
  return result;
};
protoOf(Fit).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Fit))
    return false;
  if (!equals(this.f18_1, other.f18_1))
    return false;
  if (!(this.g18_1 === other.g18_1))
    return false;
  return true;
};
function CurveFit() {
  this.h18_1 = 6;
  this.i18_1 = 6.0;
  this.j18_1 = 0.95;
  this.k18_1 = 0.99;
  this.l18_1 = 5.0E-4;
}
protoOf(CurveFit).m18 = function (sessions, floor, minSessions) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(sessions, 10));
  var _iterator__ex2g4s = sessions.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = item.j();
    while (_iterator__ex2g4s_0.k()) {
      var element = _iterator__ex2g4s_0.l();
      if (element.d18_1 > 0.0 && element.e18_1 >= 1.0) {
        destination_0.f(element);
      }
    }
    destination.f(destination_0);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = destination.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_0 = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(element_0, 10));
    var _iterator__ex2g4s_2 = element_0.j();
    while (_iterator__ex2g4s_2.k()) {
      var item_0 = _iterator__ex2g4s_2.l();
      var tmp$ret$11 = item_0.e18_1;
      destination_2.f(tmp$ret$11);
    }
    if (distinct(destination_2).o() >= 2) {
      destination_1.f(element_0);
    }
  }
  var usable = destination_1;
  if (usable.o() < minSessions)
    return null;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(usable, 10));
  var _iterator__ex2g4s_3 = usable.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_1 = _iterator__ex2g4s_3.l();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(item_1, 10));
    var _iterator__ex2g4s_4 = item_1.j();
    while (_iterator__ex2g4s_4.k()) {
      var item_2 = _iterator__ex2g4s_4.l();
      // Inline function 'kotlin.math.ln' call
      var x = item_2.d18_1;
      var tmp$ret$18 = Math.log(x);
      var tmp$ret$17 = to(tmp$ret$18, item_2.e18_1);
      destination_4.f(tmp$ret$17);
    }
    destination_3.f(destination_4);
  }
  var logs = destination_3;
  var steps = numberToInt((0.99 - 0.95) / 5.0E-4 + 0.5);
  var best = 0.95;
  var bestError = 1.7976931348623157E308;
  var inductionVariable = 0;
  if (inductionVariable <= steps)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var base = 0.95 + i * 5.0E-4;
      var curve = new FlooredExpCurve(base, floor);
      var error = 0.0;
      var _iterator__ex2g4s_5 = logs.j();
      while (_iterator__ex2g4s_5.k()) {
        var session = _iterator__ex2g4s_5.l();
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(session, 10));
        var _iterator__ex2g4s_6 = session.j();
        while (_iterator__ex2g4s_6.k()) {
          var item_3 = _iterator__ex2g4s_6.l();
          var logLoad = item_3.ya();
          var rtf = item_3.za();
          // Inline function 'kotlin.math.ln' call
          var x_0 = curve.p18(rtf);
          var tmp$ret$21 = logLoad - Math.log(x_0);
          destination_5.f(tmp$ret$21);
        }
        var residuals = destination_5;
        var mean = average(residuals);
        var tmp = error;
        // Inline function 'kotlin.collections.sumOf' call
        var sum = 0;
        var _iterator__ex2g4s_7 = residuals.j();
        while (_iterator__ex2g4s_7.k()) {
          var element_1 = _iterator__ex2g4s_7.l();
          var tmp_0 = sum;
          sum = tmp_0 + (element_1 - mean) * (element_1 - mean);
        }
        error = tmp + sum;
      }
      if (error < bestError - 1.0E-15) {
        bestError = error;
        best = base;
      }
    }
     while (!(i === steps));
  return new Fit(best, usable.o());
};
protoOf(CurveFit).q18 = function (sessions, floor, minSessions, $super) {
  floor = floor === VOID ? 0.2 : floor;
  minSessions = minSessions === VOID ? 6 : minSessions;
  return $super === VOID ? this.m18(sessions, floor, minSessions) : $super.m18.call(this, sessions, floor, minSessions);
};
protoOf(CurveFit).r18 = function (sessions, prior) {
  var tmp0_elvis_lhs = this.q18(sessions);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return prior;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var fit = tmp;
  return prior + fit.g18_1 / (fit.g18_1 + 6.0) * (fit.f18_1 - prior);
};
protoOf(CurveFit).s18 = function (history, bodyweightKg, assumedRir, prior) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = history.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if ((element.x18_1.equals(SetType_STANDARD_getInstance()) || element.x18_1.equals(SetType_FAILURE_getInstance())) && element.v18_1 > 0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_elvis_lhs = element_0.y18_1;
    var key = tmp0_elvis_lhs == null ? 'day:' + element_0.t18_1 : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.s1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.k2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = destination_0.u1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_1 = this_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(item, 10));
    var _iterator__ex2g4s_2 = item.j();
    while (_iterator__ex2g4s_2.k()) {
      var item_0 = _iterator__ex2g4s_2.l();
      var tmp_0 = item_0.u18_1 + bodyweightKg;
      var tmp0_elvis_lhs_0 = item_0.w18_1;
      var tmp$ret$13 = new Point(tmp_0, item_0.v18_1 + (tmp0_elvis_lhs_0 == null ? assumedRir : tmp0_elvis_lhs_0) | 0);
      destination_2.f(tmp$ret$13);
    }
    destination_1.f(destination_2);
  }
  var sessions = destination_1;
  return new FlooredExpCurve(this.r18(sessions, prior));
};
protoOf(CurveFit).z18 = function (history, bodyweightKg, assumedRir, prior, $super) {
  bodyweightKg = bodyweightKg === VOID ? 0.0 : bodyweightKg;
  assumedRir = assumedRir === VOID ? 2 : assumedRir;
  prior = prior === VOID ? 0.958 : prior;
  return $super === VOID ? this.s18(history, bodyweightKg, assumedRir, prior) : $super.s18.call(this, history, bodyweightKg, assumedRir, prior);
};
var CurveFit_instance;
function CurveFit_getInstance() {
  return CurveFit_instance;
}
function FixedReps(repsPerSet) {
  repsPerSet = repsPerSet === VOID ? 1.0 : repsPerSet;
  this.a19_1 = repsPerSet;
  // Inline function 'kotlin.require' call
  if (!(this.a19_1 >= 0.0)) {
    var message = 'repsPerSet must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(FixedReps).toString = function () {
  return 'FixedReps(repsPerSet=' + this.a19_1 + ')';
};
protoOf(FixedReps).hashCode = function () {
  return getNumberHashCode(this.a19_1);
};
protoOf(FixedReps).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FixedReps))
    return false;
  if (!equals(this.a19_1, other.a19_1))
    return false;
  return true;
};
function PowerLaw(lambda, alpha, beta) {
  this.b19_1 = lambda;
  this.c19_1 = alpha;
  this.d19_1 = beta;
  // Inline function 'kotlin.require' call
  if (!(this.b19_1 >= 0.0 && this.c19_1 >= 0.0 && this.d19_1 > 0.0)) {
    var message = 'invalid fatigue parameters';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(PowerLaw).e19 = function (reps, rir) {
  // Inline function 'kotlin.math.exp' call
  var x = -this.b19_1 * rir;
  return reps * Math.exp(x);
};
protoOf(PowerLaw).f19 = function (fatiguingReps) {
  var tmp;
  if (fatiguingReps <= 0.0) {
    tmp = 1.0;
  } else {
    // Inline function 'kotlin.math.pow' call
    var x = this.d19_1;
    var tmp$ret$0 = Math.pow(fatiguingReps, x);
    // Inline function 'kotlin.math.max' call
    var b = 1.0 - this.c19_1 * tmp$ret$0;
    tmp = Math.max(0.5, b);
  }
  return tmp;
};
protoOf(PowerLaw).toString = function () {
  return 'PowerLaw(lambda=' + this.b19_1 + ', alpha=' + this.c19_1 + ', beta=' + this.d19_1 + ')';
};
protoOf(PowerLaw).hashCode = function () {
  var result = getNumberHashCode(this.b19_1);
  result = imul(result, 31) + getNumberHashCode(this.c19_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.d19_1) | 0;
  return result;
};
protoOf(PowerLaw).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PowerLaw))
    return false;
  if (!equals(this.b19_1, other.b19_1))
    return false;
  if (!equals(this.c19_1, other.c19_1))
    return false;
  if (!equals(this.d19_1, other.d19_1))
    return false;
  return true;
};
function Companion_8() {
  Companion_instance_10 = this;
  this.g19_1 = 0.5;
  this.h19_1 = new PowerLaw(0.5, 0.025, 0.6);
}
var Companion_instance_10;
function Companion_getInstance_8() {
  if (Companion_instance_10 == null)
    new Companion_8();
  return Companion_instance_10;
}
var static_init_called_34;
function static_init_34() {
  if (static_init_called_34)
    return Unit_instance;
  static_init_called_34 = true;
  FatigueChoice_FIXED_instance = new FatigueChoice('FIXED', 0, new FixedReps());
  FatigueChoice_POWER_OURS_instance = new FatigueChoice('POWER_OURS', 1, Companion_getInstance_8().h19_1);
}
var FatigueChoice_FIXED_instance;
var FatigueChoice_POWER_OURS_instance;
function values_25() {
  static_init_34();
  return [FatigueChoice_FIXED_getInstance(), FatigueChoice_POWER_OURS_getInstance()];
}
function get_entries_20() {
  static_init_34();
  if ($ENTRIES_20 == null)
    $ENTRIES_20 = enumEntries(values_25());
  return $ENTRIES_20;
}
var $ENTRIES_20;
function FatigueChoice(name, ordinal, model) {
  Enum.call(this, name, ordinal);
  this.k19_1 = model;
}
var static_init_called_35;
function static_init_35() {
  if (static_init_called_35)
    return Unit_instance;
  static_init_called_35 = true;
  SurpriseCarry_NONE_instance = new SurpriseCarry('NONE', 0);
  SurpriseCarry_SYMMETRIC_instance = new SurpriseCarry('SYMMETRIC', 1);
  SurpriseCarry_ASYMMETRIC_instance = new SurpriseCarry('ASYMMETRIC', 2);
  if (Companion_instance_11 == null) {
    Companion_instance_0;
    new Companion_9();
  }
}
var SurpriseCarry_NONE_instance;
var SurpriseCarry_SYMMETRIC_instance;
var SurpriseCarry_ASYMMETRIC_instance;
function Companion_9() {
  this.l19_1 = 0.25;
}
var Companion_instance_11;
function values_26() {
  static_init_35();
  return [SurpriseCarry_NONE_getInstance(), SurpriseCarry_SYMMETRIC_getInstance(), SurpriseCarry_ASYMMETRIC_getInstance()];
}
function get_entries_21() {
  static_init_35();
  if ($ENTRIES_21 == null)
    $ENTRIES_21 = enumEntries(values_26());
  return $ENTRIES_21;
}
var $ENTRIES_21;
function SurpriseCarry(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(SurpriseCarry).o19 = function (surprise) {
  var tmp;
  switch (this.x1_1) {
    case 0:
      tmp = 0.0;
      break;
    case 1:
      tmp = 1.0;
      break;
    case 2:
      tmp = surprise < 0.0 ? 1.0 : 0.5;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
function FatigueChoice_FIXED_getInstance() {
  static_init_34();
  return FatigueChoice_FIXED_instance;
}
function FatigueChoice_POWER_OURS_getInstance() {
  static_init_34();
  return FatigueChoice_POWER_OURS_instance;
}
function SurpriseCarry_NONE_getInstance() {
  static_init_35();
  return SurpriseCarry_NONE_instance;
}
function SurpriseCarry_SYMMETRIC_getInstance() {
  static_init_35();
  return SurpriseCarry_SYMMETRIC_instance;
}
function SurpriseCarry_ASYMMETRIC_getInstance() {
  static_init_35();
  return SurpriseCarry_ASYMMETRIC_instance;
}
function GeneratorSettingsJson() {
}
protoOf(GeneratorSettingsJson).uf = function (json) {
  var map = JsonRead_instance.vf(Json_instance.uf(json), 'settings');
  var defaults = new GeneratorSettings();
  var tmp0_safe_receiver = JsonRead_instance.iq(map, 'goal');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = Companion_instance_21.p19(tmp0_safe_receiver);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0 = tmp1_elvis_lhs == null ? defaults.q19_1 : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = JsonRead_instance.xq(map, 'daysPerWeek');
  var tmp_1 = tmp2_elvis_lhs == null ? defaults.r19_1 : tmp2_elvis_lhs;
  var tmp3_elvis_lhs = JsonRead_instance.xq(map, 'minutesPerSession');
  var tmp_2 = tmp3_elvis_lhs == null ? defaults.s19_1 : tmp3_elvis_lhs;
  var tmp0 = get_entries_23();
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.w1_1 === JsonRead_instance.iq(map, 'experience')) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp4_elvis_lhs = tmp$ret$2;
  var tmp_3 = tmp4_elvis_lhs == null ? defaults.t19_1 : tmp4_elvis_lhs;
  var tmp0_0 = get_entries_24();
  var tmp$ret$4;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_0 = tmp0_0.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (element_0.w1_1 === JsonRead_instance.iq(map, 'split')) {
        tmp$ret$4 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$4 = null;
  }
  var tmp5_elvis_lhs = tmp$ret$4;
  var tmp_4 = tmp5_elvis_lhs == null ? defaults.u19_1 : tmp5_elvis_lhs;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_1 = JsonRead_instance.m12(map, 'focus');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_1 = tmp0_1.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp0_safe_receiver_0 = Companion_instance_15.j1a(element_1);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_5 = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_2 = JsonRead_instance.m12(map, 'deprioritised');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = tmp0_2.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    var tmp0_safe_receiver_1 = Companion_instance_15.j1a(element_2);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_1);
    }
  }
  var tmp_6 = destination_0;
  var tmp6_elvis_lhs = JsonRead_instance.ar(map, 'includeDeloads');
  var tmp_7 = tmp6_elvis_lhs == null ? defaults.x19_1 : tmp6_elvis_lhs;
  var tmp7_safe_receiver = JsonRead_instance.iq(map, 'deload');
  var tmp_8;
  if (tmp7_safe_receiver == null) {
    tmp_8 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_8 = Companion_instance_22.p19(tmp7_safe_receiver);
  }
  var tmp8_elvis_lhs = tmp_8;
  var tmp_9 = tmp8_elvis_lhs == null ? defaults.y19_1 : tmp8_elvis_lhs;
  var tmp9_elvis_lhs = JsonRead_instance.xq(map, 'cycles');
  var tmp_10 = tmp9_elvis_lhs == null ? defaults.z19_1 : tmp9_elvis_lhs;
  var tmp10_safe_receiver = JsonRead_instance.iq(map, 'progression');
  var tmp_11;
  if (tmp10_safe_receiver == null) {
    tmp_11 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_11 = Companion_instance_18.p19(tmp10_safe_receiver);
  }
  var tmp11_elvis_lhs = tmp_11;
  var tmp_12 = tmp11_elvis_lhs == null ? defaults.a1a_1 : tmp11_elvis_lhs;
  var tmp_13 = toSet(JsonRead_instance.m12(map, 'excludedExercises'));
  var tmp_14 = JsonRead_instance.iq(map, 'name');
  var tmp12_elvis_lhs = JsonRead_instance.ar(map, 'useLibraryRanks');
  var tmp_15 = tmp12_elvis_lhs == null ? defaults.d1a_1 : tmp12_elvis_lhs;
  var tmp_16 = toSet(JsonRead_instance.m12(map, 'skills'));
  var tmp_17 = map.s1('familiar');
  var tmp13_safe_receiver = (!(tmp_17 == null) ? isInterface(tmp_17, KtMap) : false) ? tmp_17 : null;
  var tmp14_safe_receiver = tmp13_safe_receiver == null ? null : tmp13_safe_receiver.v1();
  var tmp_18;
  if (tmp14_safe_receiver == null) {
    tmp_18 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_1 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_3 = tmp14_safe_receiver.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_3 = _iterator__ex2g4s_3.l();
      // Inline function 'kotlin.collections.component1' call
      var id = element_3.o1();
      // Inline function 'kotlin.collections.component2' call
      var count = element_3.p1();
      var tmp0_safe_receiver_2 = (!(id == null) ? typeof id === 'string' : false) ? id : null;
      var tmp_19;
      if (tmp0_safe_receiver_2 == null) {
        tmp_19 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver_3 = isNumber(count) ? count : null;
        var tmp1_safe_receiver = tmp0_safe_receiver_3 == null ? null : numberToInt(tmp0_safe_receiver_3);
        var tmp_20;
        if (tmp1_safe_receiver == null) {
          tmp_20 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_20 = to(tmp0_safe_receiver_2, tmp1_safe_receiver);
        }
        tmp_19 = tmp_20;
      }
      var tmp0_safe_receiver_4 = tmp_19;
      if (tmp0_safe_receiver_4 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_1.f(tmp0_safe_receiver_4);
      }
    }
    tmp_18 = destination_1;
  }
  var tmp15_safe_receiver = tmp_18;
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs = tmp15_safe_receiver == null ? null : toMap(tmp15_safe_receiver);
  var tmp_21 = tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
  var tmp0_3 = get_entries_25();
  var tmp$ret$38;
  $l$block_1: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_4 = tmp0_3.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_4 = _iterator__ex2g4s_4.l();
      if (element_4.w1_1 === JsonRead_instance.iq(map, 'compoundSets')) {
        tmp$ret$38 = element_4;
        break $l$block_1;
      }
    }
    tmp$ret$38 = null;
  }
  var tmp16_elvis_lhs = tmp$ret$38;
  var tmp_22 = tmp16_elvis_lhs == null ? defaults.g1a_1 : tmp16_elvis_lhs;
  var tmp0_4 = get_entries_26();
  var tmp$ret$40;
  $l$block_2: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_5 = tmp0_4.j();
    while (_iterator__ex2g4s_5.k()) {
      var element_5 = _iterator__ex2g4s_5.l();
      if (element_5.w1_1 === JsonRead_instance.iq(map, 'rest')) {
        tmp$ret$40 = element_5;
        break $l$block_2;
      }
    }
    tmp$ret$40 = null;
  }
  var tmp17_elvis_lhs = tmp$ret$40;
  var tmp_23 = tmp17_elvis_lhs == null ? defaults.h1a_1 : tmp17_elvis_lhs;
  var tmp18_elvis_lhs = JsonRead_instance.ar(map, 'powerWork');
  return new GeneratorSettings(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_9, tmp_10, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_21, tmp_22, tmp_23, tmp18_elvis_lhs == null ? defaults.i1a_1 : tmp18_elvis_lhs);
};
var GeneratorSettingsJson_instance;
function GeneratorSettingsJson_getInstance() {
  return GeneratorSettingsJson_instance;
}
function Barbell(name, kg) {
  this.k1a_1 = name;
  this.l1a_1 = kg;
}
protoOf(Barbell).toString = function () {
  return 'Barbell(name=' + this.k1a_1 + ', kg=' + this.l1a_1 + ')';
};
protoOf(Barbell).hashCode = function () {
  var result = getStringHashCode(this.k1a_1);
  result = imul(result, 31) + getNumberHashCode(this.l1a_1) | 0;
  return result;
};
protoOf(Barbell).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Barbell))
    return false;
  if (!(this.k1a_1 === other.k1a_1))
    return false;
  if (!equals(this.l1a_1, other.l1a_1))
    return false;
  return true;
};
function PlatePair(kg, pairs, unit) {
  unit = unit === VOID ? null : unit;
  this.m1a_1 = kg;
  this.n1a_1 = pairs;
  this.o1a_1 = unit;
}
protoOf(PlatePair).toString = function () {
  return 'PlatePair(kg=' + this.m1a_1 + ', pairs=' + this.n1a_1 + ', unit=' + this.o1a_1 + ')';
};
protoOf(PlatePair).hashCode = function () {
  var result = getNumberHashCode(this.m1a_1);
  result = imul(result, 31) + this.n1a_1 | 0;
  result = imul(result, 31) + (this.o1a_1 == null ? 0 : getStringHashCode(this.o1a_1)) | 0;
  return result;
};
protoOf(PlatePair).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlatePair))
    return false;
  if (!equals(this.m1a_1, other.m1a_1))
    return false;
  if (!(this.n1a_1 === other.n1a_1))
    return false;
  if (!(this.o1a_1 == other.o1a_1))
    return false;
  return true;
};
function DumbbellRange(fromKg, toKg, stepKg) {
  this.p1a_1 = fromKg;
  this.q1a_1 = toKg;
  this.r1a_1 = stepKg;
}
protoOf(DumbbellRange).toString = function () {
  return 'DumbbellRange(fromKg=' + this.p1a_1 + ', toKg=' + this.q1a_1 + ', stepKg=' + this.r1a_1 + ')';
};
protoOf(DumbbellRange).hashCode = function () {
  var result = getNumberHashCode(this.p1a_1);
  result = imul(result, 31) + getNumberHashCode(this.q1a_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.r1a_1) | 0;
  return result;
};
protoOf(DumbbellRange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof DumbbellRange))
    return false;
  if (!equals(this.p1a_1, other.p1a_1))
    return false;
  if (!equals(this.q1a_1, other.q1a_1))
    return false;
  if (!equals(this.r1a_1, other.r1a_1))
    return false;
  return true;
};
var static_init_called_36;
function static_init_36() {
  if (static_init_called_36)
    return Unit_instance;
  static_init_called_36 = true;
  MicroMode_ANY_instance = new MicroMode('ANY', 0);
  MicroMode_ONE_instance = new MicroMode('ONE', 1);
}
var MicroMode_ANY_instance;
var MicroMode_ONE_instance;
function values_27() {
  static_init_36();
  return [MicroMode_ANY_getInstance(), MicroMode_ONE_getInstance()];
}
function get_entries_22() {
  static_init_36();
  if ($ENTRIES_22 == null)
    $ENTRIES_22 = enumEntries(values_27());
  return $ENTRIES_22;
}
var $ENTRIES_22;
function MicroMode(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function WeightStack(name, ranges, microKg, microMode) {
  microKg = microKg === VOID ? emptyList() : microKg;
  microMode = microMode === VOID ? MicroMode_ANY_getInstance() : microMode;
  this.s1a_1 = name;
  this.t1a_1 = ranges;
  this.u1a_1 = microKg;
  this.v1a_1 = microMode;
}
protoOf(WeightStack).toString = function () {
  return 'WeightStack(name=' + this.s1a_1 + ', ranges=' + toString(this.t1a_1) + ', microKg=' + toString(this.u1a_1) + ', microMode=' + this.v1a_1.toString() + ')';
};
protoOf(WeightStack).hashCode = function () {
  var result = getStringHashCode(this.s1a_1);
  result = imul(result, 31) + hashCode(this.t1a_1) | 0;
  result = imul(result, 31) + hashCode(this.u1a_1) | 0;
  result = imul(result, 31) + this.v1a_1.hashCode() | 0;
  return result;
};
protoOf(WeightStack).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeightStack))
    return false;
  if (!(this.s1a_1 === other.s1a_1))
    return false;
  if (!equals(this.t1a_1, other.t1a_1))
    return false;
  if (!equals(this.u1a_1, other.u1a_1))
    return false;
  if (!this.v1a_1.equals(other.v1a_1))
    return false;
  return true;
};
function plates($this, value) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = objects($this, value);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block: {
      var tmp0_elvis_lhs = JsonRead_instance.jq(element, 'kg');
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var kg = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.xq(element, 'pairs');
      var tmp_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp2_safe_receiver = JsonRead_instance.iq(element, 'unit');
      var tmp_1;
      if (tmp2_safe_receiver == null) {
        tmp_1 = null;
      } else {
        // Inline function 'kotlin.takeIf' call
        var tmp_2;
        if (tmp2_safe_receiver === 'kg' || tmp2_safe_receiver === 'lb') {
          tmp_2 = tmp2_safe_receiver;
        } else {
          tmp_2 = null;
        }
        tmp_1 = tmp_2;
      }
      // Inline function 'kotlin.takeIf' call
      var this_0 = new PlatePair(kg, tmp_0, tmp_1);
      var tmp_3;
      if (kg > 0.0 && this_0.n1a_1 > 0) {
        tmp_3 = this_0;
      } else {
        tmp_3 = null;
      }
      tmp$ret$4 = tmp_3;
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
}
function objects($this, value) {
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.yq(value);
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
}
function plateMap($this, plate) {
  // Inline function 'kotlin.apply' call
  var this_0 = linkedMapOf([to('kg', plate.m1a_1), to('pairs', plate.n1a_1)]);
  var tmp0_safe_receiver = plate.o1a_1;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    this_0.k2('unit', tmp0_safe_receiver);
  }
  return this_0;
}
function Companion_10() {
  Companion_instance_12 = this;
  this.w1a_1 = setOf(['bumperPlates', 'offsets']);
}
protoOf(Companion_10).x1a = function (json) {
  return this.y1a(JsonRead_instance.vf(Json_instance.uf(json), 'GYM'));
};
protoOf(Companion_10).y1a = function (map) {
  var tmp0_elvis_lhs = JsonRead_instance.iq(map, 'name');
  var tmp5_name = tmp0_elvis_lhs == null ? 'Gym' : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = JsonRead_instance.ar(map, 'isDefault');
  var tmp6_isDefault = tmp1_elvis_lhs == null ? false : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.yq(map.s1('barbells'));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block: {
      var tmp0_elvis_lhs_0 = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs_0 == null) {
        tmp$ret$4 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs_0;
      }
      var bar = tmp;
      var m = isInterface(bar, KtMap) ? bar : THROW_CCE();
      var tmp1_safe_receiver = JsonRead_instance.jq(m, 'kg');
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        var tmp0_elvis_lhs_1 = JsonRead_instance.iq(m, 'name');
        tmp_0 = new Barbell(tmp0_elvis_lhs_1 == null ? 'Bar' : tmp0_elvis_lhs_1, tmp1_safe_receiver);
      }
      tmp$ret$4 = tmp_0;
    }
    var tmp0_safe_receiver = tmp$ret$4;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  var tmp8_plates = plates(this, map.s1('plates'));
  var tmp9_bumperPlates = plates(this, map.s1('bumperPlates'));
  var tmp_1 = map.s1('offsets');
  var tmp2_safe_receiver = (!(tmp_1 == null) ? isInterface(tmp_1, KtMap) : false) ? tmp_1 : null;
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.v1();
  var tmp_2;
  if (tmp3_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = tmp3_safe_receiver.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      var tmp$ret$13;
      $l$block_1: {
        // Inline function 'kotlin.collections.component1' call
        var key = element_0.o1();
        // Inline function 'kotlin.collections.component2' call
        var kg = element_0.p1();
        var tmp0_0 = get_entries_31();
        var tmp$ret$16;
        $l$block_0: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_1 = tmp0_0.j();
          while (_iterator__ex2g4s_1.k()) {
            var element_1 = _iterator__ex2g4s_1.l();
            if (equals(element_1.b1b_1, key)) {
              tmp$ret$16 = element_1;
              break $l$block_0;
            }
          }
          tmp$ret$16 = null;
        }
        var tmp0_elvis_lhs_2 = tmp$ret$16;
        var tmp_3;
        if (tmp0_elvis_lhs_2 == null) {
          tmp$ret$13 = null;
          break $l$block_1;
        } else {
          tmp_3 = tmp0_elvis_lhs_2;
        }
        var equipment = tmp_3;
        var tmp1_safe_receiver_0 = isNumber(kg) ? kg : null;
        var tmp2_safe_receiver_0 = tmp1_safe_receiver_0 == null ? null : numberToDouble(tmp1_safe_receiver_0);
        var tmp_4;
        if (tmp2_safe_receiver_0 == null) {
          tmp_4 = null;
        } else {
          // Inline function 'kotlin.takeIf' call
          var tmp_5;
          if (isFinite(tmp2_safe_receiver_0)) {
            tmp_5 = tmp2_safe_receiver_0;
          } else {
            tmp_5 = null;
          }
          tmp_4 = tmp_5;
        }
        var tmp3_safe_receiver_0 = tmp_4;
        var tmp_6;
        if (tmp3_safe_receiver_0 == null) {
          tmp_6 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_6 = to(equipment, tmp3_safe_receiver_0);
        }
        tmp$ret$13 = tmp_6;
      }
      var tmp0_safe_receiver_0 = tmp$ret$13;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.f(tmp0_safe_receiver_0);
      }
    }
    tmp_2 = destination_0;
  }
  var tmp4_safe_receiver = tmp_2;
  // Inline function 'kotlin.collections.orEmpty' call
  var tmp0_elvis_lhs_3 = tmp4_safe_receiver == null ? null : toMap(tmp4_safe_receiver);
  var tmp10_offsets = tmp0_elvis_lhs_3 == null ? emptyMap() : tmp0_elvis_lhs_3;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_1 = objects(this, map.s1('dumbbells'));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = tmp0_1.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    var tmp$ret$29;
    $l$block_4: {
      var tmp0_elvis_lhs_4 = JsonRead_instance.jq(element_2, 'fromKg');
      var tmp_7;
      if (tmp0_elvis_lhs_4 == null) {
        tmp$ret$29 = null;
        break $l$block_4;
      } else {
        tmp_7 = tmp0_elvis_lhs_4;
      }
      var from = tmp_7;
      var tmp1_elvis_lhs_0 = JsonRead_instance.jq(element_2, 'toKg');
      var tmp_8;
      if (tmp1_elvis_lhs_0 == null) {
        tmp$ret$29 = null;
        break $l$block_4;
      } else {
        tmp_8 = tmp1_elvis_lhs_0;
      }
      var to_0 = tmp_8;
      var tmp2_elvis_lhs = JsonRead_instance.jq(element_2, 'stepKg');
      var tmp_9;
      if (tmp2_elvis_lhs == null) {
        tmp$ret$29 = null;
        break $l$block_4;
      } else {
        tmp_9 = tmp2_elvis_lhs;
      }
      var step = tmp_9;
      // Inline function 'kotlin.takeIf' call
      var this_0 = new DumbbellRange(from, to_0, step);
      var tmp_10;
      if (step > 0.0 && to_0 >= from) {
        tmp_10 = this_0;
      } else {
        tmp_10 = null;
      }
      tmp$ret$29 = tmp_10;
    }
    var tmp0_safe_receiver_1 = tmp$ret$29;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.f(tmp0_safe_receiver_1);
    }
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = objects(this, map.s1('stacks'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_3 = this_1.j();
  while (_iterator__ex2g4s_3.k()) {
    var item = _iterator__ex2g4s_3.l();
    var tmp0_elvis_lhs_5 = JsonRead_instance.iq(item, 'name');
    var tmp_11 = tmp0_elvis_lhs_5 == null ? 'Stack' : tmp0_elvis_lhs_5;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0_2 = objects(Companion_getInstance_9(), item.s1('ranges'));
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_3 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_4 = tmp0_2.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_3 = _iterator__ex2g4s_4.l();
      var tmp$ret$41;
      $l$block_7: {
        var tmp0_elvis_lhs_6 = JsonRead_instance.jq(element_3, 'startKg');
        var tmp_12;
        if (tmp0_elvis_lhs_6 == null) {
          tmp$ret$41 = null;
          break $l$block_7;
        } else {
          tmp_12 = tmp0_elvis_lhs_6;
        }
        var start = tmp_12;
        var tmp1_elvis_lhs_1 = JsonRead_instance.jq(element_3, 'endKg');
        var tmp_13;
        if (tmp1_elvis_lhs_1 == null) {
          tmp$ret$41 = null;
          break $l$block_7;
        } else {
          tmp_13 = tmp1_elvis_lhs_1;
        }
        var end = tmp_13;
        var tmp2_elvis_lhs_0 = JsonRead_instance.jq(element_3, 'incrementKg');
        var tmp_14;
        if (tmp2_elvis_lhs_0 == null) {
          tmp$ret$41 = null;
          break $l$block_7;
        } else {
          tmp_14 = tmp2_elvis_lhs_0;
        }
        var increment = tmp_14;
        // Inline function 'kotlin.takeIf' call
        var this_2 = new StackRange(start, end, increment);
        var tmp_15;
        if (increment > 0.0 && end >= start) {
          tmp_15 = this_2;
        } else {
          tmp_15 = null;
        }
        tmp$ret$41 = tmp_15;
      }
      var tmp0_safe_receiver_2 = tmp$ret$41;
      if (tmp0_safe_receiver_2 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_3.f(tmp0_safe_receiver_2);
      }
    }
    var tmp_16 = destination_3;
    // Inline function 'kotlin.collections.filter' call
    var tmp0_3 = JsonRead_instance.n12(item, 'microKg');
    // Inline function 'kotlin.collections.filterTo' call
    var destination_4 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_5 = tmp0_3.j();
    while (_iterator__ex2g4s_5.k()) {
      var element_4 = _iterator__ex2g4s_5.l();
      if (element_4 > 0.0) {
        destination_4.f(element_4);
      }
    }
    var tmp_17 = destination_4;
    var tmp0_4 = get_entries_22();
    var tmp$ret$49;
    $l$block_8: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_6 = tmp0_4.j();
      while (_iterator__ex2g4s_6.k()) {
        var element_5 = _iterator__ex2g4s_6.l();
        if (element_5.w1_1 === JsonRead_instance.iq(item, 'microMode')) {
          tmp$ret$49 = element_5;
          break $l$block_8;
        }
      }
      tmp$ret$49 = null;
    }
    var tmp1_elvis_lhs_2 = tmp$ret$49;
    var tmp$ret$36 = new WeightStack(tmp_11, tmp_16, tmp_17, tmp1_elvis_lhs_2 == null ? MicroMode_ANY_getInstance() : tmp1_elvis_lhs_2);
    destination_2.f(tmp$ret$36);
  }
  // Inline function 'kotlin.collections.filter' call
  var tmp0_5 = JsonRead_instance.n12(map, 'kettlebells');
  // Inline function 'kotlin.collections.filterTo' call
  var destination_5 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_7 = tmp0_5.j();
  while (_iterator__ex2g4s_7.k()) {
    var element_6 = _iterator__ex2g4s_7.l();
    if (element_6 > 0.0) {
      destination_5.f(element_6);
    }
  }
  var tmp14_bands = JsonRead_instance.m12(map, 'bands');
  var tmp15_excludedExercises = toSet(JsonRead_instance.m12(map, 'excludedExercises'));
  return new Gym(tmp5_name, tmp6_isDefault, destination, tmp8_plates, destination_1, destination_2, destination_5, tmp14_bands, tmp15_excludedExercises, tmp9_bumperPlates, tmp10_offsets);
};
protoOf(Companion_10).c1b = function (kind) {
  var tmp;
  switch (kind.x1_1) {
    case 0:
      var tmp_0 = listOf_0(new Barbell('Olympic bar', 20.0));
      // Inline function 'kotlin.collections.map' call

      var this_0 = listOf([to(20.0, 2), to(10.0, 2), to(5.0, 2), to(2.5, 2), to(1.25, 2)]);
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.j();
      while (_iterator__ex2g4s.k()) {
        var item = _iterator__ex2g4s.l();
        var tmp$ret$2 = new PlatePair(item.hb_1, item.ib_1);
        destination.f(tmp$ret$2);
      }

      tmp = new Gym('Home', VOID, tmp_0, destination, listOf_0(new DumbbellRange(2.0, 30.0, 2.0)));
      break;
    case 1:
      var tmp_1 = listOf([new Barbell('Olympic bar', 20.0), new Barbell('Smith machine', 15.0)]);
      // Inline function 'kotlin.collections.map' call

      var this_1 = listOf([to(25.0, 4), to(20.0, 4), to(15.0, 2), to(10.0, 2), to(5.0, 2), to(2.5, 2), to(1.25, 2)]);
      // Inline function 'kotlin.collections.mapTo' call

      var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
      var _iterator__ex2g4s_0 = this_1.j();
      while (_iterator__ex2g4s_0.k()) {
        var item_0 = _iterator__ex2g4s_0.l();
        var tmp$ret$5 = new PlatePair(item_0.hb_1, item_0.ib_1);
        destination_0.f(tmp$ret$5);
      }

      tmp = new Gym('Commercial gym', VOID, tmp_1, destination_0, listOf_0(new DumbbellRange(2.0, 50.0, 2.0)), listOf([new WeightStack('Cable stack', listOf_0(new StackRange(5.0, 100.0, 5.0)), listOf_0(2.5)), new WeightStack('Machine stack', listOf_0(new StackRange(10.0, 150.0, 10.0)), listOf_0(5.0), MicroMode_ONE_getInstance())]), listOf([8.0, 12.0, 16.0, 20.0, 24.0, 28.0, 32.0]), listOf(['light', 'medium', 'heavy']));
      break;
    case 2:
      tmp = new Gym('Hotel', VOID, VOID, VOID, listOf_0(new DumbbellRange(2.0, 25.0, 2.0)));
      break;
    case 3:
      tmp = new Gym('Gym');
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var Companion_instance_12;
function Companion_getInstance_9() {
  if (Companion_instance_12 == null)
    new Companion_10();
  return Companion_instance_12;
}
function Gym(name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets) {
  Companion_getInstance_9();
  name = name === VOID ? 'Gym' : name;
  isDefault = isDefault === VOID ? false : isDefault;
  barbells = barbells === VOID ? emptyList() : barbells;
  plates = plates === VOID ? emptyList() : plates;
  dumbbells = dumbbells === VOID ? emptyList() : dumbbells;
  stacks = stacks === VOID ? emptyList() : stacks;
  kettlebells = kettlebells === VOID ? emptyList() : kettlebells;
  bands = bands === VOID ? emptyList() : bands;
  excludedExercises = excludedExercises === VOID ? emptySet() : excludedExercises;
  bumperPlates = bumperPlates === VOID ? emptyList() : bumperPlates;
  offsets = offsets === VOID ? emptyMap() : offsets;
  this.d1b_1 = name;
  this.e1b_1 = isDefault;
  this.f1b_1 = barbells;
  this.g1b_1 = plates;
  this.h1b_1 = dumbbells;
  this.i1b_1 = stacks;
  this.j1b_1 = kettlebells;
  this.k1b_1 = bands;
  this.l1b_1 = excludedExercises;
  this.m1b_1 = bumperPlates;
  this.n1b_1 = offsets;
}
protoOf(Gym).o1b = function () {
  // Inline function 'kotlin.text.trim' call
  var this_0 = this.d1b_1;
  // Inline function 'kotlin.text.ifEmpty' call
  var this_1 = toString(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_1) === 0) {
    tmp = 'Gym';
  } else {
    tmp = this_1;
  }
  var tmp$ret$1 = tmp;
  var tmp_0 = to('name', tmp$ret$1);
  var tmp_1 = to('isDefault', this.e1b_1);
  // Inline function 'kotlin.collections.map' call
  var this_2 = this.f1b_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$6 = linkedMapOf([to('name', item.k1a_1), to('kg', item.l1a_1)]);
    destination.f(tmp$ret$6);
  }
  var tmp_2 = to('barbells', destination);
  // Inline function 'kotlin.collections.map' call
  var this_3 = this.g1b_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s_0 = this_3.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$9 = plateMap(this, item_0);
    destination_0.f(tmp$ret$9);
  }
  var tmp_3 = to('plates', destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_4 = this.h1b_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
  var _iterator__ex2g4s_1 = this_4.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$12 = linkedMapOf([to('fromKg', item_1.p1a_1), to('toKg', item_1.q1a_1), to('stepKg', item_1.r1a_1)]);
    destination_1.f(tmp$ret$12);
  }
  var tmp_4 = to('dumbbells', destination_1);
  // Inline function 'kotlin.collections.map' call
  var this_5 = this.i1b_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
  var _iterator__ex2g4s_2 = this_5.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_2 = _iterator__ex2g4s_2.l();
    var tmp_5 = to('name', item_2.s1a_1);
    // Inline function 'kotlin.collections.map' call
    var this_6 = item_2.t1a_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(this_6, 10));
    var _iterator__ex2g4s_3 = this_6.j();
    while (_iterator__ex2g4s_3.k()) {
      var item_3 = _iterator__ex2g4s_3.l();
      var tmp$ret$18 = linkedMapOf([to('startKg', item_3.p1b_1), to('endKg', item_3.q1b_1), to('incrementKg', item_3.r1b_1)]);
      destination_3.f(tmp$ret$18);
    }
    // Inline function 'kotlin.apply' call
    var this_7 = linkedMapOf([tmp_5, to('ranges', destination_3), to('microKg', item_2.u1a_1)]);
    if (!item_2.v1a_1.equals(MicroMode_ANY_getInstance())) {
      this_7.k2('microMode', item_2.v1a_1.w1_1);
    }
    destination_2.f(this_7);
  }
  // Inline function 'kotlin.apply' call
  var this_8 = linkedMapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, to('stacks', destination_2), to('kettlebells', this.j1b_1), to('bands', this.k1b_1), to('excludedExercises', sorted(this.l1b_1))]);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!this.m1b_1.m()) {
    // Inline function 'kotlin.collections.map' call
    var this_9 = this.m1b_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(this_9, 10));
    var _iterator__ex2g4s_4 = this_9.j();
    while (_iterator__ex2g4s_4.k()) {
      var item_4 = _iterator__ex2g4s_4.l();
      var tmp$ret$26 = plateMap(this, item_4);
      destination_4.f(tmp$ret$26);
    }
    this_8.k2('bumperPlates', destination_4);
  }
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!this.n1b_1.m()) {
    // Inline function 'kotlin.collections.associate' call
    var this_10 = this.n1b_1.v1();
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_10, 10)), 16);
    // Inline function 'kotlin.collections.associateTo' call
    var destination_5 = LinkedHashMap_init_$Create$(capacity);
    var _iterator__ex2g4s_5 = this_10.j();
    while (_iterator__ex2g4s_5.k()) {
      var element = _iterator__ex2g4s_5.l();
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(element.o1().b1b_1, element.p1());
      destination_5.k2(pair.hb_1, pair.ib_1);
    }
    this_8.k2('offsets', destination_5);
  }
  return this_8;
};
protoOf(Gym).s1b = function (equipment) {
  var tmp;
  switch (equipment.x1_1) {
    case 0:
      var tmp0 = this.f1b_1;
      var tmp$ret$0;
      $l$block_0: {
        // Inline function 'kotlin.collections.any' call
        var tmp_0;
        if (isInterface(tmp0, Collection)) {
          tmp_0 = tmp0.m();
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
        var _iterator__ex2g4s = tmp0.j();
        while (_iterator__ex2g4s.k()) {
          var element = _iterator__ex2g4s.l();
          if (!isSmith(element)) {
            tmp$ret$0 = true;
            break $l$block_0;
          }
        }
        tmp$ret$0 = false;
      }

      tmp = tmp$ret$0;
      break;
    case 1:
      // Inline function 'kotlin.collections.isNotEmpty' call

      tmp = !this.h1b_1.m();
      break;
    case 2:
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call

      if (!this.i1b_1.m()) {
        tmp_1 = true;
      } else {
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp_1 = !this.g1b_1.m();
      }

      tmp = tmp_1;
      break;
    case 3:
      // Inline function 'kotlin.collections.isNotEmpty' call

      tmp = !this.i1b_1.m();
      break;
    case 4:
      // Inline function 'kotlin.collections.isNotEmpty' call

      tmp = !this.j1b_1.m();
      break;
    case 5:
      tmp = true;
      break;
    case 6:
      // Inline function 'kotlin.collections.isNotEmpty' call

      tmp = !this.k1b_1.m();
      break;
    case 7:
      var tmp0_0 = this.f1b_1;
      var tmp$ret$8;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_2;
        if (isInterface(tmp0_0, Collection)) {
          tmp_2 = tmp0_0.m();
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp$ret$8 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = tmp0_0.j();
        while (_iterator__ex2g4s_0.k()) {
          var element_0 = _iterator__ex2g4s_0.l();
          if (isSmith(element_0)) {
            tmp$ret$8 = true;
            break $l$block_2;
          }
        }
        tmp$ret$8 = false;
      }

      tmp = tmp$ret$8;
      break;
    case 8:
      tmp = false;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(Gym).t1b = function (equipment) {
  var tmp;
  if (equipment.equals(Equipment_SMITH_getInstance())) {
    var tmp0 = this.f1b_1;
    var tmp$ret$0;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (isSmith(element)) {
          tmp$ret$0 = element;
          break $l$block;
        }
      }
      tmp$ret$0 = null;
    }
    tmp = tmp$ret$0;
  } else {
    var tmp0_0 = this.f1b_1;
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (!isSmith(element_0)) {
          tmp$ret$2 = element_0;
          break $l$block_0;
        }
      }
      tmp$ret$2 = null;
    }
    var tmp0_elvis_lhs = tmp$ret$2;
    tmp = tmp0_elvis_lhs == null ? firstOrNull(this.f1b_1) : tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(Gym).u1b = function (name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets) {
  return new Gym(name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets);
};
protoOf(Gym).v1b = function (name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets, $super) {
  name = name === VOID ? this.d1b_1 : name;
  isDefault = isDefault === VOID ? this.e1b_1 : isDefault;
  barbells = barbells === VOID ? this.f1b_1 : barbells;
  plates = plates === VOID ? this.g1b_1 : plates;
  dumbbells = dumbbells === VOID ? this.h1b_1 : dumbbells;
  stacks = stacks === VOID ? this.i1b_1 : stacks;
  kettlebells = kettlebells === VOID ? this.j1b_1 : kettlebells;
  bands = bands === VOID ? this.k1b_1 : bands;
  excludedExercises = excludedExercises === VOID ? this.l1b_1 : excludedExercises;
  bumperPlates = bumperPlates === VOID ? this.m1b_1 : bumperPlates;
  offsets = offsets === VOID ? this.n1b_1 : offsets;
  return $super === VOID ? this.u1b(name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets) : $super.u1b.call(this, name, isDefault, barbells, plates, dumbbells, stacks, kettlebells, bands, excludedExercises, bumperPlates, offsets);
};
protoOf(Gym).toString = function () {
  return 'Gym(name=' + this.d1b_1 + ', isDefault=' + this.e1b_1 + ', barbells=' + toString(this.f1b_1) + ', plates=' + toString(this.g1b_1) + ', dumbbells=' + toString(this.h1b_1) + ', stacks=' + toString(this.i1b_1) + ', kettlebells=' + toString(this.j1b_1) + ', bands=' + toString(this.k1b_1) + ', excludedExercises=' + toString(this.l1b_1) + ', bumperPlates=' + toString(this.m1b_1) + ', offsets=' + toString(this.n1b_1) + ')';
};
protoOf(Gym).hashCode = function () {
  var result = getStringHashCode(this.d1b_1);
  result = imul(result, 31) + getBooleanHashCode(this.e1b_1) | 0;
  result = imul(result, 31) + hashCode(this.f1b_1) | 0;
  result = imul(result, 31) + hashCode(this.g1b_1) | 0;
  result = imul(result, 31) + hashCode(this.h1b_1) | 0;
  result = imul(result, 31) + hashCode(this.i1b_1) | 0;
  result = imul(result, 31) + hashCode(this.j1b_1) | 0;
  result = imul(result, 31) + hashCode(this.k1b_1) | 0;
  result = imul(result, 31) + hashCode(this.l1b_1) | 0;
  result = imul(result, 31) + hashCode(this.m1b_1) | 0;
  result = imul(result, 31) + hashCode(this.n1b_1) | 0;
  return result;
};
protoOf(Gym).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Gym))
    return false;
  if (!(this.d1b_1 === other.d1b_1))
    return false;
  if (!(this.e1b_1 === other.e1b_1))
    return false;
  if (!equals(this.f1b_1, other.f1b_1))
    return false;
  if (!equals(this.g1b_1, other.g1b_1))
    return false;
  if (!equals(this.h1b_1, other.h1b_1))
    return false;
  if (!equals(this.i1b_1, other.i1b_1))
    return false;
  if (!equals(this.j1b_1, other.j1b_1))
    return false;
  if (!equals(this.k1b_1, other.k1b_1))
    return false;
  if (!equals(this.l1b_1, other.l1b_1))
    return false;
  if (!equals(this.m1b_1, other.m1b_1))
    return false;
  if (!equals(this.n1b_1, other.n1b_1))
    return false;
  return true;
};
var static_init_called_37;
function static_init_37() {
  if (static_init_called_37)
    return Unit_instance;
  static_init_called_37 = true;
  GymTemplate_HOME_instance = new GymTemplate('HOME', 0);
  GymTemplate_COMMERCIAL_instance = new GymTemplate('COMMERCIAL', 1);
  GymTemplate_HOTEL_instance = new GymTemplate('HOTEL', 2);
  GymTemplate_BLANK_instance = new GymTemplate('BLANK', 3);
}
var GymTemplate_HOME_instance;
var GymTemplate_COMMERCIAL_instance;
var GymTemplate_HOTEL_instance;
var GymTemplate_BLANK_instance;
function valueOf_10(value) {
  static_init_37();
  switch (value) {
    case 'HOME':
      return GymTemplate_HOME_getInstance();
    case 'COMMERCIAL':
      return GymTemplate_COMMERCIAL_getInstance();
    case 'HOTEL':
      return GymTemplate_HOTEL_getInstance();
    case 'BLANK':
      return GymTemplate_BLANK_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.GymTemplate.' + value);
      break;
  }
}
function GymTemplate(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function isSmith(_this__u8e3s4) {
  return contains_1(_this__u8e3s4.k1a_1, 'smith', true);
}
var static_init_called_38;
function static_init_38() {
  if (static_init_called_38)
    return Unit_instance;
  static_init_called_38 = true;
  LoadRounding_DOWN_instance = new LoadRounding('DOWN', 0);
  LoadRounding_UP_instance = new LoadRounding('UP', 1);
  LoadRounding_NEAREST_instance = new LoadRounding('NEAREST', 2);
}
var LoadRounding_DOWN_instance;
var LoadRounding_UP_instance;
var LoadRounding_NEAREST_instance;
function valueOf_11(value) {
  static_init_38();
  switch (value) {
    case 'DOWN':
      return LoadRounding_DOWN_getInstance();
    case 'UP':
      return LoadRounding_UP_getInstance();
    case 'NEAREST':
      return LoadRounding_NEAREST_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.LoadRounding.' + value);
      break;
  }
}
function LoadRounding(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function PlateLoadout(targetKg, barKg, platesPerSide, achievedKg, remainderKg, exact) {
  this.w1b_1 = targetKg;
  this.x1b_1 = barKg;
  this.y1b_1 = platesPerSide;
  this.z1b_1 = achievedKg;
  this.a1c_1 = remainderKg;
  this.b1c_1 = exact;
}
protoOf(PlateLoadout).toString = function () {
  return 'PlateLoadout(targetKg=' + this.w1b_1 + ', barKg=' + this.x1b_1 + ', platesPerSide=' + toString(this.y1b_1) + ', achievedKg=' + this.z1b_1 + ', remainderKg=' + this.a1c_1 + ', exact=' + this.b1c_1 + ')';
};
protoOf(PlateLoadout).hashCode = function () {
  var result = getNumberHashCode(this.w1b_1);
  result = imul(result, 31) + getNumberHashCode(this.x1b_1) | 0;
  result = imul(result, 31) + hashCode(this.y1b_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.z1b_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.a1c_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.b1c_1) | 0;
  return result;
};
protoOf(PlateLoadout).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlateLoadout))
    return false;
  if (!equals(this.w1b_1, other.w1b_1))
    return false;
  if (!equals(this.x1b_1, other.x1b_1))
    return false;
  if (!equals(this.y1b_1, other.y1b_1))
    return false;
  if (!equals(this.z1b_1, other.z1b_1))
    return false;
  if (!equals(this.a1c_1, other.a1c_1))
    return false;
  if (!(this.b1c_1 === other.b1c_1))
    return false;
  return true;
};
function subsetSums($this, weights, max) {
  var sums = setOf_0(0.0);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weights.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element > 0.0) {
      destination.f(element);
    }
  }
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var weight = _iterator__ex2g4s_0.l();
    var next = HashSet_init_$Create$_0(sums);
    var _iterator__ex2g4s_1 = sums.j();
    while (_iterator__ex2g4s_1.k()) {
      var sum = _iterator__ex2g4s_1.l();
      var total = $this.d1c(sum + weight);
      if (total <= max + 1.0E-9) {
        next.f(total);
      }
    }
    sums = next;
  }
  return sorted(sums);
}
function Loads() {
  this.c1c_1 = 500.0;
}
protoOf(Loads).e1c = function (barKg, plates, maxLoadKg) {
  // Inline function 'kotlin.require' call
  if (!(barKg >= 0.0)) {
    var message = 'barKg must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = plates.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = element.n1a_1;
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$9 = element.m1a_1;
        list.f(tmp$ret$9);
      }
       while (inductionVariable < size);
    var list_0 = list;
    addAll(destination, list_0);
  }
  var perSide = subsetSums(this, destination, (maxLoadKg - barKg) / 2.0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(perSide, 10));
  var _iterator__ex2g4s_0 = perSide.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$12 = Loads_instance.d1c(barKg + 2.0 * item);
    destination_0.f(tmp$ret$12);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = destination_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_0 = _iterator__ex2g4s_1.l();
    if (element_0 <= maxLoadKg + 1.0E-9) {
      destination_1.f(element_0);
    }
  }
  return sorted(distinct(destination_1));
};
protoOf(Loads).f1c = function (plates, maxLoadKg) {
  return this.e1c(0.0, plates, maxLoadKg);
};
protoOf(Loads).g1c = function (ranges) {
  var loads = HashSet_init_$Create$();
  var _iterator__ex2g4s = ranges.j();
  while (_iterator__ex2g4s.k()) {
    var range = _iterator__ex2g4s.l();
    // Inline function 'kotlin.require' call
    if (!(range.r1a_1 > 0.0 && range.q1a_1 >= range.p1a_1)) {
      var message = 'invalid dumbbell range';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var load = range.p1a_1;
    while (load <= range.q1a_1 + 1.0E-9) {
      loads.f(this.d1c(load));
      load = load + range.r1a_1;
    }
  }
  return sorted(loads);
};
protoOf(Loads).h1c = function (stack) {
  var settings = Strength_instance.j1c(stack.t1a_1);
  var tmp;
  switch (stack.v1a_1.x1_1) {
    case 0:
      tmp = subsetSums(this, stack.u1a_1, 1.7976931348623157E308);
      break;
    case 1:
      tmp = plus(listOf_0(0.0), stack.u1a_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var extras = tmp;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = settings.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(extras, 10));
    var _iterator__ex2g4s_0 = extras.j();
    while (_iterator__ex2g4s_0.k()) {
      var item = _iterator__ex2g4s_0.l();
      var tmp$ret$5 = Loads_instance.d1c(element + item);
      destination_0.f(tmp$ret$5);
    }
    var list = destination_0;
    addAll(destination, list);
  }
  return sorted(distinct(destination));
};
protoOf(Loads).k1c = function (weights) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weights.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element > 0.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = Loads_instance.d1c(item);
    destination_0.f(tmp$ret$5);
  }
  return sorted(distinct(destination_0));
};
protoOf(Loads).l1c = function (gym, maxAddedKg) {
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = gym.g1b_1;
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.List' call
    // Inline function 'kotlin.collections.MutableList' call
    var size = imul(element.n1a_1, 2);
    var list = ArrayList_init_$Create$(size);
    // Inline function 'kotlin.repeat' call
    var inductionVariable = 0;
    if (inductionVariable < size)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp$ret$7 = element.m1a_1;
        list.f(tmp$ret$7);
      }
       while (inductionVariable < size);
    var list_0 = list;
    addAll(destination, list_0);
  }
  var plates = subsetSums(this, destination, maxAddedKg);
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = plus(plus(plus(listOf_0(0.0), plates), this.g1c(gym.h1b_1)), this.k1c(gym.j1b_1));
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = tmp0_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (element_0 <= maxAddedKg + 1.0E-9) {
      destination_0.f(element_0);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_0, 10));
  var _iterator__ex2g4s_1 = destination_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$13 = Loads_instance.d1c(item);
    destination_1.f(tmp$ret$13);
  }
  return sorted(distinct(destination_1));
};
protoOf(Loads).m1c = function (gym, maxAddedKg, $super) {
  maxAddedKg = maxAddedKg === VOID ? 100.0 : maxAddedKg;
  return $super === VOID ? this.l1c(gym, maxAddedKg) : $super.l1c.call(this, gym, maxAddedKg);
};
protoOf(Loads).n1c = function (gym, equipment, stackName, maxLoadKg) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = gym.i1b_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (stackName == null || element.s1a_1 === stackName) {
      destination.f(element);
    }
  }
  var stacks = destination;
  var plates = plus(gym.g1b_1, gym.m1b_1);
  var tmp;
  switch (equipment.x1_1) {
    case 0:
    case 7:
      var tmp1_safe_receiver = gym.t1b(equipment);
      var tmp_0;
      if (tmp1_safe_receiver == null) {
        tmp_0 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_0 = Loads_instance.e1c(tmp1_safe_receiver.l1a_1, plates, maxLoadKg);
      }

      var tmp2_elvis_lhs = tmp_0;
      tmp = tmp2_elvis_lhs == null ? emptyList() : tmp2_elvis_lhs;
      break;
    case 1:
      tmp = this.g1c(gym.h1b_1);
      break;
    case 2:
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call

      if (!stacks.m()) {
        // Inline function 'kotlin.collections.flatMap' call
        // Inline function 'kotlin.collections.flatMapTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_0 = stacks.j();
        while (_iterator__ex2g4s_0.k()) {
          var element_0 = _iterator__ex2g4s_0.l();
          var list = Loads_instance.h1c(element_0);
          addAll(destination_0, list);
        }
        tmp_1 = sorted(distinct(destination_0));
      } else {
        tmp_1 = this.f1c(plates, maxLoadKg);
      }

      tmp = tmp_1;
      break;
    case 3:
      // Inline function 'kotlin.collections.flatMap' call

      // Inline function 'kotlin.collections.flatMapTo' call

      var destination_1 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_1 = stacks.j();
      while (_iterator__ex2g4s_1.k()) {
        var element_1 = _iterator__ex2g4s_1.l();
        var list_0 = Loads_instance.h1c(element_1);
        addAll(destination_1, list_0);
      }

      tmp = sorted(distinct(destination_1));
      break;
    case 4:
      tmp = this.k1c(gym.j1b_1);
      break;
    case 5:
      tmp = this.m1c(gym);
      break;
    case 6:
    case 8:
      tmp = emptyList();
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var loads = tmp;
  var tmp3_elvis_lhs = gym.n1b_1.s1(equipment);
  var tmp_2;
  if (tmp3_elvis_lhs == null) {
    return loads;
  } else {
    tmp_2 = tmp3_elvis_lhs;
  }
  var offset = tmp_2;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(loads, 10));
  var _iterator__ex2g4s_2 = loads.j();
  while (_iterator__ex2g4s_2.k()) {
    var item = _iterator__ex2g4s_2.l();
    var tmp$ret$14 = Loads_instance.d1c(item + offset);
    destination_2.f(tmp$ret$14);
  }
  return destination_2;
};
protoOf(Loads).o1c = function (gym, equipment, stackName, maxLoadKg, $super) {
  stackName = stackName === VOID ? null : stackName;
  maxLoadKg = maxLoadKg === VOID ? 500.0 : maxLoadKg;
  return $super === VOID ? this.n1c(gym, equipment, stackName, maxLoadKg) : $super.n1c.call(this, gym, equipment, stackName, maxLoadKg);
};
protoOf(Loads).p1c = function (loads, targetKg, rounding) {
  if (loads.m())
    return null;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = loads.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element <= targetKg + 1.0E-9) {
      destination.f(element);
    }
  }
  var below = maxOrNull(destination);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = loads.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (element_0 >= targetKg - 1.0E-9) {
      destination_0.f(element_0);
    }
  }
  var above = minOrNull(destination_0);
  var tmp;
  switch (rounding.x1_1) {
    case 0:
      tmp = below == null ? min(loads) : below;
      break;
    case 1:
      tmp = above == null ? max(loads) : above;
      break;
    case 2:
      var tmp_0;
      if (below == null) {
        tmp_0 = above;
      } else {
        if (above == null) {
          tmp_0 = below;
        } else {
          // Inline function 'kotlin.math.abs' call
          var x = above - targetKg;
          var tmp_1 = Math.abs(x);
          // Inline function 'kotlin.math.abs' call
          var x_0 = targetKg - below;
          if (tmp_1 < Math.abs(x_0) - 1.0E-9) {
            tmp_0 = above;
          } else {
            tmp_0 = below;
          }
        }
      }

      tmp = tmp_0;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(Loads).q1c = function (loads, targetKg, rounding, $super) {
  rounding = rounding === VOID ? LoadRounding_NEAREST_getInstance() : rounding;
  return $super === VOID ? this.p1c(loads, targetKg, rounding) : $super.p1c.call(this, loads, targetKg, rounding);
};
protoOf(Loads).r1c = function (loads, currentKg, up) {
  var tmp;
  if (up) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = loads.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element > currentKg + 1.0E-9) {
        destination.f(element);
      }
    }
    tmp = minOrNull(destination);
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_0 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = loads.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (element_0 < currentKg - 1.0E-9) {
        destination_0.f(element_0);
      }
    }
    tmp = maxOrNull(destination_0);
  }
  return tmp;
};
protoOf(Loads).s1c = function (loads, currentKg, up, $super) {
  up = up === VOID ? true : up;
  return $super === VOID ? this.r1c(loads, currentKg, up) : $super.r1c.call(this, loads, currentKg, up);
};
protoOf(Loads).d1c = function (value) {
  return round(value * 1000.0) / 1000.0;
};
var Loads_instance;
function Loads_getInstance() {
  return Loads_instance;
}
function Search(sizes, perSide) {
  this.t1c_1 = sizes;
  this.u1c_1 = perSide;
  this.v1c_1 = 0.0;
  this.w1c_1 = 0;
  this.x1c_1 = new Int32Array(this.t1c_1.o());
  var tmp = this;
  // Inline function 'kotlin.also' call
  var this_0 = new Float64Array(this.t1c_1.o() + 1 | 0);
  var inductionVariable = this.t1c_1.o() - 1 | 0;
  if (0 <= inductionVariable)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      this_0[i] = this_0[i + 1 | 0] + this.t1c_1.n(i).m1a_1 * this.t1c_1.n(i).n1a_1;
    }
     while (0 <= inductionVariable);
  tmp.y1c_1 = this_0;
}
protoOf(Search).z1c = function (index, sum, counts, plates) {
  var tmp;
  if (sum > this.v1c_1 + 1.0E-9) {
    tmp = true;
  } else {
    var tmp_0;
    // Inline function 'kotlin.math.abs' call
    var x = sum - this.v1c_1;
    if (Math.abs(x) < 1.0E-9) {
      tmp_0 = plates < this.w1c_1;
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  }
  if (tmp) {
    this.v1c_1 = sum;
    this.w1c_1 = plates;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_1.x1c_1 = counts.slice();
  }
  var tmp_2;
  if (index === this.t1c_1.o()) {
    tmp_2 = true;
  } else {
    var tmp_3;
    // Inline function 'kotlin.math.abs' call
    var x_0 = this.v1c_1 - this.u1c_1;
    if (Math.abs(x_0) < 1.0E-9) {
      tmp_3 = plates >= this.w1c_1;
    } else {
      tmp_3 = false;
    }
    tmp_2 = tmp_3;
  }
  if (tmp_2)
    return Unit_instance;
  if (sum + this.y1c_1[index] < this.v1c_1 - 1.0E-9)
    return Unit_instance;
  var size = this.t1c_1.n(index);
  var tmp0 = size.n1a_1;
  // Inline function 'kotlin.math.floor' call
  var x_1 = (this.u1c_1 - sum) / size.m1a_1 + 1.0E-9;
  var tmp$ret$4 = Math.floor(x_1);
  // Inline function 'kotlin.comparisons.minOf' call
  var b = numberToInt(tmp$ret$4);
  var most = Math.min(tmp0, b);
  var inductionVariable = most;
  if (0 <= inductionVariable)
    do {
      var count = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      counts[index] = count;
      this.z1c(index + 1 | 0, sum + count * size.m1a_1, counts, plates + count | 0);
    }
     while (0 <= inductionVariable);
  counts[index] = 0;
};
function sam$kotlin_Comparator$0_7(function_0) {
  this.a1d_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_7).y9 = function (a, b) {
  return this.a1d_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_7).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_7).g2 = function () {
  return this.a1d_1;
};
protoOf(sam$kotlin_Comparator$0_7).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_7).hashCode = function () {
  return hashCode(this.g2());
};
function PlateCalculator$calculate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.m1a_1;
  var tmp$ret$2 = a.m1a_1;
  return compareValues(tmp, tmp$ret$2);
}
function PlateCalculator() {
}
protoOf(PlateCalculator).b1d = function (targetKg, barKg, plates) {
  // Inline function 'kotlin.require' call
  if (!(barKg >= 0.0)) {
    var message = 'barKg must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (targetKg <= barKg + 1.0E-9) {
    var tmp = emptyList();
    var tmp_0 = Loads_instance.d1c(targetKg - barKg);
    // Inline function 'kotlin.math.abs' call
    var x = targetKg - barKg;
    var tmp$ret$2 = Math.abs(x);
    return new PlateLoadout(targetKg, barKg, tmp, barKg, tmp_0, tmp$ret$2 < 1.0E-9);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = plates.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.m1a_1 > 0.0 && element.n1a_1 > 0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = element_0.m1a_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.s1(key);
    var tmp_1;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.k2(key, answer);
      tmp_1 = answer;
    } else {
      tmp_1 = value;
    }
    var list = tmp_1;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(destination_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = destination_0.v1().j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var kg = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var group = item.p1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_2 = group.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_2 = sum;
      sum = tmp_2 + element_1.n1a_1 | 0;
    }
    var tmp$ret$17 = sum;
    var tmp$ret$14 = new PlatePair(kg, tmp$ret$17);
    destination_1.f(tmp$ret$14);
  }
  // Inline function 'kotlin.collections.sortedByDescending' call
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_3 = PlateCalculator$calculate$lambda;
  var tmp$ret$20 = new sam$kotlin_Comparator$0_7(tmp_3);
  var sizes = sortedWith(destination_1, tmp$ret$20);
  var perSide = (targetKg - barKg) / 2.0;
  var search = new Search(sizes, perSide);
  search.z1c(0, 0.0, new Int32Array(sizes.o()), 0);
  var counts = search.x1c_1;
  // Inline function 'kotlin.collections.flatMap' call
  var tmp0 = get_indices(sizes);
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.oc_1;
  var last = tmp0.pc_1;
  if (inductionVariable <= last)
    do {
      var element_2 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = element_2;
      // Inline function 'kotlin.collections.List' call
      // Inline function 'kotlin.collections.MutableList' call
      var size = counts[i];
      var list_0 = ArrayList_init_$Create$(size);
      // Inline function 'kotlin.repeat' call
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < size)
        do {
          var index = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var tmp$ret$28 = sizes.n(i).m1a_1;
          list_0.f(tmp$ret$28);
        }
         while (inductionVariable_0 < size);
      var list_1 = list_0;
      addAll(destination_2, list_1);
    }
     while (!(element_2 === last));
  var side = destination_2;
  var achieved = Loads_instance.d1c(barKg + 2.0 * search.v1c_1);
  var remainder = Loads_instance.d1c(targetKg - achieved);
  // Inline function 'kotlin.math.abs' call
  var tmp$ret$29 = Math.abs(remainder);
  return new PlateLoadout(targetKg, barKg, side, achieved, remainder, tmp$ret$29 < 1.0E-6);
};
protoOf(PlateCalculator).c1d = function (previous, next) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(next, 10));
  var _iterator__ex2g4s = next.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = Loads_instance.d1c(item);
    destination.f(tmp$ret$2);
  }
  var remaining = toMutableList(destination);
  var tmp$ret$3;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(previous, Collection)) {
      tmp = previous.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$3 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s_0 = previous.j();
    while (_iterator__ex2g4s_0.k()) {
      var element = _iterator__ex2g4s_0.l();
      if (!remaining.o2(Loads_instance.d1c(element))) {
        tmp$ret$3 = false;
        break $l$block_0;
      }
    }
    tmp$ret$3 = true;
  }
  return tmp$ret$3;
};
var PlateCalculator_instance;
function PlateCalculator_getInstance() {
  return PlateCalculator_instance;
}
function MicroMode_ANY_getInstance() {
  static_init_36();
  return MicroMode_ANY_instance;
}
function MicroMode_ONE_getInstance() {
  static_init_36();
  return MicroMode_ONE_instance;
}
function GymTemplate_HOME_getInstance() {
  static_init_37();
  return GymTemplate_HOME_instance;
}
function GymTemplate_COMMERCIAL_getInstance() {
  static_init_37();
  return GymTemplate_COMMERCIAL_instance;
}
function GymTemplate_HOTEL_getInstance() {
  static_init_37();
  return GymTemplate_HOTEL_instance;
}
function GymTemplate_BLANK_getInstance() {
  static_init_37();
  return GymTemplate_BLANK_instance;
}
function LoadRounding_DOWN_getInstance() {
  static_init_38();
  return LoadRounding_DOWN_instance;
}
function LoadRounding_UP_getInstance() {
  static_init_38();
  return LoadRounding_UP_instance;
}
function LoadRounding_NEAREST_getInstance() {
  static_init_38();
  return LoadRounding_NEAREST_instance;
}
function get_CHECKLIST_EQUIPMENT() {
  _init_properties_GymEquipment_kt__chemgj();
  return CHECKLIST_EQUIPMENT;
}
var CHECKLIST_EQUIPMENT;
function get_MACHINE_STEP_PRESETS_KG() {
  _init_properties_GymEquipment_kt__chemgj();
  return MACHINE_STEP_PRESETS_KG;
}
var MACHINE_STEP_PRESETS_KG;
function isWeightStack(_this__u8e3s4) {
  _init_properties_GymEquipment_kt__chemgj();
  return _this__u8e3s4.equals(Equipment_MACHINE_getInstance()) || _this__u8e3s4.equals(Equipment_CABLE_getInstance());
}
function stackFromStep(name, stepKg) {
  _init_properties_GymEquipment_kt__chemgj();
  // Inline function 'kotlin.text.trim' call
  // Inline function 'kotlin.text.ifEmpty' call
  var this_0 = toString(trim(isCharSequence(name) ? name : THROW_CCE()));
  var tmp;
  // Inline function 'kotlin.text.isEmpty' call
  if (charSequenceLength(this_0) === 0) {
    tmp = 'Machine';
  } else {
    tmp = this_0;
  }
  var tmp$ret$1 = tmp;
  return new WeightStack(tmp$ret$1, listOf_0(new StackRange(stepKg, 200.0, stepKg)));
}
function adding(_this__u8e3s4, equipment, stack) {
  stack = stack === VOID ? null : stack;
  _init_properties_GymEquipment_kt__chemgj();
  if (_this__u8e3s4.s1b(equipment))
    return _this__u8e3s4;
  var home = Companion_getInstance_9().c1b(GymTemplate_HOME_getInstance());
  var commercial = Companion_getInstance_9().c1b(GymTemplate_COMMERCIAL_getInstance());
  var tmp;
  switch (equipment.x1_1) {
    case 0:
      var tmp_0 = plus(_this__u8e3s4.f1b_1, home.f1b_1);
      // Inline function 'kotlin.collections.ifEmpty' call

      var this_0 = _this__u8e3s4.g1b_1;
      var tmp_1;
      if (this_0.m()) {
        tmp_1 = home.g1b_1;
      } else {
        tmp_1 = this_0;
      }

      var tmp$ret$0 = tmp_1;
      tmp = _this__u8e3s4.v1b(VOID, VOID, tmp_0, tmp$ret$0);
      break;
    case 7:
      // Inline function 'kotlin.collections.filter' call

      var tmp0 = commercial.f1b_1;
      // Inline function 'kotlin.collections.filterTo' call

      var destination = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (contains_1(element.k1a_1, 'smith', true)) {
          destination.f(element);
        }
      }

      tmp = _this__u8e3s4.v1b(VOID, VOID, plus(_this__u8e3s4.f1b_1, destination));
      break;
    case 1:
      tmp = _this__u8e3s4.v1b(VOID, VOID, VOID, VOID, home.h1b_1);
      break;
    case 4:
      tmp = _this__u8e3s4.v1b(VOID, VOID, VOID, VOID, VOID, VOID, commercial.j1b_1);
      break;
    case 6:
      tmp = _this__u8e3s4.v1b(VOID, VOID, VOID, VOID, VOID, VOID, VOID, commercial.k1b_1);
      break;
    case 2:
    case 3:
      var tmp_2;
      if (stack == null) {
        tmp_2 = null;
      } else {
        // Inline function 'kotlin.let' call
        tmp_2 = _this__u8e3s4.v1b(VOID, VOID, VOID, VOID, VOID, plus_0(_this__u8e3s4.i1b_1, stack));
      }

      var tmp2_elvis_lhs = tmp_2;
      tmp = tmp2_elvis_lhs == null ? _this__u8e3s4 : tmp2_elvis_lhs;
      break;
    case 5:
    case 8:
      tmp = _this__u8e3s4;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function removing(_this__u8e3s4, equipment) {
  _init_properties_GymEquipment_kt__chemgj();
  switch (equipment.x1_1) {
    case 0:
      return _this__u8e3s4.v1b(VOID, VOID, emptyList(), emptyList());
    case 1:
      return _this__u8e3s4.v1b(VOID, VOID, VOID, VOID, emptyList());
    case 4:
      return _this__u8e3s4.v1b(VOID, VOID, VOID, VOID, VOID, VOID, emptyList());
    case 6:
      return _this__u8e3s4.v1b(VOID, VOID, VOID, VOID, VOID, VOID, VOID, emptyList());
    default:
      return _this__u8e3s4;
  }
}
var properties_initialized_GymEquipment_kt_2uuwtx;
function _init_properties_GymEquipment_kt__chemgj() {
  if (!properties_initialized_GymEquipment_kt_2uuwtx) {
    properties_initialized_GymEquipment_kt_2uuwtx = true;
    CHECKLIST_EQUIPMENT = listOf([Equipment_BARBELL_getInstance(), Equipment_DUMBBELL_getInstance(), Equipment_KETTLEBELL_getInstance(), Equipment_BAND_getInstance(), Equipment_MACHINE_getInstance(), Equipment_CABLE_getInstance()]);
    MACHINE_STEP_PRESETS_KG = listOf([2.5, 5.0, 7.0]);
  }
}
var static_init_called_39;
function static_init_39() {
  if (static_init_called_39)
    return Unit_instance;
  static_init_called_39 = true;
  LevelStatus_NONE_instance = new LevelStatus('NONE', 0);
  LevelStatus_UNDER_instance = new LevelStatus('UNDER', 1);
  LevelStatus_ON_instance = new LevelStatus('ON', 2);
  LevelStatus_HIGH_instance = new LevelStatus('HIGH', 3);
}
var LevelStatus_NONE_instance;
var LevelStatus_UNDER_instance;
var LevelStatus_ON_instance;
var LevelStatus_HIGH_instance;
function LevelStatus(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function MuscleLevel(muscle, weeklySets, targetSets, ratio, status, recovery) {
  this.d1d_1 = muscle;
  this.e1d_1 = weeklySets;
  this.f1d_1 = targetSets;
  this.g1d_1 = ratio;
  this.h1d_1 = status;
  this.i1d_1 = recovery;
}
protoOf(MuscleLevel).toString = function () {
  return 'MuscleLevel(muscle=' + this.d1d_1.toString() + ', weeklySets=' + this.e1d_1 + ', targetSets=' + this.f1d_1 + ', ratio=' + this.g1d_1 + ', status=' + this.h1d_1.toString() + ', recovery=' + this.i1d_1 + ')';
};
protoOf(MuscleLevel).hashCode = function () {
  var result = this.d1d_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.e1d_1) | 0;
  result = imul(result, 31) + (this.f1d_1 == null ? 0 : getNumberHashCode(this.f1d_1)) | 0;
  result = imul(result, 31) + (this.g1d_1 == null ? 0 : getNumberHashCode(this.g1d_1)) | 0;
  result = imul(result, 31) + this.h1d_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.i1d_1) | 0;
  return result;
};
protoOf(MuscleLevel).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof MuscleLevel))
    return false;
  if (!this.d1d_1.equals(other.d1d_1))
    return false;
  if (!equals(this.e1d_1, other.e1d_1))
    return false;
  if (!equals(this.f1d_1, other.f1d_1))
    return false;
  if (!equals(this.g1d_1, other.g1d_1))
    return false;
  if (!this.h1d_1.equals(other.h1d_1))
    return false;
  if (!equals(this.i1d_1, other.i1d_1))
    return false;
  return true;
};
function MuscleLevels() {
  this.j1d_1 = 0.8;
  this.k1d_1 = 1.2;
  this.l1d_1 = 2.0;
}
protoOf(MuscleLevels).m1d = function (sets, exercises, today, targets, windowDays) {
  var weekly = TrainingAnalytics_instance.o1d(sets, exercises, today, windowDays);
  var recovery = this.p1d(sets, exercises, today);
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_entries_30();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var done = getValue(weekly, item);
    var tmp0_safe_receiver = targets.s1(item);
    var tmp;
    if (tmp0_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_0;
      if (tmp0_safe_receiver > 0.0) {
        tmp_0 = tmp0_safe_receiver;
      } else {
        tmp_0 = null;
      }
      tmp = tmp_0;
    }
    var target = tmp;
    var tmp_1;
    if (target == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = done / target;
    }
    var ratio = tmp_1;
    var status = ratio == null ? LevelStatus_NONE_getInstance() : ratio < 0.8 ? LevelStatus_UNDER_getInstance() : ratio <= 1.2 ? LevelStatus_ON_getInstance() : LevelStatus_HIGH_getInstance();
    var tmp$ret$2 = new MuscleLevel(item, done, target, ratio, status, getValue(recovery, item));
    destination.f(tmp$ret$2);
  }
  return destination;
};
protoOf(MuscleLevels).q1d = function (sets, exercises, today, targets, windowDays, $super) {
  windowDays = windowDays === VOID ? LevelsWindow_WEEK_getInstance().t1d_1 : windowDays;
  return $super === VOID ? this.m1d(sets, exercises, today, targets, windowDays) : $super.m1d.call(this, sets, exercises, today, targets, windowDays);
};
protoOf(MuscleLevels).u1d = function (sets, exercises, today, tauDays) {
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = get_entries_30();
  var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    result.k2(element, 0.0);
  }
  var totals = toMutableMap(result);
  var _iterator__ex2g4s_0 = sets.j();
  $l$loop_0: while (_iterator__ex2g4s_0.k()) {
    var set = _iterator__ex2g4s_0.l();
    if (set.z1d_1.equals(SetType_WARMUP_getInstance()) || set.b1e_1 <= 0 || set.w1d_1 > today)
      continue $l$loop_0;
    var tmp0_elvis_lhs = exercises.s1(set.x1d_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var exercise = tmp;
    // Inline function 'kotlin.math.exp' call
    var x = (-(today - set.w1d_1 | 0) | 0) / tauDays;
    var weight = Math.exp(x);
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = exercise.h1e_1.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      // Inline function 'kotlin.collections.set' call
      var value = getValue(totals, element_0) + weight;
      totals.k2(element_0, value);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = exercise.i1e_1.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      // Inline function 'kotlin.collections.set' call
      var value_0 = getValue(totals, element_1) + 0.5 * weight;
      totals.k2(element_1, value_0);
    }
  }
  return totals;
};
protoOf(MuscleLevels).p1d = function (sets, exercises, today, tauDays, $super) {
  tauDays = tauDays === VOID ? 2.0 : tauDays;
  return $super === VOID ? this.u1d(sets, exercises, today, tauDays) : $super.u1d.call(this, sets, exercises, today, tauDays);
};
var MuscleLevels_instance;
function MuscleLevels_getInstance() {
  return MuscleLevels_instance;
}
var static_init_called_40;
function static_init_40() {
  if (static_init_called_40)
    return Unit_instance;
  static_init_called_40 = true;
  MuscleIntensity_PRIMARY_instance = new MuscleIntensity('PRIMARY', 0);
  MuscleIntensity_SECONDARY_instance = new MuscleIntensity('SECONDARY', 1);
}
var MuscleIntensity_PRIMARY_instance;
var MuscleIntensity_SECONDARY_instance;
function MuscleIntensity(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function MuscleHighlights() {
}
protoOf(MuscleHighlights).v1e = function (primaryMuscles, secondaryMuscles) {
  // Inline function 'kotlin.collections.mutableMapOf' call
  var result = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = secondaryMuscles.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.set' call
    var value = MuscleIntensity_SECONDARY_getInstance();
    result.k2(element, value);
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = primaryMuscles.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.set' call
    var value_0 = MuscleIntensity_PRIMARY_getInstance();
    result.k2(element_0, value_0);
  }
  return result;
};
var MuscleHighlights_instance;
function MuscleHighlights_getInstance() {
  return MuscleHighlights_instance;
}
function LevelStatus_NONE_getInstance() {
  static_init_39();
  return LevelStatus_NONE_instance;
}
function LevelStatus_UNDER_getInstance() {
  static_init_39();
  return LevelStatus_UNDER_instance;
}
function LevelStatus_ON_getInstance() {
  static_init_39();
  return LevelStatus_ON_instance;
}
function LevelStatus_HIGH_getInstance() {
  static_init_39();
  return LevelStatus_HIGH_instance;
}
function MuscleIntensity_PRIMARY_getInstance() {
  static_init_40();
  return MuscleIntensity_PRIMARY_instance;
}
function MuscleIntensity_SECONDARY_getInstance() {
  static_init_40();
  return MuscleIntensity_SECONDARY_instance;
}
function roundHalfUp($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0);
}
function repRange$at($repMin, window_0, offset) {
  return to($repMin + offset | 0, ($repMin + offset | 0) + window_0 | 0);
}
function Periodisation() {
  this.w1e_1 = 3;
  this.x1e_1 = 1;
  this.y1e_1 = 2;
}
protoOf(Periodisation).z1e = function (cycles, startSets, peakSets, repMin, repMax, scheme, deload, startRir, endRir, setType, occurrence) {
  // Inline function 'kotlin.require' call
  if (!(cycles >= 1)) {
    var message = 'cycles must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(startSets >= 1 && peakSets >= 1)) {
    var message_0 = 'sets must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(1 <= repMin ? repMin <= repMax : false)) {
    var message_1 = 'invalid rep range';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  // Inline function 'kotlin.require' call
  if (!((0 <= startRir ? startRir <= 10 : false) && (0 <= endRir ? endRir <= 10 : false))) {
    var message_2 = 'rir must be 0\u201310';
    throw IllegalArgumentException_init_$Create$(toString(message_2));
  }
  // Inline function 'kotlin.require' call
  if (!(occurrence >= 0)) {
    var message_3 = 'occurrence must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_3));
  }
  var hasDeload = !deload.equals(DeloadPosition_NONE_getInstance()) && cycles >= 2;
  var loadingCycles = hasDeload ? cycles - 1 | 0 : cycles;
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, loadingCycles);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last_0 = this_0.pc_1;
  if (inductionVariable <= last_0)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = item;
      var t = loadingCycles === 1 ? 0.0 : c / (loadingCycles - 1 | 0);
      var _destruct__k2r9zo = Periodisation_instance.a1f(repMin, repMax, scheme, c, loadingCycles, occurrence);
      var low = _destruct__k2r9zo.ya();
      var high = _destruct__k2r9zo.za();
      // Inline function 'kotlin.math.max' call
      var b = roundHalfUp(Periodisation_instance, startSets + (peakSets - startSets | 0) * t);
      var tmp$ret$13 = Math.max(1, b);
      var tmp$ret$12 = new CyclePrescription(tmp$ret$13, low, high, coerceIn_0(roundHalfUp(Periodisation_instance, startRir + (endRir - startRir | 0) * t), 0, 10), setType);
      destination.f(tmp$ret$12);
    }
     while (!(item === last_0));
  var loading = destination;
  if (!hasDeload)
    return loading;
  var reference = deload.equals(DeloadPosition_FIRST_getInstance()) ? first(loading) : last(loading);
  // Inline function 'kotlin.math.ceil' call
  var x = reference.b1f_1 / 2.0;
  var tmp$ret$14 = Math.ceil(x);
  // Inline function 'kotlin.math.max' call
  var b_0 = numberToInt(tmp$ret$14);
  var tmp = Math.max(1, b_0);
  // Inline function 'kotlin.math.min' call
  var b_1 = reference.e1f_1 + 2 | 0;
  var tmp$ret$16 = Math.min(10, b_1);
  var deloadCycle = new CyclePrescription(tmp, reference.c1f_1, reference.d1f_1, tmp$ret$16, setType.equals(SetType_FAILURE_getInstance()) ? SetType_STANDARD_getInstance() : setType);
  return deload.equals(DeloadPosition_FIRST_getInstance()) ? plus(listOf_0(deloadCycle), loading) : plus_0(loading, deloadCycle);
};
protoOf(Periodisation).h1f = function (cycles, startSets, peakSets, repMin, repMax, scheme, deload, startRir, endRir, setType, occurrence, $super) {
  deload = deload === VOID ? DeloadPosition_NONE_getInstance() : deload;
  startRir = startRir === VOID ? 3 : startRir;
  endRir = endRir === VOID ? 1 : endRir;
  setType = setType === VOID ? SetType_STANDARD_getInstance() : setType;
  occurrence = occurrence === VOID ? 0 : occurrence;
  return $super === VOID ? this.z1e(cycles, startSets, peakSets, repMin, repMax, scheme, deload, startRir, endRir, setType, occurrence) : $super.z1e.call(this, cycles, startSets, peakSets, repMin, repMax, scheme, deload, startRir, endRir, setType, occurrence);
};
protoOf(Periodisation).a1f = function (repMin, repMax, scheme, cycle, loadingCycles, occurrence) {
  var width = repMax - repMin | 0;
  var tmp;
  if (width <= 1) {
    tmp = width;
  } else {
    // Inline function 'kotlin.math.ceil' call
    var x = width / 2.0;
    var tmp$ret$0 = Math.ceil(x);
    tmp = numberToInt(tmp$ret$0);
  }
  var window_0 = tmp;
  var slack = width - window_0 | 0;
  var t = loadingCycles <= 1 ? 0.0 : cycle / (loadingCycles - 1 | 0);
  var tmp_0;
  switch (scheme.x1_1) {
    case 0:
    case 4:
      tmp_0 = to(repMin, repMax);
      break;
    case 1:
      tmp_0 = loadingCycles <= 1 ? to(repMin, repMax) : repRange$at(repMin, window_0, roundHalfUp(this, slack * (1.0 - t)));
      break;
    case 2:
      tmp_0 = loadingCycles <= 1 ? to(repMin, repMax) : repRange$at(repMin, window_0, roundHalfUp(this, slack * t));
      break;
    case 3:
      switch ((cycle + occurrence | 0) % 3 | 0) {
        case 0:
          tmp_0 = repRange$at(repMin, window_0, 0);
          break;
        case 1:
          tmp_0 = repRange$at(repMin, window_0, slack);
          break;
        default:
          tmp_0 = repRange$at(repMin, window_0, slack / 2 | 0);
          break;
      }

      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_0;
};
var Periodisation_instance;
function Periodisation_getInstance() {
  return Periodisation_instance;
}
var static_init_called_41;
function static_init_41() {
  if (static_init_called_41)
    return Unit_instance;
  static_init_called_41 = true;
  Experience_BEGINNER_instance = new Experience('BEGINNER', 0);
  Experience_INTERMEDIATE_instance = new Experience('INTERMEDIATE', 1);
  Experience_ADVANCED_instance = new Experience('ADVANCED', 2);
}
var Experience_BEGINNER_instance;
var Experience_INTERMEDIATE_instance;
var Experience_ADVANCED_instance;
function values_28() {
  static_init_41();
  return [Experience_BEGINNER_getInstance(), Experience_INTERMEDIATE_getInstance(), Experience_ADVANCED_getInstance()];
}
function get_entries_23() {
  static_init_41();
  if ($ENTRIES_23 == null)
    $ENTRIES_23 = enumEntries(values_28());
  return $ENTRIES_23;
}
var $ENTRIES_23;
function Experience(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_42;
function static_init_42() {
  if (static_init_called_42)
    return Unit_instance;
  static_init_called_42 = true;
  Split_AUTO_instance = new Split('AUTO', 0, 'Auto');
  Split_FULL_BODY_instance = new Split('FULL_BODY', 1, 'Full Body');
  Split_UPPER_LOWER_instance = new Split('UPPER_LOWER', 2, 'Upper/Lower');
  Split_PPL_instance = new Split('PPL', 3, 'Push/Pull/Legs');
  Split_PUSH_PULL_HINGE_SQUAT_instance = new Split('PUSH_PULL_HINGE_SQUAT', 4, 'Push/Pull/Hinge/Squat');
  Split_PPL_ACCESSORIES_instance = new Split('PPL_ACCESSORIES', 5, 'PPL + Accessories');
  Split_PPHS_ACCESSORIES_instance = new Split('PPHS_ACCESSORIES', 6, 'PPHS + Accessories');
  Split_PPL_UPPER_LOWER_instance = new Split('PPL_UPPER_LOWER', 7, 'PPL + Upper/Lower');
  Split_PPHS_UPPER_LOWER_instance = new Split('PPHS_UPPER_LOWER', 8, 'PPHS + Upper/Lower');
}
var Split_AUTO_instance;
var Split_FULL_BODY_instance;
var Split_UPPER_LOWER_instance;
var Split_PPL_instance;
var Split_PUSH_PULL_HINGE_SQUAT_instance;
var Split_PPL_ACCESSORIES_instance;
var Split_PPHS_ACCESSORIES_instance;
var Split_PPL_UPPER_LOWER_instance;
var Split_PPHS_UPPER_LOWER_instance;
function values_29() {
  static_init_42();
  return [Split_AUTO_getInstance(), Split_FULL_BODY_getInstance(), Split_UPPER_LOWER_getInstance(), Split_PPL_getInstance(), Split_PUSH_PULL_HINGE_SQUAT_getInstance(), Split_PPL_ACCESSORIES_getInstance(), Split_PPHS_ACCESSORIES_getInstance(), Split_PPL_UPPER_LOWER_getInstance(), Split_PPHS_UPPER_LOWER_getInstance()];
}
function get_entries_24() {
  static_init_42();
  if ($ENTRIES_24 == null)
    $ENTRIES_24 = enumEntries(values_29());
  return $ENTRIES_24;
}
var $ENTRIES_24;
function Split(name, ordinal, label) {
  Enum.call(this, name, ordinal);
  this.k1f_1 = label;
}
var static_init_called_43;
function static_init_43() {
  if (static_init_called_43)
    return Unit_instance;
  static_init_called_43 = true;
  CompoundSetRule_GREEDY_instance = new CompoundSetRule('GREEDY', 0);
  CompoundSetRule_POWER_instance = new CompoundSetRule('POWER', 1);
}
var CompoundSetRule_GREEDY_instance;
var CompoundSetRule_POWER_instance;
function values_30() {
  static_init_43();
  return [CompoundSetRule_GREEDY_getInstance(), CompoundSetRule_POWER_getInstance()];
}
function get_entries_25() {
  static_init_43();
  if ($ENTRIES_25 == null)
    $ENTRIES_25 = enumEntries(values_30());
  return $ENTRIES_25;
}
var $ENTRIES_25;
function CompoundSetRule(name, ordinal) {
  Enum.call(this, name, ordinal);
}
protoOf(CompoundSetRule).n1f = function (need) {
  // Inline function 'kotlin.math.floor' call
  var x = need + 0.5;
  var tmp$ret$0 = Math.floor(x);
  var n = numberToInt(tmp$ret$0);
  if (this.equals(CompoundSetRule_GREEDY_getInstance()) || n < 1)
    return null;
  // Inline function 'kotlin.math.pow' call
  var raw = 2.0 * Math.pow(n, 0.33);
  // Inline function 'kotlin.math.floor' call
  var x_0 = raw + 0.5;
  var tmp$ret$2 = Math.floor(x_0);
  // Inline function 'kotlin.math.min' call
  var b = numberToInt(tmp$ret$2);
  // Inline function 'kotlin.math.min' call
  var b_0 = Math.min(5, b);
  var tmp$ret$4 = Math.min(n, b_0);
  return coerceAtLeast(tmp$ret$4, 1);
};
var static_init_called_44;
function static_init_44() {
  if (static_init_called_44)
    return Unit_instance;
  static_init_called_44 = true;
  RestRule_BY_GOAL_instance = new RestRule('BY_GOAL', 0);
  RestRule_BY_TYPE_instance = new RestRule('BY_TYPE', 1);
}
var RestRule_BY_GOAL_instance;
var RestRule_BY_TYPE_instance;
function values_31() {
  static_init_44();
  return [RestRule_BY_GOAL_getInstance(), RestRule_BY_TYPE_getInstance()];
}
function get_entries_26() {
  static_init_44();
  if ($ENTRIES_26 == null)
    $ENTRIES_26 = enumEntries(values_31());
  return $ENTRIES_26;
}
var $ENTRIES_26;
function RestRule(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function GeneratorSettings(goal, daysPerWeek, minutesPerSession, experience, split, focus, deprioritised, includeDeloads, deload, cycles, progression, excludedExercises, name, useLibraryRanks, skills, familiar, compoundSets, rest, powerWork) {
  goal = goal === VOID ? TrainingGoal_HYPERTROPHY_getInstance() : goal;
  daysPerWeek = daysPerWeek === VOID ? 3 : daysPerWeek;
  minutesPerSession = minutesPerSession === VOID ? 60 : minutesPerSession;
  experience = experience === VOID ? Experience_INTERMEDIATE_getInstance() : experience;
  split = split === VOID ? Split_AUTO_getInstance() : split;
  focus = focus === VOID ? emptyList() : focus;
  deprioritised = deprioritised === VOID ? emptyList() : deprioritised;
  includeDeloads = includeDeloads === VOID ? true : includeDeloads;
  deload = deload === VOID ? DeloadPosition_LAST_getInstance() : deload;
  cycles = cycles === VOID ? 5 : cycles;
  progression = progression === VOID ? ProgressionScheme_DOUBLE_getInstance() : progression;
  excludedExercises = excludedExercises === VOID ? emptySet() : excludedExercises;
  name = name === VOID ? null : name;
  useLibraryRanks = useLibraryRanks === VOID ? false : useLibraryRanks;
  skills = skills === VOID ? emptySet() : skills;
  familiar = familiar === VOID ? emptyMap() : familiar;
  compoundSets = compoundSets === VOID ? CompoundSetRule_GREEDY_getInstance() : compoundSets;
  rest = rest === VOID ? RestRule_BY_GOAL_getInstance() : rest;
  powerWork = powerWork === VOID ? false : powerWork;
  this.q19_1 = goal;
  this.r19_1 = daysPerWeek;
  this.s19_1 = minutesPerSession;
  this.t19_1 = experience;
  this.u19_1 = split;
  this.v19_1 = focus;
  this.w19_1 = deprioritised;
  this.x19_1 = includeDeloads;
  this.y19_1 = deload;
  this.z19_1 = cycles;
  this.a1a_1 = progression;
  this.b1a_1 = excludedExercises;
  this.c1a_1 = name;
  this.d1a_1 = useLibraryRanks;
  this.e1a_1 = skills;
  this.f1a_1 = familiar;
  this.g1a_1 = compoundSets;
  this.h1a_1 = rest;
  this.i1a_1 = powerWork;
}
protoOf(GeneratorSettings).toString = function () {
  return 'GeneratorSettings(goal=' + this.q19_1.toString() + ', daysPerWeek=' + this.r19_1 + ', minutesPerSession=' + this.s19_1 + ', experience=' + this.t19_1.toString() + ', split=' + this.u19_1.toString() + ', focus=' + toString(this.v19_1) + ', deprioritised=' + toString(this.w19_1) + ', includeDeloads=' + this.x19_1 + ', deload=' + this.y19_1.toString() + ', cycles=' + this.z19_1 + ', progression=' + this.a1a_1.toString() + ', excludedExercises=' + toString(this.b1a_1) + ', name=' + this.c1a_1 + ', useLibraryRanks=' + this.d1a_1 + ', skills=' + toString(this.e1a_1) + ', familiar=' + toString(this.f1a_1) + ', compoundSets=' + this.g1a_1.toString() + ', rest=' + this.h1a_1.toString() + ', powerWork=' + this.i1a_1 + ')';
};
protoOf(GeneratorSettings).hashCode = function () {
  var result = this.q19_1.hashCode();
  result = imul(result, 31) + this.r19_1 | 0;
  result = imul(result, 31) + this.s19_1 | 0;
  result = imul(result, 31) + this.t19_1.hashCode() | 0;
  result = imul(result, 31) + this.u19_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.v19_1) | 0;
  result = imul(result, 31) + hashCode(this.w19_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.x19_1) | 0;
  result = imul(result, 31) + this.y19_1.hashCode() | 0;
  result = imul(result, 31) + this.z19_1 | 0;
  result = imul(result, 31) + this.a1a_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.b1a_1) | 0;
  result = imul(result, 31) + (this.c1a_1 == null ? 0 : getStringHashCode(this.c1a_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.d1a_1) | 0;
  result = imul(result, 31) + hashCode(this.e1a_1) | 0;
  result = imul(result, 31) + hashCode(this.f1a_1) | 0;
  result = imul(result, 31) + this.g1a_1.hashCode() | 0;
  result = imul(result, 31) + this.h1a_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.i1a_1) | 0;
  return result;
};
protoOf(GeneratorSettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GeneratorSettings))
    return false;
  if (!this.q19_1.equals(other.q19_1))
    return false;
  if (!(this.r19_1 === other.r19_1))
    return false;
  if (!(this.s19_1 === other.s19_1))
    return false;
  if (!this.t19_1.equals(other.t19_1))
    return false;
  if (!this.u19_1.equals(other.u19_1))
    return false;
  if (!equals(this.v19_1, other.v19_1))
    return false;
  if (!equals(this.w19_1, other.w19_1))
    return false;
  if (!(this.x19_1 === other.x19_1))
    return false;
  if (!this.y19_1.equals(other.y19_1))
    return false;
  if (!(this.z19_1 === other.z19_1))
    return false;
  if (!this.a1a_1.equals(other.a1a_1))
    return false;
  if (!equals(this.b1a_1, other.b1a_1))
    return false;
  if (!(this.c1a_1 == other.c1a_1))
    return false;
  if (!(this.d1a_1 === other.d1a_1))
    return false;
  if (!equals(this.e1a_1, other.e1a_1))
    return false;
  if (!equals(this.f1a_1, other.f1a_1))
    return false;
  if (!this.g1a_1.equals(other.g1a_1))
    return false;
  if (!this.h1a_1.equals(other.h1a_1))
    return false;
  if (!(this.i1a_1 === other.i1a_1))
    return false;
  return true;
};
function GeneratedProgram(program, split, targetSets, peakTargetSets, weeklySets, peakWeeklySets, estimatedMinutes) {
  this.o1f_1 = program;
  this.p1f_1 = split;
  this.q1f_1 = targetSets;
  this.r1f_1 = peakTargetSets;
  this.s1f_1 = weeklySets;
  this.t1f_1 = peakWeeklySets;
  this.u1f_1 = estimatedMinutes;
}
protoOf(GeneratedProgram).toString = function () {
  return 'GeneratedProgram(program=' + this.o1f_1.toString() + ', split=' + this.p1f_1.toString() + ', targetSets=' + toString(this.q1f_1) + ', peakTargetSets=' + toString(this.r1f_1) + ', weeklySets=' + toString(this.s1f_1) + ', peakWeeklySets=' + toString(this.t1f_1) + ', estimatedMinutes=' + toString(this.u1f_1) + ')';
};
protoOf(GeneratedProgram).hashCode = function () {
  var result = this.o1f_1.hashCode();
  result = imul(result, 31) + this.p1f_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.q1f_1) | 0;
  result = imul(result, 31) + hashCode(this.r1f_1) | 0;
  result = imul(result, 31) + hashCode(this.s1f_1) | 0;
  result = imul(result, 31) + hashCode(this.t1f_1) | 0;
  result = imul(result, 31) + hashCode(this.u1f_1) | 0;
  return result;
};
protoOf(GeneratedProgram).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof GeneratedProgram))
    return false;
  if (!this.o1f_1.equals(other.o1f_1))
    return false;
  if (!this.p1f_1.equals(other.p1f_1))
    return false;
  if (!equals(this.q1f_1, other.q1f_1))
    return false;
  if (!equals(this.r1f_1, other.r1f_1))
    return false;
  if (!equals(this.s1f_1, other.s1f_1))
    return false;
  if (!equals(this.t1f_1, other.t1f_1))
    return false;
  if (!equals(this.u1f_1, other.u1f_1))
    return false;
  return true;
};
var static_init_called_45;
function static_init_45() {
  if (static_init_called_45)
    return Unit_instance;
  static_init_called_45 = true;
  Slot_SQUAT_instance = new Slot('SQUAT', 0, setOf_0(Muscle_QUADRICEPS_getInstance()), Force_PUSH_getInstance(), MovementPattern_SQUAT_getInstance(), false);
  Slot_HINGE_instance = new Slot('HINGE', 1, setOf([Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_LOWER_BACK_getInstance()]), Force_PULL_getInstance(), MovementPattern_HINGE_getInstance());
  Slot_HORIZONTAL_PUSH_instance = new Slot('HORIZONTAL_PUSH', 2, setOf_0(Muscle_CHEST_getInstance()), Force_PUSH_getInstance(), MovementPattern_HORIZONTAL_PUSH_getInstance());
  Slot_VERTICAL_PUSH_instance = new Slot('VERTICAL_PUSH', 3, setOf_0(Muscle_SHOULDERS_getInstance()), Force_PUSH_getInstance(), MovementPattern_VERTICAL_PUSH_getInstance());
  Slot_HORIZONTAL_PULL_instance = new Slot('HORIZONTAL_PULL', 4, setOf_0(Muscle_MIDDLE_BACK_getInstance()), Force_PULL_getInstance(), MovementPattern_HORIZONTAL_PULL_getInstance());
  Slot_VERTICAL_PULL_instance = new Slot('VERTICAL_PULL', 5, setOf_0(Muscle_LATS_getInstance()), Force_PULL_getInstance(), MovementPattern_VERTICAL_PULL_getInstance());
  Slot_SINGLE_LEG_instance = new Slot('SINGLE_LEG', 6, setOf([Muscle_QUADRICEPS_getInstance(), Muscle_GLUTES_getInstance()]), Force_PUSH_getInstance(), MovementPattern_SQUAT_getInstance(), true);
}
var Slot_SQUAT_instance;
var Slot_HINGE_instance;
var Slot_HORIZONTAL_PUSH_instance;
var Slot_VERTICAL_PUSH_instance;
var Slot_HORIZONTAL_PULL_instance;
var Slot_VERTICAL_PULL_instance;
var Slot_SINGLE_LEG_instance;
var static_init_called_46;
function static_init_46() {
  if (static_init_called_46)
    return Unit_instance;
  static_init_called_46 = true;
  Template_FULL_BODY_instance = new Template('FULL_BODY', 0, 'Full Body', listOf([Slot_SQUAT_getInstance(), Slot_HORIZONTAL_PUSH_getInstance(), Slot_HORIZONTAL_PULL_getInstance(), Slot_HINGE_getInstance(), Slot_VERTICAL_PUSH_getInstance(), Slot_VERTICAL_PULL_getInstance()]), toSet(get_entries_30()));
  Template_UPPER_instance = new Template('UPPER', 1, 'Upper', listOf([Slot_HORIZONTAL_PUSH_getInstance(), Slot_HORIZONTAL_PULL_getInstance(), Slot_VERTICAL_PUSH_getInstance(), Slot_VERTICAL_PULL_getInstance()]), setOf([Muscle_CHEST_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_TRICEPS_getInstance(), Muscle_BICEPS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_TRAPS_getInstance(), Muscle_NECK_getInstance()]));
  Template_LOWER_instance = new Template('LOWER', 2, 'Lower', listOf([Slot_SQUAT_getInstance(), Slot_HINGE_getInstance()]), setOf([Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_CALVES_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDUCTORS_getInstance(), Muscle_LOWER_BACK_getInstance(), Muscle_ABDOMINALS_getInstance()]), listOf_0(Slot_SINGLE_LEG_getInstance()));
  Template_PUSH_instance = new Template('PUSH', 3, 'Push', listOf([Slot_HORIZONTAL_PUSH_getInstance(), Slot_VERTICAL_PUSH_getInstance()]), setOf([Muscle_CHEST_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_TRICEPS_getInstance()]));
  Template_PULL_instance = new Template('PULL', 4, 'Pull', listOf([Slot_VERTICAL_PULL_getInstance(), Slot_HORIZONTAL_PULL_getInstance()]), setOf([Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_BICEPS_getInstance(), Muscle_TRAPS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_NECK_getInstance()]));
  Template_LEGS_instance = new Template('LEGS', 5, 'Legs', listOf([Slot_SQUAT_getInstance(), Slot_HINGE_getInstance()]), setOf([Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_CALVES_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDUCTORS_getInstance(), Muscle_LOWER_BACK_getInstance(), Muscle_ABDOMINALS_getInstance()]), listOf_0(Slot_SINGLE_LEG_getInstance()));
  Template_HINGE_instance = new Template('HINGE', 6, 'Hinge', listOf_0(Slot_HINGE_getInstance()), setOf([Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_LOWER_BACK_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDOMINALS_getInstance()]));
  Template_SQUAT_instance = new Template('SQUAT', 7, 'Squat', listOf_0(Slot_SQUAT_getInstance()), setOf([Muscle_QUADRICEPS_getInstance(), Muscle_CALVES_getInstance(), Muscle_ABDUCTORS_getInstance()]));
  Template_ACCESSORIES_instance = new Template('ACCESSORIES', 8, 'Accessories', emptyList(), setOf([Muscle_SHOULDERS_getInstance(), Muscle_BICEPS_getInstance(), Muscle_TRICEPS_getInstance(), Muscle_CALVES_getInstance(), Muscle_ABDOMINALS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_TRAPS_getInstance(), Muscle_NECK_getInstance()]));
}
var Template_FULL_BODY_instance;
var Template_UPPER_instance;
var Template_LOWER_instance;
var Template_PUSH_instance;
var Template_PULL_instance;
var Template_LEGS_instance;
var Template_HINGE_instance;
var Template_SQUAT_instance;
var Template_ACCESSORIES_instance;
function Slot(name, ordinal, muscles, force, pattern, unilateral) {
  unilateral = unilateral === VOID ? null : unilateral;
  Enum.call(this, name, ordinal);
  this.x1f_1 = muscles;
  this.y1f_1 = force;
  this.z1f_1 = pattern;
  this.a1g_1 = unilateral;
}
function Template(name, ordinal, label, slots, muscles, after) {
  after = after === VOID ? emptyList() : after;
  Enum.call(this, name, ordinal);
  this.d1g_1 = label;
  this.e1g_1 = slots;
  this.f1g_1 = muscles;
  this.g1g_1 = after;
}
function templates($this, split) {
  var tmp;
  switch (split.x1_1) {
    case 0:
    case 1:
      tmp = listOf_0(Template_FULL_BODY_getInstance());
      break;
    case 2:
      tmp = listOf([Template_UPPER_getInstance(), Template_LOWER_getInstance()]);
      break;
    case 3:
      tmp = listOf([Template_PUSH_getInstance(), Template_PULL_getInstance(), Template_LEGS_getInstance()]);
      break;
    case 4:
      tmp = listOf([Template_PUSH_getInstance(), Template_HINGE_getInstance(), Template_PULL_getInstance(), Template_SQUAT_getInstance()]);
      break;
    case 5:
      tmp = listOf([Template_PUSH_getInstance(), Template_PULL_getInstance(), Template_LEGS_getInstance(), Template_ACCESSORIES_getInstance()]);
      break;
    case 6:
      tmp = listOf([Template_PUSH_getInstance(), Template_HINGE_getInstance(), Template_PULL_getInstance(), Template_SQUAT_getInstance(), Template_ACCESSORIES_getInstance()]);
      break;
    case 7:
      tmp = listOf([Template_PUSH_getInstance(), Template_PULL_getInstance(), Template_LEGS_getInstance(), Template_UPPER_getInstance(), Template_LOWER_getInstance()]);
      break;
    case 8:
      tmp = listOf([Template_PUSH_getInstance(), Template_HINGE_getInstance(), Template_PULL_getInstance(), Template_SQUAT_getInstance(), Template_UPPER_getInstance(), Template_LOWER_getInstance()]);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
}
function Picked(exercise, muscle, sets, mainLift, cap) {
  cap = cap === VOID ? null : cap;
  this.h1g_1 = exercise;
  this.i1g_1 = muscle;
  this.j1g_1 = sets;
  this.k1g_1 = mainLift;
  this.l1g_1 = cap;
}
function getsAutoWarmup($this, $receiver) {
  return !$receiver.equals(Equipment_BODYWEIGHT_getInstance()) && !$receiver.equals(Equipment_BAND_getInstance()) && !$receiver.equals(Equipment_OTHER_getInstance());
}
function nameDays($this, days) {
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$0 = new ProgramGenerator$nameDays$$inlined$groupingBy$1(days);
  var counts = eachCount(tmp$ret$0);
  var seen = HashMap_init_$Create$();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(days, 10));
  var _iterator__ex2g4s = days.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp;
    var tmp0_elvis_lhs = counts.s1(item.m1g_1);
    if ((tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs) <= 1) {
      tmp = item;
    } else {
      var tmp1_elvis_lhs = seen.s1(item.m1g_1);
      var index = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp2 = item.m1g_1;
      // Inline function 'kotlin.collections.set' call
      var value = index + 1 | 0;
      seen.k2(tmp2, value);
      tmp = item.p1g(item.m1g_1 + ' ' + toString_1(Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(65), index)));
    }
    var tmp$ret$3 = tmp;
    destination.f(tmp$ret$3);
  }
  return destination;
}
function roundHalfUp_0($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0);
}
function sam$kotlin_Comparator$0_8(function_0) {
  this.q1g_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_8).y9 = function (a, b) {
  return this.q1g_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_8).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_8).g2 = function () {
  return this.q1g_1;
};
protoOf(sam$kotlin_Comparator$0_8).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_8).hashCode = function () {
  return hashCode(this.g2());
};
function ProgramGenerator$weeklyTargets$$inlined$groupingBy$1($this) {
  this.r1g_1 = $this;
}
protoOf(ProgramGenerator$weeklyTargets$$inlined$groupingBy$1).i2 = function () {
  return this.r1g_1.j();
};
protoOf(ProgramGenerator$weeklyTargets$$inlined$groupingBy$1).r11 = function (element) {
  return element;
};
protoOf(ProgramGenerator$weeklyTargets$$inlined$groupingBy$1).j2 = function (element) {
  return this.r11(element);
};
function ProgramGenerator$generate$preferred$lambda(it) {
  return false;
}
function generate$preferred$ifStaple(exercise, value, otherwise) {
  return !(generate$staple(exercise) == null) ? value : otherwise;
}
function ProgramGenerator$generate$preferred$lambda_0(it) {
  return generate$staple(it) == null;
}
function ProgramGenerator$generate$preferred$lambda_1(it) {
  return it.j1e_1 == null;
}
function ProgramGenerator$generate$preferred$lambda_2($duplicate) {
  return function (it) {
    return $duplicate(it);
  };
}
function ProgramGenerator$generate$preferred$lambda_3(it) {
  var tmp0_elvis_lhs = generate$staple(it);
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function ProgramGenerator$generate$preferred$lambda_4(it) {
  return generate$preferred$ifStaple(it, ProgramGenerator_getInstance().r1h_1.w8(it.f1e_1), false);
}
function ProgramGenerator$generate$preferred$lambda_5(it) {
  return generate$preferred$ifStaple(it, it.u1e_1, false);
}
function ProgramGenerator$generate$preferred$lambda_6($usage) {
  return function (it) {
    var tmp0_elvis_lhs = $usage.s1(it.e1e_1);
    return generate$preferred$ifStaple(it, tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs, 0);
  };
}
function ProgramGenerator$generate$preferred$lambda_7(it) {
  return generate$preferred$ifStaple(it, it.g1e_1.x1_1, 0);
}
function ProgramGenerator$generate$preferred$lambda_8($score) {
  return function (it) {
    return -$score(it);
  };
}
function ProgramGenerator$generate$preferred$lambda_9(it) {
  return generate$preferred$ifStaple(it, it.f1e_1.length, 0);
}
function ProgramGenerator$generate$preferred$lambda_10(it) {
  return it.e1e_1;
}
function ProgramGenerator$generate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.e1e_1;
  var tmp$ret$2 = b.e1e_1;
  return compareValues(tmp, tmp$ret$2);
}
function generate$poolFor(candidates, dayGym) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = candidates.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!dayGym.l1b_1.r(element.e1e_1) && dayGym.s1b(element.g1e_1)) {
      destination.f(element);
    }
  }
  return destination;
}
function generate$allowed($settings, groupOwner, exercise) {
  var tmp;
  if (!$settings.d1a_1) {
    tmp = true;
  } else {
    var tmp0 = exercise.q1e_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.m();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        var tmp0_elvis_lhs = groupOwner.s1(element);
        if (!((tmp0_elvis_lhs == null ? exercise.e1e_1 : tmp0_elvis_lhs) === exercise.e1e_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp = tmp$ret$0;
  }
  return tmp;
}
function generate$rankBonus($settings, exercise, slot) {
  if (!$settings.d1a_1)
    return 0.0;
  var tmp0_safe_receiver = exercise.r1e_1.s1($settings.q19_1);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.s1(slot);
  var tmp;
  if (tmp1_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = 2.0 * (9.0 - tmp1_safe_receiver);
  }
  var tmp2_elvis_lhs = tmp;
  var rank = tmp2_elvis_lhs == null ? 0.0 : tmp2_elvis_lhs;
  var tmp3_safe_receiver = $settings.f1a_1.s1(exercise.e1e_1);
  var tmp_0;
  if (tmp3_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.math.ln' call
    var x = 1.0 + tmp3_safe_receiver;
    // Inline function 'kotlin.math.min' call
    var b = Math.log(x);
    tmp_0 = Math.min(3.0, b);
  }
  var tmp4_elvis_lhs = tmp_0;
  var familiar = tmp4_elvis_lhs == null ? 0.0 : tmp4_elvis_lhs;
  return rank + familiar;
}
function generate$seconds(chosen, $settings, exercise, sets) {
  var tmp;
  var tmp_0;
  if (getsAutoWarmup(ProgramGenerator_getInstance(), exercise.g1e_1)) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.none' call
      var tmp_1;
      if (isInterface(chosen, Collection)) {
        tmp_1 = chosen.m();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s = chosen.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element.h1g_1.g1e_1.equals(exercise.g1e_1)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    tmp_0 = tmp$ret$0;
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = imul(Warmups_getInstance().s1h_1.o(), 75);
  } else {
    tmp = 0;
  }
  var warmup = tmp;
  return imul(sets, 40 + ProgramGenerator_getInstance().y1h($settings, exercise) | 0) + 60 + warmup;
}
function generate$contribute(need, exercise, sets) {
  var _iterator__ex2g4s = exercise.h1e_1.j();
  while (_iterator__ex2g4s.k()) {
    var m = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = need.s1(m);
    // Inline function 'kotlin.collections.set' call
    var value = (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) - sets;
    need.k2(m, value);
  }
  var _iterator__ex2g4s_0 = exercise.i1e_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var m_0 = _iterator__ex2g4s_0.l();
    var tmp1_elvis_lhs = need.s1(m_0);
    // Inline function 'kotlin.collections.set' call
    var value_0 = (tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) - 0.5 * sets;
    need.k2(m_0, value_0);
  }
}
function generate$addExercise(used, budget, chosen, groupOwner, $settings, need, exercise, servedMuscle, mainLift, wanted) {
  wanted = wanted === VOID ? null : wanted;
  var most = wanted == null ? 2 : wanted;
  // Inline function 'kotlin.math.min' call
  var tmp$ret$0 = Math.min(most, 2);
  var tmp0 = downTo(most, tmp$ret$0);
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = tmp0.oc_1;
    var last = tmp0.pc_1;
    var step = tmp0.qc_1;
    if (step > 0 && inductionVariable <= last || (step < 0 && last <= inductionVariable))
      do {
        var element = inductionVariable;
        inductionVariable = inductionVariable + step | 0;
        var it = element;
        if (used._v + generate$seconds(chosen, $settings, exercise, it) <= budget) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
       while (!(element === last));
    tmp$ret$1 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$1;
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var sets = tmp;
  used._v = used._v + generate$seconds(chosen, $settings, exercise, sets);
  chosen.f(new Picked(exercise, servedMuscle, sets, mainLift, wanted));
  generate$contribute(need, exercise, sets);
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = exercise.q1e_1.j();
  while (_iterator__ex2g4s.k()) {
    var element_0 = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.getOrPut' call
    var value = groupOwner.s1(element_0);
    var tmp_0;
    if (value == null) {
      var answer = exercise.e1e_1;
      groupOwner.k2(element_0, answer);
      tmp_0 = answer;
    } else {
      tmp_0 = value;
    }
  }
  return true;
}
function generate$maxSets($settings, picked) {
  return !(picked.l1g_1 == null) ? picked.l1g_1 : !$settings.g1a_1.equals(CompoundSetRule_GREEDY_getInstance()) && !picked.k1g_1 ? 4 : !picked.k1g_1 ? 3 : $settings.q19_1.equals(TrainingGoal_STRENGTH_getInstance()) ? 5 : 4;
}
function generate$coverage(need, exercise) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = exercise.h1e_1.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = sum;
    var tmp0_elvis_lhs = need.s1(element);
    // Inline function 'kotlin.math.max' call
    var b = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    sum = tmp + Math.max(0.0, b);
  }
  var tmp_0 = sum;
  // Inline function 'kotlin.collections.sumOf' call
  var sum_0 = 0;
  var _iterator__ex2g4s_0 = exercise.i1e_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp_1 = sum_0;
    var tmp0_elvis_lhs_0 = need.s1(element_0);
    // Inline function 'kotlin.math.max' call
    var b_0 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
    sum_0 = tmp_1 + Math.max(0.0, b_0);
  }
  return tmp_0 + 0.5 * sum_0;
}
function generate$variety(usage, exercise) {
  var tmp0_elvis_lhs = usage.s1(exercise.e1e_1);
  return 3.0 * (tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs);
}
function generate$staple(exercise) {
  var tmp0_safe_receiver = exercise.p1e_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = ProgramGenerator_getInstance().q1h_1.s1(tmp0_safe_receiver);
  }
  return tmp;
}
function generate$preferred(usage, duplicate, score) {
  var tmp;
  if (duplicate === VOID) {
    tmp = ProgramGenerator$generate$preferred$lambda;
  } else {
    tmp = duplicate;
  }
  duplicate = tmp;
  var tmp_0 = ProgramGenerator$generate$preferred$lambda_0;
  var tmp_1 = ProgramGenerator$generate$preferred$lambda_1;
  var tmp_2 = ProgramGenerator$generate$preferred$lambda_2(duplicate);
  var tmp_3 = ProgramGenerator$generate$preferred$lambda_3;
  var tmp_4 = ProgramGenerator$generate$preferred$lambda_4;
  var tmp_5 = ProgramGenerator$generate$preferred$lambda_5;
  var tmp_6 = ProgramGenerator$generate$preferred$lambda_6(usage);
  var tmp_7 = ProgramGenerator$generate$preferred$lambda_7;
  var tmp_8 = ProgramGenerator$generate$preferred$lambda_8(score);
  var tmp_9 = ProgramGenerator$generate$preferred$lambda_9;
  return compareBy([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, ProgramGenerator$generate$preferred$lambda_10]);
}
function ProgramGenerator$generate$lambda_0($template) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp0 = b.h1e_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.m();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$2 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if ($template.f1g_1.r(element)) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$2 = count;
    }
    var tmp_0 = tmp$ret$2;
    var tmp0_0 = a.h1e_1;
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.count' call
      var tmp_1;
      if (isInterface(tmp0_0, Collection)) {
        tmp_1 = tmp0_0.m();
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp$ret$5 = 0;
        break $l$block_0;
      }
      var count_0 = 0;
      var _iterator__ex2g4s_0 = tmp0_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if ($template.f1g_1.r(element_0)) {
          count_0 = count_0 + 1 | 0;
          checkCountOverflow(count_0);
        }
      }
      tmp$ret$5 = count_0;
    }
    var tmp$ret$4 = tmp$ret$5;
    return compareValues(tmp_0, tmp$ret$4);
  };
}
function ProgramGenerator$generate$lambda_1($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.e1e_1;
      var tmp$ret$2 = b.e1e_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function ProgramGenerator$generate$lambda_2($rankSlot, $settings, $need, $usage) {
  return function (it) {
    return generate$coverage($need, it) - generate$variety($usage, it) + generate$rankBonus($settings, it, $rankSlot) + ($settings.q19_1.equals(TrainingGoal_STRENGTH_getInstance()) && it.g1e_1.equals(Equipment_BARBELL_getInstance()) ? 1.0 : 0.0);
  };
}
function ProgramGenerator$generate$lambda_3($need) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp0_elvis_lhs = $need.s1(a);
    var tmp = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp0_elvis_lhs_0 = $need.s1(b);
    var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
    return compareValues(tmp, tmp$ret$2);
  };
}
function ProgramGenerator$generate$lambda_4($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = b.x1_1;
      var tmp$ret$2 = a.x1_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function ProgramGenerator$generate$lambda_5(it) {
  return !it.equals(Muscle_ABDOMINALS_getInstance());
}
function ProgramGenerator$generate$lambda_6($need) {
  return function (it) {
    var tmp0_elvis_lhs = $need.s1(it);
    return tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  };
}
function ProgramGenerator$generate$lambda_7($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = b.x1_1;
      var tmp$ret$2 = a.x1_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function ProgramGenerator$generate$lambda_8($settings) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = $settings.q19_1.equals(TrainingGoal_STRENGTH_getInstance()) && a.xa_1.k1g_1 ? 0 : 1;
    var tmp$ret$2 = $settings.q19_1.equals(TrainingGoal_STRENGTH_getInstance()) && b.xa_1.k1g_1 ? 0 : 1;
    return compareValues(tmp, tmp$ret$2);
  };
}
function ProgramGenerator$generate$lambda_9($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.xa_1.j1g_1;
      var tmp$ret$2 = b.xa_1.j1g_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function ProgramGenerator$generate$lambda_10($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.wa_1;
      var tmp$ret$2 = b.wa_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function generate$duplicate(patterns, families, exercise) {
  return !(exercise.t1e_1 == null) && patterns.r(exercise.t1e_1) || (!(exercise.p1e_1 == null) && families.r(exercise.p1e_1));
}
function ProgramGenerator$generate$duplicate$ref($patterns, $families) {
  return constructCallableReference(function (p0) {
    return generate$duplicate($patterns, $families, p0);
  }, 1, 0, 0, 'duplicate', [$patterns, $families]);
}
function ProgramGenerator$generate$lambda_11($need, $usage, $settings) {
  return function (it) {
    return (ProgramGenerator_getInstance().z1h(it) ? 0.0 : 3.0) + generate$coverage($need, it) - generate$variety($usage, it) + generate$rankBonus($settings, it, ExerciseSlot_ACCESSORY_getInstance());
  };
}
function ProgramGenerator$nameDays$$inlined$groupingBy$1($this) {
  this.a1i_1 = $this;
}
protoOf(ProgramGenerator$nameDays$$inlined$groupingBy$1).i2 = function () {
  return this.a1i_1.j();
};
protoOf(ProgramGenerator$nameDays$$inlined$groupingBy$1).r11 = function (element) {
  return element.m1g_1;
};
protoOf(ProgramGenerator$nameDays$$inlined$groupingBy$1).j2 = function (element) {
  return this.r11(element);
};
function Slot_SQUAT_getInstance() {
  static_init_45();
  return Slot_SQUAT_instance;
}
function Slot_HINGE_getInstance() {
  static_init_45();
  return Slot_HINGE_instance;
}
function Slot_HORIZONTAL_PUSH_getInstance() {
  static_init_45();
  return Slot_HORIZONTAL_PUSH_instance;
}
function Slot_VERTICAL_PUSH_getInstance() {
  static_init_45();
  return Slot_VERTICAL_PUSH_instance;
}
function Slot_HORIZONTAL_PULL_getInstance() {
  static_init_45();
  return Slot_HORIZONTAL_PULL_instance;
}
function Slot_VERTICAL_PULL_getInstance() {
  static_init_45();
  return Slot_VERTICAL_PULL_instance;
}
function Slot_SINGLE_LEG_getInstance() {
  static_init_45();
  return Slot_SINGLE_LEG_instance;
}
function Template_FULL_BODY_getInstance() {
  static_init_46();
  return Template_FULL_BODY_instance;
}
function Template_UPPER_getInstance() {
  static_init_46();
  return Template_UPPER_instance;
}
function Template_LOWER_getInstance() {
  static_init_46();
  return Template_LOWER_instance;
}
function Template_PUSH_getInstance() {
  static_init_46();
  return Template_PUSH_instance;
}
function Template_PULL_getInstance() {
  static_init_46();
  return Template_PULL_instance;
}
function Template_LEGS_getInstance() {
  static_init_46();
  return Template_LEGS_instance;
}
function Template_HINGE_getInstance() {
  static_init_46();
  return Template_HINGE_instance;
}
function Template_SQUAT_getInstance() {
  static_init_46();
  return Template_SQUAT_instance;
}
function Template_ACCESSORIES_getInstance() {
  static_init_46();
  return Template_ACCESSORIES_instance;
}
function ProgramGenerator() {
  ProgramGenerator_instance = this;
  this.s1g_1 = 40;
  this.t1g_1 = 60;
  this.u1g_1 = 75;
  this.v1g_1 = 2;
  this.w1g_1 = 3;
  this.x1g_1 = 4;
  this.y1g_1 = 5;
  this.z1g_1 = 2.0;
  this.a1h_1 = 0.3333333333333333;
  this.b1h_1 = 0.6666666666666666;
  this.c1h_1 = 9;
  this.d1h_1 = 1.5;
  this.e1h_1 = 0.75;
  this.f1h_1 = 3.0;
  this.g1h_1 = 5;
  this.h1h_1 = 5;
  this.i1h_1 = 5;
  this.j1h_1 = 4;
  this.k1h_1 = 65;
  this.l1h_1 = 2.0;
  this.m1h_1 = 3.0;
  this.n1h_1 = setOf([Muscle_CHEST_getInstance(), Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_BICEPS_getInstance(), Muscle_TRICEPS_getInstance()]);
  this.o1h_1 = setOf([Muscle_CALVES_getInstance(), Muscle_ABDOMINALS_getInstance()]);
  this.p1h_1 = listOf(['bench press', 'incline bench press', 'chest press', 'leverage chest press', 'pushup', 'push up', 'dip tricep', 'parallel dip', 'standing military press', 'shoulder press', 'seated military press', 'leverage shoulder press', 'military press', 'bent over row', 'seated row', 'row', 't row handle', 'lying t row', 'leverage iso row', 'inverted row', 'lat pulldown', 'pullup', 'chin up', 'pulldown', 'front lat pulldown', 'v pulldown', 'squat', 'leg press', 'hack squat', 'goblet squat', 'bodyweight squat', 'lunge', 'walking lunge', 'split squat dumbbell', 'step ups', 'bodyweight walking lunge', 'romanian deadlift', 'deadlift', 'stiff legged deadlift', 'hip thrust', 'lying leg curl', 'seated leg curl', 'leg extension', 'standing calf raise', 'seated calf raise', 'calf raise', 'flye', 'crossover', 'side lateral raise', 'rear delt fly', 'face pull', 'curl', 'bicep curl', 'hammer curl', 'preacher curl', 'incline curl', 'tricep pushdown', 'skullcrusher', 'lying tricep extension', 'tricep extension', 'crunch', 'plank', 'hanging leg raise']);
  var tmp = this;
  // Inline function 'kotlin.collections.associate' call
  var this_0 = withIndex(this.p1h_1);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var index = element.ya();
    var family = element.za();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(family, index);
    destination.k2(pair.hb_1, pair.ib_1);
  }
  tmp.q1h_1 = destination;
  this.r1h_1 = Regex_init_$Create$_0('\\b(wide|close|narrow|reverse|single|one[- ](arm|leg)|alternat\\w*|neutral|underhand|behind|deficit|pause\\w*|chains?|bands?|banded|speed|partials?|powerlifting)\\b', RegexOption_IGNORE_CASE_getInstance());
}
protoOf(ProgramGenerator).b1i = function (ageYears) {
  return !(ageYears == null) && ageYears >= 65;
};
protoOf(ProgramGenerator).c1i = function (daysPerWeek) {
  return daysPerWeek <= 3 ? Split_FULL_BODY_getInstance() : daysPerWeek === 4 ? Split_UPPER_LOWER_getInstance() : daysPerWeek === 5 ? Split_PPL_UPPER_LOWER_getInstance() : Split_PPL_getInstance();
};
protoOf(ProgramGenerator).d1i = function (goal, compound) {
  var tmp;
  switch (goal.x1_1) {
    case 0:
      tmp = compound ? 180 : 120;
      break;
    case 1:
      tmp = compound ? 150 : 90;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(ProgramGenerator).y1h = function (settings, exercise) {
  var compound = this.z1h(exercise);
  var tmp;
  switch (settings.h1a_1.x1_1) {
    case 0:
      tmp = this.d1i(settings.q19_1, compound);
      break;
    case 1:
      tmp = Companion_getInstance_11().g1i(exercise).equals(Region_CORE_getInstance()) ? 180 : !compound ? 90 : settings.q19_1.equals(TrainingGoal_HYPERTROPHY_getInstance()) ? 150 : 180;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(ProgramGenerator).h1i = function (goal, compound, mainLift) {
  var tmp;
  switch (goal.x1_1) {
    case 0:
      tmp = mainLift ? to(3, 6) : compound ? to(5, 8) : to(8, 12);
      break;
    case 1:
      tmp = compound ? to(6, 10) : to(10, 15);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(ProgramGenerator).i1i = function (settings) {
  var tmp;
  switch (settings.t19_1.x1_1) {
    case 0:
      tmp = to(8.0, 12.0);
      break;
    case 1:
      tmp = to(12.0, 16.0);
      break;
    case 2:
      tmp = to(16.0, 20.0);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  var _destruct__k2r9zo = tmp;
  var startBase = _destruct__k2r9zo.ya();
  var peakBase = _destruct__k2r9zo.za();
  // Inline function 'kotlin.collections.groupingBy' call
  var this_0 = settings.v19_1;
  var tmp$ret$0 = new ProgramGenerator$weeklyTargets$$inlined$groupingBy$1(this_0);
  var points = eachCount(tmp$ret$0);
  var start = LinkedHashMap_init_$Create$_1();
  var peak = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = get_entries_30().j();
  while (_iterator__ex2g4s.k()) {
    var muscle = _iterator__ex2g4s.l();
    var tmp1_elvis_lhs = points.s1(muscle);
    var focusPoints = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
    var share = this.n1h_1.r(muscle) ? 1.0 : this.o1h_1.r(muscle) || focusPoints > 0 ? 0.6666666666666666 : 0.0;
    var s = startBase * share;
    var p = peakBase * share;
    if (focusPoints > 0) {
      s = s + 2.0 * focusPoints;
      p = p + 2.0 * focusPoints;
    } else if (settings.w19_1.r(muscle)) {
      s = s * 0.3333333333333333;
      p = s;
    }
    // Inline function 'kotlin.collections.set' call
    var value = s;
    start.k2(muscle, value);
    // Inline function 'kotlin.collections.set' call
    var value_0 = p;
    peak.k2(muscle, value_0);
  }
  return to(start, peak);
};
protoOf(ProgramGenerator).j1i = function (settings, gym, catalogue, dayGyms) {
  var containsArg = settings.r19_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg ? containsArg <= 7 : false)) {
    var message = 'daysPerWeek must be 1\u20137';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var containsArg_0 = settings.s19_1;
  // Inline function 'kotlin.require' call
  if (!(10 <= containsArg_0 ? containsArg_0 <= 300 : false)) {
    var message_0 = 'minutesPerSession must be 10\u2013300';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(settings.v19_1.o() <= 5)) {
    var message_1 = 'at most 5 focus points';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  // Inline function 'kotlin.require' call
  if (!(distinct(settings.w19_1).o() <= 5)) {
    var message_2 = 'at most 5 deprioritised muscles';
    throw IllegalArgumentException_init_$Create$(toString(message_2));
  }
  // Inline function 'kotlin.require' call
  if (!(settings.z19_1 >= 1)) {
    var message_3 = 'cycles must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message_3));
  }
  var split = settings.u19_1.equals(Split_AUTO_getInstance()) ? this.c1i(settings.r19_1) : settings.u19_1;
  var templates_0 = templates(this, split);
  // Inline function 'kotlin.collections.List' call
  // Inline function 'kotlin.collections.MutableList' call
  var size = settings.r19_1;
  var list = ArrayList_init_$Create$(size);
  // Inline function 'kotlin.repeat' call
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var index = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp$ret$14 = templates_0.n(index % templates_0.o() | 0);
      list.f(tmp$ret$14);
    }
     while (inductionVariable < size);
  var dayTemplates = list;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = catalogue.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp;
    if (equals_0(element.l1e_1, 'strength', true) && !element.n1e_1 && !settings.b1a_1.r(element.e1e_1)) {
      // Inline function 'kotlin.collections.isNotEmpty' call
      tmp = !element.h1e_1.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (!settings.d1a_1 || settings.e1a_1.n1(element_0.s1e_1)) {
      destination_0.f(element_0);
    }
  }
  // Inline function 'kotlin.collections.distinctBy' call
  var set = HashSet_init_$Create$();
  var list_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = destination_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var e = _iterator__ex2g4s_1.l();
    var key = e.e1e_1;
    if (set.f(key)) {
      list_0.f(e);
    }
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = ProgramGenerator$generate$lambda;
  var tmp$ret$25 = new sam$kotlin_Comparator$0_8(tmp_0);
  var candidates = sortedWith(list_0, tmp$ret$25);
  var defaultPool = generate$poolFor(candidates, gym);
  var groupOwner = HashMap_init_$Create$();
  var _destruct__k2r9zo = this.i1i(settings);
  var startTargets = _destruct__k2r9zo.ya();
  var peakTargets = _destruct__k2r9zo.za();
  // Inline function 'kotlin.collections.associateWith' call
  var this_0 = get_entries_30();
  var result = LinkedHashMap_init_$Create$(coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16));
  // Inline function 'kotlin.collections.associateWithTo' call
  var _iterator__ex2g4s_2 = this_0.j();
  while (_iterator__ex2g4s_2.k()) {
    var element_1 = _iterator__ex2g4s_2.l();
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = get_indices(dayTemplates);
    // Inline function 'kotlin.collections.filterTo' call
    var destination_1 = ArrayList_init_$Create$_0();
    var inductionVariable_0 = tmp0.oc_1;
    var last = tmp0.pc_1;
    if (inductionVariable_0 <= last)
      do {
        var element_2 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var it = element_2;
        if (dayTemplates.n(it).f1g_1.r(element_1) || (settings.v19_1.r(element_1) && dayTemplates.n(it).equals(Template_ACCESSORIES_getInstance()))) {
          destination_1.f(element_2);
        }
      }
       while (!(element_2 === last));
    // Inline function 'kotlin.collections.ifEmpty' call
    var tmp_1;
    if (destination_1.m()) {
      var tmp_2;
      var tmp0_elvis_lhs = peakTargets.s1(element_1);
      if ((tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) > 0.0) {
        tmp_2 = toList(get_indices(dayTemplates));
      } else {
        tmp_2 = emptyList();
      }
      tmp_1 = tmp_2;
    } else {
      tmp_1 = destination_1;
    }
    var tmp$ret$28 = tmp_1;
    result.k2(element_1, tmp$ret$28);
  }
  var daysFor = result;
  var budget = settings.s19_1 * 60.0;
  var usage = HashMap_init_$Create$();
  var days = ArrayList_init_$Create$_0();
  var occurrences = HashMap_init_$Create$();
  var tmp_3;
  if (settings.x19_1 && settings.z19_1 >= 2) {
    tmp_3 = settings.y19_1.equals(DeloadPosition_NONE_getInstance()) ? DeloadPosition_LAST_getInstance() : settings.y19_1;
  } else {
    tmp_3 = DeloadPosition_NONE_getInstance();
  }
  var deload = tmp_3;
  var iterator = dayTemplates.j();
  var index_0 = 0;
  while (iterator.k()) {
    var dayIndex = index_0;
    index_0 = index_0 + 1 | 0;
    var template = iterator.l();
    var tmp0_0 = take(dayTemplates, dayIndex);
    var tmp$ret$34;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp_4;
      if (isInterface(tmp0_0, Collection)) {
        tmp_4 = tmp0_0.m();
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp$ret$34 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s_3 = tmp0_0.j();
      while (_iterator__ex2g4s_3.k()) {
        var element_3 = _iterator__ex2g4s_3.l();
        if (element_3.equals(template)) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$34 = count;
    }
    var repeat = tmp$ret$34;
    // Inline function 'kotlin.math.max' call
    var b = template.e1g_1.o() / 2 | 0;
    var step = Math.max(1, b);
    var tmp_5;
    if (template.e1g_1.m()) {
      tmp_5 = emptyList();
    } else {
      var rotation = imul(repeat, step) % template.e1g_1.o() | 0;
      tmp_5 = plus(drop(template.e1g_1, rotation), take(template.e1g_1, rotation));
    }
    var slots = plus(tmp_5, template.g1g_1);
    var need = LinkedHashMap_init_$Create$_1();
    var _iterator__ex2g4s_4 = get_entries_30().j();
    while (_iterator__ex2g4s_4.k()) {
      var muscle = _iterator__ex2g4s_4.l();
      var trainingDays = getValue(daysFor, muscle);
      var tmp_6;
      if (trainingDays.r(dayIndex)) {
        var tmp0_elvis_lhs_0 = peakTargets.s1(muscle);
        tmp_6 = (tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0) / trainingDays.o();
      } else {
        tmp_6 = 0.0;
      }
      // Inline function 'kotlin.collections.set' call
      var value = tmp_6;
      need.k2(muscle, value);
    }
    var chosen = ArrayList_init_$Create$_0();
    var used = {_v: 0.0};
    var tmp1_safe_receiver = getOrNull_0(dayGyms, dayIndex);
    var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.ib_1;
    var tmp_7;
    if (tmp2_safe_receiver == null) {
      tmp_7 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_7 = generate$poolFor(candidates, tmp2_safe_receiver);
    }
    var tmp3_elvis_lhs = tmp_7;
    var pool = tmp3_elvis_lhs == null ? defaultPool : tmp3_elvis_lhs;
    if (settings.i1a_1) {
      var tmp4_safe_receiver = getOrNull_0(dayGyms, dayIndex);
      var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.ib_1;
      var dayGym = tmp5_elvis_lhs == null ? gym : tmp5_elvis_lhs;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_5 = catalogue.j();
      while (_iterator__ex2g4s_5.k()) {
        var element_4 = _iterator__ex2g4s_5.l();
        if (equals_0(element_4.l1e_1, 'plyometrics', true) && !element_4.n1e_1 && !settings.b1a_1.r(element_4.e1e_1) && !dayGym.l1b_1.r(element_4.e1e_1) && dayGym.s1b(element_4.g1e_1)) {
          destination_2.f(element_4);
        }
      }
      var powerPool = destination_2;
      // Inline function 'kotlin.comparisons.compareByDescending' call
      var tmp_8 = ProgramGenerator$generate$lambda_0(template);
      // Inline function 'kotlin.comparisons.thenBy' call
      var this_1 = new sam$kotlin_Comparator$0_8(tmp_8);
      var tmp_9 = ProgramGenerator$generate$lambda_1(this_1);
      var tmp$ret$44 = new sam$kotlin_Comparator$0_8(tmp_9);
      var tmp6_safe_receiver = firstOrNull(sortedWith(powerPool, tmp$ret$44));
      if (tmp6_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp0_safe_receiver = firstOrNull(tmp6_safe_receiver.h1e_1);
        var tmp_10;
        if (tmp0_safe_receiver == null) {
          tmp_10 = null;
        } else {
          // Inline function 'kotlin.let' call
          tmp_10 = generate$addExercise(used, budget, chosen, groupOwner, settings, need, tmp6_safe_receiver, tmp0_safe_receiver, false, 2);
        }
      }
    }
    var _iterator__ex2g4s_6 = slots.j();
    $l$loop_1: while (_iterator__ex2g4s_6.k()) {
      var slot = _iterator__ex2g4s_6.l();
      if (chosen.o() >= 9)
        break $l$loop_1;
      // Inline function 'kotlin.collections.maxOf' call
      var iterator_0 = slot.x1f_1.j();
      if (!iterator_0.k())
        throw NoSuchElementException_init_$Create$_0();
      var it_0 = iterator_0.l();
      var tmp0_elvis_lhs_1 = need.s1(it_0);
      var maxValue = tmp0_elvis_lhs_1 == null ? 0.0 : tmp0_elvis_lhs_1;
      while (iterator_0.k()) {
        var it_1 = iterator_0.l();
        var tmp0_elvis_lhs_2 = need.s1(it_1);
        var v = tmp0_elvis_lhs_2 == null ? 0.0 : tmp0_elvis_lhs_2;
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      if (maxValue < 1.5)
        continue $l$loop_1;
      var rankSlot = chosen.m() ? ExerciseSlot_PRIMARY_getInstance() : ExerciseSlot_SECONDARY_getInstance();
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_3 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_7 = pool.j();
      while (_iterator__ex2g4s_7.k()) {
        var element_5 = _iterator__ex2g4s_7.l();
        var tmp_11;
        var tmp_12;
        var tmp_13;
        if (ProgramGenerator_getInstance().z1h(element_5)) {
          var tmp0_1 = element_5.h1e_1;
          var tmp$ret$56;
          $l$block_1: {
            // Inline function 'kotlin.collections.any' call
            var tmp_14;
            if (isInterface(tmp0_1, Collection)) {
              tmp_14 = tmp0_1.m();
            } else {
              tmp_14 = false;
            }
            if (tmp_14) {
              tmp$ret$56 = false;
              break $l$block_1;
            }
            var _iterator__ex2g4s_8 = tmp0_1.j();
            while (_iterator__ex2g4s_8.k()) {
              var element_6 = _iterator__ex2g4s_8.l();
              if (slot.x1f_1.r(element_6)) {
                tmp$ret$56 = true;
                break $l$block_1;
              }
            }
            tmp$ret$56 = false;
          }
          tmp_13 = tmp$ret$56;
        } else {
          tmp_13 = false;
        }
        if (tmp_13) {
          var tmp$ret$58;
          $l$block_3: {
            // Inline function 'kotlin.collections.none' call
            var tmp_15;
            if (isInterface(chosen, Collection)) {
              tmp_15 = chosen.m();
            } else {
              tmp_15 = false;
            }
            if (tmp_15) {
              tmp$ret$58 = true;
              break $l$block_3;
            }
            var _iterator__ex2g4s_9 = chosen.j();
            while (_iterator__ex2g4s_9.k()) {
              var element_7 = _iterator__ex2g4s_9.l();
              if (element_7.h1g_1.e1e_1 === element_5.e1e_1) {
                tmp$ret$58 = false;
                break $l$block_3;
              }
            }
            tmp$ret$58 = true;
          }
          tmp_12 = tmp$ret$58;
        } else {
          tmp_12 = false;
        }
        if (tmp_12) {
          tmp_11 = generate$allowed(settings, groupOwner, element_5);
        } else {
          tmp_11 = false;
        }
        if (tmp_11) {
          destination_3.f(element_5);
        }
      }
      var fits = destination_3;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_4 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_10 = fits.j();
      while (_iterator__ex2g4s_10.k()) {
        var element_8 = _iterator__ex2g4s_10.l();
        if (equals(element_8.t1e_1, slot.z1f_1) && (slot.a1g_1 == null || element_8.u1e_1 === slot.a1g_1)) {
          destination_4.f(element_8);
        }
      }
      // Inline function 'kotlin.collections.ifEmpty' call
      var tmp_16;
      if (destination_4.m()) {
        var tmp_17;
        if (slot.equals(Slot_SINGLE_LEG_getInstance())) {
          tmp_17 = emptyList();
        } else {
          // Inline function 'kotlin.collections.filter' call
          // Inline function 'kotlin.collections.filterTo' call
          var destination_5 = ArrayList_init_$Create$_0();
          var _iterator__ex2g4s_11 = fits.j();
          while (_iterator__ex2g4s_11.k()) {
            var element_9 = _iterator__ex2g4s_11.l();
            if (element_9.k1e_1 == null || equals(element_9.k1e_1, slot.y1f_1)) {
              destination_5.f(element_9);
            }
          }
          tmp_17 = destination_5;
        }
        tmp_16 = tmp_17;
      } else {
        tmp_16 = destination_4;
      }
      var candidates_0 = tmp_16;
      var tmp7_elvis_lhs = minWithOrNull(candidates_0, generate$preferred(usage, VOID, ProgramGenerator$generate$lambda_2(rankSlot, settings, need, usage)));
      var tmp_18;
      if (tmp7_elvis_lhs == null) {
        continue $l$loop_1;
      } else {
        tmp_18 = tmp7_elvis_lhs;
      }
      var best = tmp_18;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_2 = slot.x1f_1;
      // Inline function 'kotlin.collections.filterTo' call
      var destination_6 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_12 = tmp0_2.j();
      while (_iterator__ex2g4s_12.k()) {
        var element_10 = _iterator__ex2g4s_12.l();
        if (best.h1e_1.r(element_10) || best.i1e_1.r(element_10)) {
          destination_6.f(element_10);
        }
      }
      var tmp_19 = destination_6;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_20 = ProgramGenerator$generate$lambda_3(need);
      // Inline function 'kotlin.comparisons.thenByDescending' call
      var this_2 = new sam$kotlin_Comparator$0_8(tmp_20);
      var tmp_21 = ProgramGenerator$generate$lambda_4(this_2);
      var tmp$ret$72 = new sam$kotlin_Comparator$0_8(tmp_21);
      var tmp8_elvis_lhs = maxWithOrNull(tmp_19, tmp$ret$72);
      var served = tmp8_elvis_lhs == null ? first(best.h1e_1) : tmp8_elvis_lhs;
      var tmp$ret$73;
      $l$block_5: {
        // Inline function 'kotlin.collections.none' call
        var tmp_22;
        if (isInterface(chosen, Collection)) {
          tmp_22 = chosen.m();
        } else {
          tmp_22 = false;
        }
        if (tmp_22) {
          tmp$ret$73 = true;
          break $l$block_5;
        }
        var _iterator__ex2g4s_13 = chosen.j();
        while (_iterator__ex2g4s_13.k()) {
          var element_11 = _iterator__ex2g4s_13.l();
          if (element_11.k1g_1) {
            tmp$ret$73 = false;
            break $l$block_5;
          }
        }
        tmp$ret$73 = true;
      }
      var tmp_23 = tmp$ret$73;
      var tmp9_elvis_lhs = need.s1(served);
      generate$addExercise(used, budget, chosen, groupOwner, settings, need, best, served, tmp_23, settings.g1a_1.n1f(tmp9_elvis_lhs == null ? 0.0 : tmp9_elvis_lhs));
    }
    var exhausted = HashSet_init_$Create$();
    var deferred = HashSet_init_$Create$();
    $l$loop_4: while (true) {
      // Inline function 'kotlin.collections.filter' call
      var tmp0_3 = get_entries_30();
      // Inline function 'kotlin.collections.filterTo' call
      var destination_7 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_14 = tmp0_3.j();
      while (_iterator__ex2g4s_14.k()) {
        var element_12 = _iterator__ex2g4s_14.l();
        var tmp_24;
        if (!exhausted.r(element_12)) {
          var tmp0_elvis_lhs_3 = need.s1(element_12);
          tmp_24 = (tmp0_elvis_lhs_3 == null ? 0.0 : tmp0_elvis_lhs_3) >= 0.75;
        } else {
          tmp_24 = false;
        }
        if (tmp_24) {
          destination_7.f(element_12);
        }
      }
      var open = destination_7;
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var destination_8 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_15 = open.j();
      while (_iterator__ex2g4s_15.k()) {
        var element_13 = _iterator__ex2g4s_15.l();
        if (!deferred.r(element_13)) {
          destination_8.f(element_13);
        }
      }
      // Inline function 'kotlin.collections.ifEmpty' call
      var tmp_25;
      if (destination_8.m()) {
        tmp_25 = open;
      } else {
        tmp_25 = destination_8;
      }
      var tmp_26 = tmp_25;
      var tmp_27 = ProgramGenerator$generate$lambda_5;
      // Inline function 'kotlin.comparisons.thenByDescending' call
      var this_3 = compareBy([tmp_27, ProgramGenerator$generate$lambda_6(need)]);
      var tmp_28 = ProgramGenerator$generate$lambda_7(this_3);
      var tmp$ret$83 = new sam$kotlin_Comparator$0_8(tmp_28);
      var tmp10_elvis_lhs = maxWithOrNull(tmp_26, tmp$ret$83);
      var tmp_29;
      if (tmp10_elvis_lhs == null) {
        break $l$loop_4;
      } else {
        tmp_29 = tmp10_elvis_lhs;
      }
      var muscle_0 = tmp_29;
      // Inline function 'kotlin.collections.filter' call
      var tmp0_4 = withIndex(chosen);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_9 = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s_16 = tmp0_4.j();
      while (_iterator__ex2g4s_16.k()) {
        var element_14 = _iterator__ex2g4s_16.l();
        var picked = element_14.za();
        if (picked.h1g_1.h1e_1.r(muscle_0) && picked.j1g_1 < generate$maxSets(settings, picked)) {
          destination_9.f(element_14);
        }
      }
      var tmp_30 = destination_9;
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_31 = ProgramGenerator$generate$lambda_8(settings);
      // Inline function 'kotlin.comparisons.thenBy' call
      var this_4 = new sam$kotlin_Comparator$0_8(tmp_31);
      var tmp_32 = ProgramGenerator$generate$lambda_9(this_4);
      // Inline function 'kotlin.comparisons.thenBy' call
      var this_5 = new sam$kotlin_Comparator$0_8(tmp_32);
      var tmp_33 = ProgramGenerator$generate$lambda_10(this_5);
      var tmp$ret$89 = new sam$kotlin_Comparator$0_8(tmp_33);
      var tmp11_safe_receiver = minWithOrNull(tmp_30, tmp$ret$89);
      var existing = tmp11_safe_receiver == null ? null : tmp11_safe_receiver.xa_1;
      if (!(existing == null)) {
        var cost = 40 + this.y1h(settings, existing.h1g_1) | 0;
        if (used._v + cost <= budget) {
          used._v = used._v + cost;
          existing.j1g_1 = existing.j1g_1 + 1 | 0;
          generate$contribute(need, existing.h1g_1, 1);
          continue $l$loop_4;
        }
      }
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_10 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_17 = chosen.j();
      while (_iterator__ex2g4s_17.k()) {
        var element_15 = _iterator__ex2g4s_17.l();
        var tmp0_safe_receiver_0 = element_15.h1g_1.t1e_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_10.f(tmp0_safe_receiver_0);
        }
      }
      var patterns = toSet(destination_10);
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_11 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_18 = chosen.j();
      while (_iterator__ex2g4s_18.k()) {
        var element_16 = _iterator__ex2g4s_18.l();
        var tmp0_safe_receiver_1 = element_16.h1g_1.p1e_1;
        if (tmp0_safe_receiver_1 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_11.f(tmp0_safe_receiver_1);
        }
      }
      var families = toSet(destination_11);
      var tmp_34;
      var tmp_35;
      if (chosen.o() < 9) {
        var tmp12_elvis_lhs = need.s1(muscle_0);
        tmp_35 = (tmp12_elvis_lhs == null ? 0.0 : tmp12_elvis_lhs) >= 1.5;
      } else {
        tmp_35 = false;
      }
      if (tmp_35) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_12 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_19 = pool.j();
        while (_iterator__ex2g4s_19.k()) {
          var element_17 = _iterator__ex2g4s_19.l();
          var tmp_36;
          var tmp_37;
          if (element_17.h1e_1.r(muscle_0)) {
            var tmp$ret$107;
            $l$block_7: {
              // Inline function 'kotlin.collections.none' call
              var tmp_38;
              if (isInterface(chosen, Collection)) {
                tmp_38 = chosen.m();
              } else {
                tmp_38 = false;
              }
              if (tmp_38) {
                tmp$ret$107 = true;
                break $l$block_7;
              }
              var _iterator__ex2g4s_20 = chosen.j();
              while (_iterator__ex2g4s_20.k()) {
                var element_18 = _iterator__ex2g4s_20.l();
                if (element_18.h1g_1.e1e_1 === element_17.e1e_1) {
                  tmp$ret$107 = false;
                  break $l$block_7;
                }
              }
              tmp$ret$107 = true;
            }
            tmp_37 = tmp$ret$107;
          } else {
            tmp_37 = false;
          }
          if (tmp_37) {
            tmp_36 = generate$allowed(settings, groupOwner, element_17);
          } else {
            tmp_36 = false;
          }
          if (tmp_36) {
            destination_12.f(element_17);
          }
        }
        var tmp_39 = destination_12;
        var tmp_40 = ProgramGenerator$generate$duplicate$ref(patterns, families);
        tmp_34 = minWithOrNull(tmp_39, generate$preferred(usage, tmp_40, ProgramGenerator$generate$lambda_11(need, usage, settings)));
      } else {
        tmp_34 = null;
      }
      var best_0 = tmp_34;
      var tmp_41;
      if (!(best_0 == null) && generate$duplicate(patterns, families, best_0) && !deferred.r(muscle_0)) {
        var tmp$ret$109;
        $l$block_9: {
          // Inline function 'kotlin.collections.any' call
          var tmp_42;
          if (isInterface(open, Collection)) {
            tmp_42 = open.m();
          } else {
            tmp_42 = false;
          }
          if (tmp_42) {
            tmp$ret$109 = false;
            break $l$block_9;
          }
          var _iterator__ex2g4s_21 = open.j();
          while (_iterator__ex2g4s_21.k()) {
            var element_19 = _iterator__ex2g4s_21.l();
            if (!element_19.equals(muscle_0) && !deferred.r(element_19)) {
              tmp$ret$109 = true;
              break $l$block_9;
            }
          }
          tmp$ret$109 = false;
        }
        tmp_41 = tmp$ret$109;
      } else {
        tmp_41 = false;
      }
      if (tmp_41) {
        deferred.f(muscle_0);
        continue $l$loop_4;
      }
      if (best_0 == null || !generate$addExercise(used, budget, chosen, groupOwner, settings, need, best_0, muscle_0, false)) {
        exhausted.f(muscle_0);
      }
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_22 = chosen.j();
    while (_iterator__ex2g4s_22.k()) {
      var element_20 = _iterator__ex2g4s_22.l();
      var tmp2 = element_20.h1g_1.e1e_1;
      var tmp0_elvis_lhs_4 = usage.s1(element_20.h1g_1.e1e_1);
      // Inline function 'kotlin.collections.set' call
      var value_0 = (tmp0_elvis_lhs_4 == null ? 0 : tmp0_elvis_lhs_4) + 1 | 0;
      usage.k2(tmp2, value_0);
    }
    var tmp_43 = Warmups_getInstance();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_13 = ArrayList_init_$Create$(collectionSizeOrDefault(chosen, 10));
    var _iterator__ex2g4s_23 = chosen.j();
    while (_iterator__ex2g4s_23.k()) {
      var item = _iterator__ex2g4s_23.l();
      var tmp$ret$116 = item.h1g_1.g1e_1;
      destination_13.f(tmp$ret$116);
    }
    var warmupIndexes = tmp_43.k1i(destination_13);
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_14 = ArrayList_init_$Create$(collectionSizeOrDefault(chosen, 10));
    var index_1 = 0;
    var _iterator__ex2g4s_24 = chosen.j();
    while (_iterator__ex2g4s_24.k()) {
      var item_0 = _iterator__ex2g4s_24.l();
      var _unary__edvuaz = index_1;
      index_1 = _unary__edvuaz + 1 | 0;
      var index_2 = checkIndexOverflow(_unary__edvuaz);
      var compound = ProgramGenerator_getInstance().z1h(item_0.h1g_1);
      var _destruct__k2r9zo_0 = ProgramGenerator_getInstance().h1i(settings.q19_1, compound, item_0.k1g_1);
      var repMin = _destruct__k2r9zo_0.ya();
      var repMax = _destruct__k2r9zo_0.za();
      var tmp0_elvis_lhs_5 = peakTargets.s1(item_0.i1g_1);
      var peakTarget = tmp0_elvis_lhs_5 == null ? 0.0 : tmp0_elvis_lhs_5;
      var tmp1_elvis_lhs = startTargets.s1(item_0.i1g_1);
      var startTarget = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
      var tmp_44;
      if (peakTarget > 0.0) {
        // Inline function 'kotlin.math.max' call
        var b_0 = roundHalfUp_0(ProgramGenerator_getInstance(), item_0.j1g_1 * startTarget / peakTarget);
        tmp_44 = Math.max(1, b_0);
      } else {
        tmp_44 = item_0.j1g_1;
      }
      var startSets = tmp_44;
      var tmp2_elvis_lhs = occurrences.s1(item_0.h1g_1.e1e_1);
      var occurrence = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
      var tmp2_0 = item_0.h1g_1.e1e_1;
      // Inline function 'kotlin.collections.set' call
      var value_1 = occurrence + 1 | 0;
      occurrences.k2(tmp2_0, value_1);
      var tmp_45 = ProgramGenerator_getInstance().y1h(settings, item_0.h1g_1);
      var tmp_46 = warmupIndexes.r(index_2) ? Companion_getInstance_22().l1i_1 : Companion_getInstance_22().n1i_1;
      var tmp_47 = Periodisation_instance;
      // Inline function 'kotlin.math.min' call
      var b_1 = item_0.j1g_1;
      var tmp$ret$122 = Math.min(startSets, b_1);
      var tmp$ret$119 = new ProgramExercise(item_0.h1g_1.e1e_1, tmp_45, tmp_46, settings.a1a_1, tmp_47.h1f(settings.z19_1, tmp$ret$122, item_0.j1g_1, repMin, repMax, settings.a1a_1, deload, VOID, VOID, VOID, occurrence));
      destination_14.f(tmp$ret$119);
    }
    var exercises = destination_14;
    var tmp13_safe_receiver = getOrNull_0(dayGyms, dayIndex);
    days.f(new ProgramDay(template.d1g_1, exercises, tmp13_safe_receiver == null ? null : tmp13_safe_receiver.hb_1));
  }
  var named = nameDays(this, days);
  var tmp14_elvis_lhs = settings.c1a_1;
  var program = new TrainingProgram(tmp14_elvis_lhs == null ? split.k1f_1 + ' ' + settings.r19_1 + 'x' : tmp14_elvis_lhs, settings.q19_1, settings.z19_1, deload, named);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(catalogue, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_15 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_25 = catalogue.j();
  while (_iterator__ex2g4s_25.k()) {
    var element_21 = _iterator__ex2g4s_25.l();
    var tmp$ret$125 = element_21.e1e_1;
    destination_15.k2(tmp$ret$125, element_21);
  }
  var byId = destination_15;
  var firstLoading = deload.equals(DeloadPosition_FIRST_getInstance()) ? 1 : 0;
  var lastLoading = deload.equals(DeloadPosition_LAST_getInstance()) ? settings.z19_1 - 2 | 0 : settings.z19_1 - 1 | 0;
  var tmp_48 = this.o1i(program, firstLoading, byId);
  var tmp_49 = this.o1i(program, lastLoading, byId);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_16 = ArrayList_init_$Create$(collectionSizeOrDefault(named, 10));
  var _iterator__ex2g4s_26 = named.j();
  while (_iterator__ex2g4s_26.k()) {
    var item_1 = _iterator__ex2g4s_26.l();
    var tmp$ret$128 = ProgramGenerator_getInstance().p1i(item_1, lastLoading, byId) / 60.0;
    destination_16.f(tmp$ret$128);
  }
  return new GeneratedProgram(program, split, startTargets, peakTargets, tmp_48, tmp_49, destination_16);
};
protoOf(ProgramGenerator).o1i = function (program, cycle, catalogue) {
  var sets = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = get_entries_30().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.set' call
    sets.k2(element, 0.0);
  }
  var _iterator__ex2g4s_0 = program.u1i_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var day = _iterator__ex2g4s_0.l();
    var _iterator__ex2g4s_1 = day.n1g_1.j();
    $l$loop_0: while (_iterator__ex2g4s_1.k()) {
      var planned = _iterator__ex2g4s_1.l();
      var tmp0_elvis_lhs = catalogue.s1(planned.y1i_1);
      var tmp;
      if (tmp0_elvis_lhs == null) {
        continue $l$loop_0;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var exercise = tmp;
      var prescription = planned.g1j(cycle);
      if (prescription.f1f_1.equals(SetType_WARMUP_getInstance()))
        continue $l$loop_0;
      var count = prescription.b1f_1;
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = exercise.h1e_1.j();
      while (_iterator__ex2g4s_2.k()) {
        var element_0 = _iterator__ex2g4s_2.l();
        // Inline function 'kotlin.collections.set' call
        var value = getValue(sets, element_0) + count;
        sets.k2(element_0, value);
      }
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_3 = exercise.i1e_1.j();
      while (_iterator__ex2g4s_3.k()) {
        var element_1 = _iterator__ex2g4s_3.l();
        // Inline function 'kotlin.collections.set' call
        var value_0 = getValue(sets, element_1) + 0.5 * count;
        sets.k2(element_1, value_0);
      }
    }
  }
  return sets;
};
protoOf(ProgramGenerator).p1i = function (day, cycle, catalogue) {
  // Inline function 'kotlin.collections.sumOf' call
  var sum = 0;
  var _iterator__ex2g4s = day.n1g_1.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = sum;
    var prescription = element.g1j(cycle);
    var tmp_0;
    switch (element.a1j_1.h1j_1.x1_1) {
      case 0:
      case 1:
        tmp_0 = Warmups_getInstance().s1h_1.o();
        break;
      case 2:
        tmp_0 = 0;
        break;
      case 3:
        tmp_0 = element.a1j_1.i1j_1.o();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    var warmups = tmp_0;
    sum = tmp + (prescription.b1f_1 * (40 + element.z1i_1 | 0) + 60 + imul(warmups, 75));
  }
  return sum;
};
protoOf(ProgramGenerator).z1h = function (exercise) {
  var tmp0_subject = exercise.j1e_1;
  var tmp;
  switch (tmp0_subject == null ? -1 : tmp0_subject.x1_1) {
    case 0:
      tmp = true;
      break;
    case 1:
      tmp = false;
      break;
    case -1:
      tmp = (exercise.h1e_1.o() + exercise.i1e_1.o() | 0) > 1;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var ProgramGenerator_instance;
function ProgramGenerator_getInstance() {
  if (ProgramGenerator_instance == null)
    new ProgramGenerator();
  return ProgramGenerator_instance;
}
function Substitute(exercise, score) {
  this.j1j_1 = exercise;
  this.k1j_1 = score;
}
protoOf(Substitute).toString = function () {
  return 'Substitute(exercise=' + this.j1j_1.toString() + ', score=' + this.k1j_1 + ')';
};
protoOf(Substitute).hashCode = function () {
  var result = this.j1j_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.k1j_1) | 0;
  return result;
};
protoOf(Substitute).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Substitute))
    return false;
  if (!this.j1j_1.equals(other.j1j_1))
    return false;
  if (!equals(this.k1j_1, other.k1j_1))
    return false;
  return true;
};
function jaccard($this, a, b) {
  if (a.m() && b.m())
    return 1.0;
  return intersect(a, b).o() / union(a, b).o();
}
function sam$kotlin_Comparator$0_9(function_0) {
  this.l1j_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_9).y9 = function (a, b) {
  return this.l1j_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_9).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_9).g2 = function () {
  return this.l1j_1;
};
protoOf(sam$kotlin_Comparator$0_9).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_9).hashCode = function () {
  return hashCode(this.g2());
};
function Substitutions$rank$lambda($exercise, $hidden) {
  return function (it) {
    return !(it.e1e_1 === $exercise.e1e_1) && !it.n1e_1 && !$hidden.r(it.e1e_1);
  };
}
function Substitutions$rank$lambda_0($exercise) {
  return function (it) {
    return equals_0(it.l1e_1, $exercise.l1e_1, true);
  };
}
function Substitutions$rank$lambda_1($gym) {
  return function (it) {
    return $gym == null || (!$gym.l1b_1.r(it.e1e_1) && $gym.s1b(it.g1e_1));
  };
}
function Substitutions$rank$lambda_2($skills) {
  return function (it) {
    return $skills == null || $skills.n1(it.s1e_1);
  };
}
function Substitutions$rank$lambda_3($primary) {
  return function (candidate) {
    var tmp0 = candidate.h1e_1;
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp;
      if (isInterface(tmp0, Collection)) {
        tmp = tmp0.m();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if ($primary.r(element)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
}
function Substitutions$rank$lambda_4($primary, $secondary, $exercise) {
  return function (candidate) {
    var score = 10.0 * jaccard(Substitutions_instance, $primary, toSet(candidate.h1e_1)) + 3.0 * jaccard(Substitutions_instance, $secondary, toSet(candidate.i1e_1)) + (!(candidate.p1e_1 == null) && candidate.p1e_1 == $exercise.p1e_1 ? 2.0 : 0.0) + (!(candidate.j1e_1 == null) && equals(candidate.j1e_1, $exercise.j1e_1) ? 2.0 : 0.0) + (!(candidate.t1e_1 == null) && equals(candidate.t1e_1, $exercise.t1e_1) ? 1.0 : 0.0) + (!(candidate.k1e_1 == null) && equals(candidate.k1e_1, $exercise.k1e_1) ? 1.0 : 0.0) + (candidate.g1e_1.equals($exercise.g1e_1) ? 0.5 : 0.0);
    return new Substitute(candidate, score);
  };
}
function Substitutions$rank$lambda_5(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = b.k1j_1;
  var tmp$ret$2 = a.k1j_1;
  return compareValues(tmp, tmp$ret$2);
}
function Substitutions$rank$lambda_6($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.j1j_1.f1e_1;
      var tmp$ret$2 = b.j1j_1.f1e_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function Substitutions$rank$lambda_7($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.j1j_1.e1e_1;
      var tmp$ret$2 = b.j1j_1.e1e_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function Substitutions() {
}
protoOf(Substitutions).m1j = function (exerciseId, catalogue, gym, hidden, limit, skills) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = catalogue.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.e1e_1 === exerciseId) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return emptyList();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var exercise = tmp;
  return this.n1j(exercise, catalogue, gym, hidden, limit, skills);
};
protoOf(Substitutions).o1j = function (exerciseId, catalogue, gym, hidden, limit, skills, $super) {
  gym = gym === VOID ? null : gym;
  hidden = hidden === VOID ? emptySet() : hidden;
  limit = limit === VOID ? 10 : limit;
  skills = skills === VOID ? null : skills;
  return $super === VOID ? this.m1j(exerciseId, catalogue, gym, hidden, limit, skills) : $super.m1j.call(this, exerciseId, catalogue, gym, hidden, limit, skills);
};
protoOf(Substitutions).n1j = function (exercise, catalogue, gym, hidden, limit, skills) {
  // Inline function 'kotlin.require' call
  if (!(limit > 0)) {
    var message = 'limit must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var primary = toSet(exercise.h1e_1);
  var secondary = toSet(exercise.i1e_1);
  var tmp = asSequence(catalogue);
  var tmp_0 = filter(tmp, Substitutions$rank$lambda(exercise, hidden));
  var tmp_1 = filter(tmp_0, Substitutions$rank$lambda_0(exercise));
  var tmp_2 = filter(tmp_1, Substitutions$rank$lambda_1(gym));
  var tmp_3 = filter(tmp_2, Substitutions$rank$lambda_2(skills));
  var tmp_4 = filter(tmp_3, Substitutions$rank$lambda_3(primary));
  var tmp_5 = map(tmp_4, Substitutions$rank$lambda_4(primary, secondary, exercise));
  // Inline function 'kotlin.comparisons.compareByDescending' call
  var tmp_6 = Substitutions$rank$lambda_5;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_9(tmp_6);
  var tmp_7 = Substitutions$rank$lambda_6(this_0);
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_1 = new sam$kotlin_Comparator$0_9(tmp_7);
  var tmp_8 = Substitutions$rank$lambda_7(this_1);
  var tmp$ret$4 = new sam$kotlin_Comparator$0_9(tmp_8);
  return toList_0(take_0(sortedWith_0(tmp_5, tmp$ret$4), limit));
};
var Substitutions_instance;
function Substitutions_getInstance() {
  return Substitutions_instance;
}
function Experience_BEGINNER_getInstance() {
  static_init_41();
  return Experience_BEGINNER_instance;
}
function Experience_INTERMEDIATE_getInstance() {
  static_init_41();
  return Experience_INTERMEDIATE_instance;
}
function Experience_ADVANCED_getInstance() {
  static_init_41();
  return Experience_ADVANCED_instance;
}
function Split_AUTO_getInstance() {
  static_init_42();
  return Split_AUTO_instance;
}
function Split_FULL_BODY_getInstance() {
  static_init_42();
  return Split_FULL_BODY_instance;
}
function Split_UPPER_LOWER_getInstance() {
  static_init_42();
  return Split_UPPER_LOWER_instance;
}
function Split_PPL_getInstance() {
  static_init_42();
  return Split_PPL_instance;
}
function Split_PUSH_PULL_HINGE_SQUAT_getInstance() {
  static_init_42();
  return Split_PUSH_PULL_HINGE_SQUAT_instance;
}
function Split_PPL_ACCESSORIES_getInstance() {
  static_init_42();
  return Split_PPL_ACCESSORIES_instance;
}
function Split_PPHS_ACCESSORIES_getInstance() {
  static_init_42();
  return Split_PPHS_ACCESSORIES_instance;
}
function Split_PPL_UPPER_LOWER_getInstance() {
  static_init_42();
  return Split_PPL_UPPER_LOWER_instance;
}
function Split_PPHS_UPPER_LOWER_getInstance() {
  static_init_42();
  return Split_PPHS_UPPER_LOWER_instance;
}
function CompoundSetRule_GREEDY_getInstance() {
  static_init_43();
  return CompoundSetRule_GREEDY_instance;
}
function CompoundSetRule_POWER_getInstance() {
  static_init_43();
  return CompoundSetRule_POWER_instance;
}
function RestRule_BY_GOAL_getInstance() {
  static_init_44();
  return RestRule_BY_GOAL_instance;
}
function RestRule_BY_TYPE_getInstance() {
  static_init_44();
  return RestRule_BY_TYPE_instance;
}
function ImportedProgram(program, unmatched) {
  this.p1j_1 = program;
  this.q1j_1 = unmatched;
}
protoOf(ImportedProgram).toString = function () {
  return 'ImportedProgram(program=' + this.p1j_1.toString() + ', unmatched=' + toString(this.q1j_1) + ')';
};
protoOf(ImportedProgram).hashCode = function () {
  var result = this.p1j_1.hashCode();
  result = imul(result, 31) + hashCode(this.q1j_1) | 0;
  return result;
};
protoOf(ImportedProgram).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ImportedProgram))
    return false;
  if (!this.p1j_1.equals(other.p1j_1))
    return false;
  if (!equals(this.q1j_1, other.q1j_1))
    return false;
  return true;
};
function words($this, text) {
  var tmp = Regex_init_$Create$('[a-z0-9]+');
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp$ret$0 = text.toLowerCase();
  var tmp_0 = tmp.z8(replace(tmp$ret$0, '-', ''));
  return toSet_0(map(tmp_0, ProgramImport$words$lambda));
}
function reps($this, text) {
  var tmp0_safe_receiver = $this.v1j_1.x8(text);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var low = toInt(tmp0_safe_receiver.v9().n(1));
    var high = toInt(tmp0_safe_receiver.v9().n(2));
    if (1 <= low ? low <= high : false)
      return to(low, high);
  }
  var tmp1_safe_receiver = $this.w1j_1.x8(text);
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.p1();
  var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : toDoubleOrNull(tmp2_safe_receiver);
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : numberToInt(tmp3_safe_receiver);
  var tmp;
  if (tmp4_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (tmp4_safe_receiver >= 1) {
      tmp_0 = tmp4_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var single = tmp;
  return !(single == null) ? to(single, single) : to(8, 12);
}
function rir($this, text, columnIsRpe) {
  var tmp0_safe_receiver = $this.w1j_1.x8(text);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p1();
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
  var tmp;
  if (tmp2_elvis_lhs == null) {
    return 2;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var value = tmp;
  var tmp_0;
  if (columnIsRpe || contains_1(text, 'rpe', true)) {
    tmp_0 = true;
  } else {
    // Inline function 'kotlin.text.trimStart' call
    var tmp$ret$0 = toString(trimStart(isCharSequence(text) ? text : THROW_CCE()));
    tmp_0 = startsWith(tmp$ret$0, '@');
  }
  var rpe = tmp_0;
  var tmp_1;
  if (rpe) {
    tmp_1 = Companion_instance_28.x1j(value);
  } else {
    // Inline function 'kotlin.math.floor' call
    var x = value + 0.5;
    var tmp$ret$1 = Math.floor(x);
    tmp_1 = coerceIn_0(numberToInt(tmp$ret$1), 0, 10);
  }
  return tmp_1;
}
function rest($this, text) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var lower = text.toLowerCase();
  var clock = Regex_init_$Create$('(\\d+):(\\d{2})').x8(lower);
  if (!(clock == null))
    return imul(toInt(clock.v9().n(1)), 60) + toInt(clock.v9().n(2)) | 0;
  var tmp0_safe_receiver = $this.w1j_1.x8(lower);
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.p1();
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toDoubleOrNull(tmp1_safe_receiver);
  var tmp;
  if (tmp2_elvis_lhs == null) {
    return 120;
  } else {
    tmp = tmp2_elvis_lhs;
  }
  var value = tmp;
  return coerceIn_0(numberToInt(contains_1(lower, 'min') || endsWith(lower, 'm') ? value * 60 : value), 0, 3600);
}
function setType($this, text) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  var lower = text.toLowerCase();
  return contains_1(lower, 'warm') ? SetType_WARMUP_getInstance() : contains_1(lower, 'drop') ? SetType_DROP_getInstance() : contains_1(lower, 'myo') || contains_1(lower, 'rest') ? SetType_MYO_getInstance() : contains_1(lower, 'fail') || contains_1(lower, 'amrap') ? SetType_FAILURE_getInstance() : SetType_STANDARD_getInstance();
}
function ProgramImport$parse$lambda(it) {
  return removePrefix(it, '\uFEFF');
}
function ProgramImport$parse$lambda_0(it) {
  // Inline function 'kotlin.text.isNotBlank' call
  return !isBlank(it);
}
function parse$column(header, names) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s = header.j();
    while (_iterator__ex2g4s.k()) {
      var item = _iterator__ex2g4s.l();
      if (contains_2(names, item)) {
        tmp$ret$0 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$0 = -1;
  }
  return tmp$ret$0;
}
function parse$cell(cells, index) {
  var tmp;
  if (index >= 0) {
    // Inline function 'kotlin.text.orEmpty' call
    var tmp0_elvis_lhs = getOrNull_0(cells, index);
    tmp = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  } else {
    tmp = '';
  }
  return tmp;
}
function ProgramImport$words$lambda(m) {
  // Inline function 'kotlin.let' call
  var it = m.p1();
  return it.length > 3 && endsWith(it, 's') && !endsWith(it, 'ss') ? dropLast(it, 1) : it;
}
function ProgramImport() {
  ProgramImport_instance = this;
  this.r1j_1 = 3;
  this.s1j_1 = 120;
  this.t1j_1 = 2;
  this.u1j_1 = Regex_init_$Create$('set \\d+ type');
  this.v1j_1 = Regex_init_$Create$('(\\d+)\\s*(?:[-\u2013\u2014]|to)\\s*(\\d+)');
  this.w1j_1 = Regex_init_$Create$('\\d+(?:\\.\\d+)?');
}
protoOf(ProgramImport).y1j = function (csv, catalogue, name) {
  var tmp = lineSequence(csv);
  var tmp_0 = map(tmp, ProgramImport$parse$lambda);
  var lines = toList_0(filter(tmp_0, ProgramImport$parse$lambda_0));
  // Inline function 'kotlin.collections.isNotEmpty' call
  // Inline function 'kotlin.require' call
  if (!!lines.m()) {
    var message = 'the file is empty';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = TrainingBacktest_getInstance().d1k(first(lines));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$5 = toString(trim(isCharSequence(item) ? item : THROW_CCE())).toLowerCase();
    destination.f(tmp$ret$5);
  }
  var header = destination;
  var exerciseColumn = parse$column(header, ['exercise', 'exercise name', 'movement']);
  // Inline function 'kotlin.require' call
  if (!(exerciseColumn >= 0)) {
    var message_0 = 'the header needs an Exercise column';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var dayColumn = parse$column(header, ['day', 'workout', 'day name']);
  var setsColumn = parse$column(header, ['sets', 'set count']);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_indices(header);
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.oc_1;
  var last = tmp0.pc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      if (ProgramImport_getInstance().u1j_1.v8(header.n(it))) {
        destination_0.f(element);
      }
    }
     while (!(element === last));
  var setTypeColumns = destination_0;
  var repsColumn = parse$column(header, ['rep range', 'reps', 'rep target']);
  var tmp$ret$14;
  $l$block: {
    // Inline function 'kotlin.collections.indexOfFirst' call
    var index = 0;
    var _iterator__ex2g4s_0 = header.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      switch (item_0) {
        case 'rir':
        case 'rpe':
        case 'rir or rpe':
          var tmp$ret$15 = true;
          break;
        default:
          tmp$ret$15 = item_0 === 'rir/rpe';
          break;
      }
      if (tmp$ret$15) {
        tmp$ret$14 = index;
        break $l$block;
      }
      index = index + 1 | 0;
    }
    tmp$ret$14 = -1;
  }
  var effortColumn = tmp$ret$14;
  var effortIsRpe = effortColumn >= 0 && header.n(effortColumn) === 'rpe';
  var restColumn = parse$column(header, ['rest', 'rest (s)', 'rest time']);
  var days = LinkedHashMap_init_$Create$_1();
  var unmatched = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = drop(lines, 1).j();
  $l$loop_0: while (_iterator__ex2g4s_1.k()) {
    var line = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.map' call
    var this_1 = TrainingBacktest_getInstance().d1k(line);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_2 = this_1.j();
    while (_iterator__ex2g4s_2.k()) {
      var item_1 = _iterator__ex2g4s_2.l();
      // Inline function 'kotlin.text.trim' call
      var tmp$ret$18 = toString(trim(isCharSequence(item_1) ? item_1 : THROW_CCE()));
      destination_1.f(tmp$ret$18);
    }
    var cells = destination_1;
    var exerciseName = parse$cell(cells, exerciseColumn);
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(exerciseName) === 0)
      continue $l$loop_0;
    var exercise = this.e1k(exerciseName, catalogue);
    if (exercise == null) {
      if (!unmatched.r(exerciseName)) {
        unmatched.f(exerciseName);
      }
      continue $l$loop_0;
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(setTypeColumns, 10));
    var _iterator__ex2g4s_3 = setTypeColumns.j();
    while (_iterator__ex2g4s_3.k()) {
      var item_2 = _iterator__ex2g4s_3.l();
      var tmp$ret$23 = parse$cell(cells, item_2);
      destination_2.f(tmp$ret$23);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_3 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_4 = destination_2.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_0 = _iterator__ex2g4s_4.l();
      // Inline function 'kotlin.text.isNotEmpty' call
      if (charSequenceLength(element_0) > 0) {
        destination_3.f(element_0);
      }
    }
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_3, 10));
    var _iterator__ex2g4s_5 = destination_3.j();
    while (_iterator__ex2g4s_5.k()) {
      var item_3 = _iterator__ex2g4s_5.l();
      var tmp$ret$30 = setType(this, item_3);
      destination_4.f(tmp$ret$30);
    }
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_5 = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_6 = destination_4.j();
    while (_iterator__ex2g4s_6.k()) {
      var element_1 = _iterator__ex2g4s_6.l();
      if (!element_1.equals(SetType_WARMUP_getInstance())) {
        destination_5.f(element_1);
      }
    }
    var types = destination_5;
    var tmp0_safe_receiver = toIntOrNull(parse$cell(cells, setsColumn));
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_2;
      if (1 <= tmp0_safe_receiver ? tmp0_safe_receiver <= 20 : false) {
        tmp_2 = tmp0_safe_receiver;
      } else {
        tmp_2 = null;
      }
      tmp_1 = tmp_2;
    }
    var tmp1_elvis_lhs = tmp_1;
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      // Inline function 'kotlin.takeIf' call
      var this_2 = types.o();
      var tmp_4;
      if (this_2 > 0) {
        tmp_4 = this_2;
      } else {
        tmp_4 = null;
      }
      tmp_3 = tmp_4;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tmp2_elvis_lhs = tmp_3;
    var sets = tmp2_elvis_lhs == null ? 3 : tmp2_elvis_lhs;
    var _destruct__k2r9zo = reps(this, parse$cell(cells, repsColumn));
    var repMin = _destruct__k2r9zo.ya();
    var repMax = _destruct__k2r9zo.za();
    var tmp_5 = rir(this, parse$cell(cells, effortColumn), effortIsRpe);
    var tmp3_elvis_lhs = firstOrNull(types);
    var prescription = new CyclePrescription(sets, repMin, repMax, tmp_5, tmp3_elvis_lhs == null ? SetType_STANDARD_getInstance() : tmp3_elvis_lhs);
    // Inline function 'kotlin.text.ifEmpty' call
    var this_3 = parse$cell(cells, dayColumn);
    var tmp_6;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(this_3) === 0) {
      tmp_6 = 'Day 1';
    } else {
      tmp_6 = this_3;
    }
    var day = tmp_6;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = days.s1(day);
    var tmp_7;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      days.k2(day, answer);
      tmp_7 = answer;
    } else {
      tmp_7 = value;
    }
    tmp_7.f(new ProgramExercise(exercise.e1e_1, rest(this, parse$cell(cells, restColumn)), Companion_getInstance_22().l1i_1, ProgressionScheme_DOUBLE_getInstance(), listOf_0(prescription)));
  }
  var tmp_8 = TrainingGoal_HYPERTROPHY_getInstance();
  var tmp_9 = DeloadPosition_NONE_getInstance();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_6 = ArrayList_init_$Create$(days.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_7 = days.v1().j();
  while (_iterator__ex2g4s_7.k()) {
    var item_4 = _iterator__ex2g4s_7.l();
    // Inline function 'kotlin.collections.component1' call
    var dayName = item_4.o1();
    // Inline function 'kotlin.collections.component2' call
    var exercises = item_4.p1();
    // Inline function 'kotlin.collections.distinctBy' call
    var set = HashSet_init_$Create$();
    var list = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_8 = exercises.j();
    while (_iterator__ex2g4s_8.k()) {
      var e = _iterator__ex2g4s_8.l();
      var key = e.y1i_1;
      if (set.f(key)) {
        list.f(e);
      }
    }
    var tmp$ret$46 = new ProgramDay(dayName, list);
    destination_6.f(tmp$ret$46);
  }
  var program = new TrainingProgram(name, tmp_8, 1, tmp_9, destination_6);
  return new ImportedProgram(program, unmatched);
};
protoOf(ProgramImport).e1k = function (name, catalogue) {
  var wanted = words(this, name);
  if (wanted.m())
    return null;
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = catalogue.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (equals(words(ProgramImport_getInstance(), element.f1e_1), wanted)) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s_0 = catalogue.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (words(ProgramImport_getInstance(), element_0.f1e_1).n1(wanted)) {
        destination.f(element_0);
      }
    }
    var tmp$ret$5;
    $l$block_1: {
      // Inline function 'kotlin.collections.minByOrNull' call
      var iterator = destination.j();
      if (!iterator.k()) {
        tmp$ret$5 = null;
        break $l$block_1;
      }
      var minElem = iterator.l();
      if (!iterator.k()) {
        tmp$ret$5 = minElem;
        break $l$block_1;
      }
      var minValue = minElem.f1e_1.length;
      do {
        var e = iterator.l();
        var v = e.f1e_1.length;
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.k());
      tmp$ret$5 = minElem;
    }
    tmp = tmp$ret$5;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  return tmp;
};
var ProgramImport_instance;
function ProgramImport_getInstance() {
  if (ProgramImport_instance == null)
    new ProgramImport();
  return ProgramImport_instance;
}
function CyclePrescription(sets, repMin, repMax, rir, setType, skip) {
  setType = setType === VOID ? SetType_STANDARD_getInstance() : setType;
  skip = skip === VOID ? false : skip;
  this.b1f_1 = sets;
  this.c1f_1 = repMin;
  this.d1f_1 = repMax;
  this.e1f_1 = rir;
  this.f1f_1 = setType;
  this.g1f_1 = skip;
  // Inline function 'kotlin.require' call
  if (!(this.b1f_1 >= 1)) {
    var message = 'sets must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var containsUpper = this.d1f_1;
  var containsArg = this.c1f_1;
  // Inline function 'kotlin.require' call
  if (!(1 <= containsArg ? containsArg <= containsUpper : false)) {
    var message_0 = 'invalid rep range';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var containsArg_0 = this.e1f_1;
  // Inline function 'kotlin.require' call
  if (!(0 <= containsArg_0 ? containsArg_0 <= 10 : false)) {
    var message_1 = 'rir must be 0\u201310';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
}
protoOf(CyclePrescription).toString = function () {
  return 'CyclePrescription(sets=' + this.b1f_1 + ', repMin=' + this.c1f_1 + ', repMax=' + this.d1f_1 + ', rir=' + this.e1f_1 + ', setType=' + this.f1f_1.toString() + ', skip=' + this.g1f_1 + ')';
};
protoOf(CyclePrescription).hashCode = function () {
  var result = this.b1f_1;
  result = imul(result, 31) + this.c1f_1 | 0;
  result = imul(result, 31) + this.d1f_1 | 0;
  result = imul(result, 31) + this.e1f_1 | 0;
  result = imul(result, 31) + this.f1f_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.g1f_1) | 0;
  return result;
};
protoOf(CyclePrescription).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof CyclePrescription))
    return false;
  if (!(this.b1f_1 === other.b1f_1))
    return false;
  if (!(this.c1f_1 === other.c1f_1))
    return false;
  if (!(this.d1f_1 === other.d1f_1))
    return false;
  if (!(this.e1f_1 === other.e1f_1))
    return false;
  if (!this.f1f_1.equals(other.f1f_1))
    return false;
  if (!(this.g1f_1 === other.g1f_1))
    return false;
  return true;
};
function SetRecord(day, loadKg, reps, rir, type, sessionId) {
  rir = rir === VOID ? null : rir;
  type = type === VOID ? SetType_STANDARD_getInstance() : type;
  sessionId = sessionId === VOID ? null : sessionId;
  this.t18_1 = day;
  this.u18_1 = loadKg;
  this.v18_1 = reps;
  this.w18_1 = rir;
  this.x18_1 = type;
  this.y18_1 = sessionId;
}
protoOf(SetRecord).toString = function () {
  return 'SetRecord(day=' + this.t18_1 + ', loadKg=' + this.u18_1 + ', reps=' + this.v18_1 + ', rir=' + this.w18_1 + ', type=' + this.x18_1.toString() + ', sessionId=' + this.y18_1 + ')';
};
protoOf(SetRecord).hashCode = function () {
  var result = this.t18_1;
  result = imul(result, 31) + getNumberHashCode(this.u18_1) | 0;
  result = imul(result, 31) + this.v18_1 | 0;
  result = imul(result, 31) + (this.w18_1 == null ? 0 : this.w18_1) | 0;
  result = imul(result, 31) + this.x18_1.hashCode() | 0;
  result = imul(result, 31) + (this.y18_1 == null ? 0 : getStringHashCode(this.y18_1)) | 0;
  return result;
};
protoOf(SetRecord).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SetRecord))
    return false;
  if (!(this.t18_1 === other.t18_1))
    return false;
  if (!equals(this.u18_1, other.u18_1))
    return false;
  if (!(this.v18_1 === other.v18_1))
    return false;
  if (!(this.w18_1 == other.w18_1))
    return false;
  if (!this.x18_1.equals(other.x18_1))
    return false;
  if (!(this.y18_1 == other.y18_1))
    return false;
  return true;
};
var static_init_called_47;
function static_init_47() {
  if (static_init_called_47)
    return Unit_instance;
  static_init_called_47 = true;
  AdjustmentPriority_REPS_FIRST_instance = new AdjustmentPriority('REPS_FIRST', 0);
  AdjustmentPriority_WEIGHT_FIRST_instance = new AdjustmentPriority('WEIGHT_FIRST', 1);
}
var AdjustmentPriority_REPS_FIRST_instance;
var AdjustmentPriority_WEIGHT_FIRST_instance;
function values_32() {
  static_init_47();
  return [AdjustmentPriority_REPS_FIRST_getInstance(), AdjustmentPriority_WEIGHT_FIRST_getInstance()];
}
function valueOf_12(value) {
  static_init_47();
  switch (value) {
    case 'REPS_FIRST':
      return AdjustmentPriority_REPS_FIRST_getInstance();
    case 'WEIGHT_FIRST':
      return AdjustmentPriority_WEIGHT_FIRST_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.AdjustmentPriority.' + value);
      break;
  }
}
function get_entries_27() {
  static_init_47();
  if ($ENTRIES_27 == null)
    $ENTRIES_27 = enumEntries(values_32());
  return $ENTRIES_27;
}
var $ENTRIES_27;
function AdjustmentPriority(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function ProgressionOptions(priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct) {
  priority = priority === VOID ? AdjustmentPriority_REPS_FIRST_getInstance() : priority;
  expandRepRange = expandRepRange === VOID ? true : expandRepRange;
  expandBy = expandBy === VOID ? 2 : expandBy;
  weightMatch = weightMatch === VOID ? true : weightMatch;
  fatigue = fatigue === VOID ? new FixedReps() : fatigue;
  curve = curve === VOID ? new EpleyCurve() : curve;
  maxLoadIncreasePct = maxLoadIncreasePct === VOID ? 5.0 : maxLoadIncreasePct;
  maxRepIncrease = maxRepIncrease === VOID ? 2 : maxRepIncrease;
  bodyweightKg = bodyweightKg === VOID ? 0.0 : bodyweightKg;
  bodyweightFactor = bodyweightFactor === VOID ? 0.0 : bodyweightFactor;
  startingOneRepMaxKg = startingOneRepMaxKg === VOID ? null : startingOneRepMaxKg;
  sessionSmoothing = sessionSmoothing === VOID ? 0.6 : sessionSmoothing;
  todayWeight = todayWeight === VOID ? 0.7 : todayWeight;
  rirAdjustment = rirAdjustment === VOID ? 0 : rirAdjustment;
  linearDeloadPct = linearDeloadPct === VOID ? 10.0 : linearDeloadPct;
  clampOneRepMax = clampOneRepMax === VOID ? false : clampOneRepMax;
  surprise = surprise === VOID ? SurpriseCarry_NONE_getInstance() : surprise;
  sessionStepPct = sessionStepPct === VOID ? 0.0 : sessionStepPct;
  this.f1k_1 = priority;
  this.g1k_1 = expandRepRange;
  this.h1k_1 = expandBy;
  this.i1k_1 = weightMatch;
  this.j1k_1 = fatigue;
  this.k1k_1 = curve;
  this.l1k_1 = maxLoadIncreasePct;
  this.m1k_1 = maxRepIncrease;
  this.n1k_1 = bodyweightKg;
  this.o1k_1 = bodyweightFactor;
  this.p1k_1 = startingOneRepMaxKg;
  this.q1k_1 = sessionSmoothing;
  this.r1k_1 = todayWeight;
  this.s1k_1 = rirAdjustment;
  this.t1k_1 = linearDeloadPct;
  this.u1k_1 = clampOneRepMax;
  this.v1k_1 = surprise;
  this.w1k_1 = sessionStepPct;
}
protoOf(ProgressionOptions).x1k = function (priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct) {
  return new ProgressionOptions(priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct);
};
protoOf(ProgressionOptions).y1k = function (priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct, $super) {
  priority = priority === VOID ? this.f1k_1 : priority;
  expandRepRange = expandRepRange === VOID ? this.g1k_1 : expandRepRange;
  expandBy = expandBy === VOID ? this.h1k_1 : expandBy;
  weightMatch = weightMatch === VOID ? this.i1k_1 : weightMatch;
  fatigue = fatigue === VOID ? this.j1k_1 : fatigue;
  curve = curve === VOID ? this.k1k_1 : curve;
  maxLoadIncreasePct = maxLoadIncreasePct === VOID ? this.l1k_1 : maxLoadIncreasePct;
  maxRepIncrease = maxRepIncrease === VOID ? this.m1k_1 : maxRepIncrease;
  bodyweightKg = bodyweightKg === VOID ? this.n1k_1 : bodyweightKg;
  bodyweightFactor = bodyweightFactor === VOID ? this.o1k_1 : bodyweightFactor;
  startingOneRepMaxKg = startingOneRepMaxKg === VOID ? this.p1k_1 : startingOneRepMaxKg;
  sessionSmoothing = sessionSmoothing === VOID ? this.q1k_1 : sessionSmoothing;
  todayWeight = todayWeight === VOID ? this.r1k_1 : todayWeight;
  rirAdjustment = rirAdjustment === VOID ? this.s1k_1 : rirAdjustment;
  linearDeloadPct = linearDeloadPct === VOID ? this.t1k_1 : linearDeloadPct;
  clampOneRepMax = clampOneRepMax === VOID ? this.u1k_1 : clampOneRepMax;
  surprise = surprise === VOID ? this.v1k_1 : surprise;
  sessionStepPct = sessionStepPct === VOID ? this.w1k_1 : sessionStepPct;
  return $super === VOID ? this.x1k(priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct) : $super.x1k.call(this, priority, expandRepRange, expandBy, weightMatch, fatigue, curve, maxLoadIncreasePct, maxRepIncrease, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, sessionSmoothing, todayWeight, rirAdjustment, linearDeloadPct, clampOneRepMax, surprise, sessionStepPct);
};
protoOf(ProgressionOptions).toString = function () {
  return 'ProgressionOptions(priority=' + this.f1k_1.toString() + ', expandRepRange=' + this.g1k_1 + ', expandBy=' + this.h1k_1 + ', weightMatch=' + this.i1k_1 + ', fatigue=' + toString(this.j1k_1) + ', curve=' + toString(this.k1k_1) + ', maxLoadIncreasePct=' + this.l1k_1 + ', maxRepIncrease=' + this.m1k_1 + ', bodyweightKg=' + this.n1k_1 + ', bodyweightFactor=' + this.o1k_1 + ', startingOneRepMaxKg=' + this.p1k_1 + ', sessionSmoothing=' + this.q1k_1 + ', todayWeight=' + this.r1k_1 + ', rirAdjustment=' + this.s1k_1 + ', linearDeloadPct=' + this.t1k_1 + ', clampOneRepMax=' + this.u1k_1 + ', surprise=' + this.v1k_1.toString() + ', sessionStepPct=' + this.w1k_1 + ')';
};
protoOf(ProgressionOptions).hashCode = function () {
  var result = this.f1k_1.hashCode();
  result = imul(result, 31) + getBooleanHashCode(this.g1k_1) | 0;
  result = imul(result, 31) + this.h1k_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.i1k_1) | 0;
  result = imul(result, 31) + hashCode(this.j1k_1) | 0;
  result = imul(result, 31) + hashCode(this.k1k_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.l1k_1) | 0;
  result = imul(result, 31) + this.m1k_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.n1k_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.o1k_1) | 0;
  result = imul(result, 31) + (this.p1k_1 == null ? 0 : getNumberHashCode(this.p1k_1)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.q1k_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.r1k_1) | 0;
  result = imul(result, 31) + this.s1k_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.t1k_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.u1k_1) | 0;
  result = imul(result, 31) + this.v1k_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.w1k_1) | 0;
  return result;
};
protoOf(ProgressionOptions).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProgressionOptions))
    return false;
  if (!this.f1k_1.equals(other.f1k_1))
    return false;
  if (!(this.g1k_1 === other.g1k_1))
    return false;
  if (!(this.h1k_1 === other.h1k_1))
    return false;
  if (!(this.i1k_1 === other.i1k_1))
    return false;
  if (!equals(this.j1k_1, other.j1k_1))
    return false;
  if (!equals(this.k1k_1, other.k1k_1))
    return false;
  if (!equals(this.l1k_1, other.l1k_1))
    return false;
  if (!(this.m1k_1 === other.m1k_1))
    return false;
  if (!equals(this.n1k_1, other.n1k_1))
    return false;
  if (!equals(this.o1k_1, other.o1k_1))
    return false;
  if (!equals(this.p1k_1, other.p1k_1))
    return false;
  if (!equals(this.q1k_1, other.q1k_1))
    return false;
  if (!equals(this.r1k_1, other.r1k_1))
    return false;
  if (!(this.s1k_1 === other.s1k_1))
    return false;
  if (!equals(this.t1k_1, other.t1k_1))
    return false;
  if (!(this.u1k_1 === other.u1k_1))
    return false;
  if (!this.v1k_1.equals(other.v1k_1))
    return false;
  if (!equals(this.w1k_1, other.w1k_1))
    return false;
  return true;
};
var static_init_called_48;
function static_init_48() {
  if (static_init_called_48)
    return Unit_instance;
  static_init_called_48 = true;
  TargetIssue_NONE_instance = new TargetIssue('NONE', 0);
  TargetIssue_NO_HISTORY_instance = new TargetIssue('NO_HISTORY', 1);
  TargetIssue_NO_LOADS_instance = new TargetIssue('NO_LOADS', 2);
  TargetIssue_OUTSIDE_REP_RANGE_instance = new TargetIssue('OUTSIDE_REP_RANGE', 3);
  TargetIssue_NO_FEASIBLE_TARGET_instance = new TargetIssue('NO_FEASIBLE_TARGET', 4);
}
var TargetIssue_NONE_instance;
var TargetIssue_NO_HISTORY_instance;
var TargetIssue_NO_LOADS_instance;
var TargetIssue_OUTSIDE_REP_RANGE_instance;
var TargetIssue_NO_FEASIBLE_TARGET_instance;
function TargetIssue(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_49;
function static_init_49() {
  if (static_init_called_49)
    return Unit_instance;
  static_init_called_49 = true;
  AlternativeKind_NEXT_LOAD_UP_instance = new AlternativeKind('NEXT_LOAD_UP', 0);
  AlternativeKind_NEXT_LOAD_DOWN_instance = new AlternativeKind('NEXT_LOAD_DOWN', 1);
  AlternativeKind_EXPAND_REP_RANGE_instance = new AlternativeKind('EXPAND_REP_RANGE', 2);
  AlternativeKind_WEIGHT_MATCH_instance = new AlternativeKind('WEIGHT_MATCH', 3);
}
var AlternativeKind_NEXT_LOAD_UP_instance;
var AlternativeKind_NEXT_LOAD_DOWN_instance;
var AlternativeKind_EXPAND_REP_RANGE_instance;
var AlternativeKind_WEIGHT_MATCH_instance;
function AlternativeKind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function TargetAlternative(kind, loadKg, reps) {
  this.z1k_1 = kind;
  this.a1l_1 = loadKg;
  this.b1l_1 = reps;
}
protoOf(TargetAlternative).toString = function () {
  return 'TargetAlternative(kind=' + this.z1k_1.toString() + ', loadKg=' + this.a1l_1 + ', reps=' + this.b1l_1 + ')';
};
protoOf(TargetAlternative).hashCode = function () {
  var result = this.z1k_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.a1l_1) | 0;
  result = imul(result, 31) + this.b1l_1 | 0;
  return result;
};
protoOf(TargetAlternative).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TargetAlternative))
    return false;
  if (!this.z1k_1.equals(other.z1k_1))
    return false;
  if (!equals(this.a1l_1, other.a1l_1))
    return false;
  if (!(this.b1l_1 === other.b1l_1))
    return false;
  return true;
};
function PlannedSet(index, loadKg, reps, rir, type, done, outsideRepRange) {
  outsideRepRange = outsideRepRange === VOID ? false : outsideRepRange;
  this.c1l_1 = index;
  this.d1l_1 = loadKg;
  this.e1l_1 = reps;
  this.f1l_1 = rir;
  this.g1l_1 = type;
  this.h1l_1 = done;
  this.i1l_1 = outsideRepRange;
}
protoOf(PlannedSet).toString = function () {
  return 'PlannedSet(index=' + this.c1l_1 + ', loadKg=' + this.d1l_1 + ', reps=' + this.e1l_1 + ', rir=' + this.f1l_1 + ', type=' + this.g1l_1.toString() + ', done=' + this.h1l_1 + ', outsideRepRange=' + this.i1l_1 + ')';
};
protoOf(PlannedSet).hashCode = function () {
  var result = this.c1l_1;
  result = imul(result, 31) + (this.d1l_1 == null ? 0 : getNumberHashCode(this.d1l_1)) | 0;
  result = imul(result, 31) + this.e1l_1 | 0;
  result = imul(result, 31) + this.f1l_1 | 0;
  result = imul(result, 31) + this.g1l_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.h1l_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.i1l_1) | 0;
  return result;
};
protoOf(PlannedSet).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof PlannedSet))
    return false;
  if (!(this.c1l_1 === other.c1l_1))
    return false;
  if (!equals(this.d1l_1, other.d1l_1))
    return false;
  if (!(this.e1l_1 === other.e1l_1))
    return false;
  if (!(this.f1l_1 === other.f1l_1))
    return false;
  if (!this.g1l_1.equals(other.g1l_1))
    return false;
  if (!(this.h1l_1 === other.h1l_1))
    return false;
  if (!(this.i1l_1 === other.i1l_1))
    return false;
  return true;
};
function ExerciseTargets(sets, oneRepMaxKg, issue, warning, alternatives, progressed) {
  this.j1l_1 = sets;
  this.k1l_1 = oneRepMaxKg;
  this.l1l_1 = issue;
  this.m1l_1 = warning;
  this.n1l_1 = alternatives;
  this.o1l_1 = progressed;
}
protoOf(ExerciseTargets).p1l = function (sets, oneRepMaxKg, issue, warning, alternatives, progressed) {
  return new ExerciseTargets(sets, oneRepMaxKg, issue, warning, alternatives, progressed);
};
protoOf(ExerciseTargets).q1l = function (sets, oneRepMaxKg, issue, warning, alternatives, progressed, $super) {
  sets = sets === VOID ? this.j1l_1 : sets;
  oneRepMaxKg = oneRepMaxKg === VOID ? this.k1l_1 : oneRepMaxKg;
  issue = issue === VOID ? this.l1l_1 : issue;
  warning = warning === VOID ? this.m1l_1 : warning;
  alternatives = alternatives === VOID ? this.n1l_1 : alternatives;
  progressed = progressed === VOID ? this.o1l_1 : progressed;
  return $super === VOID ? this.p1l(sets, oneRepMaxKg, issue, warning, alternatives, progressed) : $super.p1l.call(this, sets, oneRepMaxKg, issue, warning, alternatives, progressed);
};
protoOf(ExerciseTargets).toString = function () {
  return 'ExerciseTargets(sets=' + toString(this.j1l_1) + ', oneRepMaxKg=' + this.k1l_1 + ', issue=' + this.l1l_1.toString() + ', warning=' + this.m1l_1 + ', alternatives=' + toString(this.n1l_1) + ', progressed=' + this.o1l_1 + ')';
};
protoOf(ExerciseTargets).hashCode = function () {
  var result = hashCode(this.j1l_1);
  result = imul(result, 31) + (this.k1l_1 == null ? 0 : getNumberHashCode(this.k1l_1)) | 0;
  result = imul(result, 31) + this.l1l_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.m1l_1) | 0;
  result = imul(result, 31) + hashCode(this.n1l_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.o1l_1) | 0;
  return result;
};
protoOf(ExerciseTargets).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ExerciseTargets))
    return false;
  if (!equals(this.j1l_1, other.j1l_1))
    return false;
  if (!equals(this.k1l_1, other.k1l_1))
    return false;
  if (!this.l1l_1.equals(other.l1l_1))
    return false;
  if (!(this.m1l_1 === other.m1l_1))
    return false;
  if (!equals(this.n1l_1, other.n1l_1))
    return false;
  if (!(this.o1l_1 === other.o1l_1))
    return false;
  return true;
};
function Context(prescription, scheme, options) {
  this.r1l_1 = prescription;
  this.s1l_1 = scheme;
  this.t1l_1 = options;
  var tmp = this;
  // Inline function 'kotlin.math.max' call
  var b = this.t1l_1.n1k_1 * this.t1l_1.o1k_1;
  tmp.u1l_1 = Math.max(0.0, b);
  var tmp_0 = this;
  var tmp_1;
  if (this.r1l_1.f1f_1.equals(SetType_FAILURE_getInstance())) {
    tmp_1 = 0;
  } else {
    // Inline function 'kotlin.math.max' call
    var b_0 = this.r1l_1.e1f_1 + this.t1l_1.s1k_1 | 0;
    // Inline function 'kotlin.math.min' call
    var b_1 = Math.max(0, b_0);
    tmp_1 = Math.min(10, b_1);
  }
  tmp_0.v1l_1 = tmp_1;
  this.w1l_1 = this.r1l_1.c1f_1;
  this.x1l_1 = this.r1l_1.d1f_1;
  this.y1l_1 = (this.w1l_1 + this.x1l_1 | 0) / 2.0;
  this.z1l_1 = this.t1l_1.k1k_1;
  var tmp_2 = this;
  var tmp_3 = this.t1l_1.j1k_1;
  var tmp0_safe_receiver = tmp_3 instanceof FixedReps ? tmp_3 : null;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.a19_1;
  tmp_2.a1m_1 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var tmp_4 = this;
  var tmp_5 = this.t1l_1.j1k_1;
  var tmp0_safe_receiver_0 = tmp_5 instanceof FixedReps ? tmp_5 : null;
  var tmp1_elvis_lhs_0 = tmp0_safe_receiver_0 == null ? null : tmp0_safe_receiver_0.a19_1;
  tmp_4.b1m_1 = tmp1_elvis_lhs_0 == null ? (new FixedReps()).a19_1 : tmp1_elvis_lhs_0;
  var tmp_6 = this;
  var tmp_7 = this.t1l_1.j1k_1;
  tmp_6.c1m_1 = tmp_7 instanceof PowerLaw ? tmp_7 : null;
  this.d1m_1 = arrayListOf([0.0]);
}
protoOf(Context).e1m = function (index) {
  return this.r1l_1.f1f_1.x1_1 === 2 ? index === 0 ? SetType_STANDARD_getInstance() : SetType_DROP_getInstance() : this.r1l_1.f1f_1;
};
protoOf(Context).f1m = function () {
  this.d1m_1.u3();
  this.d1m_1.f(0.0);
};
protoOf(Context).g1m = function (index, reps, rir) {
  var tmp0_elvis_lhs = this.c1m_1;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Unit_instance;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var model = tmp;
  while (this.d1m_1.o() <= index) {
    this.d1m_1.f(last(this.d1m_1));
  }
  while (this.d1m_1.o() > (index + 1 | 0)) {
    this.d1m_1.v2(this.d1m_1.o() - 1 | 0);
  }
  var tmp_0 = this.d1m_1.n(index);
  // Inline function 'kotlin.math.max' call
  var tmp_1 = Math.max(0, reps);
  // Inline function 'kotlin.math.max' call
  var tmp$ret$1 = Math.max(0, rir);
  this.d1m_1.f(tmp_0 + model.e19(tmp_1, tmp$ret$1));
};
protoOf(Context).h1m = function (index) {
  var tmp0_safe_receiver = this.c1m_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = this.d1m_1;
    var tmp_0;
    if (0 <= index ? index < this_0.o() : false) {
      tmp_0 = this_0.n(index);
    } else {
      tmp_0 = last(this.d1m_1);
    }
    var tmp$ret$0 = tmp_0;
    tmp = tmp0_safe_receiver.f19(tmp$ret$0);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? 1.0 : tmp1_elvis_lhs;
};
protoOf(Context).i1m = function (effectiveLoad, oneRepMax, setIndex) {
  return this.z1l_1.j1m(effectiveLoad, oneRepMax * this.h1m(setIndex)) - this.a1m_1 * setIndex - this.v1l_1;
};
protoOf(Context).k1m = function (load, reps, rir, position, fatiguingBefore) {
  var rtf = (reps + rir | 0) + this.a1m_1 * position;
  var estimate = this.z1l_1.l1m(load, rtf);
  if (this.t1l_1.u1k_1)
    estimate = OneRepMaxClamp_instance.o1m(estimate, load, reps + rir | 0);
  var tmp0_safe_receiver = this.c1m_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = estimate / tmp0_safe_receiver.f19(fatiguingBefore);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? estimate : tmp1_elvis_lhs;
};
protoOf(Context).p1m = function (effectiveLoad) {
  // Inline function 'kotlin.math.max' call
  var b = gram(Progression_instance, effectiveLoad - this.u1l_1);
  return Math.max(0.0, b);
};
function prior($this, sessions, ctx) {
  var tmp0_elvis_lhs = oneRepMax_0($this, sessions, ctx);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return ctx.t1l_1.p1k_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var prior = tmp;
  var options = ctx.t1l_1;
  var stepped = ctx.s1l_1.equals(ProgressionScheme_STATIC_getInstance()) || ctx.s1l_1.equals(ProgressionScheme_UNDULATING_getInstance()) || ctx.s1l_1.equals(ProgressionScheme_REVERSE_LINEAR_getInstance());
  if (options.w1k_1 <= 0.0 || !stepped || options.s1k_1 > 0 || missedLast($this, sessions, ctx))
    return prior;
  return prior * (1.0 + options.w1k_1 / 100.0);
}
function missedLast($this, sessions, ctx) {
  var tmp0_safe_receiver = lastOrNull(sessions);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = sessionOneRepMax(Progression_instance, tmp0_safe_receiver, ctx);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var last = tmp_0;
  var tmp2_elvis_lhs = oneRepMax_0($this, dropLast_0(sessions, 1), ctx);
  var tmp_1;
  if (tmp2_elvis_lhs == null) {
    return false;
  } else {
    tmp_1 = tmp2_elvis_lhs;
  }
  var before = tmp_1;
  return last < before;
}
function current($this, prior, today, ctx) {
  var options = ctx.t1l_1;
  if (options.v1k_1.equals(SurpriseCarry_NONE_getInstance())) {
    var todayEstimate = sessionOneRepMax($this, today, ctx);
    return prior == null ? todayEstimate : todayEstimate == null ? prior : options.r1k_1 * todayEstimate + (1.0 - options.r1k_1) * prior;
  }
  var estimate = prior;
  var fatigue = 0.0;
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = strengthSets($this, today).j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var position = checkIndexOverflow(_unary__edvuaz);
    var load = item.u18_1 + ctx.u1l_1;
    var tmp0_elvis_lhs = item.w18_1;
    var rir = tmp0_elvis_lhs == null ? ctx.v1l_1 : tmp0_elvis_lhs;
    if (load > 0.0 && item.v18_1 > 0) {
      var fresh = ctx.k1m(load, item.v18_1, rir, position, fatigue);
      var tmp1_safe_receiver = estimate;
      var tmp;
      if (tmp1_safe_receiver == null) {
        tmp = null;
      } else {
        // Inline function 'kotlin.let' call
        var surprise = coerceIn(fresh / tmp1_safe_receiver - 1.0, -0.25, 0.25);
        tmp = tmp1_safe_receiver * (1.0 + options.v1k_1.o19(surprise) * surprise);
      }
      var tmp2_elvis_lhs = tmp;
      estimate = tmp2_elvis_lhs == null ? fresh : tmp2_elvis_lhs;
    }
    var tmp3_safe_receiver = ctx.c1m_1;
    if (tmp3_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      var tmp_0 = fatigue;
      // Inline function 'kotlin.math.max' call
      var b = item.v18_1;
      var tmp_1 = Math.max(0, b);
      // Inline function 'kotlin.math.max' call
      var tmp$ret$7 = Math.max(0, rir);
      fatigue = tmp_0 + tmp3_safe_receiver.e19(tmp_1, tmp$ret$7);
    }
  }
  return estimate;
}
function Choice(load, reps, outside, issue) {
  this.q1m_1 = load;
  this.r1m_1 = reps;
  this.s1m_1 = outside;
  this.t1m_1 = issue;
}
protoOf(Choice).u1m = function (index, ctx) {
  return new PlannedSet(index, ctx.p1m(this.q1m_1), this.r1m_1, ctx.v1l_1, ctx.e1m(index), false, this.s1m_1);
};
function freshPlan($this, ctx, loads, oneRepMax, sessions) {
  var last = lastOrNull(sessions);
  var tmp;
  if (last == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = topLoad(Progression_instance, last, ctx);
  }
  var lastLoad = tmp;
  ctx.f1m();
  var first = nudge($this, capReps($this, firstSet($this, ctx, loads, oneRepMax, sessions), 0, last, ctx), 0, last, ctx);
  var plan = ArrayList_init_$Create$_0();
  plan.f(first.u1m(0, ctx));
  ctx.g1m(0, first.r1m_1, ctx.v1l_1);
  var previous = first.q1m_1;
  var inductionVariable = 1;
  var last_0 = ctx.r1l_1.b1f_1;
  if (inductionVariable < last_0)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var choice = nudge($this, capReps($this, laterSet($this, ctx, loads, oneRepMax, i, previous, first.r1m_1), i, last, ctx), i, last, ctx);
      plan.f(choice.u1m(i, ctx));
      ctx.g1m(i, choice.r1m_1, ctx.v1l_1);
      previous = choice.q1m_1;
    }
     while (inductionVariable < last_0);
  var warning = !first.t1m_1.equals(TargetIssue_NONE_getInstance());
  return new ExerciseTargets(plan, oneRepMax, first.t1m_1, warning, warning ? alternatives($this, ctx, loads, oneRepMax, 0, lastLoad) : emptyList(), false);
}
function firstSet($this, ctx, loads, oneRepMax, sessions) {
  var tmp0_elvis_lhs = lastOrNull(sessions);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return smart($this, ctx, loads, oneRepMax, 0, null);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var last = tmp;
  var lastLoad = topLoad($this, last, ctx);
  var tmp1_elvis_lhs = Loads_instance.q1c(loads, lastLoad);
  var anchor = tmp1_elvis_lhs == null ? lastLoad : tmp1_elvis_lhs;
  var tmp_0;
  switch (ctx.s1l_1.x1_1) {
    case 0:
      var reps = round_0($this, ctx.i1m(anchor, oneRepMax, 0));
      // Inline function 'kotlin.collections.filter' call

      var tmp0 = strengthSets($this, last);
      // Inline function 'kotlin.collections.filterTo' call

      var destination = ArrayList_init_$Create$_0();
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        // Inline function 'kotlin.math.abs' call
        var x = element.u18_1 + ctx.u1l_1 - anchor;
        if (Math.abs(x) < 1.0E-9) {
          destination.f(element);
        }
      }

      var atAnchor = destination;
      var tmp_1;
      // Inline function 'kotlin.collections.isNotEmpty' call

      if (!atAnchor.m()) {
        var tmp$ret$5;
        $l$block_0: {
          // Inline function 'kotlin.collections.all' call
          var tmp_2;
          if (isInterface(atAnchor, Collection)) {
            tmp_2 = atAnchor.m();
          } else {
            tmp_2 = false;
          }
          if (tmp_2) {
            tmp$ret$5 = true;
            break $l$block_0;
          }
          var _iterator__ex2g4s_0 = atAnchor.j();
          while (_iterator__ex2g4s_0.k()) {
            var element_0 = _iterator__ex2g4s_0.l();
            if (!(element_0.v18_1 >= ctx.x1l_1)) {
              tmp$ret$5 = false;
              break $l$block_0;
            }
          }
          tmp$ret$5 = true;
        }
        tmp_1 = tmp$ret$5;
      } else {
        tmp_1 = false;
      }

      var hitTop = tmp_1;
      var tmp_3;
      if (reps > ctx.x1l_1 || hitTop) {
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var destination_0 = ArrayList_init_$Create$_0();
        var _iterator__ex2g4s_1 = loads.j();
        while (_iterator__ex2g4s_1.k()) {
          var element_1 = _iterator__ex2g4s_1.l();
          if (element_1 > anchor + 1.0E-9) {
            destination_0.f(element_1);
          }
        }
        var tmp$ret$10;
        $l$block_1: {
          // Inline function 'kotlin.collections.firstOrNull' call
          var _iterator__ex2g4s_2 = destination_0.j();
          while (_iterator__ex2g4s_2.k()) {
            var element_2 = _iterator__ex2g4s_2.l();
            if (round_0(Progression_instance, ctx.i1m(element_2, oneRepMax, 0)) >= ctx.w1l_1) {
              tmp$ret$10 = element_2;
              break $l$block_1;
            }
          }
          tmp$ret$10 = null;
        }
        var up = tmp$ret$10;
        var tmp_4;
        if (!(up == null)) {
          tmp_4 = new Choice(up, coerceIn_0(round_0($this, ctx.i1m(up, oneRepMax, 0)), ctx.w1l_1, ctx.x1l_1), false, TargetIssue_NONE_getInstance());
        } else if (ctx.t1l_1.g1k_1) {
          var tmp3_safe_receiver = firstOrNull(atAnchor);
          var tmp4_elvis_lhs = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.v18_1;
          // Inline function 'kotlin.math.max' call
          var b = (tmp4_elvis_lhs == null ? reps : tmp4_elvis_lhs) + 1 | 0;
          var tmp0_0 = Math.max(reps, b);
          // Inline function 'kotlin.math.min' call
          var b_0 = ctx.x1l_1 + ctx.t1l_1.h1k_1 | 0;
          var expanded = Math.min(tmp0_0, b_0);
          tmp_4 = new Choice(anchor, expanded, expanded > ctx.x1l_1, expanded > ctx.x1l_1 ? TargetIssue_OUTSIDE_REP_RANGE_getInstance() : TargetIssue_NONE_getInstance());
        } else {
          tmp_4 = new Choice(anchor, ctx.x1l_1, false, TargetIssue_NO_FEASIBLE_TARGET_getInstance());
        }
        tmp_3 = tmp_4;
      } else if (reps >= ctx.w1l_1) {
        tmp_3 = new Choice(anchor, reps, false, TargetIssue_NONE_getInstance());
      } else {
        tmp_3 = smart($this, ctx, loads, oneRepMax, 0, anchor);
      }

      tmp_0 = tmp_3;
      break;
    case 1:
      var success = linearSuccess($this, last, lastLoad, ctx);
      var previous = getOrNull_0(sessions, sessions.o() - 2 | 0);
      var tmp_5;
      var tmp_6;
      if (!success && !(previous == null)) {
        // Inline function 'kotlin.math.abs' call
        var x_0 = topLoad($this, previous, ctx) - lastLoad;
        tmp_6 = Math.abs(x_0) < 1.0E-9;
      } else {
        tmp_6 = false;
      }

      if (tmp_6) {
        tmp_5 = !linearSuccess($this, previous, lastLoad, ctx);
      } else {
        tmp_5 = false;
      }

      var missedTwice = tmp_5;
      var tmp_7;
      if (success) {
        var tmp5_elvis_lhs = Loads_instance.s1c(loads, lastLoad);
        tmp_7 = tmp5_elvis_lhs == null ? lastLoad : tmp5_elvis_lhs;
      } else if (missedTwice) {
        var tmp6_elvis_lhs = Loads_instance.q1c(loads, lastLoad * (1.0 - ctx.t1l_1.t1k_1 / 100.0));
        tmp_7 = tmp6_elvis_lhs == null ? lastLoad : tmp6_elvis_lhs;
      } else {
        tmp_7 = anchor;
      }

      var load = tmp_7;
      var reps_0 = round_0($this, ctx.i1m(load, oneRepMax, 0));
      var tmp_8;
      if (reps_0 < ctx.w1l_1) {
        // Inline function 'kotlin.math.max' call
        var tmp$ret$15 = Math.max(1, reps_0);
        tmp_8 = new Choice(load, tmp$ret$15, true, TargetIssue_OUTSIDE_REP_RANGE_getInstance());
      } else {
        // Inline function 'kotlin.math.min' call
        var b_1 = ctx.x1l_1;
        var tmp$ret$16 = Math.min(reps_0, b_1);
        tmp_8 = new Choice(load, tmp$ret$16, false, TargetIssue_NONE_getInstance());
      }

      tmp_0 = tmp_8;
      break;
    case 4:
    case 2:
    case 3:
      var reps_1 = round_0($this, ctx.i1m(anchor, oneRepMax, 0));
      var tmp_9;
      var tmp_10;
      if (ctx.t1l_1.i1k_1) {
        var containsLower = ctx.w1l_1;
        tmp_10 = reps_1 <= ctx.x1l_1 ? containsLower <= reps_1 : false;
      } else {
        tmp_10 = false;
      }

      if (tmp_10) {
        tmp_9 = new Choice(anchor, reps_1, false, TargetIssue_NONE_getInstance());
      } else {
        tmp_9 = smart($this, ctx, loads, oneRepMax, 0, anchor);
      }

      tmp_0 = tmp_9;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp_0;
}
function laterSet($this, ctx, loads, oneRepMax, index, previousLoad, plannedReps) {
  switch (ctx.r1l_1.f1f_1.x1_1) {
    case 2:
      var tmp1_elvis_lhs = Loads_instance.p1c(loads, previousLoad * 0.8, LoadRounding_DOWN_getInstance());
      var load = tmp1_elvis_lhs == null ? previousLoad : tmp1_elvis_lhs;
      // Inline function 'kotlin.math.max' call

      var b = round_0($this, ctx.i1m(load, oneRepMax, index));
      var tmp$ret$0 = Math.max(1, b);
      return new Choice(load, tmp$ret$0, false, TargetIssue_NONE_getInstance());
    case 3:
      // Inline function 'kotlin.math.max' call

      var b_0 = round_0($this, plannedReps * 0.3);
      var tmp$ret$1 = Math.max(3, b_0);
      return new Choice(previousLoad, tmp$ret$1, false, TargetIssue_NONE_getInstance());
    default:
      break;
  }
  var tmp;
  if (ctx.s1l_1.equals(ProgressionScheme_LINEAR_getInstance())) {
    var tmp$ret$2;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(loads, Collection)) {
        tmp_0 = loads.m();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = loads.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        // Inline function 'kotlin.math.abs' call
        var x = element - previousLoad;
        if (Math.abs(x) < 1.0E-9) {
          tmp$ret$2 = true;
          break $l$block_0;
        }
      }
      tmp$ret$2 = false;
    }
    tmp = tmp$ret$2;
  } else {
    tmp = false;
  }
  if (tmp) {
    // Inline function 'kotlin.math.max' call
    var b_1 = round_0($this, ctx.i1m(previousLoad, oneRepMax, index) + ctx.v1l_1);
    // Inline function 'kotlin.math.min' call
    var b_2 = Math.max(1, b_1);
    var reps = Math.min(plannedReps, b_2);
    var containsLower = ctx.w1l_1;
    return new Choice(previousLoad, reps, !(reps <= ctx.x1l_1 ? containsLower <= reps : false), TargetIssue_NONE_getInstance());
  }
  var range = numberRangeToNumber(ctx.w1l_1, ctx.x1l_1);
  if (ctx.t1l_1.f1k_1.equals(AdjustmentPriority_WEIGHT_FIRST_getInstance())) {
    // Inline function 'kotlin.comparisons.compareBy' call
    var tmp_1 = Progression$laterSet$lambda(ctx, oneRepMax, index, plannedReps);
    // Inline function 'kotlin.comparisons.thenBy' call
    var this_0 = new sam$kotlin_Comparator$0_10(tmp_1);
    var tmp_2 = Progression$laterSet$lambda_0(this_0, previousLoad);
    // Inline function 'kotlin.comparisons.thenByDescending' call
    var this_1 = new sam$kotlin_Comparator$0_10(tmp_2);
    var tmp_3 = Progression$laterSet$lambda_1(this_1);
    var tmp$ret$9 = new sam$kotlin_Comparator$0_10(tmp_3);
    var best = minWithOrNull(loads, tmp$ret$9);
    if (!(best == null)) {
      var reps_0 = round_0($this, ctx.i1m(best, oneRepMax, index));
      var containsLower_0 = range.oc_1;
      if (reps_0 <= range.pc_1 ? containsLower_0 <= reps_0 : false)
        return new Choice(best, reps_0, false, TargetIssue_NONE_getInstance());
    }
  } else {
    var reps_1 = round_0($this, ctx.i1m(previousLoad, oneRepMax, index));
    var tmp_4;
    var containsLower_1 = range.oc_1;
    if (reps_1 <= range.pc_1 ? containsLower_1 <= reps_1 : false) {
      var tmp$ret$10;
      $l$block_2: {
        // Inline function 'kotlin.collections.any' call
        var tmp_5;
        if (isInterface(loads, Collection)) {
          tmp_5 = loads.m();
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          tmp$ret$10 = false;
          break $l$block_2;
        }
        var _iterator__ex2g4s_0 = loads.j();
        while (_iterator__ex2g4s_0.k()) {
          var element_0 = _iterator__ex2g4s_0.l();
          // Inline function 'kotlin.math.abs' call
          var x_0 = element_0 - previousLoad;
          if (Math.abs(x_0) < 1.0E-9) {
            tmp$ret$10 = true;
            break $l$block_2;
          }
        }
        tmp$ret$10 = false;
      }
      tmp_4 = tmp$ret$10;
    } else {
      tmp_4 = false;
    }
    if (tmp_4)
      return new Choice(previousLoad, reps_1, false, TargetIssue_NONE_getInstance());
  }
  return smart($this, ctx, loads, oneRepMax, index, previousLoad);
}
function smart($this, ctx, loads, oneRepMax, index, previousLoad) {
  var options = ctx.t1l_1;
  var target = Strength_instance.v1m(oneRepMax, loads, ctx.w1l_1, ctx.x1l_1, ctx.v1l_1, index, ctx.a1m_1, options.i1k_1 ? previousLoad : null, VOID, options.g1k_1, options.h1k_1, ctx.z1l_1, ctx.h1m(index));
  if (!(target == null)) {
    return new Choice(target.w1m_1, target.x1m_1, target.y1m_1, target.y1m_1 ? TargetIssue_OUTSIDE_REP_RANGE_getInstance() : TargetIssue_NONE_getInstance());
  }
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.minBy' call
    var iterator = loads.j();
    if (!iterator.k())
      throw NoSuchElementException_init_$Create$_0();
    var minElem = iterator.l();
    if (!iterator.k()) {
      tmp$ret$0 = minElem;
      break $l$block;
    }
    var it = minElem;
    // Inline function 'kotlin.math.abs' call
    var x = ctx.i1m(it, oneRepMax, index) - ctx.y1l_1;
    var minValue = Math.abs(x);
    do {
      var e = iterator.l();
      // Inline function 'kotlin.math.abs' call
      var x_0 = ctx.i1m(e, oneRepMax, index) - ctx.y1l_1;
      var v = Math.abs(x_0);
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.k());
    tmp$ret$0 = minElem;
  }
  var closest = tmp$ret$0;
  // Inline function 'kotlin.math.max' call
  var b = round_0($this, ctx.i1m(closest, oneRepMax, index));
  var tmp$ret$5 = Math.max(1, b);
  return new Choice(closest, tmp$ret$5, true, TargetIssue_NO_FEASIBLE_TARGET_getInstance());
}
function alternatives($this, ctx, loads, oneRepMax, index, previousLoad) {
  var options = ctx.t1l_1;
  var ideal = ctx.z1l_1.z1m(oneRepMax * ctx.h1m(index), ctx.y1l_1 + ctx.v1l_1 + ctx.a1m_1 * index);
  var result = ArrayList_init_$Create$_0();
  var tmp = AlternativeKind_NEXT_LOAD_UP_getInstance();
  var tmp0_safe_receiver = Loads_instance.p1c(loads, ideal, LoadRounding_UP_getInstance());
  var tmp_0;
  if (tmp0_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_1;
    if (tmp0_safe_receiver >= ideal - 1.0E-9) {
      tmp_1 = tmp0_safe_receiver;
    } else {
      tmp_1 = null;
    }
    tmp_0 = tmp_1;
  }
  alternatives$add(ctx, oneRepMax, index, result, tmp, tmp_0);
  var tmp_2 = AlternativeKind_NEXT_LOAD_DOWN_getInstance();
  var tmp1_safe_receiver = Loads_instance.p1c(loads, ideal, LoadRounding_DOWN_getInstance());
  var tmp_3;
  if (tmp1_safe_receiver == null) {
    tmp_3 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_4;
    if (tmp1_safe_receiver <= ideal + 1.0E-9) {
      tmp_4 = tmp1_safe_receiver;
    } else {
      tmp_4 = null;
    }
    tmp_3 = tmp_4;
  }
  alternatives$add(ctx, oneRepMax, index, result, tmp_2, tmp_3);
  var tmp2_safe_receiver = Strength_instance.v1m(oneRepMax, loads, ctx.w1l_1, ctx.x1l_1, ctx.v1l_1, index, ctx.a1m_1, previousLoad, VOID, true, options.h1k_1, ctx.z1l_1, ctx.h1m(index));
  var tmp_5;
  if (tmp2_safe_receiver == null) {
    tmp_5 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_6;
    if (tmp2_safe_receiver.y1m_1) {
      tmp_6 = tmp2_safe_receiver;
    } else {
      tmp_6 = null;
    }
    tmp_5 = tmp_6;
  }
  var tmp3_safe_receiver = tmp_5;
  if (tmp3_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    alternatives$add(ctx, oneRepMax, index, result, AlternativeKind_EXPAND_REP_RANGE_getInstance(), tmp3_safe_receiver.w1m_1);
  }
  var tmp_7;
  if (!(previousLoad == null)) {
    var tmp$ret$8;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var tmp_8;
      if (isInterface(loads, Collection)) {
        tmp_8 = loads.m();
      } else {
        tmp_8 = false;
      }
      if (tmp_8) {
        tmp$ret$8 = false;
        break $l$block_0;
      }
      var _iterator__ex2g4s = loads.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        // Inline function 'kotlin.math.abs' call
        var x = element - previousLoad;
        if (Math.abs(x) < 1.0E-9) {
          tmp$ret$8 = true;
          break $l$block_0;
        }
      }
      tmp$ret$8 = false;
    }
    tmp_7 = tmp$ret$8;
  } else {
    tmp_7 = false;
  }
  if (tmp_7) {
    alternatives$add(ctx, oneRepMax, index, result, AlternativeKind_WEIGHT_MATCH_getInstance(), previousLoad);
  }
  return result;
}
function capReps($this, choice, index, last, ctx) {
  var tmp1_elvis_lhs = last == null ? null : getOrNull_0(last, index);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return choice;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var lastSet = tmp;
  // Inline function 'kotlin.math.abs' call
  var x = lastSet.u18_1 + ctx.u1l_1 - choice.q1m_1;
  if (Math.abs(x) > 1.0E-9)
    return choice;
  var tmp0 = choice.r1m_1;
  // Inline function 'kotlin.math.min' call
  var b = lastSet.v18_1 + ctx.t1l_1.m1k_1 | 0;
  var reps = Math.min(tmp0, b);
  if (reps === choice.r1m_1)
    return choice;
  var containsLower = ctx.w1l_1;
  return new Choice(choice.q1m_1, reps, !(reps <= ctx.x1l_1 ? containsLower <= reps : false), choice.t1m_1);
}
function nudge($this, choice, index, last, ctx) {
  if (!ctx.s1l_1.equals(ProgressionScheme_DOUBLE_getInstance()) || choice.s1m_1)
    return choice;
  var tmp1_elvis_lhs = last == null ? null : getOrNull_0(last, index);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return choice;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var lastSet = tmp;
  // Inline function 'kotlin.math.abs' call
  var x = lastSet.u18_1 + ctx.u1l_1 - choice.q1m_1;
  if (Math.abs(x) > 1.0E-9)
    return choice;
  var tmp2_elvis_lhs = lastSet.w18_1;
  if ((tmp2_elvis_lhs == null ? ctx.v1l_1 : tmp2_elvis_lhs) < ctx.v1l_1)
    return choice;
  var tmp0 = ctx.x1l_1;
  var tmp0_0 = choice.r1m_1;
  var tmp0_1 = lastSet.v18_1 + 1 | 0;
  // Inline function 'kotlin.math.min' call
  var b = choice.r1m_1 + 1 | 0;
  // Inline function 'kotlin.math.max' call
  var b_0 = Math.min(tmp0_1, b);
  // Inline function 'kotlin.math.min' call
  var b_1 = Math.max(tmp0_0, b_0);
  var reps = Math.min(tmp0, b_1);
  return reps === choice.r1m_1 ? choice : new Choice(choice.q1m_1, reps, false, choice.t1m_1);
}
function capLoads($this, loads, lastLoad, maxIncreasePct) {
  var tmp0 = lastLoad * (1.0 + maxIncreasePct / 100.0);
  var tmp0_elvis_lhs = Loads_instance.s1c(loads, lastLoad);
  // Inline function 'kotlin.math.max' call
  var b = tmp0_elvis_lhs == null ? lastLoad : tmp0_elvis_lhs;
  var limit = Math.max(tmp0, b);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = loads.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element <= limit + 1.0E-9) {
      destination.f(element);
    }
  }
  return destination;
}
function linearSuccess($this, session, load, ctx) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = session.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.math.abs' call
    var x = element.u18_1 + ctx.u1l_1 - load;
    if (Math.abs(x) < 1.0E-9) {
      destination.f(element);
    }
  }
  var atLoad = destination;
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!atLoad.m()) {
    var tmp$ret$5;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp_0;
      if (isInterface(atLoad, Collection)) {
        tmp_0 = atLoad.m();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$5 = true;
        break $l$block_0;
      }
      var _iterator__ex2g4s_0 = atLoad.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        if (!(element_0.v18_1 >= ctx.w1l_1)) {
          tmp$ret$5 = false;
          break $l$block_0;
        }
      }
      tmp$ret$5 = true;
    }
    tmp = tmp$ret$5;
  } else {
    tmp = false;
  }
  return tmp;
}
function repsOnly($this, ctx, sessions, today) {
  var options = ctx.t1l_1;
  var prior = null;
  var _iterator__ex2g4s = sessions.j();
  $l$loop: while (_iterator__ex2g4s.k()) {
    var session = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = repsOnly$sessionRtf(ctx, session);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var rtf = tmp;
    var tmp1_safe_receiver = prior;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = options.q1k_1 * rtf + (1.0 - options.q1k_1) * tmp1_safe_receiver;
    }
    var tmp2_elvis_lhs = tmp_0;
    prior = tmp2_elvis_lhs == null ? rtf : tmp2_elvis_lhs;
  }
  var todayRtf = repsOnly$sessionRtf(ctx, today);
  var current = prior == null ? todayRtf : todayRtf == null ? prior : options.r1k_1 * todayRtf + (1.0 - options.r1k_1) * prior;
  var tmp3_elvis_lhs = lastOrNull(today);
  var tmp_1;
  if (tmp3_elvis_lhs == null) {
    var tmp4_safe_receiver = lastOrNull(sessions);
    tmp_1 = tmp4_safe_receiver == null ? null : lastOrNull(tmp4_safe_receiver);
  } else {
    tmp_1 = tmp3_elvis_lhs;
  }
  var tmp5_safe_receiver = tmp_1;
  var tmp6_elvis_lhs = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.u18_1;
  var load = tmp6_elvis_lhs == null ? 0.0 : tmp6_elvis_lhs;
  var last = lastOrNull(sessions);
  var planned = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s_0 = today.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var i = checkIndexOverflow(_unary__edvuaz);
    planned.f(doneSet(Progression_instance, i, item, ctx));
  }
  var ceiling = ctx.x1l_1 + (options.g1k_1 ? options.h1k_1 : 0) | 0;
  var inductionVariable = today.o();
  var last_0 = ctx.r1l_1.b1f_1;
  if (inductionVariable < last_0)
    do {
      var i_0 = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_2;
      if (current == null) {
        // Inline function 'kotlin.math.floor' call
        var x = ctx.y1l_1;
        var tmp$ret$4 = Math.floor(x);
        tmp_2 = numberToInt(tmp$ret$4);
      } else {
        tmp_2 = round_0($this, current - ctx.b1m_1 * i_0 - ctx.v1l_1);
      }
      var reps = tmp_2;
      if (today.m()) {
        var tmp8_safe_receiver = last == null ? null : getOrNull_0(last, i_0);
        if (tmp8_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp0 = reps;
          // Inline function 'kotlin.math.min' call
          var b = tmp8_safe_receiver.v18_1 + options.m1k_1 | 0;
          reps = Math.min(tmp0, b);
        }
      }
      reps = coerceIn_0(reps, 1, ceiling);
      planned.f(new PlannedSet(i_0, load, reps, ctx.v1l_1, ctx.e1m(i_0), false, reps > ctx.x1l_1 || reps < ctx.w1l_1));
    }
     while (inductionVariable < last_0);
  return new ExerciseTargets(planned, null, current == null ? TargetIssue_NO_HISTORY_getInstance() : TargetIssue_NO_LOADS_getInstance(), false, emptyList(), progressed($this, sessions, ctx));
}
function doneSet($this, index, set, ctx) {
  var tmp0_elvis_lhs = set.w18_1;
  var tmp = tmp0_elvis_lhs == null ? ctx.v1l_1 : tmp0_elvis_lhs;
  var containsLower = ctx.w1l_1;
  var containsUpper = ctx.x1l_1;
  var containsArg = set.v18_1;
  return new PlannedSet(index, set.u18_1, set.v18_1, tmp, set.x18_1, true, !(containsLower <= containsArg ? containsArg <= containsUpper : false));
}
function sessions($this, sets) {
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = element.y18_1;
    var key = tmp0_elvis_lhs == null ? 'day:' + element.t18_1 : tmp0_elvis_lhs;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.s1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.k2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element);
  }
  var tmp_0 = destination.u1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_1 = Progression$sessions$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_11(tmp_1);
  var tmp_2 = Progression$sessions$lambda_0(this_0);
  var tmp$ret$6 = new sam$kotlin_Comparator$0_11(tmp_2);
  return sortedWith(tmp_0, tmp$ret$6);
}
function strengthSets($this, session) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = session.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.x18_1.equals(SetType_STANDARD_getInstance()) || element.x18_1.equals(SetType_FAILURE_getInstance())) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp;
  if (destination.m()) {
    tmp = session;
  } else {
    tmp = destination;
  }
  return tmp;
}
function sessionOneRepMax($this, session, ctx) {
  var weighted = 0.0;
  var total = 0.0;
  var fatigue = 0.0;
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = strengthSets($this, session).j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var tmp0 = checkIndexOverflow(_unary__edvuaz);
    $l$block: {
      var load = item.u18_1 + ctx.u1l_1;
      var tmp0_elvis_lhs = item.w18_1;
      var rir = tmp0_elvis_lhs == null ? ctx.v1l_1 : tmp0_elvis_lhs;
      var before = fatigue;
      var tmp1_safe_receiver = ctx.c1m_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        var tmp = fatigue;
        // Inline function 'kotlin.math.max' call
        var b = item.v18_1;
        var tmp_0 = Math.max(0, b);
        // Inline function 'kotlin.math.max' call
        var tmp$ret$5 = Math.max(0, rir);
        fatigue = tmp + tmp1_safe_receiver.e19(tmp_0, tmp$ret$5);
      }
      if (load <= 0.0 || item.v18_1 <= 0) {
        break $l$block;
      }
      var estimate = ctx.k1m(load, item.v18_1, rir, tmp0, before);
      var weight = rir <= 3 ? 1.0 : rir <= 5 ? 0.5 : 0.25;
      weighted = weighted + estimate * weight;
      total = total + weight;
    }
  }
  return total > 0.0 ? weighted / total : null;
}
function oneRepMax_0($this, sessions, ctx) {
  var estimate = null;
  var _iterator__ex2g4s = sessions.j();
  $l$loop: while (_iterator__ex2g4s.k()) {
    var session = _iterator__ex2g4s.l();
    var tmp0_elvis_lhs = sessionOneRepMax($this, session, ctx);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var value = tmp;
    var tmp1_safe_receiver = estimate;
    var tmp_0;
    if (tmp1_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = ctx.t1l_1.q1k_1 * value + (1.0 - ctx.t1l_1.q1k_1) * tmp1_safe_receiver;
    }
    var tmp2_elvis_lhs = tmp_0;
    estimate = tmp2_elvis_lhs == null ? value : tmp2_elvis_lhs;
  }
  return estimate;
}
function topLoad($this, session, ctx) {
  // Inline function 'kotlin.collections.maxOf' call
  var iterator = strengthSets($this, session).j();
  if (!iterator.k())
    throw NoSuchElementException_init_$Create$_0();
  var maxValue = iterator.l().u18_1;
  while (iterator.k()) {
    var v = iterator.l().u18_1;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = maxValue;
    maxValue = Math.max(a, v);
  }
  var tmp$ret$0 = maxValue;
  return gram($this, tmp$ret$0 + ctx.u1l_1);
}
function progressed($this, sessions, ctx) {
  var tmp0_safe_receiver = lastOrNull(sessions);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = firstOrNull(strengthSets(Progression_instance, tmp0_safe_receiver));
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return false;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var last = tmp_0;
  var tmp0 = asReversed(dropLast_0(sessions, 1));
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstNotNullOfOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      var tmp$ret$4;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s_0 = element.j();
        while (_iterator__ex2g4s_0.k()) {
          var element_0 = _iterator__ex2g4s_0.l();
          // Inline function 'kotlin.math.abs' call
          var x = element_0.u18_1 - last.u18_1;
          if (Math.abs(x) < 1.0E-9) {
            tmp$ret$4 = element_0;
            break $l$block;
          }
        }
        tmp$ret$4 = null;
      }
      var result = tmp$ret$4;
      if (!(result == null)) {
        tmp$ret$2 = result;
        break $l$block_0;
      }
    }
    tmp$ret$2 = null;
  }
  var previousAtLoad = tmp$ret$2;
  var tmp_1 = Strength_instance;
  // Inline function 'kotlin.math.max' call
  var b = last.u18_1;
  var tmp_2 = Math.max(0.0, b);
  // Inline function 'kotlin.math.max' call
  var b_0 = last.v18_1;
  var tmp_3 = Math.max(1, b_0);
  var tmp2_elvis_lhs = last.w18_1;
  var tmp_4 = new LoggedSet(tmp_2, tmp_3, tmp2_elvis_lhs == null ? ctx.v1l_1 : tmp2_elvis_lhs);
  return tmp_1.a1n(tmp_4, ctx.w1l_1, ctx.x1l_1, ctx.v1l_1, previousAtLoad == null ? null : previousAtLoad.v18_1);
}
function round_0($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0);
}
function round1000($this, value) {
  return numberToLong(round(value * 1000.0));
}
function gram($this, value) {
  return Loads_instance.d1c(value);
}
function sam$kotlin_Comparator$0_10(function_0) {
  this.b1n_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_10).y9 = function (a, b) {
  return this.b1n_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_10).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_10).g2 = function () {
  return this.b1n_1;
};
protoOf(sam$kotlin_Comparator$0_10).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_10).hashCode = function () {
  return hashCode(this.g2());
};
function sam$kotlin_Comparator$0_11(function_0) {
  this.c1n_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_11).y9 = function (a, b) {
  return this.c1n_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_11).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_11).g2 = function () {
  return this.c1n_1;
};
protoOf(sam$kotlin_Comparator$0_11).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_11).hashCode = function () {
  return hashCode(this.g2());
};
function Progression$laterSet$lambda($ctx, $oneRepMax, $index, $plannedReps) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    var tmp = Progression_instance;
    // Inline function 'kotlin.math.abs' call
    var x = $ctx.i1m(a, $oneRepMax, $index) - $plannedReps;
    var tmp$ret$2 = Math.abs(x);
    var tmp_0 = round1000(tmp, tmp$ret$2);
    var tmp_1 = Progression_instance;
    // Inline function 'kotlin.math.abs' call
    var x_0 = $ctx.i1m(b, $oneRepMax, $index) - $plannedReps;
    var tmp$ret$4 = Math.abs(x_0);
    var tmp$ret$3 = round1000(tmp_1, tmp$ret$4);
    return compareValues(tmp_0, tmp$ret$3);
  };
}
function Progression$laterSet$lambda_0($this, $previousLoad) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0;
      // Inline function 'kotlin.math.abs' call
      var x = a - $previousLoad;
      if (Math.abs(x) < 1.0E-9) {
        tmp_0 = 0;
      } else {
        tmp_0 = 1;
      }
      var tmp_1 = tmp_0;
      var tmp_2;
      // Inline function 'kotlin.math.abs' call
      var x_0 = b - $previousLoad;
      if (Math.abs(x_0) < 1.0E-9) {
        tmp_2 = 0;
      } else {
        tmp_2 = 1;
      }
      var tmp$ret$3 = tmp_2;
      tmp = compareValues(tmp_1, tmp$ret$3);
    }
    return tmp;
  };
}
function Progression$laterSet$lambda_1($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = b;
      tmp = compareValues(tmp_0, a);
    }
    return tmp;
  };
}
function alternatives$add($ctx, $oneRepMax, $index, result, kind, load) {
  if (load == null)
    return Unit_instance;
  var reps = round_0(Progression_instance, $ctx.i1m(load, $oneRepMax, $index));
  if (reps < 1)
    return Unit_instance;
  var alternative = new TargetAlternative(kind, $ctx.p1m(load), reps);
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.none' call
    var tmp;
    if (isInterface(result, Collection)) {
      tmp = result.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = result.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      var tmp_0;
      // Inline function 'kotlin.math.abs' call
      var x = element.a1l_1 - alternative.a1l_1;
      if (Math.abs(x) < 1.0E-9) {
        tmp_0 = element.b1l_1 === alternative.b1l_1;
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  if (tmp$ret$0) {
    result.f(alternative);
  }
}
function repsOnly$sessionRtf($ctx, sets) {
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(sets, 10));
  var index = 0;
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var i = checkIndexOverflow(_unary__edvuaz);
    var tmp0_elvis_lhs = item.w18_1;
    var tmp$ret$2 = (item.v18_1 + (tmp0_elvis_lhs == null ? $ctx.v1l_1 : tmp0_elvis_lhs) | 0) + $ctx.b1m_1 * i;
    destination.f(tmp$ret$2);
  }
  return maxOrNull(destination);
}
function Progression$sessions$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'kotlin.collections.minOf' call
  var iterator = a.j();
  if (!iterator.k())
    throw NoSuchElementException_init_$Create$_0();
  var minValue = iterator.l().t18_1;
  while (iterator.k()) {
    var v = iterator.l().t18_1;
    if (compareTo(minValue, v) > 0) {
      minValue = v;
    }
  }
  var tmp = minValue;
  // Inline function 'kotlin.collections.minOf' call
  var iterator_0 = b.j();
  if (!iterator_0.k())
    throw NoSuchElementException_init_$Create$_0();
  var minValue_0 = iterator_0.l().t18_1;
  while (iterator_0.k()) {
    var v_0 = iterator_0.l().t18_1;
    if (compareTo(minValue_0, v_0) > 0) {
      minValue_0 = v_0;
    }
  }
  var tmp$ret$5 = minValue_0;
  return compareValues(tmp, tmp$ret$5);
}
function Progression$sessions$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp0_elvis_lhs = first(a).y18_1;
      var tmp_0 = tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
      var tmp0_elvis_lhs_0 = first(b).y18_1;
      var tmp$ret$2 = tmp0_elvis_lhs_0 == null ? '' : tmp0_elvis_lhs_0;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function Progression() {
  this.d1n_1 = 0.8;
  this.e1n_1 = 0.3;
  this.f1n_1 = 3;
}
protoOf(Progression).g1n = function (prescription, scheme, loads, history, doneToday, options) {
  // Inline function 'kotlin.require' call
  if (!(options.p1k_1 == null || options.p1k_1 > 0.0)) {
    var message = 'startingOneRepMaxKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var ctx = new Context(prescription, scheme, options);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = history.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!element.x18_1.equals(SetType_WARMUP_getInstance())) {
      destination.f(element);
    }
  }
  var sessions_0 = sessions(this, destination);
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = doneToday.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (!element_0.x18_1.equals(SetType_WARMUP_getInstance())) {
      destination_0.f(element_0);
    }
  }
  var today = destination_0;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_1 = loads.j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    if (element_1 >= 0.0) {
      destination_1.f(element_1);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(destination_1, 10));
  var _iterator__ex2g4s_2 = destination_1.j();
  while (_iterator__ex2g4s_2.k()) {
    var item = _iterator__ex2g4s_2.l();
    var tmp$ret$13 = gram(Progression_instance, item + ctx.u1l_1);
    destination_2.f(tmp$ret$13);
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_3 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_3 = destination_2.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_2 = _iterator__ex2g4s_3.l();
    if (element_2 > 0.0) {
      destination_3.f(element_2);
    }
  }
  var effectiveLoads = sorted(distinct(destination_3));
  var tmp0 = plus(flatten(sessions_0), today);
  var tmp$ret$17;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$17 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s_4 = tmp0.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_3 = _iterator__ex2g4s_4.l();
      if (element_3.u18_1 + ctx.u1l_1 > 0.0) {
        tmp$ret$17 = true;
        break $l$block_0;
      }
    }
    tmp$ret$17 = false;
  }
  var loggedLoad = tmp$ret$17;
  var tmp_0;
  var tmp_1;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!effectiveLoads.m()) {
    tmp_1 = true;
  } else {
    tmp_1 = ctx.u1l_1 > 0.0;
  }
  if (tmp_1) {
    tmp_0 = loggedLoad || (sessions_0.m() && today.m());
  } else {
    tmp_0 = false;
  }
  var loadBased = tmp_0;
  if (!loadBased)
    return repsOnly(this, ctx, sessions_0, today);
  // Inline function 'kotlin.collections.ifEmpty' call
  var tmp_2;
  if (effectiveLoads.m()) {
    tmp_2 = listOf_0(gram(Progression_instance, ctx.u1l_1));
  } else {
    tmp_2 = effectiveLoads;
  }
  var feasible = tmp_2;
  var prior_0 = prior(this, sessions_0, ctx);
  var current_0 = current(this, prior_0, today, ctx);
  var progressed_0 = progressed(this, sessions_0, ctx);
  if (current_0 == null) {
    // Inline function 'kotlin.math.floor' call
    var x = (prescription.c1f_1 + prescription.d1f_1 | 0) / 2.0;
    var tmp$ret$22 = Math.floor(x);
    var reps = numberToInt(tmp$ret$22);
    // Inline function 'kotlin.collections.mapIndexed' call
    // Inline function 'kotlin.collections.mapIndexedTo' call
    var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(today, 10));
    var index = 0;
    var _iterator__ex2g4s_5 = today.j();
    while (_iterator__ex2g4s_5.k()) {
      var item_0 = _iterator__ex2g4s_5.l();
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var i = checkIndexOverflow(_unary__edvuaz);
      var tmp$ret$25 = doneSet(Progression_instance, i, item_0, ctx);
      destination_4.f(tmp$ret$25);
    }
    var tmp_3 = destination_4;
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(today.o(), prescription.b1f_1);
    // Inline function 'kotlin.collections.mapTo' call
    var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.oc_1;
    var last_0 = this_0.pc_1;
    if (inductionVariable <= last_0)
      do {
        var item_1 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item_1;
        var tmp$ret$28 = new PlannedSet(it, null, reps, ctx.v1l_1, ctx.e1m(it), false);
        destination_5.f(tmp$ret$28);
      }
       while (!(item_1 === last_0));
    var planned = plus(tmp_3, destination_5);
    return new ExerciseTargets(planned, null, TargetIssue_NO_HISTORY_getInstance(), false, emptyList(), false);
  }
  var last_1 = lastOrNull(sessions_0);
  var capped = last_1 == null ? feasible : capLoads(this, feasible, topLoad(this, last_1, ctx), options.l1k_1);
  var base = !(prior_0 == null) ? freshPlan(this, ctx, capped, prior_0, sessions_0) : null;
  if (today.m() && !(base == null))
    return base.q1l(VOID, VOID, VOID, VOID, VOID, progressed_0);
  var tmp1_safe_receiver = base == null ? null : base.j1l_1;
  var tmp2_safe_receiver = tmp1_safe_receiver == null ? null : firstOrNull(tmp1_safe_receiver);
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.e1l_1;
  var plannedReps = tmp3_elvis_lhs == null ? first(today).v18_1 : tmp3_elvis_lhs;
  var planned_0 = ArrayList_init_$Create$_0();
  ctx.f1m();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index_0 = 0;
  var _iterator__ex2g4s_6 = today.j();
  while (_iterator__ex2g4s_6.k()) {
    var item_2 = _iterator__ex2g4s_6.l();
    var _unary__edvuaz_0 = index_0;
    index_0 = _unary__edvuaz_0 + 1 | 0;
    var i_0 = checkIndexOverflow(_unary__edvuaz_0);
    planned_0.f(doneSet(Progression_instance, i_0, item_2, ctx));
    var tmp0_elvis_lhs = item_2.w18_1;
    ctx.g1m(i_0, item_2.v18_1, tmp0_elvis_lhs == null ? ctx.v1l_1 : tmp0_elvis_lhs);
  }
  var previous = gram(this, last(today).u18_1 + ctx.u1l_1);
  var first_0 = null;
  var inductionVariable_0 = today.o();
  var last_2 = prescription.b1f_1;
  if (inductionVariable_0 < last_2)
    do {
      var i_1 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var choice = laterSet(this, ctx, feasible, current_0, i_1, previous, plannedReps);
      if (first_0 == null)
        first_0 = choice;
      planned_0.f(choice.u1m(i_1, ctx));
      ctx.g1m(i_1, choice.r1m_1, ctx.v1l_1);
      previous = choice.q1m_1;
    }
     while (inductionVariable_0 < last_2);
  var tmp4_safe_receiver = first_0;
  var tmp_4;
  if (tmp4_safe_receiver == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_4 = !tmp4_safe_receiver.t1m_1.equals(TargetIssue_NONE_getInstance());
  }
  var tmp5_elvis_lhs = tmp_4;
  var warning = tmp5_elvis_lhs == null ? false : tmp5_elvis_lhs;
  var tmp6_safe_receiver = first_0;
  var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.t1m_1;
  return new ExerciseTargets(planned_0, current_0, tmp7_elvis_lhs == null ? TargetIssue_NONE_getInstance() : tmp7_elvis_lhs, warning, warning ? alternatives(this, ctx, feasible, current_0, today.o(), last(today).u18_1 + ctx.u1l_1) : emptyList(), progressed_0);
};
var Progression_instance;
function Progression_getInstance() {
  return Progression_instance;
}
function AdjustmentPriority_REPS_FIRST_getInstance() {
  static_init_47();
  return AdjustmentPriority_REPS_FIRST_instance;
}
function AdjustmentPriority_WEIGHT_FIRST_getInstance() {
  static_init_47();
  return AdjustmentPriority_WEIGHT_FIRST_instance;
}
function TargetIssue_NONE_getInstance() {
  static_init_48();
  return TargetIssue_NONE_instance;
}
function TargetIssue_NO_HISTORY_getInstance() {
  static_init_48();
  return TargetIssue_NO_HISTORY_instance;
}
function TargetIssue_NO_LOADS_getInstance() {
  static_init_48();
  return TargetIssue_NO_LOADS_instance;
}
function TargetIssue_OUTSIDE_REP_RANGE_getInstance() {
  static_init_48();
  return TargetIssue_OUTSIDE_REP_RANGE_instance;
}
function TargetIssue_NO_FEASIBLE_TARGET_getInstance() {
  static_init_48();
  return TargetIssue_NO_FEASIBLE_TARGET_instance;
}
function AlternativeKind_NEXT_LOAD_UP_getInstance() {
  static_init_49();
  return AlternativeKind_NEXT_LOAD_UP_instance;
}
function AlternativeKind_NEXT_LOAD_DOWN_getInstance() {
  static_init_49();
  return AlternativeKind_NEXT_LOAD_DOWN_instance;
}
function AlternativeKind_EXPAND_REP_RANGE_getInstance() {
  static_init_49();
  return AlternativeKind_EXPAND_REP_RANGE_instance;
}
function AlternativeKind_WEIGHT_MATCH_getInstance() {
  static_init_49();
  return AlternativeKind_WEIGHT_MATCH_instance;
}
var static_init_called_50;
function static_init_50() {
  if (static_init_called_50)
    return Unit_instance;
  static_init_called_50 = true;
  SeriesRange_WEEK_instance = new SeriesRange('WEEK', 0, 7);
  SeriesRange_MONTH_instance = new SeriesRange('MONTH', 1, 30);
  SeriesRange_THREE_MONTHS_instance = new SeriesRange('THREE_MONTHS', 2, 91);
  SeriesRange_SIX_MONTHS_instance = new SeriesRange('SIX_MONTHS', 3, 182);
  SeriesRange_YEAR_instance = new SeriesRange('YEAR', 4, 365);
  SeriesRange_ALL_instance = new SeriesRange('ALL', 5, null);
}
var SeriesRange_WEEK_instance;
var SeriesRange_MONTH_instance;
var SeriesRange_THREE_MONTHS_instance;
var SeriesRange_SIX_MONTHS_instance;
var SeriesRange_YEAR_instance;
var SeriesRange_ALL_instance;
function valueOf_13(value) {
  static_init_50();
  switch (value) {
    case 'WEEK':
      return SeriesRange_WEEK_getInstance();
    case 'MONTH':
      return SeriesRange_MONTH_getInstance();
    case 'THREE_MONTHS':
      return SeriesRange_THREE_MONTHS_getInstance();
    case 'SIX_MONTHS':
      return SeriesRange_SIX_MONTHS_getInstance();
    case 'YEAR':
      return SeriesRange_YEAR_getInstance();
    case 'ALL':
      return SeriesRange_ALL_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.SeriesRange.' + value);
      break;
  }
}
function SeriesRange(name, ordinal, days) {
  Enum.call(this, name, ordinal);
  this.j1n_1 = days;
}
var static_init_called_51;
function static_init_51() {
  if (static_init_called_51)
    return Unit_instance;
  static_init_called_51 = true;
  SeriesAggregation_DAY_instance = new SeriesAggregation('DAY', 0);
  SeriesAggregation_WEEK_instance = new SeriesAggregation('WEEK', 1);
  SeriesAggregation_MONTH_instance = new SeriesAggregation('MONTH', 2);
}
var SeriesAggregation_DAY_instance;
var SeriesAggregation_WEEK_instance;
var SeriesAggregation_MONTH_instance;
function valueOf_14(value) {
  static_init_51();
  switch (value) {
    case 'DAY':
      return SeriesAggregation_DAY_getInstance();
    case 'WEEK':
      return SeriesAggregation_WEEK_getInstance();
    case 'MONTH':
      return SeriesAggregation_MONTH_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.SeriesAggregation.' + value);
      break;
  }
}
function SeriesAggregation(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_52;
function static_init_52() {
  if (static_init_called_52)
    return Unit_instance;
  static_init_called_52 = true;
  SeriesAverage_SIMPLE_instance = new SeriesAverage('SIMPLE', 0);
  SeriesAverage_EMA_instance = new SeriesAverage('EMA', 1);
}
var SeriesAverage_SIMPLE_instance;
var SeriesAverage_EMA_instance;
function valueOf_15(value) {
  static_init_52();
  switch (value) {
    case 'SIMPLE':
      return SeriesAverage_SIMPLE_getInstance();
    case 'EMA':
      return SeriesAverage_EMA_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.training.SeriesAverage.' + value);
      break;
  }
}
function SeriesAverage(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function SeriesPoint(day, value) {
  this.k1n_1 = day;
  this.l1n_1 = value;
}
protoOf(SeriesPoint).toString = function () {
  return 'SeriesPoint(day=' + this.k1n_1 + ', value=' + this.l1n_1 + ')';
};
protoOf(SeriesPoint).hashCode = function () {
  var result = this.k1n_1;
  result = imul(result, 31) + getNumberHashCode(this.l1n_1) | 0;
  return result;
};
protoOf(SeriesPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SeriesPoint))
    return false;
  if (!(this.k1n_1 === other.k1n_1))
    return false;
  if (!equals(this.l1n_1, other.l1n_1))
    return false;
  return true;
};
function sam$kotlin_Comparator$0_12(function_0) {
  this.m1n_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_12).y9 = function (a, b) {
  return this.m1n_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_12).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_12).g2 = function () {
  return this.m1n_1;
};
protoOf(sam$kotlin_Comparator$0_12).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_12).hashCode = function () {
  return hashCode(this.g2());
};
function sam$kotlin_Comparator$0_13(function_0) {
  this.n1n_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_13).y9 = function (a, b) {
  return this.n1n_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_13).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_13).g2 = function () {
  return this.n1n_1;
};
protoOf(sam$kotlin_Comparator$0_13).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_13).hashCode = function () {
  return hashCode(this.g2());
};
function SeriesRanges$apply$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o1();
  var tmp$ret$2 = b.o1();
  return compareValues(tmp, tmp$ret$2);
}
function SeriesRanges$records$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.k1n_1;
  var tmp$ret$2 = b.k1n_1;
  return compareValues(tmp, tmp$ret$2);
}
function SeriesRanges() {
  this.o1n_1 = 0.3;
}
protoOf(SeriesRanges).p1n = function (points, today, range, aggregation, average, recordsOnly) {
  var shown = recordsOnly ? this.q1n(points) : points;
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = shown.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.k1n_1 <= today && (range.j1n_1 == null || element.k1n_1 > (today - range.j1n_1 | 0))) {
      destination.f(element);
    }
  }
  var inRange = destination;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = inRange.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = SeriesRanges_instance.r1n(element_0.k1n_1, aggregation);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.s1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.k2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination_0.v1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = SeriesRanges$apply$lambda;
  var tmp$ret$9 = new sam$kotlin_Comparator$0_12(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$9);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_1 = this_1.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var start = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var group = item.p1();
    // Inline function 'kotlin.collections.maxOf' call
    var iterator = group.j();
    if (!iterator.k())
      throw NoSuchElementException_init_$Create$_0();
    var maxValue = iterator.l().l1n_1;
    while (iterator.k()) {
      var v = iterator.l().l1n_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    var tmp$ret$15 = maxValue;
    var tmp$ret$12 = new SeriesPoint(start, tmp$ret$15);
    destination_1.f(tmp$ret$12);
  }
  var buckets = destination_1;
  if (average.equals(SeriesAverage_SIMPLE_getInstance()))
    return buckets;
  var smoothed = null;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(buckets, 10));
  var _iterator__ex2g4s_2 = buckets.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_0 = _iterator__ex2g4s_2.l();
    var tmp0_safe_receiver = smoothed;
    var tmp_1;
    if (tmp0_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = 0.3 * item_0.l1n_1 + (1.0 - 0.3) * tmp0_safe_receiver;
    }
    var tmp1_elvis_lhs = tmp_1;
    var next = tmp1_elvis_lhs == null ? item_0.l1n_1 : tmp1_elvis_lhs;
    smoothed = next;
    var tmp$ret$21 = new SeriesPoint(item_0.k1n_1, next);
    destination_2.f(tmp$ret$21);
  }
  return destination_2;
};
protoOf(SeriesRanges).q1n = function (points) {
  var best = -Infinity;
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp = SeriesRanges$records$lambda;
  var tmp$ret$1 = new sam$kotlin_Comparator$0_13(tmp);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = sortedWith(points, tmp$ret$1);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.also' call
    var this_0 = element.l1n_1 > best;
    if (this_0)
      best = element.l1n_1;
    if (this_0) {
      destination.f(element);
    }
  }
  return destination;
};
protoOf(SeriesRanges).r1n = function (day, aggregation) {
  var tmp;
  switch (aggregation.x1_1) {
    case 0:
      tmp = day;
      break;
    case 1:
      tmp = EpochDays_getInstance().ud(day);
      break;
    case 2:
      tmp = ensureNotNull(EpochDays_getInstance().rd(substring(EpochDays_getInstance().sd(day), 0, 8) + '01'));
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var SeriesRanges_instance;
function SeriesRanges_getInstance() {
  return SeriesRanges_instance;
}
function SeriesRange_WEEK_getInstance() {
  static_init_50();
  return SeriesRange_WEEK_instance;
}
function SeriesRange_MONTH_getInstance() {
  static_init_50();
  return SeriesRange_MONTH_instance;
}
function SeriesRange_THREE_MONTHS_getInstance() {
  static_init_50();
  return SeriesRange_THREE_MONTHS_instance;
}
function SeriesRange_SIX_MONTHS_getInstance() {
  static_init_50();
  return SeriesRange_SIX_MONTHS_instance;
}
function SeriesRange_YEAR_getInstance() {
  static_init_50();
  return SeriesRange_YEAR_instance;
}
function SeriesRange_ALL_getInstance() {
  static_init_50();
  return SeriesRange_ALL_instance;
}
function SeriesAggregation_DAY_getInstance() {
  static_init_51();
  return SeriesAggregation_DAY_instance;
}
function SeriesAggregation_WEEK_getInstance() {
  static_init_51();
  return SeriesAggregation_WEEK_instance;
}
function SeriesAggregation_MONTH_getInstance() {
  static_init_51();
  return SeriesAggregation_MONTH_instance;
}
function SeriesAverage_SIMPLE_getInstance() {
  static_init_52();
  return SeriesAverage_SIMPLE_instance;
}
function SeriesAverage_EMA_getInstance() {
  static_init_52();
  return SeriesAverage_EMA_instance;
}
function LoggedSet(loadKg, reps, rir) {
  this.s1n_1 = loadKg;
  this.t1n_1 = reps;
  this.u1n_1 = rir;
}
protoOf(LoggedSet).toString = function () {
  return 'LoggedSet(loadKg=' + this.s1n_1 + ', reps=' + this.t1n_1 + ', rir=' + this.u1n_1 + ')';
};
protoOf(LoggedSet).hashCode = function () {
  var result = getNumberHashCode(this.s1n_1);
  result = imul(result, 31) + this.t1n_1 | 0;
  result = imul(result, 31) + this.u1n_1 | 0;
  return result;
};
protoOf(LoggedSet).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LoggedSet))
    return false;
  if (!equals(this.s1n_1, other.s1n_1))
    return false;
  if (!(this.t1n_1 === other.t1n_1))
    return false;
  if (!(this.u1n_1 === other.u1n_1))
    return false;
  return true;
};
function SetTarget(loadKg, reps, outsideRepRange) {
  this.w1m_1 = loadKg;
  this.x1m_1 = reps;
  this.y1m_1 = outsideRepRange;
}
protoOf(SetTarget).toString = function () {
  return 'SetTarget(loadKg=' + this.w1m_1 + ', reps=' + this.x1m_1 + ', outsideRepRange=' + this.y1m_1 + ')';
};
protoOf(SetTarget).hashCode = function () {
  var result = getNumberHashCode(this.w1m_1);
  result = imul(result, 31) + this.x1m_1 | 0;
  result = imul(result, 31) + getBooleanHashCode(this.y1m_1) | 0;
  return result;
};
protoOf(SetTarget).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof SetTarget))
    return false;
  if (!equals(this.w1m_1, other.w1m_1))
    return false;
  if (!(this.x1m_1 === other.x1m_1))
    return false;
  if (!(this.y1m_1 === other.y1m_1))
    return false;
  return true;
};
function roundTo($this, value, step) {
  return round(value / step) * step;
}
function Candidate(load, reps, predicted) {
  this.v1n_1 = load;
  this.w1n_1 = reps;
  this.x1n_1 = predicted;
}
function sam$kotlin_Comparator$0_14(function_0) {
  this.y1n_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_14).y9 = function (a, b) {
  return this.y1n_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_14).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_14).g2 = function () {
  return this.y1n_1;
};
protoOf(sam$kotlin_Comparator$0_14).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_14).hashCode = function () {
  return hashCode(this.g2());
};
function Strength$nextSetTarget$pick$lambda($midpoint) {
  return function (a, b) {
    // Inline function 'kotlin.comparisons.compareValuesBy' call
    // Inline function 'kotlin.math.abs' call
    var x = a.x1n_1 - $midpoint;
    var tmp$ret$2 = Math.abs(x);
    var tmp = round(tmp$ret$2 * 1000);
    // Inline function 'kotlin.math.abs' call
    var x_0 = b.x1n_1 - $midpoint;
    var tmp$ret$4 = Math.abs(x_0);
    var tmp$ret$3 = round(tmp$ret$4 * 1000);
    return compareValues(tmp, tmp$ret$3);
  };
}
function Strength$nextSetTarget$pick$lambda_0($this, $previousLoadKg) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0;
      var tmp_1;
      if (!($previousLoadKg == null)) {
        // Inline function 'kotlin.math.abs' call
        var x = a.v1n_1 - $previousLoadKg;
        tmp_1 = Math.abs(x) < 1.0E-9;
      } else {
        tmp_1 = false;
      }
      if (tmp_1) {
        tmp_0 = 0;
      } else {
        tmp_0 = 1;
      }
      var tmp_2 = tmp_0;
      var tmp_3;
      var tmp_4;
      if (!($previousLoadKg == null)) {
        // Inline function 'kotlin.math.abs' call
        var x_0 = b.v1n_1 - $previousLoadKg;
        tmp_4 = Math.abs(x_0) < 1.0E-9;
      } else {
        tmp_4 = false;
      }
      if (tmp_4) {
        tmp_3 = 0;
      } else {
        tmp_3 = 1;
      }
      var tmp$ret$3 = tmp_3;
      tmp = compareValues(tmp_2, tmp$ret$3);
    }
    return tmp;
  };
}
function Strength$nextSetTarget$pick$lambda_1($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = b.v1n_1;
      var tmp$ret$2 = a.v1n_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function nextSetTarget$pick(candidates, midpoint, $previousLoadKg, minReps, maxReps) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = candidates.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var containsArg = element.w1n_1;
    if (minReps <= containsArg ? containsArg <= maxReps : false) {
      destination.f(element);
    }
  }
  var tmp = destination;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = Strength$nextSetTarget$pick$lambda(midpoint);
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_14(tmp_0);
  var tmp_1 = Strength$nextSetTarget$pick$lambda_0(this_0, $previousLoadKg);
  // Inline function 'kotlin.comparisons.thenByDescending' call
  var this_1 = new sam$kotlin_Comparator$0_14(tmp_1);
  var tmp_2 = Strength$nextSetTarget$pick$lambda_1(this_1);
  var tmp$ret$5 = new sam$kotlin_Comparator$0_14(tmp_2);
  return minWithOrNull(tmp, tmp$ret$5);
}
function Strength() {
  this.i1c_1 = 30.0;
}
protoOf(Strength).z1n = function (set) {
  return set.t1n_1 + set.u1n_1 | 0;
};
protoOf(Strength).a1o = function (set, k) {
  // Inline function 'kotlin.require' call
  if (!(set.s1n_1 >= 0.0 && set.t1n_1 > 0 && set.u1n_1 >= 0)) {
    var message = 'invalid set';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var rtf = this.z1n(set);
  return rtf <= 1 ? set.s1n_1 : set.s1n_1 * (1.0 + rtf / k);
};
protoOf(Strength).b1o = function (set, k, $super) {
  k = k === VOID ? 30.0 : k;
  return $super === VOID ? this.a1o(set, k) : $super.a1o.call(this, set, k);
};
protoOf(Strength).c1o = function (loadKg, oneRepMaxKg, k) {
  // Inline function 'kotlin.require' call
  if (!(loadKg > 0.0 && oneRepMaxKg > 0.0)) {
    var message = 'loads must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (loadKg >= oneRepMaxKg)
    return 1.0;
  return k * (oneRepMaxKg / loadKg - 1.0);
};
protoOf(Strength).a1n = function (set, repMin, repMax, rirTarget, previousRepsAtSameLoad) {
  // Inline function 'kotlin.require' call
  if (!(1 <= repMin ? repMin <= repMax : false)) {
    var message = 'invalid rep range';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (rirTarget === 0) {
    return !(previousRepsAtSameLoad == null) && set.t1n_1 > previousRepsAtSameLoad;
  }
  var midpoint = (repMin + repMax | 0) / 2.0;
  return (set.t1n_1 + set.u1n_1 | 0) >= midpoint + rirTarget + 1;
};
protoOf(Strength).d1o = function (oneRepMaxKg, feasibleLoadsKg, repMin, repMax, rirTarget, setIndex, fatigueRepsPerSet, previousLoadKg, k, expandRepRange, expandBy, curve, performance) {
  // Inline function 'kotlin.require' call
  if (!(1 <= repMin ? repMin <= repMax : false)) {
    var message = 'invalid rep range';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(setIndex >= 0)) {
    var message_0 = 'setIndex must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(performance > 0.0)) {
    var message_1 = 'performance must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = feasibleLoadsKg.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element > 0.0) {
      destination.f(element);
    }
  }
  var loads = distinct(destination);
  if (loads.m())
    return null;
  var midpoint = (repMin + repMax | 0) / 2.0;
  var strength = oneRepMaxKg * performance;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(loads, 10));
  var _iterator__ex2g4s_0 = loads.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var predicted = curve.j1m(item, strength) - fatigueRepsPerSet * setIndex - rirTarget;
    // Inline function 'kotlin.math.floor' call
    var x = predicted + 0.5;
    var tmp$ret$12 = Math.floor(x);
    var tmp$ret$11 = new Candidate(item, numberToInt(tmp$ret$12), predicted);
    destination_0.f(tmp$ret$11);
  }
  var candidates = destination_0;
  var tmp0_safe_receiver = nextSetTarget$pick(candidates, midpoint, previousLoadKg, repMin, repMax);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    return new SetTarget(tmp0_safe_receiver.v1n_1, tmp0_safe_receiver.w1n_1, false);
  }
  if (!expandRepRange)
    return null;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = repMin - expandBy | 0;
  var tmp$ret$15 = Math.max(1, b);
  var tmp1_elvis_lhs = nextSetTarget$pick(candidates, midpoint, previousLoadKg, tmp$ret$15, repMax + expandBy | 0);
  var tmp;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp1_elvis_lhs;
  }
  var widened = tmp;
  return new SetTarget(widened.v1n_1, widened.w1n_1, true);
};
protoOf(Strength).v1m = function (oneRepMaxKg, feasibleLoadsKg, repMin, repMax, rirTarget, setIndex, fatigueRepsPerSet, previousLoadKg, k, expandRepRange, expandBy, curve, performance, $super) {
  setIndex = setIndex === VOID ? 0 : setIndex;
  fatigueRepsPerSet = fatigueRepsPerSet === VOID ? 1.0 : fatigueRepsPerSet;
  previousLoadKg = previousLoadKg === VOID ? null : previousLoadKg;
  k = k === VOID ? 30.0 : k;
  expandRepRange = expandRepRange === VOID ? true : expandRepRange;
  expandBy = expandBy === VOID ? 2 : expandBy;
  curve = curve === VOID ? new EpleyCurve(k) : curve;
  performance = performance === VOID ? 1.0 : performance;
  return $super === VOID ? this.d1o(oneRepMaxKg, feasibleLoadsKg, repMin, repMax, rirTarget, setIndex, fatigueRepsPerSet, previousLoadKg, k, expandRepRange, expandBy, curve, performance) : $super.d1o.call(this, oneRepMaxKg, feasibleLoadsKg, repMin, repMax, rirTarget, setIndex, fatigueRepsPerSet, previousLoadKg, k, expandRepRange, expandBy, curve, performance);
};
protoOf(Strength).j1c = function (ranges) {
  var loads = HashSet_init_$Create$();
  var _iterator__ex2g4s = ranges.j();
  while (_iterator__ex2g4s.k()) {
    var range = _iterator__ex2g4s.l();
    // Inline function 'kotlin.require' call
    if (!(range.r1b_1 > 0.0 && range.q1b_1 >= range.p1b_1)) {
      var message = 'invalid stack range';
      throw IllegalArgumentException_init_$Create$(toString(message));
    }
    var load = range.p1b_1;
    while (load <= range.q1b_1 + 1.0E-9) {
      loads.f(roundTo(this, load, 0.001));
      load = load + range.r1b_1;
    }
  }
  return sorted(loads);
};
var Strength_instance;
function Strength_getInstance() {
  return Strength_instance;
}
function StackRange(startKg, endKg, incrementKg) {
  this.p1b_1 = startKg;
  this.q1b_1 = endKg;
  this.r1b_1 = incrementKg;
}
protoOf(StackRange).toString = function () {
  return 'StackRange(startKg=' + this.p1b_1 + ', endKg=' + this.q1b_1 + ', incrementKg=' + this.r1b_1 + ')';
};
protoOf(StackRange).hashCode = function () {
  var result = getNumberHashCode(this.p1b_1);
  result = imul(result, 31) + getNumberHashCode(this.q1b_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.r1b_1) | 0;
  return result;
};
protoOf(StackRange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof StackRange))
    return false;
  if (!equals(this.p1b_1, other.p1b_1))
    return false;
  if (!equals(this.q1b_1, other.q1b_1))
    return false;
  if (!equals(this.r1b_1, other.r1b_1))
    return false;
  return true;
};
function StrengthCurve() {
}
function EpleyCurve(k) {
  k = k === VOID ? 30.0 : k;
  this.e1o_1 = k;
  // Inline function 'kotlin.require' call
  if (!(this.e1o_1 > 0.0)) {
    var message = 'k must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(EpleyCurve).p18 = function (rtf) {
  return 1.0 / (1.0 + rtf / this.e1o_1);
};
protoOf(EpleyCurve).l1m = function (loadKg, rtf) {
  return rtf <= 1.0 ? loadKg : loadKg * (1.0 + rtf / this.e1o_1);
};
protoOf(EpleyCurve).j1m = function (loadKg, oneRepMaxKg) {
  return Strength_instance.c1o(loadKg, oneRepMaxKg, this.e1o_1);
};
protoOf(EpleyCurve).z1m = function (oneRepMaxKg, rtf) {
  return oneRepMaxKg / (1.0 + rtf / this.e1o_1);
};
protoOf(EpleyCurve).toString = function () {
  return 'EpleyCurve(k=' + this.e1o_1 + ')';
};
protoOf(EpleyCurve).hashCode = function () {
  return getNumberHashCode(this.e1o_1);
};
protoOf(EpleyCurve).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof EpleyCurve))
    return false;
  if (!equals(this.e1o_1, other.e1o_1))
    return false;
  return true;
};
function Companion_11() {
  Companion_instance_13 = this;
  this.f1o_1 = 0.2;
  this.g1o_1 = 0.958;
  this.h1o_1 = 100.0;
  this.i1o_1 = mapOf_0([to(1, 1.0), to(2, 0.95), to(3, 0.93), to(4, 0.9), to(5, 0.87), to(6, 0.85), to(7, 0.83), to(8, 0.8), to(9, 0.77), to(10, 0.75), to(12, 0.67), to(15, 0.65)]);
}
var Companion_instance_13;
function Companion_getInstance_10() {
  if (Companion_instance_13 == null)
    new Companion_11();
  return Companion_instance_13;
}
function FlooredExpCurve(base, floor) {
  Companion_getInstance_10();
  floor = floor === VOID ? 0.2 : floor;
  this.n18_1 = base;
  this.o18_1 = floor;
  // Inline function 'kotlin.require' call
  if (!(this.n18_1 > 0.0 && this.n18_1 < 1.0)) {
    var message = 'base must be between 0 and 1';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.o18_1 >= 0.0 && this.o18_1 < 1.0)) {
    var message_0 = 'floor must be between 0 and 1';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
}
protoOf(FlooredExpCurve).p18 = function (rtf) {
  var tmp = 1.0 - this.o18_1;
  var tmp0 = this.n18_1;
  // Inline function 'kotlin.math.pow' call
  var x = rtf - 1.0;
  var tmp$ret$0 = Math.pow(tmp0, x);
  return this.o18_1 + tmp * tmp$ret$0;
};
protoOf(FlooredExpCurve).j1m = function (loadKg, oneRepMaxKg) {
  // Inline function 'kotlin.require' call
  if (!(loadKg > 0.0 && oneRepMaxKg > 0.0)) {
    var message = 'loads must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var share = loadKg / oneRepMaxKg;
  if (share >= 1.0)
    return 1.0;
  if (share <= this.o18_1 + 1.0E-9)
    return 100.0;
  // Inline function 'kotlin.math.ln' call
  var x = (share - this.o18_1) / (1.0 - this.o18_1);
  var tmp = Math.log(x);
  // Inline function 'kotlin.math.ln' call
  var x_0 = this.n18_1;
  // Inline function 'kotlin.math.min' call
  var b = 1.0 + tmp / Math.log(x_0);
  return Math.min(100.0, b);
};
protoOf(FlooredExpCurve).toString = function () {
  return 'FlooredExpCurve(base=' + this.n18_1 + ', floor=' + this.o18_1 + ')';
};
protoOf(FlooredExpCurve).hashCode = function () {
  var result = getNumberHashCode(this.n18_1);
  result = imul(result, 31) + getNumberHashCode(this.o18_1) | 0;
  return result;
};
protoOf(FlooredExpCurve).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof FlooredExpCurve))
    return false;
  if (!equals(this.n18_1, other.n18_1))
    return false;
  if (!equals(this.o18_1, other.o18_1))
    return false;
  return true;
};
function OneRepMaxClamp() {
  this.m1m_1 = 0.99;
  this.n1m_1 = 0.95;
}
protoOf(OneRepMaxClamp).o1m = function (oneRepMaxKg, loadKg, rtf) {
  if (rtf <= 1.0)
    return oneRepMaxKg;
  // Inline function 'kotlin.math.pow' call
  var x = rtf - 1.0;
  var lower = loadKg / Math.pow(0.99, x);
  // Inline function 'kotlin.math.pow' call
  var x_0 = rtf - 1.0;
  var upper = loadKg / Math.pow(0.95, x_0);
  return coerceIn(oneRepMaxKg, lower, upper);
};
var OneRepMaxClamp_instance;
function OneRepMaxClamp_getInstance() {
  return OneRepMaxClamp_instance;
}
var static_init_called_53;
function static_init_53() {
  if (static_init_called_53)
    return Unit_instance;
  static_init_called_53 = true;
  CurveModel_EPLEY_instance = new CurveModel('EPLEY', 0);
  CurveModel_FLOORED_EXP_FITTED_instance = new CurveModel('FLOORED_EXP_FITTED', 1);
}
var CurveModel_EPLEY_instance;
var CurveModel_FLOORED_EXP_FITTED_instance;
function values_33() {
  static_init_53();
  return [CurveModel_EPLEY_getInstance(), CurveModel_FLOORED_EXP_FITTED_getInstance()];
}
function get_entries_28() {
  static_init_53();
  if ($ENTRIES_28 == null)
    $ENTRIES_28 = enumEntries(values_33());
  return $ENTRIES_28;
}
var $ENTRIES_28;
function CurveModel(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_54;
function static_init_54() {
  if (static_init_called_54)
    return Unit_instance;
  static_init_called_54 = true;
  Region_UPPER_instance = new Region('UPPER', 0, 'upper');
  Region_LOWER_instance = new Region('LOWER', 1, 'lower');
  Region_CORE_instance = new Region('CORE', 2, 'core');
  Region_FULL_instance = new Region('FULL', 3, 'full');
  if (Companion_instance_14 == null) {
    Companion_instance_0;
    new Companion_12();
  }
}
var Region_UPPER_instance;
var Region_LOWER_instance;
var Region_CORE_instance;
var Region_FULL_instance;
function Companion_12() {
  Companion_instance_14 = this;
  this.e1i_1 = setOf([Muscle_CHEST_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_TRICEPS_getInstance(), Muscle_BICEPS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_TRAPS_getInstance(), Muscle_NECK_getInstance()]);
  this.f1i_1 = setOf([Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_CALVES_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDUCTORS_getInstance()]);
}
protoOf(Companion_12).p19 = function (key) {
  var tmp0 = get_entries_29();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.l1o_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
protoOf(Companion_12).g1i = function (exercise) {
  var tmp0_elvis_lhs = exercise.o1e_1;
  return tmp0_elvis_lhs == null ? this.m1o(exercise.h1e_1) : tmp0_elvis_lhs;
};
protoOf(Companion_12).m1o = function (primary) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(primary, Collection)) {
      tmp = primary.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = primary.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (Companion_getInstance_11().e1i_1.r(element)) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  var upper = tmp$ret$0;
  var tmp$ret$2;
  $l$block_2: {
    // Inline function 'kotlin.collections.any' call
    var tmp_0;
    if (isInterface(primary, Collection)) {
      tmp_0 = primary.m();
    } else {
      tmp_0 = false;
    }
    if (tmp_0) {
      tmp$ret$2 = false;
      break $l$block_2;
    }
    var _iterator__ex2g4s_0 = primary.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (Companion_getInstance_11().f1i_1.r(element_0)) {
        tmp$ret$2 = true;
        break $l$block_2;
      }
    }
    tmp$ret$2 = false;
  }
  var lower = tmp$ret$2;
  return upper && lower ? Region_FULL_getInstance() : upper ? Region_UPPER_getInstance() : lower ? Region_LOWER_getInstance() : Region_CORE_getInstance();
};
var Companion_instance_14;
function Companion_getInstance_11() {
  static_init_54();
  return Companion_instance_14;
}
function values_34() {
  static_init_54();
  return [Region_UPPER_getInstance(), Region_LOWER_getInstance(), Region_CORE_getInstance(), Region_FULL_getInstance()];
}
function get_entries_29() {
  static_init_54();
  if ($ENTRIES_29 == null)
    $ENTRIES_29 = enumEntries(values_34());
  return $ENTRIES_29;
}
var $ENTRIES_29;
function Region(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.l1o_1 = key;
}
function CurveModel_EPLEY_getInstance() {
  static_init_53();
  return CurveModel_EPLEY_instance;
}
function CurveModel_FLOORED_EXP_FITTED_getInstance() {
  static_init_53();
  return CurveModel_FLOORED_EXP_FITTED_instance;
}
function Region_UPPER_getInstance() {
  static_init_54();
  return Region_UPPER_instance;
}
function Region_LOWER_getInstance() {
  static_init_54();
  return Region_LOWER_instance;
}
function Region_CORE_getInstance() {
  static_init_54();
  return Region_CORE_instance;
}
function Region_FULL_getInstance() {
  static_init_54();
  return Region_FULL_instance;
}
var static_init_called_55;
function static_init_55() {
  if (static_init_called_55)
    return Unit_instance;
  static_init_called_55 = true;
  Muscle_CHEST_instance = new Muscle('CHEST', 0, 'chest');
  Muscle_SHOULDERS_instance = new Muscle('SHOULDERS', 1, 'shoulders');
  Muscle_TRICEPS_instance = new Muscle('TRICEPS', 2, 'triceps');
  Muscle_BICEPS_instance = new Muscle('BICEPS', 3, 'biceps');
  Muscle_FOREARMS_instance = new Muscle('FOREARMS', 4, 'forearms');
  Muscle_LATS_instance = new Muscle('LATS', 5, 'lats');
  Muscle_MIDDLE_BACK_instance = new Muscle('MIDDLE_BACK', 6, 'middle back');
  Muscle_LOWER_BACK_instance = new Muscle('LOWER_BACK', 7, 'lower back');
  Muscle_TRAPS_instance = new Muscle('TRAPS', 8, 'traps');
  Muscle_ABDOMINALS_instance = new Muscle('ABDOMINALS', 9, 'abdominals');
  Muscle_QUADRICEPS_instance = new Muscle('QUADRICEPS', 10, 'quadriceps');
  Muscle_HAMSTRINGS_instance = new Muscle('HAMSTRINGS', 11, 'hamstrings');
  Muscle_GLUTES_instance = new Muscle('GLUTES', 12, 'glutes');
  Muscle_CALVES_instance = new Muscle('CALVES', 13, 'calves');
  Muscle_ADDUCTORS_instance = new Muscle('ADDUCTORS', 14, 'adductors');
  Muscle_ABDUCTORS_instance = new Muscle('ABDUCTORS', 15, 'abductors');
  Muscle_NECK_instance = new Muscle('NECK', 16, 'neck');
  if (Companion_instance_15 == null) {
    Companion_instance_0;
    new Companion_13();
  }
}
var Muscle_CHEST_instance;
var Muscle_SHOULDERS_instance;
var Muscle_TRICEPS_instance;
var Muscle_BICEPS_instance;
var Muscle_FOREARMS_instance;
var Muscle_LATS_instance;
var Muscle_MIDDLE_BACK_instance;
var Muscle_LOWER_BACK_instance;
var Muscle_TRAPS_instance;
var Muscle_ABDOMINALS_instance;
var Muscle_QUADRICEPS_instance;
var Muscle_HAMSTRINGS_instance;
var Muscle_GLUTES_instance;
var Muscle_CALVES_instance;
var Muscle_ADDUCTORS_instance;
var Muscle_ABDUCTORS_instance;
var Muscle_NECK_instance;
function Companion_13() {
}
protoOf(Companion_13).j1a = function (key) {
  var tmp0 = get_entries_30();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.p1o_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_15;
function Companion_getInstance_12() {
  return Companion_instance_15;
}
function values_35() {
  static_init_55();
  return [Muscle_CHEST_getInstance(), Muscle_SHOULDERS_getInstance(), Muscle_TRICEPS_getInstance(), Muscle_BICEPS_getInstance(), Muscle_FOREARMS_getInstance(), Muscle_LATS_getInstance(), Muscle_MIDDLE_BACK_getInstance(), Muscle_LOWER_BACK_getInstance(), Muscle_TRAPS_getInstance(), Muscle_ABDOMINALS_getInstance(), Muscle_QUADRICEPS_getInstance(), Muscle_HAMSTRINGS_getInstance(), Muscle_GLUTES_getInstance(), Muscle_CALVES_getInstance(), Muscle_ADDUCTORS_getInstance(), Muscle_ABDUCTORS_getInstance(), Muscle_NECK_getInstance()];
}
function get_entries_30() {
  static_init_55();
  if ($ENTRIES_30 == null)
    $ENTRIES_30 = enumEntries(values_35());
  return $ENTRIES_30;
}
var $ENTRIES_30;
function Muscle(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.p1o_1 = key;
}
var static_init_called_56;
function static_init_56() {
  if (static_init_called_56)
    return Unit_instance;
  static_init_called_56 = true;
  Equipment_BARBELL_instance = new Equipment('BARBELL', 0, 'barbell');
  Equipment_DUMBBELL_instance = new Equipment('DUMBBELL', 1, 'dumbbell');
  Equipment_MACHINE_instance = new Equipment('MACHINE', 2, 'machine');
  Equipment_CABLE_instance = new Equipment('CABLE', 3, 'cable');
  Equipment_KETTLEBELL_instance = new Equipment('KETTLEBELL', 4, 'kettlebell');
  Equipment_BODYWEIGHT_instance = new Equipment('BODYWEIGHT', 5, 'bodyweight');
  Equipment_BAND_instance = new Equipment('BAND', 6, 'band');
  Equipment_SMITH_instance = new Equipment('SMITH', 7, 'smith');
  Equipment_OTHER_instance = new Equipment('OTHER', 8, 'other');
  if (Companion_instance_16 == null) {
    Companion_instance_0;
    new Companion_14();
  }
}
var Equipment_BARBELL_instance;
var Equipment_DUMBBELL_instance;
var Equipment_MACHINE_instance;
var Equipment_CABLE_instance;
var Equipment_KETTLEBELL_instance;
var Equipment_BODYWEIGHT_instance;
var Equipment_BAND_instance;
var Equipment_SMITH_instance;
var Equipment_OTHER_instance;
function Companion_14() {
}
protoOf(Companion_14).p19 = function (key) {
  var tmp0 = get_entries_31();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.b1b_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? Equipment_OTHER_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_16;
function Companion_getInstance_13() {
  return Companion_instance_16;
}
function values_36() {
  static_init_56();
  return [Equipment_BARBELL_getInstance(), Equipment_DUMBBELL_getInstance(), Equipment_MACHINE_getInstance(), Equipment_CABLE_getInstance(), Equipment_KETTLEBELL_getInstance(), Equipment_BODYWEIGHT_getInstance(), Equipment_BAND_getInstance(), Equipment_SMITH_getInstance(), Equipment_OTHER_getInstance()];
}
function get_entries_31() {
  static_init_56();
  if ($ENTRIES_31 == null)
    $ENTRIES_31 = enumEntries(values_36());
  return $ENTRIES_31;
}
var $ENTRIES_31;
function Equipment(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.b1b_1 = key;
}
var static_init_called_57;
function static_init_57() {
  if (static_init_called_57)
    return Unit_instance;
  static_init_called_57 = true;
  SetType_STANDARD_instance = new SetType('STANDARD', 0, 'standard');
  SetType_WARMUP_instance = new SetType('WARMUP', 1, 'warmup');
  SetType_DROP_instance = new SetType('DROP', 2, 'drop');
  SetType_MYO_instance = new SetType('MYO', 3, 'myo');
  SetType_FAILURE_instance = new SetType('FAILURE', 4, 'failure');
  if (Companion_instance_17 == null) {
    Companion_instance_0;
    new Companion_15();
  }
}
var SetType_STANDARD_instance;
var SetType_WARMUP_instance;
var SetType_DROP_instance;
var SetType_MYO_instance;
var SetType_FAILURE_instance;
function Companion_15() {
}
protoOf(Companion_15).p19 = function (key) {
  var tmp0 = get_entries_32();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.s1o_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? SetType_STANDARD_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_17;
function Companion_getInstance_14() {
  return Companion_instance_17;
}
function values_37() {
  static_init_57();
  return [SetType_STANDARD_getInstance(), SetType_WARMUP_getInstance(), SetType_DROP_getInstance(), SetType_MYO_getInstance(), SetType_FAILURE_getInstance()];
}
function get_entries_32() {
  static_init_57();
  if ($ENTRIES_32 == null)
    $ENTRIES_32 = enumEntries(values_37());
  return $ENTRIES_32;
}
var $ENTRIES_32;
function SetType(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.s1o_1 = key;
}
var static_init_called_58;
function static_init_58() {
  if (static_init_called_58)
    return Unit_instance;
  static_init_called_58 = true;
  ProgressionScheme_DOUBLE_instance = new ProgressionScheme('DOUBLE', 0, 'double');
  ProgressionScheme_LINEAR_instance = new ProgressionScheme('LINEAR', 1, 'linear');
  ProgressionScheme_REVERSE_LINEAR_instance = new ProgressionScheme('REVERSE_LINEAR', 2, 'reverseLinear');
  ProgressionScheme_UNDULATING_instance = new ProgressionScheme('UNDULATING', 3, 'undulating');
  ProgressionScheme_STATIC_instance = new ProgressionScheme('STATIC', 4, 'static');
  if (Companion_instance_18 == null) {
    Companion_instance_0;
    new Companion_16();
  }
}
var ProgressionScheme_DOUBLE_instance;
var ProgressionScheme_LINEAR_instance;
var ProgressionScheme_REVERSE_LINEAR_instance;
var ProgressionScheme_UNDULATING_instance;
var ProgressionScheme_STATIC_instance;
function Companion_16() {
}
protoOf(Companion_16).p19 = function (key) {
  var tmp0 = get_entries_33();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.v1o_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? ProgressionScheme_DOUBLE_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_18;
function Companion_getInstance_15() {
  return Companion_instance_18;
}
function values_38() {
  static_init_58();
  return [ProgressionScheme_DOUBLE_getInstance(), ProgressionScheme_LINEAR_getInstance(), ProgressionScheme_REVERSE_LINEAR_getInstance(), ProgressionScheme_UNDULATING_getInstance(), ProgressionScheme_STATIC_getInstance()];
}
function get_entries_33() {
  static_init_58();
  if ($ENTRIES_33 == null)
    $ENTRIES_33 = enumEntries(values_38());
  return $ENTRIES_33;
}
var $ENTRIES_33;
function ProgressionScheme(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.v1o_1 = key;
}
var static_init_called_59;
function static_init_59() {
  if (static_init_called_59)
    return Unit_instance;
  static_init_called_59 = true;
  Mechanic_COMPOUND_instance = new Mechanic('COMPOUND', 0, 'compound');
  Mechanic_ISOLATION_instance = new Mechanic('ISOLATION', 1, 'isolation');
  if (Companion_instance_19 == null) {
    Companion_instance_0;
    new Companion_17();
  }
}
var Mechanic_COMPOUND_instance;
var Mechanic_ISOLATION_instance;
function Companion_17() {
}
protoOf(Companion_17).p19 = function (key) {
  var tmp0 = get_entries_34();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.y1o_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_19;
function Companion_getInstance_16() {
  return Companion_instance_19;
}
function values_39() {
  static_init_59();
  return [Mechanic_COMPOUND_getInstance(), Mechanic_ISOLATION_getInstance()];
}
function get_entries_34() {
  static_init_59();
  if ($ENTRIES_34 == null)
    $ENTRIES_34 = enumEntries(values_39());
  return $ENTRIES_34;
}
var $ENTRIES_34;
function Mechanic(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.y1o_1 = key;
}
var static_init_called_60;
function static_init_60() {
  if (static_init_called_60)
    return Unit_instance;
  static_init_called_60 = true;
  Force_PUSH_instance = new Force('PUSH', 0, 'push');
  Force_PULL_instance = new Force('PULL', 1, 'pull');
  Force_STATIC_instance = new Force('STATIC', 2, 'static');
  if (Companion_instance_20 == null) {
    Companion_instance_0;
    new Companion_18();
  }
}
var Force_PUSH_instance;
var Force_PULL_instance;
var Force_STATIC_instance;
function Companion_18() {
}
protoOf(Companion_18).p19 = function (key) {
  var tmp0 = get_entries_35();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.b1p_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_20;
function Companion_getInstance_17() {
  return Companion_instance_20;
}
function values_40() {
  static_init_60();
  return [Force_PUSH_getInstance(), Force_PULL_getInstance(), Force_STATIC_getInstance()];
}
function get_entries_35() {
  static_init_60();
  if ($ENTRIES_35 == null)
    $ENTRIES_35 = enumEntries(values_40());
  return $ENTRIES_35;
}
var $ENTRIES_35;
function Force(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.b1p_1 = key;
}
var static_init_called_61;
function static_init_61() {
  if (static_init_called_61)
    return Unit_instance;
  static_init_called_61 = true;
  TrainingGoal_STRENGTH_instance = new TrainingGoal('STRENGTH', 0, 'strength');
  TrainingGoal_HYPERTROPHY_instance = new TrainingGoal('HYPERTROPHY', 1, 'hypertrophy');
  if (Companion_instance_21 == null) {
    Companion_instance_0;
    new Companion_19();
  }
}
var TrainingGoal_STRENGTH_instance;
var TrainingGoal_HYPERTROPHY_instance;
function Companion_19() {
}
protoOf(Companion_19).p19 = function (key) {
  var tmp0 = get_entries_36();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.e1p_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? TrainingGoal_HYPERTROPHY_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_21;
function Companion_getInstance_18() {
  return Companion_instance_21;
}
function values_41() {
  static_init_61();
  return [TrainingGoal_STRENGTH_getInstance(), TrainingGoal_HYPERTROPHY_getInstance()];
}
function get_entries_36() {
  static_init_61();
  if ($ENTRIES_36 == null)
    $ENTRIES_36 = enumEntries(values_41());
  return $ENTRIES_36;
}
var $ENTRIES_36;
function TrainingGoal(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.e1p_1 = key;
}
var static_init_called_62;
function static_init_62() {
  if (static_init_called_62)
    return Unit_instance;
  static_init_called_62 = true;
  DeloadPosition_NONE_instance = new DeloadPosition('NONE', 0, 'none');
  DeloadPosition_FIRST_instance = new DeloadPosition('FIRST', 1, 'first');
  DeloadPosition_LAST_instance = new DeloadPosition('LAST', 2, 'last');
  if (Companion_instance_22 == null) {
    Companion_instance_0;
    new Companion_20();
  }
}
var DeloadPosition_NONE_instance;
var DeloadPosition_FIRST_instance;
var DeloadPosition_LAST_instance;
function Companion_20() {
}
protoOf(Companion_20).p19 = function (key) {
  var tmp0 = get_entries_37();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.h1p_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? DeloadPosition_NONE_getInstance() : tmp0_elvis_lhs;
};
var Companion_instance_22;
function Companion_getInstance_19() {
  return Companion_instance_22;
}
function values_42() {
  static_init_62();
  return [DeloadPosition_NONE_getInstance(), DeloadPosition_FIRST_getInstance(), DeloadPosition_LAST_getInstance()];
}
function get_entries_37() {
  static_init_62();
  if ($ENTRIES_37 == null)
    $ENTRIES_37 = enumEntries(values_42());
  return $ENTRIES_37;
}
var $ENTRIES_37;
function DeloadPosition(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.h1p_1 = key;
}
var static_init_called_63;
function static_init_63() {
  if (static_init_called_63)
    return Unit_instance;
  static_init_called_63 = true;
  MovementPattern_SQUAT_instance = new MovementPattern('SQUAT', 0, 'squat');
  MovementPattern_HINGE_instance = new MovementPattern('HINGE', 1, 'hinge');
  MovementPattern_HORIZONTAL_PUSH_instance = new MovementPattern('HORIZONTAL_PUSH', 2, 'horizontalPush');
  MovementPattern_VERTICAL_PUSH_instance = new MovementPattern('VERTICAL_PUSH', 3, 'verticalPush');
  MovementPattern_HORIZONTAL_PULL_instance = new MovementPattern('HORIZONTAL_PULL', 4, 'horizontalPull');
  MovementPattern_VERTICAL_PULL_instance = new MovementPattern('VERTICAL_PULL', 5, 'verticalPull');
  if (Companion_instance_23 == null) {
    Companion_instance_0;
    new Companion_21();
  }
}
var MovementPattern_SQUAT_instance;
var MovementPattern_HINGE_instance;
var MovementPattern_HORIZONTAL_PUSH_instance;
var MovementPattern_VERTICAL_PUSH_instance;
var MovementPattern_HORIZONTAL_PULL_instance;
var MovementPattern_VERTICAL_PULL_instance;
function Companion_21() {
}
protoOf(Companion_21).p19 = function (key) {
  var tmp0 = get_entries_38();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.k1p_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_23;
function Companion_getInstance_20() {
  return Companion_instance_23;
}
function values_43() {
  static_init_63();
  return [MovementPattern_SQUAT_getInstance(), MovementPattern_HINGE_getInstance(), MovementPattern_HORIZONTAL_PUSH_getInstance(), MovementPattern_VERTICAL_PUSH_getInstance(), MovementPattern_HORIZONTAL_PULL_getInstance(), MovementPattern_VERTICAL_PULL_getInstance()];
}
function get_entries_38() {
  static_init_63();
  if ($ENTRIES_38 == null)
    $ENTRIES_38 = enumEntries(values_43());
  return $ENTRIES_38;
}
var $ENTRIES_38;
function MovementPattern(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.k1p_1 = key;
}
var static_init_called_64;
function static_init_64() {
  if (static_init_called_64)
    return Unit_instance;
  static_init_called_64 = true;
  ExerciseSlot_PRIMARY_instance = new ExerciseSlot('PRIMARY', 0, 'primary');
  ExerciseSlot_SECONDARY_instance = new ExerciseSlot('SECONDARY', 1, 'secondary');
  ExerciseSlot_ACCESSORY_instance = new ExerciseSlot('ACCESSORY', 2, 'accessory');
  if (Companion_instance_24 == null) {
    Companion_instance_0;
    new Companion_22();
  }
}
var ExerciseSlot_PRIMARY_instance;
var ExerciseSlot_SECONDARY_instance;
var ExerciseSlot_ACCESSORY_instance;
function Companion_22() {
}
protoOf(Companion_22).p19 = function (key) {
  var tmp0 = get_entries_39();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.n1p_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_24;
function Companion_getInstance_21() {
  return Companion_instance_24;
}
function values_44() {
  static_init_64();
  return [ExerciseSlot_PRIMARY_getInstance(), ExerciseSlot_SECONDARY_getInstance(), ExerciseSlot_ACCESSORY_getInstance()];
}
function get_entries_39() {
  static_init_64();
  if ($ENTRIES_39 == null)
    $ENTRIES_39 = enumEntries(values_44());
  return $ENTRIES_39;
}
var $ENTRIES_39;
function ExerciseSlot(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.n1p_1 = key;
}
function Exercise(id, name, equipment, primaryMuscles, secondaryMuscles, mechanic, force, category, bodyweightFactor, hidden, region, family, exclusionGroups, rank, preconditions, pattern, unilateral) {
  secondaryMuscles = secondaryMuscles === VOID ? emptyList() : secondaryMuscles;
  mechanic = mechanic === VOID ? null : mechanic;
  force = force === VOID ? null : force;
  category = category === VOID ? 'strength' : category;
  bodyweightFactor = bodyweightFactor === VOID ? 0.0 : bodyweightFactor;
  hidden = hidden === VOID ? false : hidden;
  region = region === VOID ? null : region;
  family = family === VOID ? null : family;
  exclusionGroups = exclusionGroups === VOID ? emptyList() : exclusionGroups;
  rank = rank === VOID ? emptyMap() : rank;
  preconditions = preconditions === VOID ? emptyList() : preconditions;
  pattern = pattern === VOID ? null : pattern;
  unilateral = unilateral === VOID ? false : unilateral;
  this.e1e_1 = id;
  this.f1e_1 = name;
  this.g1e_1 = equipment;
  this.h1e_1 = primaryMuscles;
  this.i1e_1 = secondaryMuscles;
  this.j1e_1 = mechanic;
  this.k1e_1 = force;
  this.l1e_1 = category;
  this.m1e_1 = bodyweightFactor;
  this.n1e_1 = hidden;
  this.o1e_1 = region;
  this.p1e_1 = family;
  this.q1e_1 = exclusionGroups;
  this.r1e_1 = rank;
  this.s1e_1 = preconditions;
  this.t1e_1 = pattern;
  this.u1e_1 = unilateral;
}
protoOf(Exercise).toString = function () {
  return 'Exercise(id=' + this.e1e_1 + ', name=' + this.f1e_1 + ', equipment=' + this.g1e_1.toString() + ', primaryMuscles=' + toString(this.h1e_1) + ', secondaryMuscles=' + toString(this.i1e_1) + ', mechanic=' + toString_0(this.j1e_1) + ', force=' + toString_0(this.k1e_1) + ', category=' + this.l1e_1 + ', bodyweightFactor=' + this.m1e_1 + ', hidden=' + this.n1e_1 + ', region=' + toString_0(this.o1e_1) + ', family=' + this.p1e_1 + ', exclusionGroups=' + toString(this.q1e_1) + ', rank=' + toString(this.r1e_1) + ', preconditions=' + toString(this.s1e_1) + ', pattern=' + toString_0(this.t1e_1) + ', unilateral=' + this.u1e_1 + ')';
};
protoOf(Exercise).hashCode = function () {
  var result = getStringHashCode(this.e1e_1);
  result = imul(result, 31) + getStringHashCode(this.f1e_1) | 0;
  result = imul(result, 31) + this.g1e_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.h1e_1) | 0;
  result = imul(result, 31) + hashCode(this.i1e_1) | 0;
  result = imul(result, 31) + (this.j1e_1 == null ? 0 : this.j1e_1.hashCode()) | 0;
  result = imul(result, 31) + (this.k1e_1 == null ? 0 : this.k1e_1.hashCode()) | 0;
  result = imul(result, 31) + getStringHashCode(this.l1e_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.m1e_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.n1e_1) | 0;
  result = imul(result, 31) + (this.o1e_1 == null ? 0 : this.o1e_1.hashCode()) | 0;
  result = imul(result, 31) + (this.p1e_1 == null ? 0 : getStringHashCode(this.p1e_1)) | 0;
  result = imul(result, 31) + hashCode(this.q1e_1) | 0;
  result = imul(result, 31) + hashCode(this.r1e_1) | 0;
  result = imul(result, 31) + hashCode(this.s1e_1) | 0;
  result = imul(result, 31) + (this.t1e_1 == null ? 0 : this.t1e_1.hashCode()) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.u1e_1) | 0;
  return result;
};
protoOf(Exercise).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof Exercise))
    return false;
  if (!(this.e1e_1 === other.e1e_1))
    return false;
  if (!(this.f1e_1 === other.f1e_1))
    return false;
  if (!this.g1e_1.equals(other.g1e_1))
    return false;
  if (!equals(this.h1e_1, other.h1e_1))
    return false;
  if (!equals(this.i1e_1, other.i1e_1))
    return false;
  if (!equals(this.j1e_1, other.j1e_1))
    return false;
  if (!equals(this.k1e_1, other.k1e_1))
    return false;
  if (!(this.l1e_1 === other.l1e_1))
    return false;
  if (!equals(this.m1e_1, other.m1e_1))
    return false;
  if (!(this.n1e_1 === other.n1e_1))
    return false;
  if (!equals(this.o1e_1, other.o1e_1))
    return false;
  if (!(this.p1e_1 == other.p1e_1))
    return false;
  if (!equals(this.q1e_1, other.q1e_1))
    return false;
  if (!equals(this.r1e_1, other.r1e_1))
    return false;
  if (!equals(this.s1e_1, other.s1e_1))
    return false;
  if (!equals(this.t1e_1, other.t1e_1))
    return false;
  if (!(this.u1e_1 === other.u1e_1))
    return false;
  return true;
};
function ExerciseCatalogue() {
}
protoOf(ExerciseCatalogue).uf = function (json) {
  var root = Json_instance.uf(json);
  var tmp;
  if (!(root == null) ? isInterface(root, KtMap) : false) {
    var tmp_0 = JsonRead_instance;
    // Inline function 'kotlin.collections.get' call
    var key = 'exercises';
    var tmp$ret$0 = (isInterface(root, KtMap) ? root : THROW_CCE()).s1(key);
    tmp = tmp_0.yq(tmp$ret$0);
  } else {
    tmp = JsonRead_instance.yq(root);
  }
  var items = tmp;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = items.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$5;
    $l$block: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp_1;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$5 = null;
        break $l$block;
      } else {
        tmp_1 = tmp0_elvis_lhs;
      }
      var map = tmp_1;
      var tmp_2 = ExerciseCatalogue_instance;
      tmp$ret$5 = tmp_2.y1a(isInterface(map, KtMap) ? map : THROW_CCE());
    }
    var tmp0_safe_receiver = tmp$ret$5;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  return destination;
};
protoOf(ExerciseCatalogue).y1a = function (map) {
  var tmp0_safe_receiver = JsonRead_instance.iq(map, 'id');
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(tmp0_safe_receiver)) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_1;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_1 = tmp1_elvis_lhs;
  }
  var id = tmp_1;
  var tmp2_safe_receiver = JsonRead_instance.iq(map, 'name');
  var tmp_2;
  if (tmp2_safe_receiver == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_3;
    // Inline function 'kotlin.text.isNotBlank' call
    if (!isBlank(tmp2_safe_receiver)) {
      tmp_3 = tmp2_safe_receiver;
    } else {
      tmp_3 = null;
    }
    tmp_2 = tmp_3;
  }
  var tmp3_elvis_lhs = tmp_2;
  var tmp_4;
  if (tmp3_elvis_lhs == null) {
    return null;
  } else {
    tmp_4 = tmp3_elvis_lhs;
  }
  var name = tmp_4;
  var tmp_5 = Companion_instance_16.p19(JsonRead_instance.iq(map, 'equipment'));
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.m12(map, 'primaryMuscles');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp0_safe_receiver_0 = Companion_instance_15.j1a(element);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_6 = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_0 = JsonRead_instance.m12(map, 'secondaryMuscles');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = tmp0_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp0_safe_receiver_1 = Companion_instance_15.j1a(element_0);
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_1);
    }
  }
  var tmp_7 = destination_0;
  var tmp_8 = Companion_instance_19.p19(JsonRead_instance.iq(map, 'mechanic'));
  var tmp_9 = Companion_instance_20.p19(JsonRead_instance.iq(map, 'force'));
  var tmp4_elvis_lhs = JsonRead_instance.iq(map, 'category');
  var tmp_10 = tmp4_elvis_lhs == null ? 'strength' : tmp4_elvis_lhs;
  var tmp5_elvis_lhs = JsonRead_instance.jq(map, 'bodyweightFactor');
  var tmp_11 = tmp5_elvis_lhs == null ? 0.0 : tmp5_elvis_lhs;
  var tmp6_elvis_lhs = JsonRead_instance.ar(map, 'hidden');
  var tmp_12 = tmp6_elvis_lhs == null ? false : tmp6_elvis_lhs;
  var tmp_13 = Companion_getInstance_11().p19(JsonRead_instance.iq(map, 'region'));
  var tmp_14 = JsonRead_instance.iq(map, 'family');
  var tmp_15 = JsonRead_instance.m12(map, 'exclusionGroups');
  var tmp_16 = this.o1p(map.s1('rank'));
  var tmp_17 = JsonRead_instance.m12(map, 'preconditions');
  var tmp_18 = Companion_instance_23.p19(JsonRead_instance.iq(map, 'pattern'));
  var tmp7_elvis_lhs = JsonRead_instance.ar(map, 'unilateral');
  return new Exercise(id, name, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, tmp7_elvis_lhs == null ? false : tmp7_elvis_lhs);
};
protoOf(ExerciseCatalogue).o1p = function (value) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap) : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return emptyMap();
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var byGoal = tmp;
  var result = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = byGoal.v1().j();
  $l$loop: while (_iterator__ex2g4s.k()) {
    var _destruct__k2r9zo = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var goalKey = _destruct__k2r9zo.o1();
    // Inline function 'kotlin.collections.component2' call
    var slots = _destruct__k2r9zo.p1();
    var tmp0 = get_entries_36();
    var tmp$ret$3;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element = _iterator__ex2g4s_0.l();
        if (equals(element.e1p_1, goalKey)) {
          tmp$ret$3 = element;
          break $l$block;
        }
      }
      tmp$ret$3 = null;
    }
    var tmp1_elvis_lhs = tmp$ret$3;
    var tmp_0;
    if (tmp1_elvis_lhs == null) {
      continue $l$loop;
    } else {
      tmp_0 = tmp1_elvis_lhs;
    }
    var goal = tmp_0;
    var tmp2_safe_receiver = (!(slots == null) ? isInterface(slots, KtMap) : false) ? slots : null;
    var tmp3_safe_receiver = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.v1();
    var tmp_1;
    if (tmp3_safe_receiver == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_1 = tmp3_safe_receiver.j();
      while (_iterator__ex2g4s_1.k()) {
        var element_0 = _iterator__ex2g4s_1.l();
        var tmp$ret$9;
        $l$block_1: {
          // Inline function 'kotlin.collections.component1' call
          var slotKey = element_0.o1();
          // Inline function 'kotlin.collections.component2' call
          var rank = element_0.p1();
          var tmp_2 = Companion_instance_24;
          var tmp0_elvis_lhs_0 = tmp_2.p19((!(slotKey == null) ? typeof slotKey === 'string' : false) ? slotKey : null);
          var tmp_3;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$9 = null;
            break $l$block_1;
          } else {
            tmp_3 = tmp0_elvis_lhs_0;
          }
          var slot = tmp_3;
          var tmp1_safe_receiver = isNumber(rank) ? rank : null;
          var tmp2_safe_receiver_0 = tmp1_safe_receiver == null ? null : numberToDouble(tmp1_safe_receiver);
          var tmp_4;
          if (tmp2_safe_receiver_0 == null) {
            tmp_4 = null;
          } else {
            // Inline function 'kotlin.takeIf' call
            var tmp_5;
            if (1.0 <= tmp2_safe_receiver_0 ? tmp2_safe_receiver_0 <= 9.0 : false) {
              tmp_5 = tmp2_safe_receiver_0;
            } else {
              tmp_5 = null;
            }
            tmp_4 = tmp_5;
          }
          var tmp3_elvis_lhs = tmp_4;
          var tmp_6;
          if (tmp3_elvis_lhs == null) {
            tmp$ret$9 = null;
            break $l$block_1;
          } else {
            tmp_6 = tmp3_elvis_lhs;
          }
          var level = tmp_6;
          tmp$ret$9 = to(slot, level);
        }
        var tmp0_safe_receiver = tmp$ret$9;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination.f(tmp0_safe_receiver);
        }
      }
      tmp_1 = destination;
    }
    var tmp4_safe_receiver = tmp_1;
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs_1 = tmp4_safe_receiver == null ? null : toMap(tmp4_safe_receiver);
    var bySlot = tmp0_elvis_lhs_1 == null ? emptyMap() : tmp0_elvis_lhs_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!bySlot.m()) {
      // Inline function 'kotlin.collections.set' call
      result.k2(goal, bySlot);
    }
  }
  return result;
};
var ExerciseCatalogue_instance;
function ExerciseCatalogue_getInstance() {
  return ExerciseCatalogue_instance;
}
function Muscle_CHEST_getInstance() {
  static_init_55();
  return Muscle_CHEST_instance;
}
function Muscle_SHOULDERS_getInstance() {
  static_init_55();
  return Muscle_SHOULDERS_instance;
}
function Muscle_TRICEPS_getInstance() {
  static_init_55();
  return Muscle_TRICEPS_instance;
}
function Muscle_BICEPS_getInstance() {
  static_init_55();
  return Muscle_BICEPS_instance;
}
function Muscle_FOREARMS_getInstance() {
  static_init_55();
  return Muscle_FOREARMS_instance;
}
function Muscle_LATS_getInstance() {
  static_init_55();
  return Muscle_LATS_instance;
}
function Muscle_MIDDLE_BACK_getInstance() {
  static_init_55();
  return Muscle_MIDDLE_BACK_instance;
}
function Muscle_LOWER_BACK_getInstance() {
  static_init_55();
  return Muscle_LOWER_BACK_instance;
}
function Muscle_TRAPS_getInstance() {
  static_init_55();
  return Muscle_TRAPS_instance;
}
function Muscle_ABDOMINALS_getInstance() {
  static_init_55();
  return Muscle_ABDOMINALS_instance;
}
function Muscle_QUADRICEPS_getInstance() {
  static_init_55();
  return Muscle_QUADRICEPS_instance;
}
function Muscle_HAMSTRINGS_getInstance() {
  static_init_55();
  return Muscle_HAMSTRINGS_instance;
}
function Muscle_GLUTES_getInstance() {
  static_init_55();
  return Muscle_GLUTES_instance;
}
function Muscle_CALVES_getInstance() {
  static_init_55();
  return Muscle_CALVES_instance;
}
function Muscle_ADDUCTORS_getInstance() {
  static_init_55();
  return Muscle_ADDUCTORS_instance;
}
function Muscle_ABDUCTORS_getInstance() {
  static_init_55();
  return Muscle_ABDUCTORS_instance;
}
function Muscle_NECK_getInstance() {
  static_init_55();
  return Muscle_NECK_instance;
}
function Equipment_BARBELL_getInstance() {
  static_init_56();
  return Equipment_BARBELL_instance;
}
function Equipment_DUMBBELL_getInstance() {
  static_init_56();
  return Equipment_DUMBBELL_instance;
}
function Equipment_MACHINE_getInstance() {
  static_init_56();
  return Equipment_MACHINE_instance;
}
function Equipment_CABLE_getInstance() {
  static_init_56();
  return Equipment_CABLE_instance;
}
function Equipment_KETTLEBELL_getInstance() {
  static_init_56();
  return Equipment_KETTLEBELL_instance;
}
function Equipment_BODYWEIGHT_getInstance() {
  static_init_56();
  return Equipment_BODYWEIGHT_instance;
}
function Equipment_BAND_getInstance() {
  static_init_56();
  return Equipment_BAND_instance;
}
function Equipment_SMITH_getInstance() {
  static_init_56();
  return Equipment_SMITH_instance;
}
function Equipment_OTHER_getInstance() {
  static_init_56();
  return Equipment_OTHER_instance;
}
function SetType_STANDARD_getInstance() {
  static_init_57();
  return SetType_STANDARD_instance;
}
function SetType_WARMUP_getInstance() {
  static_init_57();
  return SetType_WARMUP_instance;
}
function SetType_DROP_getInstance() {
  static_init_57();
  return SetType_DROP_instance;
}
function SetType_MYO_getInstance() {
  static_init_57();
  return SetType_MYO_instance;
}
function SetType_FAILURE_getInstance() {
  static_init_57();
  return SetType_FAILURE_instance;
}
function ProgressionScheme_DOUBLE_getInstance() {
  static_init_58();
  return ProgressionScheme_DOUBLE_instance;
}
function ProgressionScheme_LINEAR_getInstance() {
  static_init_58();
  return ProgressionScheme_LINEAR_instance;
}
function ProgressionScheme_REVERSE_LINEAR_getInstance() {
  static_init_58();
  return ProgressionScheme_REVERSE_LINEAR_instance;
}
function ProgressionScheme_UNDULATING_getInstance() {
  static_init_58();
  return ProgressionScheme_UNDULATING_instance;
}
function ProgressionScheme_STATIC_getInstance() {
  static_init_58();
  return ProgressionScheme_STATIC_instance;
}
function Mechanic_COMPOUND_getInstance() {
  static_init_59();
  return Mechanic_COMPOUND_instance;
}
function Mechanic_ISOLATION_getInstance() {
  static_init_59();
  return Mechanic_ISOLATION_instance;
}
function Force_PUSH_getInstance() {
  static_init_60();
  return Force_PUSH_instance;
}
function Force_PULL_getInstance() {
  static_init_60();
  return Force_PULL_instance;
}
function Force_STATIC_getInstance() {
  static_init_60();
  return Force_STATIC_instance;
}
function TrainingGoal_STRENGTH_getInstance() {
  static_init_61();
  return TrainingGoal_STRENGTH_instance;
}
function TrainingGoal_HYPERTROPHY_getInstance() {
  static_init_61();
  return TrainingGoal_HYPERTROPHY_instance;
}
function DeloadPosition_NONE_getInstance() {
  static_init_62();
  return DeloadPosition_NONE_instance;
}
function DeloadPosition_FIRST_getInstance() {
  static_init_62();
  return DeloadPosition_FIRST_instance;
}
function DeloadPosition_LAST_getInstance() {
  static_init_62();
  return DeloadPosition_LAST_instance;
}
function MovementPattern_SQUAT_getInstance() {
  static_init_63();
  return MovementPattern_SQUAT_instance;
}
function MovementPattern_HINGE_getInstance() {
  static_init_63();
  return MovementPattern_HINGE_instance;
}
function MovementPattern_HORIZONTAL_PUSH_getInstance() {
  static_init_63();
  return MovementPattern_HORIZONTAL_PUSH_instance;
}
function MovementPattern_VERTICAL_PUSH_getInstance() {
  static_init_63();
  return MovementPattern_VERTICAL_PUSH_instance;
}
function MovementPattern_HORIZONTAL_PULL_getInstance() {
  static_init_63();
  return MovementPattern_HORIZONTAL_PULL_instance;
}
function MovementPattern_VERTICAL_PULL_getInstance() {
  static_init_63();
  return MovementPattern_VERTICAL_PULL_instance;
}
function ExerciseSlot_PRIMARY_getInstance() {
  static_init_64();
  return ExerciseSlot_PRIMARY_instance;
}
function ExerciseSlot_SECONDARY_getInstance() {
  static_init_64();
  return ExerciseSlot_SECONDARY_instance;
}
function ExerciseSlot_ACCESSORY_getInstance() {
  static_init_64();
  return ExerciseSlot_ACCESSORY_instance;
}
function TrainingSet(workoutId, day, exerciseId, order, type, loadKg, reps, rir, bodyweightKg) {
  rir = rir === VOID ? null : rir;
  bodyweightKg = bodyweightKg === VOID ? null : bodyweightKg;
  this.v1d_1 = workoutId;
  this.w1d_1 = day;
  this.x1d_1 = exerciseId;
  this.y1d_1 = order;
  this.z1d_1 = type;
  this.a1e_1 = loadKg;
  this.b1e_1 = reps;
  this.c1e_1 = rir;
  this.d1e_1 = bodyweightKg;
}
protoOf(TrainingSet).toString = function () {
  return 'TrainingSet(workoutId=' + this.v1d_1 + ', day=' + this.w1d_1 + ', exerciseId=' + this.x1d_1 + ', order=' + this.y1d_1 + ', type=' + this.z1d_1.toString() + ', loadKg=' + this.a1e_1 + ', reps=' + this.b1e_1 + ', rir=' + this.c1e_1 + ', bodyweightKg=' + this.d1e_1 + ')';
};
protoOf(TrainingSet).hashCode = function () {
  var result = getStringHashCode(this.v1d_1);
  result = imul(result, 31) + this.w1d_1 | 0;
  result = imul(result, 31) + getStringHashCode(this.x1d_1) | 0;
  result = imul(result, 31) + this.y1d_1 | 0;
  result = imul(result, 31) + this.z1d_1.hashCode() | 0;
  result = imul(result, 31) + getNumberHashCode(this.a1e_1) | 0;
  result = imul(result, 31) + this.b1e_1 | 0;
  result = imul(result, 31) + (this.c1e_1 == null ? 0 : this.c1e_1) | 0;
  result = imul(result, 31) + (this.d1e_1 == null ? 0 : getNumberHashCode(this.d1e_1)) | 0;
  return result;
};
protoOf(TrainingSet).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingSet))
    return false;
  if (!(this.v1d_1 === other.v1d_1))
    return false;
  if (!(this.w1d_1 === other.w1d_1))
    return false;
  if (!(this.x1d_1 === other.x1d_1))
    return false;
  if (!(this.y1d_1 === other.y1d_1))
    return false;
  if (!this.z1d_1.equals(other.z1d_1))
    return false;
  if (!equals(this.a1e_1, other.a1e_1))
    return false;
  if (!(this.b1e_1 === other.b1e_1))
    return false;
  if (!(this.c1e_1 == other.c1e_1))
    return false;
  if (!equals(this.d1e_1, other.d1e_1))
    return false;
  return true;
};
function RepMaxPoint(day, workoutId, kg) {
  this.p1p_1 = day;
  this.q1p_1 = workoutId;
  this.r1p_1 = kg;
}
protoOf(RepMaxPoint).toString = function () {
  return 'RepMaxPoint(day=' + this.p1p_1 + ', workoutId=' + this.q1p_1 + ', kg=' + this.r1p_1 + ')';
};
protoOf(RepMaxPoint).hashCode = function () {
  var result = this.p1p_1;
  result = imul(result, 31) + getStringHashCode(this.q1p_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.r1p_1) | 0;
  return result;
};
protoOf(RepMaxPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof RepMaxPoint))
    return false;
  if (!(this.p1p_1 === other.p1p_1))
    return false;
  if (!(this.q1p_1 === other.q1p_1))
    return false;
  if (!equals(this.r1p_1, other.r1p_1))
    return false;
  return true;
};
function WorkoutVolume(workoutId, day, sets, reps, externalVolumeKg, bodyweightVolumeKg) {
  this.s1p_1 = workoutId;
  this.t1p_1 = day;
  this.u1p_1 = sets;
  this.v1p_1 = reps;
  this.w1p_1 = externalVolumeKg;
  this.x1p_1 = bodyweightVolumeKg;
}
protoOf(WorkoutVolume).toString = function () {
  return 'WorkoutVolume(workoutId=' + this.s1p_1 + ', day=' + this.t1p_1 + ', sets=' + this.u1p_1 + ', reps=' + this.v1p_1 + ', externalVolumeKg=' + this.w1p_1 + ', bodyweightVolumeKg=' + this.x1p_1 + ')';
};
protoOf(WorkoutVolume).hashCode = function () {
  var result = getStringHashCode(this.s1p_1);
  result = imul(result, 31) + this.t1p_1 | 0;
  result = imul(result, 31) + this.u1p_1 | 0;
  result = imul(result, 31) + this.v1p_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.w1p_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.x1p_1) | 0;
  return result;
};
protoOf(WorkoutVolume).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WorkoutVolume))
    return false;
  if (!(this.s1p_1 === other.s1p_1))
    return false;
  if (!(this.t1p_1 === other.t1p_1))
    return false;
  if (!(this.u1p_1 === other.u1p_1))
    return false;
  if (!(this.v1p_1 === other.v1p_1))
    return false;
  if (!equals(this.w1p_1, other.w1p_1))
    return false;
  if (!equals(this.x1p_1, other.x1p_1))
    return false;
  return true;
};
function WeeklyVolume(weekStart, workouts, sets, reps, externalVolumeKg, bodyweightVolumeKg) {
  this.y1p_1 = weekStart;
  this.z1p_1 = workouts;
  this.a1q_1 = sets;
  this.b1q_1 = reps;
  this.c1q_1 = externalVolumeKg;
  this.d1q_1 = bodyweightVolumeKg;
}
protoOf(WeeklyVolume).toString = function () {
  return 'WeeklyVolume(weekStart=' + this.y1p_1 + ', workouts=' + this.z1p_1 + ', sets=' + this.a1q_1 + ', reps=' + this.b1q_1 + ', externalVolumeKg=' + this.c1q_1 + ', bodyweightVolumeKg=' + this.d1q_1 + ')';
};
protoOf(WeeklyVolume).hashCode = function () {
  var result = this.y1p_1;
  result = imul(result, 31) + this.z1p_1 | 0;
  result = imul(result, 31) + this.a1q_1 | 0;
  result = imul(result, 31) + this.b1q_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.c1q_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.d1q_1) | 0;
  return result;
};
protoOf(WeeklyVolume).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeeklyVolume))
    return false;
  if (!(this.y1p_1 === other.y1p_1))
    return false;
  if (!(this.z1p_1 === other.z1p_1))
    return false;
  if (!(this.a1q_1 === other.a1q_1))
    return false;
  if (!(this.b1q_1 === other.b1q_1))
    return false;
  if (!equals(this.c1q_1, other.c1q_1))
    return false;
  if (!equals(this.d1q_1, other.d1q_1))
    return false;
  return true;
};
var static_init_called_65;
function static_init_65() {
  if (static_init_called_65)
    return Unit_instance;
  static_init_called_65 = true;
  LevelsWindow_WEEK_instance = new LevelsWindow('WEEK', 0, 7);
  LevelsWindow_MONTH_instance = new LevelsWindow('MONTH', 1, 28);
  LevelsWindow_THREE_MONTHS_instance = new LevelsWindow('THREE_MONTHS', 2, 91);
}
var LevelsWindow_WEEK_instance;
var LevelsWindow_MONTH_instance;
var LevelsWindow_THREE_MONTHS_instance;
function LevelsWindow(name, ordinal, days) {
  Enum.call(this, name, ordinal);
  this.t1d_1 = days;
}
function working($this, sets) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (!element.z1d_1.equals(SetType_WARMUP_getInstance()) && element.b1e_1 > 0) {
      destination.f(element);
    }
  }
  return destination;
}
function bodyweightShare($this, set, factor) {
  var tmp0_elvis_lhs = set.d1e_1;
  // Inline function 'kotlin.math.max' call
  var b = (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) * factor;
  return Math.max(0.0, b);
}
function oneRepMax_1($this, set, factor, k) {
  return oneRepMax_2($this, set, factor, new EpleyCurve(k));
}
function oneRepMax_2($this, set, factor, curve) {
  var load = set.a1e_1 + bodyweightShare($this, set, factor);
  if (load <= 0.0 || set.b1e_1 <= 0)
    return null;
  var tmp0_elvis_lhs = set.c1e_1;
  // Inline function 'kotlin.math.max' call
  var b = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  var tmp$ret$0 = Math.max(0, b);
  return curve.l1m(load, set.b1e_1 + tmp$ret$0 | 0);
}
function sam$kotlin_Comparator$0_15(function_0) {
  this.e1q_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_15).y9 = function (a, b) {
  return this.e1q_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_15).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_15).g2 = function () {
  return this.e1q_1;
};
protoOf(sam$kotlin_Comparator$0_15).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_15).hashCode = function () {
  return hashCode(this.g2());
};
function sam$kotlin_Comparator$0_16(function_0) {
  this.f1q_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_16).y9 = function (a, b) {
  return this.f1q_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_16).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_16).g2 = function () {
  return this.f1q_1;
};
protoOf(sam$kotlin_Comparator$0_16).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_16).hashCode = function () {
  return hashCode(this.g2());
};
function sam$kotlin_Comparator$0_17(function_0) {
  this.g1q_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_17).y9 = function (a, b) {
  return this.g1q_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_17).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_17).g2 = function () {
  return this.g1q_1;
};
protoOf(sam$kotlin_Comparator$0_17).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_17).hashCode = function () {
  return hashCode(this.g2());
};
function sam$kotlin_Comparator$0_18(function_0) {
  this.h1q_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_18).y9 = function (a, b) {
  return this.h1q_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_18).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_18).g2 = function () {
  return this.h1q_1;
};
protoOf(sam$kotlin_Comparator$0_18).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_18).hashCode = function () {
  return hashCode(this.g2());
};
function TrainingAnalytics$repMaxSeries$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.p1p_1;
  var tmp$ret$2 = b.p1p_1;
  return compareValues(tmp, tmp$ret$2);
}
function TrainingAnalytics$repMaxSeries$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.q1p_1;
      var tmp$ret$2 = b.q1p_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function TrainingAnalytics$workoutVolumes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.t1p_1;
  var tmp$ret$2 = b.t1p_1;
  return compareValues(tmp, tmp$ret$2);
}
function TrainingAnalytics$workoutVolumes$lambda_0($this) {
  return function (a, b) {
    var previousCompare = $this.compare(a, b);
    var tmp;
    if (!(previousCompare === 0)) {
      tmp = previousCompare;
    } else {
      // Inline function 'kotlin.comparisons.compareValuesBy' call
      var tmp_0 = a.s1p_1;
      var tmp$ret$2 = b.s1p_1;
      tmp = compareValues(tmp_0, tmp$ret$2);
    }
    return tmp;
  };
}
function TrainingAnalytics$weeklyVolumes$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o1();
  var tmp$ret$2 = b.o1();
  return compareValues(tmp, tmp$ret$2);
}
function TrainingAnalytics$strengthIndex$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.o1();
  var tmp$ret$2 = b.o1();
  return compareValues(tmp, tmp$ret$2);
}
function TrainingAnalytics() {
  this.n1d_1 = 28;
}
protoOf(TrainingAnalytics).i1q = function (oneRepMaxKg, targetReps, k, curve) {
  // Inline function 'kotlin.require' call
  if (!(targetReps >= 1)) {
    var message = 'targetReps must be at least 1';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  return targetReps === 1 ? oneRepMaxKg : curve.z1m(oneRepMaxKg, targetReps);
};
protoOf(TrainingAnalytics).j1q = function (oneRepMaxKg, targetReps, k, curve, $super) {
  k = k === VOID ? 30.0 : k;
  curve = curve === VOID ? new EpleyCurve(k) : curve;
  return $super === VOID ? this.i1q(oneRepMaxKg, targetReps, k, curve) : $super.i1q.call(this, oneRepMaxKg, targetReps, k, curve);
};
protoOf(TrainingAnalytics).k1q = function (sets, exerciseId, targetReps, bodyweightFactor, k, curve) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = working(this, sets);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.x1d_1 === exerciseId) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = element_0.v1d_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.s1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.k2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = destination_0.v1().j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$13;
    $l$block: {
      // Inline function 'kotlin.collections.component1' call
      var workoutId = element_1.o1();
      // Inline function 'kotlin.collections.component2' call
      var session = element_1.p1();
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_2 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_2 = session.j();
      while (_iterator__ex2g4s_2.k()) {
        var element_2 = _iterator__ex2g4s_2.l();
        var tmp0_safe_receiver = oneRepMax_2(TrainingAnalytics_instance, element_2, bodyweightFactor, curve);
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_2.f(tmp0_safe_receiver);
        }
      }
      var tmp0_elvis_lhs = maxOrNull(destination_2);
      var tmp_0;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$13 = null;
        break $l$block;
      } else {
        tmp_0 = tmp0_elvis_lhs;
      }
      var best = tmp_0;
      // Inline function 'kotlin.collections.minOf' call
      var iterator = session.j();
      if (!iterator.k())
        throw NoSuchElementException_init_$Create$_0();
      var minValue = iterator.l().w1d_1;
      while (iterator.k()) {
        var v = iterator.l().w1d_1;
        if (compareTo(minValue, v) > 0) {
          minValue = v;
        }
      }
      var tmp$ret$23 = minValue;
      tmp$ret$13 = new RepMaxPoint(tmp$ret$23, workoutId, TrainingAnalytics_instance.j1q(best, targetReps, VOID, curve));
    }
    var tmp0_safe_receiver_0 = tmp$ret$13;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_1 = destination_1;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_2 = TrainingAnalytics$repMaxSeries$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_15(tmp_2);
  var tmp_3 = TrainingAnalytics$repMaxSeries$lambda_0(this_0);
  var tmp$ret$29 = new sam$kotlin_Comparator$0_15(tmp_3);
  return sortedWith(tmp_1, tmp$ret$29);
};
protoOf(TrainingAnalytics).l1q = function (sets, exerciseId, targetReps, bodyweightFactor, k, curve, $super) {
  targetReps = targetReps === VOID ? 1 : targetReps;
  bodyweightFactor = bodyweightFactor === VOID ? 0.0 : bodyweightFactor;
  k = k === VOID ? 30.0 : k;
  curve = curve === VOID ? new EpleyCurve(k) : curve;
  return $super === VOID ? this.k1q(sets, exerciseId, targetReps, bodyweightFactor, k, curve) : $super.k1q.call(this, sets, exerciseId, targetReps, bodyweightFactor, k, curve);
};
protoOf(TrainingAnalytics).m1q = function (sets, exercises) {
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0 = working(this, sets);
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key = element.v1d_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.s1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.k2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(destination.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = destination.v1().j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var workoutId = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var workout = item.p1();
    // Inline function 'kotlin.collections.minOf' call
    var iterator = workout.j();
    if (!iterator.k())
      throw NoSuchElementException_init_$Create$_0();
    var minValue = iterator.l().w1d_1;
    while (iterator.k()) {
      var v = iterator.l().w1d_1;
      if (compareTo(minValue, v) > 0) {
        minValue = v;
      }
    }
    var tmp_0 = minValue;
    var tmp_1 = workout.o();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_1 = workout.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      var tmp_2 = sum;
      sum = tmp_2 + element_0.b1e_1 | 0;
    }
    var tmp_3 = sum;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_2 = workout.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_4 = sum_0;
      sum_0 = tmp_4 + element_1.a1e_1 * element_1.b1e_1;
    }
    var tmp_5 = sum_0;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_1 = 0;
    var _iterator__ex2g4s_3 = workout.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_2 = _iterator__ex2g4s_3.l();
      var tmp_6 = sum_1;
      var tmp_7 = TrainingAnalytics_instance;
      var tmp0_safe_receiver = exercises.s1(element_2.x1d_1);
      var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m1e_1;
      sum_1 = tmp_6 + bodyweightShare(tmp_7, element_2, tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs) * element_2.b1e_1;
    }
    var tmp$ret$18 = sum_1;
    var tmp$ret$8 = new WorkoutVolume(workoutId, tmp_0, tmp_1, tmp_3, tmp_5, tmp$ret$18);
    destination_0.f(tmp$ret$8);
  }
  var tmp_8 = destination_0;
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_9 = TrainingAnalytics$workoutVolumes$lambda;
  // Inline function 'kotlin.comparisons.thenBy' call
  var this_0 = new sam$kotlin_Comparator$0_16(tmp_9);
  var tmp_10 = TrainingAnalytics$workoutVolumes$lambda_0(this_0);
  var tmp$ret$21 = new sam$kotlin_Comparator$0_16(tmp_10);
  return sortedWith(tmp_8, tmp$ret$21);
};
protoOf(TrainingAnalytics).n1q = function (sets, exercises) {
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0 = this.m1q(sets, exercises);
  // Inline function 'kotlin.collections.groupByTo' call
  var destination = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var key = EpochDays_getInstance().ud(element.t1p_1);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination.s1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination.k2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination.v1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = TrainingAnalytics$weeklyVolumes$lambda;
  var tmp$ret$6 = new sam$kotlin_Comparator$0_17(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$6);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var start = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var workouts = item.p1();
    var tmp_1 = workouts.o();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_1 = workouts.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      var tmp_2 = sum;
      sum = tmp_2 + element_0.u1p_1 | 0;
    }
    var tmp_3 = sum;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_0 = 0;
    var _iterator__ex2g4s_2 = workouts.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_4 = sum_0;
      sum_0 = tmp_4 + element_1.v1p_1 | 0;
    }
    var tmp_5 = sum_0;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_1 = 0;
    var _iterator__ex2g4s_3 = workouts.j();
    while (_iterator__ex2g4s_3.k()) {
      var element_2 = _iterator__ex2g4s_3.l();
      var tmp_6 = sum_1;
      sum_1 = tmp_6 + element_2.w1p_1;
    }
    var tmp_7 = sum_1;
    // Inline function 'kotlin.collections.sumOf' call
    var sum_2 = 0;
    var _iterator__ex2g4s_4 = workouts.j();
    while (_iterator__ex2g4s_4.k()) {
      var element_3 = _iterator__ex2g4s_4.l();
      var tmp_8 = sum_2;
      sum_2 = tmp_8 + element_3.x1p_1;
    }
    var tmp$ret$18 = sum_2;
    var tmp$ret$9 = new WeeklyVolume(start, tmp_1, tmp_3, tmp_5, tmp_7, tmp$ret$18);
    destination_0.f(tmp$ret$9);
  }
  return destination_0;
};
protoOf(TrainingAnalytics).o1d = function (sets, exercises, today, windowDays) {
  // Inline function 'kotlin.require' call
  if (!(windowDays > 0)) {
    var message = 'windowDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var totals = LinkedHashMap_init_$Create$_1();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = get_entries_30().j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.set' call
    totals.k2(element, 0.0);
  }
  var _iterator__ex2g4s_0 = working(this, sets).j();
  $l$loop_0: while (_iterator__ex2g4s_0.k()) {
    var set = _iterator__ex2g4s_0.l();
    if (set.w1d_1 > today || set.w1d_1 <= (today - windowDays | 0))
      continue $l$loop_0;
    var tmp0_elvis_lhs = exercises.s1(set.x1d_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      continue $l$loop_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var exercise = tmp;
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_1 = exercise.h1e_1.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_0 = _iterator__ex2g4s_1.l();
      // Inline function 'kotlin.collections.set' call
      var value = getValue(totals, element_0) + 1.0;
      totals.k2(element_0, value);
    }
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = exercise.i1e_1.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      // Inline function 'kotlin.collections.set' call
      var value_0 = getValue(totals, element_1) + 0.5;
      totals.k2(element_1, value_0);
    }
  }
  var weeks = windowDays / 7.0;
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination = LinkedHashMap_init_$Create$(mapCapacity(totals.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_3 = totals.v1().j();
  while (_iterator__ex2g4s_3.k()) {
    var element_2 = _iterator__ex2g4s_3.l();
    var tmp_0 = element_2.o1();
    var tmp$ret$15 = element_2.p1() / weeks;
    destination.k2(tmp_0, tmp$ret$15);
  }
  return destination;
};
protoOf(TrainingAnalytics).o1q = function (sets, today, windowDays) {
  // Inline function 'kotlin.require' call
  if (!(windowDays > 0)) {
    var message = 'windowDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0 = working(this, sets);
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.count' call
    var tmp;
    if (isInterface(tmp0, Collection)) {
      tmp = tmp0.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$2 = 0;
      break $l$block;
    }
    var count = 0;
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.w1d_1 <= today && element.w1d_1 > (today - windowDays | 0)) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$2 = count;
  }
  return tmp$ret$2 / (windowDays / 7.0);
};
protoOf(TrainingAnalytics).p1q = function (sets, today, windowDays, $super) {
  windowDays = windowDays === VOID ? 28 : windowDays;
  return $super === VOID ? this.o1q(sets, today, windowDays) : $super.o1q.call(this, sets, today, windowDays);
};
protoOf(TrainingAnalytics).q1q = function (sets, exercises, exerciseIds, fromDay, k) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = working(this, sets);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.w1d_1 >= fromDay && (exerciseIds == null || exerciseIds.r(element.x1d_1))) {
      destination.f(element);
    }
  }
  var relevant = destination;
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = relevant.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = to(element_0.x1d_1, element_0.w1d_1);
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.s1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.k2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_1 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = destination_0.v1().j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var key_0 = element_1.o1();
    // Inline function 'kotlin.collections.component2' call
    var group = element_1.p1();
    var tmp0_safe_receiver = exercises.s1(key_0.hb_1);
    var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.m1e_1;
    var factor = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_2 = ArrayList_init_$Create$_0();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_2 = group.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_2 = _iterator__ex2g4s_2.l();
      var tmp0_safe_receiver_0 = oneRepMax_1(TrainingAnalytics_instance, element_2, factor, k);
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_2.f(tmp0_safe_receiver_0);
      }
    }
    var tmp2_safe_receiver = maxOrNull(destination_2);
    var tmp_0;
    if (tmp2_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_0 = to(key_0, tmp2_safe_receiver);
    }
    var tmp0_safe_receiver_1 = tmp_0;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_1.f(tmp0_safe_receiver_1);
    }
  }
  var bestByExerciseAndDay = toMap(destination_1);
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0_0 = bestByExerciseAndDay.v1();
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_3 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_3 = tmp0_0.j();
  while (_iterator__ex2g4s_3.k()) {
    var element_3 = _iterator__ex2g4s_3.l();
    var key_1 = element_3.o1().hb_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value_0 = destination_3.s1(key_1);
    var tmp_1;
    if (value_0 == null) {
      var answer_0 = ArrayList_init_$Create$_0();
      destination_3.k2(key_1, answer_0);
      tmp_1 = answer_0;
    } else {
      tmp_1 = value_0;
    }
    var list_0 = tmp_1;
    list_0.f(element_3);
  }
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_4 = LinkedHashMap_init_$Create$(mapCapacity(destination_3.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_4 = destination_3.v1().j();
  while (_iterator__ex2g4s_4.k()) {
    var element_4 = _iterator__ex2g4s_4.l();
    var tmp_2 = element_4.o1();
    // Inline function 'kotlin.collections.component2' call
    var entries = element_4.p1();
    var tmp$ret$38;
    $l$block: {
      // Inline function 'kotlin.collections.minBy' call
      var iterator = entries.j();
      if (!iterator.k())
        throw NoSuchElementException_init_$Create$_0();
      var minElem = iterator.l();
      if (!iterator.k()) {
        tmp$ret$38 = minElem;
        break $l$block;
      }
      var minValue = minElem.o1().ib_1;
      do {
        var e = iterator.l();
        var v = e.o1().ib_1;
        if (compareTo(minValue, v) > 0) {
          minElem = e;
          minValue = v;
        }
      }
       while (iterator.k());
      tmp$ret$38 = minElem;
    }
    var tmp$ret$36 = tmp$ret$38.p1();
    destination_4.k2(tmp_2, tmp$ret$36);
  }
  var reference = destination_4;
  // Inline function 'kotlin.collections.groupBy' call
  var tmp0_1 = bestByExerciseAndDay.v1();
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_5 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_5 = tmp0_1.j();
  while (_iterator__ex2g4s_5.k()) {
    var element_5 = _iterator__ex2g4s_5.l();
    var key_2 = element_5.o1().ib_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value_1 = destination_5.s1(key_2);
    var tmp_3;
    if (value_1 == null) {
      var answer_1 = ArrayList_init_$Create$_0();
      destination_5.k2(key_2, answer_1);
      tmp_3 = answer_1;
    } else {
      tmp_3 = value_1;
    }
    var list_1 = tmp_3;
    list_1.f(element_5);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  var this_0 = destination_5.v1();
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_4 = TrainingAnalytics$strengthIndex$lambda;
  var tmp$ret$47 = new sam$kotlin_Comparator$0_18(tmp_4);
  // Inline function 'kotlin.collections.map' call
  var this_1 = sortedWith(this_0, tmp$ret$47);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_6 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_6 = this_1.j();
  while (_iterator__ex2g4s_6.k()) {
    var item = _iterator__ex2g4s_6.l();
    // Inline function 'kotlin.collections.component1' call
    var day = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var entries_0 = item.p1();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_7 = ArrayList_init_$Create$(collectionSizeOrDefault(entries_0, 10));
    var _iterator__ex2g4s_7 = entries_0.j();
    while (_iterator__ex2g4s_7.k()) {
      var item_0 = _iterator__ex2g4s_7.l();
      var tmp$ret$55 = item_0.p1() / getValue(reference, item_0.o1().hb_1) * 100.0;
      destination_7.f(tmp$ret$55);
    }
    var tmp$ret$50 = new StrengthIndexPoint(day, average(destination_7));
    destination_6.f(tmp$ret$50);
  }
  return destination_6;
};
protoOf(TrainingAnalytics).r1q = function (sets, exercises, exerciseIds, fromDay, k, $super) {
  exerciseIds = exerciseIds === VOID ? null : exerciseIds;
  fromDay = fromDay === VOID ? -2147483648 : fromDay;
  k = k === VOID ? 30.0 : k;
  return $super === VOID ? this.q1q(sets, exercises, exerciseIds, fromDay, k) : $super.q1q.call(this, sets, exercises, exerciseIds, fromDay, k);
};
var TrainingAnalytics_instance;
function TrainingAnalytics_getInstance() {
  return TrainingAnalytics_instance;
}
function LevelsWindow_WEEK_getInstance() {
  static_init_65();
  return LevelsWindow_WEEK_instance;
}
function TrainingBacktest() {
  TrainingBacktest_instance = this;
  this.z1j_1 = listOf(['date', 'workoutId', 'exercise', 'order', 'type', 'loadKg', 'reps', 'rir']);
  this.a1k_1 = listOf(['bodyweightKg', 'bodyweightFactor', 'region']);
  this.b1k_1 = 2.5;
  var tmp = this;
  var tmp_0 = to('EPLEY_K30', new TrainingSettings());
  var tmp_1 = to('FLOORED_EXP_FITTED', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, CurveModel_FLOORED_EXP_FITTED_getInstance()));
  var tmp_2 = to('CLAMP', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, true));
  var tmp_3 = to('FATIGUE_POWER_OURS', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, FatigueChoice_POWER_OURS_getInstance()));
  var tmp_4 = to('SURPRISE_SYMMETRIC', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, SurpriseCarry_SYMMETRIC_getInstance()));
  var tmp_5 = to('SURPRISE_ASYMMETRIC', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, SurpriseCarry_ASYMMETRIC_getInstance()));
  var tmp_6 = to('STEP_0.5', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 0.5));
  var tmp_7 = to('STEP_1', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 1.0));
  var tmp_8 = to('STEP_2', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, 2.0));
  var tmp0_curve = CurveModel_FLOORED_EXP_FITTED_getInstance();
  var tmp1_fatigue = FatigueChoice_POWER_OURS_getInstance();
  var tmp2_surprise = SurpriseCarry_ASYMMETRIC_getInstance();
  tmp.c1k_1 = linkedMapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, to('OURS_ALL', new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_curve, tmp1_fatigue, tmp2_surprise, true, 1.0))]);
}
protoOf(TrainingBacktest).d1k = function (line) {
  var result = ArrayList_init_$Create$_0();
  var current = StringBuilder_init_$Create$();
  var quoted = false;
  var i = 0;
  while (i < line.length) {
    var c = charCodeAt(line, i);
    var tmp;
    if (quoted && c === _Char___init__impl__6a9atx(34)) {
      var tmp_0 = getOrNull(line, i + 1 | 0);
      tmp = equals(tmp_0 == null ? null : new Char(tmp_0), new Char(_Char___init__impl__6a9atx(34)));
    } else {
      tmp = false;
    }
    if (tmp) {
      current.o6(_Char___init__impl__6a9atx(34));
      i = i + 1 | 0;
    } else {
      if (c === _Char___init__impl__6a9atx(34)) {
        quoted = !quoted;
      } else {
        if (c === _Char___init__impl__6a9atx(44) && !quoted) {
          result.f(current.toString());
          current.i8();
        } else {
          current.o6(c);
        }
      }
    }
    i = i + 1 | 0;
  }
  result.f(current.toString());
  return result;
};
var TrainingBacktest_instance;
function TrainingBacktest_getInstance() {
  if (TrainingBacktest_instance == null)
    new TrainingBacktest();
  return TrainingBacktest_instance;
}
var static_init_called_66;
function static_init_66() {
  if (static_init_called_66)
    return Unit_instance;
  static_init_called_66 = true;
  Kind_AUTO_instance = new Kind('AUTO', 0);
  Kind_SMART_instance = new Kind('SMART', 1);
  Kind_NONE_instance = new Kind('NONE', 2);
  Kind_CUSTOM_instance = new Kind('CUSTOM', 3);
}
var Kind_AUTO_instance;
var Kind_SMART_instance;
var Kind_NONE_instance;
var Kind_CUSTOM_instance;
function Kind(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Companion_23() {
  Companion_instance_25 = this;
  this.l1i_1 = new WarmupSpec(Kind_AUTO_getInstance());
  this.m1i_1 = new WarmupSpec(Kind_SMART_getInstance());
  this.n1i_1 = new WarmupSpec(Kind_NONE_getInstance());
}
protoOf(Companion_23).s1q = function (value) {
  var tmp;
  if (equals(value, 'none')) {
    tmp = this.n1i_1;
  } else {
    if (equals(value, 'smart')) {
      tmp = this.m1i_1;
    } else {
      if (!(value == null) ? isInterface(value, KtList) : false) {
        var tmp_0 = Kind_CUSTOM_getInstance();
        // Inline function 'kotlin.collections.mapNotNull' call
        // Inline function 'kotlin.collections.mapNotNullTo' call
        var destination = ArrayList_init_$Create$_0();
        // Inline function 'kotlin.collections.forEach' call
        var _iterator__ex2g4s = value.j();
        while (_iterator__ex2g4s.k()) {
          var element = _iterator__ex2g4s.l();
          var tmp$ret$4;
          $l$block_1: {
            var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
            var tmp_1;
            if (tmp0_elvis_lhs == null) {
              tmp$ret$4 = null;
              break $l$block_1;
            } else {
              tmp_1 = tmp0_elvis_lhs;
            }
            var map = tmp_1;
            var tmp1_elvis_lhs = JsonRead_instance.jq(map, 'pct');
            var tmp_2;
            if (tmp1_elvis_lhs == null) {
              tmp$ret$4 = null;
              break $l$block_1;
            } else {
              tmp_2 = tmp1_elvis_lhs;
            }
            var pct = tmp_2;
            var tmp2_elvis_lhs = JsonRead_instance.xq(map, 'reps');
            var tmp_3;
            if (tmp2_elvis_lhs == null) {
              tmp$ret$4 = null;
              break $l$block_1;
            } else {
              tmp_3 = tmp2_elvis_lhs;
            }
            var reps = tmp_3;
            // Inline function 'kotlin.takeIf' call
            var this_0 = new WarmupStep(pct, reps);
            var tmp_4;
            if (pct > 0.0 && reps > 0) {
              tmp_4 = this_0;
            } else {
              tmp_4 = null;
            }
            tmp$ret$4 = tmp_4;
          }
          var tmp0_safe_receiver = tmp$ret$4;
          if (tmp0_safe_receiver == null)
            null;
          else {
            // Inline function 'kotlin.let' call
            destination.f(tmp0_safe_receiver);
          }
        }
        tmp = new WarmupSpec(tmp_0, destination);
      } else {
        tmp = this.l1i_1;
      }
    }
  }
  return tmp;
};
protoOf(Companion_23).t1q = function (spec) {
  var tmp;
  switch (spec.h1j_1.x1_1) {
    case 0:
      tmp = 'auto';
      break;
    case 1:
      tmp = 'smart';
      break;
    case 2:
      tmp = 'none';
      break;
    case 3:
      // Inline function 'kotlin.collections.map' call

      var this_0 = spec.i1j_1;
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.j();
      while (_iterator__ex2g4s.k()) {
        var item = _iterator__ex2g4s.l();
        var tmp$ret$2 = linkedMapOf([to('pct', item.u1q_1), to('reps', item.v1q_1)]);
        destination.f(tmp$ret$2);
      }

      tmp = destination;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var Companion_instance_25;
function Companion_getInstance_22() {
  if (Companion_instance_25 == null)
    new Companion_23();
  return Companion_instance_25;
}
function Kind_AUTO_getInstance() {
  static_init_66();
  return Kind_AUTO_instance;
}
function Kind_SMART_getInstance() {
  static_init_66();
  return Kind_SMART_instance;
}
function Kind_NONE_getInstance() {
  static_init_66();
  return Kind_NONE_instance;
}
function Kind_CUSTOM_getInstance() {
  static_init_66();
  return Kind_CUSTOM_instance;
}
function WarmupSpec(kind, steps) {
  Companion_getInstance_22();
  steps = steps === VOID ? emptyList() : steps;
  this.h1j_1 = kind;
  this.i1j_1 = steps;
}
protoOf(WarmupSpec).toString = function () {
  return 'WarmupSpec(kind=' + this.h1j_1.toString() + ', steps=' + toString(this.i1j_1) + ')';
};
protoOf(WarmupSpec).hashCode = function () {
  var result = this.h1j_1.hashCode();
  result = imul(result, 31) + hashCode(this.i1j_1) | 0;
  return result;
};
protoOf(WarmupSpec).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WarmupSpec))
    return false;
  if (!this.h1j_1.equals(other.h1j_1))
    return false;
  if (!equals(this.i1j_1, other.i1j_1))
    return false;
  return true;
};
var static_init_called_67;
function static_init_67() {
  if (static_init_called_67)
    return Unit_instance;
  static_init_called_67 = true;
  GroupKind_SUPERSET_instance = new GroupKind('SUPERSET', 0, 'superset');
  GroupKind_CIRCUIT_instance = new GroupKind('CIRCUIT', 1, 'circuit');
  if (Companion_instance_26 == null) {
    Companion_instance_0;
    new Companion_24();
  }
}
var GroupKind_SUPERSET_instance;
var GroupKind_CIRCUIT_instance;
function Companion_24() {
}
protoOf(Companion_24).p19 = function (key) {
  var tmp0 = get_entries_40();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.y1q_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_26;
function Companion_getInstance_23() {
  return Companion_instance_26;
}
function values_45() {
  static_init_67();
  return [GroupKind_SUPERSET_getInstance(), GroupKind_CIRCUIT_getInstance()];
}
function get_entries_40() {
  static_init_67();
  if ($ENTRIES_40 == null)
    $ENTRIES_40 = enumEntries(values_45());
  return $ENTRIES_40;
}
var $ENTRIES_40;
function GroupKind(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.y1q_1 = key;
}
function ProgramExercise(exerciseId, restSec, warmup, progression, cycles, supersetGroup, deload, groupKind) {
  supersetGroup = supersetGroup === VOID ? null : supersetGroup;
  deload = deload === VOID ? null : deload;
  groupKind = groupKind === VOID ? null : groupKind;
  this.y1i_1 = exerciseId;
  this.z1i_1 = restSec;
  this.a1j_1 = warmup;
  this.b1j_1 = progression;
  this.c1j_1 = cycles;
  this.d1j_1 = supersetGroup;
  this.e1j_1 = deload;
  this.f1j_1 = groupKind;
}
protoOf(ProgramExercise).g1j = function (cycle) {
  return this.c1j_1.n(coerceIn_0(cycle, 0, this.c1j_1.o() - 1 | 0));
};
protoOf(ProgramExercise).toString = function () {
  return 'ProgramExercise(exerciseId=' + this.y1i_1 + ', restSec=' + this.z1i_1 + ', warmup=' + this.a1j_1.toString() + ', progression=' + this.b1j_1.toString() + ', cycles=' + toString(this.c1j_1) + ', supersetGroup=' + this.d1j_1 + ', deload=' + toString_0(this.e1j_1) + ', groupKind=' + toString_0(this.f1j_1) + ')';
};
protoOf(ProgramExercise).hashCode = function () {
  var result = getStringHashCode(this.y1i_1);
  result = imul(result, 31) + this.z1i_1 | 0;
  result = imul(result, 31) + this.a1j_1.hashCode() | 0;
  result = imul(result, 31) + this.b1j_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.c1j_1) | 0;
  result = imul(result, 31) + (this.d1j_1 == null ? 0 : getStringHashCode(this.d1j_1)) | 0;
  result = imul(result, 31) + (this.e1j_1 == null ? 0 : this.e1j_1.hashCode()) | 0;
  result = imul(result, 31) + (this.f1j_1 == null ? 0 : this.f1j_1.hashCode()) | 0;
  return result;
};
protoOf(ProgramExercise).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProgramExercise))
    return false;
  if (!(this.y1i_1 === other.y1i_1))
    return false;
  if (!(this.z1i_1 === other.z1i_1))
    return false;
  if (!this.a1j_1.equals(other.a1j_1))
    return false;
  if (!this.b1j_1.equals(other.b1j_1))
    return false;
  if (!equals(this.c1j_1, other.c1j_1))
    return false;
  if (!(this.d1j_1 == other.d1j_1))
    return false;
  if (!equals(this.e1j_1, other.e1j_1))
    return false;
  if (!equals(this.f1j_1, other.f1j_1))
    return false;
  return true;
};
function ProgramDay(name, exercises, gymId) {
  gymId = gymId === VOID ? null : gymId;
  this.m1g_1 = name;
  this.n1g_1 = exercises;
  this.o1g_1 = gymId;
}
protoOf(ProgramDay).z1q = function (name, exercises, gymId) {
  return new ProgramDay(name, exercises, gymId);
};
protoOf(ProgramDay).p1g = function (name, exercises, gymId, $super) {
  name = name === VOID ? this.m1g_1 : name;
  exercises = exercises === VOID ? this.n1g_1 : exercises;
  gymId = gymId === VOID ? this.o1g_1 : gymId;
  return $super === VOID ? this.z1q(name, exercises, gymId) : $super.z1q.call(this, name, exercises, gymId);
};
protoOf(ProgramDay).toString = function () {
  return 'ProgramDay(name=' + this.m1g_1 + ', exercises=' + toString(this.n1g_1) + ', gymId=' + this.o1g_1 + ')';
};
protoOf(ProgramDay).hashCode = function () {
  var result = getStringHashCode(this.m1g_1);
  result = imul(result, 31) + hashCode(this.n1g_1) | 0;
  result = imul(result, 31) + (this.o1g_1 == null ? 0 : getStringHashCode(this.o1g_1)) | 0;
  return result;
};
protoOf(ProgramDay).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof ProgramDay))
    return false;
  if (!(this.m1g_1 === other.m1g_1))
    return false;
  if (!equals(this.n1g_1, other.n1g_1))
    return false;
  if (!(this.o1g_1 == other.o1g_1))
    return false;
  return true;
};
function TrainingProgram(name, goal, cycles, deload, days, endBehaviour, archived, nextProgramId) {
  endBehaviour = endBehaviour === VOID ? 'repeat' : endBehaviour;
  archived = archived === VOID ? false : archived;
  nextProgramId = nextProgramId === VOID ? null : nextProgramId;
  this.q1i_1 = name;
  this.r1i_1 = goal;
  this.s1i_1 = cycles;
  this.t1i_1 = deload;
  this.u1i_1 = days;
  this.v1i_1 = endBehaviour;
  this.w1i_1 = archived;
  this.x1i_1 = nextProgramId;
}
protoOf(TrainingProgram).toString = function () {
  return 'TrainingProgram(name=' + this.q1i_1 + ', goal=' + this.r1i_1.toString() + ', cycles=' + this.s1i_1 + ', deload=' + this.t1i_1.toString() + ', days=' + toString(this.u1i_1) + ', endBehaviour=' + this.v1i_1 + ', archived=' + this.w1i_1 + ', nextProgramId=' + this.x1i_1 + ')';
};
protoOf(TrainingProgram).hashCode = function () {
  var result = getStringHashCode(this.q1i_1);
  result = imul(result, 31) + this.r1i_1.hashCode() | 0;
  result = imul(result, 31) + this.s1i_1 | 0;
  result = imul(result, 31) + this.t1i_1.hashCode() | 0;
  result = imul(result, 31) + hashCode(this.u1i_1) | 0;
  result = imul(result, 31) + getStringHashCode(this.v1i_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.w1i_1) | 0;
  result = imul(result, 31) + (this.x1i_1 == null ? 0 : getStringHashCode(this.x1i_1)) | 0;
  return result;
};
protoOf(TrainingProgram).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingProgram))
    return false;
  if (!(this.q1i_1 === other.q1i_1))
    return false;
  if (!this.r1i_1.equals(other.r1i_1))
    return false;
  if (!(this.s1i_1 === other.s1i_1))
    return false;
  if (!this.t1i_1.equals(other.t1i_1))
    return false;
  if (!equals(this.u1i_1, other.u1i_1))
    return false;
  if (!(this.v1i_1 === other.v1i_1))
    return false;
  if (!(this.w1i_1 === other.w1i_1))
    return false;
  if (!(this.x1i_1 == other.x1i_1))
    return false;
  return true;
};
function cycleJson($this, it) {
  // Inline function 'kotlin.apply' call
  var this_0 = linkedMapOf([to('sets', it.b1f_1), to('repMin', it.c1f_1), to('repMax', it.d1f_1), to('rir', it.e1f_1), to('setType', it.f1f_1.s1o_1)]);
  if (it.g1f_1) {
    this_0.k2('skip', true);
  }
  return this_0;
}
function cycle($this, value) {
  var tmp0_elvis_lhs = (!(value == null) ? isInterface(value, KtMap) : false) ? value : null;
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var cycle = tmp;
  // Inline function 'kotlin.runCatching' call
  var tmp_0;
  try {
    var tmp0_elvis_lhs_0 = JsonRead_instance.xq(cycle, 'sets');
    var tmp_1;
    if (tmp0_elvis_lhs_0 == null) {
      return null;
    } else {
      tmp_1 = tmp0_elvis_lhs_0;
    }
    var tmp_2 = tmp_1;
    var tmp1_elvis_lhs = JsonRead_instance.xq(cycle, 'repMin');
    var tmp_3;
    if (tmp1_elvis_lhs == null) {
      return null;
    } else {
      tmp_3 = tmp1_elvis_lhs;
    }
    var tmp_4 = tmp_3;
    var tmp2_elvis_lhs = JsonRead_instance.xq(cycle, 'repMax');
    var tmp_5;
    if (tmp2_elvis_lhs == null) {
      return null;
    } else {
      tmp_5 = tmp2_elvis_lhs;
    }
    var tmp_6 = tmp_5;
    var tmp3_elvis_lhs = JsonRead_instance.xq(cycle, 'rir');
    var tmp_7 = tmp3_elvis_lhs == null ? 2 : tmp3_elvis_lhs;
    var tmp_8 = Companion_instance_17.p19(JsonRead_instance.iq(cycle, 'setType'));
    var tmp4_elvis_lhs = JsonRead_instance.ar(cycle, 'skip');
    // Inline function 'kotlin.Companion.success' call
    var value_0 = new CyclePrescription(tmp_2, tmp_4, tmp_6, tmp_7, tmp_8, tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs);
    tmp_0 = _Result___init__impl__xyqfz8(value_0);
  } catch ($p) {
    var tmp_9;
    if ($p instanceof Error) {
      var e = $p;
      // Inline function 'kotlin.Companion.failure' call
      tmp_9 = _Result___init__impl__xyqfz8(createFailure(e));
    } else {
      throw $p;
    }
    tmp_0 = tmp_9;
  }
  // Inline function 'kotlin.Result.getOrNull' call
  var this_0 = tmp_0;
  return _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
}
function TrainingProgramJson() {
}
protoOf(TrainingProgramJson).a1r = function (program, active, startDate) {
  var tmp = Json_instance;
  var tmp_0 = to('name', program.q1i_1);
  var tmp_1 = to('goal', program.r1i_1.e1p_1);
  var tmp_2 = to('active', active);
  var tmp_3 = to('startDate', startDate);
  var tmp_4 = to('cycles', program.s1i_1);
  var tmp_5 = to('deload', program.t1i_1.h1p_1);
  var tmp_6 = to('endBehaviour', program.v1i_1);
  var tmp_7 = to('repeat', program.v1i_1 === 'stop' ? 'ONCE' : 'FOREVER');
  var tmp_8 = to('archived', program.w1i_1);
  var tmp_9 = to('nextProgramId', program.x1i_1);
  // Inline function 'kotlin.collections.map' call
  var this_0 = program.u1i_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp_10 = to('name', item.m1g_1);
    // Inline function 'kotlin.collections.map' call
    var this_1 = item.n1g_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp_11 = to('exerciseId', item_0.y1i_1);
      var tmp_12 = to('supersetGroup', item_0.d1j_1);
      var tmp_13 = to('restSec', item_0.z1i_1);
      var tmp_14 = to('warmup', Companion_getInstance_22().t1q(item_0.a1j_1));
      var tmp_15 = to('progression', item_0.b1j_1.v1o_1);
      // Inline function 'kotlin.collections.map' call
      var this_2 = item_0.c1j_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
      var _iterator__ex2g4s_1 = this_2.j();
      while (_iterator__ex2g4s_1.k()) {
        var item_1 = _iterator__ex2g4s_1.l();
        var tmp$ret$8 = cycleJson(TrainingProgramJson_instance, item_1);
        destination_1.f(tmp$ret$8);
      }
      // Inline function 'kotlin.apply' call
      var this_3 = linkedMapOf([tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, to('cycles', destination_1)]);
      var tmp0_safe_receiver = item_0.e1j_1;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this_3.k2('deload', cycleJson(TrainingProgramJson_instance, tmp0_safe_receiver));
      }
      var tmp1_safe_receiver = item_0.f1j_1;
      if (tmp1_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        this_3.k2('groupKind', tmp1_safe_receiver.y1q_1);
      }
      destination_0.f(this_3);
    }
    // Inline function 'kotlin.apply' call
    var this_4 = linkedMapOf([tmp_10, to('exercises', destination_0)]);
    var tmp0_safe_receiver_0 = item.o1g_1;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      this_4.k2('gymId', tmp0_safe_receiver_0);
    }
    destination.f(this_4);
  }
  return tmp.zf(linkedMapOf([tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, to('days', destination)]));
};
protoOf(TrainingProgramJson).b1r = function (program, active, startDate, $super) {
  active = active === VOID ? false : active;
  startDate = startDate === VOID ? null : startDate;
  return $super === VOID ? this.a1r(program, active, startDate) : $super.a1r.call(this, program, active, startDate);
};
protoOf(TrainingProgramJson).c1r = function (json) {
  var map = JsonRead_instance.vf(Json_instance.uf(json), 'TPROG');
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = JsonRead_instance.yq(map.s1('days'));
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4;
    $l$block: {
      var tmp0_elvis_lhs = (!(element == null) ? isInterface(element, KtMap) : false) ? element : null;
      var tmp;
      if (tmp0_elvis_lhs == null) {
        tmp$ret$4 = null;
        break $l$block;
      } else {
        tmp = tmp0_elvis_lhs;
      }
      var day = tmp;
      var tmp1_elvis_lhs = JsonRead_instance.iq(day, 'name');
      var tmp_0 = tmp1_elvis_lhs == null ? 'Day' : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.mapNotNull' call
      var tmp0_0 = JsonRead_instance.yq(day.s1('exercises'));
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var destination_0 = ArrayList_init_$Create$_0();
      // Inline function 'kotlin.collections.forEach' call
      var _iterator__ex2g4s_0 = tmp0_0.j();
      while (_iterator__ex2g4s_0.k()) {
        var element_0 = _iterator__ex2g4s_0.l();
        var tmp$ret$9;
        $l$block_2: {
          var tmp0_elvis_lhs_0 = (!(element_0 == null) ? isInterface(element_0, KtMap) : false) ? element_0 : null;
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$9 = null;
            break $l$block_2;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var exercise = tmp_1;
          var tmp1_elvis_lhs_0 = JsonRead_instance.iq(exercise, 'exerciseId');
          var tmp_2;
          if (tmp1_elvis_lhs_0 == null) {
            tmp$ret$9 = null;
            break $l$block_2;
          } else {
            tmp_2 = tmp1_elvis_lhs_0;
          }
          var id = tmp_2;
          // Inline function 'kotlin.collections.mapNotNull' call
          var tmp0_1 = JsonRead_instance.yq(exercise.s1('cycles'));
          // Inline function 'kotlin.collections.mapNotNullTo' call
          var destination_1 = ArrayList_init_$Create$_0();
          // Inline function 'kotlin.collections.forEach' call
          var _iterator__ex2g4s_1 = tmp0_1.j();
          while (_iterator__ex2g4s_1.k()) {
            var element_1 = _iterator__ex2g4s_1.l();
            var tmp0_safe_receiver = cycle(TrainingProgramJson_instance, element_1);
            if (tmp0_safe_receiver == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              destination_1.f(tmp0_safe_receiver);
            }
          }
          var cycles = destination_1;
          if (cycles.m()) {
            tmp$ret$9 = null;
            break $l$block_2;
          }
          var tmp2_elvis_lhs = JsonRead_instance.xq(exercise, 'restSec');
          tmp$ret$9 = new ProgramExercise(id, tmp2_elvis_lhs == null ? 120 : tmp2_elvis_lhs, Companion_getInstance_22().s1q(exercise.s1('warmup')), Companion_instance_18.p19(JsonRead_instance.iq(exercise, 'progression')), cycles, JsonRead_instance.iq(exercise, 'supersetGroup'), cycle(TrainingProgramJson_instance, exercise.s1('deload')), Companion_instance_26.p19(JsonRead_instance.iq(exercise, 'groupKind')));
        }
        var tmp0_safe_receiver_0 = tmp$ret$9;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          destination_0.f(tmp0_safe_receiver_0);
        }
      }
      tmp$ret$4 = new ProgramDay(tmp_0, destination_0, JsonRead_instance.iq(day, 'gymId'));
    }
    var tmp0_safe_receiver_1 = tmp$ret$4;
    if (tmp0_safe_receiver_1 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver_1);
    }
  }
  var days = destination;
  var tmp0_elvis_lhs_1 = JsonRead_instance.iq(map, 'endBehaviour');
  var tmp_3;
  if (tmp0_elvis_lhs_1 == null) {
    tmp_3 = JsonRead_instance.iq(map, 'repeat') === 'ONCE' ? 'stop' : 'repeat';
  } else {
    tmp_3 = tmp0_elvis_lhs_1;
  }
  var endBehaviour = tmp_3;
  var tmp2_elvis_lhs_0 = JsonRead_instance.iq(map, 'name');
  var tmp_4 = tmp2_elvis_lhs_0 == null ? 'Program' : tmp2_elvis_lhs_0;
  var tmp_5 = Companion_instance_21.p19(JsonRead_instance.iq(map, 'goal'));
  var tmp3_elvis_lhs = JsonRead_instance.xq(map, 'cycles');
  var tmp_6 = coerceAtLeast(tmp3_elvis_lhs == null ? 1 : tmp3_elvis_lhs, 1);
  var tmp_7 = Companion_instance_22.p19(JsonRead_instance.iq(map, 'deload'));
  var tmp4_elvis_lhs = JsonRead_instance.ar(map, 'archived');
  return new TrainingProgram(tmp_4, tmp_5, tmp_6, tmp_7, days, endBehaviour, tmp4_elvis_lhs == null ? false : tmp4_elvis_lhs, JsonRead_instance.iq(map, 'nextProgramId'));
};
var TrainingProgramJson_instance;
function TrainingProgramJson_getInstance() {
  return TrainingProgramJson_instance;
}
function GroupKind_SUPERSET_getInstance() {
  static_init_67();
  return GroupKind_SUPERSET_instance;
}
function GroupKind_CIRCUIT_getInstance() {
  static_init_67();
  return GroupKind_CIRCUIT_instance;
}
var static_init_called_68;
function static_init_68() {
  if (static_init_called_68)
    return Unit_instance;
  static_init_called_68 = true;
  Prefill_SMART_instance = new Prefill('SMART', 0);
  Prefill_PREVIOUS_instance = new Prefill('PREVIOUS', 1);
}
var Prefill_SMART_instance;
var Prefill_PREVIOUS_instance;
function values_46() {
  static_init_68();
  return [Prefill_SMART_getInstance(), Prefill_PREVIOUS_getInstance()];
}
function get_entries_41() {
  static_init_68();
  if ($ENTRIES_41 == null)
    $ENTRIES_41 = enumEntries(values_46());
  return $ENTRIES_41;
}
var $ENTRIES_41;
function Prefill(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_69;
function static_init_69() {
  if (static_init_called_69)
    return Unit_instance;
  static_init_called_69 = true;
  PreviousScope_ANY_instance = new PreviousScope('ANY', 0);
  PreviousScope_PROGRAM_instance = new PreviousScope('PROGRAM', 1);
}
var PreviousScope_ANY_instance;
var PreviousScope_PROGRAM_instance;
function values_47() {
  static_init_69();
  return [PreviousScope_ANY_getInstance(), PreviousScope_PROGRAM_getInstance()];
}
function get_entries_42() {
  static_init_69();
  if ($ENTRIES_42 == null)
    $ENTRIES_42 = enumEntries(values_47());
  return $ENTRIES_42;
}
var $ENTRIES_42;
function PreviousScope(name, ordinal) {
  Enum.call(this, name, ordinal);
}
var static_init_called_70;
function static_init_70() {
  if (static_init_called_70)
    return Unit_instance;
  static_init_called_70 = true;
  WarmupCategory_UPPER_COMPOUND_instance = new WarmupCategory('UPPER_COMPOUND', 0, 'upperCompound');
  WarmupCategory_LOWER_COMPOUND_instance = new WarmupCategory('LOWER_COMPOUND', 1, 'lowerCompound');
  WarmupCategory_UPPER_ISOLATION_instance = new WarmupCategory('UPPER_ISOLATION', 2, 'upperIsolation');
  WarmupCategory_LOWER_ISOLATION_instance = new WarmupCategory('LOWER_ISOLATION', 3, 'lowerIsolation');
  WarmupCategory_CORE_instance = new WarmupCategory('CORE', 4, 'core');
  if (Companion_instance_27 == null) {
    Companion_instance_0;
    new Companion_25();
  }
}
var WarmupCategory_UPPER_COMPOUND_instance;
var WarmupCategory_LOWER_COMPOUND_instance;
var WarmupCategory_UPPER_ISOLATION_instance;
var WarmupCategory_LOWER_ISOLATION_instance;
var WarmupCategory_CORE_instance;
function Companion_25() {
}
protoOf(Companion_25).p19 = function (key) {
  var tmp0 = get_entries_43();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.f1r_1 === key) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp$ret$0;
};
var Companion_instance_27;
function Companion_getInstance_24() {
  return Companion_instance_27;
}
function values_48() {
  static_init_70();
  return [WarmupCategory_UPPER_COMPOUND_getInstance(), WarmupCategory_LOWER_COMPOUND_getInstance(), WarmupCategory_UPPER_ISOLATION_getInstance(), WarmupCategory_LOWER_ISOLATION_getInstance(), WarmupCategory_CORE_getInstance()];
}
function get_entries_43() {
  static_init_70();
  if ($ENTRIES_43 == null)
    $ENTRIES_43 = enumEntries(values_48());
  return $ENTRIES_43;
}
var $ENTRIES_43;
function WarmupCategory(name, ordinal, key) {
  Enum.call(this, name, ordinal);
  this.f1r_1 = key;
}
function Companion_26() {
}
protoOf(Companion_26).x1j = function (rpe) {
  // Inline function 'kotlin.math.floor' call
  var x = 10.0 - rpe + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return coerceIn_0(numberToInt(tmp$ret$0), 0, 10);
};
var Companion_instance_28;
function Companion_getInstance_25() {
  return Companion_instance_28;
}
function TrainingSettings(weekdays, prefill, previousScope, inSessionFill, rirAutofill, propagateEdits, priority, expandRepRange, weightMatch, rpeInput, curve, fatigue, surprise, clampOneRepMax, sessionStepPct, smartWarmups, warmupLastRestSec, warmupSchemes, warmupOverrides, compoundRestSec, isolationRestSec, restOverrides, sideRestSec, betweenExercisesSec, skills) {
  weekdays = weekdays === VOID ? null : weekdays;
  prefill = prefill === VOID ? Prefill_SMART_getInstance() : prefill;
  previousScope = previousScope === VOID ? PreviousScope_ANY_getInstance() : previousScope;
  inSessionFill = inSessionFill === VOID ? true : inSessionFill;
  rirAutofill = rirAutofill === VOID ? true : rirAutofill;
  propagateEdits = propagateEdits === VOID ? false : propagateEdits;
  priority = priority === VOID ? AdjustmentPriority_REPS_FIRST_getInstance() : priority;
  expandRepRange = expandRepRange === VOID ? null : expandRepRange;
  weightMatch = weightMatch === VOID ? null : weightMatch;
  rpeInput = rpeInput === VOID ? false : rpeInput;
  curve = curve === VOID ? CurveModel_EPLEY_getInstance() : curve;
  fatigue = fatigue === VOID ? FatigueChoice_FIXED_getInstance() : fatigue;
  surprise = surprise === VOID ? SurpriseCarry_NONE_getInstance() : surprise;
  clampOneRepMax = clampOneRepMax === VOID ? false : clampOneRepMax;
  sessionStepPct = sessionStepPct === VOID ? 0.0 : sessionStepPct;
  smartWarmups = smartWarmups === VOID ? SmartWarmupStyle_OURS_getInstance() : smartWarmups;
  warmupLastRestSec = warmupLastRestSec === VOID ? 120 : warmupLastRestSec;
  warmupSchemes = warmupSchemes === VOID ? emptyMap() : warmupSchemes;
  warmupOverrides = warmupOverrides === VOID ? emptyMap() : warmupOverrides;
  compoundRestSec = compoundRestSec === VOID ? null : compoundRestSec;
  isolationRestSec = isolationRestSec === VOID ? null : isolationRestSec;
  restOverrides = restOverrides === VOID ? emptyMap() : restOverrides;
  sideRestSec = sideRestSec === VOID ? null : sideRestSec;
  betweenExercisesSec = betweenExercisesSec === VOID ? null : betweenExercisesSec;
  skills = skills === VOID ? emptySet() : skills;
  this.g1r_1 = weekdays;
  this.h1r_1 = prefill;
  this.i1r_1 = previousScope;
  this.j1r_1 = inSessionFill;
  this.k1r_1 = rirAutofill;
  this.l1r_1 = propagateEdits;
  this.m1r_1 = priority;
  this.n1r_1 = expandRepRange;
  this.o1r_1 = weightMatch;
  this.p1r_1 = rpeInput;
  this.q1r_1 = curve;
  this.r1r_1 = fatigue;
  this.s1r_1 = surprise;
  this.t1r_1 = clampOneRepMax;
  this.u1r_1 = sessionStepPct;
  this.v1r_1 = smartWarmups;
  this.w1r_1 = warmupLastRestSec;
  this.x1r_1 = warmupSchemes;
  this.y1r_1 = warmupOverrides;
  this.z1r_1 = compoundRestSec;
  this.a1s_1 = isolationRestSec;
  this.b1s_1 = restOverrides;
  this.c1s_1 = sideRestSec;
  this.d1s_1 = betweenExercisesSec;
  this.e1s_1 = skills;
}
protoOf(TrainingSettings).f1s = function (exercise, history, bodyweightKg, rirAdjustment, clientExpand, clientWeightMatch) {
  var tmp0_elvis_lhs = this.n1r_1;
  var tmp = tmp0_elvis_lhs == null ? clientExpand : tmp0_elvis_lhs;
  var tmp1_elvis_lhs = this.o1r_1;
  return new ProgressionOptions(this.m1r_1, tmp, VOID, tmp1_elvis_lhs == null ? clientWeightMatch : tmp1_elvis_lhs, this.r1r_1.k19_1, this.g1s(exercise, history, bodyweightKg), VOID, VOID, bodyweightKg, exercise.m1e_1, VOID, VOID, VOID, rirAdjustment, VOID, this.t1r_1, this.s1r_1, this.u1r_1);
};
protoOf(TrainingSettings).g1s = function (exercise, history, bodyweightKg) {
  var tmp;
  switch (this.q1r_1.x1_1) {
    case 0:
      tmp = new EpleyCurve();
      break;
    case 1:
      tmp = CurveFit_instance.z18(history, bodyweightKg * exercise.m1e_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
protoOf(TrainingSettings).toString = function () {
  return 'TrainingSettings(weekdays=' + toString_0(this.g1r_1) + ', prefill=' + this.h1r_1.toString() + ', previousScope=' + this.i1r_1.toString() + ', inSessionFill=' + this.j1r_1 + ', rirAutofill=' + this.k1r_1 + ', propagateEdits=' + this.l1r_1 + ', priority=' + this.m1r_1.toString() + ', expandRepRange=' + this.n1r_1 + ', weightMatch=' + this.o1r_1 + ', rpeInput=' + this.p1r_1 + ', curve=' + this.q1r_1.toString() + ', fatigue=' + this.r1r_1.toString() + ', surprise=' + this.s1r_1.toString() + ', clampOneRepMax=' + this.t1r_1 + ', sessionStepPct=' + this.u1r_1 + ', smartWarmups=' + this.v1r_1.toString() + ', warmupLastRestSec=' + this.w1r_1 + ', warmupSchemes=' + toString(this.x1r_1) + ', warmupOverrides=' + toString(this.y1r_1) + ', compoundRestSec=' + this.z1r_1 + ', isolationRestSec=' + this.a1s_1 + ', restOverrides=' + toString(this.b1s_1) + ', sideRestSec=' + this.c1s_1 + ', betweenExercisesSec=' + this.d1s_1 + ', skills=' + toString(this.e1s_1) + ')';
};
protoOf(TrainingSettings).hashCode = function () {
  var result = this.g1r_1 == null ? 0 : hashCode(this.g1r_1);
  result = imul(result, 31) + this.h1r_1.hashCode() | 0;
  result = imul(result, 31) + this.i1r_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.j1r_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.k1r_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.l1r_1) | 0;
  result = imul(result, 31) + this.m1r_1.hashCode() | 0;
  result = imul(result, 31) + (this.n1r_1 == null ? 0 : getBooleanHashCode(this.n1r_1)) | 0;
  result = imul(result, 31) + (this.o1r_1 == null ? 0 : getBooleanHashCode(this.o1r_1)) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.p1r_1) | 0;
  result = imul(result, 31) + this.q1r_1.hashCode() | 0;
  result = imul(result, 31) + this.r1r_1.hashCode() | 0;
  result = imul(result, 31) + this.s1r_1.hashCode() | 0;
  result = imul(result, 31) + getBooleanHashCode(this.t1r_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.u1r_1) | 0;
  result = imul(result, 31) + this.v1r_1.hashCode() | 0;
  result = imul(result, 31) + this.w1r_1 | 0;
  result = imul(result, 31) + hashCode(this.x1r_1) | 0;
  result = imul(result, 31) + hashCode(this.y1r_1) | 0;
  result = imul(result, 31) + (this.z1r_1 == null ? 0 : this.z1r_1) | 0;
  result = imul(result, 31) + (this.a1s_1 == null ? 0 : this.a1s_1) | 0;
  result = imul(result, 31) + hashCode(this.b1s_1) | 0;
  result = imul(result, 31) + (this.c1s_1 == null ? 0 : this.c1s_1) | 0;
  result = imul(result, 31) + (this.d1s_1 == null ? 0 : this.d1s_1) | 0;
  result = imul(result, 31) + hashCode(this.e1s_1) | 0;
  return result;
};
protoOf(TrainingSettings).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrainingSettings))
    return false;
  if (!equals(this.g1r_1, other.g1r_1))
    return false;
  if (!this.h1r_1.equals(other.h1r_1))
    return false;
  if (!this.i1r_1.equals(other.i1r_1))
    return false;
  if (!(this.j1r_1 === other.j1r_1))
    return false;
  if (!(this.k1r_1 === other.k1r_1))
    return false;
  if (!(this.l1r_1 === other.l1r_1))
    return false;
  if (!this.m1r_1.equals(other.m1r_1))
    return false;
  if (!(this.n1r_1 == other.n1r_1))
    return false;
  if (!(this.o1r_1 == other.o1r_1))
    return false;
  if (!(this.p1r_1 === other.p1r_1))
    return false;
  if (!this.q1r_1.equals(other.q1r_1))
    return false;
  if (!this.r1r_1.equals(other.r1r_1))
    return false;
  if (!this.s1r_1.equals(other.s1r_1))
    return false;
  if (!(this.t1r_1 === other.t1r_1))
    return false;
  if (!equals(this.u1r_1, other.u1r_1))
    return false;
  if (!this.v1r_1.equals(other.v1r_1))
    return false;
  if (!(this.w1r_1 === other.w1r_1))
    return false;
  if (!equals(this.x1r_1, other.x1r_1))
    return false;
  if (!equals(this.y1r_1, other.y1r_1))
    return false;
  if (!(this.z1r_1 == other.z1r_1))
    return false;
  if (!(this.a1s_1 == other.a1s_1))
    return false;
  if (!equals(this.b1s_1, other.b1s_1))
    return false;
  if (!(this.c1s_1 == other.c1s_1))
    return false;
  if (!(this.d1s_1 == other.d1s_1))
    return false;
  if (!equals(this.e1s_1, other.e1s_1))
    return false;
  return true;
};
function fromMap$enum($map, key, values, default_0) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var inductionVariable = 0;
    var last = values.length;
    while (inductionVariable < last) {
      var element = values[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      if (element.w1_1 === JsonRead_instance.iq($map, key)) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  return tmp0_elvis_lhs == null ? default_0 : tmp0_elvis_lhs;
}
function fromMap$seconds($map, key) {
  var tmp0_safe_receiver = JsonRead_instance.xq($map, key);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_0;
    if (0 <= tmp0_safe_receiver ? tmp0_safe_receiver <= 3600 : false) {
      tmp_0 = tmp0_safe_receiver;
    } else {
      tmp_0 = null;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function fromMap$obj($map, key) {
  var tmp = $map.s1(key);
  var tmp0_elvis_lhs = (!(tmp == null) ? isInterface(tmp, KtMap) : false) ? tmp : null;
  return tmp0_elvis_lhs == null ? emptyMap() : tmp0_elvis_lhs;
}
function TrainingSettingsJson() {
  this.h1s_1 = 5.0;
}
protoOf(TrainingSettingsJson).tf = function (json) {
  var tmp;
  if (json == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    var tmp_0;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = JsonRead_instance.vf(Json_instance.uf(json), 'training');
      tmp_0 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_0;
    tmp = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  var tmp1_elvis_lhs = tmp;
  var tmp_2;
  if (tmp1_elvis_lhs == null) {
    return new TrainingSettings();
  } else {
    tmp_2 = tmp1_elvis_lhs;
  }
  var map = tmp_2;
  return this.i1s(map);
};
protoOf(TrainingSettingsJson).i1s = function (map) {
  var d = new TrainingSettings();
  var tmp = map.s1('weekdays');
  var tmp_0;
  if (((!(tmp == null) ? isInterface(tmp, KtList) : false) ? tmp : null) == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.collections.filter' call
    var tmp0 = JsonRead_instance.zq(map, 'weekdays');
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (1 <= element ? element <= 7 : false) {
        destination.f(element);
      }
    }
    tmp_0 = toSet(destination);
  }
  var tmp_1 = tmp_0;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = get_entries_41();
  var tmp$ret$5 = copyToArray(this_0);
  var tmp_2 = fromMap$enum(map, 'prefill', tmp$ret$5, d.h1r_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_1 = get_entries_42();
  var tmp$ret$6 = copyToArray(this_1);
  var tmp_3 = fromMap$enum(map, 'previousScope', tmp$ret$6, d.i1r_1);
  var tmp1_elvis_lhs = JsonRead_instance.ar(map, 'inSessionFill');
  var tmp_4 = tmp1_elvis_lhs == null ? d.j1r_1 : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = JsonRead_instance.ar(map, 'rirAutofill');
  var tmp_5 = tmp2_elvis_lhs == null ? d.k1r_1 : tmp2_elvis_lhs;
  var tmp3_elvis_lhs = JsonRead_instance.ar(map, 'propagateEdits');
  var tmp_6 = tmp3_elvis_lhs == null ? d.l1r_1 : tmp3_elvis_lhs;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_2 = get_entries_27();
  var tmp$ret$7 = copyToArray(this_2);
  var tmp_7 = fromMap$enum(map, 'priority', tmp$ret$7, d.m1r_1);
  var tmp_8 = JsonRead_instance.ar(map, 'expandRepRange');
  var tmp_9 = JsonRead_instance.ar(map, 'weightMatch');
  var tmp4_elvis_lhs = JsonRead_instance.ar(map, 'rpeInput');
  var tmp_10 = tmp4_elvis_lhs == null ? d.p1r_1 : tmp4_elvis_lhs;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_3 = get_entries_28();
  var tmp$ret$8 = copyToArray(this_3);
  var tmp_11 = fromMap$enum(map, 'curve', tmp$ret$8, d.q1r_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_4 = get_entries_20();
  var tmp$ret$9 = copyToArray(this_4);
  var tmp_12 = fromMap$enum(map, 'fatigue', tmp$ret$9, d.r1r_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_5 = get_entries_21();
  var tmp$ret$10 = copyToArray(this_5);
  var tmp_13 = fromMap$enum(map, 'surprise', tmp$ret$10, d.s1r_1);
  var tmp5_elvis_lhs = JsonRead_instance.ar(map, 'clampOneRepMax');
  var tmp_14 = tmp5_elvis_lhs == null ? d.t1r_1 : tmp5_elvis_lhs;
  var tmp6_safe_receiver = JsonRead_instance.jq(map, 'sessionStepPct');
  var tmp_15;
  if (tmp6_safe_receiver == null) {
    tmp_15 = null;
  } else {
    // Inline function 'kotlin.takeIf' call
    var tmp_16;
    if (0.0 <= tmp6_safe_receiver ? tmp6_safe_receiver <= 5.0 : false) {
      tmp_16 = tmp6_safe_receiver;
    } else {
      tmp_16 = null;
    }
    tmp_15 = tmp_16;
  }
  var tmp7_elvis_lhs = tmp_15;
  var tmp_17 = tmp7_elvis_lhs == null ? d.u1r_1 : tmp7_elvis_lhs;
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_6 = get_entries_44();
  var tmp$ret$13 = copyToArray(this_6);
  var tmp_18 = fromMap$enum(map, 'smartWarmups', tmp$ret$13, d.v1r_1);
  var tmp8_elvis_lhs = fromMap$seconds(map, 'warmupLastRestSec');
  var tmp_19 = tmp8_elvis_lhs == null ? d.w1r_1 : tmp8_elvis_lhs;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_0 = fromMap$obj(map, 'warmupSchemes');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_0 = tmp0_0.v1().j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.component1' call
    var key = element_0.o1();
    // Inline function 'kotlin.collections.component2' call
    var value = element_0.p1();
    var tmp0_safe_receiver = Companion_instance_27.p19(key);
    var tmp_20;
    if (tmp0_safe_receiver == null) {
      tmp_20 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_20 = to(tmp0_safe_receiver, Companion_getInstance_22().s1q(value));
    }
    var tmp0_safe_receiver_0 = tmp_20;
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_0);
    }
  }
  var tmp_21 = toMap(destination_0);
  // Inline function 'kotlin.collections.mapValues' call
  var this_7 = fromMap$obj(map, 'warmupOverrides');
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_1 = LinkedHashMap_init_$Create$(mapCapacity(this_7.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_1 = this_7.v1().j();
  while (_iterator__ex2g4s_1.k()) {
    var element_1 = _iterator__ex2g4s_1.l();
    var tmp_22 = element_1.o1();
    var tmp$ret$30 = Companion_getInstance_22().s1q(element_1.p1());
    destination_1.k2(tmp_22, tmp$ret$30);
  }
  var tmp_23 = destination_1;
  var tmp_24 = fromMap$seconds(map, 'compoundRestSec');
  var tmp_25 = fromMap$seconds(map, 'isolationRestSec');
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0_1 = fromMap$obj(map, 'restOverrides');
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_2 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = tmp0_1.v1().j();
  while (_iterator__ex2g4s_2.k()) {
    var element_2 = _iterator__ex2g4s_2.l();
    // Inline function 'kotlin.collections.component1' call
    var id = element_2.o1();
    // Inline function 'kotlin.collections.component2' call
    var value_0 = element_2.p1();
    var tmp0_safe_receiver_1 = isNumber(value_0) ? value_0 : null;
    var tmp1_safe_receiver = tmp0_safe_receiver_1 == null ? null : numberToInt(tmp0_safe_receiver_1);
    var tmp_26;
    if (tmp1_safe_receiver == null) {
      tmp_26 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_27;
      if (0 <= tmp1_safe_receiver ? tmp1_safe_receiver <= 3600 : false) {
        tmp_27 = tmp1_safe_receiver;
      } else {
        tmp_27 = null;
      }
      tmp_26 = tmp_27;
    }
    var tmp2_safe_receiver = tmp_26;
    var tmp_28;
    if (tmp2_safe_receiver == null) {
      tmp_28 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_28 = to(id, tmp2_safe_receiver);
    }
    var tmp0_safe_receiver_2 = tmp_28;
    if (tmp0_safe_receiver_2 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_2.f(tmp0_safe_receiver_2);
    }
  }
  return new TrainingSettings(tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_17, tmp_18, tmp_19, tmp_21, tmp_23, tmp_24, tmp_25, toMap(destination_2), fromMap$seconds(map, 'sideRestSec'), fromMap$seconds(map, 'betweenExercisesSec'), toSet(JsonRead_instance.m12(map, 'skills')));
};
protoOf(TrainingSettingsJson).j1s = function (settings) {
  var tmp0_safe_receiver = settings.g1r_1;
  var tmp = to('weekdays', tmp0_safe_receiver == null ? null : sorted(tmp0_safe_receiver));
  var tmp_0 = to('prefill', settings.h1r_1.w1_1);
  var tmp_1 = to('previousScope', settings.i1r_1.w1_1);
  var tmp_2 = to('inSessionFill', settings.j1r_1);
  var tmp_3 = to('rirAutofill', settings.k1r_1);
  var tmp_4 = to('propagateEdits', settings.l1r_1);
  var tmp_5 = to('priority', settings.m1r_1.w1_1);
  var tmp_6 = to('expandRepRange', settings.n1r_1);
  var tmp_7 = to('weightMatch', settings.o1r_1);
  var tmp_8 = to('rpeInput', settings.p1r_1);
  var tmp_9 = to('curve', settings.q1r_1.w1_1);
  var tmp_10 = to('fatigue', settings.r1r_1.w1_1);
  var tmp_11 = to('surprise', settings.s1r_1.w1_1);
  var tmp_12 = to('clampOneRepMax', settings.t1r_1);
  var tmp_13 = to('sessionStepPct', settings.u1r_1);
  var tmp_14 = to('smartWarmups', settings.v1r_1.w1_1);
  var tmp_15 = to('warmupLastRestSec', settings.w1r_1);
  // Inline function 'kotlin.collections.associate' call
  var this_0 = settings.x1r_1.v1();
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.o1().f1r_1, Companion_getInstance_22().t1q(element.p1()));
    destination.k2(pair.hb_1, pair.ib_1);
  }
  var tmp_16 = to('warmupSchemes', destination);
  // Inline function 'kotlin.collections.mapValues' call
  var this_1 = settings.y1r_1;
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_0 = LinkedHashMap_init_$Create$(mapCapacity(this_1.o()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_0 = this_1.v1().j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp_17 = element_0.o1();
    var tmp$ret$8 = Companion_getInstance_22().t1q(element_0.p1());
    destination_0.k2(tmp_17, tmp$ret$8);
  }
  return linkedMapOf([tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, tmp_12, tmp_13, tmp_14, tmp_15, tmp_16, to('warmupOverrides', destination_0), to('compoundRestSec', settings.z1r_1), to('isolationRestSec', settings.a1s_1), to('restOverrides', settings.b1s_1), to('sideRestSec', settings.c1s_1), to('betweenExercisesSec', settings.d1s_1), to('skills', sorted(settings.e1s_1))]);
};
protoOf(TrainingSettingsJson).k1s = function (settings, existing) {
  var tmp;
  if (existing == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.runCatching' call
    var tmp_0;
    try {
      // Inline function 'kotlin.Companion.success' call
      var value = JsonRead_instance.vf(Json_instance.uf(existing), 'training');
      tmp_0 = _Result___init__impl__xyqfz8(value);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var e = $p;
        // Inline function 'kotlin.Companion.failure' call
        tmp_1 = _Result___init__impl__xyqfz8(createFailure(e));
      } else {
        throw $p;
      }
      tmp_0 = tmp_1;
    }
    // Inline function 'kotlin.Result.getOrNull' call
    var this_0 = tmp_0;
    tmp = _Result___get_isFailure__impl__jpiriv(this_0) ? null : _Result___get_value__impl__bjfvqg(this_0);
  }
  var tmp1_elvis_lhs = tmp;
  var old = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var tmp_2 = Json_instance;
  // Inline function 'kotlin.apply' call
  var this_1 = LinkedHashMap_init_$Create$_0(old);
  this_1.e4(TrainingSettingsJson_instance.j1s(settings));
  return tmp_2.zf(this_1);
};
var TrainingSettingsJson_instance;
function TrainingSettingsJson_getInstance() {
  return TrainingSettingsJson_instance;
}
function Prefill_SMART_getInstance() {
  static_init_68();
  return Prefill_SMART_instance;
}
function Prefill_PREVIOUS_getInstance() {
  static_init_68();
  return Prefill_PREVIOUS_instance;
}
function PreviousScope_ANY_getInstance() {
  static_init_69();
  return PreviousScope_ANY_instance;
}
function PreviousScope_PROGRAM_getInstance() {
  static_init_69();
  return PreviousScope_PROGRAM_instance;
}
function WarmupCategory_UPPER_COMPOUND_getInstance() {
  static_init_70();
  return WarmupCategory_UPPER_COMPOUND_instance;
}
function WarmupCategory_LOWER_COMPOUND_getInstance() {
  static_init_70();
  return WarmupCategory_LOWER_COMPOUND_instance;
}
function WarmupCategory_UPPER_ISOLATION_getInstance() {
  static_init_70();
  return WarmupCategory_UPPER_ISOLATION_instance;
}
function WarmupCategory_LOWER_ISOLATION_getInstance() {
  static_init_70();
  return WarmupCategory_LOWER_ISOLATION_instance;
}
function WarmupCategory_CORE_getInstance() {
  static_init_70();
  return WarmupCategory_CORE_instance;
}
function TrainingWeekdays() {
  TrainingWeekdays_instance = this;
  this.l1s_1 = mapOf_0([to(1, setOf_0(1)), to(2, setOf([1, 4])), to(3, setOf([1, 3, 5])), to(4, setOf([1, 2, 4, 5])), to(5, setOf([1, 2, 3, 5, 6])), to(6, setOf([1, 2, 3, 4, 5, 6]))]);
}
protoOf(TrainingWeekdays).m1s = function (sessions) {
  var tmp;
  if (sessions >= 7) {
    tmp = toSet(numberRangeToNumber(1, 7));
  } else {
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = this.l1s_1.s1(sessions);
    tmp = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
  }
  return tmp;
};
protoOf(TrainingWeekdays).n1s = function (chosen, activeProgramSessions) {
  var tmp;
  if (chosen == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList_init_$Create$_0();
    var _iterator__ex2g4s = chosen.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (1 <= element ? element <= 7 : false) {
        destination.f(element);
      }
    }
    tmp = destination;
  }
  var tmp1_safe_receiver = tmp;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toSet(tmp1_safe_receiver);
  var tmp_0;
  if (tmp2_elvis_lhs == null) {
    var tmp_1;
    if (activeProgramSessions == null) {
      tmp_1 = null;
    } else {
      // Inline function 'kotlin.let' call
      tmp_1 = this.m1s(activeProgramSessions);
    }
    // Inline function 'kotlin.collections.orEmpty' call
    var tmp0_elvis_lhs = tmp_1;
    tmp_0 = tmp0_elvis_lhs == null ? emptySet() : tmp0_elvis_lhs;
  } else {
    tmp_0 = tmp2_elvis_lhs;
  }
  return tmp_0;
};
var TrainingWeekdays_instance;
function TrainingWeekdays_getInstance() {
  if (TrainingWeekdays_instance == null)
    new TrainingWeekdays();
  return TrainingWeekdays_instance;
}
function WarmupStep(pct, reps) {
  this.u1q_1 = pct;
  this.v1q_1 = reps;
}
protoOf(WarmupStep).toString = function () {
  return 'WarmupStep(pct=' + this.u1q_1 + ', reps=' + this.v1q_1 + ')';
};
protoOf(WarmupStep).hashCode = function () {
  var result = getNumberHashCode(this.u1q_1);
  result = imul(result, 31) + this.v1q_1 | 0;
  return result;
};
protoOf(WarmupStep).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WarmupStep))
    return false;
  if (!equals(this.u1q_1, other.u1q_1))
    return false;
  if (!(this.v1q_1 === other.v1q_1))
    return false;
  return true;
};
function WarmupSet(loadKg, reps, pct) {
  this.o1s_1 = loadKg;
  this.p1s_1 = reps;
  this.q1s_1 = pct;
}
protoOf(WarmupSet).toString = function () {
  return 'WarmupSet(loadKg=' + this.o1s_1 + ', reps=' + this.p1s_1 + ', pct=' + this.q1s_1 + ')';
};
protoOf(WarmupSet).hashCode = function () {
  var result = getNumberHashCode(this.o1s_1);
  result = imul(result, 31) + this.p1s_1 | 0;
  result = imul(result, 31) + getNumberHashCode(this.q1s_1) | 0;
  return result;
};
protoOf(WarmupSet).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WarmupSet))
    return false;
  if (!equals(this.o1s_1, other.o1s_1))
    return false;
  if (!(this.p1s_1 === other.p1s_1))
    return false;
  if (!equals(this.q1s_1, other.q1s_1))
    return false;
  return true;
};
var static_init_called_71;
function static_init_71() {
  if (static_init_called_71)
    return Unit_instance;
  static_init_called_71 = true;
  SmartWarmupStyle_OURS_instance = new SmartWarmupStyle('OURS', 0);
}
var SmartWarmupStyle_OURS_instance;
function values_49() {
  static_init_71();
  return [SmartWarmupStyle_OURS_getInstance()];
}
function get_entries_44() {
  static_init_71();
  if ($ENTRIES_44 == null)
    $ENTRIES_44 = enumEntries(values_49());
  return $ENTRIES_44;
}
var $ENTRIES_44;
function SmartWarmupStyle(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function halfUp($this, value) {
  // Inline function 'kotlin.math.floor' call
  var x = value + 0.5;
  var tmp$ret$0 = Math.floor(x);
  return numberToInt(tmp$ret$0);
}
function sam$kotlin_Comparator$0_19(function_0) {
  this.r1s_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_19).y9 = function (a, b) {
  return this.r1s_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_19).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_19).g2 = function () {
  return this.r1s_1;
};
protoOf(sam$kotlin_Comparator$0_19).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_19).hashCode = function () {
  return hashCode(this.g2());
};
function Warmups$generate$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.u1q_1;
  var tmp$ret$2 = b.u1q_1;
  return compareValues(tmp, tmp$ret$2);
}
function Warmups() {
  Warmups_instance = this;
  this.s1h_1 = listOf([new WarmupStep(40.0, 8), new WarmupStep(60.0, 5), new WarmupStep(80.0, 3)]);
  this.t1h_1 = listOf([0.45, 0.65, 0.8, 0.9]);
  this.u1h_1 = 0.9;
  this.v1h_1 = 10;
  this.w1h_1 = 0.025;
  this.x1h_1 = 120;
}
protoOf(Warmups).s1s = function (workingLoadKg, loads, scheme, minLoadKg) {
  // Inline function 'kotlin.require' call
  if (!(workingLoadKg >= 0.0)) {
    var message = 'workingLoadKg must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(scheme, Collection)) {
      tmp = scheme.m();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$2 = true;
      break $l$block_0;
    }
    var _iterator__ex2g4s = scheme.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (!(element.u1q_1 > 0.0 && element.v1q_1 > 0)) {
        tmp$ret$2 = false;
        break $l$block_0;
      }
    }
    tmp$ret$2 = true;
  }
  // Inline function 'kotlin.require' call
  if (!tmp$ret$2) {
    var message_0 = 'warm-up steps need a positive % and reps';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var sets = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = Warmups$generate$lambda;
  var tmp$ret$7 = new sam$kotlin_Comparator$0_19(tmp_0);
  var _iterator__ex2g4s_0 = sortedWith(scheme, tmp$ret$7).j();
  $l$loop_1: while (_iterator__ex2g4s_0.k()) {
    var step = _iterator__ex2g4s_0.l();
    var raw = workingLoadKg * step.u1q_1 / 100.0;
    if (raw < minLoadKg - 1.0E-9)
      continue $l$loop_1;
    var tmp1_elvis_lhs = Loads_instance.q1c(loads, raw);
    var load = tmp1_elvis_lhs == null ? Loads_instance.d1c(raw) : tmp1_elvis_lhs;
    if (load < minLoadKg - 1.0E-9 || load >= workingLoadKg - 1.0E-9)
      continue $l$loop_1;
    var tmp_1;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!sets.m()) {
      // Inline function 'kotlin.math.abs' call
      var x = last(sets).o1s_1 - load;
      tmp_1 = Math.abs(x) < 1.0E-9;
    } else {
      tmp_1 = false;
    }
    if (tmp_1)
      continue $l$loop_1;
    sets.f(new WarmupSet(load, step.v1q_1, step.u1q_1));
  }
  return sets;
};
protoOf(Warmups).t1s = function (workingLoadKg, oneRepMaxKg, loads, style, curve, warmedUp, bodyweightKg, minLoadKg, bar) {
  // Inline function 'kotlin.require' call
  if (!(workingLoadKg >= 0.0)) {
    var message = 'workingLoadKg must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (oneRepMaxKg == null || oneRepMaxKg <= 0.0)
    return this.s1s(workingLoadKg, loads, this.s1h_1, minLoadKg);
  var ratio = (workingLoadKg + bodyweightKg) / oneRepMaxKg;
  var tmp;
  if (style.x1_1 === 0) {
    var tmp0 = this.t1h_1;
    var tmp$ret$2;
    $l$block: {
      // Inline function 'kotlin.collections.count' call
      var tmp_0;
      if (isInterface(tmp0, Collection)) {
        tmp_0 = tmp0.m();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$2 = 0;
        break $l$block;
      }
      var count = 0;
      var _iterator__ex2g4s = tmp0.j();
      while (_iterator__ex2g4s.k()) {
        var element = _iterator__ex2g4s.l();
        if (element < ratio) {
          count = count + 1 | 0;
          checkCountOverflow(count);
        }
      }
      tmp$ret$2 = count;
    }
    var rungs = tmp$ret$2;
    var tmp_1;
    switch (rungs) {
      case 0:
        tmp_1 = emptyList();
        break;
      case 1:
        tmp_1 = listOf_0(first(this.t1h_1));
        break;
      default:
        // Inline function 'kotlin.collections.map' call

        var this_0 = until(0, rungs);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
        var inductionVariable = this_0.oc_1;
        var last_0 = this_0.pc_1;
        if (inductionVariable <= last_0)
          do {
            var item = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var it = item;
            var tmp$ret$6 = first(Warmups_getInstance().t1h_1) + (0.9 * ratio - first(Warmups_getInstance().t1h_1)) * it / (rungs - 1 | 0);
            destination.f(tmp$ret$6);
          }
           while (!(item === last_0));
        tmp_1 = destination;
        break;
    }
    var pcts = tmp_1;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(pcts, 10));
    var _iterator__ex2g4s_0 = pcts.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp$ret$9 = coerceIn_0(halfUp(Warmups_getInstance(), curve.j1m(item_0 * oneRepMaxKg, oneRepMaxKg) / 3.0), 1, 10);
      destination_0.f(tmp$ret$9);
    }
    var reps = destination_0;
    var all = zip(pcts, reps);
    tmp = warmedUp ? takeLast(all, 1) : all;
  } else {
    noWhenBranchMatchedException();
  }
  var steps = tmp;
  var sets = ArrayList_init_$Create$_0();
  var previousPlates = null;
  var _iterator__ex2g4s_1 = steps.j();
  $l$loop_1: while (_iterator__ex2g4s_1.k()) {
    var _destruct__k2r9zo = _iterator__ex2g4s_1.l();
    var pct = _destruct__k2r9zo.ya();
    var reps_0 = _destruct__k2r9zo.za();
    var raw = pct * oneRepMaxKg - bodyweightKg;
    if (raw < minLoadKg - 1.0E-9)
      continue $l$loop_1;
    var load = this.u1s(raw, loads, bar, previousPlates);
    if (load < minLoadKg - 1.0E-9 || load >= workingLoadKg - 1.0E-9)
      continue $l$loop_1;
    var tmp_2;
    // Inline function 'kotlin.collections.isNotEmpty' call
    if (!sets.m()) {
      // Inline function 'kotlin.math.abs' call
      var x = last(sets).o1s_1 - load;
      tmp_2 = Math.abs(x) < 1.0E-9;
    } else {
      tmp_2 = false;
    }
    if (tmp_2)
      continue $l$loop_1;
    sets.f(new WarmupSet(load, reps_0, workingLoadKg > 0.0 ? 100.0 * load / workingLoadKg : 0.0));
    var tmp_3;
    if (bar == null) {
      tmp_3 = null;
    } else {
      // Inline function 'kotlin.let' call
      var barKg = bar.ya();
      var plates = bar.za();
      tmp_3 = PlateCalculator_instance.b1d(load, barKg, plates).y1b_1;
    }
    previousPlates = tmp_3;
  }
  return sets;
};
protoOf(Warmups).v1s = function (workingLoadKg, oneRepMaxKg, loads, style, curve, warmedUp, bodyweightKg, minLoadKg, bar, $super) {
  style = style === VOID ? SmartWarmupStyle_OURS_getInstance() : style;
  curve = curve === VOID ? new EpleyCurve() : curve;
  warmedUp = warmedUp === VOID ? false : warmedUp;
  bodyweightKg = bodyweightKg === VOID ? 0.0 : bodyweightKg;
  var tmp;
  if (minLoadKg === VOID) {
    var tmp0_elvis_lhs = minOrNull(loads);
    tmp = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
  } else {
    tmp = minLoadKg;
  }
  minLoadKg = tmp;
  bar = bar === VOID ? null : bar;
  return $super === VOID ? this.t1s(workingLoadKg, oneRepMaxKg, loads, style, curve, warmedUp, bodyweightKg, minLoadKg, bar) : $super.t1s.call(this, workingLoadKg, oneRepMaxKg, loads, style, curve, warmedUp, bodyweightKg, minLoadKg, bar);
};
protoOf(Warmups).u1s = function (target, loads, bar, previousPlates) {
  var tmp0_elvis_lhs = Loads_instance.q1c(loads, target);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return Loads_instance.d1c(target);
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var nearest = tmp;
  if (bar == null || previousPlates == null)
    return nearest;
  var barKg = bar.ya();
  var plates = bar.za();
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = loads.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    // Inline function 'kotlin.math.abs' call
    var x = element - target;
    if (Math.abs(x) <= 0.025 * target + 1.0E-9) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    if (PlateCalculator_instance.c1d(previousPlates, PlateCalculator_instance.b1d(element_0, barKg, plates).y1b_1)) {
      destination_0.f(element_0);
    }
  }
  var tmp$ret$7;
  $l$block_0: {
    // Inline function 'kotlin.collections.minByOrNull' call
    var iterator = destination_0.j();
    if (!iterator.k()) {
      tmp$ret$7 = null;
      break $l$block_0;
    }
    var minElem = iterator.l();
    if (!iterator.k()) {
      tmp$ret$7 = minElem;
      break $l$block_0;
    }
    // Inline function 'kotlin.math.abs' call
    var x_0 = minElem - target;
    var minValue = Math.abs(x_0);
    do {
      var e = iterator.l();
      // Inline function 'kotlin.math.abs' call
      var x_1 = e - target;
      var v = Math.abs(x_1);
      if (compareTo(minValue, v) > 0) {
        minElem = e;
        minValue = v;
      }
    }
     while (iterator.k());
    tmp$ret$7 = minElem;
  }
  var tmp1_elvis_lhs = tmp$ret$7;
  return tmp1_elvis_lhs == null ? nearest : tmp1_elvis_lhs;
};
protoOf(Warmups).k1i = function (equipment) {
  var seen = HashSet_init_$Create$();
  var result = LinkedHashSet_init_$Create$();
  // Inline function 'kotlin.collections.forEachIndexed' call
  var index = 0;
  var _iterator__ex2g4s = equipment.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var index_0 = checkIndexOverflow(_unary__edvuaz);
    if (!item.equals(Equipment_BODYWEIGHT_getInstance()) && !item.equals(Equipment_BAND_getInstance()) && !item.equals(Equipment_OTHER_getInstance()) && seen.f(item)) {
      result.f(index_0);
    }
  }
  return result;
};
var Warmups_instance;
function Warmups_getInstance() {
  if (Warmups_instance == null)
    new Warmups();
  return Warmups_instance;
}
function SmartWarmupStyle_OURS_getInstance() {
  static_init_71();
  return SmartWarmupStyle_OURS_instance;
}
var static_init_called_72;
function static_init_72() {
  if (static_init_called_72)
    return Unit_instance;
  static_init_called_72 = true;
  TrendMethod_CLASSIC_instance = new TrendMethod('CLASSIC', 0);
  TrendMethod_LESS_LAG_instance = new TrendMethod('LESS_LAG', 1);
  TrendMethod_CLASSIC_FAST_instance = new TrendMethod('CLASSIC_FAST', 2);
  TrendMethod_LESS_LAG_WATER_instance = new TrendMethod('LESS_LAG_WATER', 3);
}
var TrendMethod_CLASSIC_instance;
var TrendMethod_LESS_LAG_instance;
var TrendMethod_CLASSIC_FAST_instance;
var TrendMethod_LESS_LAG_WATER_instance;
function valueOf_16(value) {
  static_init_72();
  switch (value) {
    case 'CLASSIC':
      return TrendMethod_CLASSIC_getInstance();
    case 'LESS_LAG':
      return TrendMethod_LESS_LAG_getInstance();
    case 'CLASSIC_FAST':
      return TrendMethod_CLASSIC_FAST_getInstance();
    case 'LESS_LAG_WATER':
      return TrendMethod_LESS_LAG_WATER_getInstance();
    default:
      THROW_IAE('No enum constant app.macrotide.core.trend.TrendMethod.' + value);
      break;
  }
}
function TrendMethod(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function Trend() {
}
protoOf(Trend).xv = function (weighIns, endDay, method) {
  var tmp;
  switch (method.x1_1) {
    case 0:
      tmp = WeightTrend_instance.vm(weighIns, endDay);
      break;
    case 2:
      tmp = WeightTrend_instance.w1s(weighIns, endDay, 0.2222222222222222);
      break;
    case 1:
      tmp = LessLagTrend_instance.x1s(weighIns, endDay);
      break;
    case 3:
      // Inline function 'kotlin.collections.map' call

      var this_0 = TransientTrend_instance.y1s(weighIns, endDay);
      // Inline function 'kotlin.collections.mapTo' call

      var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.j();
      while (_iterator__ex2g4s.k()) {
        var item = _iterator__ex2g4s.l();
        var tmp$ret$2 = item.du_1;
        destination.f(tmp$ret$2);
      }

      tmp = destination;
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
  return tmp;
};
var Trend_instance;
function Trend_getInstance() {
  return Trend_instance;
}
function LessLagParams(measurementSdKg, levelSdKg, slopeSdKgPerDay, initialSlopeSdKgPerDay) {
  measurementSdKg = measurementSdKg === VOID ? 0.4 : measurementSdKg;
  levelSdKg = levelSdKg === VOID ? 0.02 : levelSdKg;
  slopeSdKgPerDay = slopeSdKgPerDay === VOID ? 0.002 : slopeSdKgPerDay;
  initialSlopeSdKgPerDay = initialSlopeSdKgPerDay === VOID ? 0.05 : initialSlopeSdKgPerDay;
  this.z1s_1 = measurementSdKg;
  this.a1t_1 = levelSdKg;
  this.b1t_1 = slopeSdKgPerDay;
  this.c1t_1 = initialSlopeSdKgPerDay;
  // Inline function 'kotlin.require' call
  if (!(this.z1s_1 > 0.0 && this.a1t_1 >= 0.0 && this.b1t_1 > 0.0 && this.c1t_1 > 0.0)) {
    var message = 'noise settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
}
protoOf(LessLagParams).toString = function () {
  return 'LessLagParams(measurementSdKg=' + this.z1s_1 + ', levelSdKg=' + this.a1t_1 + ', slopeSdKgPerDay=' + this.b1t_1 + ', initialSlopeSdKgPerDay=' + this.c1t_1 + ')';
};
protoOf(LessLagParams).hashCode = function () {
  var result = getNumberHashCode(this.z1s_1);
  result = imul(result, 31) + getNumberHashCode(this.a1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.b1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.c1t_1) | 0;
  return result;
};
protoOf(LessLagParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof LessLagParams))
    return false;
  if (!equals(this.z1s_1, other.z1s_1))
    return false;
  if (!equals(this.a1t_1, other.a1t_1))
    return false;
  if (!equals(this.b1t_1, other.b1t_1))
    return false;
  if (!equals(this.c1t_1, other.c1t_1))
    return false;
  return true;
};
function State(level, slope, p00, p01, p11) {
  this.d1t_1 = level;
  this.e1t_1 = slope;
  this.f1t_1 = p00;
  this.g1t_1 = p01;
  this.h1t_1 = p11;
}
function smooth($this, predicted, filtered) {
  var n = filtered.o();
  var levels = new Float64Array(n);
  var slopes = new Float64Array(n);
  levels[n - 1 | 0] = filtered.n(n - 1 | 0).d1t_1;
  slopes[n - 1 | 0] = filtered.n(n - 1 | 0).e1t_1;
  var inductionVariable = n - 2 | 0;
  if (0 <= inductionVariable)
    $l$loop: do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      var f = filtered.n(i);
      var p = predicted.n(i + 1 | 0);
      var a00 = f.f1t_1 + f.g1t_1;
      var a01 = f.g1t_1;
      var a10 = f.g1t_1 + f.h1t_1;
      var a11 = f.h1t_1;
      var det = p.f1t_1 * p.h1t_1 - p.g1t_1 * p.g1t_1;
      if (det <= 1.0E-18) {
        levels[i] = f.d1t_1;
        slopes[i] = f.e1t_1;
        continue $l$loop;
      }
      var i00 = p.h1t_1 / det;
      var i01 = -p.g1t_1 / det;
      var i11 = p.f1t_1 / det;
      var c00 = a00 * i00 + a01 * i01;
      var c01 = a00 * i01 + a01 * i11;
      var c10 = a10 * i00 + a11 * i01;
      var c11 = a10 * i01 + a11 * i11;
      var dLevel = levels[i + 1 | 0] - p.d1t_1;
      var dSlope = slopes[i + 1 | 0] - p.e1t_1;
      levels[i] = f.d1t_1 + c00 * dLevel + c01 * dSlope;
      slopes[i] = f.e1t_1 + c10 * dLevel + c11 * dSlope;
    }
     while (0 <= inductionVariable);
  return levels;
}
function LessLagTrend$compute$$inlined$groupingBy$1($this) {
  this.i1t_1 = $this;
}
protoOf(LessLagTrend$compute$$inlined$groupingBy$1).i2 = function () {
  return this.i1t_1.j();
};
protoOf(LessLagTrend$compute$$inlined$groupingBy$1).r11 = function (element) {
  return element.nl_1;
};
protoOf(LessLagTrend$compute$$inlined$groupingBy$1).j2 = function (element) {
  return this.r11(element);
};
function LessLagTrend() {
}
protoOf(LessLagTrend).j1t = function (weighIns, endDay, params) {
  var daily = WeightTrend_instance.bm(weighIns);
  if (daily.m())
    return emptyList();
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weighIns.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.ol_1 >= 25.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$3 = new LessLagTrend$compute$$inlined$groupingBy$1(destination);
  var counts = eachCount(tmp$ret$3);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(daily, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_0 = daily.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp = element_0.nl_1;
    var tmp$ret$7 = element_0.ol_1;
    destination_0.k2(tmp, tmp$ret$7);
  }
  var byDay = destination_0;
  var firstDay = first(daily).nl_1;
  var tmp0 = endDay == null ? last(daily).nl_1 : endDay;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = last(daily).nl_1;
  var lastDay = Math.max(tmp0, b);
  var r = params.z1s_1 * params.z1s_1;
  var qLevel = params.a1t_1 * params.a1t_1;
  var qSlope = params.b1t_1 * params.b1t_1;
  var predicted = ArrayList_init_$Create$((lastDay - firstDay | 0) + 1 | 0);
  var filtered = ArrayList_init_$Create$((lastDay - firstDay | 0) + 1 | 0);
  var state = new State(first(daily).ol_1, 0.0, r, 0.0, params.c1t_1 * params.c1t_1);
  var inductionVariable = firstDay;
  if (inductionVariable <= lastDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp_0;
      if (day === firstDay) {
        tmp_0 = state;
      } else {
        tmp_0 = new State(state.d1t_1 + state.e1t_1, state.e1t_1, state.f1t_1 + 2 * state.g1t_1 + state.h1t_1 + qLevel, state.g1t_1 + state.h1t_1, state.h1t_1 + qSlope);
      }
      var prior = tmp_0;
      predicted.f(prior);
      var reading = byDay.s1(day);
      var tmp_1;
      if (reading == null || day === firstDay) {
        tmp_1 = prior;
      } else {
        var tmp1_elvis_lhs = counts.s1(day);
        var variance = r / (tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs);
        var s = prior.f1t_1 + variance;
        var k0 = prior.f1t_1 / s;
        var k1 = prior.g1t_1 / s;
        var innovation = reading - prior.d1t_1;
        tmp_1 = new State(prior.d1t_1 + k0 * innovation, prior.e1t_1 + k1 * innovation, prior.f1t_1 - k0 * prior.f1t_1, prior.g1t_1 - k0 * prior.g1t_1, prior.h1t_1 - k1 * prior.g1t_1);
      }
      state = tmp_1;
      filtered.f(state);
    }
     while (!(day === lastDay));
  var smoothedLevels = smooth(this, predicted, filtered);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_0 = numberRangeToNumber(firstDay, lastDay);
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var index = 0;
  var inductionVariable_0 = this_0.oc_1;
  var last_0 = this_0.pc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var _unary__edvuaz = index;
      index = _unary__edvuaz + 1 | 0;
      var tmp0_0 = checkIndexOverflow(_unary__edvuaz);
      var day_0 = item;
      var scale = byDay.s1(day_0);
      var tmp$ret$11 = new TrendPoint(day_0, scale, scale == null ? smoothedLevels[tmp0_0] : scale, smoothedLevels[tmp0_0]);
      destination_1.f(tmp$ret$11);
    }
     while (!(item === last_0));
  return destination_1;
};
protoOf(LessLagTrend).x1s = function (weighIns, endDay, params, $super) {
  endDay = endDay === VOID ? null : endDay;
  params = params === VOID ? new LessLagParams() : params;
  return $super === VOID ? this.j1t(weighIns, endDay, params) : $super.j1t.call(this, weighIns, endDay, params);
};
var LessLagTrend_instance;
function LessLagTrend_getInstance() {
  return LessLagTrend_instance;
}
function TrendMethod_CLASSIC_getInstance() {
  static_init_72();
  return TrendMethod_CLASSIC_instance;
}
function TrendMethod_LESS_LAG_getInstance() {
  static_init_72();
  return TrendMethod_LESS_LAG_instance;
}
function TrendMethod_CLASSIC_FAST_getInstance() {
  static_init_72();
  return TrendMethod_CLASSIC_FAST_instance;
}
function TrendMethod_LESS_LAG_WATER_getInstance() {
  static_init_72();
  return TrendMethod_LESS_LAG_WATER_instance;
}
function TransientTrendParams(levelSdKg, slopeSdKgPerDay, initialSlopeSdKgPerDay, transientSdKg, transientHalfLifeDays, readingNoiseFraction, readingNoiseMinKg, readingNoiseMaxKg, readingNoiseKg, robust, huberK, residualWindow, minResiduals) {
  levelSdKg = levelSdKg === VOID ? 0.02 : levelSdKg;
  slopeSdKgPerDay = slopeSdKgPerDay === VOID ? 0.002 : slopeSdKgPerDay;
  initialSlopeSdKgPerDay = initialSlopeSdKgPerDay === VOID ? 0.05 : initialSlopeSdKgPerDay;
  transientSdKg = transientSdKg === VOID ? 0.3 : transientSdKg;
  transientHalfLifeDays = transientHalfLifeDays === VOID ? 3.5 : transientHalfLifeDays;
  readingNoiseFraction = readingNoiseFraction === VOID ? 0.007 : readingNoiseFraction;
  readingNoiseMinKg = readingNoiseMinKg === VOID ? 0.45 : readingNoiseMinKg;
  readingNoiseMaxKg = readingNoiseMaxKg === VOID ? 0.85 : readingNoiseMaxKg;
  readingNoiseKg = readingNoiseKg === VOID ? 0.4 : readingNoiseKg;
  robust = robust === VOID ? true : robust;
  huberK = huberK === VOID ? 1.345 : huberK;
  residualWindow = residualWindow === VOID ? 30 : residualWindow;
  minResiduals = minResiduals === VOID ? 7 : minResiduals;
  this.k1t_1 = levelSdKg;
  this.l1t_1 = slopeSdKgPerDay;
  this.m1t_1 = initialSlopeSdKgPerDay;
  this.n1t_1 = transientSdKg;
  this.o1t_1 = transientHalfLifeDays;
  this.p1t_1 = readingNoiseFraction;
  this.q1t_1 = readingNoiseMinKg;
  this.r1t_1 = readingNoiseMaxKg;
  this.s1t_1 = readingNoiseKg;
  this.t1t_1 = robust;
  this.u1t_1 = huberK;
  this.v1t_1 = residualWindow;
  this.w1t_1 = minResiduals;
  // Inline function 'kotlin.require' call
  if (!(this.k1t_1 >= 0.0 && this.l1t_1 > 0.0 && this.m1t_1 > 0.0 && this.n1t_1 >= 0.0)) {
    var message = 'noise must not be negative';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(this.o1t_1 >= 0.0 && this.s1t_1 > 0.0 && this.q1t_1 > 0.0 && this.r1t_1 >= this.q1t_1)) {
    var message_0 = 'settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(this.u1t_1 > 0.0 && this.v1t_1 > 0 && this.w1t_1 > 0)) {
    var message_1 = 'robust settings must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
}
protoOf(TransientTrendParams).toString = function () {
  return 'TransientTrendParams(levelSdKg=' + this.k1t_1 + ', slopeSdKgPerDay=' + this.l1t_1 + ', initialSlopeSdKgPerDay=' + this.m1t_1 + ', transientSdKg=' + this.n1t_1 + ', transientHalfLifeDays=' + this.o1t_1 + ', readingNoiseFraction=' + this.p1t_1 + ', readingNoiseMinKg=' + this.q1t_1 + ', readingNoiseMaxKg=' + this.r1t_1 + ', readingNoiseKg=' + this.s1t_1 + ', robust=' + this.t1t_1 + ', huberK=' + this.u1t_1 + ', residualWindow=' + this.v1t_1 + ', minResiduals=' + this.w1t_1 + ')';
};
protoOf(TransientTrendParams).hashCode = function () {
  var result = getNumberHashCode(this.k1t_1);
  result = imul(result, 31) + getNumberHashCode(this.l1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.m1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.n1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.o1t_1) | 0;
  result = imul(result, 31) + (this.p1t_1 == null ? 0 : getNumberHashCode(this.p1t_1)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.q1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.r1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.s1t_1) | 0;
  result = imul(result, 31) + getBooleanHashCode(this.t1t_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.u1t_1) | 0;
  result = imul(result, 31) + this.v1t_1 | 0;
  result = imul(result, 31) + this.w1t_1 | 0;
  return result;
};
protoOf(TransientTrendParams).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TransientTrendParams))
    return false;
  if (!equals(this.k1t_1, other.k1t_1))
    return false;
  if (!equals(this.l1t_1, other.l1t_1))
    return false;
  if (!equals(this.m1t_1, other.m1t_1))
    return false;
  if (!equals(this.n1t_1, other.n1t_1))
    return false;
  if (!equals(this.o1t_1, other.o1t_1))
    return false;
  if (!equals(this.p1t_1, other.p1t_1))
    return false;
  if (!equals(this.q1t_1, other.q1t_1))
    return false;
  if (!equals(this.r1t_1, other.r1t_1))
    return false;
  if (!equals(this.s1t_1, other.s1t_1))
    return false;
  if (!(this.t1t_1 === other.t1t_1))
    return false;
  if (!equals(this.u1t_1, other.u1t_1))
    return false;
  if (!(this.v1t_1 === other.v1t_1))
    return false;
  if (!(this.w1t_1 === other.w1t_1))
    return false;
  return true;
};
function TransientTrendPoint(point, transientKg, noiseKg) {
  this.du_1 = point;
  this.eu_1 = transientKg;
  this.fu_1 = noiseKg;
}
protoOf(TransientTrendPoint).toString = function () {
  return 'TransientTrendPoint(point=' + this.du_1.toString() + ', transientKg=' + this.eu_1 + ', noiseKg=' + this.fu_1 + ')';
};
protoOf(TransientTrendPoint).hashCode = function () {
  var result = this.du_1.hashCode();
  result = imul(result, 31) + getNumberHashCode(this.eu_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.fu_1) | 0;
  return result;
};
protoOf(TransientTrendPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TransientTrendPoint))
    return false;
  if (!this.du_1.equals(other.du_1))
    return false;
  if (!equals(this.eu_1, other.eu_1))
    return false;
  if (!equals(this.fu_1, other.fu_1))
    return false;
  return true;
};
function update_0($this, x, p, innovation, r) {
  var tmp = 0;
  var tmp_0 = new Float64Array(3);
  while (tmp < 3) {
    var tmp_1 = tmp;
    tmp_0[tmp_1] = p.n11(tmp_1, 0) + p.n11(tmp_1, 2);
    tmp = tmp + 1 | 0;
  }
  var ph = tmp_0;
  var s = ph[0] + ph[2] + r;
  var tmp_2 = 0;
  var tmp_3 = new Float64Array(3);
  while (tmp_2 < 3) {
    var tmp_4 = tmp_2;
    tmp_3[tmp_4] = ph[tmp_4] / s;
    tmp_2 = tmp_2 + 1 | 0;
  }
  var gain = tmp_3;
  var tmp_5 = 0;
  var tmp_6 = new Float64Array(9);
  while (tmp_5 < 9) {
    var tmp_7 = tmp_5;
    var i = tmp_7 / 3 | 0;
    var j = tmp_7 % 3 | 0;
    tmp_6[tmp_7] = (i === j ? 1.0 : 0.0) - gain[i] * (j === 0 || j === 2 ? 1.0 : 0.0);
    tmp_5 = tmp_5 + 1 | 0;
  }
  var a = new Matrix3(tmp_6);
  var joseph = a.o11(p).p11(a);
  var tmp_8 = 0;
  var tmp_9 = new Float64Array(9);
  while (tmp_8 < 9) {
    var tmp_10 = tmp_8;
    tmp_9[tmp_10] = joseph.m11_1[tmp_10] + gain[tmp_10 / 3 | 0] * r * gain[tmp_10 % 3 | 0];
    tmp_8 = tmp_8 + 1 | 0;
  }
  var covariance = new Matrix3(tmp_9);
  var tmp_11 = 0;
  var tmp_12 = new Float64Array(3);
  while (tmp_11 < 3) {
    var tmp_13 = tmp_11;
    tmp_12[tmp_13] = x[tmp_13] + gain[tmp_13] * innovation;
    tmp_11 = tmp_11 + 1 | 0;
  }
  return to(tmp_12, covariance);
}
function smooth_0($this, f, predictedX, predictedP, filteredX, filteredP) {
  var n = filteredX.o();
  var result = ArrayList_init_$Create$_1(filteredX);
  var inductionVariable = n - 2 | 0;
  if (0 <= inductionVariable)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + -1 | 0;
      var c = filteredP.n(i).p11(f).o11(predictedP.n(i + 1 | 0).v11());
      var next = result.n(i + 1 | 0);
      var pred = predictedX.n(i + 1 | 0);
      var tmp = 0;
      var tmp_0 = new Float64Array(3);
      while (tmp < 3) {
        var tmp_1 = tmp;
        tmp_0[tmp_1] = next[tmp_1] - pred[tmp_1];
        tmp = tmp + 1 | 0;
      }
      var diff = tmp_0;
      var tmp_2 = 0;
      var tmp_3 = new Float64Array(3);
      while (tmp_2 < 3) {
        var tmp_4 = tmp_2;
        tmp_3[tmp_4] = filteredX.n(i)[tmp_4] + c.n11(tmp_4, 0) * diff[0] + c.n11(tmp_4, 1) * diff[1] + c.n11(tmp_4, 2) * diff[2];
        tmp_2 = tmp_2 + 1 | 0;
      }
      result.n2(i, tmp_3);
    }
     while (0 <= inductionVariable);
  return result;
}
function median($this, values) {
  var sorted_0 = sorted(values);
  var middle = sorted_0.o() / 2 | 0;
  return (sorted_0.o() % 2 | 0) === 1 ? sorted_0.n(middle) : (sorted_0.n(middle - 1 | 0) + sorted_0.n(middle)) / 2.0;
}
function TransientTrend$compute$$inlined$groupingBy$1($this) {
  this.x1t_1 = $this;
}
protoOf(TransientTrend$compute$$inlined$groupingBy$1).i2 = function () {
  return this.x1t_1.j();
};
protoOf(TransientTrend$compute$$inlined$groupingBy$1).r11 = function (element) {
  return element.nl_1;
};
protoOf(TransientTrend$compute$$inlined$groupingBy$1).j2 = function (element) {
  return this.r11(element);
};
function TransientTrend() {
  this.au_1 = 1.4826;
  this.bu_1 = 1.0E-12;
}
protoOf(TransientTrend).cu = function (weighIns, endDay, params) {
  var daily = WeightTrend_instance.bm(weighIns);
  if (daily.m())
    return emptyList();
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weighIns.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.ol_1 >= 25.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupingBy' call
  var tmp$ret$3 = new TransientTrend$compute$$inlined$groupingBy$1(destination);
  var counts = eachCount(tmp$ret$3);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(daily, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_0 = daily.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp = element_0.nl_1;
    var tmp$ret$7 = element_0.ol_1;
    destination_0.k2(tmp, tmp$ret$7);
  }
  var byDay = destination_0;
  var firstDay = first(daily).nl_1;
  var tmp0 = endDay == null ? last(daily).nl_1 : endDay;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = last(daily).nl_1;
  var lastDay = Math.max(tmp0, b);
  var tmp_0;
  if (params.o1t_1 === 0.0) {
    tmp_0 = 0.0;
  } else {
    // Inline function 'kotlin.math.pow' call
    var x = 1.0 / params.o1t_1;
    tmp_0 = Math.pow(0.5, x);
  }
  var phi = tmp_0;
  var transientVariance = params.n1t_1 * params.n1t_1;
  // Inline function 'kotlin.doubleArrayOf' call
  var tmp$ret$10 = new Float64Array([1.0, 1.0, 0.0, 0.0, 1.0, 0.0, 0.0, 0.0, phi]);
  var f = new Matrix3(tmp$ret$10);
  var qLevel = params.k1t_1 * params.k1t_1;
  var qSlope = params.l1t_1 * params.l1t_1;
  var qTransient = transientVariance * (1.0 - phi * phi) + 1.0E-12;
  var firstNoise = this.y1t(first(daily).ol_1, params);
  var n = (lastDay - firstDay | 0) + 1 | 0;
  var predictedX = ArrayList_init_$Create$(n);
  var predictedP = ArrayList_init_$Create$(n);
  var filteredX = ArrayList_init_$Create$(n);
  var filteredP = ArrayList_init_$Create$(n);
  // Inline function 'kotlin.doubleArrayOf' call
  var x_0 = new Float64Array([first(daily).ol_1, 0.0, 0.0]);
  var p = Companion_instance_6.s11(firstNoise * firstNoise + transientVariance, params.m1t_1 * params.m1t_1, transientVariance + 1.0E-12);
  var residuals = ArrayDeque_init_$Create$();
  var inductionVariable = firstDay;
  if (inductionVariable <= lastDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      if (!(day === firstDay)) {
        // Inline function 'kotlin.doubleArrayOf' call
        x_0 = new Float64Array([x_0[0] + x_0[1], x_0[1], phi * x_0[2]]);
        p = f.o11(p).p11(f).t11(qLevel, qSlope, qTransient);
      }
      predictedX.f(x_0);
      predictedP.f(p);
      var reading = byDay.s1(day);
      if (!(reading == null) && !(day === firstDay)) {
        var sd = this.y1t(reading, params);
        var tmp_1 = sd * sd;
        var tmp1_elvis_lhs = counts.s1(day);
        var r = tmp_1 / (tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs);
        var innovation = reading - (x_0[0] + x_0[2]);
        var s = p.n11(0, 0) + 2.0 * p.n11(0, 2) + p.n11(2, 2) + r;
        if (params.t1t_1) {
          // Inline function 'kotlin.math.sqrt' call
          var z = innovation / Math.sqrt(s);
          if (residuals.la_1 >= params.w1t_1) {
            var centre = median(this, residuals);
            // Inline function 'kotlin.collections.map' call
            // Inline function 'kotlin.collections.mapTo' call
            var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(residuals, 10));
            var _iterator__ex2g4s_1 = residuals.j();
            while (_iterator__ex2g4s_1.k()) {
              var item = _iterator__ex2g4s_1.l();
              // Inline function 'kotlin.math.abs' call
              var x_1 = item - centre;
              var tmp$ret$16 = Math.abs(x_1);
              destination_1.f(tmp$ret$16);
            }
            var scale = 1.4826 * median(this, destination_1);
            var tmp_2;
            if (scale > 0.0) {
              // Inline function 'kotlin.math.abs' call
              var x_2 = z - centre;
              tmp_2 = Math.abs(x_2) / scale;
            } else {
              tmp_2 = 0.0;
            }
            var u = tmp_2;
            if (u > params.u1t_1)
              r = r * (u / params.u1t_1);
          }
          residuals.pa(z);
          if (residuals.la_1 > params.v1t_1) {
            residuals.qa();
          }
        }
        var _destruct__k2r9zo = update_0(this, x_0, p, innovation, r);
        var updatedX = _destruct__k2r9zo.ya();
        var updatedP = _destruct__k2r9zo.za();
        x_0 = updatedX;
        p = updatedP;
      }
      filteredX.f(x_0);
      filteredP.f(p);
    }
     while (!(day === lastDay));
  var smoothed = smooth_0(this, f, predictedX, predictedP, filteredX, filteredP);
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, n);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable_0 = this_0.oc_1;
  var last_0 = this_0.pc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var index = item_0;
      var day_0 = firstDay + index | 0;
      var scale_0 = byDay.s1(day_0);
      var level = smoothed.n(index)[0];
      var tmp_3 = TransientTrend_instance;
      // Inline function 'kotlin.let' call
      var it = tmp_3.y1t(scale_0 == null ? level : scale_0, params);
      // Inline function 'kotlin.math.sqrt' call
      var x_3 = it * it + transientVariance;
      var noise = Math.sqrt(x_3);
      var tmp$ret$21 = new TransientTrendPoint(new TrendPoint(day_0, scale_0, scale_0 == null ? level : scale_0, level), smoothed.n(index)[2], noise);
      destination_2.f(tmp$ret$21);
    }
     while (!(item_0 === last_0));
  return destination_2;
};
protoOf(TransientTrend).y1s = function (weighIns, endDay, params, $super) {
  endDay = endDay === VOID ? null : endDay;
  params = params === VOID ? new TransientTrendParams() : params;
  return $super === VOID ? this.cu(weighIns, endDay, params) : $super.cu.call(this, weighIns, endDay, params);
};
protoOf(TransientTrend).y1t = function (kg, params) {
  var tmp0_safe_receiver = params.p1t_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.math.max' call
    var tmp$ret$2 = Math.max(kg, 25.0);
    tmp = coerceIn(tmp0_safe_receiver * tmp$ret$2, params.q1t_1, params.r1t_1);
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? params.s1t_1 : tmp1_elvis_lhs;
};
var TransientTrend_instance;
function TransientTrend_getInstance() {
  return TransientTrend_instance;
}
var static_init_called_73;
function static_init_73() {
  if (static_init_called_73)
    return Unit_instance;
  static_init_called_73 = true;
  Direction_INCREASE_instance = new Direction('INCREASE', 0);
  Direction_DECREASE_instance = new Direction('DECREASE', 1);
  Direction_NO_CHANGE_instance = new Direction('NO_CHANGE', 2);
}
var Direction_INCREASE_instance;
var Direction_DECREASE_instance;
var Direction_NO_CHANGE_instance;
function Direction(name, ordinal) {
  Enum.call(this, name, ordinal);
}
function WeightChange(days, kg) {
  this.z1t_1 = days;
  this.a1u_1 = kg;
}
protoOf(WeightChange).vy = function () {
  var tmp0_safe_receiver = this.a1u_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = tmp0_safe_receiver >= 0.05 ? Direction_INCREASE_getInstance() : tmp0_safe_receiver <= -0.05 ? Direction_DECREASE_getInstance() : Direction_NO_CHANGE_getInstance();
  }
  return tmp;
};
protoOf(WeightChange).toString = function () {
  return 'WeightChange(days=' + this.z1t_1 + ', kg=' + this.a1u_1 + ')';
};
protoOf(WeightChange).hashCode = function () {
  var result = this.z1t_1;
  result = imul(result, 31) + (this.a1u_1 == null ? 0 : getNumberHashCode(this.a1u_1)) | 0;
  return result;
};
protoOf(WeightChange).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeightChange))
    return false;
  if (!(this.z1t_1 === other.z1t_1))
    return false;
  if (!equals(this.a1u_1, other.a1u_1))
    return false;
  return true;
};
function Companion_27() {
  Companion_instance_29 = this;
  this.kw_1 = listOf([3, 7, 14, 30, 90]);
  this.lw_1 = 21;
  this.mw_1 = 30;
  this.nw_1 = 0.05;
}
protoOf(Companion_27).b1u = function (points, kcalPerKg, windows, weeklyWindowDays, projectionDays) {
  // Inline function 'kotlin.require' call
  if (!(kcalPerKg > 0.0)) {
    var message = 'kcalPerKg must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(weeklyWindowDays > 0 && projectionDays > 0)) {
    var message_0 = 'windows must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var tmp0_elvis_lhs = lastOrNull(points);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var current = tmp;
  var tmp1_safe_receiver = this.ow(points, weeklyWindowDays);
  var tmp_0;
  if (tmp1_safe_receiver == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = tmp1_safe_receiver / weeklyWindowDays * 7.0;
  }
  var weekly = tmp_0;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(windows, 10));
  var _iterator__ex2g4s = windows.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$8 = new WeightChange(item, Companion_getInstance_26().ow(points, item));
    destination.f(tmp$ret$8);
  }
  var tmp_1 = destination;
  var tmp_2;
  if (weekly == null) {
    tmp_2 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_2 = weekly / 7.0 * kcalPerKg;
  }
  var tmp_3 = tmp_2;
  var tmp_4;
  if (weekly == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_4 = current.zm_1 + weekly / 7.0 * projectionDays;
  }
  return new WeightInsights(current.zm_1, tmp_1, weekly, tmp_3, tmp_4, projectionDays);
};
protoOf(Companion_27).c1u = function (points, kcalPerKg, windows, weeklyWindowDays, projectionDays, $super) {
  windows = windows === VOID ? this.kw_1 : windows;
  weeklyWindowDays = weeklyWindowDays === VOID ? 21 : weeklyWindowDays;
  projectionDays = projectionDays === VOID ? 30 : projectionDays;
  return $super === VOID ? this.b1u(points, kcalPerKg, windows, weeklyWindowDays, projectionDays) : $super.b1u.call(this, points, kcalPerKg, windows, weeklyWindowDays, projectionDays);
};
protoOf(Companion_27).ow = function (points, days) {
  // Inline function 'kotlin.require' call
  if (!(days > 0)) {
    var message = 'days must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp0_elvis_lhs = lastOrNull(points);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var last = tmp;
  var tmp$ret$2;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = points.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.wm_1 === (last.wm_1 - days | 0)) {
        tmp$ret$2 = element;
        break $l$block;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$2;
  var tmp_0;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_0 = tmp1_elvis_lhs;
  }
  var start = tmp_0;
  return last.zm_1 - start.zm_1;
};
var Companion_instance_29;
function Companion_getInstance_26() {
  if (Companion_instance_29 == null)
    new Companion_27();
  return Companion_instance_29;
}
function WeightInsights(currentKg, changes, weeklyChangeKg, energyBalanceKcalPerDay, projectionKg, projectionDays) {
  Companion_getInstance_26();
  this.d1u_1 = currentKg;
  this.e1u_1 = changes;
  this.f1u_1 = weeklyChangeKg;
  this.g1u_1 = energyBalanceKcalPerDay;
  this.h1u_1 = projectionKg;
  this.i1u_1 = projectionDays;
}
protoOf(WeightInsights).toString = function () {
  return 'WeightInsights(currentKg=' + this.d1u_1 + ', changes=' + toString(this.e1u_1) + ', weeklyChangeKg=' + this.f1u_1 + ', energyBalanceKcalPerDay=' + this.g1u_1 + ', projectionKg=' + this.h1u_1 + ', projectionDays=' + this.i1u_1 + ')';
};
protoOf(WeightInsights).hashCode = function () {
  var result = getNumberHashCode(this.d1u_1);
  result = imul(result, 31) + hashCode(this.e1u_1) | 0;
  result = imul(result, 31) + (this.f1u_1 == null ? 0 : getNumberHashCode(this.f1u_1)) | 0;
  result = imul(result, 31) + (this.g1u_1 == null ? 0 : getNumberHashCode(this.g1u_1)) | 0;
  result = imul(result, 31) + (this.h1u_1 == null ? 0 : getNumberHashCode(this.h1u_1)) | 0;
  result = imul(result, 31) + this.i1u_1 | 0;
  return result;
};
protoOf(WeightInsights).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeightInsights))
    return false;
  if (!equals(this.d1u_1, other.d1u_1))
    return false;
  if (!equals(this.e1u_1, other.e1u_1))
    return false;
  if (!equals(this.f1u_1, other.f1u_1))
    return false;
  if (!equals(this.g1u_1, other.g1u_1))
    return false;
  if (!equals(this.h1u_1, other.h1u_1))
    return false;
  if (!(this.i1u_1 === other.i1u_1))
    return false;
  return true;
};
function WeighInHabit() {
}
protoOf(WeighInHabit).j1u = function (days, today) {
  var logged = toHashSet(days);
  var day = logged.r(today) ? today : today - 1 | 0;
  var count = 0;
  while (logged.r(day)) {
    count = count + 1 | 0;
    day = day - 1 | 0;
  }
  return count;
};
var WeighInHabit_instance;
function WeighInHabit_getInstance() {
  return WeighInHabit_instance;
}
function Direction_INCREASE_getInstance() {
  static_init_73();
  return Direction_INCREASE_instance;
}
function Direction_DECREASE_getInstance() {
  static_init_73();
  return Direction_DECREASE_instance;
}
function Direction_NO_CHANGE_getInstance() {
  static_init_73();
  return Direction_NO_CHANGE_instance;
}
function WeighIn(day, kg) {
  this.nl_1 = day;
  this.ol_1 = kg;
}
protoOf(WeighIn).toString = function () {
  return 'WeighIn(day=' + this.nl_1 + ', kg=' + this.ol_1 + ')';
};
protoOf(WeighIn).hashCode = function () {
  var result = this.nl_1;
  result = imul(result, 31) + getNumberHashCode(this.ol_1) | 0;
  return result;
};
protoOf(WeighIn).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof WeighIn))
    return false;
  if (!(this.nl_1 === other.nl_1))
    return false;
  if (!equals(this.ol_1, other.ol_1))
    return false;
  return true;
};
function TrendPoint(day, scaleKg, filledKg, trendKg) {
  this.wm_1 = day;
  this.xm_1 = scaleKg;
  this.ym_1 = filledKg;
  this.zm_1 = trendKg;
}
protoOf(TrendPoint).toString = function () {
  return 'TrendPoint(day=' + this.wm_1 + ', scaleKg=' + this.xm_1 + ', filledKg=' + this.ym_1 + ', trendKg=' + this.zm_1 + ')';
};
protoOf(TrendPoint).hashCode = function () {
  var result = this.wm_1;
  result = imul(result, 31) + (this.xm_1 == null ? 0 : getNumberHashCode(this.xm_1)) | 0;
  result = imul(result, 31) + getNumberHashCode(this.ym_1) | 0;
  result = imul(result, 31) + getNumberHashCode(this.zm_1) | 0;
  return result;
};
protoOf(TrendPoint).equals = function (other) {
  if (this === other)
    return true;
  if (!(other instanceof TrendPoint))
    return false;
  if (!(this.wm_1 === other.wm_1))
    return false;
  if (!equals(this.xm_1, other.xm_1))
    return false;
  if (!equals(this.ym_1, other.ym_1))
    return false;
  if (!equals(this.zm_1, other.zm_1))
    return false;
  return true;
};
function interpolate($this, daily, previousIndex, day) {
  var previous = daily.n(previousIndex);
  var tmp0_elvis_lhs = getOrNull_0(daily, previousIndex + 1 | 0);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return previous.ol_1;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var next = tmp;
  var span = next.nl_1 - previous.nl_1 | 0;
  var fraction = (day - previous.nl_1 | 0) / span;
  return previous.ol_1 + (next.ol_1 - previous.ol_1) * fraction;
}
function sam$kotlin_Comparator$0_20(function_0) {
  this.k1u_1 = function_0;
}
protoOf(sam$kotlin_Comparator$0_20).y9 = function (a, b) {
  return this.k1u_1(a, b);
};
protoOf(sam$kotlin_Comparator$0_20).compare = function (a, b) {
  return this.y9(a, b);
};
protoOf(sam$kotlin_Comparator$0_20).g2 = function () {
  return this.k1u_1;
};
protoOf(sam$kotlin_Comparator$0_20).equals = function (other) {
  var tmp;
  if (!(other == null) ? isInterface(other, Comparator) : false) {
    var tmp_0;
    if (!(other == null) ? isInterface(other, FunctionAdapter) : false) {
      tmp_0 = equals(this.g2(), other.g2());
    } else {
      tmp_0 = false;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
};
protoOf(sam$kotlin_Comparator$0_20).hashCode = function () {
  return hashCode(this.g2());
};
function WeightTrend$dailyAverages$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.nl_1;
  var tmp$ret$2 = b.nl_1;
  return compareValues(tmp, tmp$ret$2);
}
function WeightTrend() {
  this.xl_1 = 0.1;
  this.yl_1 = 20;
  this.zl_1 = 0.2222222222222222;
  this.am_1 = 25.0;
}
protoOf(WeightTrend).bm = function (weighIns) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = weighIns.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.ol_1 >= 25.0) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.groupBy' call
  // Inline function 'kotlin.collections.groupByTo' call
  var destination_0 = LinkedHashMap_init_$Create$_1();
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var key = element_0.nl_1;
    // Inline function 'kotlin.collections.getOrPut' call
    var value = destination_0.s1(key);
    var tmp;
    if (value == null) {
      var answer = ArrayList_init_$Create$_0();
      destination_0.k2(key, answer);
      tmp = answer;
    } else {
      tmp = value;
    }
    var list = tmp;
    list.f(element_0);
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(destination_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_1 = destination_0.v1().j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    // Inline function 'kotlin.collections.component1' call
    var day = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var readings = item.p1();
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var _iterator__ex2g4s_2 = readings.j();
    while (_iterator__ex2g4s_2.k()) {
      var element_1 = _iterator__ex2g4s_2.l();
      var tmp_0 = sum;
      sum = tmp_0 + element_1.ol_1;
    }
    var tmp$ret$14 = sum;
    var tmp$ret$11 = new WeighIn(day, tmp$ret$14 / readings.o());
    destination_1.f(tmp$ret$11);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_1 = WeightTrend$dailyAverages$lambda;
  var tmp$ret$17 = new sam$kotlin_Comparator$0_20(tmp_1);
  return sortedWith(destination_1, tmp$ret$17);
};
protoOf(WeightTrend).w1s = function (weighIns, endDay, alpha) {
  // Inline function 'kotlin.require' call
  if (!(alpha > 0.0 && alpha <= 1.0)) {
    var message = 'alpha must be in (0, 1]';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var daily = this.bm(weighIns);
  if (daily.m())
    return emptyList();
  var firstDay = first(daily).nl_1;
  var tmp0 = endDay == null ? last(daily).nl_1 : endDay;
  // Inline function 'kotlin.comparisons.maxOf' call
  var b = last(daily).nl_1;
  var lastDay = Math.max(tmp0, b);
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(daily, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = daily.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp = element.nl_1;
    var tmp$ret$6 = element.ol_1;
    destination.k2(tmp, tmp$ret$6);
  }
  var byDay = destination;
  var points = ArrayList_init_$Create$((lastDay - firstDay | 0) + 1 | 0);
  var previousIndex = 0;
  var trend = first(daily).ol_1;
  var inductionVariable = firstDay;
  if (inductionVariable <= lastDay)
    do {
      var day = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      while ((previousIndex + 1 | 0) < daily.o() && daily.n(previousIndex + 1 | 0).nl_1 <= day) {
        previousIndex = previousIndex + 1 | 0;
      }
      var scale = byDay.s1(day);
      var filled = scale == null ? interpolate(this, daily, previousIndex, day) : scale;
      trend = day === firstDay ? filled : trend + alpha * (filled - trend);
      points.f(new TrendPoint(day, scale, filled, trend));
    }
     while (!(day === lastDay));
  return points;
};
protoOf(WeightTrend).vm = function (weighIns, endDay, alpha, $super) {
  endDay = endDay === VOID ? null : endDay;
  alpha = alpha === VOID ? 0.1 : alpha;
  return $super === VOID ? this.w1s(weighIns, endDay, alpha) : $super.w1s.call(this, weighIns, endDay, alpha);
};
protoOf(WeightTrend).l1u = function (points, windowDays) {
  // Inline function 'kotlin.require' call
  if (!(windowDays > 0)) {
    var message = 'windowDays must be positive';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  if (points.o() <= windowDays)
    return null;
  var last_0 = last(points);
  var start = points.n((points.o() - 1 | 0) - windowDays | 0);
  return (last_0.zm_1 - start.zm_1) / (last_0.wm_1 - start.wm_1 | 0) * 7.0;
};
protoOf(WeightTrend).iu = function (points, windowDays, $super) {
  windowDays = windowDays === VOID ? 20 : windowDays;
  return $super === VOID ? this.l1u(points, windowDays) : $super.l1u.call(this, points, windowDays);
};
var WeightTrend_instance;
function WeightTrend_getInstance() {
  return WeightTrend_instance;
}
function JsExpenditureModel(series, dynamic, initialKcal, kcalPerKg, bandDays, bandSettledKcal, bandResponsiveKcal, comparison) {
  this.series = series;
  this.dynamic = dynamic;
  this.initialKcal = initialKcal;
  this.kcalPerKg = kcalPerKg;
  this.bandDays = bandDays;
  this.bandSettledKcal = bandSettledKcal;
  this.bandResponsiveKcal = bandResponsiveKcal;
  this.comparison = comparison;
}
protoOf(JsExpenditureModel).m1u = function () {
  return this.series;
};
protoOf(JsExpenditureModel).n1u = function () {
  return this.dynamic;
};
protoOf(JsExpenditureModel).o1u = function () {
  return this.initialKcal;
};
protoOf(JsExpenditureModel).p1u = function () {
  return this.kcalPerKg;
};
protoOf(JsExpenditureModel).q1u = function () {
  return this.bandDays;
};
protoOf(JsExpenditureModel).r1u = function () {
  return this.bandSettledKcal;
};
protoOf(JsExpenditureModel).s1u = function () {
  return this.bandResponsiveKcal;
};
protoOf(JsExpenditureModel).t1u = function () {
  return this.comparison;
};
function expenditureModel(algorithmsJson, endDay, weighDays, weighKg, intakeDays, intakeKcal, intakeStatus, intakeCarbsG, intakeSodiumMg, trendKg, sex, ageYears, heightCm, bodyFatFraction, waistCm, activityLevel, goalDays, goalTypes, goalRates, goalTargets, stepsDays, steps, checkInDays, checkInKcal) {
  // Inline function 'kotlin.require' call
  if (!(intakeCarbsG.length === intakeDays.length && intakeSodiumMg.length === intakeDays.length)) {
    var message = 'intake arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(goalDays.length === goalTypes.length && goalDays.length === goalRates.length && goalDays.length === goalTargets.length)) {
    var message_0 = 'goal arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.require' call
  if (!(stepsDays.length === steps.length && checkInDays.length === checkInKcal.length)) {
    var message_1 = 'parallel arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message_1));
  }
  var intake = toIntake(intakeDays, intakeKcal, intakeStatus);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = get_indices(intake);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var inductionVariable = tmp0.oc_1;
  var last = tmp0.pc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      if (intake.n(it).oj_1.equals(DayStatus_COMPLETE_getInstance())) {
        destination.f(element);
      }
    }
     while (!(element === last));
  var logged = destination;
  var tmp;
  if (!(sex == null) && !(ageYears == null) && !(heightCm == null) && !(activityLevel == null)) {
    tmp = new BodyProfile(valueOf_7(sex), ageYears, heightCm, bodyFatFraction, null, valueOf_8(activityLevel), waistCm);
  } else {
    tmp = null;
  }
  var profile = tmp;
  var tmp_0 = ExpenditureRunner_instance;
  var tmp_1 = AlgorithmJson_getInstance().tf(algorithmsJson);
  var tmp_2 = toWeighIns(weighDays, weighKg);
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(goalDays);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable_0 = this_0.oc_1;
  var last_0 = this_0.pc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = item;
      var tmp$ret$11 = new GoalPeriodStart(goalDays[it_0], new Goal(valueOf(goalTypes[it_0]), goalRates[it_0], goalTargets[it_0]));
      destination_0.f(tmp$ret$11);
    }
     while (!(item === last_0));
  var tmp_3 = destination_0;
  // Inline function 'kotlin.collections.associate' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(logged, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_1 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = logged.j();
  while (_iterator__ex2g4s.k()) {
    var element_0 = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(intakeDays[element_0], intakeCarbsG[element_0]);
    destination_1.k2(pair.hb_1, pair.ib_1);
  }
  var tmp_4 = destination_1;
  // Inline function 'kotlin.collections.associate' call
  var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(logged, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_2 = LinkedHashMap_init_$Create$(capacity_0);
  var _iterator__ex2g4s_0 = logged.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_1 = _iterator__ex2g4s_0.l();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair_0 = to(intakeDays[element_1], intakeSodiumMg[element_1]);
    destination_2.k2(pair_0.hb_1, pair_0.ib_1);
  }
  var tmp_5 = destination_2;
  // Inline function 'kotlin.collections.associate' call
  var this_1 = get_indices_0(stepsDays);
  var capacity_1 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_3 = LinkedHashMap_init_$Create$(capacity_1);
  var inductionVariable_1 = this_1.oc_1;
  var last_1 = this_1.pc_1;
  if (inductionVariable_1 <= last_1)
    do {
      var element_2 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var it_1 = element_2;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_1 = to(stepsDays[it_1], steps[it_1]);
      destination_3.k2(pair_1.hb_1, pair_1.ib_1);
    }
     while (!(element_2 === last_1));
  var tmp_6 = new DailyInputs(tmp_4, tmp_5, destination_3);
  // Inline function 'kotlin.collections.associate' call
  var this_2 = get_indices_0(checkInDays);
  var capacity_2 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination_4 = LinkedHashMap_init_$Create$(capacity_2);
  var inductionVariable_2 = this_2.oc_1;
  var last_2 = this_2.pc_1;
  if (inductionVariable_2 <= last_2)
    do {
      var element_3 = inductionVariable_2;
      inductionVariable_2 = inductionVariable_2 + 1 | 0;
      var it_2 = element_3;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair_2 = to(checkInDays[it_2], checkInKcal[it_2]);
      destination_4.k2(pair_2.hb_1, pair_2.ib_1);
    }
     while (!(element_3 === last_2));
  var run = tmp_0.wl(tmp_1, new ExpenditureInput(endDay, tmp_2, intake, profile, trendKg, bodyFatFraction, tmp_3, tmp_6, destination_4));
  var tmp_7 = toJs_0(run.gl_1);
  var tmp_8 = toJs_0(run.hl_1);
  var tmp0_safe_receiver = run.kl_1;
  var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.az_1;
  var tmp2_elvis_lhs = tmp1_safe_receiver == null ? null : toIntArray(tmp1_safe_receiver);
  var tmp_9 = tmp2_elvis_lhs == null ? new Int32Array(0) : tmp2_elvis_lhs;
  var tmp3_safe_receiver = run.kl_1;
  var tmp4_safe_receiver = tmp3_safe_receiver == null ? null : tmp3_safe_receiver.bz_1;
  var tmp5_elvis_lhs = tmp4_safe_receiver == null ? null : toDoubleArray(tmp4_safe_receiver);
  var tmp_10 = tmp5_elvis_lhs == null ? new Float64Array(0) : tmp5_elvis_lhs;
  var tmp6_safe_receiver = run.kl_1;
  var tmp7_safe_receiver = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.cz_1;
  var tmp8_elvis_lhs = tmp7_safe_receiver == null ? null : toDoubleArray(tmp7_safe_receiver);
  var tmp_11 = tmp8_elvis_lhs == null ? new Float64Array(0) : tmp8_elvis_lhs;
  var tmp9_safe_receiver = run.ll_1;
  return new JsExpenditureModel(tmp_7, tmp_8, run.il_1, run.jl_1, tmp_9, tmp_10, tmp_11, tmp9_safe_receiver == null ? null : toJs_0(tmp9_safe_receiver));
}
function JsAlgorithmOption(key, label, help, kind, values, labels) {
  this.key = key;
  this.label = label;
  this.help = help;
  this.kind = kind;
  this.values = values;
  this.labels = labels;
}
protoOf(JsAlgorithmOption).o1 = function () {
  return this.key;
};
protoOf(JsAlgorithmOption).u1u = function () {
  return this.label;
};
protoOf(JsAlgorithmOption).v1u = function () {
  return this.help;
};
protoOf(JsAlgorithmOption).w1u = function () {
  return this.kind;
};
protoOf(JsAlgorithmOption).u1 = function () {
  return this.values;
};
protoOf(JsAlgorithmOption).x1u = function () {
  return this.labels;
};
function algorithmOptions() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = AlgorithmJson_getInstance().rf_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.map' call
    var this_1 = item.me_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
    var _iterator__ex2g4s_0 = this_1.j();
    while (_iterator__ex2g4s_0.k()) {
      var item_0 = _iterator__ex2g4s_0.l();
      var tmp$ret$5 = item_0.ge_1;
      destination_0.f(tmp$ret$5);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp = copyToArray(destination_0);
    // Inline function 'kotlin.collections.map' call
    var this_2 = item.me_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
    var _iterator__ex2g4s_1 = this_2.j();
    while (_iterator__ex2g4s_1.k()) {
      var item_1 = _iterator__ex2g4s_1.l();
      var tmp$ret$9 = item_1.he_1;
      destination_1.f(tmp$ret$9);
    }
    // Inline function 'kotlin.collections.toTypedArray' call
    var tmp$ret$10 = copyToArray(destination_1);
    var tmp$ret$2 = new JsAlgorithmOption(item.ie_1, item.je_1, item.ke_1, item.le_1.w1_1, tmp, tmp$ret$10);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function algorithmValues(algorithmsJson) {
  var values = AlgorithmJson_getInstance().wf(AlgorithmJson_getInstance().tf(algorithmsJson));
  // Inline function 'kotlin.collections.map' call
  var this_0 = AlgorithmJson_getInstance().rf_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = getValue(values, item.ie_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function algorithmsWith(algorithmsJson, key, value) {
  return AlgorithmJson_getInstance().xf(algorithmsJson, key, value);
}
function JsDisplayedExpenditure(point, waitingForWeighIn) {
  this.point = point;
  this.waitingForWeighIn = waitingForWeighIn;
}
protoOf(JsDisplayedExpenditure).y1u = function () {
  return this.point;
};
protoOf(JsDisplayedExpenditure).z1u = function () {
  return this.waitingForWeighIn;
};
function displayedExpenditure(series, today, weighedInToday) {
  var tmp0_safe_receiver = ExpenditureInsights_getInstance().bw(toPoints(series), today, weighedInToday);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new JsDisplayedExpenditure(toJs(tmp0_safe_receiver.cw_1), tmp0_safe_receiver.dw_1);
  }
  return tmp;
}
function JsExpenditureChanges(changeDays, changeKcal, changeDirection, averageDailyChangeKcal) {
  this.changeDays = changeDays;
  this.changeKcal = changeKcal;
  this.changeDirection = changeDirection;
  this.averageDailyChangeKcal = averageDailyChangeKcal;
}
protoOf(JsExpenditureChanges).a1v = function () {
  return this.changeDays;
};
protoOf(JsExpenditureChanges).b1v = function () {
  return this.changeKcal;
};
protoOf(JsExpenditureChanges).c1v = function () {
  return this.changeDirection;
};
protoOf(JsExpenditureChanges).d1v = function () {
  return this.averageDailyChangeKcal;
};
function expenditureChanges(series) {
  var list = toPoints(series);
  var changes = ExpenditureInsights_getInstance().yy(list);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(changes, 10));
  var _iterator__ex2g4s = changes.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.ty_1;
    destination.f(tmp$ret$2);
  }
  var tmp = toIntArray(destination);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(changes, 10));
  var _iterator__ex2g4s_0 = changes.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.uy_1;
    destination_0.f(tmp$ret$5);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_0 = copyToArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(changes, 10));
  var _iterator__ex2g4s_1 = changes.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp0_safe_receiver = item_1.vy();
    var tmp$ret$9 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1_1;
    destination_1.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$10 = copyToArray(destination_1);
  return new JsExpenditureChanges(tmp, tmp_0, tmp$ret$10, ExpenditureInsights_getInstance().zy(list));
}
function JsEnergyBalancePoint(day, intakeKcal, status, usable, expenditureKcal, targetKcal, balanceKcal, intakeAverageKcal, expenditureAverageKcal, balanceAverageKcal) {
  this.day = day;
  this.intakeKcal = intakeKcal;
  this.status = status;
  this.usable = usable;
  this.expenditureKcal = expenditureKcal;
  this.targetKcal = targetKcal;
  this.balanceKcal = balanceKcal;
  this.intakeAverageKcal = intakeAverageKcal;
  this.expenditureAverageKcal = expenditureAverageKcal;
  this.balanceAverageKcal = balanceAverageKcal;
}
protoOf(JsEnergyBalancePoint).e1v = function () {
  return this.day;
};
protoOf(JsEnergyBalancePoint).f1v = function () {
  return this.intakeKcal;
};
protoOf(JsEnergyBalancePoint).g1v = function () {
  return this.status;
};
protoOf(JsEnergyBalancePoint).h1v = function () {
  return this.usable;
};
protoOf(JsEnergyBalancePoint).i1v = function () {
  return this.expenditureKcal;
};
protoOf(JsEnergyBalancePoint).j1v = function () {
  return this.targetKcal;
};
protoOf(JsEnergyBalancePoint).k1v = function () {
  return this.balanceKcal;
};
protoOf(JsEnergyBalancePoint).l1v = function () {
  return this.intakeAverageKcal;
};
protoOf(JsEnergyBalancePoint).m1v = function () {
  return this.expenditureAverageKcal;
};
protoOf(JsEnergyBalancePoint).n1v = function () {
  return this.balanceAverageKcal;
};
function JsEnergyBalance(points, usableDays, averageIntakeKcal, averageExpenditureKcal, averageBalanceKcal, averageTargetKcal, impliedChangeKg) {
  this.points = points;
  this.usableDays = usableDays;
  this.averageIntakeKcal = averageIntakeKcal;
  this.averageExpenditureKcal = averageExpenditureKcal;
  this.averageBalanceKcal = averageBalanceKcal;
  this.averageTargetKcal = averageTargetKcal;
  this.impliedChangeKg = impliedChangeKg;
}
protoOf(JsEnergyBalance).o1v = function () {
  return this.points;
};
protoOf(JsEnergyBalance).p1v = function () {
  return this.usableDays;
};
protoOf(JsEnergyBalance).q1v = function () {
  return this.averageIntakeKcal;
};
protoOf(JsEnergyBalance).r1v = function () {
  return this.averageExpenditureKcal;
};
protoOf(JsEnergyBalance).s1v = function () {
  return this.averageBalanceKcal;
};
protoOf(JsEnergyBalance).t1v = function () {
  return this.averageTargetKcal;
};
protoOf(JsEnergyBalance).u1v = function () {
  return this.impliedChangeKg;
};
function energyBalance(intakeDays, intakeKcal, intakeStatus, expenditure, fromDay, toDay, targetDays, targetKcal, kcalPerKg) {
  // Inline function 'kotlin.require' call
  if (!(targetDays.length === targetKcal.length)) {
    var message = 'target arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = EnergyBalance_instance;
  var tmp_0 = toIntake(intakeDays, intakeKcal, intakeStatus);
  var tmp_1 = toPoints(expenditure);
  // Inline function 'kotlin.collections.associate' call
  var this_0 = get_indices_0(targetDays);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var element = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = element;
      // Inline function 'kotlin.collections.plusAssign' call
      var pair = to(targetDays[it], targetKcal[it]);
      destination.k2(pair.hb_1, pair.ib_1);
    }
     while (!(element === last));
  var series = tmp.ny(tmp_0, tmp_1, fromDay, toDay, destination);
  var summary = EnergyBalance_instance.oy(series, kcalPerKg);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(series, 10));
  var _iterator__ex2g4s = series.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = item.wx_1;
    var tmp$ret$8 = new JsEnergyBalancePoint(item.ux_1, item.vx_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1_1, item.xx_1, item.yx_1, item.zx_1, item.ay_1, item.by_1, item.cy_1, item.dy_1);
    destination_0.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$9 = copyToArray(destination_0);
  return new JsEnergyBalance(tmp$ret$9, summary.fy_1, summary.gy_1, summary.hy_1, summary.iy_1, summary.jy_1, summary.ky_1);
}
function JsWeeklyCheckIn(day, targets, averageTargetKcal, rawTargetKcal, changeKcal, limitedByFloor, targetsUpdated, expenditureKcal, expenditureStatus, expenditureHolding, trendWeightKg, weeklyChangeKg, kcalPerKg, leanMassKg, effectiveRatePctPerWeek, needsWeighIn, hasWeighInThisWeek, weighInsThisWeek, loggingBreak, likelyPartialDays, possibleFastingDays, partialDays, fastedDays, unloggedDays, usableDays, persistenceDirection, persistenceWeeks, trainingShiftKcal, guardrailTriggered, guardrailChangePct, suggestedRatePctPerWeek, suggestDietBreak, flagModules, flagCodes, flagMessages, flagDays, checkInJson, lifts, fastLoss, sleepAverageMin, energyAvailability, onDietBreak) {
  this.day = day;
  this.targets = targets;
  this.averageTargetKcal = averageTargetKcal;
  this.rawTargetKcal = rawTargetKcal;
  this.changeKcal = changeKcal;
  this.limitedByFloor = limitedByFloor;
  this.targetsUpdated = targetsUpdated;
  this.expenditureKcal = expenditureKcal;
  this.expenditureStatus = expenditureStatus;
  this.expenditureHolding = expenditureHolding;
  this.trendWeightKg = trendWeightKg;
  this.weeklyChangeKg = weeklyChangeKg;
  this.kcalPerKg = kcalPerKg;
  this.leanMassKg = leanMassKg;
  this.effectiveRatePctPerWeek = effectiveRatePctPerWeek;
  this.needsWeighIn = needsWeighIn;
  this.hasWeighInThisWeek = hasWeighInThisWeek;
  this.weighInsThisWeek = weighInsThisWeek;
  this.loggingBreak = loggingBreak;
  this.likelyPartialDays = likelyPartialDays;
  this.possibleFastingDays = possibleFastingDays;
  this.partialDays = partialDays;
  this.fastedDays = fastedDays;
  this.unloggedDays = unloggedDays;
  this.usableDays = usableDays;
  this.persistenceDirection = persistenceDirection;
  this.persistenceWeeks = persistenceWeeks;
  this.trainingShiftKcal = trainingShiftKcal;
  this.guardrailTriggered = guardrailTriggered;
  this.guardrailChangePct = guardrailChangePct;
  this.suggestedRatePctPerWeek = suggestedRatePctPerWeek;
  this.suggestDietBreak = suggestDietBreak;
  this.flagModules = flagModules;
  this.flagCodes = flagCodes;
  this.flagMessages = flagMessages;
  this.flagDays = flagDays;
  this.checkInJson = checkInJson;
  this.lifts = lifts;
  this.fastLoss = fastLoss;
  this.sleepAverageMin = sleepAverageMin;
  this.energyAvailability = energyAvailability;
  this.onDietBreak = onDietBreak;
}
protoOf(JsWeeklyCheckIn).e1v = function () {
  return this.day;
};
protoOf(JsWeeklyCheckIn).v1v = function () {
  return this.targets;
};
protoOf(JsWeeklyCheckIn).t1v = function () {
  return this.averageTargetKcal;
};
protoOf(JsWeeklyCheckIn).w1v = function () {
  return this.rawTargetKcal;
};
protoOf(JsWeeklyCheckIn).b1v = function () {
  return this.changeKcal;
};
protoOf(JsWeeklyCheckIn).x1v = function () {
  return this.limitedByFloor;
};
protoOf(JsWeeklyCheckIn).y1v = function () {
  return this.targetsUpdated;
};
protoOf(JsWeeklyCheckIn).i1v = function () {
  return this.expenditureKcal;
};
protoOf(JsWeeklyCheckIn).z1v = function () {
  return this.expenditureStatus;
};
protoOf(JsWeeklyCheckIn).a1w = function () {
  return this.expenditureHolding;
};
protoOf(JsWeeklyCheckIn).b1w = function () {
  return this.trendWeightKg;
};
protoOf(JsWeeklyCheckIn).c1w = function () {
  return this.weeklyChangeKg;
};
protoOf(JsWeeklyCheckIn).p1u = function () {
  return this.kcalPerKg;
};
protoOf(JsWeeklyCheckIn).d1w = function () {
  return this.leanMassKg;
};
protoOf(JsWeeklyCheckIn).e1w = function () {
  return this.effectiveRatePctPerWeek;
};
protoOf(JsWeeklyCheckIn).f1w = function () {
  return this.needsWeighIn;
};
protoOf(JsWeeklyCheckIn).g1w = function () {
  return this.hasWeighInThisWeek;
};
protoOf(JsWeeklyCheckIn).h1w = function () {
  return this.weighInsThisWeek;
};
protoOf(JsWeeklyCheckIn).i1w = function () {
  return this.loggingBreak;
};
protoOf(JsWeeklyCheckIn).j1w = function () {
  return this.likelyPartialDays;
};
protoOf(JsWeeklyCheckIn).k1w = function () {
  return this.possibleFastingDays;
};
protoOf(JsWeeklyCheckIn).l1w = function () {
  return this.partialDays;
};
protoOf(JsWeeklyCheckIn).m1w = function () {
  return this.fastedDays;
};
protoOf(JsWeeklyCheckIn).n1w = function () {
  return this.unloggedDays;
};
protoOf(JsWeeklyCheckIn).p1v = function () {
  return this.usableDays;
};
protoOf(JsWeeklyCheckIn).o1w = function () {
  return this.persistenceDirection;
};
protoOf(JsWeeklyCheckIn).p1w = function () {
  return this.persistenceWeeks;
};
protoOf(JsWeeklyCheckIn).q1w = function () {
  return this.trainingShiftKcal;
};
protoOf(JsWeeklyCheckIn).r1w = function () {
  return this.guardrailTriggered;
};
protoOf(JsWeeklyCheckIn).s1w = function () {
  return this.guardrailChangePct;
};
protoOf(JsWeeklyCheckIn).t1w = function () {
  return this.suggestedRatePctPerWeek;
};
protoOf(JsWeeklyCheckIn).u1w = function () {
  return this.suggestDietBreak;
};
protoOf(JsWeeklyCheckIn).v1w = function () {
  return this.flagModules;
};
protoOf(JsWeeklyCheckIn).w1w = function () {
  return this.flagCodes;
};
protoOf(JsWeeklyCheckIn).x1w = function () {
  return this.flagMessages;
};
protoOf(JsWeeklyCheckIn).y1w = function () {
  return this.flagDays;
};
protoOf(JsWeeklyCheckIn).z1w = function () {
  return this.checkInJson;
};
protoOf(JsWeeklyCheckIn).a1x = function () {
  return this.lifts;
};
protoOf(JsWeeklyCheckIn).b1x = function () {
  return this.fastLoss;
};
protoOf(JsWeeklyCheckIn).c1x = function () {
  return this.sleepAverageMin;
};
protoOf(JsWeeklyCheckIn).d1x = function () {
  return this.energyAvailability;
};
protoOf(JsWeeklyCheckIn).e1x = function () {
  return this.onDietBreak;
};
function JsFastLoss(ratePctPerWeek, deficitKcal, suggestedRatePctPerWeek, title, message, actionLabel) {
  this.ratePctPerWeek = ratePctPerWeek;
  this.deficitKcal = deficitKcal;
  this.suggestedRatePctPerWeek = suggestedRatePctPerWeek;
  this.title = title;
  this.message = message;
  this.actionLabel = actionLabel;
}
protoOf(JsFastLoss).f1x = function () {
  return this.ratePctPerWeek;
};
protoOf(JsFastLoss).g1x = function () {
  return this.deficitKcal;
};
protoOf(JsFastLoss).t1w = function () {
  return this.suggestedRatePctPerWeek;
};
protoOf(JsFastLoss).h1x = function () {
  return this.title;
};
protoOf(JsFastLoss).x6 = function () {
  return this.message;
};
protoOf(JsFastLoss).jp = function () {
  return this.actionLabel;
};
function weeklyCheckIn(day, programJson, goalType, ratePctPerWeek, targetWeightKg, sex, ageYears, heightCm, bodyFatFraction, leanMassKg, waistCm, activityLevel, intakeDays, intakeKcal, intakeStatus, weighDays, weighKg, expenditure, previousCheckInJson, trendMethod, trainingWeekdays, strengthDays, strengthIndex, algorithmsJson, weeklyHardSets, recoveryDays, recoverySleepMin, recoveryHrvMs, recoveryRestingHr) {
  // Inline function 'kotlin.require' call
  if (!(strengthDays.length === strengthIndex.length)) {
    var message = 'strength arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!(recoveryDays.length === recoverySleepMin.length && recoveryDays.length === recoveryHrvMs.length && recoveryDays.length === recoveryRestingHr.length)) {
    var message_0 = 'recovery arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  var tmp = WeeklyCheckIn_instance;
  var tmp_0 = NutritionJson_instance.uq(programJson);
  var tmp_1 = new Goal(valueOf(goalType), ratePctPerWeek, targetWeightKg);
  var tmp_2 = new BodyProfile(valueOf_7(sex), ageYears, heightCm, bodyFatFraction, leanMassKg, valueOf_8(activityLevel), waistCm);
  var tmp_3 = toIntake(intakeDays, intakeKcal, intakeStatus);
  var tmp_4 = toWeighIns(weighDays, weighKg);
  var tmp_5 = toPoints(expenditure);
  var tmp_6;
  if (previousCheckInJson == null) {
    tmp_6 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_6 = NutritionJson_instance.cr(previousCheckInJson);
  }
  var tmp_7 = tmp_6;
  var tmp_8 = valueOf_16(trendMethod);
  var tmp_9 = toSet_1(trainingWeekdays);
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(strengthDays);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$8 = new StrengthIndexPoint(strengthDays[it], strengthIndex[it]);
      destination.f(tmp$ret$8);
    }
     while (!(item === last));
  var tmp_10 = destination;
  var tmp_11 = AlgorithmJson_getInstance().tf(algorithmsJson);
  // Inline function 'kotlin.collections.map' call
  var this_1 = get_indices_0(recoveryDays);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var inductionVariable_0 = this_1.oc_1;
  var last_0 = this_1.pc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = item_0;
      var tmp$ret$11 = new RecoveryDay(recoveryDays[it_0], recoverySleepMin[it_0], recoveryHrvMs[it_0], recoveryRestingHr[it_0]);
      destination_0.f(tmp$ret$11);
    }
     while (!(item_0 === last_0));
  var tmp1_elvis_lhs = tmp.rq(new WeeklyCheckInInput(day, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, tmp_7, tmp_8, tmp_9, tmp_10, tmp_11, weeklyHardSets, VOID, destination_0));
  var tmp_12;
  if (tmp1_elvis_lhs == null) {
    return null;
  } else {
    tmp_12 = tmp1_elvis_lhs;
  }
  var result = tmp_12;
  // Inline function 'kotlin.collections.map' call
  var this_2 = result.ur_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.j();
  while (_iterator__ex2g4s.k()) {
    var item_1 = _iterator__ex2g4s.l();
    var tmp$ret$14 = toJs_1(item_1);
    destination_1.f(tmp$ret$14);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_13 = copyToArray(destination_1);
  var tmp_14 = toIntArray(result.er_1.gs_1);
  var tmp_15 = toIntArray(result.er_1.hs_1);
  var tmp_16 = toIntArray(result.er_1.is_1);
  var tmp_17 = toIntArray(result.er_1.js_1);
  var tmp_18 = toIntArray(result.er_1.ks_1);
  var tmp2_safe_receiver = result.yr_1;
  var tmp3_elvis_lhs = tmp2_safe_receiver == null ? null : tmp2_safe_receiver.us_1;
  var tmp_19 = tmp3_elvis_lhs == null ? false : tmp3_elvis_lhs;
  var tmp4_safe_receiver = result.yr_1;
  var tmp_20 = tmp4_safe_receiver == null ? null : tmp4_safe_receiver.vs_1;
  var tmp5_safe_receiver = result.yr_1;
  var tmp_21 = tmp5_safe_receiver == null ? null : tmp5_safe_receiver.xs_1;
  var tmp6_safe_receiver = result.yr_1;
  var tmp7_elvis_lhs = tmp6_safe_receiver == null ? null : tmp6_safe_receiver.ys_1;
  var tmp_22 = tmp7_elvis_lhs == null ? false : tmp7_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  var this_3 = result.zr_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s_0 = this_3.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_2 = _iterator__ex2g4s_0.l();
    var tmp$ret$18 = item_2.tv_1.w1_1;
    destination_2.f(tmp$ret$18);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_23 = copyToArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  var this_4 = result.zr_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
  var _iterator__ex2g4s_1 = this_4.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_3 = _iterator__ex2g4s_1.l();
    var tmp$ret$22 = item_3.uv_1.w1_1;
    destination_3.f(tmp$ret$22);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_24 = copyToArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  var this_5 = result.zr_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
  var _iterator__ex2g4s_2 = this_5.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_4 = _iterator__ex2g4s_2.l();
    var tmp$ret$26 = item_4.vv_1;
    destination_4.f(tmp$ret$26);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_25 = copyToArray(destination_4);
  // Inline function 'kotlin.collections.map' call
  var this_6 = result.zr_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(this_6, 10));
  var _iterator__ex2g4s_3 = this_6.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_5 = _iterator__ex2g4s_3.l();
    var tmp$ret$30 = toIntArray(item_5.wv_1);
    destination_5.f(tmp$ret$30);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_26 = copyToArray(destination_5);
  var tmp_27 = NutritionJson_instance.ms(result);
  var tmp8_safe_receiver = result.bs_1;
  var tmp_28 = tmp8_safe_receiver == null ? null : toJs_2(tmp8_safe_receiver);
  var tmp9_safe_receiver = result.cs_1;
  var tmp_29 = tmp9_safe_receiver == null ? null : tmp9_safe_receiver.wi_1;
  var tmp10_safe_receiver = result.cs_1;
  return new JsWeeklyCheckIn(result.dr_1, tmp_13, result.rr_1, result.qr_1, result.sr_1, result.tr_1, result.vr_1, result.jr_1.qm_1, result.jr_1.sm_1.w1_1, result.kr_1, result.lr_1, result.mr_1, result.nr_1, result.or_1, result.pr_1, result.hr_1, result.gr_1, result.fr_1, result.ir_1, tmp_14, tmp_15, tmp_16, tmp_17, tmp_18, result.er_1.ls_1, result.wr_1.hi_1, result.wr_1.ii_1, result.xr_1, tmp_19, tmp_20, tmp_21, tmp_22, tmp_23, tmp_24, tmp_25, tmp_26, tmp_27, result.as_1, tmp_28, tmp_29, tmp10_safe_receiver == null ? null : tmp10_safe_receiver.yi_1, result.ds_1);
}
function fastLossWarning(ratePctPerWeek, weightKg, bodyFatFraction, algorithmsJson, weeklyHardSets) {
  var algorithms = AlgorithmJson_getInstance().tf(algorithmsJson);
  var lifts = LossPace_instance.qp(algorithms.ef_1, weeklyHardSets);
  var tmp0_safe_receiver = LossPace_instance.aq(ratePctPerWeek, weightKg, algorithms.eg(weightKg, bodyFatFraction), lifts);
  return tmp0_safe_receiver == null ? null : toJs_2(tmp0_safe_receiver);
}
function JsDietBreak(startDay, endDay, weeks) {
  this.startDay = startDay;
  this.endDay = endDay;
  this.weeks = weeks;
}
protoOf(JsDietBreak).i1x = function () {
  return this.startDay;
};
protoOf(JsDietBreak).ek = function () {
  return this.endDay;
};
protoOf(JsDietBreak).j1x = function () {
  return this.weeks;
};
function dietBreak_0(programJson) {
  var tmp0_safe_receiver = NutritionJson_instance.uq(programJson).wu_1;
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new JsDietBreak(tmp0_safe_receiver.ck_1, tmp0_safe_receiver.ek(), tmp0_safe_receiver.dk_1);
  }
  return tmp;
}
function dietBreakWeekChoices() {
  return toIntArray(Companion_getInstance_0().ak_1);
}
function dietBreakExplainer() {
  return "A diet break holds your calories at maintenance. Breaks can make dieting easier on appetite; they don't speed up fat loss, and each break week adds a week to your diet.";
}
function programWithDietBreak(programJson, startDay, weeks) {
  // Inline function 'kotlin.require' call
  if (!(startDay == null || Companion_getInstance_0().ak_1.r(weeks))) {
    var message = 'weeks must be one of ' + toString(Companion_getInstance_0().ak_1);
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = NutritionJson_instance;
  var tmp_0;
  if (startDay == null) {
    tmp_0 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_0 = new DietBreak(startDay, weeks);
  }
  return tmp.br(programJson, tmp_0);
}
function trainingShiftCarbsHelp() {
  return "The extra calories on training days are carbohydrate, to fuel harder sessions, and rest days have a little less. Protein and fat stay the same and so does the weekly total; it supports performance, it doesn't speed up fat loss.";
}
function collaborativeEdit(kcal, proteinG, fatG, carbsG, field, value, bodyWeightKg, diet, days, keepCalories, keepWeeklyTotal) {
  // Inline function 'kotlin.require' call
  if (!(kcal.length === proteinG.length && kcal.length === fatG.length && kcal.length === carbsG.length)) {
    var message = 'target arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(kcal);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new MacroTargets(kcal[it], proteinG[it], fatG[it], carbsG[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var targets = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = CollaborativeTargets_instance.wj(targets, valueOf_1(field), value, bodyWeightKg, valueOf_3(diet), toSet_1(days), keepCalories, keepWeeklyTotal);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$7 = toJs_1(item_0);
    destination_0.f(tmp$ret$7);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function dayOneTargets(goalJson, profileJson, algorithmsJson, programJson, today, weightKg) {
  return NewProgram_instance.wq(goalJson, profileJson, algorithmsJson, programJson, today, weightKg);
}
function dayOneTargetsWithTraining(goalJson, profileJson, algorithmsJson, programJson, today, weightKg, trainingWeekdays) {
  return NewProgram_instance.sq(goalJson, profileJson, algorithmsJson, programJson, today, weightKg, toSet_1(trainingWeekdays));
}
function defaultCheckInWeekday(setupDay) {
  return NewProgram_instance.lq(setupDay);
}
function firstCheckInDay(setupDay) {
  return NewProgram_instance.oq(setupDay);
}
function firstCheckInDayOn(setupDay, checkInWeekday) {
  return NewProgram_instance.nq(setupDay, checkInWeekday);
}
function ageYears(birthDay, today) {
  return NewProgram_instance.tq(birthDay, today);
}
function goalPacePresets(goalType) {
  var tmp = Json_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = GoalPace_getInstance().xn(valueOf(goalType));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = linkedMapOf([to('id', item.bn_1), to('label', item.cn_1), to('description', item.en_1), to('ratePctPerWeek', item.dn_1)]);
    destination.f(tmp$ret$2);
  }
  return tmp.zf(destination);
}
function goalProjection(currentKg, targetKg, ratePctPerWeek, today, kcalPerKg) {
  var tmp = GoalPace_getInstance();
  // Inline function 'kotlin.takeUnless' call
  var tmp_0;
  if (!isNaN_0(targetKg)) {
    tmp_0 = targetKg;
  } else {
    tmp_0 = null;
  }
  var tmp$ret$0 = tmp_0;
  var projection = tmp.yn(currentKg, tmp$ret$0, ratePctPerWeek, today);
  var tmp_1 = Json_instance;
  var tmp_2 = to('reachDay', projection.in_1);
  // Inline function 'kotlin.collections.map' call
  var this_0 = projection.hn_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$4 = linkedMapOf([to('day', item.fn_1), to('kg', item.gn_1)]);
    destination.f(tmp$ret$4);
  }
  return tmp_1.zf(linkedMapOf([tmp_2, to('points', destination), to('dailyDeltaKcal', CheckIn_instance.qi(ratePctPerWeek, currentKg, kcalPerKg))]));
}
function goalCurve(currentKg, targetKg, ratePctPerWeek, today, lastDay) {
  var tmp = GoalPace_getInstance();
  // Inline function 'kotlin.takeUnless' call
  var tmp_0;
  if (!isNaN_0(targetKg)) {
    tmp_0 = targetKg;
  } else {
    tmp_0 = null;
  }
  var tmp$ret$0 = tmp_0;
  var projection = tmp.yn(currentKg, tmp$ret$0, ratePctPerWeek, today);
  var tmp_1 = Json_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = GoalPace_getInstance().po(projection, lastDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$4 = linkedMapOf([to('day', item.jn_1), to('kg', item.kn_1)]);
    destination.f(tmp$ret$4);
  }
  return tmp_1.zf(destination);
}
function suggestedTargetKg(weightKg, heightCm, waistCm, bmiThreshold) {
  return GoalPace_getInstance().oo(weightKg, heightCm, waistCm, bmiThreshold);
}
function ethnicityBmiThreshold(ethnicity) {
  var tmp = GoalPace_getInstance();
  var tmp0 = get_entries_12();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.w1_1 === ethnicity) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  return tmp.no(tmp$ret$0);
}
function waistToHeightBand(waistCm, heightCm) {
  var tmp0_safe_receiver = WaistToHeight_instance.to(waistCm, heightCm);
  return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1_1;
}
function availableGoalTypes(ageYears) {
  var tmp = Json_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = GoalAvailability_instance.lh(ageYears);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.w1_1;
    destination.f(tmp$ret$2);
  }
  return tmp.zf(destination);
}
function dailyDeltaKcal(ratePctPerWeek, trendWeightKg, kcalPerKg) {
  return CheckIn_instance.qi(ratePctPerWeek, trendWeightKg, kcalPerKg);
}
function kgPerWeek(ratePctPerWeek, weightKg) {
  return Goals_instance.cp(ratePctPerWeek, weightKg);
}
function ratePctPerWeek(kgPerWeek, weightKg) {
  return Goals_instance.ep(kgPerWeek, weightKg);
}
function JsGoalProgress(startKg, currentKg, targetKg, changeKg, remainingKg, fractionDone, reached, projectedDay, projectedDayAtGoalRate) {
  this.startKg = startKg;
  this.currentKg = currentKg;
  this.targetKg = targetKg;
  this.changeKg = changeKg;
  this.remainingKg = remainingKg;
  this.fractionDone = fractionDone;
  this.reached = reached;
  this.projectedDay = projectedDay;
  this.projectedDayAtGoalRate = projectedDayAtGoalRate;
}
protoOf(JsGoalProgress).k1x = function () {
  return this.startKg;
};
protoOf(JsGoalProgress).l1x = function () {
  return this.currentKg;
};
protoOf(JsGoalProgress).m1x = function () {
  return this.targetKg;
};
protoOf(JsGoalProgress).n1x = function () {
  return this.changeKg;
};
protoOf(JsGoalProgress).o1x = function () {
  return this.remainingKg;
};
protoOf(JsGoalProgress).p1x = function () {
  return this.fractionDone;
};
protoOf(JsGoalProgress).q1x = function () {
  return this.reached;
};
protoOf(JsGoalProgress).r1x = function () {
  return this.projectedDay;
};
protoOf(JsGoalProgress).s1x = function () {
  return this.projectedDayAtGoalRate;
};
function goalProgress(startKg, targetKg, currentKg, today, currentRateKgPerWeek, goalRatePctPerWeek) {
  var p = Goals_instance.mo(startKg, targetKg, currentKg, today, currentRateKgPerWeek, goalRatePctPerWeek);
  return new JsGoalProgress(p.zn_1, p.ao_1, p.bo_1, p.co_1, p.do_1, p.eo_1, p.fo_1, p.go_1, p.ho_1);
}
function JsWeightMilestone(index, thresholdKg, changeKg, fractionOfGoal, reachedDay, isTarget) {
  this.index = index;
  this.thresholdKg = thresholdKg;
  this.changeKg = changeKg;
  this.fractionOfGoal = fractionOfGoal;
  this.reachedDay = reachedDay;
  this.isTarget = isTarget;
}
protoOf(JsWeightMilestone).t1x = function () {
  return this.index;
};
protoOf(JsWeightMilestone).u1x = function () {
  return this.thresholdKg;
};
protoOf(JsWeightMilestone).n1x = function () {
  return this.changeKg;
};
protoOf(JsWeightMilestone).v1x = function () {
  return this.fractionOfGoal;
};
protoOf(JsWeightMilestone).w1x = function () {
  return this.reachedDay;
};
protoOf(JsWeightMilestone).x1x = function () {
  return this.isTarget;
};
function weightMilestones(startKg, targetKg, trendDays, trendKg, kind, step, losing) {
  // Inline function 'kotlin.require' call
  if (!(trendDays.length === trendKg.length)) {
    var message = 'trend arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(trendDays);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new TrendPoint(trendDays[it], null, trendKg[it], trendKg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var trend = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = Goals_instance.fp(startKg, targetKg, trend, valueOf_2(kind), step, losing);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$7 = new JsWeightMilestone(item_0.uo_1, item_0.vo_1, item_0.wo_1, item_0.xo_1, item_0.yo_1, item_0.zo_1);
    destination_0.f(tmp$ret$7);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function JsNutrientGoal(key, name, unit, floor, target, ceiling) {
  this.key = key;
  this.name = name;
  this.unit = unit;
  this.floor = floor;
  this.target = target;
  this.ceiling = ceiling;
}
protoOf(JsNutrientGoal).o1 = function () {
  return this.key;
};
protoOf(JsNutrientGoal).y1x = function () {
  return this.name;
};
protoOf(JsNutrientGoal).z1x = function () {
  return this.unit;
};
protoOf(JsNutrientGoal).a1y = function () {
  return this.floor;
};
protoOf(JsNutrientGoal).b1y = function () {
  return this.target;
};
protoOf(JsNutrientGoal).c1y = function () {
  return this.ceiling;
};
function nutrientGoals(sex, ageYears, energyKcal) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientGoals_instance.a18(valueOf_7(sex), ageYears, energyKcal);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(this_0.o());
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = this_0.v1().j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    // Inline function 'kotlin.collections.component1' call
    var key = item.o1();
    // Inline function 'kotlin.collections.component2' call
    var goal = item.p1();
    var info = Nutrients_getInstance().e16(key);
    var tmp1_elvis_lhs = info == null ? null : info.r17_1;
    var tmp = tmp1_elvis_lhs == null ? key : tmp1_elvis_lhs;
    var tmp3_elvis_lhs = info == null ? null : info.s17_1;
    var tmp$ret$3 = new JsNutrientGoal(key, tmp, tmp3_elvis_lhs == null ? '' : tmp3_elvis_lhs, goal.b17_1, goal.c17_1, goal.d17_1);
    destination.f(tmp$ret$3);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsCompleteness(key, byKcal, byEntries, entries, entriesWithValue) {
  this.key = key;
  this.byKcal = byKcal;
  this.byEntries = byEntries;
  this.entries = entries;
  this.entriesWithValue = entriesWithValue;
}
protoOf(JsCompleteness).o1 = function () {
  return this.key;
};
protoOf(JsCompleteness).d1y = function () {
  return this.byKcal;
};
protoOf(JsCompleteness).e1y = function () {
  return this.byEntries;
};
protoOf(JsCompleteness).v1 = function () {
  return this.entries;
};
protoOf(JsCompleteness).f1y = function () {
  return this.entriesWithValue;
};
function nutrientCompleteness(entriesJson, fromDay, toDay) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientAnalysis_instance.f15(NutrientJson_instance.v17(entriesJson), fromDay, toDay);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsCompleteness(item.b14_1, item.c14_1, item.d14_1, item.e14_1, item.f14_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsContributor(foodKey, name, amount, share, entries) {
  this.foodKey = foodKey;
  this.name = name;
  this.amount = amount;
  this.share = share;
  this.entries = entries;
}
protoOf(JsContributor).g1y = function () {
  return this.foodKey;
};
protoOf(JsContributor).y1x = function () {
  return this.name;
};
protoOf(JsContributor).h1y = function () {
  return this.amount;
};
protoOf(JsContributor).i1y = function () {
  return this.share;
};
protoOf(JsContributor).v1 = function () {
  return this.entries;
};
function nutrientTopContributors(entriesJson, key, fromDay, toDay, limit) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientAnalysis_instance.r15(NutrientJson_instance.v17(entriesJson), key, fromDay, toDay, limit);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsContributor(item.g14_1, item.h14_1, item.i14_1, item.j14_1, item.k14_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsNutrientAverages(key, dailyAverage, days, weekStarts, weeklyAverages, weeklyDays) {
  this.key = key;
  this.dailyAverage = dailyAverage;
  this.days = days;
  this.weekStarts = weekStarts;
  this.weeklyAverages = weeklyAverages;
  this.weeklyDays = weeklyDays;
}
protoOf(JsNutrientAverages).o1 = function () {
  return this.key;
};
protoOf(JsNutrientAverages).j1y = function () {
  return this.dailyAverage;
};
protoOf(JsNutrientAverages).k1y = function () {
  return this.days;
};
protoOf(JsNutrientAverages).l1y = function () {
  return this.weekStarts;
};
protoOf(JsNutrientAverages).m1y = function () {
  return this.weeklyAverages;
};
protoOf(JsNutrientAverages).n1y = function () {
  return this.weeklyDays;
};
function nutrientAverages(entriesJson, key, fromDay, toDay) {
  var averages = NutrientAnalysis_instance.u15(NutrientJson_instance.v17(entriesJson), key, fromDay, toDay);
  // Inline function 'kotlin.collections.map' call
  var this_0 = averages.y14_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.s14_1;
    destination.f(tmp$ret$2);
  }
  var tmp = toIntArray(destination);
  // Inline function 'kotlin.collections.map' call
  var this_1 = averages.y14_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.t14_1;
    destination_0.f(tmp$ret$5);
  }
  var tmp_0 = toDoubleArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_2 = averages.y14_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_1 = this_2.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$8 = item_1.u14_1;
    destination_1.f(tmp$ret$8);
  }
  return new JsNutrientAverages(averages.v14_1, averages.w14_1, averages.x14_1, tmp, tmp_0, toIntArray(destination_1));
}
function JsAlcohol(volumeMl, abvPct, alcoholG, alcoholKcal, carbsG, kcal, ukUnits, grams, per100gKcal, per100gCarbs, per100gAlcohol) {
  this.volumeMl = volumeMl;
  this.abvPct = abvPct;
  this.alcoholG = alcoholG;
  this.alcoholKcal = alcoholKcal;
  this.carbsG = carbsG;
  this.kcal = kcal;
  this.ukUnits = ukUnits;
  this.grams = grams;
  this.per100gKcal = per100gKcal;
  this.per100gCarbs = per100gCarbs;
  this.per100gAlcohol = per100gAlcohol;
}
protoOf(JsAlcohol).o1y = function () {
  return this.volumeMl;
};
protoOf(JsAlcohol).p1y = function () {
  return this.abvPct;
};
protoOf(JsAlcohol).q1y = function () {
  return this.alcoholG;
};
protoOf(JsAlcohol).r1y = function () {
  return this.alcoholKcal;
};
protoOf(JsAlcohol).s1y = function () {
  return this.carbsG;
};
protoOf(JsAlcohol).og = function () {
  return this.kcal;
};
protoOf(JsAlcohol).t1y = function () {
  return this.ukUnits;
};
protoOf(JsAlcohol).u1y = function () {
  return this.grams;
};
protoOf(JsAlcohol).v1y = function () {
  return this.per100gKcal;
};
protoOf(JsAlcohol).w1y = function () {
  return this.per100gCarbs;
};
protoOf(JsAlcohol).x1y = function () {
  return this.per100gAlcohol;
};
function alcohol(volumeMl, abvPct, carbsPer100Ml, densityGPerMl) {
  return toJs_3(Alcohol_instance.i13(volumeMl, abvPct, carbsPer100Ml, densityGPerMl));
}
function alcoholDrink(drinkType, volumeMl, abvPct) {
  var drink = valueOf_9(drinkType);
  var tmp = Alcohol_instance;
  var tmp_0 = volumeMl == null ? drink.u12_1 : volumeMl;
  return toJs_3(tmp.j13(drink, tmp_0, abvPct == null ? drink.r12_1 : abvPct));
}
function JsDrinkType(name, label, abvPct, carbsPer100Ml, densityGPerMl, servingMl) {
  this.name = name;
  this.label = label;
  this.abvPct = abvPct;
  this.carbsPer100Ml = carbsPer100Ml;
  this.densityGPerMl = densityGPerMl;
  this.servingMl = servingMl;
}
protoOf(JsDrinkType).y1x = function () {
  return this.name;
};
protoOf(JsDrinkType).u1u = function () {
  return this.label;
};
protoOf(JsDrinkType).p1y = function () {
  return this.abvPct;
};
protoOf(JsDrinkType).y1y = function () {
  return this.carbsPer100Ml;
};
protoOf(JsDrinkType).z1y = function () {
  return this.densityGPerMl;
};
protoOf(JsDrinkType).a1z = function () {
  return this.servingMl;
};
function drinkTypes() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_entries_18();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsDrinkType(item.w1_1, item.q12_1, item.r12_1, item.s12_1, item.t12_1, item.u12_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function toWeighIns(days, kg) {
  // Inline function 'kotlin.require' call
  if (!(days.length === kg.length)) {
    var message = 'weigh-in arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new WeighIn(days[it], kg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  return destination;
}
function toIntake(days, kcal, status) {
  // Inline function 'kotlin.require' call
  if (!(days.length === kcal.length && days.length === status.length)) {
    var message = 'intake arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new IntakeDay(days[it], kcal[it], valueOf_5(status[it]));
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  return destination;
}
function toPoints(series) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(series.length);
  var inductionVariable = 0;
  var last = series.length;
  while (inductionVariable < last) {
    var item = series[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp$ret$2 = new ExpenditurePoint(item.day, item.kcal, item.sdKcal, valueOf_6(item.status), item.floored, item.goalAdjustmentKcal);
    destination.f(tmp$ret$2);
  }
  return destination;
}
function toJs(_this__u8e3s4) {
  return new JsExpenditurePoint(_this__u8e3s4.pm_1, _this__u8e3s4.qm_1, _this__u8e3s4.rm_1, _this__u8e3s4.sm_1.w1_1, _this__u8e3s4.tm_1, _this__u8e3s4.um_1);
}
function toJs_0(_this__u8e3s4) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = toJs(item);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function toJs_1(_this__u8e3s4) {
  return new JsMacros(_this__u8e3s4.qj_1, _this__u8e3s4.rj_1, _this__u8e3s4.sj_1, _this__u8e3s4.tj_1);
}
function toJs_2(_this__u8e3s4) {
  return new JsFastLoss(_this__u8e3s4.gp_1, _this__u8e3s4.hp_1, _this__u8e3s4.ip_1, 'A gentler pace may keep more muscle', _this__u8e3s4.x6(), _this__u8e3s4.jp());
}
function toJs_3(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.d13_1.t13_1;
  return new JsAlcohol(_this__u8e3s4.v12_1, _this__u8e3s4.w12_1, _this__u8e3s4.x12_1, _this__u8e3s4.y12_1, _this__u8e3s4.z12_1, _this__u8e3s4.a13_1, _this__u8e3s4.b13_1, _this__u8e3s4.c13_1, _this__u8e3s4.d13_1.l13_1, _this__u8e3s4.d13_1.o13_1, tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
function JsTrendPoint(day, scaleKg, filledKg, trendKg) {
  this.day = day;
  this.scaleKg = scaleKg;
  this.filledKg = filledKg;
  this.trendKg = trendKg;
}
protoOf(JsTrendPoint).e1v = function () {
  return this.day;
};
protoOf(JsTrendPoint).b1z = function () {
  return this.scaleKg;
};
protoOf(JsTrendPoint).c1z = function () {
  return this.filledKg;
};
protoOf(JsTrendPoint).d1z = function () {
  return this.trendKg;
};
function JsExpenditurePoint(day, kcal, sdKcal, status, floored, goalAdjustmentKcal) {
  this.day = day;
  this.kcal = kcal;
  this.sdKcal = sdKcal;
  this.status = status;
  this.floored = floored;
  this.goalAdjustmentKcal = goalAdjustmentKcal;
}
protoOf(JsExpenditurePoint).e1v = function () {
  return this.day;
};
protoOf(JsExpenditurePoint).og = function () {
  return this.kcal;
};
protoOf(JsExpenditurePoint).e1z = function () {
  return this.sdKcal;
};
protoOf(JsExpenditurePoint).g1v = function () {
  return this.status;
};
protoOf(JsExpenditurePoint).f1z = function () {
  return this.floored;
};
protoOf(JsExpenditurePoint).g1z = function () {
  return this.goalAdjustmentKcal;
};
function JsCheckInResult(targetKcal, rawTargetKcal, effectiveRatePctPerWeek, limitedByFloor, changeKcal) {
  this.targetKcal = targetKcal;
  this.rawTargetKcal = rawTargetKcal;
  this.effectiveRatePctPerWeek = effectiveRatePctPerWeek;
  this.limitedByFloor = limitedByFloor;
  this.changeKcal = changeKcal;
}
protoOf(JsCheckInResult).j1v = function () {
  return this.targetKcal;
};
protoOf(JsCheckInResult).w1v = function () {
  return this.rawTargetKcal;
};
protoOf(JsCheckInResult).e1w = function () {
  return this.effectiveRatePctPerWeek;
};
protoOf(JsCheckInResult).x1v = function () {
  return this.limitedByFloor;
};
protoOf(JsCheckInResult).b1v = function () {
  return this.changeKcal;
};
function JsMacros(kcal, proteinG, fatG, carbsG) {
  this.kcal = kcal;
  this.proteinG = proteinG;
  this.fatG = fatG;
  this.carbsG = carbsG;
}
protoOf(JsMacros).og = function () {
  return this.kcal;
};
protoOf(JsMacros).h1z = function () {
  return this.proteinG;
};
protoOf(JsMacros).i1z = function () {
  return this.fatG;
};
protoOf(JsMacros).s1y = function () {
  return this.carbsG;
};
function weightTrend(days, kg, endDay, method) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = trendPoints(days, kg, endDay, method);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsTrendPoint(item.wm_1, item.xm_1, item.ym_1, item.zm_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function changeRateKgPerWeek(days, kg, endDay, method) {
  return WeightTrend_instance.iu(trendPoints(days, kg, endDay, method));
}
function JsWeightInsights(currentKg, changeDays, changeKg, changeDirection, weeklyChangeKg, energyBalanceKcalPerDay, projectionKg, projectionDays) {
  this.currentKg = currentKg;
  this.changeDays = changeDays;
  this.changeKg = changeKg;
  this.changeDirection = changeDirection;
  this.weeklyChangeKg = weeklyChangeKg;
  this.energyBalanceKcalPerDay = energyBalanceKcalPerDay;
  this.projectionKg = projectionKg;
  this.projectionDays = projectionDays;
}
protoOf(JsWeightInsights).l1x = function () {
  return this.currentKg;
};
protoOf(JsWeightInsights).a1v = function () {
  return this.changeDays;
};
protoOf(JsWeightInsights).n1x = function () {
  return this.changeKg;
};
protoOf(JsWeightInsights).c1v = function () {
  return this.changeDirection;
};
protoOf(JsWeightInsights).c1w = function () {
  return this.weeklyChangeKg;
};
protoOf(JsWeightInsights).j1z = function () {
  return this.energyBalanceKcalPerDay;
};
protoOf(JsWeightInsights).k1z = function () {
  return this.projectionKg;
};
protoOf(JsWeightInsights).l1z = function () {
  return this.projectionDays;
};
function weightInsights(days, kg, endDay, method, kcalPerKg) {
  var tmp0_elvis_lhs = Companion_getInstance_26().c1u(trendPoints(days, kg, endDay, method), kcalPerKg);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return null;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var insights = tmp;
  // Inline function 'kotlin.collections.map' call
  var this_0 = insights.e1u_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.z1t_1;
    destination.f(tmp$ret$2);
  }
  var tmp_0 = toIntArray(destination);
  // Inline function 'kotlin.collections.map' call
  var this_1 = insights.e1u_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item_0.a1u_1;
    destination_0.f(tmp$ret$5);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_1 = copyToArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_2 = insights.e1u_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_1 = this_2.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp0_safe_receiver = item_1.vy();
    var tmp$ret$9 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.w1_1;
    destination_1.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$10 = copyToArray(destination_1);
  return new JsWeightInsights(insights.d1u_1, tmp_0, tmp_1, tmp$ret$10, insights.f1u_1, insights.g1u_1, insights.h1u_1, insights.i1u_1);
}
function weighInStreak(days, today) {
  return WeighInHabit_instance.j1u(toList_1(days), today);
}
function energyDensityKcalPerKg(bodyWeightKg, bodyFatFraction) {
  return EnergyDensity_instance.eg(bodyWeightKg, bodyFatFraction);
}
function checkIn(expenditureKcal, trendWeightKg, goalType, ratePctPerWeek, targetWeightKg, kcalPerKg, previousTargetKcal, sameDirectionWeeks, expenditureHolding, calorieFloor) {
  var result = CheckIn_instance.si(new CheckInInput(expenditureKcal, trendWeightKg, new Goal(valueOf(goalType), ratePctPerWeek, targetWeightKg), kcalPerKg, previousTargetKcal, sameDirectionWeeks, expenditureHolding, valueOf_0(calorieFloor)));
  return new JsCheckInResult(result.ci_1, result.di_1, result.ei_1, result.fi_1, result.gi_1);
}
function macroTargets(kcal, bodyWeightKg, leanMassKg, diet, protein) {
  var macros = Macros_instance.gq(kcal, bodyWeightKg, leanMassKg, valueOf_3(diet), valueOf_4(protein));
  return new JsMacros(macros.qj_1, macros.rj_1, macros.sj_1, macros.tj_1);
}
function estimatedOneRepMax(loadKg, reps, rir) {
  return Strength_instance.b1o(new LoggedSet(loadKg, reps, rir));
}
function localizeUnits(message, pounds, kilojoules) {
  return UnitText_getInstance().fe(message, pounds, kilojoules);
}
function trendPoints(days, kg, endDay, method) {
  // Inline function 'kotlin.require' call
  if (!(days.length === kg.length)) {
    var message = 'days and kg must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = Trend_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new WeighIn(days[it], kg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  return tmp.xv(destination, endDay, valueOf_16(method));
}
function offProductUrl(code) {
  return OffProduct_getInstance().e12(code);
}
function offFoodJson(code, responseJson) {
  return OffProduct_getInstance().f12(code, responseJson);
}
function JsNutrientInfo(key, name, unit) {
  this.key = key;
  this.name = name;
  this.unit = unit;
}
protoOf(JsNutrientInfo).o1 = function () {
  return this.key;
};
protoOf(JsNutrientInfo).y1x = function () {
  return this.name;
};
protoOf(JsNutrientInfo).z1x = function () {
  return this.unit;
};
function nutrientInfos() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = Nutrients_getInstance().p15_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsNutrientInfo(item.q17_1, item.r17_1, item.s17_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsNutrientGoalSetting(key, name, unit, floor, target, ceiling, method, since) {
  this.key = key;
  this.name = name;
  this.unit = unit;
  this.floor = floor;
  this.target = target;
  this.ceiling = ceiling;
  this.method = method;
  this.since = since;
}
protoOf(JsNutrientGoalSetting).o1 = function () {
  return this.key;
};
protoOf(JsNutrientGoalSetting).y1x = function () {
  return this.name;
};
protoOf(JsNutrientGoalSetting).z1x = function () {
  return this.unit;
};
protoOf(JsNutrientGoalSetting).a1y = function () {
  return this.floor;
};
protoOf(JsNutrientGoalSetting).b1y = function () {
  return this.target;
};
protoOf(JsNutrientGoalSetting).c1y = function () {
  return this.ceiling;
};
protoOf(JsNutrientGoalSetting).m1z = function () {
  return this.method;
};
protoOf(JsNutrientGoalSetting).n1z = function () {
  return this.since;
};
function nutrientGoalHistory(nutrientsJson) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientGoalHistory_instance.p17(NutrientGoalJson_instance.t17(nutrientsJson));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsNutrientGoalSetting(item.k17_1, item.l17_1, item.m17_1, item.n17_1.s16_1, item.n17_1.t16_1, item.n17_1.u16_1, item.n17_1.v16_1.q16_1, item.n17_1.w16_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsGoalMethod(value, label) {
  this.value = value;
  this.label = label;
}
protoOf(JsGoalMethod).p1 = function () {
  return this.value;
};
protoOf(JsGoalMethod).u1u = function () {
  return this.label;
};
function nutrientGoalMethods(key) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = NutrientGoalMethods_getInstance().a17(key);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsGoalMethod(item.q16_1, item.r16_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function nutrientGoalsWith(nutrientsJson, key, floor, target, ceiling, method, since) {
  var tmp0 = Companion_instance_9.n16(method);
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.requireNotNull' call
    if (tmp0 == null) {
      var message = "unknown goal method '" + method + "'";
      throw IllegalArgumentException_init_$Create$(toString(message));
    } else {
      tmp$ret$0 = tmp0;
      break $l$block;
    }
  }
  var goalMethod = tmp$ret$0;
  return NutrientGoalJson_instance.u17(nutrientsJson, key, new NutrientGoalSetting(floor, target, ceiling, goalMethod, since));
}
function nutrientGoalsWithout(nutrientsJson, key) {
  return NutrientGoalJson_instance.u17(nutrientsJson, key, null);
}
function JsNutrientDay(day, amount, average7, floor, target, ceiling, status) {
  this.day = day;
  this.amount = amount;
  this.average7 = average7;
  this.floor = floor;
  this.target = target;
  this.ceiling = ceiling;
  this.status = status;
}
protoOf(JsNutrientDay).e1v = function () {
  return this.day;
};
protoOf(JsNutrientDay).h1y = function () {
  return this.amount;
};
protoOf(JsNutrientDay).o1z = function () {
  return this.average7;
};
protoOf(JsNutrientDay).a1y = function () {
  return this.floor;
};
protoOf(JsNutrientDay).b1y = function () {
  return this.target;
};
protoOf(JsNutrientDay).c1y = function () {
  return this.ceiling;
};
protoOf(JsNutrientDay).g1v = function () {
  return this.status;
};
function JsNutrientFocus(key, name, unit, days, average, loggedDays, goalDays, goalCustom, goalMethod, goalSince) {
  this.key = key;
  this.name = name;
  this.unit = unit;
  this.days = days;
  this.average = average;
  this.loggedDays = loggedDays;
  this.goalDays = goalDays;
  this.goalCustom = goalCustom;
  this.goalMethod = goalMethod;
  this.goalSince = goalSince;
}
protoOf(JsNutrientFocus).o1 = function () {
  return this.key;
};
protoOf(JsNutrientFocus).y1x = function () {
  return this.name;
};
protoOf(JsNutrientFocus).z1x = function () {
  return this.unit;
};
protoOf(JsNutrientFocus).k1y = function () {
  return this.days;
};
protoOf(JsNutrientFocus).p1z = function () {
  return this.average;
};
protoOf(JsNutrientFocus).q1z = function () {
  return this.loggedDays;
};
protoOf(JsNutrientFocus).r1z = function () {
  return this.goalDays;
};
protoOf(JsNutrientFocus).s1z = function () {
  return this.goalCustom;
};
protoOf(JsNutrientFocus).t1z = function () {
  return this.goalMethod;
};
protoOf(JsNutrientFocus).u1z = function () {
  return this.goalSince;
};
function nutrientFocus(entriesJson, key, fromDay, toDay, nutrientsJson, sex, ageYears, bodyWeightKg, energyKcal) {
  var setting = NutrientGoalJson_instance.t17(nutrientsJson).s1(key);
  var tmp;
  if (!(sex == null) && !(ageYears == null)) {
    var tmp_0 = NutrientGoals_instance;
    var tmp_1 = valueOf_7(sex);
    var tmp_2;
    if (energyKcal == null) {
      tmp_2 = null;
    } else {
      // Inline function 'kotlin.takeIf' call
      var tmp_3;
      if (energyKcal > 0.0) {
        tmp_3 = energyKcal;
      } else {
        tmp_3 = null;
      }
      tmp_2 = tmp_3;
    }
    tmp = tmp_0.a18(tmp_1, ageYears, tmp_2).s1(key);
  } else {
    tmp = null;
  }
  var default_0 = tmp;
  var focus = Companion_instance_8.a16(NutrientJson_instance.v17(entriesJson), key, fromDay, toDay, setting, default_0, bodyWeightKg, energyKcal);
  // Inline function 'kotlin.collections.map' call
  var this_0 = focus.h16_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp0_safe_receiver = item.y15_1;
    var tmp_4 = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.b17_1;
    var tmp1_safe_receiver = item.y15_1;
    var tmp_5 = tmp1_safe_receiver == null ? null : tmp1_safe_receiver.c17_1;
    var tmp2_safe_receiver = item.y15_1;
    var tmp$ret$4 = new JsNutrientDay(item.v15_1, item.w15_1, item.x15_1, tmp_4, tmp_5, tmp2_safe_receiver == null ? null : tmp2_safe_receiver.d17_1, item.z15_1.w1_1);
    destination.f(tmp$ret$4);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_6 = copyToArray(destination);
  var tmp_7 = !(setting == null);
  var tmp2_elvis_lhs = setting == null ? null : setting.v16_1;
  var tmp_8 = (tmp2_elvis_lhs == null ? GoalMethod_FIXED_getInstance() : tmp2_elvis_lhs).q16_1;
  return new JsNutrientFocus(key, focus.g16_1.r17_1, focus.g16_1.s17_1, tmp_6, focus.i16_1, focus.j16_1, focus.k16_1, tmp_7, tmp_8, setting == null ? null : setting.w16_1);
}
var catalogueCache;
function JsPlateLoadout(targetKg, barKg, platesPerSide, achievedKg, remainderKg, exact) {
  this.targetKg = targetKg;
  this.barKg = barKg;
  this.platesPerSide = platesPerSide;
  this.achievedKg = achievedKg;
  this.remainderKg = remainderKg;
  this.exact = exact;
}
protoOf(JsPlateLoadout).m1x = function () {
  return this.targetKg;
};
protoOf(JsPlateLoadout).v1z = function () {
  return this.barKg;
};
protoOf(JsPlateLoadout).w1z = function () {
  return this.platesPerSide;
};
protoOf(JsPlateLoadout).x1z = function () {
  return this.achievedKg;
};
protoOf(JsPlateLoadout).y1z = function () {
  return this.remainderKg;
};
protoOf(JsPlateLoadout).z1z = function () {
  return this.exact;
};
function plateLoadout(targetKg, barKg, plateKg, platePairs) {
  // Inline function 'kotlin.require' call
  if (!(plateKg.length === platePairs.length)) {
    var message = 'plate arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = PlateCalculator_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_1(plateKg);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new PlatePair(plateKg[it], platePairs[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var loadout = tmp.b1d(targetKg, barKg, destination);
  return new JsPlateLoadout(loadout.w1b_1, loadout.x1b_1, toDoubleArray(loadout.y1b_1), loadout.z1b_1, loadout.a1c_1, loadout.b1c_1);
}
function gymLoads(gymJson, equipment, stackName) {
  return toDoubleArray(Loads_instance.o1c(Companion_getInstance_9().x1a(gymJson), Companion_instance_16.p19(equipment), stackName));
}
function nearestLoad(loads, targetKg, rounding) {
  return Loads_instance.p1c(toList_2(loads), targetKg, valueOf_11(rounding));
}
function JsWarmupSet(loadKg, reps, pct) {
  this.loadKg = loadKg;
  this.reps = reps;
  this.pct = pct;
}
protoOf(JsWarmupSet).a20 = function () {
  return this.loadKg;
};
protoOf(JsWarmupSet).b20 = function () {
  return this.reps;
};
protoOf(JsWarmupSet).c20 = function () {
  return this.pct;
};
function warmupSets(workingLoadKg, loads, pcts, reps, minLoadKg) {
  // Inline function 'kotlin.require' call
  if (!(pcts.length === reps.length)) {
    var message = 'warm-up arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp;
  // Inline function 'kotlin.collections.isEmpty' call
  if (pcts.length === 0) {
    tmp = Warmups_getInstance().s1h_1;
  } else {
    // Inline function 'kotlin.collections.map' call
    var this_0 = get_indices_1(pcts);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
    var inductionVariable = this_0.oc_1;
    var last = this_0.pc_1;
    if (inductionVariable <= last)
      do {
        var item = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var it = item;
        var tmp$ret$5 = new WarmupStep(pcts[it], reps[it]);
        destination.f(tmp$ret$5);
      }
       while (!(item === last));
    tmp = destination;
  }
  var scheme = tmp;
  var list = toList_2(loads);
  var tmp_0 = Warmups_getInstance();
  var tmp_1;
  if (minLoadKg == null) {
    var tmp1_elvis_lhs = minOrNull(list);
    tmp_1 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  } else {
    tmp_1 = minLoadKg;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp_0.s1s(workingLoadKg, list, scheme, tmp_1);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$8 = new JsWarmupSet(item_0.o1s_1, item_0.p1s_1, item_0.q1s_1);
    destination_0.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_0);
}
function JsExerciseTargets(loadKg, reps, rir, setType, done, outsideRepRange, oneRepMaxKg, issue, warning, alternativeKinds, alternativeLoadKg, alternativeReps, progressed) {
  this.loadKg = loadKg;
  this.reps = reps;
  this.rir = rir;
  this.setType = setType;
  this.done = done;
  this.outsideRepRange = outsideRepRange;
  this.oneRepMaxKg = oneRepMaxKg;
  this.issue = issue;
  this.warning = warning;
  this.alternativeKinds = alternativeKinds;
  this.alternativeLoadKg = alternativeLoadKg;
  this.alternativeReps = alternativeReps;
  this.progressed = progressed;
}
protoOf(JsExerciseTargets).a20 = function () {
  return this.loadKg;
};
protoOf(JsExerciseTargets).b20 = function () {
  return this.reps;
};
protoOf(JsExerciseTargets).d20 = function () {
  return this.rir;
};
protoOf(JsExerciseTargets).e20 = function () {
  return this.setType;
};
protoOf(JsExerciseTargets).f20 = function () {
  return this.done;
};
protoOf(JsExerciseTargets).g20 = function () {
  return this.outsideRepRange;
};
protoOf(JsExerciseTargets).h20 = function () {
  return this.oneRepMaxKg;
};
protoOf(JsExerciseTargets).i20 = function () {
  return this.issue;
};
protoOf(JsExerciseTargets).j20 = function () {
  return this.warning;
};
protoOf(JsExerciseTargets).k20 = function () {
  return this.alternativeKinds;
};
protoOf(JsExerciseTargets).l20 = function () {
  return this.alternativeLoadKg;
};
protoOf(JsExerciseTargets).m20 = function () {
  return this.alternativeReps;
};
protoOf(JsExerciseTargets).n20 = function () {
  return this.progressed;
};
function nextSetTargets(sets, repMin, repMax, rir, setType, progression, loads, historyDays, historySessions, historyLoadKg, historyReps, historyRir, historyTypes, todayLoadKg, todayReps, todayRir, todayTypes, priority, expandRepRange, weightMatch, bodyweightKg, bodyweightFactor, startingOneRepMaxKg, rirAdjustment, trainingSettingsJson, region) {
  var n = historyDays.length;
  // Inline function 'kotlin.require' call
  if (!(historySessions.length === n && historyLoadKg.length === n && historyReps.length === n && historyRir.length === n && historyTypes.length === n)) {
    var message = 'history arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var m = todayLoadKg.length;
  // Inline function 'kotlin.require' call
  if (!(todayReps.length === m && todayRir.length === m && todayTypes.length === m)) {
    var message_0 = "today's arrays must have the same length";
    throw IllegalArgumentException_init_$Create$(toString(message_0));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, n);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$6 = new SetRecord(historyDays[it], historyLoadKg[it], historyReps[it], historyRir[it], Companion_instance_17.p19(historyTypes[it]), historySessions[it]);
      destination.f(tmp$ret$6);
    }
     while (!(item === last));
  var history = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = until(0, m);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var inductionVariable_0 = this_1.oc_1;
  var last_0 = this_1.pc_1;
  if (inductionVariable_0 <= last_0)
    do {
      var item_0 = inductionVariable_0;
      inductionVariable_0 = inductionVariable_0 + 1 | 0;
      var it_0 = item_0;
      var tmp$ret$9 = new SetRecord(0, todayLoadKg[it_0], todayReps[it_0], todayRir[it_0], Companion_instance_17.p19(todayTypes[it_0]), 'today');
      destination_0.f(tmp$ret$9);
    }
     while (!(item_0 === last_0));
  var today = destination_0;
  var settings = TrainingSettingsJson_instance.tf(trainingSettingsJson);
  var exercise = new Exercise('exercise', 'exercise', Equipment_OTHER_getInstance(), emptyList(), VOID, VOID, VOID, VOID, bodyweightFactor, VOID, Companion_getInstance_11().p19(region));
  // Inline function 'kotlin.let' call
  var it_1 = settings.f1s(exercise, history, bodyweightKg, rirAdjustment, expandRepRange, weightMatch);
  var options = trainingSettingsJson == null ? it_1.y1k(valueOf_12(priority)) : it_1;
  var targets = Progression_instance.g1n(new CyclePrescription(sets, repMin, repMax, rir, Companion_instance_17.p19(setType)), Companion_instance_18.p19(progression), toList_2(loads), history, today, options.y1k(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, startingOneRepMaxKg));
  // Inline function 'kotlin.collections.map' call
  var this_2 = targets.j1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.j();
  while (_iterator__ex2g4s.k()) {
    var item_1 = _iterator__ex2g4s.l();
    var tmp$ret$14 = item_1.d1l_1;
    destination_1.f(tmp$ret$14);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp = copyToArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  var this_3 = targets.j1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s_0 = this_3.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_2 = _iterator__ex2g4s_0.l();
    var tmp$ret$18 = item_2.e1l_1;
    destination_2.f(tmp$ret$18);
  }
  var tmp_0 = toIntArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  var this_4 = targets.j1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(this_4, 10));
  var _iterator__ex2g4s_1 = this_4.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_3 = _iterator__ex2g4s_1.l();
    var tmp$ret$21 = item_3.f1l_1;
    destination_3.f(tmp$ret$21);
  }
  var tmp_1 = toIntArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  var this_5 = targets.j1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(this_5, 10));
  var _iterator__ex2g4s_2 = this_5.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_4 = _iterator__ex2g4s_2.l();
    var tmp$ret$24 = item_4.g1l_1.s1o_1;
    destination_4.f(tmp$ret$24);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_2 = copyToArray(destination_4);
  // Inline function 'kotlin.collections.map' call
  var this_6 = targets.j1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_5 = ArrayList_init_$Create$(collectionSizeOrDefault(this_6, 10));
  var _iterator__ex2g4s_3 = this_6.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_5 = _iterator__ex2g4s_3.l();
    var tmp$ret$28 = item_5.h1l_1;
    destination_5.f(tmp$ret$28);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_3 = copyToArray(destination_5);
  // Inline function 'kotlin.collections.map' call
  var this_7 = targets.j1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_6 = ArrayList_init_$Create$(collectionSizeOrDefault(this_7, 10));
  var _iterator__ex2g4s_4 = this_7.j();
  while (_iterator__ex2g4s_4.k()) {
    var item_6 = _iterator__ex2g4s_4.l();
    var tmp$ret$32 = item_6.i1l_1;
    destination_6.f(tmp$ret$32);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_4 = copyToArray(destination_6);
  // Inline function 'kotlin.collections.map' call
  var this_8 = targets.n1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_7 = ArrayList_init_$Create$(collectionSizeOrDefault(this_8, 10));
  var _iterator__ex2g4s_5 = this_8.j();
  while (_iterator__ex2g4s_5.k()) {
    var item_7 = _iterator__ex2g4s_5.l();
    var tmp$ret$36 = item_7.z1k_1.w1_1;
    destination_7.f(tmp$ret$36);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_5 = copyToArray(destination_7);
  // Inline function 'kotlin.collections.map' call
  var this_9 = targets.n1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_8 = ArrayList_init_$Create$(collectionSizeOrDefault(this_9, 10));
  var _iterator__ex2g4s_6 = this_9.j();
  while (_iterator__ex2g4s_6.k()) {
    var item_8 = _iterator__ex2g4s_6.l();
    var tmp$ret$40 = item_8.a1l_1;
    destination_8.f(tmp$ret$40);
  }
  var tmp_6 = toDoubleArray(destination_8);
  // Inline function 'kotlin.collections.map' call
  var this_10 = targets.n1l_1;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_9 = ArrayList_init_$Create$(collectionSizeOrDefault(this_10, 10));
  var _iterator__ex2g4s_7 = this_10.j();
  while (_iterator__ex2g4s_7.k()) {
    var item_9 = _iterator__ex2g4s_7.l();
    var tmp$ret$43 = item_9.b1l_1;
    destination_9.f(tmp$ret$43);
  }
  return new JsExerciseTargets(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, targets.k1l_1, targets.l1l_1.w1_1, targets.m1l_1, tmp_5, tmp_6, toIntArray(destination_9), targets.o1l_1);
}
function JsGeneratedProgram(programJson, split, muscles, targetSets, peakTargetSets, weeklySets, peakWeeklySets, estimatedMinutes) {
  this.programJson = programJson;
  this.split = split;
  this.muscles = muscles;
  this.targetSets = targetSets;
  this.peakTargetSets = peakTargetSets;
  this.weeklySets = weeklySets;
  this.peakWeeklySets = peakWeeklySets;
  this.estimatedMinutes = estimatedMinutes;
}
protoOf(JsGeneratedProgram).o20 = function () {
  return this.programJson;
};
protoOf(JsGeneratedProgram).p20 = function () {
  return this.split;
};
protoOf(JsGeneratedProgram).q20 = function () {
  return this.muscles;
};
protoOf(JsGeneratedProgram).r20 = function () {
  return this.targetSets;
};
protoOf(JsGeneratedProgram).s20 = function () {
  return this.peakTargetSets;
};
protoOf(JsGeneratedProgram).t20 = function () {
  return this.weeklySets;
};
protoOf(JsGeneratedProgram).u20 = function () {
  return this.peakWeeklySets;
};
protoOf(JsGeneratedProgram).v20 = function () {
  return this.estimatedMinutes;
};
function generateProgram(settingsJson, gymJson, catalogueJson, dayGymIds, dayGymJsons) {
  // Inline function 'kotlin.require' call
  if (!(dayGymIds.length === dayGymJsons.length)) {
    var message = 'day gym arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_2(dayGymIds);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var i = item;
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      var this_1 = dayGymIds[i];
      if (charSequenceLength(this_1) === 0) {
        tmp = null;
      } else {
        tmp = to(dayGymIds[i], Companion_getInstance_9().x1a(dayGymJsons[i]));
      }
      var tmp$ret$4 = tmp;
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var dayGyms = destination;
  var result = ProgramGenerator_getInstance().j1i(GeneratorSettingsJson_instance.uf(settingsJson), Companion_getInstance_9().x1a(gymJson), catalogue(catalogueJson), dayGyms);
  var muscles = toList(result.q1f_1.t1());
  var tmp_0 = TrainingProgramJson_instance.b1r(result.o1f_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s = muscles.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$8 = item_0.p1o_1;
    destination_0.f(tmp$ret$8);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_1 = copyToArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s_0 = muscles.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_1 = _iterator__ex2g4s_0.l();
    var tmp$ret$12 = getValue(result.q1f_1, item_1);
    destination_1.f(tmp$ret$12);
  }
  var tmp_2 = toDoubleArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s_1 = muscles.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_2 = _iterator__ex2g4s_1.l();
    var tmp$ret$15 = getValue(result.r1f_1, item_2);
    destination_2.f(tmp$ret$15);
  }
  var tmp_3 = toDoubleArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s_2 = muscles.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_3 = _iterator__ex2g4s_2.l();
    var tmp$ret$18 = getValue(result.s1f_1, item_3);
    destination_3.f(tmp$ret$18);
  }
  var tmp_4 = toDoubleArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(muscles, 10));
  var _iterator__ex2g4s_3 = muscles.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_4 = _iterator__ex2g4s_3.l();
    var tmp$ret$21 = getValue(result.t1f_1, item_4);
    destination_4.f(tmp$ret$21);
  }
  return new JsGeneratedProgram(tmp_0, result.p1f_1.w1_1, tmp_1, tmp_2, tmp_3, tmp_4, toDoubleArray(destination_4), toDoubleArray(result.u1f_1));
}
function defaultPowerWork(ageYears) {
  return ProgramGenerator_getInstance().b1i(ageYears);
}
function JsSubstitute(exerciseId, name, equipment, score) {
  this.exerciseId = exerciseId;
  this.name = name;
  this.equipment = equipment;
  this.score = score;
}
protoOf(JsSubstitute).w20 = function () {
  return this.exerciseId;
};
protoOf(JsSubstitute).y1x = function () {
  return this.name;
};
protoOf(JsSubstitute).x20 = function () {
  return this.equipment;
};
protoOf(JsSubstitute).y20 = function () {
  return this.score;
};
function substitutes(exerciseId, catalogueJson, gymJson, hiddenIds, limit) {
  var tmp = Substitutions_instance;
  var tmp_0 = catalogue(catalogueJson);
  var tmp_1;
  if (gymJson == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = Companion_getInstance_9().x1a(gymJson);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = tmp.o1j(exerciseId, tmp_0, tmp_1, toSet_2(hiddenIds), limit);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$4 = new JsSubstitute(item.j1j_1.e1e_1, item.j1j_1.f1e_1, item.j1j_1.g1e_1.b1b_1, item.k1j_1);
    destination.f(tmp$ret$4);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsRepMaxPoint(day, workoutId, kg) {
  this.day = day;
  this.workoutId = workoutId;
  this.kg = kg;
}
protoOf(JsRepMaxPoint).e1v = function () {
  return this.day;
};
protoOf(JsRepMaxPoint).z20 = function () {
  return this.workoutId;
};
protoOf(JsRepMaxPoint).a21 = function () {
  return this.kg;
};
function repMaxSeries(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, exerciseId, targetReps, bodyweightFactor) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = TrainingAnalytics_instance.l1q(trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg), exerciseId, targetReps, bodyweightFactor);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = new JsRepMaxPoint(item.p1p_1, item.q1p_1, item.r1p_1);
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsMuscleSets(muscles, sets) {
  this.muscles = muscles;
  this.sets = sets;
}
protoOf(JsMuscleSets).q20 = function () {
  return this.muscles;
};
protoOf(JsMuscleSets).b21 = function () {
  return this.sets;
};
function weeklySetsPerMuscle(workoutIds, days, exerciseIds, types, reps, catalogueJson, today, windowDays) {
  var n = workoutIds.length;
  var tmp = new Float64Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_0 = Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp$ret$1 = Array(n);
  var sets = trainingSets(workoutIds, days, exerciseIds, types, tmp, reps, tmp_0, tmp$ret$1);
  var tmp_1 = TrainingAnalytics_instance;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4 = element.e1e_1;
    destination.k2(tmp$ret$4, element);
  }
  var result = tmp_1.o1d(sets, destination, today, windowDays);
  // Inline function 'kotlin.collections.map' call
  var this_1 = result.t1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$7 = item.p1o_1;
    destination_0.f(tmp$ret$7);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$8 = copyToArray(destination_0);
  return new JsMuscleSets(tmp$ret$8, toDoubleArray(result.u1()));
}
function smartWarmupSets(workingLoadKg, oneRepMaxKg, loads, style, curveModel, region, warmedUp, bodyweightShareKg) {
  var exercise = new Exercise('exercise', 'exercise', Equipment_OTHER_getInstance(), emptyList(), VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_11().p19(region));
  var tmp0 = get_entries_28();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.w1_1 === curveModel) {
        tmp$ret$0 = element;
        break $l$block;
      }
    }
    tmp$ret$0 = null;
  }
  var tmp0_elvis_lhs = tmp$ret$0;
  var curve = (new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp0_elvis_lhs == null ? CurveModel_EPLEY_getInstance() : tmp0_elvis_lhs)).g1s(exercise, emptyList(), 0.0);
  var tmp0_0 = get_entries_44();
  var tmp$ret$2;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_0 = tmp0_0.j();
    while (_iterator__ex2g4s_0.k()) {
      var element_0 = _iterator__ex2g4s_0.l();
      if (element_0.w1_1 === style) {
        tmp$ret$2 = element_0;
        break $l$block_0;
      }
    }
    tmp$ret$2 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$2;
  var styleValue = tmp1_elvis_lhs == null ? SmartWarmupStyle_OURS_getInstance() : tmp1_elvis_lhs;
  // Inline function 'kotlin.collections.map' call
  var this_0 = Warmups_getInstance().v1s(workingLoadKg, oneRepMaxKg, toList_2(loads), styleValue, curve, warmedUp, bodyweightShareKg);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_1 = this_0.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$6 = new JsWarmupSet(item.o1s_1, item.p1s_1, item.q1s_1);
    destination.f(tmp$ret$6);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function normalisedTrainingSettings(json) {
  return TrainingSettingsJson_instance.k1s(TrainingSettingsJson_instance.tf(json), json);
}
function rirFromRpe(rpe) {
  return Companion_instance_28.x1j(rpe);
}
function repMaxSeriesOnCurve(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, exerciseId, targetReps, bodyweightFactor, curveModel, region) {
  var sets = trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg);
  var exercise = new Exercise(exerciseId, exerciseId, Equipment_OTHER_getInstance(), emptyList(), VOID, VOID, VOID, VOID, bodyweightFactor, VOID, Companion_getInstance_11().p19(region));
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = sets.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.x1d_1 === exerciseId) {
      destination.f(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = new SetRecord(item.w1d_1, item.a1e_1, item.b1e_1, item.c1e_1, item.z1d_1, item.v1d_1);
    destination_0.f(tmp$ret$5);
  }
  var history = destination_0;
  var tmp$ret$6;
  $l$block: {
    // Inline function 'kotlin.collections.lastOrNull' call
    var iterator = sets.p(sets.o());
    while (iterator.b3()) {
      var element_0 = iterator.c3();
      if (element_0.x1d_1 === exerciseId) {
        tmp$ret$6 = element_0;
        break $l$block;
      }
    }
    tmp$ret$6 = null;
  }
  var tmp0_safe_receiver = tmp$ret$6;
  var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.d1e_1;
  var bodyweight = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var tmp0 = get_entries_28();
  var tmp$ret$8;
  $l$block_0: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s_1 = tmp0.j();
    while (_iterator__ex2g4s_1.k()) {
      var element_1 = _iterator__ex2g4s_1.l();
      if (element_1.w1_1 === curveModel) {
        tmp$ret$8 = element_1;
        break $l$block_0;
      }
    }
    tmp$ret$8 = null;
  }
  var tmp2_elvis_lhs = tmp$ret$8;
  var curve = (new TrainingSettings(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp2_elvis_lhs == null ? CurveModel_EPLEY_getInstance() : tmp2_elvis_lhs)).g1s(exercise, history, bodyweight);
  // Inline function 'kotlin.collections.map' call
  var this_0 = TrainingAnalytics_instance.l1q(sets, exerciseId, targetReps, bodyweightFactor, VOID, curve);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_2 = this_0.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_0 = _iterator__ex2g4s_2.l();
    var tmp$ret$12 = new JsRepMaxPoint(item_0.p1p_1, item_0.q1p_1, item_0.r1p_1);
    destination_1.f(tmp$ret$12);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination_1);
}
function JsMuscleLevels(muscles, sets, targets, statuses, recovery) {
  this.muscles = muscles;
  this.sets = sets;
  this.targets = targets;
  this.statuses = statuses;
  this.recovery = recovery;
}
protoOf(JsMuscleLevels).q20 = function () {
  return this.muscles;
};
protoOf(JsMuscleLevels).b21 = function () {
  return this.sets;
};
protoOf(JsMuscleLevels).v1v = function () {
  return this.targets;
};
protoOf(JsMuscleLevels).c21 = function () {
  return this.statuses;
};
protoOf(JsMuscleLevels).d21 = function () {
  return this.recovery;
};
function muscleLevels(workoutIds, days, exerciseIds, types, reps, catalogueJson, today, programJson, cycle) {
  var n = workoutIds.length;
  var tmp = new Float64Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_0 = Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp$ret$1 = Array(n);
  var sets = trainingSets(workoutIds, days, exerciseIds, types, tmp, reps, tmp_0, tmp$ret$1);
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$4 = element.e1e_1;
    destination.k2(tmp$ret$4, element);
  }
  var byId = destination;
  var tmp_1;
  if (programJson == null) {
    tmp_1 = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp_1 = ProgramGenerator_getInstance().o1i(TrainingProgramJson_instance.c1r(programJson), cycle, byId);
  }
  var tmp1_elvis_lhs = tmp_1;
  var targets = tmp1_elvis_lhs == null ? emptyMap() : tmp1_elvis_lhs;
  var levels = MuscleLevels_instance.q1d(sets, byId, today, targets);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_0 = levels.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$9 = item.d1d_1.p1o_1;
    destination_0.f(tmp$ret$9);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_2 = copyToArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_1 = levels.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_0 = _iterator__ex2g4s_1.l();
    var tmp$ret$13 = item_0.e1d_1;
    destination_1.f(tmp$ret$13);
  }
  var tmp_3 = toDoubleArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_2 = levels.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_1 = _iterator__ex2g4s_2.l();
    var tmp0_elvis_lhs = item_1.f1d_1;
    var tmp$ret$16 = tmp0_elvis_lhs == null ? NaN : tmp0_elvis_lhs;
    destination_2.f(tmp$ret$16);
  }
  var tmp_4 = toDoubleArray(destination_2);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_3 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_3 = levels.j();
  while (_iterator__ex2g4s_3.k()) {
    var item_2 = _iterator__ex2g4s_3.l();
    var tmp$ret$19 = item_2.h1d_1.w1_1;
    destination_3.f(tmp$ret$19);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_5 = copyToArray(destination_3);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList_init_$Create$(collectionSizeOrDefault(levels, 10));
  var _iterator__ex2g4s_4 = levels.j();
  while (_iterator__ex2g4s_4.k()) {
    var item_3 = _iterator__ex2g4s_4.l();
    var tmp$ret$23 = item_3.i1d_1;
    destination_4.f(tmp$ret$23);
  }
  return new JsMuscleLevels(tmp_2, tmp_3, tmp_4, tmp_5, toDoubleArray(destination_4));
}
function JsMuscleHighlights(muscles, intensities) {
  this.muscles = muscles;
  this.intensities = intensities;
}
protoOf(JsMuscleHighlights).q20 = function () {
  return this.muscles;
};
protoOf(JsMuscleHighlights).e21 = function () {
  return this.intensities;
};
function muscleHighlights(primaryMuscles, secondaryMuscles) {
  var tmp = MuscleHighlights_instance;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable = 0;
  var last = primaryMuscles.length;
  while (inductionVariable < last) {
    var element = primaryMuscles[inductionVariable];
    inductionVariable = inductionVariable + 1 | 0;
    var tmp0_safe_receiver = Companion_instance_15.j1a(element);
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.f(tmp0_safe_receiver);
    }
  }
  var tmp_0 = destination;
  // Inline function 'kotlin.collections.mapNotNull' call
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination_0 = ArrayList_init_$Create$_0();
  // Inline function 'kotlin.collections.forEach' call
  var inductionVariable_0 = 0;
  var last_0 = secondaryMuscles.length;
  while (inductionVariable_0 < last_0) {
    var element_0 = secondaryMuscles[inductionVariable_0];
    inductionVariable_0 = inductionVariable_0 + 1 | 0;
    var tmp0_safe_receiver_0 = Companion_instance_15.j1a(element_0);
    if (tmp0_safe_receiver_0 == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination_0.f(tmp0_safe_receiver_0);
    }
  }
  var result = tmp.v1e(tmp_0, destination_0);
  // Inline function 'kotlin.collections.map' call
  var this_0 = result.t1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$16 = item.p1o_1;
    destination_1.f(tmp$ret$16);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp_1 = copyToArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  var this_1 = result.u1();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s_0 = this_1.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$20 = item_0.w1_1;
    destination_2.f(tmp$ret$20);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  var tmp$ret$21 = copyToArray(destination_2);
  return new JsMuscleHighlights(tmp_1, tmp$ret$21);
}
function bodyMapMuscles(muscleId) {
  // Inline function 'kotlin.collections.map' call
  var this_0 = BodyMapArt_getInstance().c18(muscleId);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.p1o_1;
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function JsImportedProgram(programJson, unmatched) {
  this.programJson = programJson;
  this.unmatched = unmatched;
}
protoOf(JsImportedProgram).o20 = function () {
  return this.programJson;
};
protoOf(JsImportedProgram).f21 = function () {
  return this.unmatched;
};
function importProgramCsv(csv, catalogueJson, name) {
  var imported = ProgramImport_getInstance().y1j(csv, catalogue(catalogueJson), name);
  var tmp = TrainingProgramJson_instance.b1r(imported.p1j_1);
  // Inline function 'kotlin.collections.toTypedArray' call
  var this_0 = imported.q1j_1;
  var tmp$ret$0 = copyToArray(this_0);
  return new JsImportedProgram(tmp, tmp$ret$0);
}
function JsSeries(days, values) {
  this.days = days;
  this.values = values;
}
protoOf(JsSeries).k1y = function () {
  return this.days;
};
protoOf(JsSeries).u1 = function () {
  return this.values;
};
function rangeSeries(days, values, today, range, aggregation, average, recordsOnly) {
  // Inline function 'kotlin.require' call
  if (!(days.length === values.length)) {
    var message = 'series arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  var tmp = SeriesRanges_instance;
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new SeriesPoint(days[it], values[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var points = tmp.p1n(destination, today, valueOf_13(range), valueOf_14(aggregation), valueOf_15(average), recordsOnly);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(points, 10));
  var _iterator__ex2g4s = points.j();
  while (_iterator__ex2g4s.k()) {
    var item_0 = _iterator__ex2g4s.l();
    var tmp$ret$7 = item_0.k1n_1;
    destination_0.f(tmp$ret$7);
  }
  var tmp_0 = toIntArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(points, 10));
  var _iterator__ex2g4s_0 = points.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_1 = _iterator__ex2g4s_0.l();
    var tmp$ret$10 = item_1.l1n_1;
    destination_1.f(tmp$ret$10);
  }
  return new JsSeries(tmp_0, toDoubleArray(destination_1));
}
function weeklyHardSets(workoutIds, days, exerciseIds, types, reps, today) {
  var n = workoutIds.length;
  var tmp = TrainingAnalytics_instance;
  var tmp_0 = new Float64Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp_1 = Array(n);
  // Inline function 'kotlin.arrayOfNulls' call
  var tmp$ret$1 = Array(n);
  return tmp.p1q(trainingSets(workoutIds, days, exerciseIds, types, tmp_0, reps, tmp_1, tmp$ret$1), today);
}
function checkInStrengthIndex(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, catalogueJson, day) {
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg);
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList_init_$Create$_0();
  var _iterator__ex2g4s = tmp0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    if (element.w1d_1 <= day) {
      destination.f(element);
    }
  }
  var sets = destination;
  var tmp = TrainingAnalytics_instance;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s_0 = this_0.j();
  while (_iterator__ex2g4s_0.k()) {
    var element_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = element_0.e1e_1;
    destination_0.k2(tmp$ret$5, element_0);
  }
  var points = tmp.r1q(sets, destination_0, VOID, day - 21 | 0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(points, 10));
  var _iterator__ex2g4s_1 = points.j();
  while (_iterator__ex2g4s_1.k()) {
    var item = _iterator__ex2g4s_1.l();
    var tmp$ret$8 = item.ss_1;
    destination_1.f(tmp$ret$8);
  }
  var tmp_0 = toIntArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(points, 10));
  var _iterator__ex2g4s_2 = points.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_0 = _iterator__ex2g4s_2.l();
    var tmp$ret$11 = item_0.ts_1;
    destination_2.f(tmp$ret$11);
  }
  return new JsSeries(tmp_0, toDoubleArray(destination_2));
}
function trainingWeekdays(trainingSettingsJson, activeProgramSessions) {
  return toIntArray(sorted(TrainingWeekdays_getInstance().n1s(TrainingSettingsJson_instance.tf(trainingSettingsJson).g1r_1, activeProgramSessions)));
}
function JsWeeklyVolumes(weekStarts, externalKg, bodyweightKg) {
  this.weekStarts = weekStarts;
  this.externalKg = externalKg;
  this.bodyweightKg = bodyweightKg;
}
protoOf(JsWeeklyVolumes).l1y = function () {
  return this.weekStarts;
};
protoOf(JsWeeklyVolumes).g21 = function () {
  return this.externalKg;
};
protoOf(JsWeeklyVolumes).h21 = function () {
  return this.bodyweightKg;
};
function weeklyVolumes(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg, catalogueJson) {
  var sets = trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg);
  var tmp = TrainingAnalytics_instance;
  // Inline function 'kotlin.collections.associateBy' call
  var this_0 = catalogue(catalogueJson);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap_init_$Create$(capacity);
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var element = _iterator__ex2g4s.l();
    var tmp$ret$2 = element.e1e_1;
    destination.k2(tmp$ret$2, element);
  }
  var weeks = tmp.n1q(sets, destination);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(weeks, 10));
  var _iterator__ex2g4s_0 = weeks.j();
  while (_iterator__ex2g4s_0.k()) {
    var item = _iterator__ex2g4s_0.l();
    var tmp$ret$5 = item.y1p_1;
    destination_0.f(tmp$ret$5);
  }
  var tmp_0 = toIntArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(weeks, 10));
  var _iterator__ex2g4s_1 = weeks.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_0 = _iterator__ex2g4s_1.l();
    var tmp$ret$8 = item_0.c1q_1;
    destination_1.f(tmp$ret$8);
  }
  var tmp_1 = toDoubleArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(weeks, 10));
  var _iterator__ex2g4s_2 = weeks.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_1 = _iterator__ex2g4s_2.l();
    var tmp$ret$11 = item_1.d1q_1;
    destination_2.f(tmp$ret$11);
  }
  return new JsWeeklyVolumes(tmp_0, tmp_1, toDoubleArray(destination_2));
}
function gymTemplate(kind) {
  return Json_instance.zf(Companion_getInstance_9().c1b(valueOf_10(kind)).o1b());
}
function checklistEquipment() {
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_CHECKLIST_EQUIPMENT();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s = this_0.j();
  while (_iterator__ex2g4s.k()) {
    var item = _iterator__ex2g4s.l();
    var tmp$ret$2 = item.b1b_1;
    destination.f(tmp$ret$2);
  }
  // Inline function 'kotlin.collections.toTypedArray' call
  return copyToArray(destination);
}
function gymHasEquipment(gymJson, equipment) {
  return Companion_getInstance_9().x1a(gymJson).s1b(Companion_instance_16.p19(equipment));
}
function equipmentIsWeightStack(equipment) {
  return isWeightStack(Companion_instance_16.p19(equipment));
}
function machineStepPresetsKg() {
  return toDoubleArray(get_MACHINE_STEP_PRESETS_KG());
}
function gymAdding(gymJson, equipment, stackName, stackStepKg) {
  var stack = !(stackName == null) && !(stackStepKg == null) ? stackFromStep(stackName, stackStepKg) : null;
  return Json_instance.zf(adding(Companion_getInstance_9().x1a(gymJson), Companion_instance_16.p19(equipment), stack).o1b());
}
function gymRemoving(gymJson, equipment) {
  return Json_instance.zf(removing(Companion_getInstance_9().x1a(gymJson), Companion_instance_16.p19(equipment)).o1b());
}
function catalogue(json) {
  var tmp0_safe_receiver = catalogueCache;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var cachedJson = tmp0_safe_receiver.ya();
    var exercises = tmp0_safe_receiver.za();
    if (cachedJson === json)
      return exercises;
  }
  // Inline function 'kotlin.also' call
  var this_0 = ExerciseCatalogue_instance.uf(json);
  catalogueCache = to(json, this_0);
  return this_0;
}
function trainingSets(workoutIds, days, exerciseIds, types, loadKg, reps, rir, bodyweightKg) {
  var n = workoutIds.length;
  // Inline function 'kotlin.require' call
  if (!(days.length === n && exerciseIds.length === n && types.length === n && loadKg.length === n && reps.length === n && rir.length === n && bodyweightKg.length === n)) {
    var message = 'set arrays must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = until(0, n);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new TrainingSet(workoutIds[it], days[it], exerciseIds[it], it, Companion_instance_17.p19(types[it]), loadKg[it], reps[it], rir[it], bodyweightKg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  return destination;
}
function JsTrendChart(bandDays, bandLowKg, bandHighKg, projectionFromDay, projectionFromKg, projectionToDay, projectionToKg) {
  this.bandDays = bandDays;
  this.bandLowKg = bandLowKg;
  this.bandHighKg = bandHighKg;
  this.projectionFromDay = projectionFromDay;
  this.projectionFromKg = projectionFromKg;
  this.projectionToDay = projectionToDay;
  this.projectionToKg = projectionToKg;
}
protoOf(JsTrendChart).q1u = function () {
  return this.bandDays;
};
protoOf(JsTrendChart).i21 = function () {
  return this.bandLowKg;
};
protoOf(JsTrendChart).j21 = function () {
  return this.bandHighKg;
};
protoOf(JsTrendChart).k21 = function () {
  return this.projectionFromDay;
};
protoOf(JsTrendChart).l21 = function () {
  return this.projectionFromKg;
};
protoOf(JsTrendChart).m21 = function () {
  return this.projectionToDay;
};
protoOf(JsTrendChart).n21 = function () {
  return this.projectionToKg;
};
function weightTrendChart(days, kg, endDay, method, predictionStyle, goalType, goalRatePctPerWeek, goalTargetKg) {
  // Inline function 'kotlin.require' call
  if (!(days.length === kg.length)) {
    var message = 'days and kg must have the same length';
    throw IllegalArgumentException_init_$Create$(toString(message));
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get_indices_0(days);
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList_init_$Create$(collectionSizeOrDefault(this_0, 10));
  var inductionVariable = this_0.oc_1;
  var last = this_0.pc_1;
  if (inductionVariable <= last)
    do {
      var item = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var it = item;
      var tmp$ret$4 = new WeighIn(days[it], kg[it]);
      destination.f(tmp$ret$4);
    }
     while (!(item === last));
  var weighIns = destination;
  var trend = Trend_instance.xv(weighIns, endDay, valueOf_16(method));
  var band = TrendChart_instance.gu(trend, weighIns);
  var tmp;
  if (goalType == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = new Goal(valueOf(goalType), goalRatePctPerWeek, goalTargetKg);
  }
  var goal = tmp;
  var tmp0 = get_entries_2();
  var tmp$ret$7;
  $l$block: {
    // Inline function 'kotlin.collections.firstOrNull' call
    var _iterator__ex2g4s = tmp0.j();
    while (_iterator__ex2g4s.k()) {
      var element = _iterator__ex2g4s.l();
      if (element.w1_1 === predictionStyle) {
        tmp$ret$7 = element;
        break $l$block;
      }
    }
    tmp$ret$7 = null;
  }
  var tmp1_elvis_lhs = tmp$ret$7;
  var style = tmp1_elvis_lhs == null ? PredictionStyle_DATA_getInstance() : tmp1_elvis_lhs;
  var projection = TrendChart_instance.ju(trend, style, goal);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList_init_$Create$(collectionSizeOrDefault(band, 10));
  var _iterator__ex2g4s_0 = band.j();
  while (_iterator__ex2g4s_0.k()) {
    var item_0 = _iterator__ex2g4s_0.l();
    var tmp$ret$11 = item_0.qt_1;
    destination_0.f(tmp$ret$11);
  }
  var tmp_0 = toIntArray(destination_0);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList_init_$Create$(collectionSizeOrDefault(band, 10));
  var _iterator__ex2g4s_1 = band.j();
  while (_iterator__ex2g4s_1.k()) {
    var item_1 = _iterator__ex2g4s_1.l();
    var tmp$ret$14 = item_1.rt_1;
    destination_1.f(tmp$ret$14);
  }
  var tmp_1 = toDoubleArray(destination_1);
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList_init_$Create$(collectionSizeOrDefault(band, 10));
  var _iterator__ex2g4s_2 = band.j();
  while (_iterator__ex2g4s_2.k()) {
    var item_2 = _iterator__ex2g4s_2.l();
    var tmp$ret$17 = item_2.st_1;
    destination_2.f(tmp$ret$17);
  }
  var tmp_2 = toDoubleArray(destination_2);
  var tmp_3 = projection == null ? null : projection.tt_1;
  var tmp_4 = projection == null ? null : projection.ut_1;
  var tmp_5 = projection == null ? null : projection.vt_1;
  return new JsTrendChart(tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, projection == null ? null : projection.wt_1);
}
//region block: post-declaration
protoOf(FlooredExpCurve).l1m = oneRepMax;
protoOf(FlooredExpCurve).z1m = load;
//endregion
//region block: init
Fmt_instance = new Fmt();
CalorieFloors_instance = new CalorieFloors();
GoalAvailability_instance = new GoalAvailability();
CheckIn_instance = new CheckIn();
CheckInSignals_instance = new CheckInSignals();
CollaborativeTargets_instance = new CollaborativeTargets();
DailyTargets_instance = new DailyTargets();
ExpenditureRunner_instance = new ExpenditureRunner();
WaistToHeight_instance = new WaistToHeight();
Goals_instance = new Goals();
LossPace_instance = new LossPace();
Macros_instance = new Macros();
NewProgram_instance = new NewProgram();
NutritionJson_instance = new NutritionJson();
PartialDays_instance = new PartialDays();
PerformanceGuardrail_instance = new PerformanceGuardrail();
TrainingShift_instance = new TrainingShift();
TrendChart_instance = new TrendChart();
WeeklyCheckIn_instance = new WeeklyCheckIn();
WeeklyDistribution_instance = new WeeklyDistribution();
AdaptiveExpenditure_instance = new AdaptiveExpenditure();
BodyComposition_instance = new BodyComposition();
EnergyBalance_instance = new EnergyBalance();
EnergyDensity_instance = new EnergyDensity();
ExpenditureFloor_instance = new ExpenditureFloor();
ExpenditureV2_instance = new ExpenditureV2();
Companion_instance_4 = new Companion_2();
InitialExpenditure_instance = new InitialExpenditure();
StateSpaceExpenditure_instance = new StateSpaceExpenditure();
Companion_instance_6 = new Companion_4();
Json_instance = new Json();
JsonRead_instance = new JsonRead();
Alcohol_instance = new Alcohol();
Companion_instance_7 = new Companion_5();
NutrientAnalysis_instance = new NutrientAnalysis();
Companion_instance_8 = new Companion_6();
Companion_instance_9 = new Companion_7();
NutrientGoalHistory_instance = new NutrientGoalHistory();
NutrientGoalJson_instance = new NutrientGoalJson();
NutrientJson_instance = new NutrientJson();
NutrientGoals_instance = new NutrientGoals();
CurveFit_instance = new CurveFit();
Companion_instance_11 = new Companion_9();
GeneratorSettingsJson_instance = new GeneratorSettingsJson();
Loads_instance = new Loads();
PlateCalculator_instance = new PlateCalculator();
MuscleLevels_instance = new MuscleLevels();
MuscleHighlights_instance = new MuscleHighlights();
Periodisation_instance = new Periodisation();
Substitutions_instance = new Substitutions();
Progression_instance = new Progression();
SeriesRanges_instance = new SeriesRanges();
Strength_instance = new Strength();
OneRepMaxClamp_instance = new OneRepMaxClamp();
Companion_instance_15 = new Companion_13();
Companion_instance_16 = new Companion_14();
Companion_instance_17 = new Companion_15();
Companion_instance_18 = new Companion_16();
Companion_instance_19 = new Companion_17();
Companion_instance_20 = new Companion_18();
Companion_instance_21 = new Companion_19();
Companion_instance_22 = new Companion_20();
Companion_instance_23 = new Companion_21();
Companion_instance_24 = new Companion_22();
ExerciseCatalogue_instance = new ExerciseCatalogue();
TrainingAnalytics_instance = new TrainingAnalytics();
Companion_instance_26 = new Companion_24();
TrainingProgramJson_instance = new TrainingProgramJson();
Companion_instance_27 = new Companion_25();
Companion_instance_28 = new Companion_26();
TrainingSettingsJson_instance = new TrainingSettingsJson();
Trend_instance = new Trend();
LessLagTrend_instance = new LessLagTrend();
TransientTrend_instance = new TransientTrend();
WeighInHabit_instance = new WeighInHabit();
WeightTrend_instance = new WeightTrend();
catalogueCache = null;
//endregion
//region block: exports
export {
  JsExpenditureModel as JsExpenditureModel,
  expenditureModel as expenditureModel,
  JsAlgorithmOption as JsAlgorithmOption,
  algorithmOptions as algorithmOptions,
  algorithmValues as algorithmValues,
  algorithmsWith as algorithmsWith,
  JsDisplayedExpenditure as JsDisplayedExpenditure,
  displayedExpenditure as displayedExpenditure,
  JsExpenditureChanges as JsExpenditureChanges,
  expenditureChanges as expenditureChanges,
  JsEnergyBalancePoint as JsEnergyBalancePoint,
  JsEnergyBalance as JsEnergyBalance,
  energyBalance as energyBalance,
  JsWeeklyCheckIn as JsWeeklyCheckIn,
  JsFastLoss as JsFastLoss,
  weeklyCheckIn as weeklyCheckIn,
  fastLossWarning as fastLossWarning,
  JsDietBreak as JsDietBreak,
  dietBreak_0 as dietBreak,
  dietBreakWeekChoices as dietBreakWeekChoices,
  dietBreakExplainer as dietBreakExplainer,
  programWithDietBreak as programWithDietBreak,
  trainingShiftCarbsHelp as trainingShiftCarbsHelp,
  collaborativeEdit as collaborativeEdit,
  dayOneTargets as dayOneTargets,
  dayOneTargetsWithTraining as dayOneTargetsWithTraining,
  defaultCheckInWeekday as defaultCheckInWeekday,
  firstCheckInDay as firstCheckInDay,
  firstCheckInDayOn as firstCheckInDayOn,
  ageYears as ageYears,
  goalPacePresets as goalPacePresets,
  goalProjection as goalProjection,
  goalCurve as goalCurve,
  suggestedTargetKg as suggestedTargetKg,
  ethnicityBmiThreshold as ethnicityBmiThreshold,
  waistToHeightBand as waistToHeightBand,
  availableGoalTypes as availableGoalTypes,
  dailyDeltaKcal as dailyDeltaKcal,
  kgPerWeek as kgPerWeek,
  ratePctPerWeek as ratePctPerWeek,
  JsGoalProgress as JsGoalProgress,
  goalProgress as goalProgress,
  JsWeightMilestone as JsWeightMilestone,
  weightMilestones as weightMilestones,
  JsNutrientGoal as JsNutrientGoal,
  nutrientGoals as nutrientGoals,
  JsCompleteness as JsCompleteness,
  nutrientCompleteness as nutrientCompleteness,
  JsContributor as JsContributor,
  nutrientTopContributors as nutrientTopContributors,
  JsNutrientAverages as JsNutrientAverages,
  nutrientAverages as nutrientAverages,
  JsAlcohol as JsAlcohol,
  alcohol as alcohol,
  alcoholDrink as alcoholDrink,
  JsDrinkType as JsDrinkType,
  drinkTypes as drinkTypes,
  JsTrendPoint as JsTrendPoint,
  JsExpenditurePoint as JsExpenditurePoint,
  JsCheckInResult as JsCheckInResult,
  JsMacros as JsMacros,
  weightTrend as weightTrend,
  changeRateKgPerWeek as changeRateKgPerWeek,
  JsWeightInsights as JsWeightInsights,
  weightInsights as weightInsights,
  weighInStreak as weighInStreak,
  energyDensityKcalPerKg as energyDensityKcalPerKg,
  checkIn as checkIn,
  macroTargets as macroTargets,
  estimatedOneRepMax as estimatedOneRepMax,
  localizeUnits as localizeUnits,
  offProductUrl as offProductUrl,
  offFoodJson as offFoodJson,
  JsNutrientInfo as JsNutrientInfo,
  nutrientInfos as nutrientInfos,
  JsNutrientGoalSetting as JsNutrientGoalSetting,
  nutrientGoalHistory as nutrientGoalHistory,
  JsGoalMethod as JsGoalMethod,
  nutrientGoalMethods as nutrientGoalMethods,
  nutrientGoalsWith as nutrientGoalsWith,
  nutrientGoalsWithout as nutrientGoalsWithout,
  JsNutrientDay as JsNutrientDay,
  JsNutrientFocus as JsNutrientFocus,
  nutrientFocus as nutrientFocus,
  JsPlateLoadout as JsPlateLoadout,
  plateLoadout as plateLoadout,
  gymLoads as gymLoads,
  nearestLoad as nearestLoad,
  JsWarmupSet as JsWarmupSet,
  warmupSets as warmupSets,
  JsExerciseTargets as JsExerciseTargets,
  nextSetTargets as nextSetTargets,
  JsGeneratedProgram as JsGeneratedProgram,
  generateProgram as generateProgram,
  defaultPowerWork as defaultPowerWork,
  JsSubstitute as JsSubstitute,
  substitutes as substitutes,
  JsRepMaxPoint as JsRepMaxPoint,
  repMaxSeries as repMaxSeries,
  JsMuscleSets as JsMuscleSets,
  weeklySetsPerMuscle as weeklySetsPerMuscle,
  smartWarmupSets as smartWarmupSets,
  normalisedTrainingSettings as normalisedTrainingSettings,
  rirFromRpe as rirFromRpe,
  repMaxSeriesOnCurve as repMaxSeriesOnCurve,
  JsMuscleLevels as JsMuscleLevels,
  muscleLevels as muscleLevels,
  JsMuscleHighlights as JsMuscleHighlights,
  muscleHighlights as muscleHighlights,
  bodyMapMuscles as bodyMapMuscles,
  JsImportedProgram as JsImportedProgram,
  importProgramCsv as importProgramCsv,
  JsSeries as JsSeries,
  rangeSeries as rangeSeries,
  weeklyHardSets as weeklyHardSets,
  checkInStrengthIndex as checkInStrengthIndex,
  trainingWeekdays as trainingWeekdays,
  JsWeeklyVolumes as JsWeeklyVolumes,
  weeklyVolumes as weeklyVolumes,
  gymTemplate as gymTemplate,
  checklistEquipment as checklistEquipment,
  gymHasEquipment as gymHasEquipment,
  equipmentIsWeightStack as equipmentIsWeightStack,
  machineStepPresetsKg as machineStepPresetsKg,
  gymAdding as gymAdding,
  gymRemoving as gymRemoving,
  JsTrendChart as JsTrendChart,
  weightTrendChart as weightTrendChart,
};
//endregion

//# sourceMappingURL=macrotide-shared.mjs.map
